/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 203);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unsafeStringify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(5);


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  //
  // Note to future-self: No, you can't remove the `toLowerCase()` call.
  // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var uuid = unsafeStringify(arr, offset);
  // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }
  return uuid;
}
/* unused harmony default export */ var _unused_webpack_default_export = (stringify);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noopActions; });
/* harmony export (immutable) */ __webpack_exports__["a"] = registerJQueryPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * This simple helper aids in the creation of creating/registering a jquery
 * plugin.
 * @module create-jquery-plugin
 */



var NOOP = function NOOP() {};

/**
 * Provides noop actions for sensible defaults.
 * @type {Object}
 */
var noopActions = {
  deregister: NOOP
};

/**
 * Contains a number of methods representing actions.
 * @param {HTMLElement} el - The element applied to the plugin
 * @param {string} name - The name of the plugin
 */
var actions = function actions(el, name) {
  return {
    /**
     * Performs a deregisteration on the plugin
     */
    deregister: function deregister() {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.removeData(el, name);
    }
  };
};

/**
 * Simple helper function that creates/register a jQuery plugin.
 * @param {string} name - The name of the plugin to reguster
 * @param {jQueryPluginCallback} cb - A callback function
 */
function registerJQueryPlugin(name, cb) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn[name] = function pluginRegister() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var $obj = this;
    var opt = args[0];
    var _$obj$toArray$map$fil = $obj.toArray().map(function (el) {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(opt)) {
          var instance = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name);
          if (!instance) {
            throw new Error("Attempted to call method ".concat(name, " existed when no instance existed"));
          }
          if (!instance[opt]) {
            throw new Error("No method found for ".concat(opt, " on ").concat(name));
          }
          var argList = args.slice(1);
          return instance[opt].apply(instance, _toConsumableArray(argList));
        }
        if (__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name))) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name, cb(el, opt, actions(el, name)) || {});
        }

        // this is here so we can identify that chaining should occur and also
        // shut up eslint from complaining about a needed return value
        return undefined;
      }).filter(function (val) {
        return !__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(val);
      }),
      _$obj$toArray$map$fil2 = _slicedToArray(_$obj$toArray$map$fil, 1),
      result = _$obj$toArray$map$fil2[0];
    return result || $obj;
  };
}

/**
 * This callback is used for registering a jQuery plugin.
 * @callback jQueryPluginCallback
 * @param {HTMLElement} el - The element applied to the plugin
 * @param {Object} options - Options forwarded along to the plugin.
 * @param {Object} actions - Actions that can be taken on the plugin
 */

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__max_js__ = __webpack_require__(31);
/* unused harmony reexport MAX */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nil_js__ = __webpack_require__(34);
/* unused harmony reexport NIL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_js__ = __webpack_require__(4);
/* unused harmony reexport parse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringify_js__ = __webpack_require__(1);
/* unused harmony reexport stringify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__v1_js__ = __webpack_require__(14);
/* unused harmony reexport v1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__v1ToV6_js__ = __webpack_require__(15);
/* unused harmony reexport v1ToV6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__v3_js__ = __webpack_require__(37);
/* unused harmony reexport v3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__v4_js__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__v5_js__ = __webpack_require__(39);
/* unused harmony reexport v5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__v6_js__ = __webpack_require__(40);
/* unused harmony reexport v6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__v6ToV1_js__ = __webpack_require__(41);
/* unused harmony reexport v6ToV1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__v7_js__ = __webpack_require__(42);
/* unused harmony reexport v7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validate_js__ = __webpack_require__(5);
/* unused harmony reexport validate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__version_js__ = __webpack_require__(43);
/* unused harmony reexport version */















/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(5);

function parse(uuid) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }
  var v;
  var arr = new Uint8Array(16);

  // Parse ########-....-....-....-............
  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff;

  // Parse ........-####-....-....-............
  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff;

  // Parse ........-....-####-....-............
  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff;

  // Parse ........-....-....-####-............
  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff;

  // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}
/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regex_js__ = __webpack_require__(35);

function validate(uuid) {
  return typeof uuid === 'string' && __WEBPACK_IMPORTED_MODULE_0__regex_js__["a" /* default */].test(uuid);
}
/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["c"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* harmony export (immutable) */ __webpack_exports__["b"] = __spreadArray;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/* unused harmony export __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
        var ar = [];
        for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;

}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while (r = env.stack.pop()) {
            try {
                if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
                if (r.dispose) {
                    var result = r.dispose.call(r.value);
                    if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
                }
                else s |= 1;
            }
            catch (e) {
                fail(e);
            }
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
        });
    }
    return path;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension,
});


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */

var mergeOptions = function mergeOptions() {
  var DEFAULTS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = arguments.length > 2 ? arguments[2] : undefined;
  var opts = Object.assign({}, DEFAULTS, options, $el ? $el.data() : {});
  return opts;
};
/* harmony default export */ __webpack_exports__["a"] = (mergeOptions);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOG; });
/* unused harmony export LOG_LEVEL */
/* unused harmony export buildAdClick */
/* unused harmony export buildAdConversion */
/* unused harmony export buildAdImpression */
/* unused harmony export buildAddToCart */
/* unused harmony export buildConsentGranted */
/* unused harmony export buildConsentWithdrawn */
/* unused harmony export buildEcommerceTransaction */
/* unused harmony export buildEcommerceTransactionItem */
/* unused harmony export buildFormFocusOrChange */
/* unused harmony export buildFormSubmission */
/* unused harmony export buildLinkClick */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return buildPagePing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return buildPageView; });
/* unused harmony export buildRemoveFromCart */
/* unused harmony export buildScreenView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildSelfDescribingEvent; });
/* unused harmony export buildSiteSearch */
/* unused harmony export buildSocialInteraction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildStructEvent; });
/* unused harmony export getRuleParts */
/* unused harmony export getSchemaParts */
/* unused harmony export globalContexts */
/* unused harmony export isConditionalContextProvider */
/* unused harmony export isContextCallbackFunction */
/* unused harmony export isContextPrimitive */
/* unused harmony export isFilterProvider */
/* unused harmony export isJson */
/* unused harmony export isNonEmptyJson */
/* unused harmony export isRuleSet */
/* unused harmony export isRuleSetProvider */
/* unused harmony export isSelfDescribingJson */
/* unused harmony export isStringArray */
/* unused harmony export isValidRule */
/* unused harmony export isValidRuleSetArg */
/* unused harmony export matchSchemaAgainstRule */
/* unused harmony export matchSchemaAgainstRuleSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return newEmitter; });
/* unused harmony export newEventStorePayload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newInMemoryEventStore; });
/* unused harmony export payloadBuilder */
/* unused harmony export payloadJsonProcessor */
/* unused harmony export pluginContexts */
/* unused harmony export removeEmptyProperties */
/* unused harmony export resolveDynamicContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackerCore; });
/* unused harmony export validateVendor */
/* unused harmony export validateVendorParts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow JavaScript trackers v4.8.2 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */



var version$1 = "4.8.2";

/*
 * Copyright (c) 2013 Kevin van Zonneveld (http://kvz.io)
 * and Contributors (http://phpjs.org/authors)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/**
 * Decodes a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to decode
 * @returns The decoded string
 */
function base64urldecode(data) {
  if (!data) {
    return data;
  }
  var padding = 4 - data.length % 4;
  switch (padding) {
    case 2:
      data += '==';
      break;
    case 3:
      data += '=';
      break;
  }
  var b64Data = data.replace(/-/g, '+').replace(/_/g, '/');
  return base64decode(b64Data);
}
/**
 * Encodes a string into a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to encode
 * @returns The url safe Base 64 string
 */
function base64urlencode(data) {
  if (!data) {
    return data;
  }
  var enc = base64encode(data);
  return enc.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encode string as base64.
 * Any type can be passed, but will be stringified
 *
 * @param data - string to encode
 * @returns base64-encoded string
 */
function base64encode(data) {
  // discuss at: http://phpjs.org/functions/base64_encode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Bayron Guevara
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Rafał Kukawski (http://kukawski.pl)
  // bugfixed by: Pellentesque Malesuada
  // example 1: base64_encode('Kevin van Zonneveld');
  // returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
  // example 2: base64_encode('a');
  // returns 2: 'YQ=='
  // example 3: base64_encode('✓ à la mode');
  // returns 3: '4pyTIMOgIGxhIG1vZGU='
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0;
  var tmp_arr = [];
  if (!data) {
    return data;
  }
  data = unescape(encodeURIComponent(data));
  do {
    // pack three octets into four hexets
    o1 = data.charCodeAt(i++);
    o2 = data.charCodeAt(i++);
    o3 = data.charCodeAt(i++);
    bits = o1 << 16 | o2 << 8 | o3;
    h1 = bits >> 18 & 0x3f;
    h2 = bits >> 12 & 0x3f;
    h3 = bits >> 6 & 0x3f;
    h4 = bits & 0x3f;
    // use hexets to index into b64, and append result to encoded string
    tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
  } while (i < data.length);
  var enc = tmp_arr.join('');
  var r = data.length % 3;
  return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}
/**
 * Decode base64 to string
 *
 * @param data - base64 to string
 * @returns decoded string
 */
function base64decode(encodedData) {
  //  discuss at: http://locutus.io/php/base64_decode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Kevin van Zonneveld (http://kvz.io)
  //    input by: Aman Gupta
  //    input by: Brett Zamir (http://brett-zamir.me)
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  // bugfixed by: Pellentesque Malesuada
  // bugfixed by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Indigo744
  //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==')
  //   returns 1: 'Kevin van Zonneveld'
  //   example 2: base64_decode('YQ==')
  //   returns 2: 'a'
  //   example 3: base64_decode('4pyTIMOgIGxhIG1vZGU=')
  //   returns 3: '✓ à la mode'
  // decodeUTF8string()
  // Internal function to decode properly UTF8 string
  // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
  var decodeUTF8string = function decodeUTF8string(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  };
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0,
    dec = '';
  var tmpArr = [];
  if (!encodedData) {
    return encodedData;
  }
  encodedData += '';
  do {
    // unpack four hexets into three octets using index points in b64
    h1 = b64.indexOf(encodedData.charAt(i++));
    h2 = b64.indexOf(encodedData.charAt(i++));
    h3 = b64.indexOf(encodedData.charAt(i++));
    h4 = b64.indexOf(encodedData.charAt(i++));
    bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
    o1 = bits >> 16 & 0xff;
    o2 = bits >> 8 & 0xff;
    o3 = bits & 0xff;
    if (h3 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1);
    } else if (h4 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1, o2);
    } else {
      tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
    }
  } while (i < encodedData.length);
  dec = tmpArr.join('');
  return decodeUTF8string(dec.replace(/\0+$/, ''));
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
function payloadBuilder() {
  var dict = {},
    allJson = [],
    jsonForProcessing = [],
    contextEntitiesForProcessing = [];
  var processor;
  var add = function add(key, value) {
    if (value != null && value !== '') {
      // null also checks undefined
      dict[key] = value;
    }
  };
  var addDict = function addDict(dict) {
    for (var key in dict) {
      if (Object.prototype.hasOwnProperty.call(dict, key)) {
        add(key, dict[key]);
      }
    }
  };
  var addJson = function addJson(keyIfEncoded, keyIfNotEncoded, json) {
    if (json && isNonEmptyJson(json)) {
      var jsonWithKeys = {
        keyIfEncoded: keyIfEncoded,
        keyIfNotEncoded: keyIfNotEncoded,
        json: json
      };
      jsonForProcessing.push(jsonWithKeys);
      allJson.push(jsonWithKeys);
    }
  };
  var addContextEntity = function addContextEntity(entity) {
    contextEntitiesForProcessing.push(entity);
  };
  return {
    add: add,
    addDict: addDict,
    addJson: addJson,
    addContextEntity: addContextEntity,
    getPayload: function getPayload() {
      return dict;
    },
    getJson: function getJson() {
      return allJson;
    },
    withJsonProcessor: function withJsonProcessor(jsonProcessor) {
      processor = jsonProcessor;
    },
    build: function build() {
      processor === null || processor === void 0 ? void 0 : processor(this, jsonForProcessing, contextEntitiesForProcessing);
      return dict;
    }
  };
}
/**
 * A helper to build a Snowplow request from a set of name-value pairs, provided using the add methods.
 * Will base64 encode JSON, if desired, on build
 *
 * @returns The request builder, with add and build methods
 */
function payloadJsonProcessor(encodeBase64) {
  return function (payloadBuilder, jsonForProcessing, contextEntitiesForProcessing) {
    var add = function add(json, keyIfEncoded, keyIfNotEncoded) {
      var str = JSON.stringify(json);
      if (encodeBase64) {
        payloadBuilder.add(keyIfEncoded, base64urlencode(str));
      } else {
        payloadBuilder.add(keyIfNotEncoded, str);
      }
    };
    var getContextFromPayload = function getContextFromPayload() {
      var payload = payloadBuilder.getPayload();
      if (encodeBase64 ? payload.cx : payload.co) {
        return JSON.parse(encodeBase64 ? base64urldecode(payload.cx) : payload.co);
      }
      return undefined;
    };
    var combineContexts = function combineContexts(originalContext, newContext) {
      var context = originalContext || getContextFromPayload();
      if (context) {
        context.data = context.data.concat(newContext.data);
      } else {
        context = newContext;
      }
      return context;
    };
    var context = undefined;
    for (var _i = 0, jsonForProcessing_1 = jsonForProcessing; _i < jsonForProcessing_1.length; _i++) {
      var json = jsonForProcessing_1[_i];
      if (json.keyIfEncoded === 'cx') {
        context = combineContexts(context, json.json);
      } else {
        add(json.json, json.keyIfEncoded, json.keyIfNotEncoded);
      }
    }
    jsonForProcessing.length = 0;
    if (contextEntitiesForProcessing.length) {
      var newContext = {
        schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], contextEntitiesForProcessing, true)
      };
      context = combineContexts(context, newContext);
      contextEntitiesForProcessing.length = 0;
    }
    if (context) {
      add(context, 'cx', 'co');
    }
  };
}
/**
 * Is property a non-empty JSON?
 * @param property - Checks if object is non-empty json
 */
function isNonEmptyJson(property) {
  if (!isJson(property)) {
    return false;
  }
  for (var key in property) {
    if (Object.prototype.hasOwnProperty.call(property, key)) {
      return true;
    }
  }
  return false;
}
/**
 * Is property a JSON?
 * @param property - Checks if object is json
 */
function isJson(property) {
  return typeof property !== 'undefined' && property !== null && (property.constructor === {}.constructor || property.constructor === [].constructor);
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var label = 'Snowplow: ';
var LOG_LEVEL;
(function (LOG_LEVEL) {
  LOG_LEVEL[LOG_LEVEL["none"] = 0] = "none";
  LOG_LEVEL[LOG_LEVEL["error"] = 1] = "error";
  LOG_LEVEL[LOG_LEVEL["warn"] = 2] = "warn";
  LOG_LEVEL[LOG_LEVEL["debug"] = 3] = "debug";
  LOG_LEVEL[LOG_LEVEL["info"] = 4] = "info";
})(LOG_LEVEL || (LOG_LEVEL = {}));
var LOG = logger();
function logger(logLevel) {
  if (logLevel === void 0) {
    logLevel = LOG_LEVEL.warn;
  }
  function setLogLevel(level) {
    if (LOG_LEVEL[level]) {
      logLevel = level;
    } else {
      logLevel = LOG_LEVEL.warn;
    }
  }
  /**
   * Log errors, with or without error object
   */
  function error(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.error && typeof console !== 'undefined') {
      var logMsg = label + message + '\n';
      if (error) {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log warnings, with or without error object
   */
  function warn(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.warn && typeof console !== 'undefined') {
      var logMsg = label + message;
      if (error) {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log debug messages
   */
  function debug(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.debug && typeof console !== 'undefined') {
      console.debug.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  /**
   * Log info messages
   */
  function info(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.info && typeof console !== 'undefined') {
      console.info.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  return {
    setLogLevel: setLogLevel,
    warn: warn,
    error: error,
    debug: debug,
    info: info
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Contains helper functions to aid in the addition and removal of Global Contexts
 */
function globalContexts() {
  var globalPrimitives = [];
  var conditionalProviders = [];
  var namedPrimitives = {};
  var namedConditionalProviders = {};
  /**
   * Returns all applicable global contexts for a specified event
   * @param event - The event to check for applicable global contexts for
   * @returns An array of contexts
   */
  var assembleAllContexts = function assembleAllContexts(event) {
    var eventSchema = getUsefulSchema(event);
    var eventType = getEventType(event);
    var contexts = [];
    var generatedPrimitives = generatePrimitives(globalPrimitives.concat(Object.values(namedPrimitives)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedPrimitives);
    var generatedConditionals = generateConditionals(conditionalProviders.concat(Object.values(namedConditionalProviders)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedConditionals);
    return contexts;
  };
  return {
    getGlobalPrimitives: function getGlobalPrimitives() {
      return globalPrimitives.concat(Object.values(namedPrimitives));
    },
    getConditionalProviders: function getConditionalProviders() {
      return conditionalProviders.concat(Object.values(namedConditionalProviders));
    },
    addGlobalContexts: function addGlobalContexts(contexts) {
      if (Array.isArray(contexts)) {
        var acceptedConditionalContexts = [];
        var acceptedContextPrimitives = [];
        for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
          var context = contexts_1[_i];
          if (isConditionalContextProvider(context)) {
            acceptedConditionalContexts.push(context);
          } else if (isContextPrimitive(context)) {
            acceptedContextPrimitives.push(context);
          }
        }
        globalPrimitives = globalPrimitives.concat(acceptedContextPrimitives);
        conditionalProviders = conditionalProviders.concat(acceptedConditionalContexts);
      } else {
        for (var _a = 0, _b = Object.entries(contexts); _a < _b.length; _a++) {
          var _c = _b[_a],
            name_1 = _c[0],
            context = _c[1];
          if (isConditionalContextProvider(context)) {
            namedConditionalProviders[name_1] = context;
          } else if (isContextPrimitive(context)) {
            namedPrimitives[name_1] = context;
          }
        }
      }
    },
    clearGlobalContexts: function clearGlobalContexts() {
      conditionalProviders = [];
      globalPrimitives = [];
      namedConditionalProviders = {};
      namedPrimitives = {};
    },
    removeGlobalContexts: function removeGlobalContexts(contexts) {
      var _loop_1 = function _loop_1(context) {
        if (typeof context === 'string') {
          delete namedConditionalProviders[context];
          delete namedPrimitives[context];
        } else if (isConditionalContextProvider(context)) {
          conditionalProviders = conditionalProviders.filter(function (item) {
            return !compareProvider(context, item);
          });
        } else if (isContextPrimitive(context)) {
          globalPrimitives = globalPrimitives.filter(function (item) {
            return !compareProvider(context, item);
          });
        }
      };
      for (var _i = 0, contexts_2 = contexts; _i < contexts_2.length; _i++) {
        var context = contexts_2[_i];
        _loop_1(context);
      }
    },
    getApplicableContexts: function getApplicableContexts(event) {
      return assembleAllContexts(event);
    }
  };
}
function pluginContexts(plugins) {
  /**
   * Add common contexts to every event
   *
   * @param array - additionalContexts List of user-defined contexts
   * @returns userContexts combined with commonContexts
   */
  return {
    addPluginContexts: function addPluginContexts(additionalContexts) {
      var combinedContexts = additionalContexts ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], additionalContexts, true) : [];
      plugins.forEach(function (plugin) {
        try {
          if (plugin.contexts) {
            combinedContexts.push.apply(combinedContexts, plugin.contexts());
          }
        } catch (ex) {
          LOG.error('Error adding plugin contexts', ex);
        }
      });
      return combinedContexts;
    }
  };
}
/**
 * Find dynamic context generating functions and return their results to be merged into the static contexts
 * Combine an array of unchanging contexts with the result of a context-creating function
 *
 * @param dynamicOrStaticContexts - Array of custom context Objects or custom context generating functions
 * @param Parameters - to pass to dynamic context callbacks
 * @returns An array of Self Describing JSON context
 */
function resolveDynamicContext(dynamicOrStaticContexts) {
  var _a;
  var extraParams = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    extraParams[_i - 1] = arguments[_i];
  }
  return (_a = dynamicOrStaticContexts === null || dynamicOrStaticContexts === void 0 ? void 0 : dynamicOrStaticContexts.map(function (context) {
    if (typeof context === 'function') {
      try {
        return context.apply(void 0, extraParams);
      } catch (e) {
        //TODO: provide warning
        return undefined;
      }
    } else {
      return context;
    }
  }).filter(Boolean)) !== null && _a !== void 0 ? _a : [];
}
/**
 * Slices a schema into its composite parts. Useful for ruleset filtering.
 * @param input - A schema string
 * @returns The vendor, schema name, major, minor and patch information of a schema string
 */
function getSchemaParts(input) {
  var re = new RegExp('^iglu:([a-zA-Z0-9-_.]+)/([a-zA-Z0-9-_]+)/jsonschema/([1-9][0-9]*)-(0|[1-9][0-9]*)-(0|[1-9][0-9]*)$');
  var matches = re.exec(input);
  if (matches !== null) return matches.slice(1, 6);
  return undefined;
}
/**
 * Validates the vendor section of a schema string contains allowed wildcard values
 * @param parts - Array of parts from a schema string
 * @returns Whether the vendor validation parts are a valid combination
 */
function validateVendorParts(parts) {
  if (parts[0] === '*' || parts[1] === '*') {
    return false; // no wildcard in first or second part
  }
  if (parts.slice(2).length > 0) {
    var asterisk = false;
    for (var _i = 0, _a = parts.slice(2); _i < _a.length; _i++) {
      var part = _a[_i];
      if (part === '*')
        // mark when we've found a wildcard
        asterisk = true;else if (asterisk)
        // invalid if alpha parts come after wildcard
        return false;
    }
    return true;
  } else if (parts.length == 2) return true;
  return false;
}
/**
 * Validates the vendor part of a schema string is valid for a rule set
 * @param input - Vendor part of a schema string
 * @returns Whether the vendor validation string is valid
 */
function validateVendor(input) {
  var parts = input.split('.');
  if (parts && parts.length > 1) return validateVendorParts(parts);
  return false;
}
/**
 * Checks for validity of input and returns all the sections of a schema string that are used to match rules in a ruleset
 * @param input - A Schema string
 * @returns The sections of a schema string that are used to match rules in a ruleset
 */
function getRuleParts(input) {
  var re = new RegExp('^iglu:((?:(?:[a-zA-Z0-9-_]+|\\*).)+(?:[a-zA-Z0-9-_]+|\\*))/([a-zA-Z0-9-_.]+|\\*)/jsonschema/([1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)$');
  var matches = re.exec(input);
  if (matches !== null && validateVendor(matches[1])) return matches.slice(1, 6);
  return undefined;
}
/**
 * Ensures the rules specified in a schema string of a ruleset are valid
 * @param input - A Schema string
 * @returns if there rule is valid
 */
function isValidRule(input) {
  var ruleParts = getRuleParts(input);
  if (ruleParts) {
    var vendor = ruleParts[0];
    return ruleParts.length === 5 && validateVendor(vendor);
  }
  return false;
}
/**
 * Check if a variable is an Array containing only strings
 * @param input - The variable to validate
 * @returns True if the input is an array containing only strings
 */
function isStringArray(input) {
  return Array.isArray(input) && input.every(function (x) {
    return typeof x === 'string';
  });
}
/**
 * Validates whether a rule set is an array of valid ruleset strings
 * @param input - The Array of rule set arguments
 * @returns True is the input is an array of valid rules
 */
function isValidRuleSetArg(input) {
  if (isStringArray(input)) return input.every(function (x) {
    return isValidRule(x);
  });else if (typeof input === 'string') return isValidRule(input);
  return false;
}
/**
 * Check if a variable is a valid, non-empty Self Describing JSON
 * @param input - The variable to validate
 * @returns True if a valid Self Describing JSON
 */
function isSelfDescribingJson(input) {
  var sdj = input;
  if (isNonEmptyJson(sdj)) if ('schema' in sdj && 'data' in sdj) return typeof sdj.schema === 'string' && _typeof(sdj.data) === 'object';
  return false;
}
/**
 * Validates if the input object contains the expected properties of a ruleset
 * @param input - The object containing a rule set
 * @returns True if a valid rule set
 */
function isRuleSet(input) {
  var ruleSet = input;
  var ruleCount = 0;
  if (input != null && _typeof(input) === 'object' && !Array.isArray(input)) {
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'accept')) {
      if (isValidRuleSetArg(ruleSet['accept'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'reject')) {
      if (isValidRuleSetArg(ruleSet['reject'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    // if either 'reject' or 'accept' or both exists,
    // we have a valid ruleset
    return ruleCount > 0 && ruleCount <= 2;
  }
  return false;
}
/**
 * Validates if the function can be a valid context generator function
 * @param input - The function to be validated
 */
function isContextCallbackFunction(input) {
  return typeof input === 'function' && input.length <= 1;
}
/**
 * Validates if the function can be a valid context primitive function or self describing json
 * @param input - The function or orbject to be validated
 * @returns True if either a Context Generator or Self Describing JSON
 */
function isContextPrimitive(input) {
  return isContextCallbackFunction(input) || isSelfDescribingJson(input);
}
/**
 * Validates if an array is a valid shape to be a Filter Provider
 * @param input - The Array of Context filter callbacks
 */
function isFilterProvider(input) {
  if (Array.isArray(input)) {
    if (input.length === 2) {
      if (Array.isArray(input[1])) {
        return isContextCallbackFunction(input[0]) && input[1].every(isContextPrimitive);
      }
      return isContextCallbackFunction(input[0]) && isContextPrimitive(input[1]);
    }
  }
  return false;
}
/**
 * Validates if an array is a valid shape to be an array of rule sets
 * @param input - The Array of Rule Sets
 */
function isRuleSetProvider(input) {
  if (Array.isArray(input) && input.length === 2) {
    if (!isRuleSet(input[0])) return false;
    if (Array.isArray(input[1])) return input[1].every(isContextPrimitive);
    return isContextPrimitive(input[1]);
  }
  return false;
}
/**
 * Checks if an input array is either a filter provider or a rule set provider
 * @param input - An array of filter providers or rule set providers
 * @returns Whether the array is a valid {@link ConditionalContextProvider}
 */
function isConditionalContextProvider(input) {
  return isFilterProvider(input) || isRuleSetProvider(input);
}
/**
 * Checks if a given schema matches any rules within the provided rule set
 * @param ruleSet - The rule set containing rules to match schema against
 * @param schema - The schema to be matched against the rule set
 */
function matchSchemaAgainstRuleSet(ruleSet, schema) {
  var rejectCount = 0;
  var acceptCount = 0;
  var acceptRules = ruleSet['accept'];
  if (Array.isArray(acceptRules)) {
    if (ruleSet.accept.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      acceptCount++;
    }
  } else if (typeof acceptRules === 'string') {
    if (matchSchemaAgainstRule(acceptRules, schema)) {
      acceptCount++;
    }
  }
  var rejectRules = ruleSet['reject'];
  if (Array.isArray(rejectRules)) {
    if (ruleSet.reject.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      rejectCount++;
    }
  } else if (typeof rejectRules === 'string') {
    if (matchSchemaAgainstRule(rejectRules, schema)) {
      rejectCount++;
    }
  }
  if (acceptCount > 0 && rejectCount === 0) {
    return true;
  } else if (acceptCount === 0 && rejectCount > 0) {
    return false;
  }
  return false;
}
/**
 * Checks if a given schema matches a specific rule from a rule set
 * @param rule - The rule to match schema against
 * @param schema - The schema to be matched against the rule
 */
function matchSchemaAgainstRule(rule, schema) {
  if (!isValidRule(rule)) return false;
  var ruleParts = getRuleParts(rule);
  var schemaParts = getSchemaParts(schema);
  if (ruleParts && schemaParts) {
    if (!matchVendor(ruleParts[0], schemaParts[0])) return false;
    for (var i = 1; i < 5; i++) {
      if (!matchPart(ruleParts[i], schemaParts[i])) return false;
    }
    return true; // if it hasn't failed, it passes
  }
  return false;
}
function matchVendor(rule, vendor) {
  // rule and vendor must have same number of elements
  var vendorParts = vendor.split('.');
  var ruleParts = rule.split('.');
  if (vendorParts && ruleParts) {
    if (vendorParts.length !== ruleParts.length) return false;
    for (var i = 0; i < ruleParts.length; i++) {
      if (!matchPart(vendorParts[i], ruleParts[i])) return false;
    }
    return true;
  }
  return false;
}
function matchPart(rule, schema) {
  // parts should be the string nested between slashes in the URI: /example/
  return rule && schema && rule === '*' || rule === schema;
}
// Returns the "useful" schema, i.e. what would someone want to use to identify events.
// For some events this is the 'e' property but for unstructured events, this is the
// 'schema' from the 'ue_px' field.
function getUsefulSchema(sb) {
  var eventJson = sb.getJson();
  for (var _i = 0, eventJson_1 = eventJson; _i < eventJson_1.length; _i++) {
    var json = eventJson_1[_i];
    if (json.keyIfEncoded === 'ue_px' && _typeof(json.json['data']) === 'object') {
      var schema = json.json['data']['schema'];
      if (typeof schema == 'string') {
        return schema;
      }
    }
  }
  return '';
}
function getEventType(payloadBuilder) {
  var eventType = payloadBuilder.getPayload()['e'];
  return typeof eventType === 'string' ? eventType : '';
}
function buildGenerator(generator, event, eventType, eventSchema) {
  var contextGeneratorResult = undefined;
  try {
    // try to evaluate context generator
    var args = {
      event: event.getPayload(),
      eventType: eventType,
      eventSchema: eventSchema
    };
    contextGeneratorResult = generator(args);
    // determine if the produced result is a valid SDJ
    if (Array.isArray(contextGeneratorResult) && contextGeneratorResult.every(isSelfDescribingJson)) {
      return contextGeneratorResult;
    } else if (isSelfDescribingJson(contextGeneratorResult)) {
      return contextGeneratorResult;
    } else {
      return undefined;
    }
  } catch (error) {
    contextGeneratorResult = undefined;
  }
  return contextGeneratorResult;
}
function normalizeToArray(input) {
  if (Array.isArray(input)) {
    return input;
  }
  return Array.of(input);
}
function generatePrimitives(contextPrimitives, event, eventType, eventSchema) {
  var _a;
  var normalizedInputs = normalizeToArray(contextPrimitives);
  var partialEvaluate = function partialEvaluate(primitive) {
    var result = evaluatePrimitive(primitive, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInputs.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}
function evaluatePrimitive(contextPrimitive, event, eventType, eventSchema) {
  if (isSelfDescribingJson(contextPrimitive)) {
    return [contextPrimitive];
  } else if (isContextCallbackFunction(contextPrimitive)) {
    var generatorOutput = buildGenerator(contextPrimitive, event, eventType, eventSchema);
    if (isSelfDescribingJson(generatorOutput)) {
      return [generatorOutput];
    } else if (Array.isArray(generatorOutput)) {
      return generatorOutput;
    }
  }
  return undefined;
}
function evaluateProvider(provider, event, eventType, eventSchema) {
  if (isFilterProvider(provider)) {
    var filter = provider[0];
    var filterResult = false;
    try {
      var args = {
        event: event.getPayload(),
        eventType: eventType,
        eventSchema: eventSchema
      };
      filterResult = filter(args);
    } catch (error) {
      filterResult = false;
    }
    if (filterResult === true) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  } else if (isRuleSetProvider(provider)) {
    if (matchSchemaAgainstRuleSet(provider[0], eventSchema)) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  }
  return [];
}
function compareProviderPart(a, b) {
  if (typeof a === 'function') return a === b;
  return JSON.stringify(a) === JSON.stringify(b);
}
function compareProvider(a, b) {
  if (isConditionalContextProvider(a)) {
    if (!isConditionalContextProvider(b)) return false;
    var ruleA = a[0],
      primitivesA = a[1];
    var ruleB = b[0],
      primitivesB_1 = b[1];
    if (!compareProviderPart(ruleA, ruleB)) return false;
    if (Array.isArray(primitivesA)) {
      if (!Array.isArray(primitivesB_1)) return false;
      if (primitivesA.length !== primitivesB_1.length) return false;
      return primitivesA.reduce(function (matches, a, i) {
        return matches && compareProviderPart(a, primitivesB_1[i]);
      }, true);
    } else {
      if (Array.isArray(primitivesB_1)) return false;
      return compareProviderPart(primitivesA, primitivesB_1);
    }
  } else if (isContextPrimitive(a)) {
    if (!isContextPrimitive(b)) return false;
    return compareProviderPart(a, b);
  }
  return false;
}
function generateConditionals(providers, event, eventType, eventSchema) {
  var _a;
  var normalizedInput = normalizeToArray(providers);
  var partialEvaluate = function partialEvaluate(provider) {
    var result = evaluateProvider(provider, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInput.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}

/**
 * Create a new EventStorePayload
 */
function newEventStorePayload(_a) {
  var payload = _a.payload,
    _b = _a.svrAnon,
    svrAnon = _b === void 0 ? false : _b;
  return {
    payload: payload,
    svrAnon: svrAnon
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Transform optional/old-behavior number timestamp into`Timestamp` ADT
 *
 * @param timestamp - optional number or timestamp object
 * @returns correct timestamp object
 */
function getTimestamp(timestamp) {
  if (timestamp == null) {
    return {
      type: 'dtm',
      value: new Date().getTime()
    };
  } else if (typeof timestamp === 'number') {
    return {
      type: 'dtm',
      value: timestamp
    };
  } else if (timestamp.type === 'ttm') {
    // We can return timestamp here, but this is safer fallback
    return {
      type: 'ttm',
      value: timestamp.value
    };
  } else {
    return {
      type: 'dtm',
      value: timestamp.value || new Date().getTime()
    };
  }
}
/**
 * Create a tracker core object
 *
 * @param base64 - Whether to base 64 encode contexts and self describing event JSONs
 * @param corePlugins - The core plugins to be processed with each event
 * @param callback - Function applied to every payload dictionary object
 * @returns Tracker core
 */
function trackerCore(configuration) {
  if (configuration === void 0) {
    configuration = {};
  }
  function newCore(base64, corePlugins, callback) {
    var pluginContextsHelper = pluginContexts(corePlugins),
      globalContextsHelper = globalContexts();
    var encodeBase64 = base64,
      payloadPairs = {}; // Dictionary of key-value pairs which get added to every payload, e.g. tracker version
    /**
     * Wraps an array of custom contexts in a self-describing JSON
     *
     * @param contexts - Array of custom context self-describing JSONs
     * @returns Outer JSON
     */
    function completeContexts(contexts) {
      if (contexts && contexts.length) {
        return {
          schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
          data: contexts
        };
      }
      return undefined;
    }
    /**
     * Adds all global contexts to a contexts array
     *
     * @param pb - PayloadData
     * @param contexts - Custom contexts relating to the event
     */
    function attachGlobalContexts(pb, contexts) {
      var applicableContexts = globalContextsHelper.getApplicableContexts(pb);
      var returnedContexts = [];
      if (contexts && contexts.length) {
        returnedContexts.push.apply(returnedContexts, contexts);
      }
      if (applicableContexts && applicableContexts.length) {
        returnedContexts.push.apply(returnedContexts, applicableContexts);
      }
      return returnedContexts;
    }
    /**
     * Gets called by every trackXXX method
     * Adds context and payloadPairs name-value pairs to the payload
     * Applies the callback to the built payload
     *
     * @param pb - Payload
     * @param context - Custom contexts relating to the event
     * @param timestamp - Timestamp of the event
     * @returns Payload after the callback is applied or undefined if the event is skipped
     */
    function track(pb, context, timestamp) {
      if (!active) {
        LOG.error('Track called on deactivated tracker');
        return undefined;
      }
      pb.withJsonProcessor(payloadJsonProcessor(encodeBase64));
      pb.add('eid', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_uuid__["a" /* v4 */])());
      pb.addDict(payloadPairs);
      var tstamp = getTimestamp(timestamp);
      pb.add(tstamp.type, tstamp.value.toString());
      var allContexts = attachGlobalContexts(pb, pluginContextsHelper.addPluginContexts(context));
      var wrappedContexts = completeContexts(allContexts);
      if (wrappedContexts !== undefined) {
        pb.addJson('cx', 'co', wrappedContexts);
      }
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.beforeTrack) {
            plugin.beforeTrack(pb);
          }
        } catch (ex) {
          LOG.error('Plugin beforeTrack', ex);
        }
      });
      // Call the filter on plugins to determine if the event should be tracked
      var skip = corePlugins.find(function (plugin) {
        try {
          return plugin.filter && plugin.filter(pb.build()) === false;
        } catch (ex) {
          LOG.error('Plugin filter', ex);
          return false;
        }
      });
      if (skip) {
        return undefined;
      }
      if (typeof callback === 'function') {
        callback(pb);
      }
      var finalPayload = pb.build();
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.afterTrack) {
            plugin.afterTrack(finalPayload);
          }
        } catch (ex) {
          LOG.error('Plugin afterTrack', ex);
        }
      });
      return finalPayload;
    }
    /**
     * Set a persistent key-value pair to be added to every payload
     *
     * @param key - Field name
     * @param value - Field value
     */
    function addPayloadPair(key, value) {
      payloadPairs[key] = value;
    }
    var core = {
      track: track,
      addPayloadPair: addPayloadPair,
      getBase64Encoding: function getBase64Encoding() {
        return encodeBase64;
      },
      setBase64Encoding: function setBase64Encoding(encode) {
        encodeBase64 = encode;
      },
      addPayloadDict: function addPayloadDict(dict) {
        for (var key in dict) {
          if (Object.prototype.hasOwnProperty.call(dict, key)) {
            payloadPairs[key] = dict[key];
          }
        }
      },
      resetPayloadPairs: function resetPayloadPairs(dict) {
        payloadPairs = isJson(dict) ? dict : {};
      },
      setTrackerVersion: function setTrackerVersion(version) {
        addPayloadPair('tv', version);
      },
      setTrackerNamespace: function setTrackerNamespace(name) {
        addPayloadPair('tna', name);
      },
      setAppId: function setAppId(appId) {
        addPayloadPair('aid', appId);
      },
      setPlatform: function setPlatform(value) {
        addPayloadPair('p', value);
      },
      setUserId: function setUserId(userId) {
        addPayloadPair('uid', userId);
      },
      setScreenResolution: function setScreenResolution(width, height) {
        addPayloadPair('res', width + 'x' + height);
      },
      setViewport: function setViewport(width, height) {
        addPayloadPair('vp', width + 'x' + height);
      },
      setColorDepth: function setColorDepth(depth) {
        addPayloadPair('cd', depth);
      },
      setTimezone: function setTimezone(timezone) {
        addPayloadPair('tz', timezone);
      },
      setLang: function setLang(lang) {
        addPayloadPair('lang', lang);
      },
      setIpAddress: function setIpAddress(ip) {
        addPayloadPair('ip', ip);
      },
      setUseragent: function setUseragent(useragent) {
        addPayloadPair('ua', useragent);
      },
      addGlobalContexts: function addGlobalContexts(contexts) {
        globalContextsHelper.addGlobalContexts(contexts);
      },
      clearGlobalContexts: function clearGlobalContexts() {
        globalContextsHelper.clearGlobalContexts();
      },
      removeGlobalContexts: function removeGlobalContexts(contexts) {
        globalContextsHelper.removeGlobalContexts(contexts);
      }
    };
    return core;
  }
  var active = true;
  var base64 = configuration.base64,
    corePlugins = configuration.corePlugins,
    callback = configuration.callback,
    plugins = corePlugins !== null && corePlugins !== void 0 ? corePlugins : [],
    partialCore = newCore(base64 !== null && base64 !== void 0 ? base64 : true, plugins, callback),
    core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, partialCore), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        var plugin = configuration.plugin;
        plugins.push(plugin);
        (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
        (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
      },
      deactivate: function deactivate() {
        plugins.forEach(function (plugin) {
          var _a;
          (_a = plugin.deactivatePlugin) === null || _a === void 0 ? void 0 : _a.call(plugin, core);
        });
        plugins.length = 0;
        active = false;
      }
    });
  plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
    var _a, _b;
    (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
    (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
  });
  return core;
}
/**
 * Build a self-describing event
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - Contains the properties and schema location for the event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSelfDescribingEvent(event) {
  var _a = event.event,
    schema = _a.schema,
    data = _a.data,
    pb = payloadBuilder();
  var ueJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/unstruct_event/jsonschema/1-0-0',
    data: {
      schema: schema,
      data: data
    }
  };
  pb.add('e', 'ue');
  pb.addJson('ue_px', 'ue_pr', ueJson);
  return pb;
}
/**
 * Build a Page View Event
 * Represents a Page View, which is typically fired as soon as possible when a web page
 * is loaded within the users browser. Often also fired on "virtual page views" within
 * Single Page Applications (SPA).
 *
 * @param event - Contains the properties for the Page View event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPageView(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    pb = payloadBuilder();
  pb.add('e', 'pv'); // 'pv' for Page View
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  return pb;
}
/**
 * Build a Page Ping Event
 * Fires when activity tracking is enabled in the browser.
 * Tracks same information as the last tracked Page View and includes scroll
 * information from the current page view
 *
 * @param event - Contains the properties for the Page Ping event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPagePing(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    minXOffset = event.minXOffset,
    maxXOffset = event.maxXOffset,
    minYOffset = event.minYOffset,
    maxYOffset = event.maxYOffset,
    pb = payloadBuilder();
  pb.add('e', 'pp'); // 'pp' for Page Ping
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  if (minXOffset && !isNaN(Number(minXOffset))) pb.add('pp_mix', minXOffset.toString());
  if (maxXOffset && !isNaN(Number(maxXOffset))) pb.add('pp_max', maxXOffset.toString());
  if (minYOffset && !isNaN(Number(minYOffset))) pb.add('pp_miy', minYOffset.toString());
  if (maxYOffset && !isNaN(Number(maxYOffset))) pb.add('pp_may', maxYOffset.toString());
  return pb;
}
/**
 * Build a Structured Event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - Contains the properties for the Structured event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildStructEvent(event) {
  var category = event.category,
    action = event.action,
    label = event.label,
    property = event.property,
    value = event.value,
    pb = payloadBuilder();
  pb.add('e', 'se'); // 'se' for Structured Event
  pb.add('se_ca', category);
  pb.add('se_ac', action);
  pb.add('se_la', label);
  pb.add('se_pr', property);
  pb.add('se_va', value == null ? undefined : value.toString());
  return pb;
}
/**
 * Build an Ecommerce Transaction Event
 * Allows for tracking common ecommerce events, this event is usually used when
 * a consumer completes a transaction.
 *
 * @param event - Contains the properties for the Ecommerce Transactoion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransaction(event) {
  var orderId = event.orderId,
    total = event.total,
    affiliation = event.affiliation,
    tax = event.tax,
    shipping = event.shipping,
    city = event.city,
    state = event.state,
    country = event.country,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'tr'); // 'tr' for Transaction
  pb.add('tr_id', orderId);
  pb.add('tr_af', affiliation);
  pb.add('tr_tt', total);
  pb.add('tr_tx', tax);
  pb.add('tr_sh', shipping);
  pb.add('tr_ci', city);
  pb.add('tr_st', state);
  pb.add('tr_co', country);
  pb.add('tr_cu', currency);
  return pb;
}
/**
 * Build an Ecommerce Transaction Item Event
 * Related to the {@link buildEcommerceTransaction}
 * Each Ecommerce Transaction may contain one or more EcommerceTransactionItem events
 *
 * @param event - Contains the properties for the Ecommerce Transaction Item event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransactionItem(event) {
  var orderId = event.orderId,
    sku = event.sku,
    price = event.price,
    name = event.name,
    category = event.category,
    quantity = event.quantity,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'ti'); // 'tr' for Transaction Item
  pb.add('ti_id', orderId);
  pb.add('ti_sk', sku);
  pb.add('ti_nm', name);
  pb.add('ti_ca', category);
  pb.add('ti_pr', price);
  pb.add('ti_qu', quantity);
  pb.add('ti_cu', currency);
  return pb;
}
/**
 * Build a Scren View Event
 * Similar to a Page View but less focused on typical web properties
 * Often used for mobile applications as the user is presented with
 * new views as they performance navigation events
 *
 * @param event - Contains the properties for the Screen View event. One or more properties must be included.
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildScreenView(event) {
  var name = event.name,
    id = event.id;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/screen_view/jsonschema/1-0-0',
      data: removeEmptyProperties({
        name: name,
        id: id
      })
    }
  });
}
/**
 * Build a Link Click Event
 * Used when a user clicks on a link on a webpage, typically an anchor tag `<a>`
 *
 * @param event - Contains the properties for the Link Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildLinkClick(event) {
  var targetUrl = event.targetUrl,
    elementId = event.elementId,
    elementClasses = event.elementClasses,
    elementTarget = event.elementTarget,
    elementContent = event.elementContent;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/link_click/jsonschema/1-0-1',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      elementId: elementId,
      elementClasses: elementClasses,
      elementTarget: elementTarget,
      elementContent: elementContent
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Impression Event
 * Used to track an advertisement impression
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Impression event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdImpression(event) {
  var impressionId = event.impressionId,
    costModel = event.costModel,
    cost = event.cost,
    targetUrl = event.targetUrl,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0',
    data: removeEmptyProperties({
      impressionId: impressionId,
      costModel: costModel,
      cost: cost,
      targetUrl: targetUrl,
      bannerId: bannerId,
      zoneId: zoneId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Click Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdClick(event) {
  var targetUrl = event.targetUrl,
    clickId = event.clickId,
    costModel = event.costModel,
    cost = event.cost,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    impressionId = event.impressionId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_click/jsonschema/1-0-0',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      clickId: clickId,
      costModel: costModel,
      cost: cost,
      bannerId: bannerId,
      zoneId: zoneId,
      impressionId: impressionId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Conversion Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Conversion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdConversion(event) {
  var conversionId = event.conversionId,
    costModel = event.costModel,
    cost = event.cost,
    category = event.category,
    action = event.action,
    property = event.property,
    initialValue = event.initialValue,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_conversion/jsonschema/1-0-0',
    data: removeEmptyProperties({
      conversionId: conversionId,
      costModel: costModel,
      cost: cost,
      category: category,
      action: action,
      property: property,
      initialValue: initialValue,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Social Interaction Event
 * Social tracking will be used to track the way users interact
 * with Facebook, Twitter and Google + widgets
 * e.g. to capture “like this” or “tweet this” events.
 *
 * @param event - Contains the properties for the Social Interaction event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSocialInteraction(event) {
  var action = event.action,
    network = event.network,
    target = event.target;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/social_interaction/jsonschema/1-0-0',
    data: removeEmptyProperties({
      action: action,
      network: network,
      target: target
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Add To Cart Event
 * For tracking users adding items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Add To Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAddToCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/add_to_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Remove From Cart Event
 * For tracking users removing items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Remove From Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildRemoveFromCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/remove_from_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Form Focus or Change Form Event based on schema property
 * When a user focuses on a form element or when a user makes a
 * change to a form element.
 *
 * @param event - Contains the properties for the Form Focus or Change Form event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormFocusOrChange(event) {
  var event_schema = '';
  var schema = event.schema,
    formId = event.formId,
    elementId = event.elementId,
    nodeName = event.nodeName,
    elementClasses = event.elementClasses,
    value = event.value,
    type = event.type;
  var event_data = {
    formId: formId,
    elementId: elementId,
    nodeName: nodeName,
    elementClasses: elementClasses,
    value: value
  };
  if (schema === 'change_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0';
    event_data.type = type;
  } else if (schema === 'focus_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0';
    event_data.elementType = type;
  }
  return buildSelfDescribingEvent({
    event: {
      schema: event_schema,
      data: removeEmptyProperties(event_data, {
        value: true
      })
    }
  });
}
/**
 * Build a Form Submission Event
 * Used to track when a user submits a form
 *
 * @param event - Contains the properties for the Form Submission event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormSubmission(event) {
  var formId = event.formId,
    formClasses = event.formClasses,
    elements = event.elements;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
      data: removeEmptyProperties({
        formId: formId,
        formClasses: formClasses,
        elements: elements
      })
    }
  });
}
/**
 * Build a Site Search Event
 * Used when a user performs a search action on a page
 *
 * @param event - Contains the properties for the Site Search event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSiteSearch(event) {
  var terms = event.terms,
    filters = event.filters,
    totalResults = event.totalResults,
    pageResults = event.pageResults;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0',
      data: removeEmptyProperties({
        terms: terms,
        filters: filters,
        totalResults: totalResults,
        pageResults: pageResults
      })
    }
  });
}
/**
 * Build a Consent Withdrawn Event
 * Used for tracking when a user withdraws their consent
 *
 * @param event - Contains the properties for the Consent Withdrawn event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentWithdrawn(event) {
  var all = event.all,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_withdrawn/jsonschema/1-0-0',
        data: removeEmptyProperties({
          all: all
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Build a Consent Granted Event
 * Used for tracking when a user grants their consent
 *
 * @param event - Contains the properties for the Consent Granted event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentGranted(event) {
  var expiry = event.expiry,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_granted/jsonschema/1-0-0',
        data: removeEmptyProperties({
          expiry: expiry
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - JSON object to clean
 * @param exemptFields - Set of fields which should not be removed even if empty
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event, exemptFields) {
  if (exemptFields === void 0) {
    exemptFields = {};
  }
  var ret = {};
  for (var k in event) {
    if (exemptFields[k] || event[k] !== null && typeof event[k] !== 'undefined') {
      ret[k] = event[k];
    }
  }
  return ret;
}
function newInMemoryEventStore(_a) {
  var _b = _a.maxSize,
    maxSize = _b === void 0 ? 1000 : _b,
    _c = _a.events,
    events = _c === void 0 ? [] : _c;
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], events, true);
  var count = function count() {
    return Promise.resolve(store.length);
  };
  return {
    count: count,
    add: function add(payload) {
      store.push(payload);
      while (store.length > maxSize) {
        store.shift();
      }
      return count();
    },
    removeHead: function removeHead(count) {
      for (var i = 0; i < count; i++) {
        store.shift();
      }
      return Promise.resolve();
    },
    iterator: function iterator() {
      var index = 0;
      // copy the store to prevent mutation
      var events = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true);
      return {
        next: function next() {
          if (index < events.length) {
            return Promise.resolve({
              value: events[index++],
              done: false
            });
          }
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
      };
    },
    getAll: function getAll() {
      return Promise.resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true));
    },
    getAllPayloads: function getAllPayloads() {
      return Promise.resolve(store.map(function (e) {
        return e.payload;
      }));
    }
  };
}
var PAYLOAD_DATA_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4';

/**
 * Enclose an array of events in a self-describing payload_data JSON string
 *
 * @param array - events Batch of events
 * @returns string payload_data self-describing JSON
 */
function encloseInPayloadDataEnvelope(events) {
  return JSON.stringify({
    schema: PAYLOAD_DATA_SCHEMA,
    data: events
  });
}
/**
 * Attaches the STM field to outbound POST events.
 *
 * @param events - the events to attach the STM to
 */
function attachStmToEvent(events) {
  var stm = new Date().getTime().toString();
  for (var i = 0; i < events.length; i++) {
    events[i]['stm'] = stm;
  }
  return events;
}
function newEmitterRequest(_a) {
  var endpoint = _a.endpoint,
    _b = _a.protocol,
    protocol = _b === void 0 ? 'https' : _b,
    port = _a.port,
    _c = _a.eventMethod,
    eventMethod = _c === void 0 ? 'post' : _c,
    customHeaders = _a.customHeaders,
    connectionTimeout = _a.connectionTimeout,
    _d = _a.keepalive,
    keepalive = _d === void 0 ? false : _d,
    _e = _a.postPath,
    postPath = _e === void 0 ? '/com.snowplowanalytics.snowplow/tp2' : _e,
    _f = _a.useStm,
    useStm = _f === void 0 ? true : _f,
    _g = _a.maxPostBytes,
    maxPostBytes = _g === void 0 ? 40000 : _g,
    _h = _a.credentials,
    credentials = _h === void 0 ? 'include' : _h;
  var events = [];
  var usePost = eventMethod.toLowerCase() === 'post';
  var timer;
  var abortController;
  function countBytes() {
    var count = events.reduce(function (acc, event) {
      return acc + (usePost ? event.getPOSTRequestBytesCount() : event.getGETRequestBytesCount());
    }, 0);
    if (usePost) {
      count += 88; // 88 bytes for the payload_data envelope
    }
    return count;
  }
  function countEvents() {
    return events.length;
  }
  function getServerAnonymizationOfExistingEvents() {
    return events.length > 0 ? events[0].getServerAnonymization() : undefined;
  }
  function addEvent(event) {
    if (events.length > 0 && getServerAnonymizationOfExistingEvents() !== event.getServerAnonymization()) {
      return false;
    } else {
      events.push(event);
      return true;
    }
  }
  function getEvents() {
    return events;
  }
  function isFull() {
    if (usePost) {
      return countBytes() >= maxPostBytes;
    } else {
      return events.length >= 1;
    }
  }
  function createHeaders() {
    var headers = new Headers();
    if (usePost) {
      headers.append('Content-Type', 'application/json; charset=UTF-8');
    }
    if (customHeaders) {
      Object.keys(customHeaders).forEach(function (key) {
        headers.append(key, customHeaders[key]);
      });
    }
    if (getServerAnonymizationOfExistingEvents()) {
      headers.append('SP-Anonymous', '*');
    }
    return headers;
  }
  function getFullCollectorUrl() {
    var collectorUrl = endpoint;
    if (!endpoint.includes('://')) {
      collectorUrl = "".concat(protocol, "://").concat(endpoint);
    }
    if (port) {
      collectorUrl = "".concat(collectorUrl, ":").concat(port);
    }
    var path = usePost ? postPath : '/i';
    return collectorUrl + path;
  }
  function makeRequest(url, options) {
    closeRequest(false);
    abortController = new AbortController();
    timer = setTimeout(function () {
      var reason = 'Request timed out';
      console.error(reason);
      timer = undefined;
      closeRequest(false, reason);
    }, connectionTimeout !== null && connectionTimeout !== void 0 ? connectionTimeout : 5000);
    var requestOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      headers: createHeaders(),
      signal: abortController.signal,
      keepalive: keepalive,
      credentials: credentials
    }, options);
    var request = new Request(url, requestOptions);
    return request;
  }
  function makePostRequest() {
    var batch = attachStmToEvent(events.map(function (event) {
      return event.getPOSTRequestBody();
    }));
    return makeRequest(getFullCollectorUrl(), {
      method: 'POST',
      body: encloseInPayloadDataEnvelope(batch)
    });
  }
  function makeGetRequest() {
    if (events.length !== 1) {
      throw new Error('Only one event can be sent in a GET request');
    }
    var event = events[0];
    var url = event.getGETRequestURL(getFullCollectorUrl(), useStm);
    return makeRequest(url, {
      method: 'GET'
    });
  }
  function toRequest() {
    if (events.length === 0) {
      return undefined;
    }
    if (usePost) {
      return makePostRequest();
    } else {
      return makeGetRequest();
    }
  }
  function closeRequest(successful, reason) {
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    if (abortController !== undefined) {
      var controller = abortController;
      abortController = undefined;
      if (!successful) {
        controller.abort(reason);
      }
    }
  }
  return {
    addEvent: addEvent,
    getEvents: getEvents,
    toRequest: toRequest,
    countBytes: countBytes,
    countEvents: countEvents,
    isFull: isFull,
    closeRequest: closeRequest
  };
}

/**
 * Count the number of bytes a string will occupy when UTF-8 encoded
 * Taken from http://stackoverflow.com/questions/2848462/count-bytes-in-textarea-using-javascript/
 *
 * @param s - The string
 * @returns number Length of s in bytes when UTF-8 encoded
 */
function getUTF8Length(s) {
  var len = 0;
  for (var i = 0; i < s.length; i++) {
    var code = s.charCodeAt(i);
    if (code <= 0x7f) {
      len += 1;
    } else if (code <= 0x7ff) {
      len += 2;
    } else if (code >= 0xd800 && code <= 0xdfff) {
      // Surrogate pair: These take 4 bytes in UTF-8 and 2 chars in UCS-2
      // (Assume next char is the other [valid] half and just skip it)
      len += 4;
      i++;
    } else if (code < 0xffff) {
      len += 3;
    } else {
      len += 4;
    }
  }
  return len;
}
/*
  * Convert a dictionary to a querystring
  * The context field is the last in the querystring
  */
function getQuerystring(request) {
  var lowPriorityKeys = {
    co: true,
    cx: true
  };
  var args = [];
  for (var key in request) {
    if (request.hasOwnProperty(key) && !lowPriorityKeys[key]) {
      args.push(key + '=' + encodeURIComponent(request[key]));
    }
  }
  for (var contextKey in lowPriorityKeys) {
    if (request.hasOwnProperty(contextKey) && lowPriorityKeys[contextKey]) {
      args.push(contextKey + '=' + encodeURIComponent(request[contextKey]));
    }
  }
  return '?' + args.join('&');
}
/*
  * Convert numeric fields to strings to match payload_data schema
  */
function preparePostBody(request) {
  var cleanedRequest = Object.keys(request).map(function (k) {
    return [k, request[k]];
  }).reduce(function (acc, _a) {
    var key = _a[0],
      value = _a[1];
    acc[key] = value.toString();
    return acc;
  }, {});
  return cleanedRequest;
}
function newEmitterEvent(eventStorePayload) {
  var querystring = null;
  var postBody = null;
  var byteCountGET = null;
  var byteCountPOST = null;
  function getPayload() {
    return eventStorePayload.payload;
  }
  function getServerAnonymization() {
    var _a;
    return (_a = eventStorePayload.svrAnon) !== null && _a !== void 0 ? _a : false;
  }
  function getCachedQuerystring(payload) {
    if (querystring === null) {
      querystring = getQuerystring(payload);
    }
    return querystring;
  }
  function getGETRequestURL(collectorUrl, useStm) {
    var querystring = getCachedQuerystring(getPayload());
    if (useStm) {
      return collectorUrl + querystring.replace('?', '?stm=' + new Date().getTime() + '&');
    }
    return collectorUrl + querystring;
  }
  function getGETRequestBytesCount() {
    if (byteCountGET === null) {
      var querystring_1 = getCachedQuerystring(getPayload());
      byteCountGET = getUTF8Length(querystring_1);
    }
    return byteCountGET;
  }
  function getPOSTRequestBody() {
    if (postBody === null) {
      postBody = preparePostBody(getPayload());
    }
    return postBody;
  }
  function getPOSTRequestBytesCount() {
    if (byteCountPOST === null) {
      byteCountPOST = getUTF8Length(JSON.stringify(getPOSTRequestBody()));
    }
    return byteCountPOST;
  }
  return {
    getPayload: getPayload,
    getServerAnonymization: getServerAnonymization,
    getGETRequestURL: getGETRequestURL,
    getGETRequestBytesCount: getGETRequestBytesCount,
    getPOSTRequestBody: getPOSTRequestBody,
    getPOSTRequestBytesCount: getPOSTRequestBytesCount
  };
}
function newEmitter(_a) {
  var endpoint = _a.endpoint,
    _b = _a.eventMethod,
    eventMethod = _b === void 0 ? 'post' : _b,
    postPath = _a.postPath,
    protocol = _a.protocol,
    port = _a.port,
    _c = _a.maxPostBytes,
    maxPostBytes = _c === void 0 ? 40000 : _c,
    maxGetBytes = _a.maxGetBytes,
    _d = _a.bufferSize,
    bufferSize = _d === void 0 ? 1 : _d,
    customHeaders = _a.customHeaders,
    serverAnonymization = _a.serverAnonymization,
    connectionTimeout = _a.connectionTimeout,
    keepalive = _a.keepalive,
    cookieExtensionService = _a.cookieExtensionService,
    idService = _a.idService,
    _e = _a.dontRetryStatusCodes,
    dontRetryStatusCodes = _e === void 0 ? [] : _e,
    _f = _a.retryStatusCodes,
    retryStatusCodes = _f === void 0 ? [] : _f,
    _g = _a.retryFailedRequests,
    retryFailedRequests = _g === void 0 ? true : _g,
    onRequestFailure = _a.onRequestFailure,
    onRequestSuccess = _a.onRequestSuccess,
    _h = _a.customFetch,
    customFetch = _h === void 0 ? fetch : _h,
    useStm = _a.useStm,
    _j = _a.eventStore,
    eventStore = _j === void 0 ? newInMemoryEventStore({}) : _j,
    credentials = _a.credentials;
  /* `cookieExtensionService` gets priority until `idService` is completely removed. */
  cookieExtensionService = cookieExtensionService || idService;
  var cookieExtensionServiceCalled = false;
  var flushInProgress = false;
  var usePost = eventMethod.toLowerCase() === 'post';
  dontRetryStatusCodes = dontRetryStatusCodes.concat([400, 401, 403, 410, 422]);
  function shouldRetryForStatusCode(statusCode) {
    // success, don't retry
    if (statusCode >= 200 && statusCode < 300) {
      return false;
    }
    if (!retryFailedRequests) {
      return false;
    }
    // retry if status code among custom user-supplied retry codes
    if (retryStatusCodes.includes(statusCode)) {
      return true;
    }
    // retry if status code *not* among the don't retry codes
    return !dontRetryStatusCodes.includes(statusCode);
  }
  function callOnRequestSuccess(payloads, response) {
    if (onRequestSuccess !== undefined) {
      setTimeout(function () {
        try {
          onRequestSuccess === null || onRequestSuccess === void 0 ? void 0 : onRequestSuccess(payloads, response);
        } catch (e) {
          LOG.error('Error in onRequestSuccess', e);
        }
      }, 0);
    }
  }
  function callOnRequestFailure(failure, response) {
    if (onRequestFailure !== undefined) {
      setTimeout(function () {
        try {
          onRequestFailure === null || onRequestFailure === void 0 ? void 0 : onRequestFailure(failure, response);
        } catch (e) {
          LOG.error('Error in onRequestFailure', e);
        }
      }, 0);
    }
  }
  function executeRequest(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var fetchRequest, payloads, response, willRetry, e_1, message;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            fetchRequest = request.toRequest();
            if (fetchRequest === undefined) {
              throw new Error('Empty batch');
            }
            payloads = request.getEvents().map(function (event) {
              return event.getPayload();
            });
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4 /*yield*/, customFetch(fetchRequest)];
          case 2:
            response = _a.sent();
            return [4 /*yield*/, response.text()];
          case 3:
            _a.sent(); // wait for the response to be fully read
            request.closeRequest(true);
            if (response.ok) {
              callOnRequestSuccess(payloads, response);
              return [2 /*return*/, {
                success: true,
                retry: false,
                status: response.status
              }];
            } else {
              willRetry = shouldRetryForStatusCode(response.status);
              callOnRequestFailure({
                events: payloads,
                status: response.status,
                message: response.statusText,
                willRetry: willRetry
              }, response);
              return [2 /*return*/, {
                success: false,
                retry: willRetry,
                status: response.status
              }];
            }
          case 4:
            e_1 = _a.sent();
            request.closeRequest(false);
            message = typeof e_1 === 'string' ? e_1 : e_1 ? e_1.message : 'Unknown error';
            callOnRequestFailure({
              events: payloads,
              message: message,
              willRetry: true
            });
            return [2 /*return*/, {
              success: false,
              retry: true
            }];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function newEmitterRequestWithConfig() {
    return newEmitterRequest({
      endpoint: endpoint,
      protocol: protocol,
      port: port,
      eventMethod: eventMethod,
      customHeaders: customHeaders,
      connectionTimeout: connectionTimeout,
      keepalive: keepalive,
      maxPostBytes: maxPostBytes,
      useStm: useStm,
      credentials: credentials,
      postPath: postPath
    });
  }
  function shouldSkipEventStore(emitterEvent) {
    var eventTooBigWarning = function eventTooBigWarning(bytes, maxBytes) {
      return LOG.warn('Event (' + bytes + 'B) too big, max is ' + maxBytes);
    };
    if (usePost) {
      var bytes = emitterEvent.getPOSTRequestBytesCount() + 88; // 88 bytes for the payload_data envelope
      var tooBig = bytes > maxPostBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxPostBytes);
      }
      return tooBig;
    } else {
      if (maxGetBytes === undefined) {
        return false;
      }
      var bytes = emitterEvent.getGETRequestBytesCount();
      var tooBig = bytes > maxGetBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxGetBytes);
      }
      return tooBig;
    }
  }
  function callCookieExtensionService() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(cookieExtensionService && !cookieExtensionServiceCalled)) return [3 /*break*/, 2];
            cookieExtensionServiceCalled = true;
            request = new Request(cookieExtensionService, {
              method: 'GET'
            });
            return [4 /*yield*/, customFetch(request)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  }
  function flush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var e_2;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!flushInProgress) return [3 /*break*/, 5];
            flushInProgress = true;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, continueFlush()];
          case 2:
            _a.sent();
            return [3 /*break*/, 5];
          case 3:
            e_2 = _a.sent();
            LOG.error('Error sending events', e_2);
            return [3 /*break*/, 5];
          case 4:
            flushInProgress = false;
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function continueFlush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request, eventStoreIterator, _a, value, done, event_1, _b, success, retry, status;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4 /*yield*/, callCookieExtensionService()];
          case 1:
            _c.sent();
            request = newEmitterRequestWithConfig();
            eventStoreIterator = eventStore.iterator();
            _c.label = 2;
          case 2:
            if (request.isFull()) {
              return [3 /*break*/, 4];
            }
            return [4 /*yield*/, eventStoreIterator.next()];
          case 3:
            _a = _c.sent(), value = _a.value, done = _a.done;
            if (done || value === undefined) {
              return [3 /*break*/, 4];
            }
            event_1 = newEmitterEvent(value);
            if (!request.addEvent(event_1)) {
              return [3 /*break*/, 4];
            }
            return [3 /*break*/, 2];
          case 4:
            if (request.countEvents() === 0) {
              return [2 /*return*/];
            }
            return [4 /*yield*/, executeRequest(request)];
          case 5:
            _b = _c.sent(), success = _b.success, retry = _b.retry, status = _b.status;
            if (!(success || !retry)) return [3 /*break*/, 7];
            if (!success) {
              LOG.error("Status ".concat(status, ", will not retry."));
            }
            return [4 /*yield*/, eventStore.removeHead(request.countEvents())];
          case 6:
            _c.sent();
            _c.label = 7;
          case 7:
            if (!success) return [3 /*break*/, 9];
            return [4 /*yield*/, continueFlush()];
          case 8:
            _c.sent();
            _c.label = 9;
          case 9:
            return [2 /*return*/];
        }
      });
    });
  }
  function input(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var eventStorePayload, event, request, count;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            eventStorePayload = newEventStorePayload({
              payload: payload,
              svrAnon: serverAnonymization
            });
            event = newEmitterEvent(eventStorePayload);
            if (!shouldSkipEventStore(event)) return [3 /*break*/, 2];
            request = newEmitterRequestWithConfig();
            request.addEvent(event);
            return [4 /*yield*/, executeRequest(request)];
          case 1:
            _a.sent();
            return [3 /*break*/, 5];
          case 2:
            return [4 /*yield*/, eventStore.add(eventStorePayload)];
          case 3:
            count = _a.sent();
            if (!(count >= bufferSize)) return [3 /*break*/, 5];
            return [4 /*yield*/, flush()];
          case 4:
            _a.sent();
            _a.label = 5;
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function setCollectorUrl(url) {
    endpoint = url;
  }
  function setAnonymousTracking(at) {
    serverAnonymization = at;
  }
  function setBufferSize(bs) {
    bufferSize = bs;
  }
  return {
    flush: flush,
    input: input,
    setCollectorUrl: setCollectorUrl,
    setAnonymousTracking: setAnonymousTracking,
    setBufferSize: setBufferSize
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var version = version$1;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).

var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CART_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ECOMMERCE_ACTION_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECKOUT_STEP_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRODUCT_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGE_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCH_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRANSACTION_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REFUND_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PSYKHE_RECOMMENDATIONS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PSYKHE_PRODUCT_DWELL_TIME_SCHEMA; });
var CART_SCHEMA = 'iglu:com.psykhe/cart/jsonschema/1-0-0';
var ECOMMERCE_ACTION_SCHEMA = 'iglu:com.psykhe/ecommerce_action/jsonschema/1-0-0';
var CHECKOUT_STEP_SCHEMA = 'iglu:com.psykhe/checkout_step/jsonschema/1-0-0';
var PRODUCT_SCHEMA = 'iglu:com.psykhe/product/jsonschema/1-0-0';
var PAGE_SCHEMA = 'iglu:com.psykhe/page/jsonschema/1-0-0';
var SEARCH_SCHEMA = 'iglu:com.psykhe/search/jsonschema/1-0-0';
var USER_SCHEMA = 'iglu:com.psykhe/user/jsonschema/1-0-0';
var TRANSACTION_SCHEMA = 'iglu:com.psykhe/transaction/jsonschema/1-0-0';
var REFUND_SCHEMA = 'iglu:com.psykhe/refund/jsonschema/1-0-0';
var PSYKHE_RECOMMENDATIONS_SCHEMA = 'iglu:com.psykhe/recommendations/jsonschema/1-0-0';
var PSYKHE_PRODUCT_DWELL_TIME_SCHEMA = 'iglu:com.psykhe/product_dwell_time/jsonschema/1-0-0';

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SharedState */
/* unused harmony export addEventListener */
/* unused harmony export addTracker */
/* unused harmony export allTrackerNames */
/* unused harmony export allTrackers */
/* unused harmony export attemptDeleteLocalStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return attemptGetLocalStorage; });
/* unused harmony export attemptGetSessionStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return attemptWriteLocalStorage; });
/* unused harmony export attemptWriteSessionStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cookie; });
/* unused harmony export createCrossDomainParameterValue */
/* unused harmony export createSharedState */
/* unused harmony export decorateQuerystring */
/* unused harmony export deleteCookie */
/* unused harmony export dispatchToTrackers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return dispatchToTrackersInCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findRootDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fixupDomain; });
/* unused harmony export fixupTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fixupUrl; });
/* unused harmony export flushPendingCookies */
/* unused harmony export fromQuerystring */
/* unused harmony export getCookiesWithPrefix */
/* unused harmony export getCssClasses */
/* unused harmony export getFilterByClass */
/* unused harmony export getFilterByName */
/* unused harmony export getHostName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getReferrer; });
/* unused harmony export getTimeZone */
/* unused harmony export getTracker */
/* unused harmony export getTrackers */
/* unused harmony export hasLocalStorage */
/* unused harmony export hasSessionStorage */
/* unused harmony export isFunction */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isValueInArray */
/* unused harmony export localStorageAccessible */
/* unused harmony export parseAndValidateFloat */
/* unused harmony export parseAndValidateInt */
/* unused harmony export trackerExists */
/* unused harmony export urlSafeBase64Encode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha1__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow Browser trackers v4.5.0 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */






/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Attempt to get a value from localStorage
 *
 * @param string - key
 * @returns string The value obtained from localStorage, or
 *                undefined if localStorage is inaccessible
 */
function attemptGetLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage,
      exp = localStorageAlias.getItem(key + '.expires');
    if (exp === null || +exp > Date.now()) {
      return localStorageAlias.getItem(key);
    } else {
      localStorageAlias.removeItem(key);
      localStorageAlias.removeItem(key + '.expires');
    }
    return undefined;
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to localStorage
 *
 * @param string - key
 * @param string - value
 * @param number - ttl Time to live in seconds, defaults to 2 years from Date.now()
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteLocalStorage(key, value, ttl) {
  if (ttl === void 0) {
    ttl = 63072000;
  }
  try {
    var localStorageAlias = window.localStorage,
      t = Date.now() + ttl * 1000;
    localStorageAlias.setItem("".concat(key, ".expires"), t.toString());
    localStorageAlias.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to delete a value from localStorage
 *
 * @param string - key
 * @returns boolean Whether the operation succeeded
 */
function attemptDeleteLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage;
    localStorageAlias.removeItem(key);
    localStorageAlias.removeItem(key + '.expires');
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to get a value from sessionStorage
 *
 * @param string - key
 * @returns string The value obtained from sessionStorage, or
 *                undefined if sessionStorage is inaccessible
 */
function attemptGetSessionStorage(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to sessionStorage
 *
 * @param string - key
 * @param string - value
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteSessionStorage(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
var DEFAULT_CROSS_DOMAIN_LINKER_PARAMS = {
  sessionId: true,
  sourceId: true,
  sourcePlatform: false,
  userId: false,
  reason: false
};
function createCrossDomainParameterValue(isExtendedFormat, attributeConfiguration, attributeValues) {
  var _a;
  var crossDomainParameterValue;
  var timestamp = new Date().getTime();
  var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, DEFAULT_CROSS_DOMAIN_LINKER_PARAMS), attributeConfiguration);
  var domainUserId = attributeValues.domainUserId,
    userId = attributeValues.userId,
    sessionId = attributeValues.sessionId,
    sourceId = attributeValues.sourceId,
    sourcePlatform = attributeValues.sourcePlatform,
    event = attributeValues.event;
  var eventTarget = event.currentTarget;
  var reason = typeof config.reason === 'function' ? config.reason(event) : (_a = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.textContent) === null || _a === void 0 ? void 0 : _a.trim();
  if (isExtendedFormat) {
    /* Index is used by Enrich, so it should not be changed. */
    crossDomainParameterValue = [domainUserId, timestamp, config.sessionId && sessionId, config.userId && urlSafeBase64Encode(userId || ''), config.sourceId && urlSafeBase64Encode(sourceId || ''), config.sourcePlatform && sourcePlatform, config.reason && urlSafeBase64Encode(reason || '')].map(function (attribute) {
      return attribute || '';
    }).join('.')
    // Remove trailing dots
    .replace(/([.]*$)/, '');
  } else {
    crossDomainParameterValue = attributeValues.domainUserId + '.' + timestamp;
  }
  return crossDomainParameterValue;
}
/**
 *
 * The url-safe variation emits - and _ instead of + and / characters. Also removes = sign padding.
 * @param {string} str The string to encode in a URL safe manner
 * @return {string}
 */
function urlSafeBase64Encode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Checks if an object is a string
 * @param str - The object to check
 */
function isString(str) {
  if (str && typeof str.valueOf() === 'string') {
    return true;
  }
  return false;
}
/**
 * Checks if an object is an integer
 * @param int - The object to check
 */
function isInteger(_int) {
  return Number.isInteger && Number.isInteger(_int) || typeof _int === 'number' && isFinite(_int) && Math.floor(_int) === _int;
}
/**
 * Checks if the input parameter is a function
 * @param func - The object to check
 */
function isFunction(func) {
  if (func && typeof func === 'function') {
    return true;
  }
  return false;
}
/**
 * Lightweight configured runtime timezone detection
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions#getting_the_users_time_zone_and_locale_preferences
 * @returns IANA timezone name of current runtime preference
 */
function getTimeZone() {
  if ((typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && typeof Intl.DateTimeFormat === 'function') {
    var systemPreferences = new Intl.DateTimeFormat().resolvedOptions();
    return systemPreferences.timeZone;
  }
}
/**
 * Cleans up the page title
 */
function fixupTitle(title) {
  if (!isString(title)) {
    title = title.text || '';
    var tmp = document.getElementsByTagName('title');
    if (tmp && tmp[0] != null) {
      title = tmp[0].text;
    }
  }
  return title;
}
/**
 * Extract hostname from URL
 */
function getHostName(url) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:(?:https?|ftp):)/*(?:[^@]+@)?([^:/#]+)'),
    matches = e.exec(url);
  return matches ? matches[1] : url;
}
/**
 * Fix-up domain
 */
function fixupDomain(domain) {
  var dl = domain.length;
  // remove trailing '.'
  if (domain.charAt(--dl) === '.') {
    domain = domain.slice(0, dl);
  }
  // remove leading '*'
  if (domain.slice(0, 2) === '*.') {
    domain = domain.slice(1);
  }
  return domain;
}
/**
 * Get page referrer. In the case of a single-page app,
 * if the URL changes without the page reloading, pass
 * in the old URL. It will be returned unless overriden
 * by a "refer(r)er" parameter in the querystring.
 *
 * @param string - oldLocation Optional.
 * @returns string The referrer
 */
function getReferrer(oldLocation) {
  var windowAlias = window,
    fromQs = fromQuerystring('referrer', windowAlias.location.href) || fromQuerystring('referer', windowAlias.location.href);
  // Short-circuit
  if (fromQs) {
    return fromQs;
  }
  // In the case of a single-page app, return the old URL
  if (oldLocation) {
    return oldLocation;
  }
  try {
    if (windowAlias.top) {
      return windowAlias.top.document.referrer;
    } else if (windowAlias.parent) {
      return windowAlias.parent.document.referrer;
    }
  } catch (_a) {}
  return document.referrer;
}
/**
 * Cross-browser helper function to add event handler
 */
function addEventListener(element, eventType, eventHandler, options) {
  if (element.addEventListener) {
    element.addEventListener(eventType, eventHandler, options);
    return true;
  }
  // IE Support
  if (element.attachEvent) {
    return element.attachEvent('on' + eventType, eventHandler);
  }
  element['on' + eventType] = eventHandler;
}
/**
 * Return value from name-value pair in querystring
 */
function fromQuerystring(field, url) {
  var match = new RegExp('^[^#]*[?&]' + field + '=([^&#]*)').exec(url);
  if (!match) {
    return null;
  }
  return decodeURIComponent(match[1].replace(/\+/g, ' '));
}
/**
 * Add a name-value pair to the querystring of a URL
 *
 * @param string - url URL to decorate
 * @param string - name Name of the querystring pair
 * @param string - value Value of the querystring pair
 */
function decorateQuerystring(url, name, value) {
  var initialQsParams = name + '=' + value;
  var hashSplit = url.split('#');
  var qsSplit = hashSplit[0].split('?');
  var beforeQuerystring = qsSplit.shift();
  // Necessary because a querystring may contain multiple question marks
  var querystring = qsSplit.join('?');
  if (!querystring) {
    querystring = initialQsParams;
  } else {
    // Whether this is the first time the link has been decorated
    var initialDecoration = true;
    var qsFields = querystring.split('&');
    for (var i = 0; i < qsFields.length; i++) {
      if (qsFields[i].substr(0, name.length + 1) === name + '=') {
        initialDecoration = false;
        qsFields[i] = initialQsParams;
        querystring = qsFields.join('&');
        break;
      }
    }
    if (initialDecoration) {
      querystring = initialQsParams + '&' + querystring;
    }
  }
  hashSplit[0] = beforeQuerystring + '?' + querystring;
  return hashSplit.join('#');
}
/**
 * Finds the root domain
 */
function findRootDomain(sameSite, secure) {
  var windowLocationHostnameAlias = window.location.hostname,
    cookiePrefix = '_sp_root_domain_test_',
    cookieName = cookiePrefix + new Date().getTime(),
    cookieValue = '_test_value_' + new Date().getTime();
  var locationParts = windowLocationHostnameAlias.split('.');
  for (var idx = locationParts.length - 2; idx >= 0; idx--) {
    var currentDomain = locationParts.slice(idx).join('.');
    cookie(cookieName, cookieValue, 0, '/', currentDomain, sameSite, secure);
    if (cookie(cookieName) === cookieValue) {
      // Clean up created cookie(s)
      deleteCookie(cookieName, '/', currentDomain, sameSite, secure);
      var cookieNames = getCookiesWithPrefix(cookiePrefix);
      for (var i = 0; i < cookieNames.length; i++) {
        deleteCookie(cookieNames[i], '/', currentDomain, sameSite, secure);
      }
      return currentDomain;
    }
  }
  // Cookies cannot be read
  return windowLocationHostnameAlias;
}
/**
 * Checks whether a value is present within an array
 *
 * @param val - The value to check for
 * @param array - The array to check within
 * @returns boolean Whether it exists
 */
function isValueInArray(val, array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === val) {
      return true;
    }
  }
  return false;
}
/**
 * Deletes an arbitrary cookie by setting the expiration date to the past
 *
 * @param cookieName - The name of the cookie to delete
 * @param domainName - The domain the cookie is in
 */
function deleteCookie(cookieName, path, domainName, sameSite, secure) {
  cookie(cookieName, '', -1, path, domainName, sameSite, secure);
}
/**
 * Fetches the name of all cookies beginning with a certain prefix
 *
 * @param cookiePrefix - The prefix to check for
 * @returns array The cookies that begin with the prefix
 */
function getCookiesWithPrefix(cookiePrefix) {
  var cookies = document.cookie.split('; ');
  var cookieNames = [];
  for (var i = 0; i < cookies.length; i++) {
    if (cookies[i].substring(0, cookiePrefix.length) === cookiePrefix) {
      cookieNames.push(cookies[i]);
    }
  }
  return cookieNames;
}
/**
 * Get and set the cookies associated with the current document in browser
 * This implementation always returns a string, returns the cookie value if only name is specified
 *
 * @param name - The cookie name (required)
 * @param value - The cookie value
 * @param ttl - The cookie Time To Live (seconds)
 * @param path - The cookies path
 * @param domain - The cookies domain
 * @param samesite - The cookies samesite attribute
 * @param secure - Boolean to specify if cookie should be secure
 * @returns string The cookies value
 */
function cookie(name, value, ttl, path, domain, samesite, secure) {
  if (arguments.length > 1) {
    return document.cookie = name + '=' + encodeURIComponent(value !== null && value !== void 0 ? value : '') + (ttl ? '; Expires=' + new Date(+new Date() + ttl * 1000).toUTCString() : '') + (path ? '; Path=' + path : '') + (domain ? '; Domain=' + domain : '') + (samesite ? '; SameSite=' + samesite : '') + (secure ? '; Secure' : '');
  }
  return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
}
/**
 * Parses an object and returns either the
 * integer or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateInt(obj) {
  var result = parseInt(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Parses an object and returns either the
 * number or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateFloat(obj) {
  var result = parseFloat(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 * @param boolean - byClass Whether to allowlist/denylist based on an element's classes (for forms)
 *                        or name attribute (for fields)
 */
function getFilterByClass(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = Object.prototype.hasOwnProperty.call(criterion, 'allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return checkClass(elt, specifiedClassesSet) === inclusive;
  });
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 */
function getFilterByName(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = criterion.hasOwnProperty('allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return elt.name in specifiedClassesSet === inclusive;
  });
}
/**
 * List the classes of a DOM element without using elt.classList (for compatibility with IE 9)
 */
function getCssClasses(elt) {
  return elt.className.match(/\S+/g) || [];
}
/**
 * Check whether an element has at least one class from a given list
 */
function checkClass(elt, classList) {
  var classes = getCssClasses(elt);
  for (var _i = 0, classes_1 = classes; _i < classes_1.length; _i++) {
    var className = classes_1[_i];
    if (classList[className]) {
      return true;
    }
  }
  return false;
}
function getFilter(criterion, fallbackFilter) {
  if (criterion.hasOwnProperty('filter') && criterion.filter) {
    return criterion.filter;
  }
  return fallbackFilter;
}
function getSpecifiedClassesSet(criterion) {
  // Convert the array of classes to an object of the form {class1: true, class2: true, ...}
  var specifiedClassesSet = {};
  var specifiedClasses = criterion.allowlist || criterion.denylist;
  if (specifiedClasses) {
    if (!Array.isArray(specifiedClasses)) {
      specifiedClasses = [specifiedClasses];
    }
    for (var i = 0; i < specifiedClasses.length; i++) {
      specifiedClassesSet[specifiedClasses[i]] = true;
    }
  }
  return specifiedClassesSet;
}
function newLocalStorageEventStore(_a) {
  var trackerId = _a.trackerId,
    _b = _a.maxLocalStorageQueueSize,
    maxLocalStorageQueueSize = _b === void 0 ? 1000 : _b,
    _c = _a.useLocalStorage,
    useLocalStorage = _c === void 0 ? true : _c;
  var queueName = "snowplowOutQueue_".concat(trackerId);
  function newInMemoryEventStoreFromLocalStorage() {
    if (useLocalStorage) {
      var localStorageQueue = window.localStorage.getItem(queueName);
      var events = localStorageQueue ? JSON.parse(localStorageQueue) : [];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["a" /* newInMemoryEventStore */])({
        maxSize: maxLocalStorageQueueSize,
        events: events
      });
    } else {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["a" /* newInMemoryEventStore */])({
        maxSize: maxLocalStorageQueueSize
      });
    }
  }
  var _d = newInMemoryEventStoreFromLocalStorage(),
    getAll = _d.getAll,
    getAllPayloads = _d.getAllPayloads,
    _add = _d.add,
    count = _d.count,
    iterator = _d.iterator,
    _removeHead = _d.removeHead;
  function sync() {
    if (useLocalStorage) {
      return getAll().then(function (events) {
        window.localStorage.setItem(queueName, JSON.stringify(events));
      });
    } else {
      return Promise.resolve();
    }
  }
  return {
    count: count,
    add: function add(payload) {
      _add(payload);
      return sync().then(count);
    },
    removeHead: function removeHead(count) {
      _removeHead(count);
      return sync();
    },
    iterator: iterator,
    getAll: getAll,
    getAllPayloads: getAllPayloads,
    setUseLocalStorage: function setUseLocalStorage(use) {
      useLocalStorage = use;
    }
  };
}
function newOutQueue(configuration, sharedState) {
  var _a;
  var eventStore = (_a = configuration.eventStore) !== null && _a !== void 0 ? _a : newLocalStorageEventStore(configuration);
  configuration.eventStore = eventStore;
  var emitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["b" /* newEmitter */])(configuration);
  sharedState.bufferFlushers.push(emitter.flush);
  return {
    enqueueRequest: emitter.input,
    executeQueue: emitter.flush,
    setAnonymousTracking: emitter.setAnonymousTracking,
    setCollectorUrl: emitter.setCollectorUrl,
    setBufferSize: emitter.setBufferSize,
    setUseLocalStorage: function setUseLocalStorage(localStorage) {
      if (eventStore.hasOwnProperty('setUseLocalStorage')) {
        var localStorageStore = eventStore;
        localStorageStore.setUseLocalStorage(localStorage);
      }
    }
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Extract parameter from URL
 */
function getParameter(url, name) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:https?|ftp)(?::/*(?:[^?]+))([?][^#]+)'),
    matches = e.exec(url);
  if (matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 1) {
    return fromQuerystring(name, matches[1]);
  }
  return null;
}
/*
 * Fix-up URL when page rendered from search engine cache or translated page.
 */
function fixupUrl(hostName, href, referrer) {
  var _a;
  if (hostName === 'translate.googleusercontent.com') {
    // Google
    if (referrer === '') {
      referrer = href;
    }
    href = (_a = getParameter(href, 'u')) !== null && _a !== void 0 ? _a : '';
    hostName = getHostName(href);
  } else if (hostName === 'cc.bingj.com' ||
  // Bing & Yahoo
  hostName === 'webcache.googleusercontent.com' // Google
  ) {
    href = document.links[0].href;
    hostName = getHostName(href);
  }
  return [hostName, href, referrer];
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Indices of cookie values
 */
var cookieDisabledIndex = 0,
  domainUserIdIndex = 1,
  createTsIndex = 2,
  visitCountIndex = 3,
  nowTsIndex = 4,
  lastVisitTsIndex = 5,
  sessionIdIndex = 6,
  previousSessionIdIndex = 7,
  firstEventIdIndex = 8,
  firstEventTsInMsIndex = 9,
  eventIndexIndex = 10;
function emptyIdCookie() {
  var idCookie = ['1', '', 0, 0, 0, undefined, '', '', '', undefined, 0];
  return idCookie;
}
/**
 * Parses the cookie values from its string representation.
 *
 * @param id Cookie value as string
 * @param domainUserId Domain user ID to be used in case of empty cookie string
 * @returns Parsed ID cookie tuple
 */
function parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount) {
  var now = new Date(),
    nowTs = Math.round(now.getTime() / 1000),
    tmpContainer;
  if (id) {
    tmpContainer = id.split('.');
    // cookies enabled
    tmpContainer.unshift('0');
  } else {
    tmpContainer = [
    // cookies disabled
    '1',
    // Domain user ID
    domainUserId,
    // Creation timestamp - seconds since Unix epoch
    nowTs,
    // visitCount - 0 = no previous visit
    memorizedVisitCount,
    // Current visit timestamp
    nowTs,
    // Last visit timestamp - blank meaning no previous visit
    '',
    // Session ID
    memorizedSessionId];
  }
  if (!tmpContainer[sessionIdIndex] || tmpContainer[sessionIdIndex] === 'undefined') {
    // session id
    tmpContainer[sessionIdIndex] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
  }
  if (!tmpContainer[previousSessionIdIndex] || tmpContainer[previousSessionIdIndex] === 'undefined') {
    // previous session id
    tmpContainer[previousSessionIdIndex] = '';
  }
  if (!tmpContainer[firstEventIdIndex] || tmpContainer[firstEventIdIndex] === 'undefined') {
    // firstEventId - blank meaning no previous event
    tmpContainer[firstEventIdIndex] = '';
  }
  if (!tmpContainer[firstEventTsInMsIndex] || tmpContainer[firstEventTsInMsIndex] === 'undefined') {
    // firstEventTs - blank meaning no previous event
    tmpContainer[firstEventTsInMsIndex] = '';
  }
  if (!tmpContainer[eventIndexIndex] || tmpContainer[eventIndexIndex] === 'undefined') {
    // eventIndex – 0 = no previous event
    tmpContainer[eventIndexIndex] = 0;
  }
  var parseIntOr = function parseIntOr(value, defaultValue) {
    var parsed = parseInt(value);
    return isNaN(parsed) ? defaultValue : parsed;
  };
  var parseIntOrUndefined = function parseIntOrUndefined(value) {
    return value ? parseIntOr(value, undefined) : undefined;
  };
  var parsed = [tmpContainer[cookieDisabledIndex], tmpContainer[domainUserIdIndex], parseIntOr(tmpContainer[createTsIndex], nowTs), parseIntOr(tmpContainer[visitCountIndex], memorizedVisitCount), parseIntOr(tmpContainer[nowTsIndex], nowTs), parseIntOrUndefined(tmpContainer[lastVisitTsIndex]), tmpContainer[sessionIdIndex], tmpContainer[previousSessionIdIndex], tmpContainer[firstEventIdIndex], parseIntOrUndefined(tmpContainer[firstEventTsInMsIndex]), parseIntOr(tmpContainer[eventIndexIndex], 0)];
  return parsed;
}
/**
 * Initializes the domain user ID if not already present in the cookie. Sets an empty string if anonymous tracking.
 *
 * @param idCookie Parsed cookie
 * @param configAnonymousTracking Whether anonymous tracking is enabled
 * @returns Domain user ID
 */
function initializeDomainUserId(idCookie, configAnonymousTracking) {
  var domainUserId;
  if (idCookie[domainUserIdIndex]) {
    domainUserId = idCookie[domainUserIdIndex];
  } else if (!configAnonymousTracking) {
    domainUserId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
    idCookie[domainUserIdIndex] = domainUserId;
  } else {
    domainUserId = '';
    idCookie[domainUserIdIndex] = domainUserId;
  }
  return domainUserId;
}
/**
 * Starts a new session with a new ID.
 * Sets the previous session, last visit timestamp, and increments visit count if cookies enabled.
 * First event references are reset and will be updated in `updateFirstEventInIdCookie`.
 *
 * @param idCookie Parsed cookie
 * @param options.configStateStorageStrategy Cookie storage strategy
 * @param options.configAnonymousTracking If anonymous tracking is enabled
 * @param options.memorizedVisitCount Visit count to be used if cookies not enabled
 * @param options.onSessionUpdateCallback Session callback triggered on every session update
 * @returns New session ID
 */
function startNewIdCookieSession(idCookie, options) {
  if (options === void 0) {
    options = {
      memorizedVisitCount: 1
    };
  }
  var memorizedVisitCount = options.memorizedVisitCount;
  // If cookies are enabled, base visit count and session ID on the cookies
  if (cookiesEnabledInIdCookie(idCookie)) {
    // Store the previous session ID
    idCookie[previousSessionIdIndex] = idCookie[sessionIdIndex];
    // Set lastVisitTs to currentVisitTs
    idCookie[lastVisitTsIndex] = idCookie[nowTsIndex];
    // Increment the session ID
    idCookie[visitCountIndex]++;
  } else {
    idCookie[visitCountIndex] = memorizedVisitCount;
  }
  // Create a new sessionId
  var sessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
  idCookie[sessionIdIndex] = sessionId;
  // Reset event index and first event references
  idCookie[eventIndexIndex] = 0;
  idCookie[firstEventIdIndex] = '';
  idCookie[firstEventTsInMsIndex] = undefined;
  return sessionId;
}
/**
 * Update now timestamp in cookie.
 *
 * @param idCookie Parsed cookie
 */
function updateNowTsInIdCookie(idCookie) {
  idCookie[nowTsIndex] = Math.round(new Date().getTime() / 1000);
}
/**
 * Updates the first event references according to the event payload if first event in session.
 *
 * @param idCookie - Parsed cookie
 * @param payloadBuilder - Event payload builder
 */
function updateFirstEventInIdCookie(idCookie, payloadBuilder) {
  // Update first event references if new session or not present
  if (idCookie[eventIndexIndex] === 0) {
    var payload = payloadBuilder.build();
    idCookie[firstEventIdIndex] = payload['eid'];
    var ts = payload['dtm'] || payload['ttm'];
    idCookie[firstEventTsInMsIndex] = ts ? parseInt(ts) : undefined;
  }
}
/**
 * Increments event index counter.
 *
 * @param idCookie Parsed cookie
 */
function incrementEventIndexInIdCookie(idCookie) {
  idCookie[eventIndexIndex] += 1;
}
/**
 * Serializes parsed cookie to string representation.
 *
 * @param idCookie Parsed cookie
 * @returns String cookie value
 */
function serializeIdCookie(idCookie, configAnonymousTracking) {
  var anonymizedIdCookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __spreadArray */])([], idCookie, true);
  if (configAnonymousTracking) {
    anonymizedIdCookie[domainUserIdIndex] = '';
    anonymizedIdCookie[previousSessionIdIndex] = '';
  }
  anonymizedIdCookie.shift();
  return anonymizedIdCookie.join('.');
}
/**
 * Transforms the parsed cookie into a client session context entity.
 *
 * @param idCookie Parsed cookie
 * @param configStateStorageStrategy Cookie storage strategy
 * @param configAnonymousTracking If anonymous tracking is enabled
 * @returns Client session context entity
 */
function clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking) {
  var firstEventTsInMs = idCookie[firstEventTsInMsIndex];
  var clientSession = {
    userId: configAnonymousTracking ? '00000000-0000-0000-0000-000000000000' // TODO: use uuid.NIL when we upgrade to uuid v8.3
    : idCookie[domainUserIdIndex],
    sessionId: idCookie[sessionIdIndex],
    eventIndex: idCookie[eventIndexIndex],
    sessionIndex: idCookie[visitCountIndex],
    previousSessionId: configAnonymousTracking ? null : idCookie[previousSessionIdIndex] || null,
    storageMechanism: configStateStorageStrategy == 'localStorage' ? 'LOCAL_STORAGE' : 'COOKIE_1',
    firstEventId: idCookie[firstEventIdIndex] || null,
    firstEventTimestamp: firstEventTsInMs ? new Date(firstEventTsInMs).toISOString() : null
  };
  return clientSession;
}
function sessionIdFromIdCookie(idCookie) {
  return idCookie[sessionIdIndex];
}
function domainUserIdFromIdCookie(idCookie) {
  return idCookie[domainUserIdIndex];
}
function visitCountFromIdCookie(idCookie) {
  return idCookie[visitCountIndex];
}
function cookiesEnabledInIdCookie(idCookie) {
  return idCookie[cookieDisabledIndex] === '0';
}
function eventIndexFromIdCookie(idCookie) {
  return idCookie[eventIndexIndex];
}
var WEB_PAGE_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/web_page/jsonschema/1-0-0';
var BROWSER_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/browser_context/jsonschema/2-0-0';
var CLIENT_SESSION_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/client_session/jsonschema/1-0-2';
var APPLICATION_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/application/jsonschema/1-0-0';
function useResizeObserver() {
  return 'ResizeObserver' in window;
}
var resizeObserverInitialized = false;
var readBrowserPropertiesTask = null;
function initializeResizeObserver() {
  if (resizeObserverInitialized) {
    return;
  }
  if (!document || !document.body || !document.documentElement) {
    return;
  }
  resizeObserverInitialized = true;
  var resizeObserver = new ResizeObserver(function () {
    if (!readBrowserPropertiesTask) {
      // The browser property lookup causes a forced synchronous layout when offsets/sizes are
      // queried. It's possible that the forced synchronous layout causes the ResizeObserver
      // to be fired again, leading to an infinite loop and the "ResizeObserver loop completed
      // with undelivered notifications" error.
      readBrowserPropertiesTask = requestAnimationFrame(function () {
        readBrowserPropertiesTask = null;
        cachedProperties = readBrowserProperties();
      });
    }
  });
  resizeObserver.observe(document.body);
  resizeObserver.observe(document.documentElement);
}
var cachedProperties;
/* Separator used for dimension values e.g. widthxheight */
var DIMENSION_SEPARATOR = 'x';
/**
 * Gets various browser properties (that are expensive to read!)
 * - Will use a "ResizeObserver" approach in modern browsers to update cached properties only on change
 * - Will fallback to a direct read approach without cache in old browsers
 *
 * @returns BrowserProperties
 */
function getBrowserProperties() {
  if (!useResizeObserver()) {
    return readBrowserProperties();
  }
  if (!cachedProperties) {
    cachedProperties = readBrowserProperties();
  }
  initializeResizeObserver();
  return cachedProperties;
}
/**
 * Reads the browser properties - expensive call!
 *
 * @returns BrowserProperties
 */
function readBrowserProperties() {
  return {
    viewport: floorDimensionFields(detectViewport()),
    documentSize: floorDimensionFields(detectDocumentSize()),
    resolution: floorDimensionFields(detectScreenResolution()),
    colorDepth: screen.colorDepth,
    devicePixelRatio: window.devicePixelRatio,
    cookiesEnabled: window.navigator.cookieEnabled,
    online: window.navigator.onLine,
    browserLanguage: window.navigator.language || window.navigator.userLanguage,
    documentLanguage: document.documentElement.lang,
    webdriver: window.navigator.webdriver,
    deviceMemory: window.navigator.deviceMemory,
    hardwareConcurrency: window.navigator.hardwareConcurrency
  };
}
/**
 * Gets the current viewport.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 * - http://responsejs.com/labs/dimensions/
 */
function detectViewport() {
  var width, height;
  if ('innerWidth' in window) {
    width = window['innerWidth'];
    height = window['innerHeight'];
  } else {
    var e = document.documentElement || document.body;
    width = e['clientWidth'];
    height = e['clientHeight'];
  }
  return Math.max(0, width) + DIMENSION_SEPARATOR + Math.max(0, height);
}
/**
 * Gets the dimensions of the current
 * document.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 */
function detectDocumentSize() {
  var de = document.documentElement,
    // Alias
    be = document.body,
    // document.body may not have rendered, so check whether be.offsetHeight is null
    bodyHeight = be ? Math.max(be.offsetHeight, be.scrollHeight) : 0;
  var w = Math.max(de.clientWidth, de.offsetWidth, de.scrollWidth);
  var h = Math.max(de.clientHeight, de.offsetHeight, de.scrollHeight, bodyHeight);
  return isNaN(w) || isNaN(h) ? '' : w + DIMENSION_SEPARATOR + h;
}
function detectScreenResolution() {
  return screen.width + DIMENSION_SEPARATOR + screen.height;
}
function floorDimensionFields(field) {
  return field && field.split(DIMENSION_SEPARATOR).map(function (dimension) {
    return Math.floor(Number(dimension));
  }).join(DIMENSION_SEPARATOR);
}
function newCookie(name) {
  var flushTimer;
  var lastSetValueArgs;
  var cacheExpireAt;
  var flushed = true;
  var flushTimeout = 10; // milliseconds
  var maxCacheTtl = 0.05; // seconds
  function getValue() {
    var _a;
    // Note: we can't cache the cookie value as we don't know the expiration date
    if (lastSetValueArgs && (!cacheExpireAt || cacheExpireAt > new Date())) {
      return (_a = lastSetValueArgs[0]) !== null && _a !== void 0 ? _a : cookie(name);
    }
    return cookie(name);
  }
  function setValue(value, ttl, path, domain, samesite, secure) {
    lastSetValueArgs = [value, ttl, path, domain, samesite, secure];
    flushed = false;
    // throttle setting the cookie
    if (flushTimer === undefined) {
      flushTimer = setTimeout(function () {
        flushTimer = undefined;
        flush();
      }, flushTimeout);
    }
    cacheExpireAt = new Date(Date.now() + Math.min(maxCacheTtl, ttl !== null && ttl !== void 0 ? ttl : maxCacheTtl) * 1000);
    return true;
  }
  function deleteValue(path, domainName, sameSite, secure) {
    lastSetValueArgs = undefined;
    flushed = true;
    // cancel setting the cookie
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    deleteCookie(name, path, domainName, sameSite, secure);
  }
  function flush() {
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    if (flushed) {
      return;
    }
    flushed = true;
    if (lastSetValueArgs !== undefined) {
      var value = lastSetValueArgs[0],
        ttl = lastSetValueArgs[1],
        path = lastSetValueArgs[2],
        domain = lastSetValueArgs[3],
        samesite = lastSetValueArgs[4],
        secure = lastSetValueArgs[5];
      cookie(name, value, ttl, path, domain, samesite, secure);
    }
  }
  return {
    getValue: getValue,
    setValue: setValue,
    deleteValue: deleteValue,
    flush: flush
  };
}
/**
 * Create a new async cookie storage
 *
 * @returns A new cookie storage
 */
function newCookieStorage() {
  var cache = {};
  function getOrInitCookie(name) {
    if (!cache[name]) {
      cache[name] = newCookie(name);
    }
    return cache[name];
  }
  function getCookie(name) {
    return getOrInitCookie(name).getValue();
  }
  function setCookie(name, value, ttl, path, domain, samesite, secure) {
    return getOrInitCookie(name).setValue(value, ttl, path, domain, samesite, secure);
  }
  function deleteCookie(name, path, domainName, sameSite, secure) {
    getOrInitCookie(name).deleteValue(path, domainName, sameSite, secure);
  }
  function clearCache() {
    cache = {};
  }
  function flush() {
    for (var _i = 0, _a = Object.values(cache); _i < _a.length; _i++) {
      var cookie_1 = _a[_i];
      cookie_1.flush();
    }
  }
  return {
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
    clearCache: clearCache,
    flush: flush
  };
}
/**
 * Cookie storage instance with asynchronous cookie writes
 */
var asyncCookieStorage = newCookieStorage();
/**
 * Cookie storage instance with synchronous cookie writes
 */
var syncCookieStorage = {
  getCookie: cookie,
  setCookie: function setCookie(name, value, ttl, path, domain, samesite, secure) {
    cookie(name, value, ttl, path, domain, samesite, secure);
    return document.cookie.indexOf("".concat(name, "=")) !== -1;
  },
  deleteCookie: deleteCookie,
  flush: function flush() {}
};

/**
 * The Snowplow Tracker
 *
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker object
 * @param version - The current version of the JavaScript Tracker
 * @param endpoint - The collector endpoint to send events to, with or without protocol
 * @param sharedState - An object containing state which is shared across tracker instances
 * @param trackerConfiguration - Dictionary of configuration options
 */
function Tracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration) {
  if (trackerConfiguration === void 0) {
    trackerConfiguration = {};
  }
  var browserPlugins = [];
  var newTracker = function newTracker(trackerId, namespace, version, endpoint, state, trackerConfiguration) {
    /************************************************************
     * Private members
     ************************************************************/
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    //use POST if eventMethod isn't present on the newTrackerConfiguration
    trackerConfiguration.eventMethod = (_a = trackerConfiguration.eventMethod) !== null && _a !== void 0 ? _a : 'post';
    var getStateStorageStrategy = function getStateStorageStrategy(config) {
        var _a;
        return (_a = config.stateStorageStrategy) !== null && _a !== void 0 ? _a : 'cookieAndLocalStorage';
      },
      getAnonymousSessionTracking = function getAnonymousSessionTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withSessionTracking) === true;
      },
      getAnonymousServerTracking = function getAnonymousServerTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withServerAnonymisation) === true;
      },
      getAnonymousTracking = function getAnonymousTracking(config) {
        return !!config.anonymousTracking;
      },
      isBrowserContextAvailable = (_c = (_b = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _b === void 0 ? void 0 : _b.browser) !== null && _c !== void 0 ? _c : false,
      isWebPageContextAvailable = (_e = (_d = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _d === void 0 ? void 0 : _d.webPage) !== null && _e !== void 0 ? _e : true,
      getExtendedCrossDomainTrackingConfiguration = function getExtendedCrossDomainTrackingConfiguration(crossDomainTrackingConfig) {
        if (typeof crossDomainTrackingConfig === 'boolean') {
          return {
            useExtendedCrossDomainLinker: crossDomainTrackingConfig
          };
        }
        return {
          useExtendedCrossDomainLinker: true,
          collectCrossDomainAttributes: crossDomainTrackingConfig
        };
      };
    // Create a new cookie storage instance with synchronous cookie write if configured
    var cookieStorage = trackerConfiguration.synchronousCookieWrite ? syncCookieStorage : asyncCookieStorage;
    // Get all injected plugins
    browserPlugins.push(getBrowserDataPlugin());
    /* When including the Web Page context, we add the relevant internal plugins */
    if (isWebPageContextAvailable) {
      browserPlugins.push(getWebPagePlugin());
    }
    if (isBrowserContextAvailable) {
      browserPlugins.push(getBrowserContextPlugin());
    }
    browserPlugins.push.apply(browserPlugins, (_f = trackerConfiguration.plugins) !== null && _f !== void 0 ? _f : []);
    var
      // Tracker core
      core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["c" /* trackerCore */])({
        base64: (_g = trackerConfiguration.encodeBase64) !== null && _g !== void 0 ? _g : trackerConfiguration.eventMethod !== 'post',
        corePlugins: browserPlugins,
        callback: sendRequest
      }),
      // Aliases
      documentCharset = document.characterSet || document.charset,
      // Current URL and Referrer URL
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer()),
      domainAlias = fixupDomain(locationArray[0]),
      locationHrefAlias = locationArray[1],
      configReferrerUrl = locationArray[2],
      customReferrer,
      // Platform defaults to web for this tracker
      configPlatform = (_h = trackerConfiguration.platform) !== null && _h !== void 0 ? _h : 'web',
      // Site ID
      configTrackerSiteId = (_j = trackerConfiguration.appId) !== null && _j !== void 0 ? _j : '',
      // Application version
      configAppVersion = trackerConfiguration.appVersion,
      // Document URL
      configCustomUrl,
      // Document title
      lastDocumentTitle = document.title,
      // Custom title
      lastConfigTitle,
      // Indicates that the lastConfigTitle was set from a trackPageView call
      // Custom title configured this way has a shorter lifespan than when set using setDocumentTitle.
      // It only lasts until the next trackPageView call.
      lastConfigTitleFromTrackPageView = false,
      // Controls whether activity tracking page ping event timers are reset on page view events
      resetActivityTrackingOnPageView = (_k = trackerConfiguration.resetActivityTrackingOnPageView) !== null && _k !== void 0 ? _k : true,
      // Disallow hash tags in URL. TODO: Should this be set to true by default?
      configDiscardHashTag,
      // Disallow brace in URL.
      configDiscardBrace,
      // First-party cookie name prefix
      configCookieNamePrefix = (_l = trackerConfiguration.cookieName) !== null && _l !== void 0 ? _l : '_sp_',
      // First-party cookie domain
      // User agent defaults to origin hostname
      configCookieDomain = (_m = trackerConfiguration.cookieDomain) !== null && _m !== void 0 ? _m : undefined,
      discoverRootDomain = (_o = trackerConfiguration.discoverRootDomain) !== null && _o !== void 0 ? _o : configCookieDomain === undefined,
      // First-party cookie path
      // Default is user agent defined.
      configCookiePath = '/',
      // First-party cookie samesite attribute
      configCookieSameSite = (_p = trackerConfiguration.cookieSameSite) !== null && _p !== void 0 ? _p : 'Lax',
      // First-party cookie secure attribute
      configCookieSecure = (_q = trackerConfiguration.cookieSecure) !== null && _q !== void 0 ? _q : true,
      // Do Not Track browser feature
      dnt = window.navigator.doNotTrack || window.navigator.msDoNotTrack || window.doNotTrack,
      // Do Not Track
      configDoNotTrack = typeof trackerConfiguration.respectDoNotTrack !== 'undefined' ? trackerConfiguration.respectDoNotTrack && (dnt === 'yes' || dnt === '1') : false,
      // Opt out of cookie tracking
      configOptOutCookie,
      // Life of the visitor cookie (in seconds)
      configVisitorCookieTimeout = (_r = trackerConfiguration.cookieLifetime) !== null && _r !== void 0 ? _r : 63072000,
      // 2 years
      // Life of the session cookie (in seconds)
      configSessionCookieTimeout = (_s = trackerConfiguration.sessionCookieTimeout) !== null && _s !== void 0 ? _s : 1800,
      // 30 minutes
      // Allows tracking user session (using cookies or local storage), can only be used with anonymousTracking
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration),
      // Will send a header to server to prevent returning cookie and capturing IP
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration),
      // Sets tracker to work in anonymous mode without accessing client storage
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration),
      // Strategy defining how to store the state: cookie, localStorage, cookieAndLocalStorage or none
      configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration),
      // Last activity timestamp
      lastActivityTime,
      // The last time an event was fired on the page - used to invalidate session if cookies are disabled
      lastEventTime = new Date().getTime(),
      // How are we scrolling?
      minXOffset,
      maxXOffset,
      minYOffset,
      maxYOffset,
      // Domain hash value
      domainHash,
      // Domain unique user ID
      domainUserId,
      // ID for the current session
      memorizedSessionId,
      // Index for the current session - kept in memory in case cookies are disabled
      memorizedVisitCount = 1,
      // Business-defined unique user ID
      businessUserId,
      // Manager for local storage queue
      outQueue = newOutQueue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({
        trackerId: trackerId,
        endpoint: asCollectorUrl(endpoint),
        serverAnonymization: configAnonymousServerTracking,
        useLocalStorage: configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage'
      }, trackerConfiguration), state),
      // Whether pageViewId should be regenerated after each trackPageView. Affect web_page context
      _preservePageViewId = false,
      // Whether pageViewId should be kept the same until the page URL changes. Affects web_page context
      _preservePageViewIdForUrl = (_t = trackerConfiguration.preservePageViewIdForUrl) !== null && _t !== void 0 ? _t : false,
      // The pageViewId of the last page view event or undefined if no page view tracked yet. Used to determine if pageViewId should be regenerated for a new page view.
      lastSentPageViewId = undefined,
      // Activity tracking config for callback and page ping variants
      activityTrackingConfig = {
        enabled: false,
        installed: false,
        configurations: {}
      },
      configSessionContext = (_v = (_u = trackerConfiguration.contexts) === null || _u === void 0 ? void 0 : _u.session) !== null && _v !== void 0 ? _v : false,
      toOptoutByCookie,
      onSessionUpdateCallback = trackerConfiguration.onSessionUpdateCallback,
      manualSessionUpdateCalled = false,
      _w = getExtendedCrossDomainTrackingConfiguration(trackerConfiguration.useExtendedCrossDomainLinker || false),
      useExtendedCrossDomainLinker = _w.useExtendedCrossDomainLinker,
      collectCrossDomainAttributes = _w.collectCrossDomainAttributes;
    if (discoverRootDomain && !configCookieDomain) {
      configCookieDomain = findRootDomain(configCookieSameSite, configCookieSecure);
    }
    var _x = getBrowserProperties(),
      browserLanguage = _x.browserLanguage,
      resolution = _x.resolution,
      colorDepth = _x.colorDepth,
      cookiesEnabled = _x.cookiesEnabled;
    var timeZone = getTimeZone();
    // Set up unchanging name-value pairs
    core.setTrackerVersion(version);
    core.setTrackerNamespace(namespace);
    core.setAppId(configTrackerSiteId);
    core.setPlatform(configPlatform);
    core.addPayloadPair('cookie', cookiesEnabled ? '1' : '0');
    core.addPayloadPair('cs', documentCharset);
    core.addPayloadPair('lang', browserLanguage);
    core.addPayloadPair('res', resolution);
    core.addPayloadPair('cd', colorDepth);
    if (timeZone) core.addPayloadPair('tz', timeZone);
    // Add the application version context entity
    if (configAppVersion) {
      core.addPlugin({
        plugin: {
          contexts: function contexts() {
            return [{
              schema: APPLICATION_CONTEXT_SCHEMA,
              data: {
                version: configAppVersion
              }
            }];
          }
        }
      });
    }
    /*
     * Initialize tracker
     */
    updateDomainHash();
    initializeIdsAndCookies();
    if (trackerConfiguration.crossDomainLinker) {
      decorateLinks(trackerConfiguration.crossDomainLinker);
    }
    /**
     * Recalculate the domain, URL, and referrer
     */
    function refreshUrl() {
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer());
      // If this is a single-page app and the page URL has changed, then:
      //   - if the new URL's querystring contains a "refer(r)er" parameter, use it as the referrer
      //   - otherwise use the old URL as the referer
      if (locationArray[1] !== locationHrefAlias) {
        configReferrerUrl = getReferrer(locationHrefAlias);
      }
      domainAlias = fixupDomain(locationArray[0]);
      locationHrefAlias = locationArray[1];
    }
    /**
     * Create link handler to decorate the querystring of a link (onClick/onMouseDown)
     *
     * @param event - e The event targeting the link
     */
    function addLinkDecorationHandler(extended) {
      var CROSS_DOMAIN_PARAMETER_NAME = '_sp';
      return function (evt) {
        var elt = evt.currentTarget;
        var crossDomainParameterValue = createCrossDomainParameterValue(extended, collectCrossDomainAttributes, {
          domainUserId: domainUserId,
          userId: businessUserId || undefined,
          sessionId: memorizedSessionId,
          sourceId: configTrackerSiteId,
          sourcePlatform: configPlatform,
          event: evt
        });
        if (elt === null || elt === void 0 ? void 0 : elt.href) {
          elt.href = decorateQuerystring(elt.href, CROSS_DOMAIN_PARAMETER_NAME, crossDomainParameterValue);
        }
      };
    }
    /**
     * Enable querystring decoration for links passing a filter
     * Whenever such a link is clicked on or navigated to via the keyboard,
     * add "_sp={{duid}}.{{timestamp}}" to its querystring
     *
     * @param crossDomainLinker - Function used to determine which links to decorate
     */
    function decorateLinks(crossDomainLinker) {
      var crossDomainLinkHandler = addLinkDecorationHandler(useExtendedCrossDomainLinker);
      for (var i = 0; i < document.links.length; i++) {
        var elt = document.links[i];
        if (!elt.spDecorationEnabled && crossDomainLinker(elt)) {
          elt.addEventListener('click', crossDomainLinkHandler, true);
          elt.addEventListener('mousedown', crossDomainLinkHandler, true);
          // Don't add event listeners more than once
          elt.spDecorationEnabled = true;
        }
      }
    }
    /*
     * Removes hash tag from the URL
     *
     * URLs are purified before being recorded in the cookie,
     * or before being sent as GET parameters
     */
    function purify(url) {
      var targetPattern;
      if (configDiscardHashTag) {
        targetPattern = new RegExp('#.*');
        url = url.replace(targetPattern, '');
      }
      if (configDiscardBrace) {
        targetPattern = new RegExp('[{}]', 'g');
        url = url.replace(targetPattern, '');
      }
      return url;
    }
    /*
     * Extract scheme/protocol from URL
     */
    function getProtocolScheme(url) {
      var e = new RegExp('^([a-z]+):'),
        matches = e.exec(url);
      return matches ? matches[1] : null;
    }
    /*
     * Resolve relative reference
     *
     * Note: not as described in rfc3986 section 5.2
     */
    function resolveRelativeReference(baseUrl, url) {
      var protocol = getProtocolScheme(url),
        i;
      if (protocol) {
        return url;
      }
      if (url.slice(0, 1) === '/') {
        return getProtocolScheme(baseUrl) + '://' + getHostName(baseUrl) + url;
      }
      baseUrl = purify(baseUrl);
      if ((i = baseUrl.indexOf('?')) >= 0) {
        baseUrl = baseUrl.slice(0, i);
      }
      if ((i = baseUrl.lastIndexOf('/')) !== baseUrl.length - 1) {
        baseUrl = baseUrl.slice(0, i + 1);
      }
      return baseUrl + url;
    }
    /*
     * Send request
     */
    function sendRequest(request) {
      if (!(configDoNotTrack || toOptoutByCookie)) {
        outQueue.enqueueRequest(request.build());
      }
    }
    /*
     * Get cookie name with prefix and domain hash
     */
    function getSnowplowCookieName(baseName) {
      return configCookieNamePrefix + baseName + '.' + domainHash;
    }
    /*
     * Cookie getter.
     */
    function getSnowplowCookieValue(cookieName) {
      var fullName = getSnowplowCookieName(cookieName);
      if (configStateStorageStrategy == 'localStorage') {
        return attemptGetLocalStorage(fullName);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.getCookie(fullName);
      }
      return undefined;
    }
    /*
     * Update domain hash
     */
    function updateDomainHash() {
      refreshUrl();
      domainHash = __WEBPACK_IMPORTED_MODULE_2_sha1___default()((configCookieDomain || domainAlias) + (configCookiePath || '/')).slice(0, 4); // 4 hexits = 16 bits
    }
    /*
     * Process all "activity" events.
     * For performance, this function must have low overhead.
     */
    function activityHandler() {
      var now = new Date();
      lastActivityTime = now.getTime();
    }
    /*
     * Process all "scroll" events.
     */
    function scrollHandler() {
      updateMaxScrolls();
      activityHandler();
    }
    /*
     * Returns [pageXOffset, pageYOffset]
     */
    function getPageOffsets() {
      var documentElement = document.documentElement;
      if (documentElement) {
        return [documentElement.scrollLeft || window.pageXOffset, documentElement.scrollTop || window.pageYOffset];
      }
      return [0, 0];
    }
    /*
     * Quick initialization/reset of max scroll levels
     */
    function resetMaxScrolls() {
      var offsets = getPageOffsets();
      var x = offsets[0];
      minXOffset = x;
      maxXOffset = x;
      var y = offsets[1];
      minYOffset = y;
      maxYOffset = y;
    }
    /*
     * Check the max scroll levels, updating as necessary
     */
    function updateMaxScrolls() {
      var offsets = getPageOffsets();
      var x = offsets[0];
      if (x < minXOffset) {
        minXOffset = x;
      } else if (x > maxXOffset) {
        maxXOffset = x;
      }
      var y = offsets[1];
      if (y < minYOffset) {
        minYOffset = y;
      } else if (y > maxYOffset) {
        maxYOffset = y;
      }
    }
    /*
     * Prevents offsets from being decimal or NaN
     * See https://github.com/snowplow/snowplow-javascript-tracker/issues/324
     */
    function cleanOffset(offset) {
      return Math.round(offset);
    }
    /**
     * Sets or renews the session cookie.
     * Responsible for calling the `onSessionUpdateCallback` callback.
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setSessionCookie() {
      var cookieName = getSnowplowCookieName('ses');
      var cookieValue = '*';
      return persistValue(cookieName, cookieValue, configSessionCookieTimeout);
    }
    /**
     * @mutates idCookie
     * @param {ParsedIdCookie} idCookie
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setDomainUserIdCookie(idCookie) {
      var cookieName = getSnowplowCookieName('id');
      var cookieValue = serializeIdCookie(idCookie, configAnonymousTracking);
      return persistValue(cookieName, cookieValue, configVisitorCookieTimeout);
    }
    /**
     * no-op if anonymousTracking enabled, will still set cookies if anonymousSessionTracking is enabled
     * Sets a cookie based on the storage strategy:
     * - if 'localStorage': attempts to write to local storage
     * - if 'cookie' or 'cookieAndLocalStorage': writes to cookies
     * - otherwise: no-op
     * @param {string} name Name/key of the value to persist
     * @param {string} value
     * @param {number} timeout Used as the expiration date for cookies or as a TTL to be checked on LocalStorage
     * @returns {boolean} If the operation was successful or not
     */
    function persistValue(name, value, timeout) {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return false;
      }
      if (configStateStorageStrategy == 'localStorage') {
        return attemptWriteLocalStorage(name, value, timeout);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.setCookie(name, value, timeout, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      }
      return false;
    }
    /**
     * Clears all cookie and local storage for id and ses values
     */
    function clearUserDataAndCookies(configuration) {
      var idname = getSnowplowCookieName('id');
      var sesname = getSnowplowCookieName('ses');
      attemptDeleteLocalStorage(idname);
      attemptDeleteLocalStorage(sesname);
      cookieStorage.deleteCookie(idname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      cookieStorage.deleteCookie(sesname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveSession)) {
        memorizedSessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        memorizedVisitCount = 1;
      }
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveUser)) {
        domainUserId = configAnonymousTracking ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        businessUserId = null;
      }
    }
    /**
     * Toggle Anonymous Tracking
     */
    function toggleAnonymousTracking(configuration) {
      if (configuration && configuration.stateStorageStrategy) {
        trackerConfiguration.stateStorageStrategy = configuration.stateStorageStrategy;
        configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration);
      }
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration);
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration);
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration);
      outQueue.setUseLocalStorage(configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage');
      outQueue.setAnonymousTracking(configAnonymousServerTracking);
    }
    /*
     * Load the domain user ID and the session ID
     * Set the cookies (if cookies are enabled)
     */
    function initializeIdsAndCookies() {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return;
      }
      var sesCookieSet = configStateStorageStrategy != 'none' && !!getSnowplowCookieValue('ses');
      var idCookie = loadDomainUserIdCookie();
      domainUserId = initializeDomainUserId(idCookie, configAnonymousTracking);
      if (!sesCookieSet) {
        memorizedSessionId = startNewIdCookieSession(idCookie);
      } else {
        memorizedSessionId = sessionIdFromIdCookie(idCookie);
      }
      memorizedVisitCount = visitCountFromIdCookie(idCookie);
      if (configStateStorageStrategy != 'none') {
        setSessionCookie();
        // Update currentVisitTs
        updateNowTsInIdCookie(idCookie);
        setDomainUserIdCookie(idCookie);
        if (!eventIndexFromIdCookie(idCookie)) {
          // Synchronously update the cookies to persist the new session ASAP
          cookieStorage.flush();
        }
      }
    }
    /*
     * Load visitor ID cookie
     */
    function loadDomainUserIdCookie() {
      if (configStateStorageStrategy == 'none') {
        return emptyIdCookie();
      }
      var id = getSnowplowCookieValue('id') || undefined;
      return parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount);
    }
    /**
     * Adds the protocol in front of our collector URL
     *
     * @param string - collectorUrl The collector URL with or without protocol
     * @returns string collectorUrl The tracker URL with protocol
     */
    function asCollectorUrl(collectorUrl) {
      if (collectorUrl.indexOf('http') === 0) {
        return collectorUrl;
      }
      return ('https:' === document.location.protocol ? 'https' : 'http') + '://' + collectorUrl;
    }
    /**
     * Initialize new `pageViewId` if it shouldn't be preserved.
     * Should be called when `trackPageView` is invoked
     */
    function resetPageView() {
      if (!_preservePageViewId || state.pageViewId == null) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
    }
    /**
     * Safe function to get `pageViewId`.
     * Generates it if it wasn't initialized by other tracker
     */
    function getPageViewId() {
      if (shouldGenerateNewPageViewId()) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
      return state.pageViewId;
    }
    function shouldGenerateNewPageViewId() {
      // If pageViewId is not initialized, generate it
      if (state.pageViewId == null) {
        return true;
      }
      // If pageViewId should be preserved regardless of the URL, don't generate a new one
      if (_preservePageViewId || !_preservePageViewIdForUrl) {
        return false;
      }
      // If doesn't have previous URL in state, generate a new pageViewId
      if (state.pageViewUrl === undefined) {
        return true;
      }
      var current = configCustomUrl || locationHrefAlias;
      // If full preserve is enabled, compare the full URL
      if (_preservePageViewIdForUrl === true || _preservePageViewIdForUrl == 'full' || !('URL' in window)) {
        return state.pageViewUrl != current;
      }
      var currentUrl = new URL(current);
      var previousUrl = new URL(state.pageViewUrl);
      // If pathname preserve is enabled, compare the pathname
      if (_preservePageViewIdForUrl == 'pathname') {
        return currentUrl.pathname != previousUrl.pathname;
      }
      // If pathname and search preserve is enabled, compare the pathname and search
      if (_preservePageViewIdForUrl == 'pathnameAndSearch') {
        return currentUrl.pathname != previousUrl.pathname || currentUrl.search != previousUrl.search;
      }
      return false;
    }
    /**
     * Safe function to get `tabId`.
     * Generates it if it is not yet initialized. Shared between trackers.
     */
    function getTabId() {
      if (configStateStorageStrategy === 'none' || configAnonymousTracking || !isWebPageContextAvailable) {
        return null;
      }
      var SESSION_STORAGE_TAB_ID = '_sp_tab_id';
      var tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      if (!tabId) {
        attemptWriteSessionStorage(SESSION_STORAGE_TAB_ID, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["a" /* v4 */])());
        tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      }
      return tabId || null;
    }
    /**
     * Put together a web page context with a unique UUID for the page view
     *
     * @returns web_page context
     */
    function getWebPagePlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: WEB_PAGE_SCHEMA,
            data: {
              id: getPageViewId()
            }
          }];
        }
      };
    }
    function getBrowserContextPlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: BROWSER_CONTEXT_SCHEMA,
            data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, getBrowserProperties()), {
              tabId: getTabId()
            })
          }];
        }
      };
    }
    /*
     * Attaches common web fields to every request (resolution, url, referrer, etc.)
     * Also sets the required cookies.
     */
    function getBrowserDataPlugin() {
      var anonymizeOr = function anonymizeOr(value) {
        return configAnonymousTracking ? null : value;
      };
      var anonymizeSessionOr = function anonymizeSessionOr(value) {
        return configAnonymousSessionTracking ? value : anonymizeOr(value);
      };
      return {
        beforeTrack: function beforeTrack(payloadBuilder) {
          var existingSession = getSnowplowCookieValue('ses'),
            idCookie = loadDomainUserIdCookie();
          var isFirstEventInSession = eventIndexFromIdCookie(idCookie) === 0;
          if (configOptOutCookie) {
            toOptoutByCookie = !!cookieStorage.getCookie(configOptOutCookie);
          } else {
            toOptoutByCookie = false;
          }
          if (configDoNotTrack || toOptoutByCookie) {
            clearUserDataAndCookies();
            return;
          }
          // If cookies are enabled, base visit count and session ID on the cookies
          if (cookiesEnabledInIdCookie(idCookie)) {
            // New session?
            if (!existingSession && configStateStorageStrategy != 'none') {
              memorizedSessionId = startNewIdCookieSession(idCookie);
            } else {
              memorizedSessionId = sessionIdFromIdCookie(idCookie);
            }
            memorizedVisitCount = visitCountFromIdCookie(idCookie);
          } else if (new Date().getTime() - lastEventTime > configSessionCookieTimeout * 1000) {
            memorizedVisitCount++;
            memorizedSessionId = startNewIdCookieSession(idCookie, {
              memorizedVisitCount: memorizedVisitCount
            });
          }
          // Update cookie
          updateNowTsInIdCookie(idCookie);
          updateFirstEventInIdCookie(idCookie, payloadBuilder);
          incrementEventIndexInIdCookie(idCookie);
          var _a = getBrowserProperties(),
            viewport = _a.viewport,
            documentSize = _a.documentSize;
          payloadBuilder.add('vp', viewport);
          payloadBuilder.add('ds', documentSize);
          payloadBuilder.add('vid', anonymizeSessionOr(memorizedVisitCount));
          payloadBuilder.add('sid', anonymizeSessionOr(memorizedSessionId));
          payloadBuilder.add('duid', anonymizeOr(domainUserIdFromIdCookie(idCookie))); // Always load from cookie as this is better etiquette than in-memory values
          payloadBuilder.add('uid', anonymizeOr(businessUserId));
          refreshUrl();
          payloadBuilder.add('refr', purify(customReferrer || configReferrerUrl));
          // Add the page URL last as it may take us over the IE limit (and we don't always need it)
          payloadBuilder.add('url', purify(configCustomUrl || locationHrefAlias));
          var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
          if (configSessionContext && (!configAnonymousTracking || configAnonymousSessionTracking)) {
            addSessionContextToPayload(payloadBuilder, clientSession);
          }
          // Update cookies
          if (configStateStorageStrategy != 'none') {
            setDomainUserIdCookie(idCookie);
            var sessionIdentifierPersisted = setSessionCookie();
            if ((!existingSession || isFirstEventInSession) && sessionIdentifierPersisted && onSessionUpdateCallback && !manualSessionUpdateCalled) {
              // Synchronously update the cookies to persist the new session ASAP
              cookieStorage.flush();
              onSessionUpdateCallback(clientSession);
              manualSessionUpdateCalled = false;
            }
          }
          lastEventTime = new Date().getTime();
        }
      };
    }
    function addSessionContextToPayload(payloadBuilder, clientSession) {
      var sessionContext = {
        schema: CLIENT_SESSION_SCHEMA,
        data: clientSession
      };
      payloadBuilder.addContextEntity(sessionContext);
    }
    /**
     * Expires current session and starts a new session.
     */
    function newSession() {
      // If cookies are enabled, base visit count and session ID on the cookies
      var idCookie = loadDomainUserIdCookie();
      // When cookies are enabled
      if (cookiesEnabledInIdCookie(idCookie)) {
        // When cookie/local storage is enabled - make a new session
        if (configStateStorageStrategy != 'none') {
          memorizedSessionId = startNewIdCookieSession(idCookie);
        } else {
          memorizedSessionId = sessionIdFromIdCookie(idCookie);
        }
        memorizedVisitCount = visitCountFromIdCookie(idCookie);
      } else {
        memorizedVisitCount++;
        memorizedSessionId = startNewIdCookieSession(idCookie, {
          memorizedVisitCount: memorizedVisitCount
        });
      }
      updateNowTsInIdCookie(idCookie);
      // Update cookies
      if (configStateStorageStrategy != 'none') {
        var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
        setDomainUserIdCookie(idCookie);
        var sessionIdentifierPersisted = setSessionCookie();
        // Synchronously update the cookies to persist the new session ASAP
        cookieStorage.flush();
        if (sessionIdentifierPersisted && onSessionUpdateCallback) {
          manualSessionUpdateCalled = true;
          onSessionUpdateCallback(clientSession);
        }
      }
      lastEventTime = new Date().getTime();
    }
    /**
     * Combine an array of unchanging contexts with the result of a context-creating function
     *
     * @param staticContexts - Array of custom contexts
     * @param contextCallback - Function returning an array of contexts
     */
    function finalizeContexts(staticContexts, contextCallback) {
      return (staticContexts || []).concat(contextCallback ? contextCallback() : []);
    }
    function logPageView(_a) {
      var title = _a.title,
        context = _a.context,
        timestamp = _a.timestamp,
        contextCallback = _a.contextCallback;
      refreshUrl();
      if (lastSentPageViewId && lastSentPageViewId == getPageViewId()) {
        // Do not reset pageViewId if a page view was not tracked yet or a different page view ID was used (in order to support multiple trackers with shared state)
        resetPageView();
      }
      lastSentPageViewId = getPageViewId();
      // So we know what document.title was at the time of trackPageView
      lastDocumentTitle = document.title;
      if (title) {
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = true;
      } else if (lastConfigTitleFromTrackPageView) {
        lastConfigTitle = null;
      }
      // Fixup page title
      var pageTitle = fixupTitle(lastConfigTitle || lastDocumentTitle);
      // Log page view
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* buildPageView */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: pageTitle,
        referrer: purify(customReferrer || configReferrerUrl)
      }), finalizeContexts(context, contextCallback), timestamp);
      // Send ping (to log that user has stayed on page)
      var now = new Date();
      var installingActivityTracking = false;
      if (activityTrackingConfig.enabled && !activityTrackingConfig.installed) {
        activityTrackingConfig.installed = true;
        installingActivityTracking = true;
        // Add mousewheel event handler, detect passive event listeners for performance
        var detectPassiveEvents_1 = {
          update: function update() {
            if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
              var passive_1 = false;
              var options = Object.defineProperty({}, 'passive', {
                get: function get() {
                  passive_1 = true;
                },
                set: function set() {}
              });
              // note: have to set and remove a no-op listener instead of null
              // (which was used previously), because Edge v15 throws an error
              // when providing a null callback.
              // https://github.com/rafrex/detect-passive-events/pull/3
              var noop = function noop() {};
              window.addEventListener('testPassiveEventSupport', noop, options);
              window.removeEventListener('testPassiveEventSupport', noop, options);
              detectPassiveEvents_1.hasSupport = passive_1;
            }
          }
        };
        detectPassiveEvents_1.update();
        // Detect available wheel event
        var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' // Modern browsers support "wheel"
        : document.onmousewheel !== undefined ? 'mousewheel' // Webkit and IE support at least "mousewheel"
        : 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
        if (Object.prototype.hasOwnProperty.call(detectPassiveEvents_1, 'hasSupport')) {
          addEventListener(document, wheelEvent, activityHandler, {
            passive: true
          });
        } else {
          addEventListener(document, wheelEvent, activityHandler);
        }
        // Capture our initial scroll points
        resetMaxScrolls();
        // Add event handlers; cross-browser compatibility here varies significantly
        // @see http://quirksmode.org/dom/events
        var documentHandlers = ['click', 'mouseup', 'mousedown', 'mousemove', 'keypress', 'keydown', 'keyup', 'touchend', 'touchstart'];
        var windowHandlers = ['resize', 'focus', 'blur'];
        var listener = function listener(_, handler) {
          if (handler === void 0) {
            handler = activityHandler;
          }
          return function (ev) {
            return addEventListener(document, ev, handler);
          };
        };
        documentHandlers.forEach(listener(document));
        windowHandlers.forEach(listener(window));
        listener(window, scrollHandler)('scroll');
      }
      if (activityTrackingConfig.enabled && (resetActivityTrackingOnPageView || installingActivityTracking)) {
        // Periodic check for activity.
        lastActivityTime = now.getTime();
        var key = void 0;
        for (key in activityTrackingConfig.configurations) {
          var config = activityTrackingConfig.configurations[key];
          if (config) {
            //Clear page ping heartbeat on new page view
            window.clearInterval(config.activityInterval);
            scheduleActivityInterval(config, context, contextCallback);
          }
        }
      }
    }
    function scheduleActivityInterval(config, context, contextCallback) {
      var executePagePing = function executePagePing(cb, context) {
        refreshUrl();
        cb({
          context: context,
          pageViewId: getPageViewId(),
          minXOffset: minXOffset,
          minYOffset: minYOffset,
          maxXOffset: maxXOffset,
          maxYOffset: maxYOffset
        });
        resetMaxScrolls();
      };
      var timeout = function timeout() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configMinimumVisitLength > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      };
      var heartbeat = function heartbeat() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configHeartBeatTimer > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
      };
      if (config.configMinimumVisitLength === 0) {
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      } else {
        config.activityInterval = window.setTimeout(timeout, config.configMinimumVisitLength);
      }
    }
    /**
     * Configure the activity tracking and ensures integer values for min visit and heartbeat
     */
    function configureActivityTracking(configuration) {
      var minimumVisitLength = configuration.minimumVisitLength,
        heartbeatDelay = configuration.heartbeatDelay,
        callback = configuration.callback;
      if (isInteger(minimumVisitLength) && isInteger(heartbeatDelay)) {
        return {
          configMinimumVisitLength: minimumVisitLength * 1000,
          configHeartBeatTimer: heartbeatDelay * 1000,
          callback: callback
        };
      }
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].error('Activity tracking minimumVisitLength & heartbeatDelay must be integers');
      return undefined;
    }
    /**
     * Log that a user is still viewing a given page by sending a page ping.
     * Not part of the public API - only called from logPageView() above.
     */
    function logPagePing(_a) {
      var context = _a.context,
        minXOffset = _a.minXOffset,
        minYOffset = _a.minYOffset,
        maxXOffset = _a.maxXOffset,
        maxYOffset = _a.maxYOffset;
      var newDocumentTitle = document.title;
      if (newDocumentTitle !== lastDocumentTitle) {
        lastDocumentTitle = newDocumentTitle;
        lastConfigTitle = undefined;
      }
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["f" /* buildPagePing */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: fixupTitle(lastConfigTitle || lastDocumentTitle),
        referrer: purify(customReferrer || configReferrerUrl),
        minXOffset: cleanOffset(minXOffset),
        maxXOffset: cleanOffset(maxXOffset),
        minYOffset: cleanOffset(minYOffset),
        maxYOffset: cleanOffset(maxYOffset)
      }), context);
    }
    function disableActivityTrackingAction(actionKey) {
      var callbackConfiguration = activityTrackingConfig.configurations[actionKey];
      if ((callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.configMinimumVisitLength) === 0) {
        window.clearTimeout(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      } else {
        window.clearInterval(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      }
      activityTrackingConfig.configurations[actionKey] = undefined;
    }
    var apiMethods = {
      getDomainSessionIndex: function getDomainSessionIndex() {
        return memorizedVisitCount;
      },
      getPageViewId: getPageViewId,
      getTabId: getTabId,
      newSession: newSession,
      getCookieName: function getCookieName(basename) {
        return getSnowplowCookieName(basename);
      },
      getUserId: function getUserId() {
        return businessUserId;
      },
      getDomainUserId: function getDomainUserId() {
        return loadDomainUserIdCookie()[1];
      },
      getDomainUserInfo: function getDomainUserInfo() {
        return loadDomainUserIdCookie();
      },
      setReferrerUrl: function setReferrerUrl(url) {
        customReferrer = url;
      },
      setCustomUrl: function setCustomUrl(url) {
        refreshUrl();
        configCustomUrl = resolveRelativeReference(locationHrefAlias, url);
      },
      setDocumentTitle: function setDocumentTitle(title) {
        // So we know what document.title was at the time of trackPageView
        lastDocumentTitle = document.title;
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = false;
      },
      discardHashTag: function discardHashTag(enableFilter) {
        configDiscardHashTag = enableFilter;
      },
      discardBrace: function discardBrace(enableFilter) {
        configDiscardBrace = enableFilter;
      },
      setCookiePath: function setCookiePath(path) {
        configCookiePath = path;
        updateDomainHash();
      },
      setVisitorCookieTimeout: function setVisitorCookieTimeout(timeout) {
        configVisitorCookieTimeout = timeout;
      },
      crossDomainLinker: function crossDomainLinker(crossDomainLinkerCriterion) {
        decorateLinks(crossDomainLinkerCriterion);
      },
      enableActivityTracking: function enableActivityTracking(configuration) {
        if (!activityTrackingConfig.configurations.pagePing) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.pagePing = configureActivityTracking(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, configuration), {
            callback: logPagePing
          }));
        }
      },
      enableActivityTrackingCallback: function enableActivityTrackingCallback(configuration) {
        if (!activityTrackingConfig.configurations.callback) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.callback = configureActivityTracking(configuration);
        }
      },
      disableActivityTracking: function disableActivityTracking() {
        disableActivityTrackingAction('pagePing');
      },
      disableActivityTrackingCallback: function disableActivityTrackingCallback() {
        disableActivityTrackingAction('callback');
      },
      updatePageActivity: function updatePageActivity() {
        activityHandler();
      },
      setOptOutCookie: function setOptOutCookie(name) {
        configOptOutCookie = name;
      },
      setUserId: function setUserId(userId) {
        businessUserId = userId;
      },
      setUserIdFromLocation: function setUserIdFromLocation(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, locationHrefAlias);
      },
      setUserIdFromReferrer: function setUserIdFromReferrer(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, configReferrerUrl);
      },
      setUserIdFromCookie: function setUserIdFromCookie(cookieName) {
        businessUserId = cookieStorage.getCookie(cookieName);
      },
      setCollectorUrl: function setCollectorUrl(collectorUrl) {
        outQueue.setCollectorUrl(asCollectorUrl(collectorUrl));
      },
      setBufferSize: function setBufferSize(newBufferSize) {
        outQueue.setBufferSize(newBufferSize);
      },
      flushBuffer: function flushBuffer(configuration) {
        if (configuration === void 0) {
          configuration = {};
        }
        outQueue.executeQueue();
        if (configuration.newBufferSize) {
          outQueue.setBufferSize(configuration.newBufferSize);
        }
      },
      trackPageView: function trackPageView(event) {
        if (event === void 0) {
          event = {};
        }
        logPageView(event);
      },
      preservePageViewId: function preservePageViewId() {
        _preservePageViewId = true;
      },
      preservePageViewIdForUrl: function preservePageViewIdForUrl(preserve) {
        _preservePageViewIdForUrl = preserve;
      },
      disableAnonymousTracking: function disableAnonymousTracking(configuration) {
        trackerConfiguration.anonymousTracking = false;
        toggleAnonymousTracking(configuration);
        initializeIdsAndCookies();
        outQueue.executeQueue(); // There might be some events in the queue we've been unable to send in anonymous mode
      },
      enableAnonymousTracking: function enableAnonymousTracking(configuration) {
        var _a;
        trackerConfiguration.anonymousTracking = (_a = configuration && (configuration === null || configuration === void 0 ? void 0 : configuration.options)) !== null && _a !== void 0 ? _a : true;
        toggleAnonymousTracking(configuration);
        // Reset the page view, if not tracking the session, so can't stitch user into new events on the page view id
        if (!configAnonymousSessionTracking) {
          resetPageView();
        }
      },
      clearUserData: clearUserDataAndCookies
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, apiMethods), {
      id: trackerId,
      namespace: namespace,
      core: core,
      sharedState: state
    });
  };
  // Initialise the tracker
  var partialTracker = newTracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration),
    tracker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, partialTracker), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        tracker.core.addPlugin(configuration);
        (_b = (_a = configuration.plugin).activateBrowserPlugin) === null || _b === void 0 ? void 0 : _b.call(_a, tracker);
      }
    });
  // Initialise each plugin with the tracker
  browserPlugins.forEach(function (p) {
    var _a;
    (_a = p.activateBrowserPlugin) === null || _a === void 0 ? void 0 : _a.call(p, tracker);
  });
  return tracker;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var namedTrackers = {};
/**
 * Dispatch function to all specified trackers
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackers(trackers, fn) {
  try {
    getTrackers(trackers !== null && trackers !== void 0 ? trackers : allTrackerNames()).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Dispatch function to all specified trackers from the supplied collection
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param trackerCollection - The collection which the trackers will be selected from
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackersInCollection(trackers, trackerCollection, fn) {
  try {
    getTrackersFromCollection(trackers !== null && trackers !== void 0 ? trackers : Object.keys(trackerCollection), trackerCollection).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Checks if a tracker has been created for a particular identifier
 * @param trackerId - The unique identifier of the tracker
 */
function trackerExists(trackerId) {
  return namedTrackers.hasOwnProperty(trackerId);
}
/**
 * Creates a Tracker and adds it to the internal collection
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker, tracked with each event as `tna`
 * @param version - The current version of the tracker library
 * @param endpoint - The endpoint to send events to
 * @param sharedState - The instance of shared state to use for this tracker
 * @param configuration - The configuration to use for this tracker instance
 */
function addTracker(trackerId, namespace, version, endpoint, sharedState, configuration) {
  if (!namedTrackers.hasOwnProperty(trackerId)) {
    namedTrackers[trackerId] = Tracker(trackerId, namespace, version, endpoint, sharedState, configuration);
    return namedTrackers[trackerId];
  }
  return null;
}
/**
 * Gets a single instance of the internal tracker object
 * @param trackerId - The unique identifier of the tracker
 * @returns The tracker instance, or null if not found
 */
function getTracker(trackerId) {
  if (namedTrackers.hasOwnProperty(trackerId)) {
    return namedTrackers[trackerId];
  }
  __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].warn(trackerId + ' not configured');
  return null;
}
/**
 * Gets an array of tracker instances based on the list of identifiers
 * @param trackerIds - An array of unique identifiers of the trackers
 * @returns The tracker instances, or empty list if none found
 */
function getTrackers(trackerIds) {
  return getTrackersFromCollection(trackerIds, namedTrackers);
}
/**
 * Gets all the trackers as a object, keyed by their unique identifiers
 */
function allTrackers() {
  return namedTrackers;
}
/**
 * Returns all the unique tracker identifiers
 */
function allTrackerNames() {
  return Object.keys(namedTrackers);
}
function getTrackersFromCollection(trackerIds, trackerCollection) {
  var trackers = [];
  for (var _i = 0, trackerIds_1 = trackerIds; _i < trackerIds_1.length; _i++) {
    var id = trackerIds_1[_i];
    if (trackerCollection.hasOwnProperty(id)) {
      trackers.push(trackerCollection[id]);
    } else {
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* LOG */].warn(id + ' not configured');
    }
  }
  return trackers;
}
/**
 * Write all pending cookies to the browser.
 * Useful if you track events just before the page is unloaded.
 * This call is not necessary if `synchronousCookieWrite` is set to `true`.
 */
function flushPendingCookies() {
  asyncCookieStorage.flush();
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Checks whether sessionStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasSessionStorage() {
  try {
    return !!window.sessionStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is accessible
 * sets and removes an item to handle private IOS5 browsing
 * (http://git.io/jFB2Xw)
 */
function localStorageAccessible() {
  var mod = 'modernizr';
  if (!hasLocalStorage()) {
    return false;
  }
  try {
    var ls = window.localStorage;
    ls.setItem(mod, mod);
    ls.removeItem(mod);
    return true;
  } catch (e) {
    return false;
  }
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * A set of variables which are shared among all initialised trackers
 */
var SharedState = /** @class */function () {
  function SharedState() {
    this.bufferFlushers = [];
    /* DOM Ready */
    this.hasLoaded = false;
    this.registeredOnLoadHandlers = [];
  }
  return SharedState;
}();
function createSharedState() {
  var sharedState = new SharedState(),
    documentAlias = document,
    windowAlias = window;
  /*
   * Handle page visibility event
   * Works everywhere except IE9
   */
  function visibilityChangeHandler() {
    if (documentAlias.visibilityState == 'hidden') {
      // Flush all POST queues
      sharedState.bufferFlushers.forEach(function (flusher) {
        flusher(false);
      });
    }
  }
  function flushBuffers() {
    // Flush all POST queues
    sharedState.bufferFlushers.forEach(function (flusher) {
      flusher(false);
    });
  }
  /*
   * Handler for onload event
   */
  function loadHandler() {
    var i;
    if (!sharedState.hasLoaded) {
      sharedState.hasLoaded = true;
      for (i = 0; i < sharedState.registeredOnLoadHandlers.length; i++) {
        sharedState.registeredOnLoadHandlers[i]();
      }
    }
    return true;
  }
  /*
   * Add onload or DOM ready handler
   */
  function addReadyListener() {
    if (documentAlias.addEventListener) {
      documentAlias.addEventListener('DOMContentLoaded', function ready() {
        documentAlias.removeEventListener('DOMContentLoaded', ready, false);
        loadHandler();
      });
    } else if (documentAlias.attachEvent) {
      documentAlias.attachEvent('onreadystatechange', function ready() {
        if (documentAlias.readyState === 'complete') {
          documentAlias.detachEvent('onreadystatechange', ready);
          loadHandler();
        }
      });
    }
    // fallback
    addEventListener(windowAlias, 'load', loadHandler, false);
  }
  /************************************************************
   * Constructor
   ************************************************************/
  // initialize the Snowplow singleton
  if (documentAlias.visibilityState) {
    // Flush for mobile and modern browsers
    addEventListener(documentAlias, 'visibilitychange', visibilityChangeHandler, false);
  }
  // Last attempt at flushing in beforeunload
  addEventListener(windowAlias, 'beforeunload', flushBuffers, false);
  if (document.readyState === 'loading') {
    addReadyListener();
  } else {
    loadHandler();
  }
  return sharedState;
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SharedState */
/* unused harmony export addEventListener */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTracker; });
/* unused harmony export allTrackerNames */
/* unused harmony export allTrackers */
/* unused harmony export attemptDeleteLocalStorage */
/* unused harmony export attemptGetLocalStorage */
/* unused harmony export attemptGetSessionStorage */
/* unused harmony export attemptWriteLocalStorage */
/* unused harmony export attemptWriteSessionStorage */
/* unused harmony export cookie */
/* unused harmony export createCrossDomainParameterValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSharedState; });
/* unused harmony export decorateQuerystring */
/* unused harmony export deleteCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dispatchToTrackers; });
/* unused harmony export dispatchToTrackersInCollection */
/* unused harmony export findRootDomain */
/* unused harmony export fixupDomain */
/* unused harmony export fixupTitle */
/* unused harmony export fixupUrl */
/* unused harmony export flushPendingCookies */
/* unused harmony export fromQuerystring */
/* unused harmony export getCookiesWithPrefix */
/* unused harmony export getCssClasses */
/* unused harmony export getFilterByClass */
/* unused harmony export getFilterByName */
/* unused harmony export getHostName */
/* unused harmony export getReferrer */
/* unused harmony export getTimeZone */
/* unused harmony export getTracker */
/* unused harmony export getTrackers */
/* unused harmony export hasLocalStorage */
/* unused harmony export hasSessionStorage */
/* unused harmony export isFunction */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isValueInArray */
/* unused harmony export localStorageAccessible */
/* unused harmony export parseAndValidateFloat */
/* unused harmony export parseAndValidateInt */
/* unused harmony export trackerExists */
/* unused harmony export urlSafeBase64Encode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow Browser trackers v4.8.2 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */





/**
 * Pure-JS SHA-1 implementation (FIPS 180-4).
 * Replaces the `sha1` npm package to avoid pulling in a Node.js `Buffer`
 * polyfill (~28 KB) when bundled for the browser.
 */
/** Compute SHA-1 hex digest of a UTF-8 string (FIPS 180-4). */
function sha1(message) {
  // Encode UTF-8
  var bytes = [];
  for (var i = 0; i < message.length; i++) {
    var c = message.charCodeAt(i);
    if (c < 0x80) {
      bytes.push(c);
    } else if (c < 0x800) {
      bytes.push(0xc0 | c >> 6, 0x80 | c & 0x3f);
    } else if (c >= 0xd800 && c <= 0xdbff && i + 1 < message.length) {
      var next = message.charCodeAt(++i);
      c = 0x10000 + ((c & 0x3ff) << 10) + (next & 0x3ff);
      bytes.push(0xf0 | c >> 18, 0x80 | c >> 12 & 0x3f, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
    } else {
      bytes.push(0xe0 | c >> 12, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
    }
  }
  // Pre-processing: pad to 512-bit blocks
  var bitLen = bytes.length * 8;
  bytes.push(0x80);
  while (bytes.length % 64 !== 56) bytes.push(0);
  // Append length as 64-bit big-endian (high 32 bits always 0 for strings < 512 MB)
  bytes.push(0, 0, 0, 0);
  bytes.push(bitLen >>> 24 & 0xff, bitLen >>> 16 & 0xff, bitLen >>> 8 & 0xff, bitLen & 0xff);
  // Initialize hash values
  var h0 = 0x67452301;
  var h1 = 0xefcdab89;
  var h2 = 0x98badcfe;
  var h3 = 0x10325476;
  var h4 = 0xc3d2e1f0;
  // Process each 512-bit block
  var w = new Array(80);
  for (var offset = 0; offset < bytes.length; offset += 64) {
    for (var i = 0; i < 16; i++) {
      w[i] = bytes[offset + i * 4] << 24 | bytes[offset + i * 4 + 1] << 16 | bytes[offset + i * 4 + 2] << 8 | bytes[offset + i * 4 + 3];
    }
    for (var i = 16; i < 80; i++) {
      var n = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
      w[i] = n << 1 | n >>> 31;
    }
    var a = h0,
      b = h1,
      c = h2,
      d = h3,
      e = h4;
    for (var i = 0; i < 80; i++) {
      var f = void 0,
        k = void 0;
      if (i < 20) {
        f = b & c | ~b & d;
        k = 0x5a827999;
      } else if (i < 40) {
        f = b ^ c ^ d;
        k = 0x6ed9eba1;
      } else if (i < 60) {
        f = b & c | b & d | c & d;
        k = 0x8f1bbcdc;
      } else {
        f = b ^ c ^ d;
        k = 0xca62c1d6;
      }
      var temp = (a << 5 | a >>> 27) + f + e + k + w[i] | 0;
      e = d;
      d = c;
      c = b << 30 | b >>> 2;
      b = a;
      a = temp;
    }
    h0 = h0 + a | 0;
    h1 = h1 + b | 0;
    h2 = h2 + c | 0;
    h3 = h3 + d | 0;
    h4 = h4 + e | 0;
  }
  // Produce hex digest
  var hex = '';
  for (var _i = 0, _a = [h0, h1, h2, h3, h4]; _i < _a.length; _i++) {
    var h = _a[_i];
    var part = (h >>> 0).toString(16);
    hex += (part.length < 8 ? '00000000'.slice(part.length) : '') + part;
  }
  return hex;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Attempt to get a value from localStorage
 *
 * @param string - key
 * @returns string The value obtained from localStorage, or
 *                undefined if localStorage is inaccessible
 */
function attemptGetLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage,
      exp = localStorageAlias.getItem(key + '.expires');
    if (exp === null || +exp > Date.now()) {
      return localStorageAlias.getItem(key);
    } else {
      localStorageAlias.removeItem(key);
      localStorageAlias.removeItem(key + '.expires');
    }
    return undefined;
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to localStorage
 *
 * @param string - key
 * @param string - value
 * @param number - ttl Time to live in seconds, defaults to 2 years from Date.now()
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteLocalStorage(key, value, ttl) {
  if (ttl === void 0) {
    ttl = 63072000;
  }
  try {
    var localStorageAlias = window.localStorage,
      t = Date.now() + ttl * 1000;
    localStorageAlias.setItem("".concat(key, ".expires"), t.toString());
    localStorageAlias.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to delete a value from localStorage
 *
 * @param string - key
 * @returns boolean Whether the operation succeeded
 */
function attemptDeleteLocalStorage(key) {
  try {
    var localStorageAlias = window.localStorage;
    localStorageAlias.removeItem(key);
    localStorageAlias.removeItem(key + '.expires');
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Attempt to get a value from sessionStorage
 *
 * @param string - key
 * @returns string The value obtained from sessionStorage, or
 *                undefined if sessionStorage is inaccessible
 */
function attemptGetSessionStorage(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    return undefined;
  }
}
/**
 * Attempt to write a value to sessionStorage
 *
 * @param string - key
 * @param string - value
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteSessionStorage(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}
var DEFAULT_CROSS_DOMAIN_LINKER_PARAMS = {
  sessionId: true,
  sourceId: true,
  sourcePlatform: false,
  userId: false,
  reason: false
};
function createCrossDomainParameterValue(isExtendedFormat, attributeConfiguration, attributeValues) {
  var _a;
  var crossDomainParameterValue;
  var timestamp = new Date().getTime();
  var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, DEFAULT_CROSS_DOMAIN_LINKER_PARAMS), attributeConfiguration);
  var domainUserId = attributeValues.domainUserId,
    userId = attributeValues.userId,
    sessionId = attributeValues.sessionId,
    sourceId = attributeValues.sourceId,
    sourcePlatform = attributeValues.sourcePlatform,
    event = attributeValues.event;
  var eventTarget = event.currentTarget;
  var reason = typeof config.reason === 'function' ? config.reason(event) : (_a = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.textContent) === null || _a === void 0 ? void 0 : _a.trim();
  if (isExtendedFormat) {
    /* Index is used by Enrich, so it should not be changed. */
    crossDomainParameterValue = [domainUserId, timestamp, config.sessionId && sessionId, config.userId && urlSafeBase64Encode(userId || ''), config.sourceId && urlSafeBase64Encode(sourceId || ''), config.sourcePlatform && sourcePlatform, config.reason && urlSafeBase64Encode(reason || '')].map(function (attribute) {
      return attribute || '';
    }).join('.')
    // Remove trailing dots
    .replace(/([.]*$)/, '');
  } else {
    crossDomainParameterValue = attributeValues.domainUserId + '.' + timestamp;
  }
  return crossDomainParameterValue;
}
/**
 *
 * The url-safe variation emits - and _ instead of + and / characters. Also removes = sign padding.
 * @param {string} str The string to encode in a URL safe manner
 * @return {string}
 */
function urlSafeBase64Encode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Checks if an object is a string
 * @param str - The object to check
 */
function isString(str) {
  if (str && typeof str.valueOf() === 'string') {
    return true;
  }
  return false;
}
/**
 * Checks if an object is an integer
 * @param int - The object to check
 */
function isInteger(_int) {
  return Number.isInteger && Number.isInteger(_int) || typeof _int === 'number' && isFinite(_int) && Math.floor(_int) === _int;
}
/**
 * Checks if the input parameter is a function
 * @param func - The object to check
 */
function isFunction(func) {
  if (func && typeof func === 'function') {
    return true;
  }
  return false;
}
/**
 * Lightweight configured runtime timezone detection
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions#getting_the_users_time_zone_and_locale_preferences
 * @returns IANA timezone name of current runtime preference
 */
function getTimeZone() {
  if ((typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && typeof Intl.DateTimeFormat === 'function') {
    var systemPreferences = new Intl.DateTimeFormat().resolvedOptions();
    return systemPreferences.timeZone;
  }
}
/**
 * Cleans up the page title
 */
function fixupTitle(title) {
  if (!isString(title)) {
    title = title.text || '';
    var tmp = document.getElementsByTagName('title');
    if (tmp && tmp[0] != null) {
      title = tmp[0].text;
    }
  }
  return title;
}
/**
 * Extract hostname from URL
 */
function getHostName(url) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:(?:https?|ftp):)/*(?:[^@]+@)?([^:/#]+)'),
    matches = e.exec(url);
  return matches ? matches[1] : url;
}
/**
 * Fix-up domain
 */
function fixupDomain(domain) {
  var dl = domain.length;
  // remove trailing '.'
  if (domain.charAt(--dl) === '.') {
    domain = domain.slice(0, dl);
  }
  // remove leading '*'
  if (domain.slice(0, 2) === '*.') {
    domain = domain.slice(1);
  }
  return domain;
}
/**
 * Get page referrer. In the case of a single-page app,
 * if the URL changes without the page reloading, pass
 * in the old URL. It will be returned unless overriden
 * by a "refer(r)er" parameter in the querystring.
 *
 * @param string - oldLocation Optional.
 * @returns string The referrer
 */
function getReferrer(oldLocation) {
  var windowAlias = window,
    fromQs = fromQuerystring('referrer', windowAlias.location.href) || fromQuerystring('referer', windowAlias.location.href);
  // Short-circuit
  if (fromQs) {
    return fromQs;
  }
  // In the case of a single-page app, return the old URL
  if (oldLocation) {
    return oldLocation;
  }
  try {
    if (windowAlias.top) {
      return windowAlias.top.document.referrer;
    } else if (windowAlias.parent) {
      return windowAlias.parent.document.referrer;
    }
  } catch (_a) {}
  return document.referrer;
}
/**
 * Cross-browser helper function to add event handler
 */
function addEventListener(element, eventType, eventHandler, options) {
  if (element.addEventListener) {
    element.addEventListener(eventType, eventHandler, options);
    return true;
  }
  // IE Support
  if (element.attachEvent) {
    return element.attachEvent('on' + eventType, eventHandler);
  }
  element['on' + eventType] = eventHandler;
}
/**
 * Return value from name-value pair in querystring
 */
function fromQuerystring(field, url) {
  var match = new RegExp('^[^#]*[?&]' + field + '=([^&#]*)').exec(url);
  if (!match) {
    return null;
  }
  return decodeURIComponent(match[1].replace(/\+/g, ' '));
}
/**
 * Add a name-value pair to the querystring of a URL
 *
 * @param string - url URL to decorate
 * @param string - name Name of the querystring pair
 * @param string - value Value of the querystring pair
 */
function decorateQuerystring(url, name, value) {
  var initialQsParams = name + '=' + value;
  var hashSplit = url.split('#');
  var qsSplit = hashSplit[0].split('?');
  var beforeQuerystring = qsSplit.shift();
  // Necessary because a querystring may contain multiple question marks
  var querystring = qsSplit.join('?');
  if (!querystring) {
    querystring = initialQsParams;
  } else {
    // Whether this is the first time the link has been decorated
    var initialDecoration = true;
    var qsFields = querystring.split('&');
    for (var i = 0; i < qsFields.length; i++) {
      if (qsFields[i].substr(0, name.length + 1) === name + '=') {
        initialDecoration = false;
        qsFields[i] = initialQsParams;
        querystring = qsFields.join('&');
        break;
      }
    }
    if (initialDecoration) {
      querystring = initialQsParams + '&' + querystring;
    }
  }
  hashSplit[0] = beforeQuerystring + '?' + querystring;
  return hashSplit.join('#');
}
/**
 * Finds the root domain
 */
function findRootDomain(sameSite, secure) {
  var windowLocationHostnameAlias = window.location.hostname,
    cookiePrefix = '_sp_root_domain_test_',
    cookieName = cookiePrefix + new Date().getTime(),
    cookieValue = '_test_value_' + new Date().getTime();
  var locationParts = windowLocationHostnameAlias.split('.');
  for (var idx = locationParts.length - 2; idx >= 0; idx--) {
    var currentDomain = locationParts.slice(idx).join('.');
    cookie(cookieName, cookieValue, 0, '/', currentDomain, sameSite, secure);
    if (cookie(cookieName) === cookieValue) {
      // Clean up created cookie(s)
      deleteCookie(cookieName, '/', currentDomain, sameSite, secure);
      var cookieNames = getCookiesWithPrefix(cookiePrefix);
      for (var i = 0; i < cookieNames.length; i++) {
        deleteCookie(cookieNames[i], '/', currentDomain, sameSite, secure);
      }
      return currentDomain;
    }
  }
  // Cookies cannot be read
  return windowLocationHostnameAlias;
}
/**
 * Checks whether a value is present within an array
 *
 * @param val - The value to check for
 * @param array - The array to check within
 * @returns boolean Whether it exists
 */
function isValueInArray(val, array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === val) {
      return true;
    }
  }
  return false;
}
/**
 * Deletes an arbitrary cookie by setting the expiration date to the past
 *
 * @param cookieName - The name of the cookie to delete
 * @param domainName - The domain the cookie is in
 */
function deleteCookie(cookieName, path, domainName, sameSite, secure) {
  cookie(cookieName, '', -1, path, domainName, sameSite, secure);
}
/**
 * Fetches the name of all cookies beginning with a certain prefix
 *
 * @param cookiePrefix - The prefix to check for
 * @returns array The cookies that begin with the prefix
 */
function getCookiesWithPrefix(cookiePrefix) {
  var cookies = document.cookie.split('; ');
  var cookieNames = [];
  for (var i = 0; i < cookies.length; i++) {
    if (cookies[i].substring(0, cookiePrefix.length) === cookiePrefix) {
      cookieNames.push(cookies[i]);
    }
  }
  return cookieNames;
}
/**
 * Get and set the cookies associated with the current document in browser
 * This implementation always returns a string, returns the cookie value if only name is specified
 *
 * @param name - The cookie name (required)
 * @param value - The cookie value
 * @param ttl - The cookie Time To Live (seconds)
 * @param path - The cookies path
 * @param domain - The cookies domain
 * @param samesite - The cookies samesite attribute
 * @param secure - Boolean to specify if cookie should be secure
 * @returns string The cookies value
 */
function cookie(name, value, ttl, path, domain, samesite, secure) {
  if (arguments.length > 1) {
    return document.cookie = name + '=' + encodeURIComponent(value !== null && value !== void 0 ? value : '') + (ttl ? '; Expires=' + new Date(+new Date() + ttl * 1000).toUTCString() : '') + (path ? '; Path=' + path : '') + (domain ? '; Domain=' + domain : '') + (samesite ? '; SameSite=' + samesite : '') + (secure ? '; Secure' : '');
  }
  return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
}
/**
 * Parses an object and returns either the
 * integer or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateInt(obj) {
  var result = parseInt(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Parses an object and returns either the
 * number or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateFloat(obj) {
  var result = parseFloat(obj);
  return isNaN(result) ? undefined : result;
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 * @param boolean - byClass Whether to allowlist/denylist based on an element's classes (for forms)
 *                        or name attribute (for fields)
 */
function getFilterByClass(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = Object.prototype.hasOwnProperty.call(criterion, 'allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return checkClass(elt, specifiedClassesSet) === inclusive;
  });
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 */
function getFilterByName(criterion) {
  // If the criterion argument is not an object, add listeners to all elements
  if (criterion == null || _typeof(criterion) !== 'object' || Array.isArray(criterion)) {
    return function () {
      return true;
    };
  }
  var inclusive = criterion.hasOwnProperty('allowlist');
  var specifiedClassesSet = getSpecifiedClassesSet(criterion);
  return getFilter(criterion, function (elt) {
    return elt.name in specifiedClassesSet === inclusive;
  });
}
/**
 * List the classes of a DOM element without using elt.classList (for compatibility with IE 9)
 */
function getCssClasses(elt) {
  return elt.className.match(/\S+/g) || [];
}
/**
 * Check whether an element has at least one class from a given list
 */
function checkClass(elt, classList) {
  var classes = getCssClasses(elt);
  for (var _i = 0, classes_1 = classes; _i < classes_1.length; _i++) {
    var className = classes_1[_i];
    if (classList[className]) {
      return true;
    }
  }
  return false;
}
function getFilter(criterion, fallbackFilter) {
  if (criterion.hasOwnProperty('filter') && criterion.filter) {
    return criterion.filter;
  }
  return fallbackFilter;
}
function getSpecifiedClassesSet(criterion) {
  // Convert the array of classes to an object of the form {class1: true, class2: true, ...}
  var specifiedClassesSet = {};
  var specifiedClasses = criterion.allowlist || criterion.denylist;
  if (specifiedClasses) {
    if (!Array.isArray(specifiedClasses)) {
      specifiedClasses = [specifiedClasses];
    }
    for (var i = 0; i < specifiedClasses.length; i++) {
      specifiedClassesSet[specifiedClasses[i]] = true;
    }
  }
  return specifiedClassesSet;
}
function newLocalStorageEventStore(_a) {
  var trackerId = _a.trackerId,
    _b = _a.maxLocalStorageQueueSize,
    maxLocalStorageQueueSize = _b === void 0 ? 1000 : _b,
    _c = _a.useLocalStorage,
    useLocalStorage = _c === void 0 ? true : _c;
  var queueName = "snowplowOutQueue_".concat(trackerId);
  function newInMemoryEventStoreFromLocalStorage() {
    if (useLocalStorage) {
      try {
        var localStorageQueue = window.localStorage.getItem(queueName);
        var events = localStorageQueue ? JSON.parse(localStorageQueue) : [];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* newInMemoryEventStore */])({
          maxSize: maxLocalStorageQueueSize,
          events: events
        });
      } catch (e) {
        console.error('Failed to access localStorage when initializing event store:', e);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* newInMemoryEventStore */])({
          maxSize: maxLocalStorageQueueSize
        });
      }
    } else {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["d" /* newInMemoryEventStore */])({
        maxSize: maxLocalStorageQueueSize
      });
    }
  }
  var _d = newInMemoryEventStoreFromLocalStorage(),
    getAll = _d.getAll,
    getAllPayloads = _d.getAllPayloads,
    _add = _d.add,
    count = _d.count,
    iterator = _d.iterator,
    _removeHead = _d.removeHead;
  function sync() {
    if (useLocalStorage) {
      return getAll().then(function (events) {
        try {
          window.localStorage.setItem(queueName, JSON.stringify(events));
        } catch (e) {
          console.error('Failed to persist events to localStorage:', e);
        }
      });
    } else {
      return Promise.resolve();
    }
  }
  return {
    count: count,
    add: function add(payload) {
      _add(payload);
      return sync().then(count);
    },
    removeHead: function removeHead(count) {
      _removeHead(count);
      return sync();
    },
    iterator: iterator,
    getAll: getAll,
    getAllPayloads: getAllPayloads,
    setUseLocalStorage: function setUseLocalStorage(use) {
      useLocalStorage = use;
    }
  };
}
function newOutQueue(configuration, sharedState) {
  var _a;
  var eventStore = (_a = configuration.eventStore) !== null && _a !== void 0 ? _a : newLocalStorageEventStore(configuration);
  configuration.eventStore = eventStore;
  var emitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["e" /* newEmitter */])(configuration);
  sharedState.bufferFlushers.push(emitter.flush);
  return {
    enqueueRequest: emitter.input,
    executeQueue: emitter.flush,
    setAnonymousTracking: emitter.setAnonymousTracking,
    setCollectorUrl: emitter.setCollectorUrl,
    setBufferSize: emitter.setBufferSize,
    setUseLocalStorage: function setUseLocalStorage(localStorage) {
      if (eventStore.hasOwnProperty('setUseLocalStorage')) {
        var localStorageStore = eventStore;
        localStorageStore.setUseLocalStorage(localStorage);
      }
    }
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Extract parameter from URL
 */
function getParameter(url, name) {
  // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
  var e = new RegExp('^(?:https?|ftp)(?::/*(?:[^?]+))([?][^#]+)'),
    matches = e.exec(url);
  if (matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 1) {
    return fromQuerystring(name, matches[1]);
  }
  return null;
}
/*
 * Fix-up URL when page rendered from search engine cache or translated page.
 */
function fixupUrl(hostName, href, referrer) {
  var _a;
  if (hostName === 'translate.googleusercontent.com') {
    // Google
    if (referrer === '') {
      referrer = href;
    }
    href = (_a = getParameter(href, 'u')) !== null && _a !== void 0 ? _a : '';
    hostName = getHostName(href);
  } else if (hostName === 'cc.bingj.com' ||
  // Bing & Yahoo
  hostName === 'webcache.googleusercontent.com' // Google
  ) {
    href = document.links[0].href;
    hostName = getHostName(href);
  }
  return [hostName, href, referrer];
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Indices of cookie values
 */
var cookieDisabledIndex = 0,
  domainUserIdIndex = 1,
  createTsIndex = 2,
  visitCountIndex = 3,
  nowTsIndex = 4,
  lastVisitTsIndex = 5,
  sessionIdIndex = 6,
  previousSessionIdIndex = 7,
  firstEventIdIndex = 8,
  firstEventTsInMsIndex = 9,
  eventIndexIndex = 10;
function emptyIdCookie() {
  var idCookie = ['1', '', 0, 0, 0, undefined, '', '', '', undefined, 0];
  return idCookie;
}
/**
 * Parses the cookie values from its string representation.
 *
 * @param id Cookie value as string
 * @param domainUserId Domain user ID to be used in case of empty cookie string
 * @returns Parsed ID cookie tuple
 */
function parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount) {
  var now = new Date(),
    nowTs = Math.round(now.getTime() / 1000),
    tmpContainer;
  if (id) {
    tmpContainer = id.split('.');
    // cookies enabled
    tmpContainer.unshift('0');
  } else {
    tmpContainer = [
    // cookies disabled
    '1',
    // Domain user ID
    domainUserId,
    // Creation timestamp - seconds since Unix epoch
    nowTs,
    // visitCount - 0 = no previous visit
    memorizedVisitCount,
    // Current visit timestamp
    nowTs,
    // Last visit timestamp - blank meaning no previous visit
    '',
    // Session ID
    memorizedSessionId];
  }
  if (!tmpContainer[sessionIdIndex] || tmpContainer[sessionIdIndex] === 'undefined') {
    // session id
    tmpContainer[sessionIdIndex] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
  }
  if (!tmpContainer[previousSessionIdIndex] || tmpContainer[previousSessionIdIndex] === 'undefined') {
    // previous session id
    tmpContainer[previousSessionIdIndex] = '';
  }
  if (!tmpContainer[firstEventIdIndex] || tmpContainer[firstEventIdIndex] === 'undefined') {
    // firstEventId - blank meaning no previous event
    tmpContainer[firstEventIdIndex] = '';
  }
  if (!tmpContainer[firstEventTsInMsIndex] || tmpContainer[firstEventTsInMsIndex] === 'undefined') {
    // firstEventTs - blank meaning no previous event
    tmpContainer[firstEventTsInMsIndex] = '';
  }
  if (!tmpContainer[eventIndexIndex] || tmpContainer[eventIndexIndex] === 'undefined') {
    // eventIndex – 0 = no previous event
    tmpContainer[eventIndexIndex] = 0;
  }
  var parseIntOr = function parseIntOr(value, defaultValue) {
    var parsed = parseInt(value);
    return isNaN(parsed) ? defaultValue : parsed;
  };
  var parseIntOrUndefined = function parseIntOrUndefined(value) {
    return value ? parseIntOr(value, undefined) : undefined;
  };
  var parsed = [tmpContainer[cookieDisabledIndex], tmpContainer[domainUserIdIndex], parseIntOr(tmpContainer[createTsIndex], nowTs), parseIntOr(tmpContainer[visitCountIndex], memorizedVisitCount), parseIntOr(tmpContainer[nowTsIndex], nowTs), parseIntOrUndefined(tmpContainer[lastVisitTsIndex]), tmpContainer[sessionIdIndex], tmpContainer[previousSessionIdIndex], tmpContainer[firstEventIdIndex], parseIntOrUndefined(tmpContainer[firstEventTsInMsIndex]), parseIntOr(tmpContainer[eventIndexIndex], 0)];
  return parsed;
}
/**
 * Initializes the domain user ID if not already present in the cookie. Sets an empty string if anonymous tracking.
 *
 * @param idCookie Parsed cookie
 * @param configAnonymousTracking Whether anonymous tracking is enabled
 * @returns Domain user ID
 */
function initializeDomainUserId(idCookie, configAnonymousTracking) {
  var domainUserId;
  if (idCookie[domainUserIdIndex]) {
    domainUserId = idCookie[domainUserIdIndex];
  } else if (!configAnonymousTracking) {
    domainUserId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
    idCookie[domainUserIdIndex] = domainUserId;
  } else {
    domainUserId = '';
    idCookie[domainUserIdIndex] = domainUserId;
  }
  return domainUserId;
}
/**
 * Starts a new session with a new ID.
 * Sets the previous session, last visit timestamp, and increments visit count if cookies enabled.
 * First event references are reset and will be updated in `updateFirstEventInIdCookie`.
 *
 * @param idCookie Parsed cookie
 * @param options.configStateStorageStrategy Cookie storage strategy
 * @param options.configAnonymousTracking If anonymous tracking is enabled
 * @param options.memorizedVisitCount Visit count to be used if cookies not enabled
 * @param options.onSessionUpdateCallback Session callback triggered on every session update
 * @returns New session ID
 */
function startNewIdCookieSession(idCookie, options) {
  if (options === void 0) {
    options = {
      memorizedVisitCount: 1
    };
  }
  var memorizedVisitCount = options.memorizedVisitCount;
  // If cookies are enabled, base visit count and session ID on the cookies
  if (cookiesEnabledInIdCookie(idCookie)) {
    // Store the previous session ID
    idCookie[previousSessionIdIndex] = idCookie[sessionIdIndex];
    // Set lastVisitTs to currentVisitTs
    idCookie[lastVisitTsIndex] = idCookie[nowTsIndex];
    // Increment the session ID
    idCookie[visitCountIndex]++;
  } else {
    idCookie[visitCountIndex] = memorizedVisitCount;
  }
  // Create a new sessionId
  var sessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
  idCookie[sessionIdIndex] = sessionId;
  // Reset event index and first event references
  idCookie[eventIndexIndex] = 0;
  idCookie[firstEventIdIndex] = '';
  idCookie[firstEventTsInMsIndex] = undefined;
  return sessionId;
}
/**
 * Update now timestamp in cookie.
 *
 * @param idCookie Parsed cookie
 */
function updateNowTsInIdCookie(idCookie) {
  idCookie[nowTsIndex] = Math.round(new Date().getTime() / 1000);
}
/**
 * Updates the first event references according to the event payload if first event in session.
 *
 * @param idCookie - Parsed cookie
 * @param payloadBuilder - Event payload builder
 */
function updateFirstEventInIdCookie(idCookie, payloadBuilder) {
  // Update first event references if new session or not present
  if (idCookie[eventIndexIndex] === 0) {
    var payload = payloadBuilder.build();
    idCookie[firstEventIdIndex] = payload['eid'];
    var ts = payload['dtm'] || payload['ttm'];
    idCookie[firstEventTsInMsIndex] = ts ? parseInt(ts) : undefined;
  }
}
/**
 * Increments event index counter.
 *
 * @param idCookie Parsed cookie
 */
function incrementEventIndexInIdCookie(idCookie) {
  idCookie[eventIndexIndex] += 1;
}
/**
 * Serializes parsed cookie to string representation.
 *
 * @param idCookie Parsed cookie
 * @returns String cookie value
 */
function serializeIdCookie(idCookie, configAnonymousTracking) {
  var anonymizedIdCookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __spreadArray */])([], idCookie, true);
  if (configAnonymousTracking) {
    anonymizedIdCookie[domainUserIdIndex] = '';
    anonymizedIdCookie[previousSessionIdIndex] = '';
  }
  anonymizedIdCookie.shift();
  return anonymizedIdCookie.join('.');
}
/**
 * Transforms the parsed cookie into a client session context entity.
 *
 * @param idCookie Parsed cookie
 * @param configStateStorageStrategy Cookie storage strategy
 * @param configAnonymousTracking If anonymous tracking is enabled
 * @returns Client session context entity
 */
function clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking) {
  var firstEventTsInMs = idCookie[firstEventTsInMsIndex];
  var clientSession = {
    userId: configAnonymousTracking ? '00000000-0000-0000-0000-000000000000' // TODO: use uuid.NIL when we upgrade to uuid v8.3
    : idCookie[domainUserIdIndex],
    sessionId: idCookie[sessionIdIndex],
    eventIndex: idCookie[eventIndexIndex],
    sessionIndex: idCookie[visitCountIndex],
    previousSessionId: configAnonymousTracking ? null : idCookie[previousSessionIdIndex] || null,
    storageMechanism: configStateStorageStrategy == 'localStorage' ? 'LOCAL_STORAGE' : 'COOKIE_1',
    firstEventId: idCookie[firstEventIdIndex] || null,
    firstEventTimestamp: firstEventTsInMs ? new Date(firstEventTsInMs).toISOString() : null
  };
  return clientSession;
}
function sessionIdFromIdCookie(idCookie) {
  return idCookie[sessionIdIndex];
}
function domainUserIdFromIdCookie(idCookie) {
  return idCookie[domainUserIdIndex];
}
function visitCountFromIdCookie(idCookie) {
  return idCookie[visitCountIndex];
}
function cookiesEnabledInIdCookie(idCookie) {
  return idCookie[cookieDisabledIndex] === '0';
}
function eventIndexFromIdCookie(idCookie) {
  return idCookie[eventIndexIndex];
}
var WEB_PAGE_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/web_page/jsonschema/1-0-0';
var BROWSER_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/browser_context/jsonschema/2-0-0';
var CLIENT_SESSION_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/client_session/jsonschema/1-0-2';
var APPLICATION_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/application/jsonschema/1-0-0';
var ACTIVITY_METRICS_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/activity_metrics/jsonschema/1-0-0';
function useResizeObserver() {
  return 'ResizeObserver' in window;
}
var resizeObserverInitialized = false;
var readBrowserPropertiesTask = null;
function initializeResizeObserver() {
  if (resizeObserverInitialized) {
    return;
  }
  if (!document || !document.body || !document.documentElement) {
    return;
  }
  resizeObserverInitialized = true;
  var resizeObserver = new ResizeObserver(function () {
    if (!readBrowserPropertiesTask) {
      // The browser property lookup causes a forced synchronous layout when offsets/sizes are
      // queried. It's possible that the forced synchronous layout causes the ResizeObserver
      // to be fired again, leading to an infinite loop and the "ResizeObserver loop completed
      // with undelivered notifications" error.
      readBrowserPropertiesTask = requestAnimationFrame(function () {
        readBrowserPropertiesTask = null;
        cachedProperties = readBrowserProperties();
      });
    }
  });
  resizeObserver.observe(document.body);
  resizeObserver.observe(document.documentElement);
}
var cachedProperties;
/**
 * Gets various browser properties (that are expensive to read!)
 * - Will use a "ResizeObserver" approach in modern browsers to update cached properties only on change
 * - Will fallback to a direct read approach without cache in old browsers
 *
 * @returns BrowserProperties
 */
function getBrowserProperties() {
  if (!useResizeObserver()) {
    return readBrowserProperties();
  }
  if (!cachedProperties) {
    cachedProperties = readBrowserProperties();
  }
  initializeResizeObserver();
  return cachedProperties;
}
/**
 * Reads the browser properties - expensive call!
 *
 * @returns BrowserProperties
 */
function readBrowserProperties() {
  return {
    viewport: detectViewport(),
    documentSize: detectDocumentSize(),
    resolution: detectScreenResolution(),
    colorDepth: screen.colorDepth,
    devicePixelRatio: window.devicePixelRatio,
    cookiesEnabled: window.navigator.cookieEnabled,
    online: window.navigator.onLine,
    browserLanguage: window.navigator.language || window.navigator.userLanguage,
    documentLanguage: document.documentElement.lang,
    webdriver: window.navigator.webdriver,
    deviceMemory: window.navigator.deviceMemory,
    hardwareConcurrency: Math.floor(window.navigator.hardwareConcurrency) || undefined
  };
}
/**
 * Gets the current viewport.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 * - http://responsejs.com/labs/dimensions/
 */
function detectViewport() {
  var width, height;
  if ('innerWidth' in window) {
    width = window['innerWidth'];
    height = window['innerHeight'];
  } else {
    var e = document.documentElement || document.body;
    width = e['clientWidth'];
    height = e['clientHeight'];
  }
  return makeDimension(Math.max(0, width), Math.max(0, height));
}
/**
 * Gets the dimensions of the current
 * document.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 */
function detectDocumentSize() {
  var de = document.documentElement,
    // Alias
    be = document.body,
    // document.body may not have rendered, so check whether be.offsetHeight is null
    bodyHeight = be ? Math.max(be.offsetHeight, be.scrollHeight) : 0;
  return makeDimension(Math.max(de.clientWidth, de.offsetWidth, de.scrollWidth), Math.max(de.clientHeight, de.offsetHeight, de.scrollHeight, bodyHeight));
}
function detectScreenResolution() {
  return makeDimension(screen.width, screen.height);
}
function makeDimension(width, height) {
  if (isNaN(width) || isNaN(height)) {
    return null;
  }
  return Math.floor(width) + 'x' + Math.floor(height);
}
function newCookie(name) {
  var flushTimer;
  var lastSetValueArgs;
  var cacheExpireAt;
  var flushed = true;
  var flushTimeout = 10; // milliseconds
  var maxCacheTtl = 0.05; // seconds
  function getValue() {
    var _a;
    // Note: we can't cache the cookie value as we don't know the expiration date
    if (lastSetValueArgs && (!cacheExpireAt || cacheExpireAt > new Date())) {
      return (_a = lastSetValueArgs[0]) !== null && _a !== void 0 ? _a : cookie(name);
    }
    return cookie(name);
  }
  function setValue(value, ttl, path, domain, samesite, secure) {
    lastSetValueArgs = [value, ttl, path, domain, samesite, secure];
    flushed = false;
    // throttle setting the cookie
    if (flushTimer === undefined) {
      flushTimer = setTimeout(function () {
        flushTimer = undefined;
        flush();
      }, flushTimeout);
    }
    cacheExpireAt = new Date(Date.now() + Math.min(maxCacheTtl, ttl !== null && ttl !== void 0 ? ttl : maxCacheTtl) * 1000);
    return true;
  }
  function deleteValue(path, domainName, sameSite, secure) {
    lastSetValueArgs = undefined;
    flushed = true;
    // cancel setting the cookie
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    deleteCookie(name, path, domainName, sameSite, secure);
  }
  function flush() {
    if (flushTimer !== undefined) {
      clearTimeout(flushTimer);
      flushTimer = undefined;
    }
    if (flushed) {
      return;
    }
    flushed = true;
    if (lastSetValueArgs !== undefined) {
      var value = lastSetValueArgs[0],
        ttl = lastSetValueArgs[1],
        path = lastSetValueArgs[2],
        domain = lastSetValueArgs[3],
        samesite = lastSetValueArgs[4],
        secure = lastSetValueArgs[5];
      cookie(name, value, ttl, path, domain, samesite, secure);
    }
  }
  return {
    getValue: getValue,
    setValue: setValue,
    deleteValue: deleteValue,
    flush: flush
  };
}
/**
 * Create a new async cookie storage
 *
 * @returns A new cookie storage
 */
function newCookieStorage() {
  var cache = {};
  function getOrInitCookie(name) {
    if (!cache[name]) {
      cache[name] = newCookie(name);
    }
    return cache[name];
  }
  function getCookie(name) {
    return getOrInitCookie(name).getValue();
  }
  function setCookie(name, value, ttl, path, domain, samesite, secure) {
    return getOrInitCookie(name).setValue(value, ttl, path, domain, samesite, secure);
  }
  function deleteCookie(name, path, domainName, sameSite, secure) {
    getOrInitCookie(name).deleteValue(path, domainName, sameSite, secure);
  }
  function clearCache() {
    cache = {};
  }
  function flush() {
    for (var _i = 0, _a = Object.values(cache); _i < _a.length; _i++) {
      var cookie_1 = _a[_i];
      cookie_1.flush();
    }
  }
  return {
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
    clearCache: clearCache,
    flush: flush
  };
}
/**
 * Cookie storage instance with asynchronous cookie writes
 */
var asyncCookieStorage = newCookieStorage();
/**
 * Cookie storage instance with synchronous cookie writes
 */
var syncCookieStorage = {
  getCookie: cookie,
  setCookie: function setCookie(name, value, ttl, path, domain, samesite, secure) {
    cookie(name, value, ttl, path, domain, samesite, secure);
    return document.cookie.indexOf("".concat(name, "=")) !== -1;
  },
  deleteCookie: deleteCookie,
  flush: function flush() {}
};

/**
 * The Snowplow Tracker
 *
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker object
 * @param version - The current version of the JavaScript Tracker
 * @param endpoint - The collector endpoint to send events to, with or without protocol
 * @param sharedState - An object containing state which is shared across tracker instances
 * @param trackerConfiguration - Dictionary of configuration options
 */
function Tracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration) {
  if (trackerConfiguration === void 0) {
    trackerConfiguration = {};
  }
  var browserPlugins = [];
  var newTracker = function newTracker(trackerId, namespace, version, endpoint, state, trackerConfiguration) {
    /************************************************************
     * Private members
     ************************************************************/
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    //use POST if eventMethod isn't present on the newTrackerConfiguration
    trackerConfiguration.eventMethod = (_a = trackerConfiguration.eventMethod) !== null && _a !== void 0 ? _a : 'post';
    var getStateStorageStrategy = function getStateStorageStrategy(config) {
        var _a;
        return (_a = config.stateStorageStrategy) !== null && _a !== void 0 ? _a : 'cookieAndLocalStorage';
      },
      getAnonymousSessionTracking = function getAnonymousSessionTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withSessionTracking) === true;
      },
      getAnonymousServerTracking = function getAnonymousServerTracking(config) {
        var _a;
        if (typeof config.anonymousTracking === 'boolean') {
          return false;
        }
        return ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withServerAnonymisation) === true;
      },
      getAnonymousTracking = function getAnonymousTracking(config) {
        return !!config.anonymousTracking;
      },
      isBrowserContextAvailable = (_c = (_b = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _b === void 0 ? void 0 : _b.browser) !== null && _c !== void 0 ? _c : false,
      isWebPageContextAvailable = (_e = (_d = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _d === void 0 ? void 0 : _d.webPage) !== null && _e !== void 0 ? _e : true,
      getExtendedCrossDomainTrackingConfiguration = function getExtendedCrossDomainTrackingConfiguration(crossDomainTrackingConfig) {
        if (typeof crossDomainTrackingConfig === 'boolean') {
          return {
            useExtendedCrossDomainLinker: crossDomainTrackingConfig
          };
        }
        return {
          useExtendedCrossDomainLinker: true,
          collectCrossDomainAttributes: crossDomainTrackingConfig
        };
      };
    // Create a new cookie storage instance with synchronous cookie write if configured
    var cookieStorage = trackerConfiguration.synchronousCookieWrite ? syncCookieStorage : asyncCookieStorage;
    // Get all injected plugins
    browserPlugins.push(getBrowserDataPlugin());
    /* When including the Web Page context, we add the relevant internal plugins */
    if (isWebPageContextAvailable) {
      browserPlugins.push(getWebPagePlugin());
    }
    if (isBrowserContextAvailable) {
      browserPlugins.push(getBrowserContextPlugin());
    }
    browserPlugins.push.apply(browserPlugins, (_f = trackerConfiguration.plugins) !== null && _f !== void 0 ? _f : []);
    var
      // Tracker core
      core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["f" /* trackerCore */])({
        base64: (_g = trackerConfiguration.encodeBase64) !== null && _g !== void 0 ? _g : trackerConfiguration.eventMethod !== 'post',
        corePlugins: browserPlugins,
        callback: sendRequest
      }),
      // Aliases
      documentCharset = document.characterSet || document.charset,
      // Current URL and Referrer URL
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer()),
      domainAlias = fixupDomain(locationArray[0]),
      locationHrefAlias = locationArray[1],
      configReferrerUrl = locationArray[2],
      customReferrer,
      // Platform defaults to web for this tracker
      configPlatform = (_h = trackerConfiguration.platform) !== null && _h !== void 0 ? _h : 'web',
      // Site ID
      configTrackerSiteId = (_j = trackerConfiguration.appId) !== null && _j !== void 0 ? _j : '',
      // Application version
      configAppVersion = trackerConfiguration.appVersion,
      // Document URL
      configCustomUrl,
      // Document title
      lastDocumentTitle = document.title,
      // Custom title
      lastConfigTitle,
      // Indicates that the lastConfigTitle was set from a trackPageView call
      // Custom title configured this way has a shorter lifespan than when set using setDocumentTitle.
      // It only lasts until the next trackPageView call.
      lastConfigTitleFromTrackPageView = false,
      // Controls whether activity tracking page ping event timers are reset on page view events
      resetActivityTrackingOnPageView = (_k = trackerConfiguration.resetActivityTrackingOnPageView) !== null && _k !== void 0 ? _k : true,
      // Disallow hash tags in URL. TODO: Should this be set to true by default?
      configDiscardHashTag,
      // Disallow brace in URL.
      configDiscardBrace,
      // First-party cookie name prefix
      configCookieNamePrefix = (_l = trackerConfiguration.cookieName) !== null && _l !== void 0 ? _l : '_sp_',
      // First-party cookie domain
      // User agent defaults to origin hostname
      configCookieDomain = (_m = trackerConfiguration.cookieDomain) !== null && _m !== void 0 ? _m : undefined,
      discoverRootDomain = (_o = trackerConfiguration.discoverRootDomain) !== null && _o !== void 0 ? _o : configCookieDomain === undefined,
      // First-party cookie path
      // Default is user agent defined.
      configCookiePath = '/',
      // First-party cookie samesite attribute
      configCookieSameSite = (_p = trackerConfiguration.cookieSameSite) !== null && _p !== void 0 ? _p : 'Lax',
      // First-party cookie secure attribute
      configCookieSecure = (_q = trackerConfiguration.cookieSecure) !== null && _q !== void 0 ? _q : true,
      // Do Not Track browser feature
      dnt = window.navigator.doNotTrack || window.navigator.msDoNotTrack || window.doNotTrack,
      // Do Not Track
      configDoNotTrack = typeof trackerConfiguration.respectDoNotTrack !== 'undefined' ? trackerConfiguration.respectDoNotTrack && (dnt === 'yes' || dnt === '1') : false,
      // Opt out of cookie tracking
      configOptOutCookie,
      // Life of the visitor cookie (in seconds)
      configVisitorCookieTimeout = (_r = trackerConfiguration.cookieLifetime) !== null && _r !== void 0 ? _r : 63072000,
      // 2 years
      // Life of the session cookie (in seconds)
      configSessionCookieTimeout = (_s = trackerConfiguration.sessionCookieTimeout) !== null && _s !== void 0 ? _s : 1800,
      // 30 minutes
      // Allows tracking user session (using cookies or local storage), can only be used with anonymousTracking
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration),
      // Will send a header to server to prevent returning cookie and capturing IP
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration),
      // Sets tracker to work in anonymous mode without accessing client storage
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration),
      // Strategy defining how to store the state: cookie, localStorage, cookieAndLocalStorage or none
      configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration),
      // Last activity timestamp
      lastActivityTime,
      // The last time an event was fired on the page - used to invalidate session if cookies are disabled
      lastEventTime = new Date().getTime(),
      // How are we scrolling?
      minXOffset,
      maxXOffset,
      minYOffset,
      maxYOffset,
      // Activity metrics tracking state
      activityMetricsState = {
        metrics: {
          mouseDistance: 0,
          scrollDistance: 0,
          keyPresses: 0,
          clicks: 0,
          touches: 0
        },
        lastMouseX: undefined,
        lastMouseY: undefined,
        lastScrollX: undefined,
        lastScrollY: undefined
      },
      // Domain hash value
      domainHash,
      // Domain unique user ID
      domainUserId,
      // ID for the current session
      memorizedSessionId,
      // Index for the current session - kept in memory in case cookies are disabled
      memorizedVisitCount = 1,
      // Business-defined unique user ID
      businessUserId,
      // Manager for local storage queue
      outQueue = newOutQueue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({
        trackerId: trackerId,
        endpoint: asCollectorUrl(endpoint),
        serverAnonymization: configAnonymousServerTracking,
        useLocalStorage: configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage'
      }, trackerConfiguration), state),
      // Whether pageViewId should be regenerated after each trackPageView. Affect web_page context
      _preservePageViewId = false,
      // Whether pageViewId should be kept the same until the page URL changes. Affects web_page context
      _preservePageViewIdForUrl = (_t = trackerConfiguration.preservePageViewIdForUrl) !== null && _t !== void 0 ? _t : false,
      // The pageViewId of the last page view event or undefined if no page view tracked yet. Used to determine if pageViewId should be regenerated for a new page view.
      lastSentPageViewId = undefined,
      // Activity tracking config for callback and page ping variants
      activityTrackingConfig = {
        enabled: false,
        installed: false,
        configurations: {}
      },
      configSessionContext = (_v = (_u = trackerConfiguration.contexts) === null || _u === void 0 ? void 0 : _u.session) !== null && _v !== void 0 ? _v : false,
      toOptoutByCookie,
      onSessionUpdateCallback = trackerConfiguration.onSessionUpdateCallback,
      manualSessionUpdateCalled = false,
      _w = getExtendedCrossDomainTrackingConfiguration(trackerConfiguration.useExtendedCrossDomainLinker || false),
      useExtendedCrossDomainLinker = _w.useExtendedCrossDomainLinker,
      collectCrossDomainAttributes = _w.collectCrossDomainAttributes;
    if (discoverRootDomain && !configCookieDomain) {
      configCookieDomain = findRootDomain(configCookieSameSite, configCookieSecure);
    }
    var _x = getBrowserProperties(),
      browserLanguage = _x.browserLanguage,
      resolution = _x.resolution,
      colorDepth = _x.colorDepth,
      cookiesEnabled = _x.cookiesEnabled;
    var timeZone = getTimeZone();
    // Set up unchanging name-value pairs
    core.setTrackerVersion(version);
    core.setTrackerNamespace(namespace);
    core.setAppId(configTrackerSiteId);
    core.setPlatform(configPlatform);
    core.addPayloadPair('cookie', cookiesEnabled ? '1' : '0');
    core.addPayloadPair('cs', documentCharset);
    core.addPayloadPair('lang', browserLanguage);
    core.addPayloadPair('res', resolution);
    core.addPayloadPair('cd', colorDepth);
    if (timeZone) core.addPayloadPair('tz', timeZone);
    // Add the application version context entity
    if (configAppVersion) {
      core.addPlugin({
        plugin: {
          contexts: function contexts() {
            return [{
              schema: APPLICATION_CONTEXT_SCHEMA,
              data: {
                version: configAppVersion
              }
            }];
          }
        }
      });
    }
    /*
     * Initialize tracker
     */
    updateDomainHash();
    initializeIdsAndCookies();
    if (trackerConfiguration.crossDomainLinker) {
      decorateLinks(trackerConfiguration.crossDomainLinker);
    }
    /**
     * Recalculate the domain, URL, and referrer
     */
    function refreshUrl() {
      locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer());
      // If this is a single-page app and the page URL has changed, then:
      //   - if the new URL's querystring contains a "refer(r)er" parameter, use it as the referrer
      //   - otherwise use the old URL as the referer
      if (locationArray[1] !== locationHrefAlias) {
        configReferrerUrl = getReferrer(locationHrefAlias);
      }
      domainAlias = fixupDomain(locationArray[0]);
      locationHrefAlias = locationArray[1];
    }
    /**
     * Create link handler to decorate the querystring of a link (onClick/onMouseDown)
     *
     * @param event - e The event targeting the link
     */
    function addLinkDecorationHandler(extended) {
      var CROSS_DOMAIN_PARAMETER_NAME = '_sp';
      return function (evt) {
        var elt = evt.currentTarget;
        var crossDomainParameterValue = createCrossDomainParameterValue(extended, collectCrossDomainAttributes, {
          domainUserId: domainUserId,
          userId: businessUserId || undefined,
          sessionId: memorizedSessionId,
          sourceId: configTrackerSiteId,
          sourcePlatform: configPlatform,
          event: evt
        });
        if (elt === null || elt === void 0 ? void 0 : elt.href) {
          elt.href = decorateQuerystring(elt.href, CROSS_DOMAIN_PARAMETER_NAME, crossDomainParameterValue);
        }
      };
    }
    /**
     * Enable querystring decoration for links passing a filter
     * Whenever such a link is clicked on or navigated to via the keyboard,
     * add "_sp={{duid}}.{{timestamp}}" to its querystring
     *
     * @param crossDomainLinker - Function used to determine which links to decorate
     */
    function decorateLinks(crossDomainLinker) {
      var crossDomainLinkHandler = addLinkDecorationHandler(useExtendedCrossDomainLinker);
      for (var i = 0; i < document.links.length; i++) {
        var elt = document.links[i];
        if (!elt.spDecorationEnabled && crossDomainLinker(elt)) {
          elt.addEventListener('click', crossDomainLinkHandler, true);
          elt.addEventListener('mousedown', crossDomainLinkHandler, true);
          // Don't add event listeners more than once
          elt.spDecorationEnabled = true;
        }
      }
    }
    /*
     * Removes hash tag from the URL
     *
     * URLs are purified before being recorded in the cookie,
     * or before being sent as GET parameters
     */
    function purify(url) {
      var targetPattern;
      if (configDiscardHashTag) {
        targetPattern = new RegExp('#.*');
        url = url.replace(targetPattern, '');
      }
      if (configDiscardBrace) {
        targetPattern = new RegExp('[{}]', 'g');
        url = url.replace(targetPattern, '');
      }
      return url;
    }
    /*
     * Extract scheme/protocol from URL
     */
    function getProtocolScheme(url) {
      var e = new RegExp('^([a-z]+):'),
        matches = e.exec(url);
      return matches ? matches[1] : null;
    }
    /*
     * Resolve relative reference
     *
     * Note: not as described in rfc3986 section 5.2
     */
    function resolveRelativeReference(baseUrl, url) {
      var protocol = getProtocolScheme(url),
        i;
      if (protocol) {
        return url;
      }
      if (url.slice(0, 1) === '/') {
        return getProtocolScheme(baseUrl) + '://' + getHostName(baseUrl) + url;
      }
      baseUrl = purify(baseUrl);
      if ((i = baseUrl.indexOf('?')) >= 0) {
        baseUrl = baseUrl.slice(0, i);
      }
      if ((i = baseUrl.lastIndexOf('/')) !== baseUrl.length - 1) {
        baseUrl = baseUrl.slice(0, i + 1);
      }
      return baseUrl + url;
    }
    /*
     * Send request
     */
    function sendRequest(request) {
      if (!(configDoNotTrack || toOptoutByCookie)) {
        outQueue.enqueueRequest(request.build());
      }
    }
    /*
     * Get cookie name with prefix and domain hash
     */
    function getSnowplowCookieName(baseName) {
      return configCookieNamePrefix + baseName + '.' + domainHash;
    }
    /*
     * Cookie getter.
     */
    function getSnowplowCookieValue(cookieName) {
      var fullName = getSnowplowCookieName(cookieName);
      if (configStateStorageStrategy == 'localStorage') {
        return attemptGetLocalStorage(fullName);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.getCookie(fullName);
      }
      return undefined;
    }
    /*
     * Update domain hash
     */
    function updateDomainHash() {
      refreshUrl();
      domainHash = sha1((configCookieDomain || domainAlias) + (configCookiePath || '/')).slice(0, 4); // 4 hexits = 16 bits
    }
    /*
     * Process all "activity" events.
     * For performance, this function must have low overhead.
     */
    function activityHandler(event) {
      var now = new Date();
      lastActivityTime = now.getTime();
      if (isActivityMetricsEnabled() && event) {
        switch (event.type) {
          case 'mousemove':
            {
              var me = event;
              if (activityMetricsState.lastMouseX !== undefined && activityMetricsState.lastMouseY !== undefined) {
                var dx = me.clientX - activityMetricsState.lastMouseX;
                var dy = me.clientY - activityMetricsState.lastMouseY;
                activityMetricsState.metrics.mouseDistance += Math.sqrt(dx * dx + dy * dy);
              }
              activityMetricsState.lastMouseX = me.clientX;
              activityMetricsState.lastMouseY = me.clientY;
              break;
            }
          case 'click':
            activityMetricsState.metrics.clicks++;
            break;
          case 'keydown':
            activityMetricsState.metrics.keyPresses++;
            break;
          case 'touchstart':
            activityMetricsState.metrics.touches++;
            break;
          // scroll handled in scrollHandler
        }
      }
    }
    /*
     * Process all "scroll" events.
     */
    function scrollHandler() {
      activityHandler();
      var offsets = getPageOffsets();
      var x = offsets[0];
      if (x < minXOffset) {
        minXOffset = x;
      } else if (x > maxXOffset) {
        maxXOffset = x;
      }
      var y = offsets[1];
      if (y < minYOffset) {
        minYOffset = y;
      } else if (y > maxYOffset) {
        maxYOffset = y;
      }
      if (isActivityMetricsEnabled()) {
        if (activityMetricsState.lastScrollX !== undefined && activityMetricsState.lastScrollY !== undefined) {
          activityMetricsState.metrics.scrollDistance += Math.abs(x - activityMetricsState.lastScrollX) + Math.abs(y - activityMetricsState.lastScrollY);
        }
        activityMetricsState.lastScrollX = x;
        activityMetricsState.lastScrollY = y;
      }
    }
    /*
     * Returns [pageXOffset, pageYOffset]
     */
    function getPageOffsets() {
      var documentElement = document.documentElement;
      if (documentElement) {
        return [documentElement.scrollLeft || window.pageXOffset, documentElement.scrollTop || window.pageYOffset];
      }
      return [0, 0];
    }
    /*
     * Quick initialization/reset of max scroll levels
     */
    function resetMaxScrolls() {
      var offsets = getPageOffsets();
      var x = offsets[0];
      minXOffset = x;
      maxXOffset = x;
      var y = offsets[1];
      minYOffset = y;
      maxYOffset = y;
    }
    /*
     * Whether activity metrics tracking is enabled for any active configuration
     */
    function isActivityMetricsEnabled() {
      var _a, _b;
      return !!(((_a = activityTrackingConfig.configurations.pagePing) === null || _a === void 0 ? void 0 : _a.activityMetrics) || ((_b = activityTrackingConfig.configurations.callback) === null || _b === void 0 ? void 0 : _b.activityMetrics));
    }
    /*
     * Reset activity metrics accumulators and position trackers
     */
    function resetActivityMetricsState() {
      activityMetricsState.metrics = {
        mouseDistance: 0,
        scrollDistance: 0,
        keyPresses: 0,
        clicks: 0,
        touches: 0
      };
      activityMetricsState.lastMouseX = undefined;
      activityMetricsState.lastMouseY = undefined;
      activityMetricsState.lastScrollX = undefined;
      activityMetricsState.lastScrollY = undefined;
    }
    /*
     * Return a snapshot of current activity metrics
     */
    function getActivityMetrics() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, activityMetricsState.metrics), {
        mouseDistance: Math.round(activityMetricsState.metrics.mouseDistance),
        scrollDistance: Math.round(activityMetricsState.metrics.scrollDistance)
      });
    }
    /*
     * Prevents offsets from being decimal or NaN
     * See https://github.com/snowplow/snowplow-javascript-tracker/issues/324
     */
    function cleanOffset(offset) {
      return Math.round(offset);
    }
    /**
     * Sets or renews the session cookie.
     * Responsible for calling the `onSessionUpdateCallback` callback.
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setSessionCookie() {
      var cookieName = getSnowplowCookieName('ses');
      var cookieValue = '*';
      return persistValue(cookieName, cookieValue, configSessionCookieTimeout);
    }
    /**
     * @mutates idCookie
     * @param {ParsedIdCookie} idCookie
     * @returns {boolean} If the value persisted in cookies or LocalStorage
     */
    function setDomainUserIdCookie(idCookie) {
      var cookieName = getSnowplowCookieName('id');
      var cookieValue = serializeIdCookie(idCookie, configAnonymousTracking);
      return persistValue(cookieName, cookieValue, configVisitorCookieTimeout);
    }
    /**
     * no-op if anonymousTracking enabled, will still set cookies if anonymousSessionTracking is enabled
     * Sets a cookie based on the storage strategy:
     * - if 'localStorage': attempts to write to local storage
     * - if 'cookie' or 'cookieAndLocalStorage': writes to cookies
     * - otherwise: no-op
     * @param {string} name Name/key of the value to persist
     * @param {string} value
     * @param {number} timeout Used as the expiration date for cookies or as a TTL to be checked on LocalStorage
     * @returns {boolean} If the operation was successful or not
     */
    function persistValue(name, value, timeout) {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return false;
      }
      if (configStateStorageStrategy == 'localStorage') {
        return attemptWriteLocalStorage(name, value, timeout);
      } else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
        return cookieStorage.setCookie(name, value, timeout, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      }
      return false;
    }
    /**
     * Clears all cookie and local storage for id and ses values
     */
    function clearUserDataAndCookies(configuration) {
      var idname = getSnowplowCookieName('id');
      var sesname = getSnowplowCookieName('ses');
      attemptDeleteLocalStorage(idname);
      attemptDeleteLocalStorage(sesname);
      cookieStorage.deleteCookie(idname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      cookieStorage.deleteCookie(sesname, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveSession)) {
        memorizedSessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        memorizedVisitCount = 1;
      }
      if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveUser)) {
        domainUserId = configAnonymousTracking ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        businessUserId = null;
      }
    }
    /**
     * Toggle Anonymous Tracking
     */
    function toggleAnonymousTracking(configuration) {
      if (configuration && configuration.stateStorageStrategy) {
        trackerConfiguration.stateStorageStrategy = configuration.stateStorageStrategy;
        configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration);
      }
      configAnonymousTracking = getAnonymousTracking(trackerConfiguration);
      configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration);
      configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration);
      outQueue.setUseLocalStorage(configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage');
      outQueue.setAnonymousTracking(configAnonymousServerTracking);
    }
    /*
     * Load the domain user ID and the session ID
     * Set the cookies (if cookies are enabled)
     */
    function initializeIdsAndCookies() {
      if (configAnonymousTracking && !configAnonymousSessionTracking) {
        return;
      }
      var sesCookieSet = configStateStorageStrategy != 'none' && !!getSnowplowCookieValue('ses');
      var idCookie = loadDomainUserIdCookie();
      domainUserId = initializeDomainUserId(idCookie, configAnonymousTracking);
      if (!sesCookieSet) {
        memorizedSessionId = startNewIdCookieSession(idCookie);
      } else {
        memorizedSessionId = sessionIdFromIdCookie(idCookie);
      }
      memorizedVisitCount = visitCountFromIdCookie(idCookie);
      if (configStateStorageStrategy != 'none') {
        setSessionCookie();
        // Update currentVisitTs
        updateNowTsInIdCookie(idCookie);
        setDomainUserIdCookie(idCookie);
        if (!eventIndexFromIdCookie(idCookie)) {
          // Synchronously update the cookies to persist the new session ASAP
          cookieStorage.flush();
        }
      }
    }
    /*
     * Load visitor ID cookie
     */
    function loadDomainUserIdCookie() {
      if (configStateStorageStrategy == 'none') {
        return emptyIdCookie();
      }
      var id = getSnowplowCookieValue('id') || undefined;
      return parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount);
    }
    /**
     * Adds the protocol in front of our collector URL
     *
     * @param string - collectorUrl The collector URL with or without protocol
     * @returns string collectorUrl The tracker URL with protocol
     */
    function asCollectorUrl(collectorUrl) {
      if (collectorUrl.indexOf('http') === 0) {
        return collectorUrl;
      }
      return ('https:' === document.location.protocol ? 'https' : 'http') + '://' + collectorUrl;
    }
    /**
     * Initialize new `pageViewId` if it shouldn't be preserved.
     * Should be called when `trackPageView` is invoked
     */
    function resetPageView() {
      if (!_preservePageViewId || state.pageViewId == null) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
    }
    /**
     * Safe function to get `pageViewId`.
     * Generates it if it wasn't initialized by other tracker
     */
    function getPageViewId() {
      if (shouldGenerateNewPageViewId()) {
        state.pageViewId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])();
        state.pageViewUrl = configCustomUrl || locationHrefAlias;
      }
      return state.pageViewId;
    }
    function shouldGenerateNewPageViewId() {
      // If pageViewId is not initialized, generate it
      if (state.pageViewId == null) {
        return true;
      }
      // If pageViewId should be preserved regardless of the URL, don't generate a new one
      if (_preservePageViewId || !_preservePageViewIdForUrl) {
        return false;
      }
      // If doesn't have previous URL in state, generate a new pageViewId
      if (state.pageViewUrl === undefined) {
        return true;
      }
      var current = configCustomUrl || locationHrefAlias;
      // If full preserve is enabled, compare the full URL
      if (_preservePageViewIdForUrl === true || _preservePageViewIdForUrl == 'full' || !('URL' in window)) {
        return state.pageViewUrl != current;
      }
      var currentUrl = new URL(current);
      var previousUrl = new URL(state.pageViewUrl);
      // If pathname preserve is enabled, compare the pathname
      if (_preservePageViewIdForUrl == 'pathname') {
        return currentUrl.pathname != previousUrl.pathname;
      }
      // If pathname and search preserve is enabled, compare the pathname and search
      if (_preservePageViewIdForUrl == 'pathnameAndSearch') {
        return currentUrl.pathname != previousUrl.pathname || currentUrl.search != previousUrl.search;
      }
      return false;
    }
    /**
     * Safe function to get `tabId`.
     * Generates it if it is not yet initialized. Shared between trackers.
     */
    function getTabId() {
      if (configStateStorageStrategy === 'none' || configAnonymousTracking || !isWebPageContextAvailable) {
        return null;
      }
      var SESSION_STORAGE_TAB_ID = '_sp_tab_id';
      var tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      if (!tabId) {
        attemptWriteSessionStorage(SESSION_STORAGE_TAB_ID, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])());
        tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
      }
      return tabId || null;
    }
    /**
     * Put together a web page context with a unique UUID for the page view
     *
     * @returns web_page context
     */
    function getWebPagePlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: WEB_PAGE_SCHEMA,
            data: {
              id: getPageViewId()
            }
          }];
        }
      };
    }
    function getBrowserContextPlugin() {
      return {
        contexts: function contexts() {
          return [{
            schema: BROWSER_CONTEXT_SCHEMA,
            data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, getBrowserProperties()), {
              tabId: getTabId()
            })
          }];
        }
      };
    }
    /*
     * Attaches common web fields to every request (resolution, url, referrer, etc.)
     * Also sets the required cookies.
     */
    function getBrowserDataPlugin() {
      var anonymizeOr = function anonymizeOr(value) {
        return configAnonymousTracking ? null : value;
      };
      var anonymizeSessionOr = function anonymizeSessionOr(value) {
        return configAnonymousSessionTracking ? value : anonymizeOr(value);
      };
      return {
        beforeTrack: function beforeTrack(payloadBuilder) {
          var existingSession = getSnowplowCookieValue('ses'),
            idCookie = loadDomainUserIdCookie();
          var isFirstEventInSession = eventIndexFromIdCookie(idCookie) === 0;
          if (configOptOutCookie) {
            toOptoutByCookie = !!cookieStorage.getCookie(configOptOutCookie);
          } else {
            toOptoutByCookie = false;
          }
          if (configDoNotTrack || toOptoutByCookie) {
            clearUserDataAndCookies();
            return;
          }
          // If cookies are enabled, base visit count and session ID on the cookies
          if (cookiesEnabledInIdCookie(idCookie)) {
            // New session?
            if (!existingSession && configStateStorageStrategy != 'none') {
              memorizedSessionId = startNewIdCookieSession(idCookie);
            } else {
              memorizedSessionId = sessionIdFromIdCookie(idCookie);
            }
            memorizedVisitCount = visitCountFromIdCookie(idCookie);
          } else if (new Date().getTime() - lastEventTime > configSessionCookieTimeout * 1000) {
            memorizedVisitCount++;
            memorizedSessionId = startNewIdCookieSession(idCookie, {
              memorizedVisitCount: memorizedVisitCount
            });
          }
          // Update cookie
          updateNowTsInIdCookie(idCookie);
          updateFirstEventInIdCookie(idCookie, payloadBuilder);
          incrementEventIndexInIdCookie(idCookie);
          var _a = getBrowserProperties(),
            viewport = _a.viewport,
            documentSize = _a.documentSize;
          payloadBuilder.add('vp', viewport);
          payloadBuilder.add('ds', documentSize);
          payloadBuilder.add('vid', anonymizeSessionOr(memorizedVisitCount));
          payloadBuilder.add('sid', anonymizeSessionOr(memorizedSessionId));
          payloadBuilder.add('duid', anonymizeOr(domainUserIdFromIdCookie(idCookie))); // Always load from cookie as this is better etiquette than in-memory values
          payloadBuilder.add('uid', anonymizeOr(businessUserId));
          refreshUrl();
          payloadBuilder.add('refr', purify(customReferrer || configReferrerUrl));
          // Add the page URL last as it may take us over the IE limit (and we don't always need it)
          payloadBuilder.add('url', purify(configCustomUrl || locationHrefAlias));
          var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
          if (configSessionContext && (!configAnonymousTracking || configAnonymousSessionTracking)) {
            addSessionContextToPayload(payloadBuilder, clientSession);
          }
          // Update cookies
          if (configStateStorageStrategy != 'none') {
            setDomainUserIdCookie(idCookie);
            var sessionIdentifierPersisted = setSessionCookie();
            if ((!existingSession || isFirstEventInSession) && sessionIdentifierPersisted && onSessionUpdateCallback && !manualSessionUpdateCalled) {
              // Synchronously update the cookies to persist the new session ASAP
              cookieStorage.flush();
              onSessionUpdateCallback(clientSession);
              manualSessionUpdateCalled = false;
            }
          }
          lastEventTime = new Date().getTime();
        }
      };
    }
    function addSessionContextToPayload(payloadBuilder, clientSession) {
      var sessionContext = {
        schema: CLIENT_SESSION_SCHEMA,
        data: clientSession
      };
      payloadBuilder.addContextEntity(sessionContext);
    }
    /**
     * Expires current session and starts a new session.
     */
    function newSession() {
      // If cookies are enabled, base visit count and session ID on the cookies
      var idCookie = loadDomainUserIdCookie();
      // When cookies are enabled
      if (cookiesEnabledInIdCookie(idCookie)) {
        // When cookie/local storage is enabled - make a new session
        if (configStateStorageStrategy != 'none') {
          memorizedSessionId = startNewIdCookieSession(idCookie);
        } else {
          memorizedSessionId = sessionIdFromIdCookie(idCookie);
        }
        memorizedVisitCount = visitCountFromIdCookie(idCookie);
      } else {
        memorizedVisitCount++;
        memorizedSessionId = startNewIdCookieSession(idCookie, {
          memorizedVisitCount: memorizedVisitCount
        });
      }
      updateNowTsInIdCookie(idCookie);
      // Update cookies
      if (configStateStorageStrategy != 'none') {
        var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
        setDomainUserIdCookie(idCookie);
        var sessionIdentifierPersisted = setSessionCookie();
        // Synchronously update the cookies to persist the new session ASAP
        cookieStorage.flush();
        if (sessionIdentifierPersisted && onSessionUpdateCallback) {
          manualSessionUpdateCalled = true;
          onSessionUpdateCallback(clientSession);
        }
      }
      lastEventTime = new Date().getTime();
    }
    /**
     * Combine an array of unchanging contexts with the result of a context-creating function
     *
     * @param staticContexts - Array of custom contexts
     * @param contextCallback - Function returning an array of contexts
     */
    function finalizeContexts(staticContexts, contextCallback) {
      return (staticContexts || []).concat(contextCallback ? contextCallback() : []);
    }
    function logPageView(_a) {
      var title = _a.title,
        context = _a.context,
        timestamp = _a.timestamp,
        contextCallback = _a.contextCallback;
      refreshUrl();
      if (lastSentPageViewId && lastSentPageViewId == getPageViewId()) {
        // Do not reset pageViewId if a page view was not tracked yet or a different page view ID was used (in order to support multiple trackers with shared state)
        resetPageView();
      }
      lastSentPageViewId = getPageViewId();
      // So we know what document.title was at the time of trackPageView
      lastDocumentTitle = document.title;
      if (title) {
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = true;
      } else if (lastConfigTitleFromTrackPageView) {
        lastConfigTitle = null;
      }
      // Fixup page title
      var pageTitle = fixupTitle(lastConfigTitle || lastDocumentTitle);
      // Log page view
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["g" /* buildPageView */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: pageTitle,
        referrer: purify(customReferrer || configReferrerUrl)
      }), finalizeContexts(context, contextCallback), timestamp);
      // Send ping (to log that user has stayed on page)
      var now = new Date();
      var installingActivityTracking = false;
      if (activityTrackingConfig.enabled && !activityTrackingConfig.installed) {
        activityTrackingConfig.installed = true;
        installingActivityTracking = true;
        // Add mousewheel event handler, detect passive event listeners for performance
        var detectPassiveEvents_1 = {
          update: function update() {
            if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
              var passive_1 = false;
              var options = Object.defineProperty({}, 'passive', {
                get: function get() {
                  passive_1 = true;
                },
                set: function set() {}
              });
              // note: have to set and remove a no-op listener instead of null
              // (which was used previously), because Edge v15 throws an error
              // when providing a null callback.
              // https://github.com/rafrex/detect-passive-events/pull/3
              var noop = function noop() {};
              window.addEventListener('testPassiveEventSupport', noop, options);
              window.removeEventListener('testPassiveEventSupport', noop, options);
              detectPassiveEvents_1.hasSupport = passive_1;
            }
          }
        };
        detectPassiveEvents_1.update();
        // Detect available wheel event
        var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' // Modern browsers support "wheel"
        : document.onmousewheel !== undefined ? 'mousewheel' // Webkit and IE support at least "mousewheel"
        : 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
        if (Object.prototype.hasOwnProperty.call(detectPassiveEvents_1, 'hasSupport')) {
          addEventListener(document, wheelEvent, activityHandler, {
            passive: true
          });
        } else {
          addEventListener(document, wheelEvent, activityHandler);
        }
        // Capture our initial scroll points
        resetMaxScrolls();
        resetActivityMetricsState();
        // Add event handlers; cross-browser compatibility here varies significantly
        // @see http://quirksmode.org/dom/events
        var documentHandlers = ['click', 'mouseup', 'mousedown', 'mousemove', 'keypress', 'keydown', 'keyup', 'touchend', 'touchstart'];
        var windowHandlers = ['resize', 'focus', 'blur'];
        var listener = function listener(_, handler) {
          if (handler === void 0) {
            handler = activityHandler;
          }
          return function (ev) {
            return addEventListener(document, ev, handler);
          };
        };
        documentHandlers.forEach(listener(document));
        windowHandlers.forEach(listener(window));
        listener(window, scrollHandler)('scroll');
      }
      if (activityTrackingConfig.enabled && (resetActivityTrackingOnPageView || installingActivityTracking)) {
        // Periodic check for activity.
        lastActivityTime = now.getTime();
        resetActivityMetricsState();
        var key = void 0;
        for (key in activityTrackingConfig.configurations) {
          var config = activityTrackingConfig.configurations[key];
          if (config) {
            //Clear page ping heartbeat on new page view
            window.clearInterval(config.activityInterval);
            scheduleActivityInterval(config, context, contextCallback);
          }
        }
      }
    }
    function scheduleActivityInterval(config, context, contextCallback) {
      var executePagePing = function executePagePing(cb, context) {
        refreshUrl();
        var activityMetrics;
        if (isActivityMetricsEnabled()) {
          activityMetrics = getActivityMetrics();
          context = context.concat([{
            schema: ACTIVITY_METRICS_SCHEMA,
            data: activityMetrics
          }]);
        }
        cb({
          context: context,
          pageViewId: getPageViewId(),
          minXOffset: minXOffset,
          minYOffset: minYOffset,
          maxXOffset: maxXOffset,
          maxYOffset: maxYOffset,
          activityMetrics: activityMetrics
        });
        resetMaxScrolls();
        if (isActivityMetricsEnabled()) {
          resetActivityMetricsState();
        }
      };
      var timeout = function timeout() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configMinimumVisitLength > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      };
      var heartbeat = function heartbeat() {
        var now = new Date();
        // There was activity during the heart beat period;
        // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
        if (lastActivityTime + config.configHeartBeatTimer > now.getTime()) {
          executePagePing(config.callback, finalizeContexts(context, contextCallback));
        }
      };
      if (config.configMinimumVisitLength === 0) {
        config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
      } else {
        config.activityInterval = window.setTimeout(timeout, config.configMinimumVisitLength);
      }
    }
    /**
     * Configure the activity tracking and ensures integer values for min visit and heartbeat
     */
    function configureActivityTracking(configuration) {
      var minimumVisitLength = configuration.minimumVisitLength,
        heartbeatDelay = configuration.heartbeatDelay,
        callback = configuration.callback;
      if (isInteger(minimumVisitLength) && isInteger(heartbeatDelay)) {
        return {
          configMinimumVisitLength: minimumVisitLength * 1000,
          configHeartBeatTimer: heartbeatDelay * 1000,
          callback: callback,
          activityMetrics: configuration.activityMetrics
        };
      }
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].error('Activity tracking minimumVisitLength & heartbeatDelay must be integers');
      return undefined;
    }
    /**
     * Log that a user is still viewing a given page by sending a page ping.
     * Not part of the public API - only called from logPageView() above.
     */
    function logPagePing(_a) {
      var context = _a.context,
        minXOffset = _a.minXOffset,
        minYOffset = _a.minYOffset,
        maxXOffset = _a.maxXOffset,
        maxYOffset = _a.maxYOffset;
      var newDocumentTitle = document.title;
      if (newDocumentTitle !== lastDocumentTitle) {
        lastDocumentTitle = newDocumentTitle;
        lastConfigTitle = undefined;
      }
      core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["i" /* buildPagePing */])({
        pageUrl: purify(configCustomUrl || locationHrefAlias),
        pageTitle: fixupTitle(lastConfigTitle || lastDocumentTitle),
        referrer: purify(customReferrer || configReferrerUrl),
        minXOffset: cleanOffset(minXOffset),
        maxXOffset: cleanOffset(maxXOffset),
        minYOffset: cleanOffset(minYOffset),
        maxYOffset: cleanOffset(maxYOffset)
      }), context);
    }
    function disableActivityTrackingAction(actionKey) {
      var callbackConfiguration = activityTrackingConfig.configurations[actionKey];
      if ((callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.configMinimumVisitLength) === 0) {
        window.clearTimeout(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      } else {
        window.clearInterval(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
      }
      activityTrackingConfig.configurations[actionKey] = undefined;
      if (!activityTrackingConfig.configurations.pagePing && !activityTrackingConfig.configurations.callback) {
        resetActivityMetricsState();
      }
    }
    var apiMethods = {
      getDomainSessionIndex: function getDomainSessionIndex() {
        return memorizedVisitCount;
      },
      getPageViewId: getPageViewId,
      getTabId: getTabId,
      newSession: newSession,
      getCookieName: function getCookieName(basename) {
        return getSnowplowCookieName(basename);
      },
      getUserId: function getUserId() {
        return businessUserId;
      },
      getDomainUserId: function getDomainUserId() {
        return loadDomainUserIdCookie()[1];
      },
      getDomainUserInfo: function getDomainUserInfo() {
        return loadDomainUserIdCookie();
      },
      setReferrerUrl: function setReferrerUrl(url) {
        customReferrer = url;
      },
      setCustomUrl: function setCustomUrl(url) {
        refreshUrl();
        configCustomUrl = resolveRelativeReference(locationHrefAlias, url);
      },
      setDocumentTitle: function setDocumentTitle(title) {
        // So we know what document.title was at the time of trackPageView
        lastDocumentTitle = document.title;
        lastConfigTitle = title;
        lastConfigTitleFromTrackPageView = false;
      },
      discardHashTag: function discardHashTag(enableFilter) {
        configDiscardHashTag = enableFilter;
      },
      discardBrace: function discardBrace(enableFilter) {
        configDiscardBrace = enableFilter;
      },
      setCookiePath: function setCookiePath(path) {
        configCookiePath = path;
        updateDomainHash();
      },
      setVisitorCookieTimeout: function setVisitorCookieTimeout(timeout) {
        configVisitorCookieTimeout = timeout;
      },
      crossDomainLinker: function crossDomainLinker(crossDomainLinkerCriterion) {
        decorateLinks(crossDomainLinkerCriterion);
      },
      enableActivityTracking: function enableActivityTracking(configuration) {
        if (!activityTrackingConfig.configurations.pagePing) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.pagePing = configureActivityTracking(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, configuration), {
            callback: logPagePing
          }));
        }
      },
      enableActivityTrackingCallback: function enableActivityTrackingCallback(configuration) {
        if (!activityTrackingConfig.configurations.callback) {
          activityTrackingConfig.enabled = true;
          activityTrackingConfig.configurations.callback = configureActivityTracking(configuration);
        }
      },
      disableActivityTracking: function disableActivityTracking() {
        disableActivityTrackingAction('pagePing');
      },
      disableActivityTrackingCallback: function disableActivityTrackingCallback() {
        disableActivityTrackingAction('callback');
      },
      updatePageActivity: function updatePageActivity() {
        activityHandler();
      },
      setOptOutCookie: function setOptOutCookie(name) {
        configOptOutCookie = name;
      },
      setUserId: function setUserId(userId) {
        businessUserId = userId;
      },
      setUserIdFromLocation: function setUserIdFromLocation(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, locationHrefAlias);
      },
      setUserIdFromReferrer: function setUserIdFromReferrer(querystringField) {
        refreshUrl();
        businessUserId = fromQuerystring(querystringField, configReferrerUrl);
      },
      setUserIdFromCookie: function setUserIdFromCookie(cookieName) {
        businessUserId = cookieStorage.getCookie(cookieName);
      },
      setCollectorUrl: function setCollectorUrl(collectorUrl) {
        outQueue.setCollectorUrl(asCollectorUrl(collectorUrl));
      },
      setBufferSize: function setBufferSize(newBufferSize) {
        outQueue.setBufferSize(newBufferSize);
      },
      flushBuffer: function flushBuffer(configuration) {
        if (configuration === void 0) {
          configuration = {};
        }
        outQueue.executeQueue();
        if (configuration.newBufferSize) {
          outQueue.setBufferSize(configuration.newBufferSize);
        }
      },
      trackPageView: function trackPageView(event) {
        if (event === void 0) {
          event = {};
        }
        logPageView(event);
      },
      preservePageViewId: function preservePageViewId() {
        _preservePageViewId = true;
      },
      preservePageViewIdForUrl: function preservePageViewIdForUrl(preserve) {
        _preservePageViewIdForUrl = preserve;
      },
      disableAnonymousTracking: function disableAnonymousTracking(configuration) {
        /*
          Flag for if the state storage strategy has changed and we are currently storing session state (anonymously or not).
          Because the strategy changes, the below call to initializeIdsAndCookies will fail to see that a session is currently in progress and start a new one.
          Detect this state, and once we've updated settings, bump the session cookie with the new strategy to ensure it exists before loading the ID cookie, which will resume the session.
        */
        var shouldResumeSession = (configuration === null || configuration === void 0 ? void 0 : configuration.stateStorageStrategy) &&
        // a new strategy was defined (otherwise will already resume)
        configuration.stateStorageStrategy !== configStateStorageStrategy && (
        // new strategy is different to old one (otherwise will already resume)
        !configAnonymousTracking || configAnonymousSessionTracking) &&
        // we were previously tracking session IDs (otherwise nothing to resume)
        getSnowplowCookieValue('ses'); // and we currently have a session in progress (otherwise we want a new session anyway)
        trackerConfiguration.anonymousTracking = false;
        toggleAnonymousTracking(configuration);
        if (shouldResumeSession) setSessionCookie(); // ensure session cookie exists with new strategy
        initializeIdsAndCookies();
        outQueue.executeQueue(); // There might be some events in the queue we've been unable to send in anonymous mode
      },
      enableAnonymousTracking: function enableAnonymousTracking(configuration) {
        var _a;
        trackerConfiguration.anonymousTracking = (_a = configuration && (configuration === null || configuration === void 0 ? void 0 : configuration.options)) !== null && _a !== void 0 ? _a : true;
        toggleAnonymousTracking(configuration);
        // Reset the page view, if not tracking the session, so can't stitch user into new events on the page view id
        if (!configAnonymousSessionTracking) {
          resetPageView();
        }
      },
      clearUserData: clearUserDataAndCookies
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, apiMethods), {
      id: trackerId,
      namespace: namespace,
      core: core,
      sharedState: state
    });
  };
  // Initialise the tracker
  var partialTracker = newTracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration),
    tracker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, partialTracker), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        tracker.core.addPlugin(configuration);
        (_b = (_a = configuration.plugin).activateBrowserPlugin) === null || _b === void 0 ? void 0 : _b.call(_a, tracker);
      }
    });
  // Initialise each plugin with the tracker
  browserPlugins.forEach(function (p) {
    var _a;
    (_a = p.activateBrowserPlugin) === null || _a === void 0 ? void 0 : _a.call(p, tracker);
  });
  return tracker;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var namedTrackers = {};
/**
 * Dispatch function to all specified trackers
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackers(trackers, fn) {
  try {
    getTrackers(trackers !== null && trackers !== void 0 ? trackers : allTrackerNames()).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Dispatch function to all specified trackers from the supplied collection
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param trackerCollection - The collection which the trackers will be selected from
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackersInCollection(trackers, trackerCollection, fn) {
  try {
    getTrackersFromCollection(trackers !== null && trackers !== void 0 ? trackers : Object.keys(trackerCollection), trackerCollection).forEach(fn);
  } catch (ex) {
    __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].error('Function failed', ex);
  }
}
/**
 * Checks if a tracker has been created for a particular identifier
 * @param trackerId - The unique identifier of the tracker
 */
function trackerExists(trackerId) {
  return namedTrackers.hasOwnProperty(trackerId);
}
/**
 * Creates a Tracker and adds it to the internal collection
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker, tracked with each event as `tna`
 * @param version - The current version of the tracker library
 * @param endpoint - The endpoint to send events to
 * @param sharedState - The instance of shared state to use for this tracker
 * @param configuration - The configuration to use for this tracker instance
 */
function addTracker(trackerId, namespace, version, endpoint, sharedState, configuration) {
  if (!namedTrackers.hasOwnProperty(trackerId)) {
    namedTrackers[trackerId] = Tracker(trackerId, namespace, version, endpoint, sharedState, configuration);
    return namedTrackers[trackerId];
  }
  return null;
}
/**
 * Gets a single instance of the internal tracker object
 * @param trackerId - The unique identifier of the tracker
 * @returns The tracker instance, or null if not found
 */
function getTracker(trackerId) {
  if (namedTrackers.hasOwnProperty(trackerId)) {
    return namedTrackers[trackerId];
  }
  __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].warn(trackerId + ' not configured');
  return null;
}
/**
 * Gets an array of tracker instances based on the list of identifiers
 * @param trackerIds - An array of unique identifiers of the trackers
 * @returns The tracker instances, or empty list if none found
 */
function getTrackers(trackerIds) {
  return getTrackersFromCollection(trackerIds, namedTrackers);
}
/**
 * Gets all the trackers as a object, keyed by their unique identifiers
 */
function allTrackers() {
  return namedTrackers;
}
/**
 * Returns all the unique tracker identifiers
 */
function allTrackerNames() {
  return Object.keys(namedTrackers);
}
function getTrackersFromCollection(trackerIds, trackerCollection) {
  var trackers = [];
  for (var _i = 0, trackerIds_1 = trackerIds; _i < trackerIds_1.length; _i++) {
    var id = trackerIds_1[_i];
    if (trackerCollection.hasOwnProperty(id)) {
      trackers.push(trackerCollection[id]);
    } else {
      __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["h" /* LOG */].warn(id + ' not configured');
    }
  }
  return trackers;
}
/**
 * Write all pending cookies to the browser.
 * Useful if you track events just before the page is unloaded.
 * This call is not necessary if `synchronousCookieWrite` is set to `true`.
 */
function flushPendingCookies() {
  asyncCookieStorage.flush();
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Checks whether sessionStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasSessionStorage() {
  try {
    return !!window.sessionStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e) {
    return true; // SecurityError when referencing it means it exists
  }
}
/*
 * Checks whether localStorage is accessible
 * sets and removes an item to handle private IOS5 browsing
 * (http://git.io/jFB2Xw)
 */
function localStorageAccessible() {
  var mod = 'modernizr';
  if (!hasLocalStorage()) {
    return false;
  }
  try {
    var ls = window.localStorage;
    ls.setItem(mod, mod);
    ls.removeItem(mod);
    return true;
  } catch (e) {
    return false;
  }
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * A set of variables which are shared among all initialised trackers
 */
var SharedState = /** @class */function () {
  function SharedState() {
    this.bufferFlushers = [];
    /* DOM Ready */
    this.hasLoaded = false;
    this.registeredOnLoadHandlers = [];
  }
  return SharedState;
}();
function createSharedState() {
  var sharedState = new SharedState(),
    documentAlias = document,
    windowAlias = window;
  /*
   * Handle page visibility event
   * Works everywhere except IE9
   */
  function visibilityChangeHandler() {
    if (documentAlias.visibilityState == 'hidden') {
      // Flush all POST queues
      sharedState.bufferFlushers.forEach(function (flusher) {
        flusher(false);
      });
    }
  }
  function flushBuffers() {
    // Flush all POST queues
    sharedState.bufferFlushers.forEach(function (flusher) {
      flusher(false);
    });
  }
  /*
   * Handler for onload event
   */
  function loadHandler() {
    var i;
    if (!sharedState.hasLoaded) {
      sharedState.hasLoaded = true;
      for (i = 0; i < sharedState.registeredOnLoadHandlers.length; i++) {
        sharedState.registeredOnLoadHandlers[i]();
      }
    }
    return true;
  }
  /*
   * Add onload or DOM ready handler
   */
  function addReadyListener() {
    if (documentAlias.addEventListener) {
      documentAlias.addEventListener('DOMContentLoaded', function ready() {
        documentAlias.removeEventListener('DOMContentLoaded', ready, false);
        loadHandler();
      });
    } else if (documentAlias.attachEvent) {
      documentAlias.attachEvent('onreadystatechange', function ready() {
        if (documentAlias.readyState === 'complete') {
          documentAlias.detachEvent('onreadystatechange', ready);
          loadHandler();
        }
      });
    }
    // fallback
    addEventListener(windowAlias, 'load', loadHandler, false);
  }
  /************************************************************
   * Constructor
   ************************************************************/
  // initialize the Snowplow singleton
  if (documentAlias.visibilityState) {
    // Flush for mobile and modern browsers
    addEventListener(documentAlias, 'visibilitychange', visibilityChangeHandler, false);
  }
  // Last attempt at flushing in beforeunload
  addEventListener(windowAlias, 'beforeunload', flushBuffers, false);
  if (document.readyState === 'loading') {
    addReadyListener();
  } else {
    loadHandler();
  }
  return sharedState;
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOG; });
/* unused harmony export LOG_LEVEL */
/* unused harmony export buildAdClick */
/* unused harmony export buildAdConversion */
/* unused harmony export buildAdImpression */
/* unused harmony export buildAddToCart */
/* unused harmony export buildConsentGranted */
/* unused harmony export buildConsentWithdrawn */
/* unused harmony export buildEcommerceTransaction */
/* unused harmony export buildEcommerceTransactionItem */
/* unused harmony export buildFormFocusOrChange */
/* unused harmony export buildFormSubmission */
/* unused harmony export buildLinkClick */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return buildPagePing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildPageView; });
/* unused harmony export buildRemoveFromCart */
/* unused harmony export buildScreenView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return buildSelfDescribingEvent; });
/* unused harmony export buildSiteSearch */
/* unused harmony export buildSocialInteraction */
/* unused harmony export buildStructEvent */
/* unused harmony export getRuleParts */
/* unused harmony export getSchemaParts */
/* unused harmony export globalContexts */
/* unused harmony export isConditionalContextProvider */
/* unused harmony export isContextCallbackFunction */
/* unused harmony export isContextPrimitive */
/* unused harmony export isFilterProvider */
/* unused harmony export isJson */
/* unused harmony export isNonEmptyJson */
/* unused harmony export isRuleSet */
/* unused harmony export isRuleSetProvider */
/* unused harmony export isSelfDescribingJson */
/* unused harmony export isStringArray */
/* unused harmony export isValidRule */
/* unused harmony export isValidRuleSetArg */
/* unused harmony export matchSchemaAgainstRule */
/* unused harmony export matchSchemaAgainstRuleSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newEmitter; });
/* unused harmony export newEventStorePayload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newInMemoryEventStore; });
/* unused harmony export payloadBuilder */
/* unused harmony export payloadJsonProcessor */
/* unused harmony export pluginContexts */
/* unused harmony export removeEmptyProperties */
/* unused harmony export resolveDynamicContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackerCore; });
/* unused harmony export validateVendor */
/* unused harmony export validateVendorParts */
/* unused harmony export version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * Core functionality for Snowplow JavaScript trackers v4.5.0 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */



var version$1 = "4.5.0";

/*
 * Copyright (c) 2013 Kevin van Zonneveld (http://kvz.io)
 * and Contributors (http://phpjs.org/authors)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/**
 * Decodes a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to decode
 * @returns The decoded string
 */
function base64urldecode(data) {
  if (!data) {
    return data;
  }
  var padding = 4 - data.length % 4;
  switch (padding) {
    case 2:
      data += '==';
      break;
    case 3:
      data += '=';
      break;
  }
  var b64Data = data.replace(/-/g, '+').replace(/_/g, '/');
  return base64decode(b64Data);
}
/**
 * Encodes a string into a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to encode
 * @returns The url safe Base 64 string
 */
function base64urlencode(data) {
  if (!data) {
    return data;
  }
  var enc = base64encode(data);
  return enc.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encode string as base64.
 * Any type can be passed, but will be stringified
 *
 * @param data - string to encode
 * @returns base64-encoded string
 */
function base64encode(data) {
  // discuss at: http://phpjs.org/functions/base64_encode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Bayron Guevara
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Rafał Kukawski (http://kukawski.pl)
  // bugfixed by: Pellentesque Malesuada
  // example 1: base64_encode('Kevin van Zonneveld');
  // returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
  // example 2: base64_encode('a');
  // returns 2: 'YQ=='
  // example 3: base64_encode('✓ à la mode');
  // returns 3: '4pyTIMOgIGxhIG1vZGU='
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0;
  var tmp_arr = [];
  if (!data) {
    return data;
  }
  data = unescape(encodeURIComponent(data));
  do {
    // pack three octets into four hexets
    o1 = data.charCodeAt(i++);
    o2 = data.charCodeAt(i++);
    o3 = data.charCodeAt(i++);
    bits = o1 << 16 | o2 << 8 | o3;
    h1 = bits >> 18 & 0x3f;
    h2 = bits >> 12 & 0x3f;
    h3 = bits >> 6 & 0x3f;
    h4 = bits & 0x3f;
    // use hexets to index into b64, and append result to encoded string
    tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
  } while (i < data.length);
  var enc = tmp_arr.join('');
  var r = data.length % 3;
  return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}
/**
 * Decode base64 to string
 *
 * @param data - base64 to string
 * @returns decoded string
 */
function base64decode(encodedData) {
  //  discuss at: http://locutus.io/php/base64_decode/
  // original by: Tyler Akins (http://rumkin.com)
  // improved by: Thunder.m
  // improved by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Kevin van Zonneveld (http://kvz.io)
  //    input by: Aman Gupta
  //    input by: Brett Zamir (http://brett-zamir.me)
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  // bugfixed by: Pellentesque Malesuada
  // bugfixed by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Indigo744
  //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==')
  //   returns 1: 'Kevin van Zonneveld'
  //   example 2: base64_decode('YQ==')
  //   returns 2: 'a'
  //   example 3: base64_decode('4pyTIMOgIGxhIG1vZGU=')
  //   returns 3: '✓ à la mode'
  // decodeUTF8string()
  // Internal function to decode properly UTF8 string
  // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
  var decodeUTF8string = function decodeUTF8string(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  };
  var o1,
    o2,
    o3,
    h1,
    h2,
    h3,
    h4,
    bits,
    i = 0,
    ac = 0,
    dec = '';
  var tmpArr = [];
  if (!encodedData) {
    return encodedData;
  }
  encodedData += '';
  do {
    // unpack four hexets into three octets using index points in b64
    h1 = b64.indexOf(encodedData.charAt(i++));
    h2 = b64.indexOf(encodedData.charAt(i++));
    h3 = b64.indexOf(encodedData.charAt(i++));
    h4 = b64.indexOf(encodedData.charAt(i++));
    bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
    o1 = bits >> 16 & 0xff;
    o2 = bits >> 8 & 0xff;
    o3 = bits & 0xff;
    if (h3 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1);
    } else if (h4 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1, o2);
    } else {
      tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
    }
  } while (i < encodedData.length);
  dec = tmpArr.join('');
  return decodeUTF8string(dec.replace(/\0+$/, ''));
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
function payloadBuilder() {
  var dict = {},
    allJson = [],
    jsonForProcessing = [],
    contextEntitiesForProcessing = [];
  var processor;
  var add = function add(key, value) {
    if (value != null && value !== '') {
      // null also checks undefined
      dict[key] = value;
    }
  };
  var addDict = function addDict(dict) {
    for (var key in dict) {
      if (Object.prototype.hasOwnProperty.call(dict, key)) {
        add(key, dict[key]);
      }
    }
  };
  var addJson = function addJson(keyIfEncoded, keyIfNotEncoded, json) {
    if (json && isNonEmptyJson(json)) {
      var jsonWithKeys = {
        keyIfEncoded: keyIfEncoded,
        keyIfNotEncoded: keyIfNotEncoded,
        json: json
      };
      jsonForProcessing.push(jsonWithKeys);
      allJson.push(jsonWithKeys);
    }
  };
  var addContextEntity = function addContextEntity(entity) {
    contextEntitiesForProcessing.push(entity);
  };
  return {
    add: add,
    addDict: addDict,
    addJson: addJson,
    addContextEntity: addContextEntity,
    getPayload: function getPayload() {
      return dict;
    },
    getJson: function getJson() {
      return allJson;
    },
    withJsonProcessor: function withJsonProcessor(jsonProcessor) {
      processor = jsonProcessor;
    },
    build: function build() {
      processor === null || processor === void 0 ? void 0 : processor(this, jsonForProcessing, contextEntitiesForProcessing);
      return dict;
    }
  };
}
/**
 * A helper to build a Snowplow request from a set of name-value pairs, provided using the add methods.
 * Will base64 encode JSON, if desired, on build
 *
 * @returns The request builder, with add and build methods
 */
function payloadJsonProcessor(encodeBase64) {
  return function (payloadBuilder, jsonForProcessing, contextEntitiesForProcessing) {
    var add = function add(json, keyIfEncoded, keyIfNotEncoded) {
      var str = JSON.stringify(json);
      if (encodeBase64) {
        payloadBuilder.add(keyIfEncoded, base64urlencode(str));
      } else {
        payloadBuilder.add(keyIfNotEncoded, str);
      }
    };
    var getContextFromPayload = function getContextFromPayload() {
      var payload = payloadBuilder.getPayload();
      if (encodeBase64 ? payload.cx : payload.co) {
        return JSON.parse(encodeBase64 ? base64urldecode(payload.cx) : payload.co);
      }
      return undefined;
    };
    var combineContexts = function combineContexts(originalContext, newContext) {
      var context = originalContext || getContextFromPayload();
      if (context) {
        context.data = context.data.concat(newContext.data);
      } else {
        context = newContext;
      }
      return context;
    };
    var context = undefined;
    for (var _i = 0, jsonForProcessing_1 = jsonForProcessing; _i < jsonForProcessing_1.length; _i++) {
      var json = jsonForProcessing_1[_i];
      if (json.keyIfEncoded === 'cx') {
        context = combineContexts(context, json.json);
      } else {
        add(json.json, json.keyIfEncoded, json.keyIfNotEncoded);
      }
    }
    jsonForProcessing.length = 0;
    if (contextEntitiesForProcessing.length) {
      var newContext = {
        schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], contextEntitiesForProcessing, true)
      };
      context = combineContexts(context, newContext);
      contextEntitiesForProcessing.length = 0;
    }
    if (context) {
      add(context, 'cx', 'co');
    }
  };
}
/**
 * Is property a non-empty JSON?
 * @param property - Checks if object is non-empty json
 */
function isNonEmptyJson(property) {
  if (!isJson(property)) {
    return false;
  }
  for (var key in property) {
    if (Object.prototype.hasOwnProperty.call(property, key)) {
      return true;
    }
  }
  return false;
}
/**
 * Is property a JSON?
 * @param property - Checks if object is json
 */
function isJson(property) {
  return typeof property !== 'undefined' && property !== null && (property.constructor === {}.constructor || property.constructor === [].constructor);
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var label = 'Snowplow: ';
var LOG_LEVEL;
(function (LOG_LEVEL) {
  LOG_LEVEL[LOG_LEVEL["none"] = 0] = "none";
  LOG_LEVEL[LOG_LEVEL["error"] = 1] = "error";
  LOG_LEVEL[LOG_LEVEL["warn"] = 2] = "warn";
  LOG_LEVEL[LOG_LEVEL["debug"] = 3] = "debug";
  LOG_LEVEL[LOG_LEVEL["info"] = 4] = "info";
})(LOG_LEVEL || (LOG_LEVEL = {}));
var LOG = logger();
function logger(logLevel) {
  if (logLevel === void 0) {
    logLevel = LOG_LEVEL.warn;
  }
  function setLogLevel(level) {
    if (LOG_LEVEL[level]) {
      logLevel = level;
    } else {
      logLevel = LOG_LEVEL.warn;
    }
  }
  /**
   * Log errors, with or without error object
   */
  function error(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.error && typeof console !== 'undefined') {
      var logMsg = label + message + '\n';
      if (error) {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.error.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log warnings, with or without error object
   */
  function warn(message, error) {
    var extraParams = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      extraParams[_i - 2] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.warn && typeof console !== 'undefined') {
      var logMsg = label + message;
      if (error) {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg + '\n', error], extraParams, false));
      } else {
        console.warn.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([logMsg], extraParams, false));
      }
    }
  }
  /**
   * Log debug messages
   */
  function debug(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.debug && typeof console !== 'undefined') {
      console.debug.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  /**
   * Log info messages
   */
  function info(message) {
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      extraParams[_i - 1] = arguments[_i];
    }
    if (logLevel >= LOG_LEVEL.info && typeof console !== 'undefined') {
      console.info.apply(console, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([label + message], extraParams, false));
    }
  }
  return {
    setLogLevel: setLogLevel,
    warn: warn,
    error: error,
    debug: debug,
    info: info
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Contains helper functions to aid in the addition and removal of Global Contexts
 */
function globalContexts() {
  var globalPrimitives = [];
  var conditionalProviders = [];
  var namedPrimitives = {};
  var namedConditionalProviders = {};
  /**
   * Returns all applicable global contexts for a specified event
   * @param event - The event to check for applicable global contexts for
   * @returns An array of contexts
   */
  var assembleAllContexts = function assembleAllContexts(event) {
    var eventSchema = getUsefulSchema(event);
    var eventType = getEventType(event);
    var contexts = [];
    var generatedPrimitives = generatePrimitives(globalPrimitives.concat(Object.values(namedPrimitives)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedPrimitives);
    var generatedConditionals = generateConditionals(conditionalProviders.concat(Object.values(namedConditionalProviders)), event, eventType, eventSchema);
    contexts.push.apply(contexts, generatedConditionals);
    return contexts;
  };
  return {
    getGlobalPrimitives: function getGlobalPrimitives() {
      return globalPrimitives.concat(Object.values(namedPrimitives));
    },
    getConditionalProviders: function getConditionalProviders() {
      return conditionalProviders.concat(Object.values(namedConditionalProviders));
    },
    addGlobalContexts: function addGlobalContexts(contexts) {
      if (Array.isArray(contexts)) {
        var acceptedConditionalContexts = [];
        var acceptedContextPrimitives = [];
        for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
          var context = contexts_1[_i];
          if (isConditionalContextProvider(context)) {
            acceptedConditionalContexts.push(context);
          } else if (isContextPrimitive(context)) {
            acceptedContextPrimitives.push(context);
          }
        }
        globalPrimitives = globalPrimitives.concat(acceptedContextPrimitives);
        conditionalProviders = conditionalProviders.concat(acceptedConditionalContexts);
      } else {
        for (var _a = 0, _b = Object.entries(contexts); _a < _b.length; _a++) {
          var _c = _b[_a],
            name_1 = _c[0],
            context = _c[1];
          if (isConditionalContextProvider(context)) {
            namedConditionalProviders[name_1] = context;
          } else if (isContextPrimitive(context)) {
            namedPrimitives[name_1] = context;
          }
        }
      }
    },
    clearGlobalContexts: function clearGlobalContexts() {
      conditionalProviders = [];
      globalPrimitives = [];
      namedConditionalProviders = {};
      namedPrimitives = {};
    },
    removeGlobalContexts: function removeGlobalContexts(contexts) {
      var _loop_1 = function _loop_1(context) {
        if (typeof context === 'string') {
          delete namedConditionalProviders[context];
          delete namedPrimitives[context];
        } else if (isConditionalContextProvider(context)) {
          conditionalProviders = conditionalProviders.filter(function (item) {
            return !compareProvider(context, item);
          });
        } else if (isContextPrimitive(context)) {
          globalPrimitives = globalPrimitives.filter(function (item) {
            return !compareProvider(context, item);
          });
        }
      };
      for (var _i = 0, contexts_2 = contexts; _i < contexts_2.length; _i++) {
        var context = contexts_2[_i];
        _loop_1(context);
      }
    },
    getApplicableContexts: function getApplicableContexts(event) {
      return assembleAllContexts(event);
    }
  };
}
function pluginContexts(plugins) {
  /**
   * Add common contexts to every event
   *
   * @param array - additionalContexts List of user-defined contexts
   * @returns userContexts combined with commonContexts
   */
  return {
    addPluginContexts: function addPluginContexts(additionalContexts) {
      var combinedContexts = additionalContexts ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], additionalContexts, true) : [];
      plugins.forEach(function (plugin) {
        try {
          if (plugin.contexts) {
            combinedContexts.push.apply(combinedContexts, plugin.contexts());
          }
        } catch (ex) {
          LOG.error('Error adding plugin contexts', ex);
        }
      });
      return combinedContexts;
    }
  };
}
/**
 * Find dynamic context generating functions and return their results to be merged into the static contexts
 * Combine an array of unchanging contexts with the result of a context-creating function
 *
 * @param dynamicOrStaticContexts - Array of custom context Objects or custom context generating functions
 * @param Parameters - to pass to dynamic context callbacks
 * @returns An array of Self Describing JSON context
 */
function resolveDynamicContext(dynamicOrStaticContexts) {
  var _a;
  var extraParams = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    extraParams[_i - 1] = arguments[_i];
  }
  return (_a = dynamicOrStaticContexts === null || dynamicOrStaticContexts === void 0 ? void 0 : dynamicOrStaticContexts.map(function (context) {
    if (typeof context === 'function') {
      try {
        return context.apply(void 0, extraParams);
      } catch (e) {
        //TODO: provide warning
        return undefined;
      }
    } else {
      return context;
    }
  }).filter(Boolean)) !== null && _a !== void 0 ? _a : [];
}
/**
 * Slices a schema into its composite parts. Useful for ruleset filtering.
 * @param input - A schema string
 * @returns The vendor, schema name, major, minor and patch information of a schema string
 */
function getSchemaParts(input) {
  var re = new RegExp('^iglu:([a-zA-Z0-9-_.]+)/([a-zA-Z0-9-_]+)/jsonschema/([1-9][0-9]*)-(0|[1-9][0-9]*)-(0|[1-9][0-9]*)$');
  var matches = re.exec(input);
  if (matches !== null) return matches.slice(1, 6);
  return undefined;
}
/**
 * Validates the vendor section of a schema string contains allowed wildcard values
 * @param parts - Array of parts from a schema string
 * @returns Whether the vendor validation parts are a valid combination
 */
function validateVendorParts(parts) {
  if (parts[0] === '*' || parts[1] === '*') {
    return false; // no wildcard in first or second part
  }
  if (parts.slice(2).length > 0) {
    var asterisk = false;
    for (var _i = 0, _a = parts.slice(2); _i < _a.length; _i++) {
      var part = _a[_i];
      if (part === '*')
        // mark when we've found a wildcard
        asterisk = true;else if (asterisk)
        // invalid if alpha parts come after wildcard
        return false;
    }
    return true;
  } else if (parts.length == 2) return true;
  return false;
}
/**
 * Validates the vendor part of a schema string is valid for a rule set
 * @param input - Vendor part of a schema string
 * @returns Whether the vendor validation string is valid
 */
function validateVendor(input) {
  var parts = input.split('.');
  if (parts && parts.length > 1) return validateVendorParts(parts);
  return false;
}
/**
 * Checks for validity of input and returns all the sections of a schema string that are used to match rules in a ruleset
 * @param input - A Schema string
 * @returns The sections of a schema string that are used to match rules in a ruleset
 */
function getRuleParts(input) {
  var re = new RegExp('^iglu:((?:(?:[a-zA-Z0-9-_]+|\\*).)+(?:[a-zA-Z0-9-_]+|\\*))/([a-zA-Z0-9-_.]+|\\*)/jsonschema/([1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)$');
  var matches = re.exec(input);
  if (matches !== null && validateVendor(matches[1])) return matches.slice(1, 6);
  return undefined;
}
/**
 * Ensures the rules specified in a schema string of a ruleset are valid
 * @param input - A Schema string
 * @returns if there rule is valid
 */
function isValidRule(input) {
  var ruleParts = getRuleParts(input);
  if (ruleParts) {
    var vendor = ruleParts[0];
    return ruleParts.length === 5 && validateVendor(vendor);
  }
  return false;
}
/**
 * Check if a variable is an Array containing only strings
 * @param input - The variable to validate
 * @returns True if the input is an array containing only strings
 */
function isStringArray(input) {
  return Array.isArray(input) && input.every(function (x) {
    return typeof x === 'string';
  });
}
/**
 * Validates whether a rule set is an array of valid ruleset strings
 * @param input - The Array of rule set arguments
 * @returns True is the input is an array of valid rules
 */
function isValidRuleSetArg(input) {
  if (isStringArray(input)) return input.every(function (x) {
    return isValidRule(x);
  });else if (typeof input === 'string') return isValidRule(input);
  return false;
}
/**
 * Check if a variable is a valid, non-empty Self Describing JSON
 * @param input - The variable to validate
 * @returns True if a valid Self Describing JSON
 */
function isSelfDescribingJson(input) {
  var sdj = input;
  if (isNonEmptyJson(sdj)) if ('schema' in sdj && 'data' in sdj) return typeof sdj.schema === 'string' && _typeof(sdj.data) === 'object';
  return false;
}
/**
 * Validates if the input object contains the expected properties of a ruleset
 * @param input - The object containing a rule set
 * @returns True if a valid rule set
 */
function isRuleSet(input) {
  var ruleSet = input;
  var ruleCount = 0;
  if (input != null && _typeof(input) === 'object' && !Array.isArray(input)) {
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'accept')) {
      if (isValidRuleSetArg(ruleSet['accept'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    if (Object.prototype.hasOwnProperty.call(ruleSet, 'reject')) {
      if (isValidRuleSetArg(ruleSet['reject'])) {
        ruleCount += 1;
      } else {
        return false;
      }
    }
    // if either 'reject' or 'accept' or both exists,
    // we have a valid ruleset
    return ruleCount > 0 && ruleCount <= 2;
  }
  return false;
}
/**
 * Validates if the function can be a valid context generator function
 * @param input - The function to be validated
 */
function isContextCallbackFunction(input) {
  return typeof input === 'function' && input.length <= 1;
}
/**
 * Validates if the function can be a valid context primitive function or self describing json
 * @param input - The function or orbject to be validated
 * @returns True if either a Context Generator or Self Describing JSON
 */
function isContextPrimitive(input) {
  return isContextCallbackFunction(input) || isSelfDescribingJson(input);
}
/**
 * Validates if an array is a valid shape to be a Filter Provider
 * @param input - The Array of Context filter callbacks
 */
function isFilterProvider(input) {
  if (Array.isArray(input)) {
    if (input.length === 2) {
      if (Array.isArray(input[1])) {
        return isContextCallbackFunction(input[0]) && input[1].every(isContextPrimitive);
      }
      return isContextCallbackFunction(input[0]) && isContextPrimitive(input[1]);
    }
  }
  return false;
}
/**
 * Validates if an array is a valid shape to be an array of rule sets
 * @param input - The Array of Rule Sets
 */
function isRuleSetProvider(input) {
  if (Array.isArray(input) && input.length === 2) {
    if (!isRuleSet(input[0])) return false;
    if (Array.isArray(input[1])) return input[1].every(isContextPrimitive);
    return isContextPrimitive(input[1]);
  }
  return false;
}
/**
 * Checks if an input array is either a filter provider or a rule set provider
 * @param input - An array of filter providers or rule set providers
 * @returns Whether the array is a valid {@link ConditionalContextProvider}
 */
function isConditionalContextProvider(input) {
  return isFilterProvider(input) || isRuleSetProvider(input);
}
/**
 * Checks if a given schema matches any rules within the provided rule set
 * @param ruleSet - The rule set containing rules to match schema against
 * @param schema - The schema to be matched against the rule set
 */
function matchSchemaAgainstRuleSet(ruleSet, schema) {
  var rejectCount = 0;
  var acceptCount = 0;
  var acceptRules = ruleSet['accept'];
  if (Array.isArray(acceptRules)) {
    if (ruleSet.accept.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      acceptCount++;
    }
  } else if (typeof acceptRules === 'string') {
    if (matchSchemaAgainstRule(acceptRules, schema)) {
      acceptCount++;
    }
  }
  var rejectRules = ruleSet['reject'];
  if (Array.isArray(rejectRules)) {
    if (ruleSet.reject.some(function (rule) {
      return matchSchemaAgainstRule(rule, schema);
    })) {
      rejectCount++;
    }
  } else if (typeof rejectRules === 'string') {
    if (matchSchemaAgainstRule(rejectRules, schema)) {
      rejectCount++;
    }
  }
  if (acceptCount > 0 && rejectCount === 0) {
    return true;
  } else if (acceptCount === 0 && rejectCount > 0) {
    return false;
  }
  return false;
}
/**
 * Checks if a given schema matches a specific rule from a rule set
 * @param rule - The rule to match schema against
 * @param schema - The schema to be matched against the rule
 */
function matchSchemaAgainstRule(rule, schema) {
  if (!isValidRule(rule)) return false;
  var ruleParts = getRuleParts(rule);
  var schemaParts = getSchemaParts(schema);
  if (ruleParts && schemaParts) {
    if (!matchVendor(ruleParts[0], schemaParts[0])) return false;
    for (var i = 1; i < 5; i++) {
      if (!matchPart(ruleParts[i], schemaParts[i])) return false;
    }
    return true; // if it hasn't failed, it passes
  }
  return false;
}
function matchVendor(rule, vendor) {
  // rule and vendor must have same number of elements
  var vendorParts = vendor.split('.');
  var ruleParts = rule.split('.');
  if (vendorParts && ruleParts) {
    if (vendorParts.length !== ruleParts.length) return false;
    for (var i = 0; i < ruleParts.length; i++) {
      if (!matchPart(vendorParts[i], ruleParts[i])) return false;
    }
    return true;
  }
  return false;
}
function matchPart(rule, schema) {
  // parts should be the string nested between slashes in the URI: /example/
  return rule && schema && rule === '*' || rule === schema;
}
// Returns the "useful" schema, i.e. what would someone want to use to identify events.
// For some events this is the 'e' property but for unstructured events, this is the
// 'schema' from the 'ue_px' field.
function getUsefulSchema(sb) {
  var eventJson = sb.getJson();
  for (var _i = 0, eventJson_1 = eventJson; _i < eventJson_1.length; _i++) {
    var json = eventJson_1[_i];
    if (json.keyIfEncoded === 'ue_px' && _typeof(json.json['data']) === 'object') {
      var schema = json.json['data']['schema'];
      if (typeof schema == 'string') {
        return schema;
      }
    }
  }
  return '';
}
function getEventType(payloadBuilder) {
  var eventType = payloadBuilder.getPayload()['e'];
  return typeof eventType === 'string' ? eventType : '';
}
function buildGenerator(generator, event, eventType, eventSchema) {
  var contextGeneratorResult = undefined;
  try {
    // try to evaluate context generator
    var args = {
      event: event.getPayload(),
      eventType: eventType,
      eventSchema: eventSchema
    };
    contextGeneratorResult = generator(args);
    // determine if the produced result is a valid SDJ
    if (Array.isArray(contextGeneratorResult) && contextGeneratorResult.every(isSelfDescribingJson)) {
      return contextGeneratorResult;
    } else if (isSelfDescribingJson(contextGeneratorResult)) {
      return contextGeneratorResult;
    } else {
      return undefined;
    }
  } catch (error) {
    contextGeneratorResult = undefined;
  }
  return contextGeneratorResult;
}
function normalizeToArray(input) {
  if (Array.isArray(input)) {
    return input;
  }
  return Array.of(input);
}
function generatePrimitives(contextPrimitives, event, eventType, eventSchema) {
  var _a;
  var normalizedInputs = normalizeToArray(contextPrimitives);
  var partialEvaluate = function partialEvaluate(primitive) {
    var result = evaluatePrimitive(primitive, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInputs.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}
function evaluatePrimitive(contextPrimitive, event, eventType, eventSchema) {
  if (isSelfDescribingJson(contextPrimitive)) {
    return [contextPrimitive];
  } else if (isContextCallbackFunction(contextPrimitive)) {
    var generatorOutput = buildGenerator(contextPrimitive, event, eventType, eventSchema);
    if (isSelfDescribingJson(generatorOutput)) {
      return [generatorOutput];
    } else if (Array.isArray(generatorOutput)) {
      return generatorOutput;
    }
  }
  return undefined;
}
function evaluateProvider(provider, event, eventType, eventSchema) {
  if (isFilterProvider(provider)) {
    var filter = provider[0];
    var filterResult = false;
    try {
      var args = {
        event: event.getPayload(),
        eventType: eventType,
        eventSchema: eventSchema
      };
      filterResult = filter(args);
    } catch (error) {
      filterResult = false;
    }
    if (filterResult === true) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  } else if (isRuleSetProvider(provider)) {
    if (matchSchemaAgainstRuleSet(provider[0], eventSchema)) {
      return generatePrimitives(provider[1], event, eventType, eventSchema);
    }
  }
  return [];
}
function compareProviderPart(a, b) {
  if (typeof a === 'function') return a === b;
  return JSON.stringify(a) === JSON.stringify(b);
}
function compareProvider(a, b) {
  if (isConditionalContextProvider(a)) {
    if (!isConditionalContextProvider(b)) return false;
    var ruleA = a[0],
      primitivesA = a[1];
    var ruleB = b[0],
      primitivesB_1 = b[1];
    if (!compareProviderPart(ruleA, ruleB)) return false;
    if (Array.isArray(primitivesA)) {
      if (!Array.isArray(primitivesB_1)) return false;
      if (primitivesA.length !== primitivesB_1.length) return false;
      return primitivesA.reduce(function (matches, a, i) {
        return matches && compareProviderPart(a, primitivesB_1[i]);
      }, true);
    } else {
      if (Array.isArray(primitivesB_1)) return false;
      return compareProviderPart(primitivesA, primitivesB_1);
    }
  } else if (isContextPrimitive(a)) {
    if (!isContextPrimitive(b)) return false;
    return compareProviderPart(a, b);
  }
  return false;
}
function generateConditionals(providers, event, eventType, eventSchema) {
  var _a;
  var normalizedInput = normalizeToArray(providers);
  var partialEvaluate = function partialEvaluate(provider) {
    var result = evaluateProvider(provider, event, eventType, eventSchema);
    if (result && result.length !== 0) {
      return result;
    }
    return undefined;
  };
  var generatedContexts = normalizedInput.map(partialEvaluate);
  return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) {
    return c != null && c.filter(Boolean);
  }));
}

/**
 * Create a new EventStorePayload
 */
function newEventStorePayload(_a) {
  var payload = _a.payload,
    _b = _a.svrAnon,
    svrAnon = _b === void 0 ? false : _b;
  return {
    payload: payload,
    svrAnon: svrAnon
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Transform optional/old-behavior number timestamp into`Timestamp` ADT
 *
 * @param timestamp - optional number or timestamp object
 * @returns correct timestamp object
 */
function getTimestamp(timestamp) {
  if (timestamp == null) {
    return {
      type: 'dtm',
      value: new Date().getTime()
    };
  } else if (typeof timestamp === 'number') {
    return {
      type: 'dtm',
      value: timestamp
    };
  } else if (timestamp.type === 'ttm') {
    // We can return timestamp here, but this is safer fallback
    return {
      type: 'ttm',
      value: timestamp.value
    };
  } else {
    return {
      type: 'dtm',
      value: timestamp.value || new Date().getTime()
    };
  }
}
/**
 * Create a tracker core object
 *
 * @param base64 - Whether to base 64 encode contexts and self describing event JSONs
 * @param corePlugins - The core plugins to be processed with each event
 * @param callback - Function applied to every payload dictionary object
 * @returns Tracker core
 */
function trackerCore(configuration) {
  if (configuration === void 0) {
    configuration = {};
  }
  function newCore(base64, corePlugins, callback) {
    var pluginContextsHelper = pluginContexts(corePlugins),
      globalContextsHelper = globalContexts();
    var encodeBase64 = base64,
      payloadPairs = {}; // Dictionary of key-value pairs which get added to every payload, e.g. tracker version
    /**
     * Wraps an array of custom contexts in a self-describing JSON
     *
     * @param contexts - Array of custom context self-describing JSONs
     * @returns Outer JSON
     */
    function completeContexts(contexts) {
      if (contexts && contexts.length) {
        return {
          schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
          data: contexts
        };
      }
      return undefined;
    }
    /**
     * Adds all global contexts to a contexts array
     *
     * @param pb - PayloadData
     * @param contexts - Custom contexts relating to the event
     */
    function attachGlobalContexts(pb, contexts) {
      var applicableContexts = globalContextsHelper.getApplicableContexts(pb);
      var returnedContexts = [];
      if (contexts && contexts.length) {
        returnedContexts.push.apply(returnedContexts, contexts);
      }
      if (applicableContexts && applicableContexts.length) {
        returnedContexts.push.apply(returnedContexts, applicableContexts);
      }
      return returnedContexts;
    }
    /**
     * Gets called by every trackXXX method
     * Adds context and payloadPairs name-value pairs to the payload
     * Applies the callback to the built payload
     *
     * @param pb - Payload
     * @param context - Custom contexts relating to the event
     * @param timestamp - Timestamp of the event
     * @returns Payload after the callback is applied or undefined if the event is skipped
     */
    function track(pb, context, timestamp) {
      if (!active) {
        LOG.error('Track called on deactivated tracker');
        return undefined;
      }
      pb.withJsonProcessor(payloadJsonProcessor(encodeBase64));
      pb.add('eid', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_uuid__["a" /* v4 */])());
      pb.addDict(payloadPairs);
      var tstamp = getTimestamp(timestamp);
      pb.add(tstamp.type, tstamp.value.toString());
      var allContexts = attachGlobalContexts(pb, pluginContextsHelper.addPluginContexts(context));
      var wrappedContexts = completeContexts(allContexts);
      if (wrappedContexts !== undefined) {
        pb.addJson('cx', 'co', wrappedContexts);
      }
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.beforeTrack) {
            plugin.beforeTrack(pb);
          }
        } catch (ex) {
          LOG.error('Plugin beforeTrack', ex);
        }
      });
      // Call the filter on plugins to determine if the event should be tracked
      var skip = corePlugins.find(function (plugin) {
        try {
          return plugin.filter && plugin.filter(pb.build()) === false;
        } catch (ex) {
          LOG.error('Plugin filter', ex);
          return false;
        }
      });
      if (skip) {
        return undefined;
      }
      if (typeof callback === 'function') {
        callback(pb);
      }
      var finalPayload = pb.build();
      corePlugins.forEach(function (plugin) {
        try {
          if (plugin.afterTrack) {
            plugin.afterTrack(finalPayload);
          }
        } catch (ex) {
          LOG.error('Plugin afterTrack', ex);
        }
      });
      return finalPayload;
    }
    /**
     * Set a persistent key-value pair to be added to every payload
     *
     * @param key - Field name
     * @param value - Field value
     */
    function addPayloadPair(key, value) {
      payloadPairs[key] = value;
    }
    var core = {
      track: track,
      addPayloadPair: addPayloadPair,
      getBase64Encoding: function getBase64Encoding() {
        return encodeBase64;
      },
      setBase64Encoding: function setBase64Encoding(encode) {
        encodeBase64 = encode;
      },
      addPayloadDict: function addPayloadDict(dict) {
        for (var key in dict) {
          if (Object.prototype.hasOwnProperty.call(dict, key)) {
            payloadPairs[key] = dict[key];
          }
        }
      },
      resetPayloadPairs: function resetPayloadPairs(dict) {
        payloadPairs = isJson(dict) ? dict : {};
      },
      setTrackerVersion: function setTrackerVersion(version) {
        addPayloadPair('tv', version);
      },
      setTrackerNamespace: function setTrackerNamespace(name) {
        addPayloadPair('tna', name);
      },
      setAppId: function setAppId(appId) {
        addPayloadPair('aid', appId);
      },
      setPlatform: function setPlatform(value) {
        addPayloadPair('p', value);
      },
      setUserId: function setUserId(userId) {
        addPayloadPair('uid', userId);
      },
      setScreenResolution: function setScreenResolution(width, height) {
        addPayloadPair('res', width + 'x' + height);
      },
      setViewport: function setViewport(width, height) {
        addPayloadPair('vp', width + 'x' + height);
      },
      setColorDepth: function setColorDepth(depth) {
        addPayloadPair('cd', depth);
      },
      setTimezone: function setTimezone(timezone) {
        addPayloadPair('tz', timezone);
      },
      setLang: function setLang(lang) {
        addPayloadPair('lang', lang);
      },
      setIpAddress: function setIpAddress(ip) {
        addPayloadPair('ip', ip);
      },
      setUseragent: function setUseragent(useragent) {
        addPayloadPair('ua', useragent);
      },
      addGlobalContexts: function addGlobalContexts(contexts) {
        globalContextsHelper.addGlobalContexts(contexts);
      },
      clearGlobalContexts: function clearGlobalContexts() {
        globalContextsHelper.clearGlobalContexts();
      },
      removeGlobalContexts: function removeGlobalContexts(contexts) {
        globalContextsHelper.removeGlobalContexts(contexts);
      }
    };
    return core;
  }
  var active = true;
  var base64 = configuration.base64,
    corePlugins = configuration.corePlugins,
    callback = configuration.callback,
    plugins = corePlugins !== null && corePlugins !== void 0 ? corePlugins : [],
    partialCore = newCore(base64 !== null && base64 !== void 0 ? base64 : true, plugins, callback),
    core = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, partialCore), {
      addPlugin: function addPlugin(configuration) {
        var _a, _b;
        var plugin = configuration.plugin;
        plugins.push(plugin);
        (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
        (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
      },
      deactivate: function deactivate() {
        plugins.forEach(function (plugin) {
          var _a;
          (_a = plugin.deactivatePlugin) === null || _a === void 0 ? void 0 : _a.call(plugin, core);
        });
        plugins.length = 0;
        active = false;
      }
    });
  plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
    var _a, _b;
    (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, LOG);
    (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
  });
  return core;
}
/**
 * Build a self-describing event
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - Contains the properties and schema location for the event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSelfDescribingEvent(event) {
  var _a = event.event,
    schema = _a.schema,
    data = _a.data,
    pb = payloadBuilder();
  var ueJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/unstruct_event/jsonschema/1-0-0',
    data: {
      schema: schema,
      data: data
    }
  };
  pb.add('e', 'ue');
  pb.addJson('ue_px', 'ue_pr', ueJson);
  return pb;
}
/**
 * Build a Page View Event
 * Represents a Page View, which is typically fired as soon as possible when a web page
 * is loaded within the users browser. Often also fired on "virtual page views" within
 * Single Page Applications (SPA).
 *
 * @param event - Contains the properties for the Page View event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPageView(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    pb = payloadBuilder();
  pb.add('e', 'pv'); // 'pv' for Page View
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  return pb;
}
/**
 * Build a Page Ping Event
 * Fires when activity tracking is enabled in the browser.
 * Tracks same information as the last tracked Page View and includes scroll
 * information from the current page view
 *
 * @param event - Contains the properties for the Page Ping event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPagePing(event) {
  var pageUrl = event.pageUrl,
    pageTitle = event.pageTitle,
    referrer = event.referrer,
    minXOffset = event.minXOffset,
    maxXOffset = event.maxXOffset,
    minYOffset = event.minYOffset,
    maxYOffset = event.maxYOffset,
    pb = payloadBuilder();
  pb.add('e', 'pp'); // 'pp' for Page Ping
  pb.add('url', pageUrl);
  pb.add('page', pageTitle);
  pb.add('refr', referrer);
  if (minXOffset && !isNaN(Number(minXOffset))) pb.add('pp_mix', minXOffset.toString());
  if (maxXOffset && !isNaN(Number(maxXOffset))) pb.add('pp_max', maxXOffset.toString());
  if (minYOffset && !isNaN(Number(minYOffset))) pb.add('pp_miy', minYOffset.toString());
  if (maxYOffset && !isNaN(Number(maxYOffset))) pb.add('pp_may', maxYOffset.toString());
  return pb;
}
/**
 * Build a Structured Event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - Contains the properties for the Structured event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildStructEvent(event) {
  var category = event.category,
    action = event.action,
    label = event.label,
    property = event.property,
    value = event.value,
    pb = payloadBuilder();
  pb.add('e', 'se'); // 'se' for Structured Event
  pb.add('se_ca', category);
  pb.add('se_ac', action);
  pb.add('se_la', label);
  pb.add('se_pr', property);
  pb.add('se_va', value == null ? undefined : value.toString());
  return pb;
}
/**
 * Build an Ecommerce Transaction Event
 * Allows for tracking common ecommerce events, this event is usually used when
 * a consumer completes a transaction.
 *
 * @param event - Contains the properties for the Ecommerce Transactoion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransaction(event) {
  var orderId = event.orderId,
    total = event.total,
    affiliation = event.affiliation,
    tax = event.tax,
    shipping = event.shipping,
    city = event.city,
    state = event.state,
    country = event.country,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'tr'); // 'tr' for Transaction
  pb.add('tr_id', orderId);
  pb.add('tr_af', affiliation);
  pb.add('tr_tt', total);
  pb.add('tr_tx', tax);
  pb.add('tr_sh', shipping);
  pb.add('tr_ci', city);
  pb.add('tr_st', state);
  pb.add('tr_co', country);
  pb.add('tr_cu', currency);
  return pb;
}
/**
 * Build an Ecommerce Transaction Item Event
 * Related to the {@link buildEcommerceTransaction}
 * Each Ecommerce Transaction may contain one or more EcommerceTransactionItem events
 *
 * @param event - Contains the properties for the Ecommerce Transaction Item event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransactionItem(event) {
  var orderId = event.orderId,
    sku = event.sku,
    price = event.price,
    name = event.name,
    category = event.category,
    quantity = event.quantity,
    currency = event.currency,
    pb = payloadBuilder();
  pb.add('e', 'ti'); // 'tr' for Transaction Item
  pb.add('ti_id', orderId);
  pb.add('ti_sk', sku);
  pb.add('ti_nm', name);
  pb.add('ti_ca', category);
  pb.add('ti_pr', price);
  pb.add('ti_qu', quantity);
  pb.add('ti_cu', currency);
  return pb;
}
/**
 * Build a Scren View Event
 * Similar to a Page View but less focused on typical web properties
 * Often used for mobile applications as the user is presented with
 * new views as they performance navigation events
 *
 * @param event - Contains the properties for the Screen View event. One or more properties must be included.
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildScreenView(event) {
  var name = event.name,
    id = event.id;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/screen_view/jsonschema/1-0-0',
      data: removeEmptyProperties({
        name: name,
        id: id
      })
    }
  });
}
/**
 * Build a Link Click Event
 * Used when a user clicks on a link on a webpage, typically an anchor tag `<a>`
 *
 * @param event - Contains the properties for the Link Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildLinkClick(event) {
  var targetUrl = event.targetUrl,
    elementId = event.elementId,
    elementClasses = event.elementClasses,
    elementTarget = event.elementTarget,
    elementContent = event.elementContent;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/link_click/jsonschema/1-0-1',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      elementId: elementId,
      elementClasses: elementClasses,
      elementTarget: elementTarget,
      elementContent: elementContent
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Impression Event
 * Used to track an advertisement impression
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Impression event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdImpression(event) {
  var impressionId = event.impressionId,
    costModel = event.costModel,
    cost = event.cost,
    targetUrl = event.targetUrl,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0',
    data: removeEmptyProperties({
      impressionId: impressionId,
      costModel: costModel,
      cost: cost,
      targetUrl: targetUrl,
      bannerId: bannerId,
      zoneId: zoneId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Click Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdClick(event) {
  var targetUrl = event.targetUrl,
    clickId = event.clickId,
    costModel = event.costModel,
    cost = event.cost,
    bannerId = event.bannerId,
    zoneId = event.zoneId,
    impressionId = event.impressionId,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_click/jsonschema/1-0-0',
    data: removeEmptyProperties({
      targetUrl: targetUrl,
      clickId: clickId,
      costModel: costModel,
      cost: cost,
      bannerId: bannerId,
      zoneId: zoneId,
      impressionId: impressionId,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Ad Conversion Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Conversion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdConversion(event) {
  var conversionId = event.conversionId,
    costModel = event.costModel,
    cost = event.cost,
    category = event.category,
    action = event.action,
    property = event.property,
    initialValue = event.initialValue,
    advertiserId = event.advertiserId,
    campaignId = event.campaignId;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/ad_conversion/jsonschema/1-0-0',
    data: removeEmptyProperties({
      conversionId: conversionId,
      costModel: costModel,
      cost: cost,
      category: category,
      action: action,
      property: property,
      initialValue: initialValue,
      advertiserId: advertiserId,
      campaignId: campaignId
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Social Interaction Event
 * Social tracking will be used to track the way users interact
 * with Facebook, Twitter and Google + widgets
 * e.g. to capture “like this” or “tweet this” events.
 *
 * @param event - Contains the properties for the Social Interaction event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSocialInteraction(event) {
  var action = event.action,
    network = event.network,
    target = event.target;
  var eventJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/social_interaction/jsonschema/1-0-0',
    data: removeEmptyProperties({
      action: action,
      network: network,
      target: target
    })
  };
  return buildSelfDescribingEvent({
    event: eventJson
  });
}
/**
 * Build a Add To Cart Event
 * For tracking users adding items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Add To Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAddToCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/add_to_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Remove From Cart Event
 * For tracking users removing items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Remove From Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildRemoveFromCart(event) {
  var sku = event.sku,
    quantity = event.quantity,
    name = event.name,
    category = event.category,
    unitPrice = event.unitPrice,
    currency = event.currency;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/remove_from_cart/jsonschema/1-0-0',
      data: removeEmptyProperties({
        sku: sku,
        quantity: quantity,
        name: name,
        category: category,
        unitPrice: unitPrice,
        currency: currency
      })
    }
  });
}
/**
 * Build a Form Focus or Change Form Event based on schema property
 * When a user focuses on a form element or when a user makes a
 * change to a form element.
 *
 * @param event - Contains the properties for the Form Focus or Change Form event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormFocusOrChange(event) {
  var event_schema = '';
  var schema = event.schema,
    formId = event.formId,
    elementId = event.elementId,
    nodeName = event.nodeName,
    elementClasses = event.elementClasses,
    value = event.value,
    type = event.type;
  var event_data = {
    formId: formId,
    elementId: elementId,
    nodeName: nodeName,
    elementClasses: elementClasses,
    value: value
  };
  if (schema === 'change_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0';
    event_data.type = type;
  } else if (schema === 'focus_form') {
    event_schema = 'iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0';
    event_data.elementType = type;
  }
  return buildSelfDescribingEvent({
    event: {
      schema: event_schema,
      data: removeEmptyProperties(event_data, {
        value: true
      })
    }
  });
}
/**
 * Build a Form Submission Event
 * Used to track when a user submits a form
 *
 * @param event - Contains the properties for the Form Submission event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormSubmission(event) {
  var formId = event.formId,
    formClasses = event.formClasses,
    elements = event.elements;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
      data: removeEmptyProperties({
        formId: formId,
        formClasses: formClasses,
        elements: elements
      })
    }
  });
}
/**
 * Build a Site Search Event
 * Used when a user performs a search action on a page
 *
 * @param event - Contains the properties for the Site Search event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSiteSearch(event) {
  var terms = event.terms,
    filters = event.filters,
    totalResults = event.totalResults,
    pageResults = event.pageResults;
  return buildSelfDescribingEvent({
    event: {
      schema: 'iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0',
      data: removeEmptyProperties({
        terms: terms,
        filters: filters,
        totalResults: totalResults,
        pageResults: pageResults
      })
    }
  });
}
/**
 * Build a Consent Withdrawn Event
 * Used for tracking when a user withdraws their consent
 *
 * @param event - Contains the properties for the Consent Withdrawn event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentWithdrawn(event) {
  var all = event.all,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_withdrawn/jsonschema/1-0-0',
        data: removeEmptyProperties({
          all: all
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Build a Consent Granted Event
 * Used for tracking when a user grants their consent
 *
 * @param event - Contains the properties for the Consent Granted event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentGranted(event) {
  var expiry = event.expiry,
    id = event.id,
    version = event.version,
    name = event.name,
    description = event.description;
  var documentJson = {
    schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
    data: removeEmptyProperties({
      id: id,
      version: version,
      name: name,
      description: description
    })
  };
  return {
    event: buildSelfDescribingEvent({
      event: {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_granted/jsonschema/1-0-0',
        data: removeEmptyProperties({
          expiry: expiry
        })
      }
    }),
    context: [documentJson]
  };
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - JSON object to clean
 * @param exemptFields - Set of fields which should not be removed even if empty
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event, exemptFields) {
  if (exemptFields === void 0) {
    exemptFields = {};
  }
  var ret = {};
  for (var k in event) {
    if (exemptFields[k] || event[k] !== null && typeof event[k] !== 'undefined') {
      ret[k] = event[k];
    }
  }
  return ret;
}
function newInMemoryEventStore(_a) {
  var _b = _a.maxSize,
    maxSize = _b === void 0 ? 1000 : _b,
    _c = _a.events,
    events = _c === void 0 ? [] : _c;
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], events, true);
  var count = function count() {
    return Promise.resolve(store.length);
  };
  return {
    count: count,
    add: function add(payload) {
      store.push(payload);
      while (store.length > maxSize) {
        store.shift();
      }
      return count();
    },
    removeHead: function removeHead(count) {
      for (var i = 0; i < count; i++) {
        store.shift();
      }
      return Promise.resolve();
    },
    iterator: function iterator() {
      var index = 0;
      // copy the store to prevent mutation
      var events = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true);
      return {
        next: function next() {
          if (index < events.length) {
            return Promise.resolve({
              value: events[index++],
              done: false
            });
          }
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
      };
    },
    getAll: function getAll() {
      return Promise.resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([], store, true));
    },
    getAllPayloads: function getAllPayloads() {
      return Promise.resolve(store.map(function (e) {
        return e.payload;
      }));
    }
  };
}
var PAYLOAD_DATA_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4';

/**
 * Enclose an array of events in a self-describing payload_data JSON string
 *
 * @param array - events Batch of events
 * @returns string payload_data self-describing JSON
 */
function encloseInPayloadDataEnvelope(events) {
  return JSON.stringify({
    schema: PAYLOAD_DATA_SCHEMA,
    data: events
  });
}
/**
 * Attaches the STM field to outbound POST events.
 *
 * @param events - the events to attach the STM to
 */
function attachStmToEvent(events) {
  var stm = new Date().getTime().toString();
  for (var i = 0; i < events.length; i++) {
    events[i]['stm'] = stm;
  }
  return events;
}
function newEmitterRequest(_a) {
  var endpoint = _a.endpoint,
    _b = _a.protocol,
    protocol = _b === void 0 ? 'https' : _b,
    port = _a.port,
    _c = _a.eventMethod,
    eventMethod = _c === void 0 ? 'post' : _c,
    customHeaders = _a.customHeaders,
    connectionTimeout = _a.connectionTimeout,
    _d = _a.keepalive,
    keepalive = _d === void 0 ? false : _d,
    _e = _a.postPath,
    postPath = _e === void 0 ? '/com.snowplowanalytics.snowplow/tp2' : _e,
    _f = _a.useStm,
    useStm = _f === void 0 ? true : _f,
    _g = _a.maxPostBytes,
    maxPostBytes = _g === void 0 ? 40000 : _g,
    _h = _a.credentials,
    credentials = _h === void 0 ? 'include' : _h;
  var events = [];
  var usePost = eventMethod.toLowerCase() === 'post';
  var timer;
  var abortController;
  function countBytes() {
    var count = events.reduce(function (acc, event) {
      return acc + (usePost ? event.getPOSTRequestBytesCount() : event.getGETRequestBytesCount());
    }, 0);
    if (usePost) {
      count += 88; // 88 bytes for the payload_data envelope
    }
    return count;
  }
  function countEvents() {
    return events.length;
  }
  function getServerAnonymizationOfExistingEvents() {
    return events.length > 0 ? events[0].getServerAnonymization() : undefined;
  }
  function addEvent(event) {
    if (events.length > 0 && getServerAnonymizationOfExistingEvents() !== event.getServerAnonymization()) {
      return false;
    } else {
      events.push(event);
      return true;
    }
  }
  function getEvents() {
    return events;
  }
  function isFull() {
    if (usePost) {
      return countBytes() >= maxPostBytes;
    } else {
      return events.length >= 1;
    }
  }
  function createHeaders() {
    var headers = new Headers();
    if (usePost) {
      headers.append('Content-Type', 'application/json; charset=UTF-8');
    }
    if (customHeaders) {
      Object.keys(customHeaders).forEach(function (key) {
        headers.append(key, customHeaders[key]);
      });
    }
    if (getServerAnonymizationOfExistingEvents()) {
      headers.append('SP-Anonymous', '*');
    }
    return headers;
  }
  function getFullCollectorUrl() {
    var collectorUrl = endpoint;
    if (!endpoint.includes('://')) {
      collectorUrl = "".concat(protocol, "://").concat(endpoint);
    }
    if (port) {
      collectorUrl = "".concat(collectorUrl, ":").concat(port);
    }
    var path = usePost ? postPath : '/i';
    return collectorUrl + path;
  }
  function makeRequest(url, options) {
    closeRequest(false);
    abortController = new AbortController();
    timer = setTimeout(function () {
      var reason = 'Request timed out';
      console.error(reason);
      timer = undefined;
      closeRequest(false, reason);
    }, connectionTimeout !== null && connectionTimeout !== void 0 ? connectionTimeout : 5000);
    var requestOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      headers: createHeaders(),
      signal: abortController.signal,
      keepalive: keepalive,
      credentials: credentials
    }, options);
    var request = new Request(url, requestOptions);
    return request;
  }
  function makePostRequest() {
    var batch = attachStmToEvent(events.map(function (event) {
      return event.getPOSTRequestBody();
    }));
    return makeRequest(getFullCollectorUrl(), {
      method: 'POST',
      body: encloseInPayloadDataEnvelope(batch)
    });
  }
  function makeGetRequest() {
    if (events.length !== 1) {
      throw new Error('Only one event can be sent in a GET request');
    }
    var event = events[0];
    var url = event.getGETRequestURL(getFullCollectorUrl(), useStm);
    return makeRequest(url, {
      method: 'GET'
    });
  }
  function toRequest() {
    if (events.length === 0) {
      return undefined;
    }
    if (usePost) {
      return makePostRequest();
    } else {
      return makeGetRequest();
    }
  }
  function closeRequest(successful, reason) {
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    if (abortController !== undefined) {
      var controller = abortController;
      abortController = undefined;
      if (!successful) {
        controller.abort(reason);
      }
    }
  }
  return {
    addEvent: addEvent,
    getEvents: getEvents,
    toRequest: toRequest,
    countBytes: countBytes,
    countEvents: countEvents,
    isFull: isFull,
    closeRequest: closeRequest
  };
}

/**
 * Count the number of bytes a string will occupy when UTF-8 encoded
 * Taken from http://stackoverflow.com/questions/2848462/count-bytes-in-textarea-using-javascript/
 *
 * @param s - The string
 * @returns number Length of s in bytes when UTF-8 encoded
 */
function getUTF8Length(s) {
  var len = 0;
  for (var i = 0; i < s.length; i++) {
    var code = s.charCodeAt(i);
    if (code <= 0x7f) {
      len += 1;
    } else if (code <= 0x7ff) {
      len += 2;
    } else if (code >= 0xd800 && code <= 0xdfff) {
      // Surrogate pair: These take 4 bytes in UTF-8 and 2 chars in UCS-2
      // (Assume next char is the other [valid] half and just skip it)
      len += 4;
      i++;
    } else if (code < 0xffff) {
      len += 3;
    } else {
      len += 4;
    }
  }
  return len;
}
/*
  * Convert a dictionary to a querystring
  * The context field is the last in the querystring
  */
function getQuerystring(request) {
  var lowPriorityKeys = {
    co: true,
    cx: true
  };
  var args = [];
  for (var key in request) {
    if (request.hasOwnProperty(key) && !lowPriorityKeys[key]) {
      args.push(key + '=' + encodeURIComponent(request[key]));
    }
  }
  for (var contextKey in lowPriorityKeys) {
    if (request.hasOwnProperty(contextKey) && lowPriorityKeys[contextKey]) {
      args.push(contextKey + '=' + encodeURIComponent(request[contextKey]));
    }
  }
  return '?' + args.join('&');
}
/*
  * Convert numeric fields to strings to match payload_data schema
  */
function preparePostBody(request) {
  var cleanedRequest = Object.keys(request).map(function (k) {
    return [k, request[k]];
  }).reduce(function (acc, _a) {
    var key = _a[0],
      value = _a[1];
    acc[key] = value.toString();
    return acc;
  }, {});
  return cleanedRequest;
}
function newEmitterEvent(eventStorePayload) {
  var querystring = null;
  var postBody = null;
  var byteCountGET = null;
  var byteCountPOST = null;
  function getPayload() {
    return eventStorePayload.payload;
  }
  function getServerAnonymization() {
    var _a;
    return (_a = eventStorePayload.svrAnon) !== null && _a !== void 0 ? _a : false;
  }
  function getCachedQuerystring(payload) {
    if (querystring === null) {
      querystring = getQuerystring(payload);
    }
    return querystring;
  }
  function getGETRequestURL(collectorUrl, useStm) {
    var querystring = getCachedQuerystring(getPayload());
    if (useStm) {
      return collectorUrl + querystring.replace('?', '?stm=' + new Date().getTime() + '&');
    }
    return collectorUrl + querystring;
  }
  function getGETRequestBytesCount() {
    if (byteCountGET === null) {
      var querystring_1 = getCachedQuerystring(getPayload());
      byteCountGET = getUTF8Length(querystring_1);
    }
    return byteCountGET;
  }
  function getPOSTRequestBody() {
    if (postBody === null) {
      postBody = preparePostBody(getPayload());
    }
    return postBody;
  }
  function getPOSTRequestBytesCount() {
    if (byteCountPOST === null) {
      byteCountPOST = getUTF8Length(JSON.stringify(getPOSTRequestBody()));
    }
    return byteCountPOST;
  }
  return {
    getPayload: getPayload,
    getServerAnonymization: getServerAnonymization,
    getGETRequestURL: getGETRequestURL,
    getGETRequestBytesCount: getGETRequestBytesCount,
    getPOSTRequestBody: getPOSTRequestBody,
    getPOSTRequestBytesCount: getPOSTRequestBytesCount
  };
}
function newEmitter(_a) {
  var endpoint = _a.endpoint,
    _b = _a.eventMethod,
    eventMethod = _b === void 0 ? 'post' : _b,
    postPath = _a.postPath,
    protocol = _a.protocol,
    port = _a.port,
    _c = _a.maxPostBytes,
    maxPostBytes = _c === void 0 ? 40000 : _c,
    maxGetBytes = _a.maxGetBytes,
    _d = _a.bufferSize,
    bufferSize = _d === void 0 ? 1 : _d,
    customHeaders = _a.customHeaders,
    serverAnonymization = _a.serverAnonymization,
    connectionTimeout = _a.connectionTimeout,
    keepalive = _a.keepalive,
    idService = _a.idService,
    _e = _a.dontRetryStatusCodes,
    dontRetryStatusCodes = _e === void 0 ? [] : _e,
    _f = _a.retryStatusCodes,
    retryStatusCodes = _f === void 0 ? [] : _f,
    _g = _a.retryFailedRequests,
    retryFailedRequests = _g === void 0 ? true : _g,
    onRequestFailure = _a.onRequestFailure,
    onRequestSuccess = _a.onRequestSuccess,
    _h = _a.customFetch,
    customFetch = _h === void 0 ? fetch : _h,
    useStm = _a.useStm,
    _j = _a.eventStore,
    eventStore = _j === void 0 ? newInMemoryEventStore({}) : _j,
    credentials = _a.credentials;
  var idServiceCalled = false;
  var flushInProgress = false;
  var usePost = eventMethod.toLowerCase() === 'post';
  dontRetryStatusCodes = dontRetryStatusCodes.concat([400, 401, 403, 410, 422]);
  function shouldRetryForStatusCode(statusCode) {
    // success, don't retry
    if (statusCode >= 200 && statusCode < 300) {
      return false;
    }
    if (!retryFailedRequests) {
      return false;
    }
    // retry if status code among custom user-supplied retry codes
    if (retryStatusCodes.includes(statusCode)) {
      return true;
    }
    // retry if status code *not* among the don't retry codes
    return !dontRetryStatusCodes.includes(statusCode);
  }
  function callOnRequestSuccess(payloads, response) {
    if (onRequestSuccess !== undefined) {
      setTimeout(function () {
        try {
          onRequestSuccess === null || onRequestSuccess === void 0 ? void 0 : onRequestSuccess(payloads, response);
        } catch (e) {
          LOG.error('Error in onRequestSuccess', e);
        }
      }, 0);
    }
  }
  function callOnRequestFailure(failure, response) {
    if (onRequestFailure !== undefined) {
      setTimeout(function () {
        try {
          onRequestFailure === null || onRequestFailure === void 0 ? void 0 : onRequestFailure(failure, response);
        } catch (e) {
          LOG.error('Error in onRequestFailure', e);
        }
      }, 0);
    }
  }
  function executeRequest(request) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var fetchRequest, payloads, response, willRetry, e_1, message;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            fetchRequest = request.toRequest();
            if (fetchRequest === undefined) {
              throw new Error('Empty batch');
            }
            payloads = request.getEvents().map(function (event) {
              return event.getPayload();
            });
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4 /*yield*/, customFetch(fetchRequest)];
          case 2:
            response = _a.sent();
            return [4 /*yield*/, response.text()];
          case 3:
            _a.sent(); // wait for the response to be fully read
            request.closeRequest(true);
            if (response.ok) {
              callOnRequestSuccess(payloads, response);
              return [2 /*return*/, {
                success: true,
                retry: false,
                status: response.status
              }];
            } else {
              willRetry = shouldRetryForStatusCode(response.status);
              callOnRequestFailure({
                events: payloads,
                status: response.status,
                message: response.statusText,
                willRetry: willRetry
              }, response);
              return [2 /*return*/, {
                success: false,
                retry: willRetry,
                status: response.status
              }];
            }
          case 4:
            e_1 = _a.sent();
            request.closeRequest(false);
            message = typeof e_1 === 'string' ? e_1 : e_1 ? e_1.message : 'Unknown error';
            callOnRequestFailure({
              events: payloads,
              message: message,
              willRetry: true
            });
            return [2 /*return*/, {
              success: false,
              retry: true
            }];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function newEmitterRequestWithConfig() {
    return newEmitterRequest({
      endpoint: endpoint,
      protocol: protocol,
      port: port,
      eventMethod: eventMethod,
      customHeaders: customHeaders,
      connectionTimeout: connectionTimeout,
      keepalive: keepalive,
      maxPostBytes: maxPostBytes,
      useStm: useStm,
      credentials: credentials,
      postPath: postPath
    });
  }
  function shouldSkipEventStore(emitterEvent) {
    var eventTooBigWarning = function eventTooBigWarning(bytes, maxBytes) {
      return LOG.warn('Event (' + bytes + 'B) too big, max is ' + maxBytes);
    };
    if (usePost) {
      var bytes = emitterEvent.getPOSTRequestBytesCount() + 88; // 88 bytes for the payload_data envelope
      var tooBig = bytes > maxPostBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxPostBytes);
      }
      return tooBig;
    } else {
      if (maxGetBytes === undefined) {
        return false;
      }
      var bytes = emitterEvent.getGETRequestBytesCount();
      var tooBig = bytes > maxGetBytes;
      if (tooBig) {
        eventTooBigWarning(bytes, maxGetBytes);
      }
      return tooBig;
    }
  }
  function callIdService() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(idService && !idServiceCalled)) return [3 /*break*/, 2];
            idServiceCalled = true;
            request = new Request(idService, {
              method: 'GET'
            });
            return [4 /*yield*/, customFetch(request)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  }
  function flush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var e_2;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!flushInProgress) return [3 /*break*/, 5];
            flushInProgress = true;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, continueFlush()];
          case 2:
            _a.sent();
            return [3 /*break*/, 5];
          case 3:
            e_2 = _a.sent();
            LOG.error('Error sending events', e_2);
            return [3 /*break*/, 5];
          case 4:
            flushInProgress = false;
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function continueFlush() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var request, eventStoreIterator, _a, value, done, event_1, _b, success, retry, status;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4 /*yield*/, callIdService()];
          case 1:
            _c.sent();
            request = newEmitterRequestWithConfig();
            eventStoreIterator = eventStore.iterator();
            _c.label = 2;
          case 2:
            if (request.isFull()) {
              return [3 /*break*/, 4];
            }
            return [4 /*yield*/, eventStoreIterator.next()];
          case 3:
            _a = _c.sent(), value = _a.value, done = _a.done;
            if (done || value === undefined) {
              return [3 /*break*/, 4];
            }
            event_1 = newEmitterEvent(value);
            if (!request.addEvent(event_1)) {
              return [3 /*break*/, 4];
            }
            return [3 /*break*/, 2];
          case 4:
            if (request.countEvents() === 0) {
              return [2 /*return*/];
            }
            return [4 /*yield*/, executeRequest(request)];
          case 5:
            _b = _c.sent(), success = _b.success, retry = _b.retry, status = _b.status;
            if (!(success || !retry)) return [3 /*break*/, 7];
            if (!success) {
              LOG.error("Status ".concat(status, ", will not retry."));
            }
            return [4 /*yield*/, eventStore.removeHead(request.countEvents())];
          case 6:
            _c.sent();
            _c.label = 7;
          case 7:
            if (!success) return [3 /*break*/, 9];
            return [4 /*yield*/, continueFlush()];
          case 8:
            _c.sent();
            _c.label = 9;
          case 9:
            return [2 /*return*/];
        }
      });
    });
  }
  function input(payload) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(this, void 0, void 0, function () {
      var eventStorePayload, event, request, count;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
          case 0:
            eventStorePayload = newEventStorePayload({
              payload: payload,
              svrAnon: serverAnonymization
            });
            event = newEmitterEvent(eventStorePayload);
            if (!shouldSkipEventStore(event)) return [3 /*break*/, 2];
            request = newEmitterRequestWithConfig();
            request.addEvent(event);
            return [4 /*yield*/, executeRequest(request)];
          case 1:
            _a.sent();
            return [3 /*break*/, 5];
          case 2:
            return [4 /*yield*/, eventStore.add(eventStorePayload)];
          case 3:
            count = _a.sent();
            if (!(count >= bufferSize)) return [3 /*break*/, 5];
            return [4 /*yield*/, flush()];
          case 4:
            _a.sent();
            _a.label = 5;
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }
  function setCollectorUrl(url) {
    endpoint = url;
  }
  function setAnonymousTracking(at) {
    serverAnonymization = at;
  }
  function setBufferSize(bs) {
    bufferSize = bs;
  }
  return {
    flush: flush,
    input: input,
    setCollectorUrl: setCollectorUrl,
    setAnonymousTracking: setAnonymousTracking,
    setBufferSize: setBufferSize
  };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var version = version$1;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node;
  var clockseq = options.clockseq;

  // v1 only: Use cached `node` and `clockseq` values
  if (!options._v6) {
    if (!node) {
      node = _nodeId;
    }
    if (clockseq == null) {
      clockseq = _clockseq;
    }
  }

  // Handle cases where we need entropy.  We do this lazily to minimize issues
  // related to insufficient system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    // Randomize node
    if (node == null) {
      node = [seedBytes[0], seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];

      // v1 only: cache node value for reuse
      if (!_nodeId && !options._v6) {
        // per RFC4122 4.5: Set MAC multicast bit (v1 only)
        node[0] |= 0x01; // Set multicast bit

        _nodeId = node;
      }
    }

    // Randomize clockseq
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
      if (_clockseq === undefined && !options._v6) {
        _clockseq = clockseq;
      }
    }
  }

  // v1 & v6 timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so time is
  // handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : Date.now();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }
  return buf || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(b);
}
/* harmony default export */ __webpack_exports__["a"] = (v1);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = v1ToV6;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



/**
 * Convert a v1 UUID to a v6 UUID
 *
 * @param {string|Uint8Array} uuid - The v1 UUID to convert to v6
 * @returns {string|Uint8Array} The v6 UUID as the same type as the `uuid` arg
 * (string or Uint8Array)
 */
function v1ToV6(uuid) {
  var v1Bytes = typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse_js__["a" /* default */])(uuid) : uuid;
  var v6Bytes = _v1ToV6(v1Bytes);
  return typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(v6Bytes) : v6Bytes;
}

// Do the field transformation needed for v1 -> v6
function _v1ToV6(v1Bytes) {
  var randomize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Uint8Array.of((v1Bytes[6] & 0x0f) << 4 | v1Bytes[7] >> 4 & 0x0f, (v1Bytes[7] & 0x0f) << 4 | (v1Bytes[4] & 0xf0) >> 4, (v1Bytes[4] & 0x0f) << 4 | (v1Bytes[5] & 0xf0) >> 4, (v1Bytes[5] & 0x0f) << 4 | (v1Bytes[0] & 0xf0) >> 4, (v1Bytes[0] & 0x0f) << 4 | (v1Bytes[1] & 0xf0) >> 4, (v1Bytes[1] & 0x0f) << 4 | (v1Bytes[2] & 0xf0) >> 4, 0x60 | v1Bytes[2] & 0x0f, v1Bytes[3], v1Bytes[8], v1Bytes[9], v1Bytes[10], v1Bytes[11], v1Bytes[12], v1Bytes[13], v1Bytes[14], v1Bytes[15]);
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony export (immutable) */ __webpack_exports__["a"] = v35;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringify_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(4);


function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];
  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }
  return bytes;
}
var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }
    if (typeof namespace === 'string') {
      namespace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(namespace);
    }
    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    }

    // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`
    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;
    if (buf) {
      offset = offset || 0;
      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }
      return buf;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stringify_js__["a" /* unsafeStringify */])(bytes);
  }

  // Function#name is not settable on some platforms (#270)
  try {
    generateUUID.name = name;
  } catch (err) {}

  // For CommonJS default export support
  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {(function() {
  var crypt = __webpack_require__(46),
      utf8 = __webpack_require__(17).utf8,
      bin = __webpack_require__(17).bin,

  // The core
  sha1 = function (message) {
    // Convert to byte array
    if (message.constructor == String)
      message = utf8.stringToBytes(message);
    else if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();

    // otherwise assume byte array

    var m  = crypt.bytesToWords(message),
        l  = message.length * 8,
        w  = [],
        H0 =  1732584193,
        H1 = -271733879,
        H2 = -1732584194,
        H3 =  271733878,
        H4 = -1009589776;

    // Padding
    m[l >> 5] |= 0x80 << (24 - l % 32);
    m[((l + 64 >>> 9) << 4) + 15] = l;

    for (var i = 0; i < m.length; i += 16) {
      var a = H0,
          b = H1,
          c = H2,
          d = H3,
          e = H4;

      for (var j = 0; j < 80; j++) {

        if (j < 16)
          w[j] = m[i + j];
        else {
          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
          w[j] = (n << 1) | (n >>> 31);
        }

        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
                j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 :
                j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 :
                j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 :
                         (H1 ^ H2 ^ H3) - 899497514);

        H4 = H3;
        H3 = H2;
        H2 = (H1 << 30) | (H1 >>> 2);
        H1 = H0;
        H0 = t;
      }

      H0 += a;
      H1 += b;
      H2 += c;
      H3 += d;
      H4 += e;
    }

    return [H0, H1, H2, H3, H4];
  },

  // Public API
  api = function (message, options) {
    var digestbytes = crypt.wordsToBytes(sha1(message));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

  api._blocksize = 16;
  api._digestsize = 20;

  module.exports = api;
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackPsykhePdpView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackPsykhePlpView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackPsykhePlpClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackPsykheAddToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackPsykheTransaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



var tracker;
function initTracker() {
  if (!window.rcProps.enablePsykheTracking) {
    tracker = null;
  }
  if (tracker === undefined) {
    var PSYKHE_BASE_URL = 'https://api.psykhe.dev';
    var POST_PATH = '/v1/collector';
    var clientIdentifier = 'fwrd';
    var cookieName = '_psykhe_';
    var cookieDomain = document.location.hostname;
    var stateStorageStrategy = 'cookieAndLocalStorage';
    var _seedSnowplowDomainUs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["a" /* seedSnowplowDomainUserId */])(window.rcProps.browserId, {
        cookieName: cookieName,
        cookieDomain: cookieDomain,
        stateStorageStrategy: stateStorageStrategy
      }),
      seeded = _seedSnowplowDomainUs.seeded;
    tracker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker__["a" /* newTracker */])('psykhe-ai', PSYKHE_BASE_URL, {
      appId: clientIdentifier,
      appVersion: '1.0.0',
      postPath: POST_PATH,
      cookieName: '_psykhe_',
      cookieDomain: document.location.hostname,
      stateStorageStrategy: 'cookieAndLocalStorage',
      cookieSecure: true,
      cookieSameSite: 'Lax',
      keepalive: true,
      credentials: 'include',
      bufferSize: 1,
      contexts: {
        session: true,
        // mandatory session context
        webPage: true,
        // optional
        browser: true // optional
      },
      plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["b" /* PsykheSnowplowEcommercePlugin */])()]
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["c" /* setEcommerceUser */])({
      is_guest: window.rcProps.isGuest,
      id: window.rcProps.userId
    });
  }
  return tracker;
}
var trackPsykhePdpView = function trackPsykhePdpView(code, name, price) {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["d" /* trackProductView */])({
      product_id: code,
      variant_id: code,
      name: name,
      price: price,
      currency: 'USD'
    });
  }
};
var trackPsykhePlpView = function trackPsykhePlpView() {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["e" /* trackProductListView */])({
      name: window.rcProps.plp.psykheCategory,
      products: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-plp-container').toArray().map(function (el, index) {
        var $el = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(el);
        var code = $el.attr('id');
        return {
          product_id: code,
          variant_id: code,
          name: $el.data('product-name'),
          price: parseFloat($el.data('priceUsd')),
          currency: 'USD',
          position: index + 1
        };
      })
    });
  }
};
var trackPsykhePlpClick = function trackPsykhePlpClick($plpContainer) {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["f" /* trackListClick */])({
      productList: window.rcProps.plp.psykheCategory,
      product: {
        product_id: $plpContainer.attr('id'),
        variant_id: $plpContainer.attr('id'),
        name: $plpContainer.data('product-name'),
        price: parseFloat($plpContainer.data('priceUsd')),
        currency: 'USD',
        position: _toConsumableArray($plpContainer.parent().children()).indexOf($plpContainer[0]) + 1
      }
    });
  }
};
var trackPsykheAddToCart = function trackPsykheAddToCart(code, atbResponse) {
  if (initTracker() && atbResponse) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["g" /* trackAddToCart */])({
      cart_id: window.rcProps.browserId,
      total_value: parseFloat(atbResponse.msg33),
      currency: 'USD',
      products: [{
        product_id: code,
        variant_id: code,
        name: atbResponse.msg31,
        price: parseFloat(atbResponse.msg15),
        currency: 'USD',
        quantity: 1
      }]
    });
  }
};
var trackPsykheTransaction = function trackPsykheTransaction(transaction) {
  if (initTracker()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__psykhe_ai_browser_plugin_snowplow_ecommerce__["h" /* trackTransaction */])(transaction);
  }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(59);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addToBag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_psykhe__ = __webpack_require__(20);


function addToBag(productcode, size, returnElement, showConfirmation, addlData) {
  if (size == undefined || size == '') {
    return;
  }
  if (window.hasReachedBagLimit(productcode, size, 1)) {
    return;
  }
  if (typeof window.gaAddToCartActionWithAjax === 'function') {
    window.gaAddToCartActionWithAjax('add', productcode, size, 1);
  }
  insertCordialAddToBagFromDisplayProduct(productcode, size);
  if (typeof insertFacebookAddToCart === 'function') {
    window.insertFacebookAddToCart(productcode, null);
  }
  if (typeof insertTiktokAddToCart === "function") {
    insertTiktokAddToCart(productcode);
  }
  if (typeof iPinYouAddtoCart === 'function') {
    window.iPinYouAddtoCart(productcode);
  }
  if (typeof insertCriteoAddToCart === 'function') {
    insertCriteoAddToCart(productcode);
  }
  if (typeof insertKakaoAddToCart === 'function') {
    insertKakaoAddToCart(productcode);
  }
  if (typeof insertRTBHouseAddToCart === 'function') {
    insertRTBHouseAddToCart(productcode);
  }
  if (typeof insertTaboolaAddToCart === 'function') {
    insertTaboolaAddToCart("add", productcode);
  }
  if (typeof brazeAddToCart === 'function') {
    if (window.rcProps && window.rcProps.pdp) {
      brazeAddToCart('add', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
    } else if (addlData) {
      brazeAddToCart('add', productcode, addlData.name, size, addlData.imageurl, addlData.pdpurl, addlData.price, addlData.currency, addlData.department, addlData.color, addlData.brand, addlData.category, addlData.cat1);
    }
  }
  var pdpData = window.rcProps.pdp || {};
  var isMens = pdpData.d == 'Mens';
  var dept = window.rcProps && window.rcProps.department ? window.rcProps.department : "";
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    colorSelect: productcode,
    sizeSelect: size,
    isMens: isMens,
    count: 1,
    d: dept,
    sectionURL: pdpData.sectionURL
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/AddItemToBag.jsp", data, function (res) {
    var result = parseRtn(res);
    if (result && result.reCAPTCHA) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: "/fw/dialog/VerifyHuman.jsp?mobile=true",
        type: "full",
        open: null,
        cache: false,
        overlayClose: true,
        closeButton: false,
        triggerOpen: true,
        onClose: function onClose() {
          if (window.rcProps && typeof window.rcProps.ReCAPTCHARestore == 'function') {
            window.rcProps.ReCAPTCHARestore();
            window.rcProps.ReCAPTCHARestore = "";
          }
        }
      });
      return;
    }
    if (typeof window.insertPageTrackForMobile === 'function') {
      window.insertPageTrackForMobile(true);
    }
    if (showConfirmation === undefined || showConfirmation === true) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#product-added-confirmation-container').length) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get("/fw/content/product/productAddedConfirmationModal", {
          code: productcode,
          size: size
        }, function (markup) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-added-confirmation-container").html(markup);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            open: "product-added-confirmation",
            triggerOpen: true,
            triggerElement: returnElement ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(returnElement.target) : null,
            onOpen: function onOpen() {
              var dataType = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-added-confirmation").data('type');
              if (dataType === 'toast') {
                var jsCarouselCtlAtb = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-carousel-ctl-atb");
                jsCarouselCtlAtb.not('.slick-initialized').slick({
                  arrows: false,
                  lazyLoad: 'ondemand',
                  slidesToShow: 3,
                  slidesToScroll: 2,
                  accessibility: true
                });
              }
            }
          });
        });
      } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#top-modal').length > 0) {
        //wishlist.jsp page
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: 'top-modal',
          triggerOpen: true
        });
      } else if (window.rcProps.shoppingBag) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('shoppingbag.wishlist.added.to.bag');
      }
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: "POST",
      url: "/fw/mobile/AjaxUserShoppingBag.jsp",
      success: function success(response) {
        var responseObj = eval('(' + response + ')');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shopping_bag_count").html(responseObj);
        if (typeof insertGoogleRemarketingAddToCart === 'function') {
          insertGoogleRemarketingAddToCart();
        }
        if (typeof addToCartYahoo === 'function') {
          addToCartYahoo(productcode);
        }
      }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_psykhe__["b" /* trackPsykheAddToCart */])(productcode, result);
  });
}
function insertCordialAddToBagFromDisplayProduct(code, size) {
  var pdpData = window.rcProps.pdp || {};
  var cartItems = new Array();
  var cartItem = {};
  cartItem.productCode = code;
  cartItem.productName = pdpData.productName;
  cartItem.productCategory = pdpData.categoryName;
  cartItem.brandName = pdpData.brandName;
  cartItem.price = pdpData.price;
  cartItem.images = [pdpData.imageUrl];
  cartItem.size = size;
  cartItem.description = pdpData.description;
  cartItem.url = pdpData.url;
  cartItem.department = pdpData.department;
  cartItem.cat1 = pdpData.cat1;
  cartItems.push(cartItem);
  if (typeof window.insertCordialAddToCart === 'function') {
    window.insertCordialAddToCart(cartItems);
  }
}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PsykheSnowplowEcommercePlugin;
/* unused harmony export trackCheckoutStep */
/* harmony export (immutable) */ __webpack_exports__["d"] = trackProductListView;
/* harmony export (immutable) */ __webpack_exports__["c"] = trackProductView;
/* harmony export (immutable) */ __webpack_exports__["e"] = trackListClick;
/* unused harmony export trackSiteSearch */
/* harmony export (immutable) */ __webpack_exports__["f"] = trackAddToCart;
/* unused harmony export trackRemoveFromCart */
/* harmony export (immutable) */ __webpack_exports__["g"] = trackTransaction;
/* unused harmony export trackRefund */
/* unused harmony export trackProductDwellTime */
/* unused harmony export setPageType */
/* harmony export (immutable) */ __webpack_exports__["b"] = setEcommerceUser;
/* unused harmony export withRecommendIdCtx */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schemata_js__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["context", "timestamp"],
  _excluded2 = ["context", "timestamp"],
  _excluded3 = ["context", "timestamp", "resultProducts"],
  _excluded4 = ["context", "timestamp", "products"],
  _excluded5 = ["context", "timestamp", "products"],
  _excluded6 = ["context", "timestamp", "products"],
  _excluded7 = ["context", "timestamp", "products"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }



var _trackers = {};
/* Scheduled to include Page and User */
var _context = {};
/**
 * Adds ecommerce tracking
 */
function PsykheSnowplowEcommercePlugin() {
  var trackerId;
  return {
    activateBrowserPlugin: function activateBrowserPlugin(tracker) {
      trackerId = tracker.id;
      _trackers[trackerId] = tracker;
      _context[trackerId] = [];
    },
    contexts: function contexts() {
      return _context[trackerId] || [];
    }
  };
}
/**
 * Track a checkout step
 *
 * @param checkoutStep - The checkout step index and the attributes the user filled in.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackCheckoutStep(checkoutStep) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _checkoutStep$context = checkoutStep.context,
    context = _checkoutStep$context === void 0 ? [] : _checkoutStep$context,
    timestamp = checkoutStep.timestamp,
    checkoutStepAttributes = _objectWithoutProperties(checkoutStep, _excluded);
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["a" /* CHECKOUT_STEP_SCHEMA */],
    data: _objectSpread({}, checkoutStepAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'checkout_step'
    }), context, timestamp);
  });
}
/**
 * Track a product list view
 *
 * @param listView - The list name along with the products which were viewed by the visitor.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackProductListView(listView) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _listView$context = listView.context,
    context = _listView$context === void 0 ? [] : _listView$context,
    timestamp = listView.timestamp,
    _listView$products = listView.products,
    products = _listView$products === void 0 ? [] : _listView$products,
    name = listView.name;
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'list_view',
      name: name
    }), context, timestamp);
  });
}
/**
 * Track a product view/detail
 *
 * @param productView - The product which was viewed in a product detail page.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackProductView(productView) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _productView$context = productView.context,
    context = _productView$context === void 0 ? [] : _productView$context,
    timestamp = productView.timestamp,
    product = _objectWithoutProperties(productView, _excluded2);
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
    data: _objectSpread({}, product)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'product_view'
    }), context, timestamp);
  });
}
function trackListClick(listClickEvent) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _listClickEvent$conte = listClickEvent.context,
    context = _listClickEvent$conte === void 0 ? [] : _listClickEvent$conte,
    timestamp = listClickEvent.timestamp,
    productList = listClickEvent.productList,
    product = listClickEvent.product;
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
    data: _objectSpread({}, product)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'list_click',
      name: productList
    }), context, timestamp);
  });
}
/**
 * Track site search
 *
 * @param siteSearch - The search which was requested by the visitor.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackSiteSearch(siteSearch) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _siteSearch$context = siteSearch.context,
    context = _siteSearch$context === void 0 ? [] : _siteSearch$context,
    timestamp = siteSearch.timestamp,
    _siteSearch$resultPro = siteSearch.resultProducts,
    resultProducts = _siteSearch$resultPro === void 0 ? [] : _siteSearch$resultPro,
    search = _objectWithoutProperties(siteSearch, _excluded3);
  resultProducts.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["c" /* SEARCH_SCHEMA */],
    data: _objectSpread({}, search)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'site_search'
    }), context, timestamp);
  });
}
/**
 * Track a product addition to cart
 *
 * @param cart - The product/s which was/were added to the cart and the total value of the cart after the product was added.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackAddToCart(cart) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _cart$context = cart.context,
    context = _cart$context === void 0 ? [] : _cart$context,
    timestamp = cart.timestamp,
    _cart$products = cart.products,
    products = _cart$products === void 0 ? [] : _cart$products,
    cartAttributes = _objectWithoutProperties(cart, _excluded4);
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["d" /* CART_SCHEMA */],
    data: _objectSpread({}, cartAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'add_to_cart'
    }), context, timestamp);
  });
}
/**
 * Track removal of products from cart
 *
 * @param cart - The product/s which were removed from the cart and the total value of the cart after the product was removed.
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackRemoveFromCart(cart) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _cart$context2 = cart.context,
    context = _cart$context2 === void 0 ? [] : _cart$context2,
    timestamp = cart.timestamp,
    _cart$products2 = cart.products,
    products = _cart$products2 === void 0 ? [] : _cart$products2,
    cartAttributes = _objectWithoutProperties(cart, _excluded5);
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: _objectSpread({}, product)
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["d" /* CART_SCHEMA */],
    data: _objectSpread({}, cartAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'remove_from_cart'
    }), context, timestamp);
  });
}
/**
 * Track a transaction event
 *
 * @param transaction - The transaction information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackTransaction(transaction) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var totalQuantity = 0;
  var _transaction$context = transaction.context,
    context = _transaction$context === void 0 ? [] : _transaction$context,
    timestamp = transaction.timestamp,
    _transaction$products = transaction.products,
    products = _transaction$products === void 0 ? [] : _transaction$products,
    transactionAttributes = _objectWithoutProperties(transaction, _excluded6);
  products.forEach(function (product) {
    /* If `total_quantity` is not provided, we calculate it from individual product quantities. */
    if (product.quantity) {
      totalQuantity += product.quantity;
    }
    context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: product
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["e" /* TRANSACTION_SCHEMA */],
    data: _objectSpread({
      total_quantity: totalQuantity || undefined
    }, transactionAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'transaction'
    }), context, timestamp);
  });
}
/**
 * Track a refund event
 *
 * @param refund - The refund information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackRefund(refund) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _refund$context = refund.context,
    context = _refund$context === void 0 ? [] : _refund$context,
    timestamp = refund.timestamp,
    _refund$products = refund.products,
    products = _refund$products === void 0 ? [] : _refund$products,
    refundAttributes = _objectWithoutProperties(refund, _excluded7);
  products.forEach(function (product) {
    return context.push({
      schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
      data: product
    });
  });
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["f" /* REFUND_SCHEMA */],
    data: _objectSpread({}, refundAttributes)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* buildEcommerceActionEvent */])({
      type: 'refund'
    }), context, timestamp);
  });
}
function trackProductDwellTime(productDwellTime) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var _productDwellTime$con = productDwellTime.context,
    context = _productDwellTime$con === void 0 ? [] : _productDwellTime$con,
    timestamp = productDwellTime.timestamp;
  context.push({
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["b" /* PRODUCT_SCHEMA */],
    data: _objectSpread({}, productDwellTime.product)
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["h" /* dispatchToTrackersInCollection */])(trackers, _trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["b" /* buildDwellTimeEvent */])({
      type: productDwellTime.pageType,
      duration: productDwellTime.duration
    }), context, timestamp);
  });
}
/**
 * Set Ecommerce Page context
 *
 * @param context - The ecommerce page context to be stored
 * @param trackers - The tracker identifiers which the context will be stored
 */
function setPageType(context) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var type = context.type,
    language = context.language,
    locale = context.locale;
  trackers.forEach(function (trackerId) {
    if (_context[trackerId]) {
      _context[trackerId] = removeContext(_context[trackerId], __WEBPACK_IMPORTED_MODULE_2__schemata_js__["g" /* PAGE_SCHEMA */]);
      _context[trackerId].push({
        schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["g" /* PAGE_SCHEMA */],
        data: {
          type: type,
          language: language,
          locale: locale
        }
      });
    }
  });
}
/**
 * Set Ecommerce User context
 *
 * @param context - The ecommerce user context to be stored
 * @param trackers - The tracker identifiers which the context will be stored
 */
function setEcommerceUser(context) {
  var trackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(_trackers);
  var id = context.id,
    is_guest = context.is_guest,
    email = context.email;
  trackers.forEach(function (trackerId) {
    if (_context[trackerId]) {
      _context[trackerId] = removeContext(_context[trackerId], __WEBPACK_IMPORTED_MODULE_2__schemata_js__["h" /* USER_SCHEMA */]);
      _context[trackerId].push({
        schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["h" /* USER_SCHEMA */],
        data: {
          id: id,
          is_guest: is_guest,
          email: email
        }
      });
    }
  });
}
/**
 * Attaches a recommendation ID context for events coming from PSYKHE AI.
 * This should be used when tracking user interaction with products returned
 * by PSYKHE recommendations or search results to support downstream attribution.
 *
 * @param recommendationId - The identifier of the recommendation session.
 * @returns A context object to be passed in the `context` array of tracking events.
 */
function withRecommendIdCtx(recommendationId) {
  return {
    schema: __WEBPACK_IMPORTED_MODULE_2__schemata_js__["i" /* PSYKHE_RECOMMENDATIONS_SCHEMA */],
    data: {
      id: recommendationId
    }
  };
}
/**
 * Return a new array with the context matching the `schemaToRemove` removed from the array.
 * Used in cases where we want only one type of the said context on the context array for a tracker.
 */
function removeContext(trackerContext, schemaToRemove) {
  return trackerContext.filter(function (context) {
    return context.schema !== schemaToRemove;
  });
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildEcommerceActionEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildDwellTimeEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schemata_js__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Build an Ecommerce Action Event
 * For tracking ecommerce actions
 *
 * @param event - Contains the properties for Cart related events
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceActionEvent(event) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["g" /* buildSelfDescribingEvent */])({
    event: {
      schema: __WEBPACK_IMPORTED_MODULE_1__schemata_js__["j" /* ECOMMERCE_ACTION_SCHEMA */],
      data: removeEmptyProperties(_objectSpread({}, event))
    }
  });
}
function buildDwellTimeEvent(event) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_tracker_core__["g" /* buildSelfDescribingEvent */])({
    event: {
      schema: __WEBPACK_IMPORTED_MODULE_1__schemata_js__["k" /* PSYKHE_PRODUCT_DWELL_TIME_SCHEMA */],
      data: removeEmptyProperties(_objectSpread({}, event))
    }
  });
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - Object to clean
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event) {
  var ret = {};
  for (var k in event) {
    if (event[k] !== null && typeof event[k] !== 'undefined') {
      ret[k] = event[k];
    }
  }
  return ret;
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = seedSnowplowDomainUserId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sha1__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__ = __webpack_require__(11);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var DEFAULT_COOKIE_NAME = '_sp_';
var DEFAULT_COOKIE_PATH = '/';
var DEFAULT_COOKIE_SAME_SITE = 'Lax';
var DEFAULT_COOKIE_SECURE = true;
var DEFAULT_VISITOR_COOKIE_TIMEOUT = 63072000;
var DEFAULT_SESSION_COOKIE_TIMEOUT = 1800;
// Mirrors Snowplow Browser Tracker 4.5.0 internals:
// - state key naming from `getSnowplowCookieName` in tracker/index.ts
// - id value shape from `parseIdCookie` in tracker/id_cookie.ts
// Re-check those files when upgrading @snowplow/browser-tracker-core.
// https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/index.ts
// https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts
/**
 * Seeds Snowplow's first-party visitor state before `newTracker` runs so the
 * browser tracker reuses a caller-provided domain_userid.
 */
function seedSnowplowDomainUserId(domainUserId) {
  var _options$stateStorage, _options$cookieName, _options$cookieSameSi, _options$cookieSecure, _options$discoverRoot, _options$cookieLifeti, _options$sessionCooki;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  assertBrowserEnvironment();
  assertValidDomainUserId(domainUserId);
  var stateStorageStrategy = (_options$stateStorage = options.stateStorageStrategy) !== null && _options$stateStorage !== void 0 ? _options$stateStorage : 'cookieAndLocalStorage';
  if (stateStorageStrategy === 'none') {
    return {
      seeded: false,
      storage: 'none'
    };
  }
  var cookieNamePrefix = (_options$cookieName = options.cookieName) !== null && _options$cookieName !== void 0 ? _options$cookieName : DEFAULT_COOKIE_NAME;
  // Falsy fallback (not nullish), matching Snowplow's `configCookiePath || '/'`: an empty
  // cookiePath must coerce to '/', otherwise the domain hash diverges from newTracker().
  var cookiePath = options.cookiePath || DEFAULT_COOKIE_PATH;
  var cookieSameSite = (_options$cookieSameSi = options.cookieSameSite) !== null && _options$cookieSameSi !== void 0 ? _options$cookieSameSi : DEFAULT_COOKIE_SAME_SITE;
  var cookieSecure = (_options$cookieSecure = options.cookieSecure) !== null && _options$cookieSecure !== void 0 ? _options$cookieSecure : DEFAULT_COOKIE_SECURE;
  // Mirror Snowplow's resolution exactly: discover the root domain only when the caller left
  // cookieDomain falsy (undefined or ''), via the same `&& !configCookieDomain` guard.
  var discoverRootDomain = (_options$discoverRoot = options.discoverRootDomain) !== null && _options$discoverRoot !== void 0 ? _options$discoverRoot : options.cookieDomain === undefined;
  var cookieDomain = options.cookieDomain;
  if (discoverRootDomain && !cookieDomain) {
    cookieDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["a" /* findRootDomain */])(cookieSameSite, cookieSecure);
  }
  // Snowplow hashes `(configCookieDomain || domainAlias) + (configCookiePath || '/')`, where
  // domainAlias is the fixupUrl-normalized hostname (handles translate/cache hosts), not the raw one.
  var domainAlias = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["b" /* fixupDomain */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["c" /* fixupUrl */])(window.location.hostname, window.location.href, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["d" /* getReferrer */])())[0]);
  var domainHash = __WEBPACK_IMPORTED_MODULE_0_sha1___default()("".concat(cookieDomain || domainAlias).concat(cookiePath)).slice(0, 4);
  var idStateName = "".concat(cookieNamePrefix, "id.").concat(domainHash);
  var sessionStateName = "".concat(cookieNamePrefix, "ses.").concat(domainHash);
  var storage = stateStorageStrategy === 'localStorage' ? 'localStorage' : 'cookie';
  if (!options.overwriteExisting && getStateValue(idStateName, storage)) {
    return {
      seeded: false,
      storage: storage,
      idStateName: idStateName,
      sessionStateName: sessionStateName
    };
  }
  var state = buildInitialSnowplowState(domainUserId);
  var visitorTtl = (_options$cookieLifeti = options.cookieLifetime) !== null && _options$cookieLifeti !== void 0 ? _options$cookieLifeti : DEFAULT_VISITOR_COOKIE_TIMEOUT;
  var sessionTtl = (_options$sessionCooki = options.sessionCookieTimeout) !== null && _options$sessionCooki !== void 0 ? _options$sessionCooki : DEFAULT_SESSION_COOKIE_TIMEOUT;
  var idStateSeeded;
  var sessionStateSeeded;
  if (storage === 'localStorage') {
    idStateSeeded = writeLocalStorage(idStateName, state.idCookie, visitorTtl);
    sessionStateSeeded = writeLocalStorage(sessionStateName, '*', sessionTtl);
  } else {
    var cookieOptions = {
      ttl: visitorTtl,
      path: cookiePath,
      domain: cookieDomain,
      sameSite: cookieSameSite,
      secure: cookieSecure
    };
    var sessionCookieOptions = _objectSpread(_objectSpread({}, cookieOptions), {}, {
      ttl: sessionTtl
    });
    idStateSeeded = writeCookie(idStateName, state.idCookie, cookieOptions);
    sessionStateSeeded = writeCookie(sessionStateName, '*', sessionCookieOptions);
  }
  var seeded = idStateSeeded && sessionStateSeeded;
  return {
    seeded: seeded,
    storage: storage,
    idStateName: idStateName,
    sessionStateName: sessionStateName
  };
}
function buildInitialSnowplowState(domainUserId) {
  var nowTs = Math.round(Date.now() / 1000);
  // Snowplow uses `uuid` v4 for generated domain/session/page identifiers.
  // We use the same package so the seeded session id matches Snowplow's format.
  // https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts#L32
  var sessionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_uuid__["a" /* v4 */])();
  // This is the serialized form produced by Snowplow's `serializeIdCookie`.
  // It intentionally excludes the leading "cookies enabled" marker, because
  // Snowplow adds that only while parsing the persisted value.
  // Source:
  // https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts#L62-L135
  // https://github.com/snowplow/snowplow-javascript-tracker/blob/4.5.0/libraries/browser-tracker-core/src/tracker/id_cookie.ts#L245-L253
  var parsedIdCookie = ['0',
  // cookieDisabled: "0" means storage is enabled
  domainUserId, nowTs, 1, nowTs, undefined, sessionId, '', '', undefined, 0];
  return {
    idCookie: parsedIdCookie.slice(1).join('.')
  };
}
function getStateValue(name, storage) {
  if (storage === 'localStorage') {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["e" /* attemptGetLocalStorage */])(name);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["f" /* cookie */])(name);
}
function writeLocalStorage(name, value, ttl) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["g" /* attemptWriteLocalStorage */])(name, value, ttl);
}
function writeCookie(name, value, options) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["f" /* cookie */])(name, value, options.ttl, options.path, options.domain, options.sameSite, options.secure);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__snowplow_browser_tracker_core__["f" /* cookie */])(name) === value;
}
function assertBrowserEnvironment() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    throw new Error('seedSnowplowDomainUserId must be called in a browser before Snowplow newTracker is initialized.');
  }
}
function assertValidDomainUserId(domainUserId) {
  if (!domainUserId) {
    throw new Error('Snowplow domain_userid must not be empty.');
  }
  if (domainUserId.includes('.')) {
    throw new Error('Snowplow domain_userid must not contain dots because Snowplow stores it in a dot-delimited value.');
  }
  if (/[\s;]/.test(domainUserId)) {
    throw new Error('Snowplow domain_userid must not contain whitespace or semicolons.');
  }
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_js__ = __webpack_require__(25);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__api_js__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_user_id_js__ = __webpack_require__(27);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__domain_user_id_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(29);
/* unused harmony namespace reexport */




/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageType */
var PageType;
(function (PageType) {
  // Product List Page / collection page
  PageType["PLP"] = "plp";
  // Product Detail Page
  PageType["PDP"] = "pdp";
})(PageType || (PageType = {}));

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addGlobalContexts */
/* unused harmony export addPlugin */
/* unused harmony export clearGlobalContexts */
/* unused harmony export clearUserData */
/* unused harmony export crossDomainLinker */
/* unused harmony export disableActivityTracking */
/* unused harmony export disableActivityTrackingCallback */
/* unused harmony export disableAnonymousTracking */
/* unused harmony export discardBrace */
/* unused harmony export discardHashTag */
/* unused harmony export enableActivityTracking */
/* unused harmony export enableActivityTrackingCallback */
/* unused harmony export enableAnonymousTracking */
/* unused harmony export flushBuffer */
/* unused harmony export newSession */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newTracker; });
/* unused harmony export preservePageViewId */
/* unused harmony export removeGlobalContexts */
/* unused harmony export setBufferSize */
/* unused harmony export setCollectorUrl */
/* unused harmony export setCookiePath */
/* unused harmony export setCustomUrl */
/* unused harmony export setDocumentTitle */
/* unused harmony export setOptOutCookie */
/* unused harmony export setReferrerUrl */
/* unused harmony export setUserId */
/* unused harmony export setUserIdFromCookie */
/* unused harmony export setUserIdFromLocation */
/* unused harmony export setUserIdFromReferrer */
/* unused harmony export setVisitorCookieTimeout */
/* unused harmony export trackPageView */
/* unused harmony export trackSelfDescribingEvent */
/* unused harmony export trackStructEvent */
/* unused harmony export updatePageActivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__ = __webpack_require__(12);
/* unused harmony reexport SharedState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__ = __webpack_require__(8);
/* unused harmony reexport version */
/*!
 * Browser tracker for Snowplow v4.8.2 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */






/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Expires current session and starts a new session.
 *
 * @param trackers - The tracker identifiers which will have their session refreshed
 */
function newSession(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.newSession();
  });
}
/**
 * Override referrer
 *
 * @param url - Custom Referrer which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setReferrerUrl(url, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setReferrerUrl(url);
  });
}
/**
 * Override url
 *
 * @param url - Custom URL which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setCustomUrl(url, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setCustomUrl(url);
  });
}
/**
 * Override document.title
 *
 * @param title - Document title which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setDocumentTitle(title, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setDocumentTitle(title);
  });
}
/**
 * Strip hash tag (or anchor) from URL
 *
 * @param enable - Whether to enable stripping of hash
 * @param trackers - The tracker identifiers which will be configured
 */
function discardHashTag(enable, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.discardHashTag(enable);
  });
}
/**
 * Strip braces from URL
 *
 * @param enable - Whther to enable stripping of braces
 * @param trackers - The tracker identifiers which will be configured
 */
function discardBrace(enable, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.discardBrace(enable);
  });
}
/**
 * Set first-party cookie path
 *
 * @param path - The path which will be used when setting cookies
 * @param trackers - The tracker identifiers which will be configured
 */
function setCookiePath(path, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setCookiePath(path);
  });
}
/**
 * Set visitor cookie timeout (in seconds)
 *
 * @param timeout - The timeout until cookies will expire
 * @param trackers - The tracker identifiers which will be configured
 */
function setVisitorCookieTimeout(timeout, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setVisitorCookieTimeout(timeout);
  });
}
/**
 * Enable querystring decoration for links passing a filter
 *
 * @param crossDomainLinker - Function used to determine which links to decorate
 * @param trackers - The tracker identifiers which will be configured
 */
function crossDomainLinker(crossDomainLinkerCriterion, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.crossDomainLinker(crossDomainLinkerCriterion);
  });
}
/**
 * Enables page activity tracking (sends page pings to the Collector regularly).
 *
 * @param configuration - The activity tracking configuration
 * @param trackers - The tracker identifiers which will be configured
 */
function enableActivityTracking(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.enableActivityTracking(configuration);
  });
}
/**
 * Enables page activity tracking (replaces collector ping with callback).
 *
 * @param configuration - The activity tracking callback configuration
 * @param trackers - The tracker identifiers which will be configured
 */
function enableActivityTrackingCallback(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.enableActivityTrackingCallback(configuration);
  });
}
/**
 * Disables page activity tracking.
 *
 * @param trackers - The tracker identifiers the activity tracking will be disabled.
 */
function disableActivityTracking(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.disableActivityTracking();
  });
}
/**
 * Disables page activity tracking callback.
 *
 * @param trackers - The tracker identifiers the activity tracking callback will be disabled.
 */
function disableActivityTrackingCallback(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.disableActivityTrackingCallback();
  });
}
/**
 * Triggers the activityHandler manually to allow external user defined activity. i.e. While watching a video
 *
 * @param trackers - The tracker identifiers which will be updated
 */
function updatePageActivity(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.updatePageActivity();
  });
}
/**
 * Sets the opt out cookie.
 *
 * @param name - of the opt out cookie
 * @param trackers - The tracker identifiers which will be configured
 */
function setOptOutCookie(name, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setOptOutCookie(name);
  });
}
/**
 * Set the business-defined user ID for this user.
 *
 * @param userId - The business-defined user ID
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserId(userId, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserId(userId);
  });
}
/**
 * Set the business-defined user ID for this user using the location querystring.
 *
 * @param querystringField - Name of a querystring name-value pair
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromLocation(querystringField, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserIdFromLocation(querystringField);
  });
}
/**
 * Set the business-defined user ID for this user using the referrer querystring.
 *
 * @param querystringField - Name of a querystring name-value pair
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromReferrer(querystringField, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserIdFromReferrer(querystringField);
  });
}
/**
 * Set the business-defined user ID for this user to the value of a cookie.
 *
 * @param cookieName - Name of the cookie whose value will be assigned to businessUserId
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromCookie(cookieName, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setUserIdFromCookie(cookieName);
  });
}
/**
 * Specify the Snowplow collector URL. Specific http or https to force it
 * or leave it off to match the website protocol.
 *
 * @param collectorUrl - The collector URL, with or without protocol
 * @param trackers - The tracker identifiers which will be configured
 */
function setCollectorUrl(collectorUrl, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setCollectorUrl(collectorUrl);
  });
}
/**
 * Set the buffer size
 * Can be useful if you want to stop batching requests to ensure events start
 * sending closer to event creation
 *
 * @param newBufferSize - The value with which to update the bufferSize to
 * @param trackers - The tracker identifiers which will be flushed
 */
function setBufferSize(newBufferSize, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.setBufferSize(newBufferSize);
  });
}
/**
 * Send all events in the outQueue
 * Only need to use this when sending events with a bufferSize of at least 2
 *
 * @param configuration - The configuration to use following flushing the buffer
 * @param trackers - The tracker identifiers which will be flushed
 */
function flushBuffer(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.flushBuffer(configuration);
  });
}
/**
 * Track a visit to a web page
 *
 * @param event - The Page View Event properties
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackPageView(event, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.trackPageView(event);
  });
}
/**
 * Track a structured event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - The Structured Event properties
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackStructEvent(event, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__["a" /* buildStructEvent */])(event), event.context, event.timestamp);
  });
}
/**
 * Track a self-describing event happening on this page.
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackSelfDescribingEvent(event, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.track(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__["b" /* buildSelfDescribingEvent */])({
      event: event.event
    }), event.context, event.timestamp);
  });
}
/**
 * All provided contexts will be sent with every event
 *
 * @param contexts - An array of contexts or conditional contexts
 * @param trackers - The tracker identifiers which the global contexts will be added to
 */
function addGlobalContexts(contexts, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.addGlobalContexts(contexts);
  });
}
/**
 * All provided contexts will no longer be sent with every event
 *
 * @param contexts - An array of contexts or conditional contexts
 * @param trackers - The tracker identifiers which the global contexts will be remove from
 */
function removeGlobalContexts(contexts, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.removeGlobalContexts(contexts);
  });
}
/**
 * Clear all global contexts that are sent with events
 *
 * @param trackers - The tracker identifiers which the global contexts will be cleared from
 */
function clearGlobalContexts(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.core.clearGlobalContexts();
  });
}
/**
 * Stop regenerating `pageViewId` (available from `web_page` context)
 *
 * @param trackers - The tracker identifiers which the event will preserve their Page View Ids
 */
function preservePageViewId(trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.preservePageViewId();
  });
}
/**
 * Disables anonymous tracking if active (ie. tracker initialized with `anonymousTracking`)
 * For stateStorageStrategy override, uses supplied value first,
 * falls back to one defined in initial config, otherwise uses cookieAndLocalStorage.
 *
 * @param configuration - The configuration for disabling anonymous tracking
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function disableAnonymousTracking(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.disableAnonymousTracking(configuration);
  });
}
/**
 * Enables anonymous tracking (ie. tracker initialized without `anonymousTracking`)
 *
 * @param configuration - The configuration for enabling anonymous tracking
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function enableAnonymousTracking(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.enableAnonymousTracking(configuration);
  });
}
/**
 * Clears all cookies and local storage containing user and session identifiers
 *
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function clearUserData(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.clearUserData(configuration);
  });
}
/**
 * Add a plugin into the plugin collection after trackers have already been initialised
 *
 * @param configuration - The plugin to add
 * @param trackers - The tracker identifiers which the plugin will be added to
 */
function addPlugin(configuration, trackers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["a" /* dispatchToTrackers */])(trackers, function (t) {
    t.addPlugin(configuration);
  });
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var state = typeof window !== 'undefined' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["b" /* createSharedState */])() : undefined;
/**
 * Initialise a new tracker
 *
 * @param trackerId - The tracker id - also known as tracker namespace
 * @param endpoint - Collector endpoint in the form collector.mysite.com
 * @param configuration - The initialisation options of the tracker
 */
function newTracker(trackerId, endpoint, configuration) {
  if (state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__snowplow_browser_tracker_core__["c" /* addTracker */])(trackerId, trackerId, "js-".concat(__WEBPACK_IMPORTED_MODULE_1__snowplow_tracker_core__["c" /* version */]), endpoint, state, configuration);
  } else {
    return undefined;
  }
}


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ('ffffffff-ffff-ffff-ffff-ffffffffffff');

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);
    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}

/*
 * Convert an array of little-endian words to an array of bytes
 */
function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';
  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }
  return output;
}

/**
 * Calculate output length with padding and bit length
 */
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;
  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }
  return output;
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ __webpack_exports__["a"] = ({
  randomUUID: randomUUID
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ('00000000-0000-0000-0000-000000000000');

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;
    case 1:
      return x ^ y ^ z;
    case 2:
      return x & y ^ x & z ^ y & z;
    case 3:
      return x ^ y ^ z;
  }
}
function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}
function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];
    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }
    M[_i] = arr;
  }
  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);
    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }
    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }
    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }
  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}
/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__(32);


var v3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v3);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__native_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rng_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringify_js__ = __webpack_require__(1);



function v4(options, buf, offset) {
  if (__WEBPACK_IMPORTED_MODULE_0__native_js__["a" /* default */].randomUUID && !buf && !options) {
    return __WEBPACK_IMPORTED_MODULE_0__native_js__["a" /* default */].randomUUID();
  }
  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_1__rng_js__["a" /* default */])();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stringify_js__["a" /* unsafeStringify */])(rnds);
}
/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__(36);


var v5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v5);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringify_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v1_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v1ToV6_js__ = __webpack_require__(15);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}




/**
 *
 * @param {object} options
 * @param {Uint8Array=} buf
 * @param {number=} offset
 * @returns
 */
function v6() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var buf = arguments.length > 1 ? arguments[1] : undefined;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  // v6 is v1 with different field layout, so we start with a v1 UUID, albeit
  // with slightly different behavior around how the clock_seq and node fields
  // are randomized, which is why we call v1 with _v6: true.
  var bytes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__v1_js__["a" /* default */])(_objectSpread(_objectSpread({}, options), {}, {
    _v6: true
  }), new Uint8Array(16));

  // Reorder the fields to v6 layout.
  bytes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__v1ToV6_js__["a" /* default */])(bytes);

  // Return as a byte array if requested
  if (buf) {
    for (var i = 0; i < 16; i++) {
      buf[offset + i] = bytes[i];
    }
    return buf;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stringify_js__["a" /* unsafeStringify */])(bytes);
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



/**
 * Convert a v6 UUID to a v1 UUID
 *
 * @param {string|Uint8Array} uuid - The v6 UUID to convert to v6
 * @returns {string|Uint8Array} The v1 UUID as the same type as the `uuid` arg
 * (string or Uint8Array)
 */
function v6ToV1(uuid) {
  var v6Bytes = typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse_js__["a" /* default */])(uuid) : uuid;
  var v1Bytes = _v6ToV1(v6Bytes);
  return typeof uuid === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(v1Bytes) : v1Bytes;
}

// Do the field transformation needed for v6 -> v1
function _v6ToV1(v6Bytes) {
  return Uint8Array.of((v6Bytes[3] & 0x0f) << 4 | v6Bytes[4] >> 4 & 0x0f, (v6Bytes[4] & 0x0f) << 4 | (v6Bytes[5] & 0xf0) >> 4, (v6Bytes[5] & 0x0f) << 4 | v6Bytes[6] & 0x0f, v6Bytes[7], (v6Bytes[1] & 0x0f) << 4 | (v6Bytes[2] & 0xf0) >> 4, (v6Bytes[2] & 0x0f) << 4 | (v6Bytes[3] & 0xf0) >> 4, 0x10 | (v6Bytes[0] & 0xf0) >> 4, (v6Bytes[0] & 0x0f) << 4 | (v6Bytes[1] & 0xf0) >> 4, v6Bytes[8], v6Bytes[9], v6Bytes[10], v6Bytes[11], v6Bytes[12], v6Bytes[13], v6Bytes[14], v6Bytes[15]);
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(1);



/**
 * UUID V7 - Unix Epoch time-based UUID
 *
 * The IETF has published RFC9562, introducing 3 new UUID versions (6,7,8). This
 * implementation of V7 is based on the accepted, though not yet approved,
 * revisions.
 *
 * RFC 9562:https://www.rfc-editor.org/rfc/rfc9562.html Universally Unique
 * IDentifiers (UUIDs)

 *
 * Sample V7 value:
 * https://www.rfc-editor.org/rfc/rfc9562.html#name-example-of-a-uuidv7-value
 *
 * Monotonic Bit Layout: RFC rfc9562.6.2 Method 1, Dedicated Counter Bits ref:
 *     https://www.rfc-editor.org/rfc/rfc9562.html#section-6.2-5.1
 *
 *   0                   1                   2                   3 0 1 2 3 4 5 6
 *   7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |                          unix_ts_ms                           |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |          unix_ts_ms           |  ver  |        seq_hi         |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |var|               seq_low               |        rand         |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |                             rand                              |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *
 * seq is a 31 bit serialized counter; comprised of 12 bit seq_hi and 19 bit
 * seq_low, and randomly initialized upon timestamp change. 31 bit counter size
 * was selected as any bitwise operations in node are done as _signed_ 32 bit
 * ints. we exclude the sign bit.
 */

var _seqLow = null;
var _seqHigh = null;
var _msecs = 0;
function v7(options, buf, offset) {
  options = options || {};

  // initialize buffer and pointer
  var i = buf && offset || 0;
  var b = buf || new Uint8Array(16);

  // rnds is Uint8Array(16) filled with random bytes
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

  // milliseconds since unix epoch, 1970-01-01 00:00
  var msecs = options.msecs !== undefined ? options.msecs : Date.now();

  // seq is user provided 31 bit counter
  var seq = options.seq !== undefined ? options.seq : null;

  // initialize local seq high/low parts
  var seqHigh = _seqHigh;
  var seqLow = _seqLow;

  // check if clock has advanced and user has not provided msecs
  if (msecs > _msecs && options.msecs === undefined) {
    _msecs = msecs;

    // unless user provided seq, reset seq parts
    if (seq !== null) {
      seqHigh = null;
      seqLow = null;
    }
  }

  // if we have a user provided seq
  if (seq !== null) {
    // trim provided seq to 31 bits of value, avoiding overflow
    if (seq > 0x7fffffff) {
      seq = 0x7fffffff;
    }

    // split provided seq into high/low parts
    seqHigh = seq >>> 19 & 0xfff;
    seqLow = seq & 0x7ffff;
  }

  // randomly initialize seq
  if (seqHigh === null || seqLow === null) {
    seqHigh = rnds[6] & 0x7f;
    seqHigh = seqHigh << 8 | rnds[7];
    seqLow = rnds[8] & 0x3f; // pad for var
    seqLow = seqLow << 8 | rnds[9];
    seqLow = seqLow << 5 | rnds[10] >>> 3;
  }

  // increment seq if within msecs window
  if (msecs + 10000 > _msecs && seq === null) {
    if (++seqLow > 0x7ffff) {
      seqLow = 0;
      if (++seqHigh > 0xfff) {
        seqHigh = 0;

        // increment internal _msecs. this allows us to continue incrementing
        // while staying monotonic. Note, once we hit 10k milliseconds beyond system
        // clock, we will reset breaking monotonicity (after (2^31)*10000 generations)
        _msecs++;
      }
    }
  } else {
    // resetting; we have advanced more than
    // 10k milliseconds beyond system clock
    _msecs = msecs;
  }
  _seqHigh = seqHigh;
  _seqLow = seqLow;

  // [bytes 0-5] 48 bits of local timestamp
  b[i++] = _msecs / 0x10000000000 & 0xff;
  b[i++] = _msecs / 0x100000000 & 0xff;
  b[i++] = _msecs / 0x1000000 & 0xff;
  b[i++] = _msecs / 0x10000 & 0xff;
  b[i++] = _msecs / 0x100 & 0xff;
  b[i++] = _msecs & 0xff;

  // [byte 6] - set 4 bits of version (7) with first 4 bits seq_hi
  b[i++] = seqHigh >>> 4 & 0x0f | 0x70;

  // [byte 7] remaining 8 bits of seq_hi
  b[i++] = seqHigh & 0xff;

  // [byte 8] - variant (2 bits), first 6 bits seq_low
  b[i++] = seqLow >>> 13 & 0x3f | 0x80;

  // [byte 9] 8 bits seq_low
  b[i++] = seqLow >>> 5 & 0xff;

  // [byte 10] remaining 5 bits seq_low, 3 bits random
  b[i++] = seqLow << 3 & 0xff | rnds[10] & 0x07;

  // [bytes 11-15] always random
  b[i++] = rnds[11];
  b[i++] = rnds[12];
  b[i++] = rnds[13];
  b[i++] = rnds[14];
  b[i++] = rnds[15];
  return buf || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* unsafeStringify */])(b);
}
/* unused harmony default export */ var _unused_webpack_default_export = (v7);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(5);

function version(uuid) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }
  return parseInt(uuid.slice(14, 15), 16);
}
/* unused harmony default export */ var _unused_webpack_default_export = (version);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(44)
var ieee754 = __webpack_require__(47)
var isArray = __webpack_require__(48)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 46 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 48 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var wishlistModule = function () {
  function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
      return url;
    } else {
      return url;
    }
  }
  function addToWishList(productcode, isOneSize) {
    var size = '';
    if (isOneSize == 'true') {
      size = 'all';
    } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="size-options"]:checked').length) {
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="size-options"]:checked').val();
    }
    var b_id = 'fm_plp_' + productcode;
    var _btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + b_id);
    var email = '';
    var sectionUrl = '';
    var sessionId = '';
    var canGuestsHaveFavorites = false;
    var wishlistTagId = '';
    var department = window.rcProps.department;
    if (typeof window.rcProps.wishlist != "undefined") {
      email = window.rcProps.wishlist.email;
      sectionUrl = window.rcProps.wishlist.sectionurl;
      sessionId = window.rcProps.wishlist.sessionID;
      wishlistTagId = window.rcProps.wishlist.wishlistTagId;
      canGuestsHaveFavorites = window.rcProps.wishlist.canGuestsHaveFavorites;
      department = department || window.rcProps.pdp.department;
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".favorite-button-pdp").length > 0) {
        _btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".favorite-button-pdp");
      }
    }
    if (!email && !canGuestsHaveFavorites) {
      var wishlistTagIdPair = wishlistTagId + '=' + b_id;
      var wishlistReturnUrl = window.location.pathname + window.location.search;
      if (wishlistReturnUrl.includes(wishlistTagId)) wishlistReturnUrl = removeURLParameter(wishlistReturnUrl, wishlistTagId);
      if (wishlistReturnUrl.includes('?')) {
        wishlistReturnUrl = wishlistReturnUrl + '&' + wishlistTagIdPair;
      } else {
        wishlistReturnUrl = wishlistReturnUrl + '?' + wishlistTagIdPair;
      }
      var signInCreateAccountPage = '/fw/addToWishList.jsp?code=' + productcode + '&size=' + size + '&sectionURL=' + encodeURIComponent(sectionUrl) + '&sessionID=' + sessionId + '&redirect=true&mobile=true&returnUrl=' + encodeURIComponent(wishlistReturnUrl) + '&d=' + department;
      var signInCreateAccount = '/fw/mobile/Login.jsp?returnURL=' + encodeURIComponent(signInCreateAccountPage);
      showWishListPopup(signInCreateAccount);
    } else {
      var datastring = '&code=' + productcode + '&size=' + size + '&qty=1&sectionURL=' + encodeURIComponent(sectionUrl) + '&d=' + department;
      if (_btn.hasClass("favorite-button--active")) {
        datastring = datastring + "&cond=remove";
      } else {
        var wishlistCountUpdater = new WishlistCountUpdater();
        if (wishlistCountUpdater.showWishListMaxRestrictionPopup()) {
          return;
        }
      }
      var postUrl = "/fw/mobile/ajaxAddToWishlist.jsp?" + datastring;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: "POST",
        url: postUrl,
        success: function success(ajaxResponse) {
          try {
            var responseObject = JSON.parse(ajaxResponse.trim());
            if (responseObject.maxPopup) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('count', responseObject.data);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('limit', responseObject.limit);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wish-max-popup-div').empty().append(responseObject.maxPopup);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                triggerOpen: true,
                open: "restrict-favorites"
              });
              return;
            }
          } catch (e) {}
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wish_nav_mpdp").css("display", "none");

          //wishlist button in plp
          var wishlistNotifyText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlistNotifyText");
          if (_btn.hasClass("favorite-button--active")) {
            wishlistNotifyText.text(wishlistNotifyText.data("wishlistadded"));
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wishlist-link').removeClass('u-hide');
            _btn.removeClass("favorite-button--active");
            if (typeof gaUpdateWishList === 'function') {
              gaUpdateWishList('remove', productcode);
            }
            if (typeof insertCordialUpdateWishList === 'function') {
              insertCordialUpdateWishList('remove', productcode);
            }
            if (typeof taboolaWishListAction === 'function') {
              taboolaWishListAction("remove", productcode);
            }
            if (typeof brazeAddToFavorites === 'function') {
              if (window.rcProps.pdp !== undefined) {
                brazeAddToFavorites('remove', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
              } else {
                brazeAddToFavorites('remove', productcode, _btn.data('name'), _btn.data('size'), _btn.data('imageurl'), _btn.data('pdpurl'), _btn.data('price'), _btn.data('currency'), _btn.data('department'), _btn.data('color'), _btn.data('brand'), _btn.data('category'), _btn.data('cat1'));
              }
            }
          } else {
            wishlistNotifyText.text(wishlistNotifyText.data("wishlistremoved"));
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wishlist-link').addClass('u-hide');
            _btn.addClass("favorite-button--active");
            if (typeof gaUpdateWishList === 'function') {
              gaUpdateWishList('add', productcode);
            }
            if (typeof iPinYouHeartItem === 'function') {
              iPinYouHeartItem(productcode);
            }
            if (typeof insertRTBHouseHeartItem === 'function') {
              insertRTBHouseHeartItem(productcode);
            }
            if (typeof insertCordialUpdateWishList === 'function') {
              insertCordialUpdateWishList('add', productcode);
            }
            if (typeof taboolaWishListAction === 'function') {
              taboolaWishListAction("add", productcode);
            }
            if (typeof brazeAddToFavorites === 'function') {
              if (window.rcProps.pdp !== undefined) {
                brazeAddToFavorites('add', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
              } else {
                brazeAddToFavorites('add', productcode, _btn.data('name'), _btn.data('size'), _btn.data('imageurl'), _btn.data('pdpurl'), _btn.data('price'), _btn.data('currency'), _btn.data('department'), _btn.data('color'), _btn.data('brand'), _btn.data('category'), _btn.data('cat1'));
              }
            }
          }
          if (typeof window.rcProps.wishlist != "undefined") {
            updateFavoritesMessage(_btn);
          }
          //Update header wishlist count
          var wishlistCountUpdater = new WishlistCountUpdater();
          wishlistCountUpdater.updateCount();
        }
      });
    }
  }
  function updateFavoritesMessage(favBtn) {
    if (!favBtn || favBtn.length == 0) return;
    var favoriteMsg = window.rcProps.wishlist.favoriteMsg;
    var unfavoriteMsg = window.rcProps.wishlist.unfavoriteMsg;
    var favoriteNote = window.rcProps.wishlist.favoriteNote;
    var unfavoriteNote = window.rcProps.wishlist.unfavoriteNote;
    var notificationContainer = '.js-favorite-notify';
    var productDescription = favBtn.data('product-description');

    // Set messaging based on current data attribute value and rcProps values
    var favMessage = "";
    favMessage += favoriteMsg;
    favMessage += productDescription;
    var unFavMessage = "";
    unFavMessage += unfavoriteMsg;
    unFavMessage += productDescription;
    var favNotification = "";
    favNotification += productDescription;
    favNotification += favoriteNote;
    var unFavNotification = "";
    unFavNotification += productDescription;
    unFavNotification += unfavoriteNote;
    var isFav = !favBtn.hasClass('favorite-button--active');
    if (isFav) {
      favBtn.find('.u-screen-reader').html(favMessage);
      favBtn.parent().find(notificationContainer).html(unFavNotification);
    } else {
      favBtn.find('.u-screen-reader').html(unFavMessage);
      favBtn.parent().find(notificationContainer).html(favNotification);
    }
  }
  function showWishListPopup(signInCreateAccount) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "/fw/content/wishlist/login?href=" + encodeURIComponent(signInCreateAccount),
      type: "top",
      triggerOpen: true
    });
  }
  function checkWihlistTagId() {
    if (!window.rcProps || !window.rcProps.wishlist) return;
    var wishlistTagId = window.rcProps.wishlist.wishlistTagId;
    if (window.location.search.includes(wishlistTagId)) {
      var urlparts = window.location.search.split('?');
      if (urlparts.length >= 2) {
        var pars = urlparts[1].split(/[&;]/g);
        for (var i = 0; i < pars.length; i++) {
          console.log('pars[i] = ' + pars[i]);
          if (pars[i].includes(wishlistTagId)) {
            var pair = pars[i].split('=');
            if (pair.length > 0) {
              console.log('pair[1] = ' + pair[1]);
              console.log('document.getElementById(pair[1]) = ' + document.getElementById(pair[1]));
              if (document.getElementById(pair[1])) {
                console.log('scrollIntoView');
                document.getElementById(pair[1]).scrollIntoView();
              }
            }
          }
        }
      }
    }
  }
  return {
    checkWihlistTagId: checkWihlistTagId,
    bindWishListEvent: function bindWishListEvent() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').off('click').on('click', function (e) {
        var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
        var oneSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('oneSize');
        if (typeof code !== "undefined") {
          addToWishList(code, oneSize);
          iPinYouHeartItem(code);
        }
      });
    }
  };
}();
/* harmony default export */ __webpack_exports__["a"] = (wishlistModule);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    getRawTag = __webpack_require__(63),
    objectToString = __webpack_require__(64);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Keyboard JS
 * Parses keyboard events
 * Trap the focus in the given element
 */


var keyCodes = {
  9: 'TAB',
  13: 'ENTER',
  27: 'ESCAPE',
  32: 'SPACE',
  37: 'ARROWLEFT',
  38: 'ARROWUP',
  39: 'ARROWRIGHT',
  40: 'ARROWDOWN'
};
/*
 * Constants for easier comparing.
 * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
 */
var getKeyCodes = function getKeyCodes(kcs) {
  var k = {};
  Object.keys(kcs).forEach(function (key) {
    k[kcs[key]] = kcs[key];
  });
  return k;
};
var Keyboard = {
  keys: getKeyCodes(keyCodes),
  /**
   * Parses the (keyboard) event and returns a String that represents its key
   * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
   * @param {Event} event - the event generated by the event handler
   * @return String key - String that represents the key pressed
   */
  parseKey: function parseKey(event) {
    var key;
    if (event.key !== undefined) {
      if (event.key === ' ') {
        key = 'SPACE';
      } else {
        key = event.key.toUpperCase();
      }
    } else {
      key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
    }

    // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
    key = key.replace(/\W+/, '');
    if (event.shiftKey) key = "SHIFT_".concat(key);
    if (event.ctrlKey) key = "CTRL_".concat(key);
    if (event.altKey) key = "ALT_".concat(key);

    // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
    key = key.replace(/_$/, '');
    return key;
  },
  /**
   * Finds all focusable elements within the given `$element`
   * @param {jQuery} $el - jQuery object to search within
   * @return {jQuery} $focusable - all focusable elements within `$el`
   */
  findFocusable: function findFocusable($el) {
    // only have visible elements and those that have a tabindex greater or equal 0
    return $el.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(':visible').filter(function (index, el) {
      return el.getAttribute('tabindex') >= 0;
    });
  },
  /**
   * Traps the focus in the given element.
   * @param  {jQuery} $el - jQuery object to trap the foucs into.
   */
  trapFocus: function trapFocus($el) {
    $el.on('keydown.trapfocus', function (event) {
      var parsedKey = Keyboard.parseKey(event);
      if (parsedKey === 'TAB' || parsedKey === 'SHIFT_TAB') {
        // New element might be loaded. If the target is the same as the last,
        // attempt to rerun trapFocus Logic.
        var $focusable = Keyboard.findFocusable($el);
        var $firstFocusable = $focusable.eq(0);
        var $lastFocusable = $focusable.eq(-1);
        if (parsedKey === 'TAB' && event.target === $lastFocusable[0]) {
          event.preventDefault();
          $firstFocusable.focus();
        } else if (parsedKey === 'SHIFT_TAB') {
          if (event.target === $firstFocusable[0]) {
            event.preventDefault();
            $lastFocusable.focus();
          }

          //Accounting for firstFocusable possibly being in a list that could change
          if (event.target.name === $firstFocusable[0].name && $firstFocusable[0].name !== '') {
            event.preventDefault();
            $lastFocusable.focus();
          }
          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(event.target, $focusable) === -1) {
            $lastFocusable.focus();
          }
        }
      }
    });
  },
  /**
   * Releases the trapped focus from the given element.
   * @param  {jQuery} $el  jQuery object to release the focus for.
   * @param  {jQuery} $lastFocus return to last focus
   */
  releaseFocus: function releaseFocus($el, $lastFocus) {
    $el.off('keydown.trapfocus');
    if ($lastFocus) {
      $lastFocus.focus();
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Keyboard);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logEngagement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function logEngagement(url, module, action, params) {
  if (!url) {
    url = window.location.href;
  }
  if (params) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + (typeof params === 'string' || params instanceof String ? params : __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(params));
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: url,
      module: module,
      action: action
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false Mustache: true*/

(function defineMustache (global, factory) {
  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
    factory(exports); // CommonJS
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
  } else {
    global.Mustache = {};
    factory(global.Mustache); // script, wsh, asp
  }
}(this, function mustacheFactory (mustache) {

  var objectToString = Object.prototype.toString;
  var isArray = Array.isArray || function isArrayPolyfill (object) {
    return objectToString.call(object) === '[object Array]';
  };

  function isFunction (object) {
    return typeof object === 'function';
  }

  /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */
  function typeStr (obj) {
    return isArray(obj) ? 'array' : typeof obj;
  }

  function escapeRegExp (string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
  }

  /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */
  function hasProperty (obj, propName) {
    return obj != null && typeof obj === 'object' && (propName in obj);
  }

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var regExpTest = RegExp.prototype.test;
  function testRegExp (re, string) {
    return regExpTest.call(re, string);
  }

  var nonSpaceRe = /\S/;
  function isWhitespace (string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };

  function escapeHtml (string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
      return entityMap[s];
    });
  }

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   */
  function parseTemplate (template, tags) {
    if (!template)
      return [];

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace () {
      if (hasTag && !nonSpace) {
        while (spaces.length)
          delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var openingTagRe, closingTagRe, closingCurlyRe;
    function compileTags (tagsToCompile) {
      if (typeof tagsToCompile === 'string')
        tagsToCompile = tagsToCompile.split(spaceRe, 2);

      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error('Invalid tags: ' + tagsToCompile);

      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
    }

    compileTags(tags || mustache.tags);

    var scanner = new Scanner(template);

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(openingTagRe);

      if (value) {
        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push([ 'text', chr, start, start + 1 ]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n')
            stripSpace();
        }
      }

      // Match the opening tag.
      if (!scanner.scan(openingTagRe))
        break;

      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === '{') {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = '&';
      } else {
        value = scanner.scanUntil(closingTagRe);
      }

      // Match the closing tag.
      if (!scanner.scan(closingTagRe))
        throw new Error('Unclosed tag at ' + scanner.pos);

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);

        if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        compileTags(value);
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();

    if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens (tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens (tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      switch (token[0]) {
        case '#':
        case '^':
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case '/':
          section = sections.pop();
          section[5] = token[2];
          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner (string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function eos () {
    return this.tail === '';
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function scan (re) {
    var match = this.tail.match(re);

    if (!match || match.index !== 0)
      return '';

    var string = match[0];

    this.tail = this.tail.substring(string.length);
    this.pos += string.length;

    return string;
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function scanUntil (re) {
    var index = this.tail.search(re), match;

    switch (index) {
      case -1:
        match = this.tail;
        this.tail = '';
        break;
      case 0:
        match = '';
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context (view, parentContext) {
    this.view = view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function push (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function lookup (name) {
    var cache = this.cache;

    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this, names, index, lookupHit = false;

      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;
          names = name.split('.');
          index = 0;

          /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           **/
          while (value != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit = hasProperty(value, names[index]);

            value = value[names[index++]];
          }
        } else {
          value = context.view[name];
          lookupHit = hasProperty(context.view, name);
        }

        if (lookupHit)
          break;

        context = context.parent;
      }

      cache[name] = value;
    }

    if (isFunction(value))
      value = value.call(this.view);

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer () {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function clearCache () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function parse (template, tags) {
    var cache = this.cache;
    var tokens = cache[template];

    if (tokens == null)
      tokens = cache[template] = parseTemplate(template, tags);

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   */
  Writer.prototype.render = function render (template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
    var buffer = '';

    var token, symbol, value;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      value = undefined;
      token = tokens[i];
      symbol = token[0];

      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
      else if (symbol === '&') value = this.unescapedValue(token, context);
      else if (symbol === 'name') value = this.escapedValue(token, context);
      else if (symbol === 'text') value = this.rawValue(token);

      if (value !== undefined)
        buffer += value;
    }

    return buffer;
  };

  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
    var self = this;
    var buffer = '';
    var value = context.lookup(token[1]);

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    function subRender (template) {
      return self.render(template, context, partials);
    }

    if (!value) return;

    if (isArray(value)) {
      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
      }
    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== 'string')
        throw new Error('Cannot use higher-order sections without the original template');

      // Extract the portion of the original template that the section contains.
      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

      if (value != null)
        buffer += value;
    } else {
      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
    }
    return buffer;
  };

  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
    var value = context.lookup(token[1]);

    // Use JavaScript's definition of falsy. Include empty arrays.
    // See https://github.com/janl/mustache.js/issues/186
    if (!value || (isArray(value) && value.length === 0))
      return this.renderTokens(token[4], context, partials, originalTemplate);
  };

  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
    if (!partials) return;

    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null)
      return this.renderTokens(this.parse(value), context, partials, value);
  };

  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return value;
  };

  Writer.prototype.escapedValue = function escapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return mustache.escape(value);
  };

  Writer.prototype.rawValue = function rawValue (token) {
    return token[1];
  };

  mustache.name = 'mustache.js';
  mustache.version = '2.3.2';
  mustache.tags = [ '{{', '}}' ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function clearCache () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function parse (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  mustache.render = function render (template, view, partials) {
    if (typeof template !== 'string') {
      throw new TypeError('Invalid template! Template should be a "string" ' +
                          'but "' + typeStr(template) + '" was given as the first ' +
                          'argument for mustache#render(template, view, partials)');
    }

    return defaultWriter.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.,
  /*eslint-disable */ // eslint wants camel cased function name
  mustache.to_html = function to_html (template, view, partials, send) {
    /*eslint-enable*/

    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

  return mustache;
}));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateStore */
/* unused harmony export clearStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_property__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clone__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_clone__);
/**
 * Responsible for setting up page specific properties. These properties are
 * intended to be used for environment specific properties such as URLs or
 * values that are used throughout multiple pages.
 * @module lib/props
 */



var props = window.rcProps || {};

/**
 * Responsible for overriding the existing store.
 * @param {Object} obj - Values used for replacing the store
 */
var updateStore = function updateStore(obj) {
  props = obj;
};

/**
 * Responsible for clearing or wiping out a store.
 */
var clearStore = function clearStore() {
  props = {};
};

/**
 * Responsible for obtaining a value from a store of properties. It will accept
 * a defaultValue if no value is found in the store. To ensure safety in
 * obtaining a value, the name takes a string in dot notation in order of
 * object nesting.
 *
 * @example
 * get('character');
 * get('character.bowls.onShabbos');
 * get('character.bowls.onShabbos', true);
 * @param {string} name - Property name looked up
 * @param {string} defaultValue - Provided if no property exists
 * @return {*} The value coming from the store
 */
var get = function get(name, defaultValue) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(name)) {
    throw new Error('A property name is required when getting a property value');
  }
  /**
   * props represents window.rcProps
   * checks for if name has rcProps and removes it
   */
  var rcPropsPrefix = 'rcProps.';
  var nameHasRCProps = name.indexOf(rcPropsPrefix) === 0;
  var finalName = nameHasRCProps ? name.slice(rcPropsPrefix.length) : name;
  var value = __WEBPACK_IMPORTED_MODULE_1_lodash_property___default()(finalName)(props);
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(value)) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_clone___default()(value);
  }
  return defaultValue;
};

/**
 * Responsible for setting a value in the store. In most cases, properties
 * will already be predefined, but this exists in case any properties need to
 * set dynamically or on demand. It will ensure that values overridden are
 * intentional by providing a flag.
 * @param {string} name - Property name used for setting
 * @param {*} value - The value of the property
 * @param {boolean} [override=false] - Allows a property to be overriden
 */
var set = function set(name, value) {
  var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(name)) {
    throw new Error('A property name is required when setting a property');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(value)) {
    throw new Error('A property value is required when setting a property');
  }
  var existingValue = get(name);
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(existingValue) && !override) {
    throw new Error('Cannot override an existing property. If this is intentional, then pass the override flag.');
  }
  props[name] = value;
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(111),
    baseAssignValue = __webpack_require__(112);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(329),
    getValue = __webpack_require__(370);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isArray = __webpack_require__(22),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;
(function (factory) {
  'use strict';

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  var Slick = window.Slick || {};
  Slick = function () {
    var instanceUid = 0;
    function Slick(element, settings) {
      var _ = this,
        dataSettings;
      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(slider, i) {
          return $('<button type="button" />').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        focusOnChange: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };
      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: false,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        swiping: false,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };
      $.extend(_, _.initials);
      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;
      dataSettings = $(element).data('slick') || {};
      _.options = $.extend({}, _.defaults, settings, dataSettings);
      _.currentSlide = _.options.initialSlide;
      _.originalSettings = _.options;
      if (typeof document.mozHidden !== 'undefined') {
        _.hidden = 'mozHidden';
        _.visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        _.hidden = 'webkitHidden';
        _.visibilityChange = 'webkitvisibilitychange';
      }
      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);
      _.instanceUid = instanceUid++;

      // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source
      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
      _.registerBreakpoints();
      _.init(true);
    }
    return Slick;
  }();
  Slick.prototype.activateADA = function () {
    var _ = this;
    _.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      'tabindex': '0'
    });
  };
  Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
    var _ = this;
    if (typeof index === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || index >= _.slideCount) {
      return false;
    }
    _.unload();
    if (typeof index === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index);
    });
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.animateHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.animate({
        height: targetHeight
      }, _.options.speed);
    }
  };
  Slick.prototype.animateSlide = function (targetLeft, callback) {
    var animProps = {},
      _ = this;
    _.animateHeight();
    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }
    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({
          left: targetLeft
        }, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({
          top: targetLeft
        }, _.options.speed, _.options.easing, callback);
      }
    } else {
      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -_.currentLeft;
        }
        $({
          animStart: _.currentLeft
        }).animate({
          animStart: targetLeft
        }, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function step(now) {
            now = Math.ceil(now);
            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' + now + 'px, 0px)';
              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' + now + 'px)';
              _.$slideTrack.css(animProps);
            }
          },
          complete: function complete() {
            if (callback) {
              callback.call();
            }
          }
        });
      } else {
        _.applyTransition();
        targetLeft = Math.ceil(targetLeft);
        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }
        _.$slideTrack.css(animProps);
        if (callback) {
          setTimeout(function () {
            _.disableTransition();
            callback.call();
          }, _.options.speed);
        }
      }
    }
  };
  Slick.prototype.getNavTarget = function () {
    var _ = this,
      asNavFor = _.options.asNavFor;
    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }
    return asNavFor;
  };
  Slick.prototype.asNavFor = function (index) {
    var _ = this,
      asNavFor = _.getNavTarget();
    if (asNavFor !== null && _typeof(asNavFor) === 'object') {
      asNavFor.each(function () {
        var target = $(this).slick('getSlick');
        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }
  };
  Slick.prototype.applyTransition = function (slide) {
    var _ = this,
      transition = {};
    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.autoPlay = function () {
    var _ = this;
    _.autoPlayClear();
    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }
  };
  Slick.prototype.autoPlayClear = function () {
    var _ = this;
    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }
  };
  Slick.prototype.autoPlayIterator = function () {
    var _ = this,
      slideTo = _.currentSlide + _.options.slidesToScroll;
    if (!_.paused && !_.interrupted && !_.focussed) {
      if (_.options.infinite === false) {
        if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
          _.direction = 0;
        } else if (_.direction === 0) {
          slideTo = _.currentSlide - _.options.slidesToScroll;
          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }
        }
      }
      _.slideHandler(slideTo);
    }
  };
  Slick.prototype.buildArrows = function () {
    var _ = this;
    if (_.options.arrows === true) {
      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
      if (_.slideCount > _.options.slidesToShow) {
        _.$prevArrow.removeClass('slick-hidden slick-disabled').removeAttr('aria-hidden tabindex');
        _.$nextArrow.removeClass('slick-hidden slick-disabled').removeAttr('aria-hidden tabindex');
        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }
        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }
        if (_.options.infinite !== true) {
          _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      } else {
        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden slick-disabled').attr({
          'aria-disabled': 'true',
          'tabindex': '-1'
        });
      }
    }
  };
  Slick.prototype.buildDots = function () {
    var _ = this,
      i,
      dot;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$slider.addClass('slick-dotted');
      dot = $('<ul />').addClass(_.options.dotsClass);
      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
      }
      _.$dots = dot.appendTo(_.options.appendDots);
      _.$dots.find('li').first().addClass('slick-active');
    }
  };
  Slick.prototype.buildOut = function () {
    var _ = this;
    _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
    _.slideCount = _.$slides.length;
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
    });
    _.$slider.addClass('slick-slider');
    _.$slideTrack = _.slideCount === 0 ? $('<ul class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<ul class="slick-track"/>').parent();
    _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
    _.$slideTrack.css('opacity', 0);
    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }
    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
    _.setupInfinite();
    _.buildArrows();
    _.buildDots();
    _.updateDots();
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }
  };
  Slick.prototype.buildRows = function () {
    var _ = this,
      a,
      b,
      c,
      newSlides,
      numOfSlides,
      originalSlides,
      slidesPerSection;
    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();
    if (_.options.rows > 0) {
      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('li');
        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');
          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }
          slide.appendChild(row);
        }
        newSlides.appendChild(slide);
      }
      _.$slider.empty().append(newSlides);
      _.$slider.children().children().children().css({
        'width': 100 / _.options.slidesPerRow + '%',
        'display': 'inline-block'
      });
    }
  };
  Slick.prototype.checkResponsive = function (initial, forceUpdate) {
    var _ = this,
      breakpoint,
      targetBreakpoint,
      respondToWidth,
      triggerBreakpoint = false;
    var sliderWidth = _.$slider.width();
    var windowWidth = window.innerWidth || $(window).width();
    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }
    if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
      targetBreakpoint = null;
      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }
      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint = targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;
          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;
          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }
          _.refresh(initial);
          triggerBreakpoint = targetBreakpoint;
        }
      }

      // only trigger breakpoints during an actual break. not on initialize.
      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }
  };
  Slick.prototype.changeSlide = function (event, dontAnimate) {
    var _ = this,
      $target = $(event.currentTarget),
      indexOffset,
      slideOffset,
      unevenOffset;

    // If target is a link, prevent default action.
    if ($target.is('a')) {
      event.preventDefault();
    }

    // If target is not the <li> element (ie: a child), find the <li>.
    if (!$target.is('li')) {
      $target = $target.closest('li');
    }
    unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
    switch (event.data.message) {
      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }
        break;
      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }
        break;
      case 'index':
        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
        _.slideHandler(_.checkNavigable(index), false, dontAnimate);
        $target.children().trigger('focus');
        break;
      default:
        return;
    }
  };
  Slick.prototype.checkNavigable = function (index) {
    var _ = this,
      navigables,
      prevNavigable;
    navigables = _.getNavigableIndexes();
    prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }
    return index;
  };
  Slick.prototype.cleanUpEvents = function () {
    var _ = this;
    if (_.options.dots && _.$dots !== null) {
      $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
      if (_.options.accessibility === true) {
        _.$dots.off('keydown.slick', _.keyHandler);
      }
    }
    _.$slider.off('focus.slick blur.slick');
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
        _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
      }
    }
    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
    _.$list.off('click.slick', _.clickHandler);
    $(document).off(_.visibilityChange, _.visibility);
    _.cleanUpSlideEvents();
    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }
    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
  };
  Slick.prototype.cleanUpSlideEvents = function () {
    var _ = this;
    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
  };
  Slick.prototype.cleanUpRows = function () {
    var _ = this,
      originalSlides;
    if (_.options.rows > 0) {
      originalSlides = _.$slides.children().children();
      originalSlides.removeAttr('style');
      _.$slider.empty().append(originalSlides);
    }
  };
  Slick.prototype.clickHandler = function (event) {
    var _ = this;
    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  };
  Slick.prototype.destroy = function (refresh) {
    var _ = this;
    _.autoPlayClear();
    _.touchObject = {};
    _.cleanUpEvents();
    $('.slick-cloned', _.$slider).detach();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.$prevArrow.length) {
      _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }
    if (_.$nextArrow && _.$nextArrow.length) {
      _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }
    if (_.$slides) {
      _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
        $(this).attr('style', $(this).data('originalStyling'));
      });
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.detach();
      _.$list.detach();
      _.$slider.append(_.$slides);
    }
    _.cleanUpRows();
    _.$slider.removeClass('slick-slider');
    _.$slider.removeClass('slick-initialized');
    _.$slider.removeClass('slick-dotted');
    _.unslicked = true;
    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }
  };
  Slick.prototype.disableTransition = function (slide) {
    var _ = this,
      transition = {};
    transition[_.transitionType] = '';
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.fadeSlide = function (slideIndex, callback) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).css({
        zIndex: _.options.zIndex
      });
      _.$slides.eq(slideIndex).animate({
        opacity: 1
      }, _.options.speed, _.options.easing, callback);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });
      if (callback) {
        setTimeout(function () {
          _.disableTransition(slideIndex);
          callback.call();
        }, _.options.speed);
      }
    }
  };
  Slick.prototype.fadeSlideOut = function (slideIndex) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });
    }
  };
  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
    var _ = this;
    if (filter !== null) {
      _.$slidesCache = _.$slides;
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.focusHandler = function () {
    var _ = this;
    _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {
      event.stopImmediatePropagation();
      var $sf = $(this);
      setTimeout(function () {
        if (_.options.pauseOnFocus) {
          _.focussed = $sf.is(':focus');
          _.autoPlay();
        }
      }, 0);
    });
  };
  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
    var _ = this;
    return _.currentSlide;
  };
  Slick.prototype.getDotCount = function () {
    var _ = this;
    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;
    if (_.options.infinite === true) {
      if (_.slideCount <= _.options.slidesToShow) {
        ++pagerQty;
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }
    return pagerQty - 1;
  };
  Slick.prototype.getLeft = function (slideIndex) {
    var _ = this,
      targetLeft,
      verticalHeight,
      verticalOffset = 0,
      targetSlide,
      coef;
    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);
    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
        coef = -1;
        if (_.options.vertical === true && _.options.centerMode === true) {
          if (_.options.slidesToShow === 2) {
            coef = -1.5;
          } else if (_.options.slidesToShow === 1) {
            coef = -2;
          }
        }
        verticalOffset = verticalHeight * _.options.slidesToShow * coef;
      }
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
            verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
          } else {
            _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
            verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
        verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
      }
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }
    if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
      _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
    } else if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }
    if (_.options.vertical === false) {
      targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
    } else {
      targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
    }
    if (_.options.variableWidth === true) {
      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }
      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }
      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }
        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }
        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }
    return targetLeft;
  };
  Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
    var _ = this;
    return _.options[option];
  };
  Slick.prototype.getNavigableIndexes = function () {
    var _ = this,
      breakPoint = 0,
      counter = 0,
      indexes = [],
      max;
    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }
    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }
    return indexes;
  };
  Slick.prototype.getSlick = function () {
    return this;
  };
  Slick.prototype.getSlideCount = function () {
    var _ = this,
      slidesTraversed,
      swipedSlide,
      centerOffset;
    centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function (index, slide) {
        if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      });
      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
      return slidesTraversed;
    } else {
      return _.options.slidesToScroll;
    }
  };
  Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'index',
        index: parseInt(slide)
      }
    }, dontAnimate);
  };
  Slick.prototype.init = function (creation) {
    var _ = this;
    if (!$(_.$slider).hasClass('slick-initialized')) {
      $(_.$slider).addClass('slick-initialized');
      _.buildRows();
      _.buildOut();
      _.setProps();
      _.startLoad();
      _.loadSlider();
      _.initializeEvents();
      _.updateArrows();
      _.updateDots();
      _.checkResponsive(true);
      _.focusHandler();
    }
    if (creation) {
      _.$slider.trigger('init', [_]);
    }
    if (_.options.accessibility === true) {
      _.initADA();
    }
    if (_.options.autoplay) {
      _.paused = false;
      _.autoPlay();
    }
  };
  Slick.prototype.initADA = function () {
    var _ = this,
      numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
      tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
        return val >= 0 && val < _.slideCount;
      });
    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    }).find('a, input, button, select').attr({
      'tabindex': '-1'
    });
    if (_.$dots !== null) {
      _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
        var slideControlIndex = tabControlIndexes.indexOf(i);
        $(this).attr({
          'role': 'tabpanel',
          'id': 'slick-slide' + _.instanceUid + i,
          'tabindex': -1
        });
        if (slideControlIndex !== -1) {
          var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
          if ($('#' + ariaButtonControl).length) {
            $(this).attr({
              'aria-describedby': ariaButtonControl
            });
          }
        }
      });
      _.$dots.attr('role', 'tablist').find('li').each(function (i) {
        var mappedSlideIndex = tabControlIndexes[i];
        $(this).attr({
          'role': 'presentation'
        });
        $(this).find('button').first().attr({
          'role': 'button',
          'id': 'slick-slide-control' + _.instanceUid + i,
          'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
          'aria-label': i + 1 + ' of ' + numDotGroups,
          'aria-selected': null,
          'tabindex': '0'
        });
      }).eq(_.currentSlide).find('button').attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).end();
    }
    for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
      if (_.options.focusOnChange) {
        _.$slides.eq(i).attr({
          'tabindex': '0'
        });
      } else {
        _.$slides.eq(i).removeAttr('tabindex');
      }
    }
    _.activateADA();
  };
  Slick.prototype.initArrowEvents = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.off('click.slick').on('click.slick', {
        message: 'previous'
      }, _.changeSlide);
      _.$nextArrow.off('click.slick').on('click.slick', {
        message: 'next'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow.on('keydown.slick', _.keyHandler);
        _.$nextArrow.on('keydown.slick', _.keyHandler);
      }
    }
  };
  Slick.prototype.initDotEvents = function () {
    var _ = this;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {
        message: 'index'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$dots.on('keydown.slick', _.keyHandler);
      }
    }
    if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initSlideEvents = function () {
    var _ = this;
    if (_.options.pauseOnHover) {
      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initializeEvents = function () {
    var _ = this;
    _.initArrowEvents();
    _.initDotEvents();
    _.initSlideEvents();
    _.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, _.swipeHandler);
    _.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, _.swipeHandler);
    _.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('click.slick', _.clickHandler);
    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(_.setPosition);
  };
  Slick.prototype.initUI = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.show();
      _.$nextArrow.show();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.show();
    }
  };
  Slick.prototype.keyHandler = function (event) {
    var _ = this;
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'next' : 'previous'
          }
        });
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'previous' : 'next'
          }
        });
      }
    }
  };
  Slick.prototype.lazyLoad = function () {
    var _ = this,
      loadRange,
      cloneRange,
      rangeStart,
      rangeEnd;
    function loadImages(imagesScope) {
      $('img[data-lazy]', imagesScope).each(function () {
        var image = $(this),
          imageSource = $(this).attr('data-lazy'),
          imageSrcSet = $(this).attr('data-srcset'),
          imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
          imageToLoad = document.createElement('img');
        imageToLoad.onload = function () {
          image.animate({
            opacity: 0
          }, 100, function () {
            if (imageSrcSet) {
              image.attr('srcset', imageSrcSet);
              if (imageSizes) {
                image.attr('sizes', imageSizes);
              }
            }
            image.attr('src', imageSource).animate({
              opacity: 1
            }, 200, function () {
              image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            });
            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
          });
        };
        imageToLoad.onerror = function () {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
        };
        if (imageSrcSet) {
          imageToLoad.srcset = imageSrcSet;
        }
        imageToLoad.src = imageSource;
      });
    }
    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
      if (_.options.fade === true) {
        if (rangeStart > 0) rangeStart--;
        if (rangeEnd <= _.slideCount) rangeEnd++;
      }
    }
    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
    if (_.options.lazyLoad === 'anticipated') {
      var prevSlide = rangeStart - 1,
        nextSlide = rangeEnd,
        $slides = _.$slider.find('.slick-slide');
      for (var i = 0; i < _.options.slidesToScroll; i++) {
        if (prevSlide < 0) prevSlide = _.slideCount - 1;
        loadRange = loadRange.add($slides.eq(prevSlide));
        loadRange = loadRange.add($slides.eq(nextSlide));
        prevSlide--;
        nextSlide++;
      }
    }
    loadImages(loadRange);
    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
      loadImages(cloneRange);
    } else if (_.currentSlide === 0) {
      cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
      loadImages(cloneRange);
    }
  };
  Slick.prototype.loadSlider = function () {
    var _ = this;
    _.setPosition();
    _.$slideTrack.css({
      opacity: 1
    });
    _.$slider.removeClass('slick-loading');
    _.initUI();
    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }
  };
  Slick.prototype.next = Slick.prototype.slickNext = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'next'
      }
    });
  };
  Slick.prototype.orientationChange = function () {
    var _ = this;
    _.checkResponsive();
    _.setPosition();
  };
  Slick.prototype.pause = Slick.prototype.slickPause = function () {
    var _ = this;
    _.autoPlayClear();
    _.paused = true;
  };
  Slick.prototype.play = Slick.prototype.slickPlay = function () {
    var _ = this;
    _.autoPlay();
    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;
  };
  Slick.prototype.postSlide = function (index) {
    var _ = this;
    if (!_.unslicked) {
      _.$slider.trigger('afterChange', [_, index]);
      _.animating = false;
      if (_.slideCount > _.options.slidesToShow) {
        _.setPosition();
      }
      _.swipeLeft = null;
      if (_.options.autoplay) {
        _.autoPlay();
      }
      if (_.options.accessibility === true) {
        _.initADA();
        if (_.options.focusOnChange) {
          var $currentSlide = $(_.$slides.get(_.currentSlide));
          $currentSlide.attr('tabindex', 0).focus();
        }
      }
    }
  };
  Slick.prototype.prev = Slick.prototype.slickPrev = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'previous'
      }
    });
  };
  Slick.prototype.preventDefault = function (event) {
    event.preventDefault();
  };
  Slick.prototype.progressiveLazyLoad = function (tryCount) {
    tryCount = tryCount || 1;
    var _ = this,
      $imgsToLoad = $('img[data-lazy]', _.$slider),
      image,
      imageSource,
      imageSrcSet,
      imageSizes,
      imageToLoad;
    if ($imgsToLoad.length) {
      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageSrcSet = image.attr('data-srcset');
      imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
      imageToLoad = document.createElement('img');
      imageToLoad.onload = function () {
        if (imageSrcSet) {
          image.attr('srcset', imageSrcSet);
          if (imageSizes) {
            image.attr('sizes', imageSizes);
          }
        }
        image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }
        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
        _.progressiveLazyLoad();
      };
      imageToLoad.onerror = function () {
        if (tryCount < 3) {
          /**
           * try to load the image 3 times,
           * leave a slight delay so we don't get
           * servers blocking the request.
           */
          setTimeout(function () {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);
        } else {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
          _.progressiveLazyLoad();
        }
      };
      if (imageSrcSet) {
        imageToLoad.srcset = imageSrcSet;
      }
      imageToLoad.src = imageSource;
    } else {
      _.$slider.trigger('allImagesLoaded', [_]);
    }
  };
  Slick.prototype.refresh = function (initializing) {
    var _ = this,
      currentSlide,
      lastVisibleIndex;
    lastVisibleIndex = _.slideCount - _.options.slidesToShow;

    // in non-infinite sliders, we don't want to go past the
    // last visible index.
    if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
      _.currentSlide = lastVisibleIndex;
    }

    // if less slides than to show, go to start.
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    currentSlide = _.currentSlide;
    _.destroy(true);
    $.extend(_, _.initials, {
      currentSlide: currentSlide
    });
    _.init();
    if (!initializing) {
      _.changeSlide({
        data: {
          message: 'index',
          index: currentSlide
        }
      }, false);
    }
  };
  Slick.prototype.registerBreakpoints = function () {
    var _ = this,
      breakpoint,
      currentBreakpoint,
      l,
      responsiveSettings = _.options.responsive || null;
    if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
      _.respondTo = _.options.respondTo || 'window';
      for (breakpoint in responsiveSettings) {
        l = _.breakpoints.length - 1;
        if (responsiveSettings.hasOwnProperty(breakpoint)) {
          currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

          // loop through the breakpoints and cut out any existing
          // ones with the same breakpoint number, we don't want dupes.
          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }
            l--;
          }
          _.breakpoints.push(currentBreakpoint);
          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
        }
      }
      _.breakpoints.sort(function (a, b) {
        return _.options.mobileFirst ? a - b : b - a;
      });
    }
  };
  Slick.prototype.reinit = function () {
    var _ = this;
    _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
    _.slideCount = _.$slides.length;
    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    _.registerBreakpoints();
    _.setProps();
    _.setupInfinite();
    _.buildArrows();
    _.updateArrows();
    _.initArrowEvents();
    _.buildDots();
    _.updateDots();
    _.initDotEvents();
    _.cleanUpSlideEvents();
    _.initSlideEvents();
    _.checkResponsive(false, true);
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    _.setPosition();
    _.focusHandler();
    _.paused = !_.options.autoplay;
    _.autoPlay();
    _.$slider.trigger('reInit', [_]);
  };
  Slick.prototype.resize = function () {
    var _ = this;
    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function () {
        _.windowWidth = $(window).width();
        _.checkResponsive();
        if (!_.unslicked) {
          _.setPosition();
        }
      }, 50);
    }
  };
  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
    var _ = this;
    if (typeof index === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }
    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }
    _.unload();
    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.setCSS = function (position) {
    var _ = this,
      positionProps = {},
      x,
      y;
    if (_.options.rtl === true) {
      position = -position;
    }
    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
    positionProps[_.positionProp] = position;
    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};
      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
        _.$slideTrack.css(positionProps);
      }
    }
  };
  Slick.prototype.setDimensions = function () {
    var _ = this;
    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: '0px ' + _.options.centerPadding
        });
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: _.options.centerPadding + ' 0px'
        });
      }
    }
    _.listWidth = _.$list.width();
    _.listHeight = _.$list.height();
    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
      _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = Math.ceil(_.listWidth);
      _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
    }
    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
    if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
  };
  Slick.prototype.setFade = function () {
    var _ = this,
      targetLeft;
    _.$slides.each(function (index, element) {
      targetLeft = _.slideWidth * index * -1;
      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      }
    });
    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: 1
    });
  };
  Slick.prototype.setHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.css('height', targetHeight);
    }
  };
  Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
    /**
     * accepts arguments in format of:
     *
     *  - for changing a single option's value:
     *     .slick("setOption", option, value, refresh )
     *
     *  - for changing a set of responsive options:
     *     .slick("setOption", 'responsive', [{}, ...], refresh )
     *
     *  - for updating multiple values at once (not responsive)
     *     .slick("setOption", { 'option': value, ... }, refresh )
     */

    var _ = this,
      l,
      item,
      option,
      value,
      refresh = false,
      type;
    if ($.type(arguments[0]) === 'object') {
      option = arguments[0];
      refresh = arguments[1];
      type = 'multiple';
    } else if ($.type(arguments[0]) === 'string') {
      option = arguments[0];
      value = arguments[1];
      refresh = arguments[2];
      if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
        type = 'responsive';
      } else if (typeof arguments[1] !== 'undefined') {
        type = 'single';
      }
    }
    if (type === 'single') {
      _.options[option] = value;
    } else if (type === 'multiple') {
      $.each(option, function (opt, val) {
        _.options[opt] = val;
      });
    } else if (type === 'responsive') {
      for (item in value) {
        if ($.type(_.options.responsive) !== 'array') {
          _.options.responsive = [value[item]];
        } else {
          l = _.options.responsive.length - 1;

          // loop through the responsive object and splice out duplicates.
          while (l >= 0) {
            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
              _.options.responsive.splice(l, 1);
            }
            l--;
          }
          _.options.responsive.push(value[item]);
        }
      }
    }
    if (refresh) {
      _.unload();
      _.reinit();
    }
  };
  Slick.prototype.setPosition = function () {
    var _ = this;
    _.setDimensions();
    _.setHeight();
    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }
    _.$slider.trigger('setPosition', [_]);
  };
  Slick.prototype.setProps = function () {
    var _ = this,
      bodyStyle = document.body.style;
    _.positionProp = _.options.vertical === true ? 'top' : 'left';
    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }
    if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }
    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }
    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined) _.animType = false;
    }
    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }
    _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
  };
  Slick.prototype.setSlideClasses = function (index) {
    var _ = this,
      centerOffset,
      allSlides,
      indexOffset,
      remainder;
    allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
    _.$slides.eq(index).addClass('slick-current');
    if (_.options.centerMode === true) {
      var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
      centerOffset = Math.floor(_.options.slidesToShow / 2);
      if (_.options.infinite === true) {
        if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
          _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          indexOffset = _.options.slidesToShow + index;
          allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
        }
        if (index === 0) {
          allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
        } else if (index === _.slideCount - 1) {
          allSlides.eq(_.options.slidesToShow).addClass('slick-center');
        }
      }
      _.$slides.eq(index).addClass('slick-center');
    } else {
      if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
      } else if (allSlides.length <= _.options.slidesToShow) {
        allSlides.addClass('slick-active').attr('aria-hidden', 'false');
      } else {
        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
        if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
          allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
        }
      }
    }
    if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
      _.lazyLoad();
    }
  };
  Slick.prototype.setupInfinite = function () {
    var _ = this,
      i,
      slideIndex,
      infiniteCount;
    if (_.options.fade === true) {
      _.options.centerMode = false;
    }
    if (_.options.infinite === true && _.options.fade === false) {
      slideIndex = null;
      if (_.slideCount > _.options.slidesToShow) {
        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }
        for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
        }
        for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
        }
        _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
          $(this).attr('id', '');
        });
      }
    }
  };
  Slick.prototype.interrupt = function (toggle) {
    var _ = this;
    if (!toggle) {
      _.autoPlay();
    }
    _.interrupted = toggle;
  };
  Slick.prototype.selectHandler = function (event) {
    var _ = this;
    var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
    var index = parseInt(targetElement.attr('data-slick-index'));
    if (!index) index = 0;
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideHandler(index, false, true);
      return;
    }
    _.slideHandler(index);
  };
  Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
    var targetSlide,
      animSlide,
      oldSlide,
      slideLeft,
      targetLeft = null,
      _ = this,
      navTarget;
    sync = sync || false;
    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }
    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }
    if (sync === false) {
      _.asNavFor(index);
    }
    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);
    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    }
    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }
    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }
    _.animating = true;
    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;
    _.setSlideClasses(_.currentSlide);
    if (_.options.asNavFor) {
      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');
      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }
    }
    _.updateDots();
    _.updateArrows();
    if (_.options.fade === true) {
      if (dontAnimate !== true) {
        _.fadeSlideOut(oldSlide);
        _.fadeSlide(animSlide, function () {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }
      _.animateHeight();
      return;
    }
    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
      _.animateSlide(targetLeft, function () {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }
  };
  Slick.prototype.startLoad = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.hide();
      _.$nextArrow.hide();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.hide();
    }
    _.$slider.addClass('slick-loading');
  };
  Slick.prototype.swipeDirection = function () {
    var xDist,
      yDist,
      r,
      swipeAngle,
      _ = this;
    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return _.options.rtl === false ? 'right' : 'left';
    }
    if (_.options.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }
    return 'vertical';
  };
  Slick.prototype.swipeEnd = function (event) {
    var _ = this,
      slideCount,
      direction;
    _.dragging = false;
    _.swiping = false;
    if (_.scrolling) {
      _.scrolling = false;
      return false;
    }
    _.interrupted = false;
    _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
    if (_.touchObject.curX === undefined) {
      return false;
    }
    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }
    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
      direction = _.swipeDirection();
      switch (direction) {
        case 'left':
        case 'down':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
          _.currentDirection = 0;
          break;
        case 'right':
        case 'up':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
          _.currentDirection = 1;
          break;
        default:
      }
      if (direction != 'vertical') {
        _.slideHandler(slideCount);
        _.touchObject = {};
        _.$slider.trigger('swipe', [_, direction]);
      }
    } else {
      if (_.touchObject.startX !== _.touchObject.curX) {
        _.slideHandler(_.currentSlide);
        _.touchObject = {};
      }
    }
  };
  Slick.prototype.swipeHandler = function (event) {
    var _ = this;
    if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }
    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
    _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
    }
    switch (event.data.action) {
      case 'start':
        _.swipeStart(event);
        break;
      case 'move':
        _.swipeMove(event);
        break;
      case 'end':
        _.swipeEnd(event);
        break;
    }
  };
  Slick.prototype.swipeMove = function (event) {
    var _ = this,
      edgeWasHit = false,
      curLeft,
      swipeDirection,
      swipeLength,
      positionOffset,
      touches,
      verticalSwipeLength;
    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
    if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
      return false;
    }
    curLeft = _.getLeft(_.currentSlide);
    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
    _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
    verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
      _.scrolling = true;
      return false;
    }
    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = verticalSwipeLength;
    }
    swipeDirection = _.swipeDirection();
    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      _.swiping = true;
      event.preventDefault();
    }
    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }
    swipeLength = _.touchObject.swipeLength;
    _.touchObject.edgeHit = false;
    if (_.options.infinite === false) {
      if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }
    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
    }
    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }
    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }
    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }
    _.setCSS(_.swipeLeft);
  };
  Slick.prototype.swipeStart = function (event) {
    var _ = this,
      touches;
    _.interrupted = true;
    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }
    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }
    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
    _.dragging = true;
  };
  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
    var _ = this;
    if (_.$slidesCache !== null) {
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.unload = function () {
    var _ = this;
    $('.slick-cloned', _.$slider).remove();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }
    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }
    _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  };
  Slick.prototype.unslick = function (fromBreakpoint) {
    var _ = this;
    _.$slider.trigger('unslick', [_, fromBreakpoint]);
    _.destroy();
  };
  Slick.prototype.updateArrows = function () {
    var _ = this,
      centerOffset;
    centerOffset = Math.floor(_.options.slidesToShow / 2);
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      if (_.currentSlide === 0) {
        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      }
    }
  };
  Slick.prototype.updateDots = function () {
    var _ = this;
    if (_.$dots !== null) {
      _.$dots.find('li').removeClass('slick-active').end();
      _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
    }
  };
  Slick.prototype.visibility = function () {
    var _ = this;
    if (_.options.autoplay) {
      if (document[_.hidden]) {
        _.interrupted = true;
      } else {
        _.interrupted = false;
      }
    }
  };
  $.fn.slick = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (_typeof(opt) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };
});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(126),
    isLength = __webpack_require__(127);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(145),
    baseKeys = __webpack_require__(332),
    isArrayLike = __webpack_require__(68);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TYPES; });
/* harmony export (immutable) */ __webpack_exports__["a"] = floatingLabel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_property__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_symbol__);
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible initiating a floating label and sending events down to any
 * callers or extended functionality.
 * @module floatingLabel
 */



/**
 * Defines default options for a floating LABEL
 * @type {Object}
 */
var FLOATING_LABEL_OPTIONS = {
  block: 'floating-label',
  fieldElements: ['input', 'select', 'textarea'],
  labelElement: 'label',
  callers: []
};

/**
 * Defines the different types of supported events.
 * @type {Object}
 */
var EVENTS = {
  FOCUS: 'focus',
  BLUR: 'blur',
  INVALID: 'invalid',
  INPUT: 'input',
  LOAD: 'load'
};

/**
 * Defines the types associated to the elements within a floating label. It
 * uses Symbol as the value so that unique values can be used without caring
 * about conflicts values. Think of this similar to an Enum or an IOTA.
 * @enum
 * @type {Object}
 */
var TYPES = {
  CONTAINER: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('container'),
  LABEL: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('label'),
  FIELD: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('field')
};

/**
 * Creates a FIELD based on the block and optionally supplied element.
 * @private
 * @param {Symbol} type - Uniquely identify a type of FIELD
 * @param {HTMLElement} container - Contains the child elements
 * @param {string} block - The block name
 * @param {string|null} [element=null] - The element name
 * @returns {Object} The name and node representing the FIELD.
 */
var createField = function createField(type, container, block) {
  var element = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (element) {
    var name = "".concat(block, "__").concat(element);
    return {
      type: type,
      name: name,
      node: container.querySelector(".".concat(name))
    };
  }
  return {
    type: type,
    name: block,
    node: container
  };
};

/**
 * Negotiates and resolves the form FIELD within the CONTAINER. There are a
 * number of possible element names that can be used, so this will ensure that
 * the supported element names correlate to what is in the DOM.
 * @private
 * @param {HTMLElement} container - Contains the form FIELD element
 * @param {string} block - The block name
 * @param {Array} fieldElements = Possible elements names
 * @returns {Object} The name and node representing the form FIELD.
 */
var createFormField = function createFormField(container, block, fieldElements) {
  var _fieldElements$map$fi = fieldElements.map(function (element) {
      return createField(TYPES.FIELD, container, block, element);
    }).filter(function (_ref) {
      var node = _ref.node;
      return node;
    }),
    _fieldElements$map$fi2 = _toArray(_fieldElements$map$fi),
    field = _fieldElements$map$fi2[0],
    otherFields = _arrayLikeToArray(_fieldElements$map$fi2).slice(1);
  if (otherFields.length) {
    throw new Error('Floating label only supports one field in a container');
  }
  if (!field) {
    throw new Error('No form field node found in a floating label');
  }
  return field;
};

/**
 * Provides additional data that can be used from the consumer side of the
 * floating label. Think of this as extra data that isn't part of the event.
 * @private
 * @param {HTMLElement} fieldElement - The form field element
 * @returns {Object} Data to be passed along to the event.
 */
var buildAdditionalData = function buildAdditionalData(fieldElement) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0_lodash_property___default()('form.dataset')(fieldElement) || {},
    validateOnlyOnSubmit = _ref2.validateOnlyOnSubmit;
  return {
    validateOnlyOnSubmit: !!validateOnlyOnSubmit
  };
};

/**
 * Creates an event listener and passes back all the necessary properties
 * needed for clean up.
 * @private
 * @param {string} eventName - The name of the event
 * @param {HTMLElement} node - Element receiving the event
 * @param {Array} listeners - The listeners or callers provided from the outside
 * @param {Function} [fn=e => e] - Allow for internal hooking in of the callback
 * @returns {Object} Properties containing event information
 */
var addListener = function addListener(eventName, node, listeners) {
  var fn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (e) {
    return e;
  };
  var handler;
  var data = buildAdditionalData(node);
  node.addEventListener(eventName, handler = function handler(e) {
    fn(e);
    listeners.forEach(function (listener) {
      return listener && listener(eventName, e, data);
    });
  });
  return {
    node: node,
    eventName: eventName,
    handler: handler
  };
};

/**
 * Removes all events applied to a single floating LABEL.
 * @private
 * @param {Object} listeners - Info about each element
 */
var _removeListeners = function removeListeners(listeners) {
  listeners.forEach(function (_ref3) {
    var node = _ref3.node,
      eventName = _ref3.eventName,
      handler = _ref3.handler;
    return node.removeEventListener(eventName, handler);
  });
};

/**
 * Fires off a load event denoting that the element has loaded.
 * @private
 * @param {HTMLElement} fieldNode - The element receiving the event
 */
var fireLoadEvent = function fireLoadEvent(fieldNode) {
  var evt = new Event(EVENTS.LOAD);
  fieldNode.dispatchEvent(evt);
};

/**
 * Responsible for setting up any caller that needs to hook into the floating
 * LABEL. The goal of this work is to:
 *
 * - Offload responsibility of the interaction so any floating LABEL
 *   functionality can scale horizontally.
 * - Decrease the amount of event bound to the DOM by calling on the listener
 *   provided by the callers.
 * - Consolidate all events for ease of clean up.
 *
 * As part of the setup, a number of requirements are needed for a floating
 * LABEL include:
 *
 * - A CONTAINER element (the one passed in)
 * - A LABEL element
 * - Some kinda of form FIELD element
 *
 * Once all the requirements have been met, floating label will interact with
 * "callers", which serve the following purposes:
 *
 * - Accept the output of elements
 * - Respond to any events dictated by floating label by forwarding along the
 *   event name followed by the event on the form field
 *
 * To do so, a caller is a function where the returned function acts as the
 * responder. In it's simplest form, a caller is a function that returns a
 * function, where the first function passes along all the "nodes" or elements
 * defined in TYPES and the second function (or inner function) it used for
 * listening to/responding to events.
 *
 * @example
 * const myCaller = (blockElement, labelElement, fieldFormElement) => (type, evt) => {
 *   switch(type) {
 *     case 'FOCUS':
 *       blockElement.classList.add('i-do-focus-things');
 *     case 'BLUR':
 *       blockElement.classList.remove('i-do-focus-things');
 *       blockElement.classList.add('i-do-blur-things');
 *   };
 * };
 *
 * floatingLabel($el, {
 *   callers: [myCaller]
 * });
 *
 * @see TYPES
 * @see FLOATING_LABEL_OPTIONS
 * @param {HTMLElement} container - The element containing the LABEL and FIELD
 * @param {Object} options - Options used for overriding
 * @returns {Object} Properties used for interacting after the initial call
 */
function floatingLabel(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _$$extend = $.extend({}, FLOATING_LABEL_OPTIONS, options),
    block = _$$extend.block,
    fieldElements = _$$extend.fieldElements,
    labelElement = _$$extend.labelElement,
    callers = _$$extend.callers;
  var formField = createFormField(container, block, fieldElements);
  var label = createField(TYPES.LABEL, container, block, labelElement);
  if (!label.node) {
    throw new Error("No field found in a floating label for ".concat(label.name));
  }
  var elements = [createField(TYPES.CONTAINER, container, block), label, formField];
  var FOCUS = EVENTS.FOCUS,
    BLUR = EVENTS.BLUR,
    INVALID = EVENTS.INVALID,
    INPUT = EVENTS.INPUT,
    LOAD = EVENTS.LOAD;
  var listeners = callers.map(function (caller) {
    return caller.apply(void 0, elements);
  });
  var fieldNode = formField.node;
  var focusListener = addListener(FOCUS, fieldNode, listeners, function (_ref4) {
    var target = _ref4.target;
    return target.setCustomValidity('');
  });
  var blurListener = addListener(BLUR, fieldNode, listeners);
  var invalidListener = addListener(INVALID, fieldNode, listeners);
  var inputListener = addListener(INPUT, fieldNode, listeners);
  var loadListener = addListener(LOAD, fieldNode, listeners);
  var eventListeners = [focusListener, blurListener, invalidListener, inputListener, loadListener];

  // At this point all the necessary elements are in the DOM so we communicate
  // to any subscribers that the floating label functionality has loaded.
  fireLoadEvent(fieldNode);
  return {
    removeListeners: function removeListeners() {
      return _removeListeners(eventListeners);
    }
  };
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(96);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(145),
    baseKeysIn = __webpack_require__(333),
    isArrayLike = __webpack_require__(68);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(343);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue         = __webpack_require__(192)
  , isPlainFunction = __webpack_require__(450)
  , assign          = __webpack_require__(286)
  , normalizeOpts   = __webpack_require__(292)
  , contains        = __webpack_require__(294);

var d = (module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if (arguments.length < 2 || typeof dscr !== "string") {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
		w = contains.call(dscr, "w");
	} else {
		c = w = true;
		e = false;
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
});

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== "string") {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (!isValue(get)) {
		get = undefined;
	} else if (!isPlainFunction(get)) {
		options = get;
		get = set = undefined;
	} else if (!isValue(set)) {
		set = undefined;
	} else if (!isPlainFunction(set)) {
		options = set;
		set = undefined;
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
	} else {
		c = true;
		e = false;
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(305)() ? globalThis : __webpack_require__(304);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(386),
    listCacheDelete = __webpack_require__(387),
    listCacheGet = __webpack_require__(388),
    listCacheHas = __webpack_require__(389),
    listCacheSet = __webpack_require__(390);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    stackClear = __webpack_require__(406),
    stackDelete = __webpack_require__(407),
    stackGet = __webpack_require__(408),
    stackHas = __webpack_require__(409),
    stackSet = __webpack_require__(410);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(72);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(22),
    isKey = __webpack_require__(121),
    stringToPath = __webpack_require__(413),
    toString = __webpack_require__(74);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(82),
    isObject = __webpack_require__(52);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(383);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(309),
    Map = __webpack_require__(104),
    Promise = __webpack_require__(311),
    Set = __webpack_require__(140),
    WeakMap = __webpack_require__(142),
    baseGetTag = __webpack_require__(51),
    toSource = __webpack_require__(181);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(324),
    isObjectLike = __webpack_require__(24);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(21),
    stubFalse = __webpack_require__(438);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS; });
/* unused harmony export VALIDATE_TRIGGER */
/* unused harmony export DEFAULT_MESSAGE */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_difference__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_kebabCase__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_partial__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_partial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_partial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_error_scroller__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_register_jquery_plugin__ = __webpack_require__(2);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for performing form validation via the Constraint Validation API.
 * It provides both custom data attributes as well leverage any fields in a
 * given area (form or any container with elements) that are seen as invalid.
 * @module elements/fields/validator
 */








var PLUGIN_NAME = 'validator';
var placeholder = __WEBPACK_IMPORTED_MODULE_4_lodash_partial___default.a.placeholder;

/**
 * Defines default options for a validator.
 * @type {Object}
 */
var VALIDATOR_OPTIONS = {
  /**
   * Allows for a form to be validated only upon submission.
   */
  validateOnlyOnSubmit: false,
  /**
   * Called when a submission is valid
   * @param {Array} validElements - An array of valid HTML elements
   */
  successCallback: function successCallback(validElements) {
    return validElements;
  },
  /**
   * Called when a submission was unsuccessful
   * @param {Array} invalidElements - An array of invalid HTML elements
   */
  errorCallback: function errorCallback(invalidElements) {
    return invalidElements;
  },
  /**
   * Provides baseline implementation of where/how the page should scroll to
   * when an error has been found.
   * @param {number} x - The x coordinate to scroll to
   * @param {number} y - The y coordinate to scroll to
   */
  scrollTrigger: function scrollTrigger(x, y) {
    return window.scrollTo(x, y);
  },
  /**
   * Allows for custom scrolling when an error occurs.
   */
  useCustomFormErrorScroll: __WEBPACK_IMPORTED_MODULE_6__form_error_scroller__["a" /* default */]
};

/**
 * Defines all validator related events.
 * @type {Object}
 */
var EVENTS = {
  INVALID_SCROLL_POSITION: 'validator:invalid-scroll-position',
  VALIDATOR_SUCCESS: 'validator:success',
  VALIDATOR_ERROR: 'validator:error'
};

/**
 * Defines the data attribute for triggering an element.
 * @type {string}
 */
var VALIDATE_TRIGGER = 'data-validate-trigger';

/**
 * Defines default value for when a field is invalid
 * @type string
 */
var DEFAULT_MESSAGE = 'Valid entry required';

/**
 * Defines a number of custom data attributes used for validating.
 * @private
 * @type {Object}
 */
var validators = {
  /**
   * Ensures that an element is not empty. This is different from a required
   * attribute as the validation occurs on submit by the validator verses
   * natively in the browser.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-not-empty="true" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be not empty
   * @returns {string} Value used for setting custom validity
   */
  validateNotEmpty: function validateNotEmpty($el) {
    if (!$el.val()) {
      return $el.data('errorMessage') || DEFAULT_MESSAGE;
    }
    return '';
  },
  /**
   * Ensure that an element value is not set to the provided value. When it has
   * been set to the value provided, the element will be set as invalid.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-not="walter" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be not empty
   * @param {string} dataVal - Elements checked to be not empty
   * @returns {string} Value used for setting custom validity
   */
  validateNot: function validateNot($el, dataVal) {
    if ($el.val() === dataVal) {
      return $el.data('errorMessage') || DEFAULT_MESSAGE;
    }
    return '';
  },
  /**
   * Ensure that a valid email has been provided. The field must have a handle
   * plus domain plus some kind of tld.
   * @param {jQuery} $el - Elements checked to be a valid email
   * @returns {string} Value used for setting custom validity
   */
  validateEmail: function validateEmail($el) {
    var val = $el.val();
    // Make sure we have a value just in case the field is not required. That
    // can be handled by another data-validate-*.
    if (!val) {
      return '';
    }
    if (!__WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default()(val)) {
      return $el.data('errorMessage') || DEFAULT_MESSAGE;
    }
    return '';
  }
};

/**
 * Simple helper that will determine the top position of an element on the page.
 * @private
 * @param {HTMLElement} el - Element under question to find top position
 * @returns {number} The total distance from the top for an element
 */
var getTop = function getTop(el) {
  var bodyTop = document.body.getBoundingClientRect().top;
  var elTop = el.getBoundingClientRect().top;
  return elTop - bodyTop;
};

/**
 * Figures out the highest elements found in the DOM based on an array of HTML
 * elements.
 * @private
 * @param {Array} invalidElements - A list of HTML elements
 * @returns {HTMLElement} Highest HTML element on the page
 */
var findHighestEl = function findHighestEl(invalidElements) {
  var _invalidElements = _slicedToArray(invalidElements, 1),
    initial = _invalidElements[0];
  return invalidElements.reduce(function (prev, curr) {
    return getTop(curr) < getTop(prev) ? curr : prev;
  }, initial);
};

/**
 * Determines where in the form to scroll to when an error has been found, so
 * that the user has some context about what in the form has been filled in
 * incorrectly.
 * @private
 * @param {Array} invalidElements - A list of invalid elements
 * @param {Function} scrollTrigger - Called on to determine where to scroll to.
 */
var setInvalidScrollPosition = function setInvalidScrollPosition(invalidElements, scrollTrigger) {
  var highestEl = findHighestEl(invalidElements);
  var yAxis = getTop(highestEl);
  var dict = {
    detail: {
      setElement: function setElement(el) {
        yAxis = getTop(el);
      },
      setPosition: function setPosition(pos) {
        yAxis = window.scrollY + pos;
      },
      setRawPosition: function setRawPosition(pos) {
        yAxis = pos;
      }
    }
  };
  var evt = new CustomEvent(EVENTS.INVALID_SCROLL_POSITION, dict);
  highestEl.dispatchEvent(evt);
  scrollTrigger(0, yAxis);
};

/**
 * Validates for form field based on whether it contains a custom data
 * attribute as specified by any validators. It's purpose is to set the proper
 * validity if the field's requirements haven't been met. It will return true
 * if the element was found invalid.
 * @private
 * @see validators
 * @param {HTMLSelectElement|HTMLInputElement} el - Form element
 * @returns {boolean|undefined} Determines if element is invalid
 */
var validateField = function validateField(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  if ($el.is(':hidden')) {
    return false;
  }
  var dataAttrs = $el.data();
  var validatorList = Object.keys(validators);
  for (var i = 0, len = validatorList.length; i < len; i += 1) {
    var name = validatorList[i];
    var dataVal = dataAttrs[name];
    if (!!dataVal && !!validators[name]) {
      var message = validators[name]($el, dataVal, dataAttrs);
      if (message) {
        el.setCustomValidity(message);
        return true;
      }
      el.setCustomValidity('');
    }
  }
  return false;
};

/**
 * Responsible for cleaning up and ensuring that all invalid elements are
 * actually invalid and normalized.
 * @private
 * @param {Array} elements - Contains an array of possible invalid elements
 * @returns {Array} Normalized invalidates
 */
var removeExistingInvalidates = function removeExistingInvalidates(elements) {
  var elementsToRemove = elements.filter(function (element) {
    return element.checkValidity();
  });
  var diff = __WEBPACK_IMPORTED_MODULE_1_lodash_difference___default()(elements, elementsToRemove);
  return __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(diff);
};

/**
 * Helper that determines all the elements that contain data validator
 * attributes and applies a function to interact with each element.
 * @private
 * @param {jQuery} $wrapper - Container for the form elements
 * @param {Function} fn - Called and passed along a form element
 */
var forEachFormField = function forEachFormField($wrapper, fn) {
  var dataSelector = Object.keys(validators).map(function (name) {
    return "[data-".concat(__WEBPACK_IMPORTED_MODULE_3_lodash_kebabCase___default()(name), "]");
  }).join(',');
  $wrapper.find(dataSelector).each(function iterateElement() {
    fn(this);
  });
};

/**
 * Performs the submit handler used for verifying the fields within an element.
 * @private
 * @param {Event} evt - DOM event
 * @param {jQuery} $wrapper - The element containing form elements
 * @param {Function} successCallback - Fired off if submission was successful
 * @param {Function} errorCallback - Fired off if submissions was unsuccessful
 * @param {Function} useCustomFormErrorScroll - Called on when an error has
 * been found
 * @param {Function} scrollTrigger - Called on to go a position on the page
 * @param {boolean} disableErrorScroll - Disables a form error from scrolling
 * to the error on the screen.
 */
var submitHandler = function submitHandler(evt, $wrapper, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll) {
  var invalidElements = $wrapper.find(':invalid').not(':hidden').toArray();
  var validElements = [];
  forEachFormField($wrapper, function (formField) {
    var isInvalid = validateField(formField);
    if (isInvalid) {
      invalidElements = [].concat(_toConsumableArray(invalidElements), [formField]);
    } else {
      validElements = [].concat(_toConsumableArray(validElements), [formField]);
    }
  });
  invalidElements = removeExistingInvalidates(invalidElements);
  if (invalidElements.length > 0) {
    evt.preventDefault();
    errorCallback(invalidElements);
    if (!useCustomFormErrorScroll($wrapper, scrollTrigger) && !disableErrorScroll) {
      setInvalidScrollPosition(invalidElements, scrollTrigger);
    }
    var errorEvt = new CustomEvent(EVENTS.VALIDATOR_ERROR, {
      detail: {
        invalidElements: invalidElements,
        srcEvent: evt
      }
    });
    $wrapper[0].dispatchEvent(errorEvt);
  } else {
    successCallback(validElements);
    var _errorEvt = new CustomEvent(EVENTS.VALIDATOR_SUCCESS, {
      detail: {
        srcEvent: evt
      }
    });
    $wrapper[0].dispatchEvent(_errorEvt);
  }
};

/**
 * Responsible for allowing a single handler to be called on to avoid a handler
 * to be called on multiple times.
 * @param {Function} handler - Func to call on
 * @returns {Function} An event callback
 */
var makeSingleEventCall = function makeSingleEventCall(handler) {
  var called;
  return function (evt) {
    if (!called) {
      called = evt.type;
    }
    if (evt.type === called) {
      handler(evt);
    }
  };
};

/**
 * Determines the type of event used for refreshing. In other words, when a
 * field should be checked for validity.
 * @private
 * @param {HTMLInputElement|HTMLSelectElement} el - An element
 * @returns {string} The type of event used for determining a refresh of a field
 */
var resolveRefreshEventType = function resolveRefreshEventType(el) {
  switch (el.tagName.toLowerCase()) {
    case 'select':
      return 'change';
    default:
      return 'blur';
  }
};

/**
 * Based on the type of element, will apply an event listener whenever a value
 * has been finalized on the form element.
 * @private
 * @param {jQuery} $el - The form or container for form fields
 */
var listenForFieldChange = function listenForFieldChange($el) {
  forEachFormField($el, function (formField) {
    var evtName = resolveRefreshEventType(formField);
    var callback = function callback() {
      return validateField(formField);
    };
    formField.addEventListener(evtName, callback);
  });
};

/**
 * Validates fields within an element, most likely a form based on what is
 * passed in. The validation of fields is done by a couple of ways:
 *
 * 1. By using browser defaults around validity. For example, if a form element
 * is using a required attribute, has a type that uses built in validation, has
 * a patter attribute, or is controlling validity programmatically by
 * JavaScript.
 * 2. By leveraging data attributes that are coming from within. Think of these
 * attributes as additional configuration that extends the capabilities of
 * validation that isn't supported by the browser.
 * 3. A combination of two.
 *
 * Whether either of these conditions are met, they are finally triggered by
 * either a form submission or a click event applied to an element that
 * contains a data-validate-trigger attribute. This would allow for form
 * submissions to be applied to an element other than a input[type="submit"] or
 * button, in case it's needed. When any form elements are found invalid, a
 * pseudo class of invalid is set and can be styled by CSS.
 *
 * The goal of this work is to leverage as much from within the browser and
 * remove the need for as much custom work as possible.
 * @see validators
 * @see VALIDATOR_OPTIONS
 * @param {HTMLElement} el - An element containing fields used for validating
 * @param {Object} [options={}] - Options used for overriding
 */
function validator(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $triggers = $el.find("[".concat(VALIDATE_TRIGGER, "]"));
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, VALIDATOR_OPTIONS, options, $el.data()),
    validateOnlyOnSubmit = _$$extend.validateOnlyOnSubmit,
    successCallback = _$$extend.successCallback,
    errorCallback = _$$extend.errorCallback,
    scrollTrigger = _$$extend.scrollTrigger,
    useCustomFormErrorScroll = _$$extend.useCustomFormErrorScroll,
    disableErrorScroll = _$$extend.validateDisableErrorScroll;
  var partialSubmitHandler = __WEBPACK_IMPORTED_MODULE_4_lodash_partial___default()(submitHandler, placeholder, $el, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll);
  var submitHandlerFunc = makeSingleEventCall(partialSubmitHandler);
  $el.on('submit', submitHandlerFunc);
  if ($triggers.length) {
    $triggers.on('click', submitHandlerFunc);
  }
  if (!validateOnlyOnSubmit) {
    listenForFieldChange($el);
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, validator);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* harmony export (immutable) */ __webpack_exports__["a"] = modal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scriptjs__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles all modals
 * @module modal
 */







var HAMMERJS_FALLBACK = 'https://ajax.googleapis.com/ajax/libs/hammerjs/2.0.8/hammer.min.js';

/**
 * AB### for R Mobile Faster Modal
 */
var isFasterModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('abtests.ab000', false);
if (isFasterModal) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass('modal--faster');
  });
}

/**
 * Makes a request for HammerJS.
 * @private
 * @return {Promise} Denotes when the request has been successfully executed
 */
var loadHammerJSFunc = function loadHammerJSFunc() {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_1_scriptjs___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('scripts.hammerJS', HAMMERJS_FALLBACK), function () {
      resolve(window.Hammer);
    });
  });
};
// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'modal';
var DEFAULTS = {
  url: '',
  type: '',
  open: null,
  data: '',
  animation: true,
  returnFocus: '',
  notificationAutoClose: true,
  cache: true,
  closeButton: true,
  overlayClose: true,
  triggerOpen: false,
  triggerElement: '',
  padding: true,
  addModifierClass: '',
  onOpen: function onOpen() {},
  onComplete: function onComplete() {},
  onLoad: function onLoad() {},
  onCleanup: function onCleanup() {},
  onClose: function onClose() {},
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  loadHammerJS: loadHammerJSFunc,
  srLinkText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.translations.openModalSRText', 'Opens in a modal window'),
  closeText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.modal.translations.closeText', 'close'),
  noSrLink: false
};

/**
 * Check if options.url is define, if it is create an empty modal
 * for ajax content. Otherwise, assign with options.open or $el's data attribute
 * @return {jQuery} modal element
 */
var appendModal = function appendModal() {
  var $modalHTML = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>', {
    id: 'modal',
    "class": 'modal'
  });
  return $modalHTML;
};
/**
 * Set Aria
 * @param  {jQuery} $el - button /element that opens modal
 */
var setA11yAttr = function setA11yAttr($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.attr('aria-haspopup', 'dialog');
  if ($el.is('a')) {
    $el.attr('role', 'button');
  } else if ($el.is('button')) {
    $el.attr('type', 'button');
  }
};
/**
 * Get Modal
 * Target modal via options.open / data-open(legacy) / href(accessibility)
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal element
 */
var getModal = function getModal($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $modal;
  if (options.open) {
    $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(options.open));
  } else if (options.url || $el.data('url')) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal').length) {
      $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal');
    } else {
      $modal = appendModal();
    }
  } else if ($el.data('open')) {
    $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat($el.data('open')));
  }
  return $modal;
};
/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Assign $modal to modal element either by options {} or $el's data attribute
  var $modal = getModal($el, options);
  var opts = {};
  var modalData = !$modal ? {} : $modal.data();
  if (!$modal) return false;
  opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, $el.data(), options);
  if (!options.url) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, modalData, $el.data(), options);
  }
  return opts;
};

/**
 * Check if options.url is define, if it is create an empty modal
 * otherwise target options.open or $el's data attribute
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal element
 */
var setModal = function setModal($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Assign $modal to modal element either by options {} or $el's data attribute
  var $modal = getModal($el, options);
  $modal.appendTo('body');
  return $modal;
};
/**
 * @param  {jQuery} $overlay - modal overlay
 */
var appendLoadingBar = function appendLoadingBar($overlay) {
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').length) {
    var ajaxLoadingMessage;
    try {
      ajaxLoadingMessage = window.rcProps.translations.ajaxLoadingMessage;
    } catch (e) {
      ajaxLoadingMessage = 'Content is loading';
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class=\"modal-overlay__progress-bar modal-overlay__progress-bar--hidden progress-bar progress-bar--center\" tabindex=\"-1\" role=\"presentation\">\n        <div class=\"u-screen-reader\">\n            ".concat(ajaxLoadingMessage, "\n        </div>\n     </div>")).appendTo($overlay);
  }
};
/**
 * @return {jQuery} modal overlay element
 */
var appendModalOverlay = function appendModalOverlay(options) {
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="modal-overlay"></div>').appendTo('body');
  }
  if (!options.animation) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay').addClass('modal-overlay--no-animation');
  }
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay');
};
/**
 * Check if options.url is define, if it is create an empty modal
 * otherwise target options.open or $el's data attribute
 * @param  {jQuery} $el - modal element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal content element
 */
var wrapModalContent = function wrapModalContent($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!$el.find('.modal__content').length) {
    $el.wrapInner('<div class="modal__content"></div>');
    $el.find('.modal__content').wrapInner('<div class="modal__content-main"></div>');
  }
  if (!options.padding) {
    $el.find('.modal__content').addClass('u-padding-a--none');
  }
  if (!options.animation) {
    $el.find('.modal__content').addClass('modal__content--no-animation');
  }
  return $el.find('.modal__content-main');
};
/**
 * Adjust and set classes and options for appropriate modal type
 * @param  {jQuery} $el - modal element
 * @param  {string} type - modifier
 */
var addModalModifiers = function addModalModifiers($el, type, classModifier) {
  var modalTypeClass = "modal--".concat(type);
  if (type) {
    $el.addClass(modalTypeClass);
  }
  if (classModifier) {
    $el.addClass(classModifier);
  }
};
/**
 * Adjust and set classes and options for appropriate modal type
 * @param  {jQuery} $el - modal element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable modal settings
 */
var adjustToModalType = function adjustToModalType($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var typeAdjust = {
    pageScroll: false,
    overlay: true
  };
  addModalModifiers($el, options.type, options.addModifierClass);
  switch (options.type) {
    case 'notification':
      typeAdjust = {
        pageScroll: true,
        overlay: false
      };
      break;
    case 'toast':
      typeAdjust = {
        pageScroll: false,
        overlay: true
      };
      break;
    case 'full':
      typeAdjust = {
        pageScroll: true,
        overlay: true
      };
      break;
    default:
  }
  return typeAdjust;
};

/**
 * Remove active class on elements
 * @param  {rest}
 */
var removeActiveClass = function removeActiveClass() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args.forEach(function ($el) {
    $el.removeClass('is-active');
  });
};
/**
 * @param  {jQuery} $el - modal element
 */
var removeModalModifiers = function removeModalModifiers($el) {
  var classArray = Array.from($el[0].classList);
  var modifers = classArray.filter(function (modalClass) {
    return modalClass.includes('--');
  });
  modifers.forEach(function (modClass) {
    $el.removeClass(modClass);
  });
};
/**
 * Reset modal for next ajax loaded content
 */
var resetAjaxModal = function resetAjaxModal() {
  var $ajaxModal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal');
  if ($ajaxModal.length) {
    removeModalModifiers($ajaxModal);
    $ajaxModal.find('.modal__content-main *:not(".modal__close, .modal__close *")').remove();
  }
};
/**
 * Ensure one modal is open at a time
 * @param  {jQuery} $modal
 * @param  {jQuery} $overlay
 */
var closeAllModals = function closeAllModals() {
  clearTimeout(window.modalCloseTimeout);
  resetAjaxModal();
  removeActiveClass(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal'));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('body--modal-overflow-hidden').css({
    overflow: 'auto'
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["clearAllBodyScrollLocks"])();
};
/**
 * Add active class on elements
 * @param  {rest}
 */
var addActiveClass = function addActiveClass() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  // Delay to allow for css animation
  setTimeout(function () {
    args.forEach(function ($el) {
      $el.addClass('is-active');
    });
  }, 1);
};
/**
 * Callback after css animation
 * @param {jQuery} $el - css animated element
 */
var afterAnimation = function afterAnimation($el, cb) {
  if (isFasterModal) {
    cb();
    return;
  }
  var animationDone = false;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal__content').on('transitionend', function (e) {
    if (e.originalEvent.propertyName === 'transform' && !animationDone) {
      animationDone = true;
      cb();
    }
  });
};
/**
 * Return to last focusable element
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var returnToLastFocus = function returnToLastFocus($content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (options.returnFocus) {
    options.releaseFocusFunc($content, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.returnFocus));
  } else {
    options.releaseFocusFunc($content, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus'));
  }
};
/**
 * Handles the click event to close the modal
 * @param  {event} event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var closeModal = function closeModal(evt, $el, $modal, $content, $overlay, typeAdjust) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  clearTimeout(window.modalCloseTimeout);
  if (evt) {
    evt.preventDefault();
  }
  if (typeAdjust.overlay) {
    removeActiveClass($overlay);
  }
  removeActiveClass($modal);
  $content.attr('aria-modal', false);
  options.onCleanup({
    target: $el,
    options: options
  });
  afterAnimation($content, function () {
    if (!typeAdjust.pageScroll) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["clearAllBodyScrollLocks"])();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('body--modal-overflow-hidden').css({
        overflow: 'auto'
      });
    }
    options.onClose({
      target: $el,
      options: options
    });
    if (options.url) {
      resetAjaxModal();
    }
    returnToLastFocus($content, options);
  });

  // to ensure the event isn't get bound multiple times
  $content.off('mousedown.modal');
  if (options.overlayClose) {
    // to ensure the event isn't get bound multiple times
    $modal.off('mousedown');
  }
};
/**
 * Set timeout for notification modal
 * @param  {jQuery} $el
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 */
var setNotificationDuration = function setNotificationDuration($el, $modal, $content, $overlay, typeAdjust, options) {
  /*
  this has duration based on
  word count has been commented out
  waiting on feedback - 02/01/2018
  */
  // Set Timer base on number of words
  // const numWords = $content
  // .text()
  // .replace(/^[\s,.;]+/, '')
  // .replace(/[\s,.;]+$/, '')
  // .split(/[\s,.;]+/)
  // .length;
  var minDuration = 5000;
  // let duration = numWords * 500;
  // if (duration < minDuration) {
  //   duration = minDuration;
  // }
  window.modalCloseTimeout = setTimeout(function () {
    closeModal(false, $el, $modal, $content, $overlay, typeAdjust, options);
  }, minDuration);
};
/**
 * Add aria-labelledby to modal content for accessible
 * audible title that corresponds with modal's heading
 * @param  {jQuery} $content
 */
var addHedAria = function addHedAria($content) {
  var $modalHed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($content.find('.modal__hed'));
  if (!$content.find('.modal__hed').length) {
    $modalHed = $content.find('.modal__focus-element');
  }
  if ($modalHed.length && !$modalHed.attr('id')) {
    var modalHedID = "modal-hed-".concat(Math.ceil(Math.random() * 10000000000));
    $content.attr('aria-labelledby', modalHedID);
    $content.attr('role', 'dialog');
    $content.attr('tabindex', '-1');
    $modalHed.attr('id', modalHedID).attr('tabindex', '-1');
  }
};
/**
 * Save last focus element that's not inside modal
 * @param  {jQuery} $el - last focusable element
 */
var saveLastFocus = function saveLastFocus($el) {
  if (!$el.parents('.modal__content').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus', $el);
  }
};
/**
 * Give each <a> a unique href value, in order to avoid users hearing
 * "visited" on links they've yet to visit.
 * @param  {jQuery} $modal
 */
var uniqueCloseHref = function uniqueCloseHref($modal) {
  $modal.find('.js-modal-close').each(function eachCloseLink() {
    var $closeLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if ($closeLink.is('a')) {
      $closeLink.attr('href', "#modal-uid-".concat(Math.ceil(Math.random() * 10000000000)));
    } else if ($closeLink.is('button')) {
      return;
    } else {
      throw new Error('Modal close triggers should be anchors');
    }
  });
};
/**
 * Open modal
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

var openModal = function openModal($el, $modal, $content, $overlay, typeAdjust) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').addClass('modal-overlay__progress-bar--hidden');
  $content.attr('aria-modal', true);
  options.onOpen({
    target: $el,
    options: options
  });
  addActiveClass($modal);
  addHedAria($content);
  saveLastFocus($el);
  uniqueCloseHref($modal);
  $content.scrollTop(0);
  if (typeAdjust.overlay) {
    addActiveClass($overlay);
  }
  if (!typeAdjust.pageScroll) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass('body--modal-overflow-hidden');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["disableBodyScroll"])($content[0]);
  }
  if (options.type === 'notification') {
    options.loadHammerJS().then(function (Hammer) {
      var hammertime = new Hammer($content[0]);
      hammertime.get('swipe').set({
        direction: Hammer.DIRECTION_VERTICAL
      });
      hammertime.on('swipeup', function (evt) {
        return closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
      });
      if ($content.find('.js-close-link--notification').length < 1) {
        $content.append("\n          <div class=\"js-close-link--notification u-center u-margin-t--sm\">\n            <button tabindex=\"0\" class=\"js-modal-close link link--hover-lighter\" type=\"button\">".concat(options.closeText, "</button>\n            <span class=\"u-screen-reader\">Close notification modal</span>\n          </div>\n        "));
      }
      if (options.notificationAutoClose) {
        setNotificationDuration($el, $modal, $content, $overlay, typeAdjust, options);
      }
    });
  }
  // Shift and trap focus to modal after animation
  afterAnimation($content, function () {
    options.trapFocusFunc($content);
    if ($content.find('.modal__hed').length) {
      $content.find('.modal__hed').focus();
    } else {
      $content.find('.modal__focus-element').focus();
    }
    options.onComplete({
      target: $el,
      options: options,
      content: $content
    });
  });
};
/**
 * Handles the click event when modal trigger/ button is clicked
 * @param  {jQuery} $el - control
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {event} evt
 */
var openModalEventHandler = function openModalEventHandler($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var evt = arguments.length > 5 ? arguments[5] : undefined;
  var typeAdjust = adjustToModalType($modal, options);
  if (evt) {
    evt.preventDefault();
  }
  closeAllModals();
  $content
  // To ensure the event isn't get bound multiple times
  .off('keydown.modalEscape')
  // escape event to close modal
  .on('keydown.modalEscape', function (event) {
    return escapeModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
  }).data('modalEscape', true)
  // Add listener to modal close button keyboard users hitting the enter key for a11y
  .on('keydown.modalClose', '.js-modal-close', function (event) {
    return keyboardCloseModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
  }).data('modalEscape', true)
  // Add listener modal content for modalCloseClass to close modal
  .on('mousedown.modal', '.js-modal-close', function (event) {
    return closeModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
  })
  // Prevents href getting added to end of URL
  .on('click.modal', '.js-modal-close', function (event) {
    return event.preventDefault();
  })
  // Stop the clicks from bubbling up
  .on('mousedown.modal', function (event) {
    return event.stopPropagation();
  });
  if (options.overlayClose) {
    $modal
    // Add listener to outside of the modal if set true
    .on('mousedown.modal', function (event) {
      return closeModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
    });
  }
  // If url is passed then attempt to load ajax.
  if (options.url) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').removeClass('modal-overlay__progress-bar--hidden');
    options.onLoad({
      target: $el,
      options: options
    });
    addModalModifiers($modal, options.type, options.addModifierClass);
    if (options.type !== 'notification') {
      addActiveClass($overlay);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').focus();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: options.url,
      method: 'POST',
      cache: options.cache,
      data: options.data,
      timeout: 60000
    }).fail(function (jqXHR) {
      $content.prepend("<h3 class=\"modal__hed\">".concat(jqXHR.statusText, "</h3>"));
      openModal($el, $modal, $content, $overlay, typeAdjust, options);
    }).done(function (content) {
      $content.prepend(content);
      openModal($el, $modal, $content, $overlay, typeAdjust, options);
    });
    // Not dynamic, open inline modal instead.
  } else {
    openModal($el, $modal, $content, $overlay, typeAdjust, options);
  }
};
/**
 * @param  {jQuery} evt - key event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var escapeModal = function escapeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options) {
  if (__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].keys.ESCAPE) {
    closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  }
};
/**
 * @param  {jQuery} evt - key event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var keyboardCloseModal = function keyboardCloseModal(evt, $el, $modal, $content, $overlay, typeAdjust, options) {
  if (__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].keys.ENTER) {
    closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  }
};
/**
 * Applies any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  // Add escape key down feature
  // Add listener to button to open modal
  if (!options.triggerOpen) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on('click.modal', function (evt) {
      return openModalEventHandler($el, $modal, $content, $overlay, options, evt);
    });
  }
};
/**
 * Remove any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 */
var removeEventListeners = function removeEventListeners($el, $modal, $content) {
  $el.off('click.modal');
  $content.off('mousedown.modal').off('keydown.modalEscape');
  $modal.off('mousedown.modal');
};
/**
 * If triggerOpen option is set true open modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var checkTriggerOpen = function checkTriggerOpen($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  if (options.triggerOpen) {
    openModalEventHandler($el, $modal, $content, $overlay, options, false);
  }
};
/**
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Function} deregister - teardown method from register jquery plugin
 */
var _destroy = function destroy($el, $modal, $content) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var deregister = arguments.length > 4 ? arguments[4] : undefined;
  removeEventListeners($el, $modal, $content);
  removeActiveClass(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal'));
  removeModalModifiers($modal);
  deregister();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('body--modal-overflow-hidden');
  if (options.url) {
    $modal.remove();
  }
};
/* Add Close Button to modal
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var addCloseButton = function addCloseButton($content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var hasCloseButton = $content.find('.js-modal-close').length >= 1;
  var ariaHiddenClose = hasCloseButton ? true : false;
  if (options.closeButton && !$content.find('.modal__close').length && options.type !== 'notification') {
    $content.append("\n      <button class=\"btn btn--close js-modal-close modal__close\" aria-label=\"close modal\" aria-hidden=\"".concat(ariaHiddenClose, "\">\n          <span class=\"u-text--sm\">Close</span>\n          <span class=\"icon icon--x\">\n            <svg viewBox=\"0 0 16 16\" focusable=\"false\" aria-hidden=\"true\">\n              <use xlink:href=\"#icon-x\"></use>\n            </svg>\n        </span>\n      </button>\n    "));
  }
};
var setA11y = function setA11y($el, opts) {
  setA11yAttr($el);
  if (!opts.noSrLink && !$el.find('.u-screen-reader').length) {
    $el.append("<span class=\"u-screen-reader\">".concat(opts.srLinkText, "</span>"));
  }
};
/**
 * Initializes modal.
 * @param {HTMLElement} el - button /element that opens modal
 * @param {Object} options - Options used for wiring up the modal
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function modal(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = options.triggerElement ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.triggerElement) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = mergeOptions($el, options);
  if (opts) {
    var $modal = setModal($el, opts);
    var $overlay = appendModalOverlay(opts);
    var $content = wrapModalContent($modal, opts);
    setA11y($el, opts);
    appendLoadingBar($overlay);
    addCloseButton($content, opts);
    setEventListeners($el, $modal, $content, $overlay, opts, deregister);
    checkTriggerOpen($el, $modal, $content, $overlay, opts, deregister);
    return {
      destroy: function destroy() {
        return _destroy($el, $modal, $content, opts, deregister);
      }
    };
  }
  return true;
}
/**
 * Utility Function for Modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal = function (options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').modal(options);
};
/**
 * Utility Function for Closing Modal
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close = function () {
  closeAllModals();
};
/**
 * Utility Function for accessibility
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.a11y = function () {
  var $els = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal-utility');
  var options = {
    srLinkText: DEFAULTS.srLinkText
  };
  $els.each(function applyA11y() {
    setA11y(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), options);
  });
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, modal);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Toggle Text on click
 * @module toggleText
 */




var PLUGIN_NAME = 'productFilterCount';
var DEFAULTS = {};
var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};
var renderCount = function renderCount($checkboxes, $count) {
  var count = countChecked($checkboxes);
  $count.text("(".concat(count, ")"));
  if (count === 0) $count.text('');
};
var onChangeListener = function onChangeListener($checkboxes, $count) {
  return $checkboxes.on('change', function () {
    return renderCount($checkboxes, $count);
  });
};

/**
 * Initializes productFilterCount.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterCount(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.filterCount);
  var $checkboxes = $container.find('input[type="checkbox"]');
  renderCount($checkboxes, $count);
  onChangeListener($checkboxes, $count);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterCount);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function i(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function d(t){return u.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})}function c(e){var t=e||window.event;return!!d(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))}function o(){setTimeout(function(){void 0!==m&&(document.body.style.paddingRight=m,m=void 0),void 0!==f&&(document.body.style.overflow=f,f=void 0)})}var a="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),u=[],s=!1,v=-1,f=void 0,m=void 0;exports.disableBodyScroll=function(r,e){if(a){if(!r)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(r&&!u.some(function(e){return e.targetElement===r})){var t={targetElement:r,options:e||{}};u=[].concat(i(u),[t]),r.ontouchstart=function(e){1===e.targetTouches.length&&(v=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var t,o,n,i;1===e.targetTouches.length&&(o=r,i=(t=e).targetTouches[0].clientY-v,d(t.target)||(o&&0===o.scrollTop&&0<i||(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?c(t):t.stopPropagation()))},s||(document.addEventListener("touchmove",c,l?{passive:!1}:void 0),s=!0)}}else{n=e,setTimeout(function(){if(void 0===m){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(m=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===f&&(f=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:r,options:e||{}};u=[].concat(i(u),[o])}var n},exports.clearAllBodyScrollLocks=function(){a?(u.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),s&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1),u=[],v=-1):(o(),u=[])},exports.enableBodyScroll=function(t){if(a){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,u=u.filter(function(e){return e.targetElement!==t}),s&&0===u.length&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1)}else(u=u.filter(function(e){return e.targetElement!==t})).length||o()}});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(285)(); // Support ES3 engines

module.exports = function (val) { return val !== _undefined && val !== null; };


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jquery.mask.js
 * @version: v1.14.16
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
 *
 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function (factory, jQuery, Zepto) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function ($) {
    'use strict';

    var Mask = function (el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function () {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else { // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                .on('keydown.mask', function(e) {
                    el.data('mask-keycode', e.keyCode || e.which);
                    el.data('mask-previus-value', el.val());
                    el.data('mask-previus-caret-pos', p.getCaret());
                    p.maskDigitPosMapOld = p.maskDigitPosMap;
                })
                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
                .on('paste.mask drop.mask', function() {
                    setTimeout(function() {
                        el.keydown().keyup();
                    }, 100);
                })
                .on('change.mask', function(){
                    el.data('changed', true);
                })
                .on('blur.mask', function(){
                    if (oldValue !== p.val() && !el.data('changed')) {
                        el.trigger('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function() {
                    oldValue = p.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function() {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                       p.val('');
                   }
                });
            },
            getRegexMask: function() {
                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function(oldVal) {
                var newVal = p.getMasked(),
                    caretPosNew = p.getCaret();
                if (oldVal !== newVal) {
                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                        newValL = newVal.length,
                        oldValL = oldVal.length,
                        maskDigitsBeforeCaret = 0,
                        maskDigitsAfterCaret = 0,
                        maskDigitsBeforeCaretAll = 0,
                        maskDigitsBeforeCaretAllOld = 0,
                        i = 0;

                    for (i = caretPosNew; i < newValL; i++) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsAfterCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsBeforeCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (p.maskDigitPosMap[i]) {
                            maskDigitsBeforeCaretAll++;
                        }
                    }

                    for (i = caretPosOld - 1; i >= 0; i--) {
                        if (p.maskDigitPosMapOld[i]) {
                            maskDigitsBeforeCaretAllOld++;
                        }
                    }

                    // if the cursor is at the end keep it there
                    if (caretPosNew > oldValL) {
                      caretPosNew = newValL * 10;
                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                        if (!p.maskDigitPosMapOld[caretPosNew])  {
                          var caretPos = caretPosNew;
                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                          caretPosNew -= maskDigitsBeforeCaret;
                          if (p.maskDigitPosMap[caretPosNew])  {
                            caretPosNew = caretPos;
                          }
                        }
                    }
                    else if (caretPosNew > caretPosOld) {
                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                        caretPosNew += maskDigitsAfterCaret;
                    }
                }
                return caretPosNew;
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret(),
                        oldVal = el.data('mask-previus-value') || '';

                    // this is a compensation to devices/browsers that don't compensate
                    // caret positioning the right way
                    setTimeout(function() {
                      p.setCaret(p.calculateCaretPosition(oldVal));
                    }, $.jMaskGlobals.keyStrokeCompensation);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0, maskLen = mask.length,
                    v = 0, valLen = value.length,
                    offset = 1, addMethod = 'push',
                    resetPos = -1,
                    maskDigitCount = 0,
                    maskDigitPosArr = [],
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function () {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function () {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                             if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar && m !== resetPos) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            maskDigitCount--;
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            maskDigitPosArr.push(v);
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                            maskDigitPosArr.push(v + maskDigitCount);
                            maskDigitCount++;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                var newVal = buf.join('');
                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
                return newVal;
            },
            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
              var maskDiff = options.reverse ? newVal.length - valLen : 0;
              p.maskDigitPosMap = {};
              for (var i = 0; i < maskDigitPosArr.length; i++) {
                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
              }
            },
            callbacks: function (e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this, oldValue = p.val(), regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            if (jMask.options.placeholder) {
                el.removeAttr('placeholder');
            }
            if (el.data('mask-maxlength')) {
                el.removeAttr('maxlength');
            }
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
           return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function(val) {
           return p.getMasked(false, val);
        };

       jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder' , options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                  el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function () {
        var input = $(this),
            options = {},
            prefix = 'data-mask-',
            mask = input.attr('data-mask');

        if (input.attr(prefix + 'reverse')) {
            options.reverse = true;
        }

        if (input.attr(prefix + 'clearifnotmatch')) {
            options.clearIfNotMatch = true;
        }

        if (input.attr(prefix + 'selectonfocus') === 'true') {
           options.selectOnFocus = true;
        }

        if (notSameMaskObject(input, mask, options)) {
            return input.data('mask', new Mask(this, mask, options));
        }
    },
    notSameMaskObject = function(field, mask, options) {
        options = options || {};
        var maskObject = $(field).data('mask'),
            stringify = JSON.stringify,
            value = $(field).val() || $(field).text();
        try {
            if (typeof mask === 'function') {
                mask = mask(value);
            }
            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
        } catch (e) {}
    },
    eventSupported = function(eventName) {
        var el = document.createElement('div'), isSupported;

        eventName = 'on' + eventName;
        isSupported = (eventName in el);

        if ( !isSupported ) {
            el.setAttribute(eventName, 'return;');
            isSupported = typeof el[eventName] === 'function';
        }
        el = null;

        return isSupported;
    };

    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function(){
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function(val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        keyStrokeCompensation: 10,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': {pattern: /\d/},
            '9': {pattern: /\d/, optional: true},
            '#': {pattern: /\d/, recursive: true},
            'A': {pattern: /[a-zA-Z0-9]/},
            'S': {pattern: /[a-zA-Z]/}
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function() {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(82),
    baseLodash = __webpack_require__(114);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(391),
    mapCacheDelete = __webpack_require__(392),
    mapCacheGet = __webpack_require__(393),
    mapCacheHas = __webpack_require__(394),
    mapCacheSet = __webpack_require__(395);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(105),
    setCacheAdd = __webpack_require__(404),
    setCacheHas = __webpack_require__(405);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(323);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(112),
    eq = __webpack_require__(72);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(163);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(84),
    toKey = __webpack_require__(71);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(93),
    overRest = __webpack_require__(176),
    setToString = __webpack_require__(124);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(141);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(175);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(312),
    stubArray = __webpack_require__(188);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(22),
    isSymbol = __webpack_require__(96);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(59);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(341),
    shortOut = __webpack_require__(180);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(113);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObject = __webpack_require__(52);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(331),
    baseUnary = __webpack_require__(83),
    nodeUtil = __webpack_require__(122);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(338),
    basePropertyDeep = __webpack_require__(339),
    isKey = __webpack_require__(121),
    toKey = __webpack_require__(71);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(182),
    isObject = __webpack_require__(52);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CONTAINER_CLASS_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ICON_CLASS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VISIBLE_CLASS_NAME; });
/* unused harmony export HIDDEN_CLASS_NAME */
/* unused harmony export appendIconContainer */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIconify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__floating_label__ = __webpack_require__(70);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for doing the baseline setup for an iconify floating label.
 * @module iconifySetup
 */



/**
 * Defines default configuration for iconify.
 * @type {Object}
 */
var DEFAULT_ICONIFY_OPTIONS = {
  prefix: 'iconify',
  containerClassName: 'floating-label__iconify',
  containerElementName: 'div'
};

/**
 * CSS className used for the container.
 * @type {string}
 */
var CONTAINER_CLASS_NAME = 'iconify';

/**
 * CSS className for an icon element.
 * @type {string}
 */
var ICON_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon");

/**
 * CSS className for a visible modifier.
 * @type {string}
 */
var VISIBLE_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon--visible");

/**
 * CSS className for a hidden modifier.
 * @type {string}
 */
var HIDDEN_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon--hidden");

/**
 * Obtains all the available icons based on how the data-iconify-* attributes
 * have been configured.
 * @private
 * @param {Array} acceptedIcons - List of icons with affiliated data
 * @param {Object} dataset - Data attributes on the floating label container
 * @param {string} prefix - Prepended name applied to the data attributes
 * @returns {Array} Al available icons based on name, text, and the unique ID
 */
var getAvailableIcons = function getAvailableIcons(acceptedIcons, dataset, prefix) {
  return acceptedIcons.map(function (_ref) {
    var name = _ref.name,
      iconId = _ref.iconId;
    return {
      name: name,
      iconId: iconId,
      text: dataset[__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default()("".concat(prefix, "-").concat(name))]
    };
  }).filter(function (_ref2) {
    var text = _ref2.text;
    return text;
  });
};

/**
 * Creates the icon container with the selected icons.
 * @private
 * @param {Object} icons - Set of icons that will be rendered
 * @param {string} containerClassName - CSS className for the icon container
 * @param {string} iconClassName - CSS className applied to a single icon
 * @param {string} hiddenClassName - CSS className used to hide an icon
 * @returns {string} String representation of rendered icons
 */
var renderIcons = function renderIcons(_ref3) {
  var icons = _ref3.icons,
    containerClassName = _ref3.containerClassName,
    iconClassName = _ref3.iconClassName,
    hiddenClassName = _ref3.hiddenClassName;
  return "\n  <div class=\"".concat(containerClassName, "\">\n    ").concat(icons.map(function (_ref4) {
    var text = _ref4.text,
      iconId = _ref4.iconId;
    return "\n      <span class=\"".concat(iconClassName, " ").concat(hiddenClassName, " icon ").concat(iconClassName, "--").concat(iconId, "\">\n        <svg>\n          <title>").concat(text, "</title>\n          <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-").concat(iconId, "\"></use>\n        </svg>\n      </span>\n    ");
  }).join(''), "\n  </div>\n");
};

/**
 * Append the icon container to the DOM.
 * @private
 * @param {HTMLElement} floatingLabel - The floating label container
 * @param {Object} icons - Set of icons that will be rendered
 * @param {string} elementName - Name of the element for the appended element
 * @param {string} className - CSS className for the appended element
 * @returns {Element} The icon container
 */
var appendIconContainer = function appendIconContainer(floatingLabel, icons, elementName, className) {
  var container = document.createElement(elementName);
  container.classList.add(className);
  container.innerHTML = renderIcons({
    icons: icons,
    containerClassName: CONTAINER_CLASS_NAME,
    iconClassName: ICON_CLASS_NAME,
    hiddenClassName: HIDDEN_CLASS_NAME
  });
  floatingLabel.appendChild(container);
  return container;
};

/**
 * Looks for all icon related nodes and creates an object based on the name of
 * the icon. This will allow for the consumers of this code to easily reference
 * icons based on what has been passed in by the consumers.
 * @private
 * @param {HTMLElement} iconContainer - Element with icon container
 * @param {Array} icons - Reference to passed in icons from consumer
 * @returns {Object} Contains icons keyed by icon name with icon HTML element
 */
var findIconNodes = function findIconNodes(iconContainer, icons) {
  return icons.reduce(function (acc, _ref5) {
    var name = _ref5.name,
      iconId = _ref5.iconId;
    return $.extend({}, acc, _defineProperty({}, name, iconContainer.querySelector(".".concat(ICON_CLASS_NAME, "--").concat(iconId))));
  }, {});
};

/**
 * Responsible for taking a list of icons, HTML elements, and options with the
 * intention of rendering a icon contains and the icons that have been passed
 * in. This is a common piece of functionality that covers a couple different
 * of iconify floating labels. The goal here is to ensure iconify floating
 * labels can focus on their functionality without having to worry about doing
 * this type of setup and expose all the available elements created so they
 * can be leveraged by the consumers.
 * @see DEFAULT_ICONIFY_OPTIONS
 * @param {Array} possibleIcons - Icons that might be available
 * @param {Array} nodes - All floating label related elements
 * @param {Object} options - Used for overriding any options
 * @returns {Object} HTML elements pertaining to the icons being rendered
 */
function setupIconify(possibleIcons, nodes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _$$extend2 = $.extend({}, DEFAULT_ICONIFY_OPTIONS, options),
    prefix = _$$extend2.prefix,
    className = _$$extend2.containerClassName,
    elementName = _$$extend2.containerElementName;
  var _nodes$filter = nodes.filter(function (_ref6) {
      var type = _ref6.type;
      return __WEBPACK_IMPORTED_MODULE_1__floating_label__["c" /* TYPES */].CONTAINER === type;
    }),
    _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
    floatingLabel = _nodes$filter2[0].node;
  var _nodes$filter3 = nodes.filter(function (_ref7) {
      var type = _ref7.type;
      return __WEBPACK_IMPORTED_MODULE_1__floating_label__["c" /* TYPES */].FIELD === type;
    }),
    _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
    formField = _nodes$filter4[0].node;
  var availableIcons = getAvailableIcons(possibleIcons, floatingLabel.dataset, prefix);
  if (!availableIcons.length) {
    return {};
  }
  var iconContainer = appendIconContainer(floatingLabel, availableIcons, elementName, className);
  var iconNodes = findIconNodes(iconContainer, availableIcons);
  return {
    floatingLabel: floatingLabel,
    formField: formField,
    iconContainer: iconContainer,
    iconNodes: iconNodes
  };
}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BLOCK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCarousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_arrow__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_accessible__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_props__ = __webpack_require__(60);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var BLOCK_NAME = 'image-carousel';

/**
 *
 * AB Test 899 HP/PDP Increased Slick Sensitivity
 */
var increasedSensitivity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_props__["a" /* get */])('slick.slickSensitivity', false);

/**
 * Wires up slick slider and provides hooks such that the internal can talk to
 * external functionality.
 */
var ImageCarousel = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {HTMLElement|string} el - Element (or a selector) containing the slider
   * @param {Object} options - Any additional options based along to the slider
   */
  function ImageCarousel(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ImageCarousel);
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var _$el$data = $el.data(),
      nextArrowTitle = _$el$data.nextArrowTitle,
      previousArrowTitle = _$el$data.previousArrowTitle;

    // Mock Content Start - AB Test 899 PDP Increased Slick Sensitivity
    if (increasedSensitivity) document.body.classList.add('ab899-slick-sensitivity');
    // Mock Content End

    this.num = 0;
    this.$el = $el.slickAccessible(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
      lazyLoad: 'ondemand',
      dots: true,
      dotsClass: "".concat(BLOCK_NAME, "__dots"),
      appendDots: $el,
      infinite: true,
      nextArrow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__slick_arrow__["a" /* default */])('next', nextArrowTitle, 'arrow-right-lg'),
      prevArrow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__slick_arrow__["a" /* default */])('previous', previousArrowTitle, 'arrow-left-lg'),
      slickContainer: '',
      counterContainer: '',
      // Mock Content Start - AB Test 899 PDP Increased Slick Sensitivity
      touchThreshold: increasedSensitivity ? 20 : 5,
      vertical: false,
      verticalSwiping: false
      // Mock Content End
    }, options));
  }
  /**
   * Sets the active slider number for later use.
   * @param {number} currentNum - The number of the active slide
   */
  return _createClass(ImageCarousel, [{
    key: "setSlideNumber",
    value: function setSlideNumber(currentNum) {
      this.num = currentNum;
    }

    /**
     * Transitions or goes to the slide number based on the current state.
     */
  }, {
    key: "transitionSlide",
    value: function transitionSlide() {
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isUndefined___default()(this.num)) {
        this.$el.slick('slickGoTo', this.num, true);
      }
    }
  }]);
}();

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('imageCarousel', function (el, opts) {
  return new ImageCarousel(el, opts);
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DOT_CLASS */
/* harmony export (immutable) */ __webpack_exports__["a"] = createCounter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Defines the className of the dot button
 * @type {string}
 */
var DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */

var updateCounterMarkup = function updateCounterMarkup(e, slick, $el, slickContainer, counterContainer) {
  var $parentElement = slickContainer.length ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slickContainer) : $el;
  var counterContainerIsProvided = counterContainer.length;
  if (counterContainerIsProvided) {
    $parentElement.find(counterContainer).html(slick.currentSlide + 1 + ' / ' + slick.slideCount);
  } else {
    $parentElement.find('.image-carousel__counter').html(slick.currentSlide + 1 + ' / ' + slick.slideCount);
  }
};
var counterMarkup = function counterMarkup(e, slick, $el, slickContainer, counterContainer) {
  var slickContainerIsProvided = slickContainer.length;
  var counterContainerIsProvided = counterContainer.length;
  var $parentElement = slickContainerIsProvided ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slickContainer) : $el;
  var $counterContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(counterContainer);
  if (slickContainerIsProvided && counterContainerIsProvided) {
    $counterContainer.append("".concat(parseInt(slick.currentSlide + 1, 10), " / ").concat(slick.slideCount, " "));
  } else {
    $parentElement.append('<div class="image-carousel__counter">' + parseInt(slick.currentSlide + 1, 10) + ' / ' + slick.slideCount + '</div>');
  }
};
function createCounter($el, slickContainer, counterContainer) {
  $el.on('init', function (e, slick) {
    counterMarkup(e, slick, $el, slickContainer, counterContainer);
  });
  $el.on('afterChange', function (e, slick) {
    updateCounterMarkup(e, slick, $el, slickContainer, counterContainer);
  });
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DOT_CLASS */
/* harmony export (immutable) */ __webpack_exports__["a"] = customPaging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Defines the className of the dot button
 * @type {string}
 */
var DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */
function customPaging(_ref, i) {
  var $slides = _ref.$slides;
  // try to get the slide's id to use in the link's href
  var id = $slides[i].id || '';
  var $button;
  $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<button id=\"".concat(id, "\" class=\"").concat(DOT_CLASS, "\" data-role=\"none\">Image ").concat(i + 1, "\n    <span class=\"image-carousel__dots-active-text\">, currently selected</span>\n  </button>"));
  return $button.on('click', function (e) {
    return e.preventDefault();
  });
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(299);

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(82),
    baseLodash = __webpack_require__(114);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(342),
    isArguments = __webpack_require__(94),
    isArray = __webpack_require__(22),
    isBuffer = __webpack_require__(95),
    isIndex = __webpack_require__(89),
    isTypedArray = __webpack_require__(128);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(112),
    eq = __webpack_require__(72);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(80),
    arrayEach = __webpack_require__(143),
    assignValue = __webpack_require__(111),
    baseAssign = __webpack_require__(317),
    baseAssignIn = __webpack_require__(318),
    cloneBuffer = __webpack_require__(155),
    copyArray = __webpack_require__(85),
    copySymbols = __webpack_require__(351),
    copySymbolsIn = __webpack_require__(352),
    getAllKeys = __webpack_require__(165),
    getAllKeysIn = __webpack_require__(166),
    getTag = __webpack_require__(88),
    initCloneArray = __webpack_require__(378),
    initCloneByTag = __webpack_require__(379),
    initCloneObject = __webpack_require__(171),
    isArray = __webpack_require__(22),
    isBuffer = __webpack_require__(95),
    isMap = __webpack_require__(429),
    isObject = __webpack_require__(52),
    isSet = __webpack_require__(430),
    keys = __webpack_require__(69),
    keysIn = __webpack_require__(73);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(110),
    isFlattenable = __webpack_require__(381);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(110),
    isArray = __webpack_require__(22);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(325),
    isObjectLike = __webpack_require__(24);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(334),
    baseMatchesProperty = __webpack_require__(335),
    identity = __webpack_require__(93),
    isArray = __webpack_require__(22),
    property = __webpack_require__(129);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(93),
    metaMap = __webpack_require__(174);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(21);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(132)(module)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(117);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(115),
    isIterateeCall = __webpack_require__(382);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(313),
    deburr = __webpack_require__(424),
    words = __webpack_require__(443);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(157),
    composeArgsRight = __webpack_require__(158),
    countHolders = __webpack_require__(354),
    createCtor = __webpack_require__(86),
    createRecurry = __webpack_require__(162),
    getHolder = __webpack_require__(118),
    reorder = __webpack_require__(403),
    replaceHolders = __webpack_require__(92),
    root = __webpack_require__(21);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(384),
    setData = __webpack_require__(178),
    setWrapToString = __webpack_require__(179);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(106),
    arraySome = __webpack_require__(314),
    cacheHas = __webpack_require__(116);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(150),
    getSymbols = __webpack_require__(120),
    keys = __webpack_require__(69);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(150),
    getSymbolsIn = __webpack_require__(168),
    keysIn = __webpack_require__(73);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(174),
    noop = __webpack_require__(187);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(110),
    getPrototype = __webpack_require__(119),
    getSymbols = __webpack_require__(120),
    stubArray = __webpack_require__(188);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(84),
    isArguments = __webpack_require__(94),
    isArray = __webpack_require__(22),
    isIndex = __webpack_require__(89),
    isLength = __webpack_require__(127),
    toKey = __webpack_require__(71);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(82),
    getPrototype = __webpack_require__(119),
    isPrototype = __webpack_require__(90);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(142);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(107);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(153),
    shortOut = __webpack_require__(180);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(371),
    insertWrapDetails = __webpack_require__(380),
    setToString = __webpack_require__(124),
    updateWrapDetails = __webpack_require__(417);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52),
    now = __webpack_require__(435),
    toNumber = __webpack_require__(190);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(319),
    baseFlatten = __webpack_require__(149),
    baseRest = __webpack_require__(115),
    isArrayLikeObject = __webpack_require__(185);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(148),
    baseIteratee = __webpack_require__(152),
    toInteger = __webpack_require__(189);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(68),
    isObjectLike = __webpack_require__(24);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    getPrototype = __webpack_require__(119),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(439);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(344),
    isObject = __webpack_require__(52),
    isSymbol = __webpack_require__(96);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ES3 safe
var _undefined = void 0;

module.exports = function (value) { return value !== _undefined && value !== null; };


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports) {

$(function () {
  $('#signupEmailOpenButton').click(function (e) {
    if (validEmail($("#emailSubscribe").val())) {
      $.modal({
        open: "subscribe",
        triggerOpen: true
      });
    }
  });
  function validEmail(email) {
    var atPosition = email.indexOf("@");
    var dotPosition = email.lastIndexOf(".");
    if (atPosition < 1 || dotPosition < atPosition + 2 || dotPosition + 2 >= email.length) {
      alert("Not a valid e-mail address");
      return false;
    }
    return true;
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_web_vitals__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_shop_the_look__ = __webpack_require__(218);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


var addToGlobal = function addToGlobal() {
  for (var _len = arguments.length, propTuple = new Array(_len), _key = 0; _key < _len; _key++) {
    propTuple[_key] = arguments[_key];
  }
  propTuple.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    window[name] = value;
  });
};
addToGlobal(['getLCP', __WEBPACK_IMPORTED_MODULE_0_web_vitals__["a" /* getLCP */]], ['getCLS', __WEBPACK_IMPORTED_MODULE_0_web_vitals__["b" /* getCLS */]], ['onINP', __WEBPACK_IMPORTED_MODULE_0_web_vitals__["c" /* onINP */]]);
$(function () {
  $('.js-shop-the-look-modal').shopTheLookModal();
  $('#editorPickSection').on('shopTheLookLoaded', function () {
    $('.js-shop-the-look-modal').shopTheLookModal();
  });
  var searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get(window.rcProps.clearWishlistUrlParam) === 'true') {
    $.modal({
      url: window.rcProps.oldWishlistRemovedModalHref,
      type: 'notification',
      triggerOpen: true
    });
  }
});

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
window.logEngagementWithDetails = function logEngagementWithDetails(url, module, action, details) {
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_search__ = __webpack_require__(217);


function initSearch() {
  __WEBPACK_IMPORTED_MODULE_1_modules_search__["a" /* default */].init();
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  initSearch();
});
function WishlistCountUpdater() {
  /**
   * Update the wishlist items count.
   * @param onUpdate the callback function executed on successful count update. The count value is passed as the first
   *  argument to the callback function.
   */
  this.updateCount = function (onUpdate) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'POST',
      url: "/fw/ajax/GetWishlistItemsCount.jsp",
      success: function success(ajaxResponse) {
        var responseObject = JSON.parse(ajaxResponse);
        if (responseObject.success) {
          var count = responseObject.data;
          if (count < 100) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").text(count);
          } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").text("99+");
          }
          var limit = responseObject.limit;
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('count', count);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('limit', limit);
          if (responseObject.maxPopup) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wish-max-popup-div').empty().append(responseObject.maxPopup);
          }
          if (typeof onUpdate === 'function') {
            onUpdate(count);
          }
        }
      }
    });
  };
  this.showWishListMaxRestrictionPopup = function () {
    var productCount = 0;
    var maxLimit = 0;
    var str = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('count');
    if (!Number.isNaN(Number(str))) {
      productCount = Number(str);
    }
    str = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('limit');
    if (!Number.isNaN(Number(str))) {
      maxLimit = Number(str);
    }
    if (productCount >= maxLimit && __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#restrict-favorites").length) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        triggerOpen: true,
        open: "restrict-favorites"
      });
      return true;
    }
    return false;
  };
}
function clearOldWishItems() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'GET',
    url: '/fw/content/wishlist/clearOldItems',
    success: function success() {
      window.location.search += "&".concat(window.rcProps.clearWishlistUrlParam, "=true");
    }
  });
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  window.WishlistCountUpdater = WishlistCountUpdater;
  window.clearOldWishItems = clearOldWishItems;
  //Get initial wishlist count
  var wishlistCountUpdater = new WishlistCountUpdater();
  wishlistCountUpdater.updateCount();
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow').find('.cookie-banner-slide').length == 0) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookie-banner-global').show();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-close-banner-custom").click(function (e) {
    e.preventDefault();
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".banner--slider-list__item.slick-active");
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".banner--slider-list__item.slick-active").find('.cookie-banner-slide').length) {
      if (typeof cookiesClose === "function") {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow').slick('slickRemove', __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.slick-slide').index(el) - 1);
        cookiesClose();
        el.remove();
      }
    } else {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow').find('.cookie-banner-slide').length) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookie-banner-global').show();
      }
      var slideClosed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).siblings('.banner--slider-list').find('.banner--slider-list__item');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-parent').hide().remove();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SetRevolveSessionParam.jsp", __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        "key": "fglobalbannerdismiss",
        "value": "disableglobalbanner"
      }), function () {});
    }
  });
  if (rcProps.cart && rcProps.cart.detailsHref) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      cache: false,
      url: rcProps.cart.detailsHref,
      dataType: 'json',
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopping_bag_count').html(data.itemCount);
      }
    });
  }
});

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_lib__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_base__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_elements__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_layouts__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_layouts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layouts_layouts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_modules__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_helpers__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helpers_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_scss__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__main_scss__);








/***/ }),
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styleguide_styleguide__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_log_engagement__ = __webpack_require__(54);





window.logEngagement = __WEBPACK_IMPORTED_MODULE_4_modules_log_engagement__["a" /* default */];

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vendor_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mustache__);



/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    initSearchBar();
    if (window.rcProps && typeof window.rcProps.get === 'function') {
      initVisualSearch();
    }
  }
});
function initSearchBar() {
  // New Search
  var textboxInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__input');
  var cancelSearch = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__x');
  var searchForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search');
  var searchBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-button');
  var closeBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-search-close');
  var searchOverlay;
  var createOverlay = function createOverlay(e) {
    searchOverlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div>', {
      "class": 'site-search__overlay'
    });
    return searchOverlay;
  };
  var updateField = function updateField(e) {
    if (textboxInput.val().length > 0) {
      cancelSearch.addClass('is-active');
    } else {
      cancelSearch.removeClass('is-active');
    }
  };
  var clearInput = function clearInput() {
    cancelSearch.removeClass('is-active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-input').typeahead('val', '');
  };
  var closeSearch = function closeSearch() {
    searchForm.fadeOut(400, function () {});
    searchOverlay.removeClass('site-search__overlay--active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search').attr('aria-modal', false);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').attr('aria-expanded', false);
    clearInput();
  };
  var openSearch = function openSearch(e) {
    searchForm.show();
    textboxInput.focus();
    searchOverlay.addClass('site-search__overlay--active');
    logEngagement('Search Box');
  };
  var addEventListeners = function addEventListeners() {
    cancelSearch.on('click', clearInput);
    searchBtn.on('click', openSearch);
    closeBtn.on('click', closeSearch);
    textboxInput.keyup(updateField);
    searchOverlay.on('click', closeSearch);
  };
  var initSearch = function initSearch() {
    createOverlay();
    addEventListeners();
  };
  initSearch();
}
function initVisualSearch() {
  if (!window.rcProps) return;
  /*
   Suggestive Search
   =================
   */

  // Products
  var products = new __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a({
    datumTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.obj.whitespace("productName"),
    queryTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.whitespace,
    remote: {
      url: '/r/ajax/VisualSearch.jsp?fw=true&q=%QUERY&d=' + rcProps.department,
      wildcard: '%QUERY'
    }
  });

  // Text Suggestions
  var textSuggestions = new __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a({
    datumTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.obj.whitespace("searchTerm"),
    queryTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.whitespace,
    remote: {
      url: '/r/ajax/TextSuggestions.jsp?fw=true&q=%QUERY&d=' + rcProps.department,
      wildcard: '%QUERY'
    }
  });
  // Creates typeahead feature on search box.
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-input').typeahead({
    hint: false,
    highlight: true,
    minLength: window.rcProps.search.minCharLengthForSearching,
    classNames: {
      menu: 'site-search__results',
      dataset: "g n-block-grid--1"
    }
  }, {
    name: 'textSuggestions',
    display: function display(obj) {
      return obj.suggestion;
    },
    source: textSuggestions,
    templates: {
      suggestion: function suggestion(data) {
        return __WEBPACK_IMPORTED_MODULE_2_mustache___default.a.render(rcProps.get("search.text.templates.line"), data);
      }
    },
    limit: rcProps.get("search.text.limit")
  }, {
    name: 'recent',
    display: function display(obj) {
      return obj.searchText;
    },
    source: function source(query, callback) {
      callback(rcProps.get('search.recent.json'));
    },
    templates: {
      suggestion: function suggestion(data) {
        return __WEBPACK_IMPORTED_MODULE_2_mustache___default.a.render(rcProps.get('search.recent.template'), data);
      }
    }
  }, {
    name: 'productSuggestions',
    display: 'productName',
    source: products,
    templates: {
      header: function header() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-search-hed-target").parent().before(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-search-hed-target"));
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-search-hed-target').first().remove();
        return rcProps.get("search.visual.templates.header");
      },
      suggestion: function suggestion(data) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-search__results .n-block-grid--1-productSuggestions").removeClass("g n-block-grid--1").addClass("horizontal-scroll u-flex");
        return __WEBPACK_IMPORTED_MODULE_2_mustache___default.a.render(rcProps.get("search.visual.templates.line"), data);
      },
      notFound: function notFound() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.n-block-grid--1-productSuggestions').removeClass('horizontal-scroll');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product-suggestions__title').remove();
      }
    },
    limit: rcProps.get("search.visual.limit")
  }).on('typeahead:select', function (event, suggestion) {
    logEngagement("click_search_suggestion_" + (suggestion.termType || "search"));
    if ("productURL" in suggestion) {
      window.location.href = suggestion.productURL;
    } else if ("suggestionUrl" in suggestion) {
      window.location.href = suggestion.suggestionUrl;
    } else if ('href' in suggestion) {
      // Recent search
      window.location.href = suggestion.href;
    } else {
      var href = '/content/s/ct?type=' + suggestion.typeShortCode + '&q=' + suggestion.searchTerm + '&s=' + suggestion.suggestion + '&d=' + rcProps.get("department");
      window.location.href = href;
    }
  }).on('typeahead:render', function ($e) {
    /**
     * we're showing 5 recently searches initially,
     * but as you type, show only 3 max.
     */
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-input').val().length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.n-block-grid--1-recent li').slice(3).hide();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.n-block-grid--1-recent li').slice(3).show();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dropdown-menu").addClass("site-search__predictions").css({
    "left": "",
    "z-index": "",
    "right": ""
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".twitter-typeahead").addClass("site-search__typeahead form-search__input").css({
    'width': '60%'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dataset-textSuggestions").addClass("site-search__suggestions");
  // remove once UX-9169 has been implemented
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-search__results div").first().removeClass("g n-block-grid--2  n-block-grid--2-textSuggestions");
  // $(".site-search__results-wrap div").first().removeClass("g n-block-grid--2  n-block-grid--2-textSuggestions");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dataset-products").addClass("g").addClass("n-block-grid--2");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-highlight").addClass("site-search__highlight");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dataset-products").addClass("predict-related");
  // remove once UX-9169 has been implemented
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').insertAfter(".site-search");
  // $('.site-search__results-wrap').insertAfter(".site-search");
  //$('.site-search__results').css({ display:"inline-block" });
  // remove once UX-9169 has been implemented
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').css({
    width: "100%"
  });
  // $('.site-search__results-wrap').css({ width: "100%" });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').css({
    'padding-bottom': '17px'
  });
  // $('.site-search__results-wrap').css({ 'padding-bottom': '17px' });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search').attr('aria-modal', true);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').attr('aria-expanded', true);
}
function logEngagement(action) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: window.location.href,
      module: "mobile_search",
      action: action
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__entry_points_pdp_add_to_bag__ = __webpack_require__(23);



var PLUGIN_NAME = 'shopTheLookModal';
var DEFAULTS = {};


/**
 * Displays a confirmation block within the modal content.
 *
 * @param {jQuery} $modalContent - The jQuery object representing the modal content.
 */
var showConfirmation = function showConfirmation($modalContent) {
  var $confirmationBlock = $modalContent.find('.js-stl-confirmation');

  // Fade in the confirmation block
  $confirmationBlock.fadeIn(500);

  // Fade out the confirmation block after 3 seconds
  setTimeout(function () {
    $confirmationBlock.fadeOut(500);
  }, 3000);
};

/**
 * Handles the form submission event for adding a product size to the bag.
 *
 * @param {jQuery} $slickCarousel - The slick carousel jQuery object.
 * @param {jQuery} $modalContent - The jQuery object representing the modal content.
 */
var handleFormSubmit = function handleFormSubmit($slickCarousel, $modalContent) {
  var $currentSlide = $slickCarousel.find('.slick-current.slick-active');
  var productCode = $currentSlide.find('.js-product-slide').data('productCode');
  var $formToSubmit = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sizes-".concat(productCode));
  var $sizeOption = $modalContent.find('.js-stl-size-options:visible');

  // Attach submit event handler to the form
  $formToSubmit.on('submit', function (e) {
    e.preventDefault(); // Prevent default form submission behavior
    var $size = $sizeOption.length ? $sizeOption.find(":selected").val() : 'all';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__entry_points_pdp_add_to_bag__["a" /* default */])(productCode, $size, false, false);
    showConfirmation($modalContent);
  });
};

/**
 * Updates the "Add to Bag" button text based on the product's preorder status.
 *
 * @param {boolean} preorder - Indicates if the product is a preorder.
 * @param {jQuery} $modalContent - The jQuery object representing the modal content.
 */
var updateAddToBagButton = function updateAddToBagButton(preorder, $modalContent) {
  var $addToBagBtn = $modalContent.find('.js-stl-add-to-bag:visible');
  var addToBagText = $addToBagBtn.data('addToBagText');
  var preorderText = $addToBagBtn.data('preorderText');

  // Update button text based on preorder status
  $addToBagBtn.text(preorder ? preorderText : addToBagText);
};

/**
 * Applies the appropriate UI updates based on the selected product size.
 *
 * @param {Object} selectedSizeData - Data attributes for the selected size.
 * @param {jQuery} $modalContent - The jQuery object representing the modal content.
 */
var setUseCases = function setUseCases(selectedSizeData, $modalContent) {
  var preorder = selectedSizeData.preorder;
  updateAddToBagButton(preorder, $modalContent);
};

/**
 * Displays the relevant product details based on the current slide.
 *
 * @param {jQuery} $slickCarousel - The slick carousel jQuery object.
 * @param {string} sizesContainer - Selector for the size options container.
 * @param {jQuery} $modalContent - The jQuery object representing the modal content.
 */
var showProductDetails = function showProductDetails($slickCarousel, sizesContainer, $modalContent) {
  var $currentSlide = $slickCarousel.find('.slick-current.slick-active');
  var productCode = $currentSlide.find('.js-product-slide').data('productCode');
  var productDetails = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-details-block-".concat(productCode));
  var $sizesSelect = $modalContent.find('.js-stl-size-options:visible');

  // Reset size selection and display relevant product details
  $sizesSelect.off('change');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(sizesContainer, " > div")).hide();
  productDetails.show();
};

/**
 * Sets up the size change handler to update the UI based on the selected size.
 *
 * @param {jQuery} $modalContent - The jQuery object representing the modal content.
 * @param {jQuery} $slickCarousel - The slick carousel jQuery object.
 */
var setSizeUpdate = function setSizeUpdate($modalContent, $slickCarousel) {
  var $sizesSelect = $modalContent.find('.js-stl-size-options:visible');
  var $currentSlide = $slickCarousel.find('.slick-current.slick-active');
  var isOneSize = $currentSlide.find('.js-product-slide').data('oneSize');
  if (!isOneSize) {
    // Attach change event handler to the size selector
    $sizesSelect.on('change', function () {
      var selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('option:selected');
      var selectedSizeData = selectedSize.data();
      setUseCases(selectedSizeData, $modalContent);
    });
  }
};

/**
 * Handles updates to the carousel and triggers relevant UI updates.
 *
 * @param {jQuery} $slickCarousel - The slick carousel jQuery object.
 * @param {string} sizesContainer - Selector for the size options container.
 * @param {jQuery} $modalContent - The jQuery object representing the modal content.
 */
var handleSwipeUpdate = function handleSwipeUpdate($slickCarousel, sizesContainer, $modalContent) {
  $slickCarousel.on('afterChange', function () {
    showProductDetails($slickCarousel, sizesContainer, $modalContent);
    setSizeUpdate($modalContent, $slickCarousel);
    handleFormSubmit($slickCarousel, $modalContent);
  });
};

/**
 * Initializes and opens the modal, setting up carousel and event handlers.
 *
 * @param {jQuery} triggerElement - The element that triggered the modal opening.
 */
var openModal = function openModal(triggerElement) {
  var modalHref = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(triggerElement).data('href');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: modalHref,
    triggerOpen: true,
    type: 'toast',
    triggerElement: triggerElement,
    addModifierClass: 'modal--padding-rl-0',
    onComplete: function onComplete(opts) {
      var $modalContent = opts.content;
      var sizesContainer = '.js-product-sizes';
      var $slickCarousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slick-stl');

      // Initialize the slick carousel
      $slickCarousel.imageCarousel({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        dots: false,
        slickContainer: '.js-slick-container',
        counterContainer: '.js-slick-counter',
        accessibility: true
      });
      handleSwipeUpdate($slickCarousel, sizesContainer, $modalContent);
      setSizeUpdate($modalContent, $slickCarousel);
      handleFormSubmit($slickCarousel, $modalContent);
    }
  });
};

/**
 * Sets up the click event listener to open the modal.
 *
 * @param {jQuery} $el - The jQuery object for the modal trigger element.
 */
var setEventListeners = function setEventListeners($el) {
  $el.on('click', function (e) {
    var triggerElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);
    openModal(triggerElement);
  });
};

/**
 * Initializes the "Shop the Look" modal and sets up event listeners.
 */
function shopTheLookModal(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el);
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, shopTheLookModal);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * typeahead.js 0.11.1
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
 */

// Applied pull request 1542: https://github.com/twitter/typeahead.js/pull/1542/commits/a9e6cec997c413146f81fd4e98107785be5c35e1
// Minified using: http://www.minifier.com/

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return root["Bloodhound"] = factory(a0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    module.exports = factory(require("jquery"));
  } else {
    root["Bloodhound"] = factory(jQuery);
  }
})(this, function ($) {
  var _ = function () {
    "use strict";

    return {
      isMsie: function isMsie() {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
      },
      isBlankString: function isBlankString(str) {
        return !str || /^\s*$/.test(str);
      },
      escapeRegExChars: function escapeRegExChars(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      isString: function isString(obj) {
        return typeof obj === "string";
      },
      isNumber: function isNumber(obj) {
        return typeof obj === "number";
      },
      isArray: $.isArray,
      isFunction: $.isFunction,
      isObject: $.isPlainObject,
      isUndefined: function isUndefined(obj) {
        return typeof obj === "undefined";
      },
      isElement: function isElement(obj) {
        return !!(obj && obj.nodeType === 1);
      },
      isJQuery: function isJQuery(obj) {
        return obj instanceof $;
      },
      toStr: function toStr(s) {
        return _.isUndefined(s) || s === null ? "" : s + "";
      },
      bind: $.proxy,
      each: function each(collection, cb) {
        $.each(collection, reverseArgs);
        function reverseArgs(index, value) {
          return cb(value, index);
        }
      },
      map: $.map,
      filter: $.grep,
      every: function every(obj, test) {
        var result = true;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (!(result = test.call(null, val, key, obj))) {
            return false;
          }
        });
        return !!result;
      },
      some: function some(obj, test) {
        var result = false;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (result = test.call(null, val, key, obj)) {
            return false;
          }
        });
        return !!result;
      },
      mixin: $.extend,
      identity: function identity(x) {
        return x;
      },
      clone: function clone(obj) {
        return $.extend(true, {}, obj);
      },
      getIdGenerator: function getIdGenerator() {
        var counter = 0;
        return function () {
          return counter++;
        };
      },
      templatify: function templatify(obj) {
        return $.isFunction(obj) ? obj : template;
        function template() {
          return String(obj);
        }
      },
      defer: function defer(fn) {
        setTimeout(fn, 0);
      },
      debounce: function debounce(func, wait, immediate) {
        var timeout, result;
        return function () {
          var context = this,
            args = arguments,
            later,
            callNow;
          later = function later() {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
          };
          callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            result = func.apply(context, args);
          }
          return result;
        };
      },
      throttle: function throttle(func, wait) {
        var context, args, timeout, result, previous, later;
        previous = 0;
        later = function later() {
          previous = new Date();
          timeout = null;
          result = func.apply(context, args);
        };
        return function () {
          var now = new Date(),
            remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
          } else if (!timeout) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      },
      stringify: function stringify(val) {
        return _.isString(val) ? val : JSON.stringify(val);
      },
      noop: function noop() {}
    };
  }();
  var VERSION = "0.11.1";
  var tokenizers = function () {
    "use strict";

    return {
      nonword: nonword,
      whitespace: whitespace,
      obj: {
        nonword: getObjTokenizer(nonword),
        whitespace: getObjTokenizer(whitespace)
      }
    };
    function whitespace(str) {
      str = _.toStr(str);
      return str ? str.split(/\s+/) : [];
    }
    function nonword(str) {
      str = _.toStr(str);
      return str ? str.split(/\W+/) : [];
    }
    function getObjTokenizer(tokenizer) {
      return function setKey(keys) {
        keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
        return function tokenize(o) {
          var tokens = [];
          _.each(keys, function (k) {
            tokens = tokens.concat(tokenizer(_.toStr(o[k])));
          });
          return tokens;
        };
      };
    }
  }();
  var LruCache = function () {
    "use strict";

    function LruCache(maxSize) {
      this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
      this.reset();
      if (this.maxSize <= 0) {
        this.set = this.get = $.noop;
      }
    }
    _.mixin(LruCache.prototype, {
      set: function set(key, val) {
        var tailItem = this.list.tail,
          node;
        if (this.size >= this.maxSize) {
          this.list.remove(tailItem);
          delete this.hash[tailItem.key];
          this.size--;
        }
        if (node = this.hash[key]) {
          node.val = val;
          this.list.moveToFront(node);
        } else {
          node = new Node(key, val);
          this.list.add(node);
          this.hash[key] = node;
          this.size++;
        }
      },
      get: function get(key) {
        var node = this.hash[key];
        if (node) {
          this.list.moveToFront(node);
          return node.val;
        }
      },
      reset: function reset() {
        this.size = 0;
        this.hash = {};
        this.list = new List();
      }
    });
    function List() {
      this.head = this.tail = null;
    }
    _.mixin(List.prototype, {
      add: function add(node) {
        if (this.head) {
          node.next = this.head;
          this.head.prev = node;
        }
        this.head = node;
        this.tail = this.tail || node;
      },
      remove: function remove(node) {
        node.prev ? node.prev.next = node.next : this.head = node.next;
        node.next ? node.next.prev = node.prev : this.tail = node.prev;
      },
      moveToFront: function moveToFront(node) {
        this.remove(node);
        this.add(node);
      }
    });
    function Node(key, val) {
      this.key = key;
      this.val = val;
      this.prev = this.next = null;
    }
    return LruCache;
  }();
  var PersistentStorage = function () {
    "use strict";

    var LOCAL_STORAGE;
    try {
      LOCAL_STORAGE = window.localStorage;
      LOCAL_STORAGE.setItem("~~~", "!");
      LOCAL_STORAGE.removeItem("~~~");
    } catch (err) {
      LOCAL_STORAGE = null;
    }
    function PersistentStorage(namespace, override) {
      this.prefix = ["__", namespace, "__"].join("");
      this.ttlKey = "__ttl__";
      this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
      this.ls = override || LOCAL_STORAGE;
      !this.ls && this._noop();
    }
    _.mixin(PersistentStorage.prototype, {
      _prefix: function _prefix(key) {
        return this.prefix + key;
      },
      _ttlKey: function _ttlKey(key) {
        return this._prefix(key) + this.ttlKey;
      },
      _noop: function _noop() {
        this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
      },
      _safeSet: function _safeSet(key, val) {
        try {
          this.ls.setItem(key, val);
        } catch (err) {
          if (err.name === "QuotaExceededError") {
            this.clear();
            this._noop();
          }
        }
      },
      get: function get(key) {
        if (this.isExpired(key)) {
          this.remove(key);
        }
        return decode(this.ls.getItem(this._prefix(key)));
      },
      set: function set(key, val, ttl) {
        if (_.isNumber(ttl)) {
          this._safeSet(this._ttlKey(key), encode(now() + ttl));
        } else {
          this.ls.removeItem(this._ttlKey(key));
        }
        return this._safeSet(this._prefix(key), encode(val));
      },
      remove: function remove(key) {
        this.ls.removeItem(this._ttlKey(key));
        this.ls.removeItem(this._prefix(key));
        return this;
      },
      clear: function clear() {
        var i,
          keys = gatherMatchingKeys(this.keyMatcher);
        for (i = keys.length; i--;) {
          this.remove(keys[i]);
        }
        return this;
      },
      isExpired: function isExpired(key) {
        var ttl = decode(this.ls.getItem(this._ttlKey(key)));
        return _.isNumber(ttl) && now() > ttl ? true : false;
      }
    });
    return PersistentStorage;
    function now() {
      return new Date().getTime();
    }
    function encode(val) {
      return JSON.stringify(_.isUndefined(val) ? null : val);
    }
    function decode(val) {
      return $.parseJSON(val);
    }
    function gatherMatchingKeys(keyMatcher) {
      var i,
        key,
        keys = [],
        len = LOCAL_STORAGE.length;
      for (i = 0; i < len; i++) {
        if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
          keys.push(key.replace(keyMatcher, ""));
        }
      }
      return keys;
    }
  }();
  var Transport = function () {
    "use strict";

    var pendingRequestsCount = 0,
      pendingRequests = {},
      maxPendingRequests = 6,
      sharedCache = new LruCache(10);
    function Transport(o) {
      o = o || {};
      this.cancelled = false;
      this.lastReq = null;
      this._send = o.transport;
      this._get = o.limiter ? o.limiter(this._get) : this._get;
      this._cache = o.cache === false ? new LruCache(0) : sharedCache;
    }
    Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
      maxPendingRequests = num;
    };
    Transport.resetCache = function resetCache() {
      sharedCache.reset();
    };
    _.mixin(Transport.prototype, {
      _fingerprint: function fingerprint(o) {
        o = o || {};
        return o.url + o.type + $.param(o.data || {});
      },
      _get: function _get(o, cb) {
        var that = this,
          fingerprint,
          jqXhr;
        fingerprint = this._fingerprint(o);
        if (this.cancelled || fingerprint !== this.lastReq) {
          return;
        }
        if (jqXhr = pendingRequests[fingerprint]) {
          jqXhr.done(done).fail(fail);
        } else if (pendingRequestsCount < maxPendingRequests) {
          pendingRequestsCount++;
          pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
        } else {
          this.onDeckRequestArgs = [].slice.call(arguments, 0);
        }
        function done(resp) {
          cb(null, resp);
          that._cache.set(fingerprint, resp);
        }
        function fail() {
          cb(true);
        }
        function always() {
          pendingRequestsCount--;
          delete pendingRequests[fingerprint];
          if (that.onDeckRequestArgs) {
            that._get.apply(that, that.onDeckRequestArgs);
            that.onDeckRequestArgs = null;
          }
        }
      },
      get: function get(o, cb) {
        var resp, fingerprint;
        cb = cb || $.noop;
        o = _.isString(o) ? {
          url: o
        } : o || {};
        fingerprint = this._fingerprint(o);
        this.cancelled = false;
        this.lastReq = fingerprint;
        if (resp = this._cache.get(fingerprint)) {
          cb(null, resp);
        } else {
          this._get(o, cb);
        }
      },
      cancel: function cancel() {
        this.cancelled = true;
      }
    });
    return Transport;
  }();
  var SearchIndex = window.SearchIndex = function () {
    "use strict";

    var CHILDREN = "c",
      IDS = "i";
    function SearchIndex(o) {
      o = o || {};
      if (!o.datumTokenizer || !o.queryTokenizer) {
        $.error("datumTokenizer and queryTokenizer are both required");
      }
      this.identify = o.identify || _.stringify;
      this.datumTokenizer = o.datumTokenizer;
      this.queryTokenizer = o.queryTokenizer;
      this.reset();
    }
    _.mixin(SearchIndex.prototype, {
      bootstrap: function bootstrap(o) {
        this.datums = o.datums;
        this.trie = o.trie;
      },
      add: function add(data) {
        var that = this;
        data = _.isArray(data) ? data : [data];
        _.each(data, function (datum) {
          var id, tokens;
          that.datums[id = that.identify(datum)] = datum;
          tokens = normalizeTokens(that.datumTokenizer(datum));
          _.each(tokens, function (token) {
            var node, chars, ch;
            node = that.trie;
            chars = token.split("");
            while (ch = chars.shift()) {
              node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
              node[IDS].push(id);
            }
          });
        });
      },
      get: function get(ids) {
        var that = this;
        return _.map(ids, function (id) {
          return that.datums[id];
        });
      },
      search: function search(query) {
        var that = this,
          tokens,
          matches;
        tokens = normalizeTokens(this.queryTokenizer(query));
        _.each(tokens, function (token) {
          var node, chars, ch, ids;
          if (matches && matches.length === 0) {
            return false;
          }
          node = that.trie;
          chars = token.split("");
          while (node && (ch = chars.shift())) {
            node = node[CHILDREN][ch];
          }
          if (node && chars.length === 0) {
            ids = node[IDS].slice(0);
            matches = matches ? getIntersection(matches, ids) : ids;
          } else {
            matches = [];
            return false;
          }
        });
        return matches ? _.map(unique(matches), function (id) {
          return that.datums[id];
        }) : [];
      },
      all: function all() {
        var values = [];
        for (var key in this.datums) {
          values.push(this.datums[key]);
        }
        return values;
      },
      reset: function reset() {
        this.datums = {};
        this.trie = newNode();
      },
      serialize: function serialize() {
        return {
          datums: this.datums,
          trie: this.trie
        };
      }
    });
    return SearchIndex;
    function normalizeTokens(tokens) {
      tokens = _.filter(tokens, function (token) {
        return !!token;
      });
      tokens = _.map(tokens, function (token) {
        return token.toLowerCase();
      });
      return tokens;
    }
    function newNode() {
      var node = {};
      node[IDS] = [];
      node[CHILDREN] = {};
      return node;
    }
    function unique(array) {
      var seen = {},
        uniques = [];
      for (var i = 0, len = array.length; i < len; i++) {
        if (!seen[array[i]]) {
          seen[array[i]] = true;
          uniques.push(array[i]);
        }
      }
      return uniques;
    }
    function getIntersection(arrayA, arrayB) {
      var ai = 0,
        bi = 0,
        intersection = [];
      arrayA = arrayA.sort();
      arrayB = arrayB.sort();
      var lenArrayA = arrayA.length,
        lenArrayB = arrayB.length;
      while (ai < lenArrayA && bi < lenArrayB) {
        if (arrayA[ai] < arrayB[bi]) {
          ai++;
        } else if (arrayA[ai] > arrayB[bi]) {
          bi++;
        } else {
          intersection.push(arrayA[ai]);
          ai++;
          bi++;
        }
      }
      return intersection;
    }
  }();
  var Prefetch = function () {
    "use strict";

    var keys;
    keys = {
      data: "data",
      protocol: "protocol",
      thumbprint: "thumbprint"
    };
    function Prefetch(o) {
      this.url = o.url;
      this.ttl = o.ttl;
      this.cache = o.cache;
      this.prepare = o.prepare;
      this.transform = o.transform;
      this.transport = o.transport;
      this.thumbprint = o.thumbprint;
      this.storage = new PersistentStorage(o.cacheKey);
    }
    _.mixin(Prefetch.prototype, {
      _settings: function settings() {
        return {
          url: this.url,
          type: "GET",
          dataType: "json"
        };
      },
      store: function store(data) {
        if (!this.cache) {
          return;
        }
        this.storage.set(keys.data, data, this.ttl);
        this.storage.set(keys.protocol, location.protocol, this.ttl);
        this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
      },
      fromCache: function fromCache() {
        var stored = {},
          isExpired;
        if (!this.cache) {
          return null;
        }
        stored.data = this.storage.get(keys.data);
        stored.protocol = this.storage.get(keys.protocol);
        stored.thumbprint = this.storage.get(keys.thumbprint);
        isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
        return stored.data && !isExpired ? stored.data : null;
      },
      fromNetwork: function fromNetwork(cb) {
        var that = this,
          settings;
        if (!cb) {
          return;
        }
        settings = this.prepare(this._settings());
        this.transport(settings).fail(onError).done(onResponse);
        function onError() {
          cb(true);
        }
        function onResponse(resp) {
          cb(null, that.transform(resp));
        }
      },
      clear: function clear() {
        this.storage.clear();
        return this;
      }
    });
    return Prefetch;
  }();
  var Remote = function () {
    "use strict";

    function Remote(o) {
      this.url = o.url;
      this.prepare = o.prepare;
      this.transform = o.transform;
      this.transport = new Transport({
        cache: o.cache,
        limiter: o.limiter,
        transport: o.transport
      });
    }
    _.mixin(Remote.prototype, {
      _settings: function settings() {
        return {
          url: this.url,
          type: "GET",
          dataType: "json"
        };
      },
      get: function get(query, cb) {
        var that = this,
          settings;
        if (!cb) {
          return;
        }
        query = query || "";
        settings = this.prepare(query, this._settings());
        return this.transport.get(settings, onResponse);
        function onResponse(err, resp) {
          err ? cb([]) : cb(that.transform(resp));
        }
      },
      cancelLastRequest: function cancelLastRequest() {
        this.transport.cancel();
      }
    });
    return Remote;
  }();
  var oParser = function () {
    "use strict";

    return function parse(o) {
      var defaults, sorter;
      defaults = {
        initialize: true,
        identify: _.stringify,
        datumTokenizer: null,
        queryTokenizer: null,
        sufficient: 5,
        sorter: null,
        local: [],
        prefetch: null,
        remote: null
      };
      o = _.mixin(defaults, o || {});
      !o.datumTokenizer && $.error("datumTokenizer is required");
      !o.queryTokenizer && $.error("queryTokenizer is required");
      sorter = o.sorter;
      o.sorter = sorter ? function (x) {
        return x.sort(sorter);
      } : _.identity;
      o.local = _.isFunction(o.local) ? o.local() : o.local;
      o.prefetch = parsePrefetch(o.prefetch);
      o.remote = parseRemote(o.remote);
      return o;
    };
    function parsePrefetch(o) {
      var defaults;
      if (!o) {
        return null;
      }
      defaults = {
        url: null,
        ttl: 24 * 60 * 60 * 1e3,
        cache: true,
        cacheKey: null,
        thumbprint: "",
        prepare: _.identity,
        transform: _.identity,
        transport: null
      };
      o = _.isString(o) ? {
        url: o
      } : o;
      o = _.mixin(defaults, o);
      !o.url && $.error("prefetch requires url to be set");
      o.transform = o.filter || o.transform;
      o.cacheKey = o.cacheKey || o.url;
      o.thumbprint = VERSION + o.thumbprint;
      o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
      return o;
    }
    function parseRemote(o) {
      var defaults;
      if (!o) {
        return;
      }
      defaults = {
        url: null,
        cache: true,
        prepare: null,
        replace: null,
        wildcard: null,
        limiter: null,
        rateLimitBy: "debounce",
        rateLimitWait: 300,
        transform: _.identity,
        transport: null
      };
      o = _.isString(o) ? {
        url: o
      } : o;
      o = _.mixin(defaults, o);
      !o.url && $.error("remote requires url to be set");
      o.transform = o.filter || o.transform;
      o.prepare = toRemotePrepare(o);
      o.limiter = toLimiter(o);
      o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
      delete o.replace;
      delete o.wildcard;
      delete o.rateLimitBy;
      delete o.rateLimitWait;
      return o;
    }
    function toRemotePrepare(o) {
      var prepare, replace, wildcard;
      prepare = o.prepare;
      replace = o.replace;
      wildcard = o.wildcard;
      if (prepare) {
        return prepare;
      }
      if (replace) {
        prepare = prepareByReplace;
      } else if (o.wildcard) {
        prepare = prepareByWildcard;
      } else {
        prepare = idenityPrepare;
      }
      return prepare;
      function prepareByReplace(query, settings) {
        settings.url = replace(settings.url, query);
        return settings;
      }
      function prepareByWildcard(query, settings) {
        settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
        return settings;
      }
      function idenityPrepare(query, settings) {
        return settings;
      }
    }
    function toLimiter(o) {
      var limiter, method, wait;
      limiter = o.limiter;
      method = o.rateLimitBy;
      wait = o.rateLimitWait;
      if (!limiter) {
        limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
      }
      return limiter;
      function debounce(wait) {
        return function debounce(fn) {
          return _.debounce(fn, wait);
        };
      }
      function throttle(wait) {
        return function throttle(fn) {
          return _.throttle(fn, wait);
        };
      }
    }
    function callbackToDeferred(fn) {
      return function wrapper(o) {
        var deferred = $.Deferred();
        fn(o, onSuccess, onError);
        return deferred;
        function onSuccess(resp) {
          _.defer(function () {
            deferred.resolve(resp);
          });
        }
        function onError(err) {
          _.defer(function () {
            deferred.reject(err);
          });
        }
      };
    }
  }();
  var Bloodhound = function () {
    "use strict";

    var old;
    old = window && window.Bloodhound;
    function Bloodhound(o) {
      o = oParser(o);
      this.sorter = o.sorter;
      this.identify = o.identify;
      this.sufficient = o.sufficient;
      this.local = o.local;
      this.remote = o.remote ? new Remote(o.remote) : null;
      this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
      this.index = new SearchIndex({
        identify: this.identify,
        datumTokenizer: o.datumTokenizer,
        queryTokenizer: o.queryTokenizer
      });
      o.initialize !== false && this.initialize();
    }
    Bloodhound.noConflict = function noConflict() {
      window && (window.Bloodhound = old);
      return Bloodhound;
    };
    Bloodhound.tokenizers = tokenizers;
    _.mixin(Bloodhound.prototype, {
      __ttAdapter: function ttAdapter() {
        var that = this;
        return this.remote ? withAsync : withoutAsync;
        function withAsync(query, sync, async) {
          return that.search(query, sync, async);
        }
        function withoutAsync(query, sync) {
          return that.search(query, sync);
        }
      },
      _loadPrefetch: function loadPrefetch() {
        var that = this,
          deferred,
          serialized;
        deferred = $.Deferred();
        if (!this.prefetch) {
          deferred.resolve();
        } else if (serialized = this.prefetch.fromCache()) {
          this.index.bootstrap(serialized);
          deferred.resolve();
        } else {
          this.prefetch.fromNetwork(done);
        }
        return deferred.promise();
        function done(err, data) {
          if (err) {
            return deferred.reject();
          }
          that.add(data);
          that.prefetch.store(that.index.serialize());
          deferred.resolve();
        }
      },
      _initialize: function initialize() {
        var that = this,
          deferred;
        this.clear();
        (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
        return this.initPromise;
        function addLocalToIndex() {
          that.add(that.local);
        }
      },
      initialize: function initialize(force) {
        return !this.initPromise || force ? this._initialize() : this.initPromise;
      },
      add: function add(data) {
        this.index.add(data);
        return this;
      },
      get: function get(ids) {
        ids = _.isArray(ids) ? ids : [].slice.call(arguments);
        return this.index.get(ids);
      },
      search: function search(query, sync, async) {
        var that = this,
          local;
        local = this.sorter(this.index.search(query));
        sync(this.remote ? local.slice() : local);
        if (this.remote && local.length < this.sufficient) {
          this.remote.get(query, processRemote);
        } else if (this.remote) {
          this.remote.cancelLastRequest();
        }
        return this;
        function processRemote(remote) {
          var nonDuplicates = [];
          _.each(remote, function (r) {
            !_.some(local, function (l) {
              return that.identify(r) === that.identify(l);
            }) && nonDuplicates.push(r);
          });
          async && async(nonDuplicates);
        }
      },
      all: function all() {
        return this.index.all();
      },
      clear: function clear() {
        this.index.reset();
        return this;
      },
      clearPrefetchCache: function clearPrefetchCache() {
        this.prefetch && this.prefetch.clear();
        return this;
      },
      clearRemoteCache: function clearRemoteCache() {
        Transport.resetCache();
        return this;
      },
      ttAdapter: function ttAdapter() {
        return this.__ttAdapter();
      }
    });
    return Bloodhound;
  }();
  return Bloodhound;
});
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return factory(a0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
})(this, function ($) {
  var _ = function () {
    "use strict";

    return {
      isMsie: function isMsie() {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
      },
      isBlankString: function isBlankString(str) {
        return !str || /^\s*$/.test(str);
      },
      escapeRegExChars: function escapeRegExChars(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      isString: function isString(obj) {
        return typeof obj === "string";
      },
      isNumber: function isNumber(obj) {
        return typeof obj === "number";
      },
      isArray: $.isArray,
      isFunction: $.isFunction,
      isObject: $.isPlainObject,
      isUndefined: function isUndefined(obj) {
        return typeof obj === "undefined";
      },
      isElement: function isElement(obj) {
        return !!(obj && obj.nodeType === 1);
      },
      isJQuery: function isJQuery(obj) {
        return obj instanceof $;
      },
      toStr: function toStr(s) {
        return _.isUndefined(s) || s === null ? "" : s + "";
      },
      bind: $.proxy,
      each: function each(collection, cb) {
        $.each(collection, reverseArgs);
        function reverseArgs(index, value) {
          return cb(value, index);
        }
      },
      map: $.map,
      filter: $.grep,
      every: function every(obj, test) {
        var result = true;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (!(result = test.call(null, val, key, obj))) {
            return false;
          }
        });
        return !!result;
      },
      some: function some(obj, test) {
        var result = false;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (result = test.call(null, val, key, obj)) {
            return false;
          }
        });
        return !!result;
      },
      mixin: $.extend,
      identity: function identity(x) {
        return x;
      },
      clone: function clone(obj) {
        return $.extend(true, {}, obj);
      },
      getIdGenerator: function getIdGenerator() {
        var counter = 0;
        return function () {
          return counter++;
        };
      },
      templatify: function templatify(obj) {
        return $.isFunction(obj) ? obj : template;
        function template() {
          return String(obj);
        }
      },
      defer: function defer(fn) {
        setTimeout(fn, 0);
      },
      debounce: function debounce(func, wait, immediate) {
        var timeout, result;
        return function () {
          var context = this,
            args = arguments,
            later,
            callNow;
          later = function later() {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
          };
          callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            result = func.apply(context, args);
          }
          return result;
        };
      },
      throttle: function throttle(func, wait) {
        var context, args, timeout, result, previous, later;
        previous = 0;
        later = function later() {
          previous = new Date();
          timeout = null;
          result = func.apply(context, args);
        };
        return function () {
          var now = new Date(),
            remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
          } else if (!timeout) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      },
      stringify: function stringify(val) {
        return _.isString(val) ? val : JSON.stringify(val);
      },
      noop: function noop() {}
    };
  }();
  var WWW = function () {
    "use strict";

    var defaultClassNames = {
      wrapper: "twitter-typeahead",
      input: "tt-input",
      hint: "tt-hint",
      menu: "tt-menu",
      dataset: "tt-dataset",
      suggestion: "tt-suggestion",
      selectable: "tt-selectable",
      empty: "tt-empty",
      open: "tt-open",
      cursor: "tt-cursor",
      highlight: "tt-highlight"
    };
    return build;
    function build(o) {
      var www, classes;
      classes = _.mixin({}, defaultClassNames, o);
      www = {
        css: buildCss(),
        classes: classes,
        html: buildHtml(classes),
        selectors: buildSelectors(classes)
      };
      return {
        css: www.css,
        html: www.html,
        classes: www.classes,
        selectors: www.selectors,
        mixin: function mixin(o) {
          _.mixin(o, www);
        }
      };
    }
    function buildHtml(c) {
      return {
        wrapper: '<span class="' + c.wrapper + '"></span>',
        menu: '<div class="' + c.menu + '"></div>'
      };
    }
    function buildSelectors(classes) {
      var selectors = {};
      _.each(classes, function (v, k) {
        selectors[k] = "." + v;
      });
      return selectors;
    }
    function buildCss() {
      var css = {
        wrapper: {
          position: "relative",
          display: "inline-block"
        },
        hint: {
          position: "absolute",
          top: "0",
          left: "0",
          borderColor: "transparent",
          boxShadow: "none",
          opacity: "1"
        },
        input: {
          position: "relative",
          verticalAlign: "top",
          backgroundColor: "transparent"
        },
        inputWithNoHint: {
          position: "relative",
          verticalAlign: "top"
        },
        menu: {
          //position: "absolute",
          position: "relative",
          top: "100%",
          left: "0",
          zIndex: "100",
          display: "none"
        },
        ltr: {
          left: "0",
          right: "auto"
        },
        rtl: {
          left: "auto",
          right: " 0"
        }
      };
      if (_.isMsie()) {
        _.mixin(css.input, {
          backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
        });
      }
      return css;
    }
  }();
  var EventBus = function () {
    "use strict";

    var namespace, deprecationMap;
    namespace = "typeahead:";
    deprecationMap = {
      render: "rendered",
      cursorchange: "cursorchanged",
      select: "selected",
      autocomplete: "autocompleted"
    };
    function EventBus(o) {
      if (!o || !o.el) {
        $.error("EventBus initialized without el");
      }
      this.$el = $(o.el);
    }
    _.mixin(EventBus.prototype, {
      _trigger: function _trigger(type, args) {
        var $e;
        $e = $.Event(namespace + type);
        (args = args || []).unshift($e);
        this.$el.trigger.apply(this.$el, args);
        return $e;
      },
      before: function before(type) {
        var args, $e;
        args = [].slice.call(arguments, 1);
        $e = this._trigger("before" + type, args);
        return $e.isDefaultPrevented();
      },
      trigger: function trigger(type) {
        var deprecatedType;
        this._trigger(type, [].slice.call(arguments, 1));
        if (deprecatedType = deprecationMap[type]) {
          this._trigger(deprecatedType, [].slice.call(arguments, 1));
        }
      }
    });
    return EventBus;
  }();
  var EventEmitter = function () {
    "use strict";

    var splitter = /\s+/,
      nextTick = getNextTick();
    return {
      onSync: onSync,
      onAsync: onAsync,
      off: off,
      trigger: trigger
    };
    function on(method, types, cb, context) {
      var type;
      if (!cb) {
        return this;
      }
      types = types.split(splitter);
      cb = context ? bindContext(cb, context) : cb;
      this._callbacks = this._callbacks || {};
      while (type = types.shift()) {
        this._callbacks[type] = this._callbacks[type] || {
          sync: [],
          async: []
        };
        this._callbacks[type][method].push(cb);
      }
      return this;
    }
    function onAsync(types, cb, context) {
      return on.call(this, "async", types, cb, context);
    }
    function onSync(types, cb, context) {
      return on.call(this, "sync", types, cb, context);
    }
    function off(types) {
      var type;
      if (!this._callbacks) {
        return this;
      }
      types = types.split(splitter);
      while (type = types.shift()) {
        delete this._callbacks[type];
      }
      return this;
    }
    function trigger(types) {
      var type, callbacks, args, syncFlush, asyncFlush;
      if (!this._callbacks) {
        return this;
      }
      types = types.split(splitter);
      args = [].slice.call(arguments, 1);
      while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
        syncFlush = getFlush(callbacks.sync, this, [type].concat(args));
        asyncFlush = getFlush(callbacks.async, this, [type].concat(args));
        syncFlush() && nextTick(asyncFlush);
      }
      return this;
    }
    function getFlush(callbacks, context, args) {
      return flush;
      function flush() {
        var cancelled;
        for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
          cancelled = callbacks[i].apply(context, args) === false;
        }
        return !cancelled;
      }
    }
    function getNextTick() {
      var nextTickFn;
      if (window.setImmediate) {
        nextTickFn = function nextTickSetImmediate(fn) {
          setImmediate(function () {
            fn();
          });
        };
      } else {
        nextTickFn = function nextTickSetTimeout(fn) {
          setTimeout(function () {
            fn();
          }, 0);
        };
      }
      return nextTickFn;
    }
    function bindContext(fn, context) {
      return fn.bind ? fn.bind(context) : function () {
        fn.apply(context, [].slice.call(arguments, 0));
      };
    }
  }();
  var highlight = function (doc) {
    "use strict";

    var defaults = {
      node: null,
      pattern: null,
      tagName: "strong",
      className: null,
      wordsOnly: false,
      caseSensitive: false
    };
    return function hightlight(o) {
      var regex;
      o = _.mixin({}, defaults, o);
      if (!o.node || !o.pattern) {
        return;
      }
      o.pattern = _.isArray(o.pattern) ? o.pattern : [o.pattern];
      regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
      traverse(o.node, hightlightTextNode);
      function hightlightTextNode(textNode) {
        var match, patternNode, wrapperNode;
        if (match = regex.exec(textNode.data)) {
          wrapperNode = doc.createElement(o.tagName);
          o.className && (wrapperNode.className = o.className);
          patternNode = textNode.splitText(match.index);
          patternNode.splitText(match[0].length);
          wrapperNode.appendChild(patternNode.cloneNode(true));
          textNode.parentNode.replaceChild(wrapperNode, patternNode);
        }
        return !!match;
      }
      function traverse(el, hightlightTextNode) {
        var childNode,
          TEXT_NODE_TYPE = 3;
        for (var i = 0; i < el.childNodes.length; i++) {
          childNode = el.childNodes[i];
          if (childNode.nodeType === TEXT_NODE_TYPE) {
            i += hightlightTextNode(childNode) ? 1 : 0;
          } else {
            traverse(childNode, hightlightTextNode);
          }
        }
      }
    };
    function getRegex(patterns, caseSensitive, wordsOnly) {
      var escapedPatterns = [],
        regexStr;
      for (var i = 0, len = patterns.length; i < len; i++) {
        escapedPatterns.push(_.escapeRegExChars(patterns[i]));
      }
      regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
      return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
    }
  }(window.document);
  var Input = function () {
    "use strict";

    var specialKeyCodeMap;
    specialKeyCodeMap = {
      9: "tab",
      27: "esc",
      37: "left",
      39: "right",
      13: "enter",
      38: "up",
      40: "down"
    };
    function Input(o, www) {
      o = o || {};
      if (!o.input) {
        $.error("input is missing");
      }
      www.mixin(this);
      this.$hint = $(o.hint);
      this.$input = $(o.input);
      this.query = this.$input.val();
      this.queryWhenFocused = this.hasFocus() ? this.query : null;
      this.$overflowHelper = buildOverflowHelper(this.$input);
      this._checkLanguageDirection();
      if (this.$hint.length === 0) {
        this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
      }
    }
    Input.normalizeQuery = function (str) {
      return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
    };
    _.mixin(Input.prototype, EventEmitter, {
      _onBlur: function onBlur() {
        this.resetInputValue();
        this.trigger("blurred");
      },
      _onFocus: function onFocus() {
        this.queryWhenFocused = this.query;
        this.trigger("focused");
      },
      _onKeydown: function onKeydown($e) {
        var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
        this._managePreventDefault(keyName, $e);
        if (keyName && this._shouldTrigger(keyName, $e)) {
          this.trigger(keyName + "Keyed", $e);
        }
      },
      _onInput: function onInput() {
        this._setQuery(this.getInputValue());
        this.clearHintIfInvalid();
        this._checkLanguageDirection();
      },
      _managePreventDefault: function managePreventDefault(keyName, $e) {
        var preventDefault;
        switch (keyName) {
          case "up":
          case "down":
            preventDefault = !withModifier($e);
            break;
          default:
            preventDefault = false;
        }
        preventDefault && $e.preventDefault();
      },
      _shouldTrigger: function shouldTrigger(keyName, $e) {
        var trigger;
        switch (keyName) {
          case "tab":
            trigger = !withModifier($e);
            break;
          default:
            trigger = true;
        }
        return trigger;
      },
      _checkLanguageDirection: function checkLanguageDirection() {
        var dir = (this.$input.css("direction") || "ltr").toLowerCase();
        if (this.dir !== dir) {
          this.dir = dir;
          this.$hint.attr("dir", dir);
          this.trigger("langDirChanged", dir);
        }
      },
      _setQuery: function setQuery(val, silent) {
        var areEquivalent, hasDifferentWhitespace;
        areEquivalent = areQueriesEquivalent(val, this.query);
        hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
        this.query = val;
        if (!silent && !areEquivalent) {
          this.trigger("queryChanged", this.query);
        } else if (!silent && hasDifferentWhitespace) {
          this.trigger("whitespaceChanged", this.query);
        }
      },
      bind: function bind() {
        var that = this,
          onBlur,
          onFocus,
          onKeydown,
          onInput;
        onBlur = _.bind(this._onBlur, this);
        onFocus = _.bind(this._onFocus, this);
        onKeydown = _.bind(this._onKeydown, this);
        onInput = _.bind(this._onInput, this);
        this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
        if (!_.isMsie() || _.isMsie() > 9) {
          this.$input.on("input.tt", onInput);
        } else {
          this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function ($e) {
            if (specialKeyCodeMap[$e.which || $e.keyCode]) {
              return;
            }
            _.defer(_.bind(that._onInput, that, $e));
          });
        }
        return this;
      },
      focus: function focus() {
        this.$input.focus();
      },
      blur: function blur() {
        this.$input.blur();
      },
      getLangDir: function getLangDir() {
        return this.dir;
      },
      getQuery: function getQuery() {
        return this.query || "";
      },
      setQuery: function setQuery(val, silent) {
        this.setInputValue(val);
        this._setQuery(val, silent);
      },
      hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
        return this.query !== this.queryWhenFocused;
      },
      getInputValue: function getInputValue() {
        return this.$input.val();
      },
      setInputValue: function setInputValue(value) {
        this.$input.val(value);
        this.clearHintIfInvalid();
        this._checkLanguageDirection();
      },
      resetInputValue: function resetInputValue() {
        this.setInputValue(this.query);
      },
      getHint: function getHint() {
        return this.$hint.val();
      },
      setHint: function setHint(value) {
        this.$hint.val(value);
      },
      clearHint: function clearHint() {
        this.setHint("");
      },
      clearHintIfInvalid: function clearHintIfInvalid() {
        var val, hint, valIsPrefixOfHint, isValid;
        val = this.getInputValue();
        hint = this.getHint();
        valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
        isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
        !isValid && this.clearHint();
      },
      hasFocus: function hasFocus() {
        return this.$input.is(":focus");
      },
      hasOverflow: function hasOverflow() {
        var constraint = this.$input.width() - 2;
        this.$overflowHelper.text(this.getInputValue());
        return this.$overflowHelper.width() >= constraint;
      },
      isCursorAtEnd: function isCursorAtEnd() {
        var valueLength, selectionStart, range;
        valueLength = this.$input.val().length;
        selectionStart = this.$input[0].selectionStart;
        if (_.isNumber(selectionStart)) {
          return selectionStart === valueLength;
        } else if (document.selection) {
          range = document.selection.createRange();
          range.moveStart("character", -valueLength);
          return valueLength === range.text.length;
        }
        return true;
      },
      destroy: function destroy() {
        this.$hint.off(".tt");
        this.$input.off(".tt");
        this.$overflowHelper.remove();
        this.$hint = this.$input = this.$overflowHelper = $("<div>");
      }
    });
    return Input;
    function buildOverflowHelper($input) {
      return $('<pre aria-hidden="true"></pre>').css({
        position: "absolute",
        visibility: "hidden",
        whiteSpace: "pre",
        fontFamily: $input.css("font-family"),
        //fontSize: $input.css("font-size"), //was forcing zoom - needs to be 16px
        fontStyle: $input.css("font-style"),
        fontVariant: $input.css("font-variant"),
        fontWeight: $input.css("font-weight"),
        wordSpacing: $input.css("word-spacing"),
        letterSpacing: $input.css("letter-spacing"),
        textIndent: $input.css("text-indent"),
        textRendering: $input.css("text-rendering"),
        textTransform: $input.css("text-transform")
      }).insertAfter($input);
    }
    function areQueriesEquivalent(a, b) {
      return Input.normalizeQuery(a) === Input.normalizeQuery(b);
    }
    function withModifier($e) {
      return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
    }
  }();
  var Dataset = function () {
    "use strict";

    var keys, nameGenerator;
    keys = {
      val: "tt-selectable-display",
      obj: "tt-selectable-object"
    };
    nameGenerator = _.getIdGenerator();
    function Dataset(o, www) {
      o = o || {};
      o.templates = o.templates || {};
      o.templates.notFound = o.templates.notFound || o.templates.empty;
      if (!o.source) {
        $.error("missing source");
      }
      if (!o.node) {
        $.error("missing node");
      }
      if (o.name && !isValidName(o.name)) {
        $.error("invalid dataset name:" + o.name);
      }
      www.mixin(this);
      this.highlight = !!o.highlight;
      this.name = o.name || nameGenerator();
      this.limit = o.limit || 5;
      this.displayFn = getDisplayFn(o.display || o.displayKey);
      this.templates = getTemplates(o.templates, this.displayFn);
      this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
      this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
      this._resetLastSuggestion();
      this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
    }
    Dataset.extractData = function extractData(el) {
      var $el = $(el);
      if ($el.data(keys.obj)) {
        return {
          val: $el.data(keys.val) || "",
          obj: $el.data(keys.obj) || null
        };
      }
      return null;
    };
    _.mixin(Dataset.prototype, EventEmitter, {
      _overwrite: function overwrite(query, suggestions) {
        suggestions = suggestions || [];
        if (suggestions.length) {
          this._renderSuggestions(query, suggestions);
        } else if (this.async && this.templates.pending) {
          this._renderPending(query);
        } else if (!this.async && this.templates.notFound) {
          this._renderNotFound(query);
        } else {
          this._empty();
        }
        this.trigger("rendered", this.name, suggestions, false);
      },
      _append: function append(query, suggestions) {
        suggestions = suggestions || [];
        if (suggestions.length && this.$lastSuggestion.length) {
          this._appendSuggestions(query, suggestions);
        } else if (suggestions.length) {
          this._renderSuggestions(query, suggestions);
        } else if (!this.$lastSuggestion.length && this.templates.notFound) {
          this._renderNotFound(query);
        }
        this.trigger("rendered", this.name, suggestions, true);
      },
      _renderSuggestions: function renderSuggestions(query, suggestions) {
        var $fragment;
        $fragment = this._getSuggestionsFragment(query, suggestions);
        this.$lastSuggestion = $fragment.children().last();
        this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
      },
      _appendSuggestions: function appendSuggestions(query, suggestions) {
        var $fragment, $lastSuggestion;
        $fragment = this._getSuggestionsFragment(query, suggestions);
        $lastSuggestion = $fragment.children().last();
        this.$lastSuggestion.after($fragment);
        this.$lastSuggestion = $lastSuggestion;
      },
      _renderPending: function renderPending(query) {
        var template = this.templates.pending;
        this._resetLastSuggestion();
        template && this.$el.html(template({
          query: query,
          dataset: this.name
        }));
      },
      _renderNotFound: function renderNotFound(query) {
        var template = this.templates.notFound;
        this._resetLastSuggestion();
        template && this.$el.html(template({
          query: query,
          dataset: this.name
        }));
      },
      _empty: function empty() {
        this.$el.empty();
        this._resetLastSuggestion();
      },
      _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
        var that = this,
          fragment;
        fragment = document.createDocumentFragment();
        _.each(suggestions, function getSuggestionNode(suggestion) {
          var $el, context;
          context = that._injectQuery(query, suggestion);
          $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
          fragment.appendChild($el[0]);
        });
        this.highlight && highlight({
          className: this.classes.highlight,
          node: fragment,
          pattern: query
        });
        return $(fragment);
      },
      _getFooter: function getFooter(query, suggestions) {
        return this.templates.footer ? this.templates.footer({
          query: query,
          suggestions: suggestions,
          dataset: this.name
        }) : null;
      },
      _getHeader: function getHeader(query, suggestions) {
        return this.templates.header ? this.templates.header({
          query: query,
          suggestions: suggestions,
          dataset: this.name
        }) : null;
      },
      _resetLastSuggestion: function resetLastSuggestion() {
        this.$lastSuggestion = $();
      },
      _injectQuery: function injectQuery(query, obj) {
        return _.isObject(obj) ? _.mixin({
          _query: query
        }, obj) : obj;
      },
      update: function update(query) {
        var that = this,
          canceled = false,
          syncCalled = false,
          rendered = 0;
        this.cancel();
        this.cancel = function cancel() {
          canceled = true;
          that.cancel = $.noop;
          that.async && that.trigger("asyncCanceled", query);
        };
        this.source(query, sync, async);
        !syncCalled && sync([]);
        function sync(suggestions) {
          if (syncCalled) {
            return;
          }
          syncCalled = true;
          suggestions = (suggestions || []).slice(0, that.limit);
          rendered = suggestions.length;
          that._overwrite(query, suggestions);
          if (rendered < that.limit && that.async) {
            that.trigger("asyncRequested", query);
          }
        }
        function async(suggestions) {
          suggestions = suggestions || [];
          if (!canceled && rendered < that.limit) {
            that.cancel = $.noop;
            var top = Math.max(0, that.limit - rendered);
            top = Math.min(top, suggestions.length);
            rendered += suggestions.length;
            that._append(query, suggestions.slice(0, top));
            that.async && that.trigger("asyncReceived", query);
          }
        }
      },
      cancel: $.noop,
      clear: function clear() {
        this._empty();
        this.cancel();
        this.trigger("cleared");
      },
      isEmpty: function isEmpty() {
        return this.$el.is(":empty");
      },
      destroy: function destroy() {
        this.$el = $("<div>");
      }
    });
    return Dataset;
    function getDisplayFn(display) {
      display = display || _.stringify;
      return _.isFunction(display) ? display : displayFn;
      function displayFn(obj) {
        return obj[display];
      }
    }
    function getTemplates(templates, displayFn) {
      return {
        notFound: templates.notFound && _.templatify(templates.notFound),
        pending: templates.pending && _.templatify(templates.pending),
        header: templates.header && _.templatify(templates.header),
        footer: templates.footer && _.templatify(templates.footer),
        suggestion: templates.suggestion || suggestionTemplate
      };
      function suggestionTemplate(context) {
        return $("<div>").text(displayFn(context));
      }
    }
    function isValidName(str) {
      return /^[_a-zA-Z0-9-]+$/.test(str);
    }
  }();
  var Menu = function () {
    "use strict";

    function Menu(o, www) {
      var that = this;
      o = o || {};
      if (!o.node) {
        $.error("node is required");
      }
      www.mixin(this);
      this.$node = $(o.node);
      this.query = null;
      this.datasets = _.map(o.datasets, initializeDataset);
      function initializeDataset(oDataset) {
        var node = that.$node.find(oDataset.node).first();
        oDataset.node = node.length ? node : $("<ul class=\"ui-list\">").appendTo(that.$node);
        return new Dataset(oDataset, www);
      }
    }
    _.mixin(Menu.prototype, EventEmitter, {
      _onSelectableClick: function onSelectableClick($e) {
        this.trigger("selectableClicked", $($e.currentTarget));
      },
      _onRendered: function onRendered(type, dataset, suggestions, async) {
        this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
        this.trigger("datasetRendered", dataset, suggestions, async);
      },
      _onCleared: function onCleared() {
        this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
        this.trigger("datasetCleared");
      },
      _propagate: function propagate() {
        this.trigger.apply(this, arguments);
      },
      _allDatasetsEmpty: function allDatasetsEmpty() {
        return _.every(this.datasets, isDatasetEmpty);
        function isDatasetEmpty(dataset) {
          return dataset.isEmpty();
        }
      },
      _getSelectables: function getSelectables() {
        return this.$node.find(this.selectors.selectable);
      },
      _removeCursor: function _removeCursor() {
        var $selectable = this.getActiveSelectable();
        $selectable && $selectable.removeClass(this.classes.cursor);
      },
      _ensureVisible: function ensureVisible($el) {
        var elTop, elBottom, nodeScrollTop, nodeHeight;
        elTop = $el.position().top;
        elBottom = elTop + $el.outerHeight(true);
        nodeScrollTop = this.$node.scrollTop();
        nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
        if (elTop < 0) {
          this.$node.scrollTop(nodeScrollTop + elTop);
        } else if (nodeHeight < elBottom) {
          this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
        }
      },
      bind: function bind() {
        var that = this,
          onSelectableClick;
        onSelectableClick = _.bind(this._onSelectableClick, this);
        this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
        _.each(this.datasets, function (dataset) {
          dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
        });
        return this;
      },
      isOpen: function isOpen() {
        return this.$node.hasClass(this.classes.open);
      },
      open: function open() {
        this.$node.addClass(this.classes.open);
      },
      close: function close() {
        this.$node.removeClass(this.classes.open);
        this._removeCursor();
      },
      setLanguageDirection: function setLanguageDirection(dir) {
        this.$node.attr("dir", dir);
      },
      selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
        var $selectables, $oldCursor, oldIndex, newIndex;
        $oldCursor = this.getActiveSelectable();
        $selectables = this._getSelectables();
        oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
        newIndex = oldIndex + delta;
        newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
        newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
        return newIndex === -1 ? null : $selectables.eq(newIndex);
      },
      setCursor: function setCursor($selectable) {
        this._removeCursor();
        if ($selectable = $selectable && $selectable.first()) {
          $selectable.addClass(this.classes.cursor);
          this._ensureVisible($selectable);
        }
      },
      getSelectableData: function getSelectableData($el) {
        return $el && $el.length ? Dataset.extractData($el) : null;
      },
      getActiveSelectable: function getActiveSelectable() {
        var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
        return $selectable.length ? $selectable : null;
      },
      getTopSelectable: function getTopSelectable() {
        var $selectable = this._getSelectables().first();
        return $selectable.length ? $selectable : null;
      },
      update: function update(query) {
        var isValidUpdate = query !== this.query;
        if (isValidUpdate) {
          this.query = query;
          _.each(this.datasets, updateDataset);
        }
        return isValidUpdate;
        function updateDataset(dataset) {
          dataset.update(query);
        }
      },
      empty: function empty() {
        _.each(this.datasets, clearDataset);
        this.query = null;
        this.$node.addClass(this.classes.empty);
        function clearDataset(dataset) {
          dataset.clear();
        }
      },
      destroy: function destroy() {
        this.$node.off(".tt");
        this.$node = $("<div>");
        _.each(this.datasets, destroyDataset);
        function destroyDataset(dataset) {
          dataset.destroy();
        }
      }
    });
    return Menu;
  }();
  var DefaultMenu = function () {
    "use strict";

    var s = Menu.prototype;
    function DefaultMenu() {
      Menu.apply(this, [].slice.call(arguments, 0));
    }
    _.mixin(DefaultMenu.prototype, Menu.prototype, {
      open: function open() {
        !this._allDatasetsEmpty() && this._show();
        return s.open.apply(this, [].slice.call(arguments, 0));
      },
      close: function close() {
        this._hide();
        return s.close.apply(this, [].slice.call(arguments, 0));
      },
      _onRendered: function onRendered() {
        if (this._allDatasetsEmpty()) {
          this._hide();
        } else {
          this.isOpen() && this._show();
        }
        return s._onRendered.apply(this, [].slice.call(arguments, 0));
      },
      _onCleared: function onCleared() {
        if (this._allDatasetsEmpty()) {
          this._hide();
        } else {
          this.isOpen() && this._show();
        }
        return s._onCleared.apply(this, [].slice.call(arguments, 0));
      },
      setLanguageDirection: function setLanguageDirection(dir) {
        this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
        return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
      },
      _hide: function hide() {
        this.$node.hide();
      },
      _show: function show() {
        this.$node.css("display", "inline-block");
      }
    });
    return DefaultMenu;
  }();
  var Typeahead = function () {
    "use strict";

    function Typeahead(o, www) {
      var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
      o = o || {};
      if (!o.input) {
        $.error("missing input");
      }
      if (!o.menu) {
        $.error("missing menu");
      }
      if (!o.eventBus) {
        $.error("missing event bus");
      }
      www.mixin(this);
      this.eventBus = o.eventBus;
      this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
      this.input = o.input;
      this.menu = o.menu;
      this.enabled = true;
      this.active = false;
      this.input.hasFocus() && this.activate();
      this.dir = this.input.getLangDir();
      this._hacks();
      this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
      onFocused = c(this, "activate", "open", "_onFocused");
      onBlurred = c(this, "deactivate", "_onBlurred");
      onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
      onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
      onEscKeyed = c(this, "isActive", "_onEscKeyed");
      onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
      onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
      onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
      onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
      onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
      onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
      this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
    }
    _.mixin(Typeahead.prototype, {
      _hacks: function hacks() {
        var $input, $menu;
        $input = this.input.$input || $("<div>");
        $menu = this.menu.$node || $("<div>");
        $input.on("blur.tt", function ($e) {
          var active, isActive, hasActive;
          active = document.activeElement;
          isActive = $menu.is(active);
          hasActive = $menu.has(active).length > 0;
          if (_.isMsie() && (isActive || hasActive)) {
            $e.preventDefault();
            $e.stopImmediatePropagation();
            _.defer(function () {
              $input.focus();
            });
          }
        });
        $menu.on("mousedown.tt", function ($e) {
          $e.preventDefault();
        });
      },
      _onSelectableClicked: function onSelectableClicked(type, $el) {
        this.select($el);
      },
      _onDatasetCleared: function onDatasetCleared() {
        this._updateHint();
      },
      _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
        this._updateHint();
        this.eventBus.trigger("render", suggestions, async, dataset);
      },
      _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
        this.eventBus.trigger("asyncrequest", query, dataset);
      },
      _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
        this.eventBus.trigger("asynccancel", query, dataset);
      },
      _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
        this.eventBus.trigger("asyncreceive", query, dataset);
      },
      _onFocused: function onFocused() {
        this._minLengthMet() && this.menu.update(this.input.getQuery());
      },
      _onBlurred: function onBlurred() {
        if (this.input.hasQueryChangedSinceLastFocus()) {
          this.eventBus.trigger("change", this.input.getQuery());
        }
      },
      _onEnterKeyed: function onEnterKeyed(type, $e) {
        var $selectable;
        if ($selectable = this.menu.getActiveSelectable()) {
          this.select($selectable) && $e.preventDefault();
        }
      },
      _onTabKeyed: function onTabKeyed(type, $e) {
        var $selectable;
        if ($selectable = this.menu.getActiveSelectable()) {
          this.select($selectable) && $e.preventDefault();
        } else if ($selectable = this.menu.getTopSelectable()) {
          this.autocomplete($selectable) && $e.preventDefault();
        }
      },
      _onEscKeyed: function onEscKeyed() {
        this.close();
      },
      _onUpKeyed: function onUpKeyed() {
        this.moveCursor(-1);
      },
      _onDownKeyed: function onDownKeyed() {
        this.moveCursor(+1);
      },
      _onLeftKeyed: function onLeftKeyed() {
        if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
          this.autocomplete(this.menu.getTopSelectable());
        }
      },
      _onRightKeyed: function onRightKeyed() {
        if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
          this.autocomplete(this.menu.getTopSelectable());
        }
      },
      _onQueryChanged: function onQueryChanged(e, query) {
        this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
      },
      _onWhitespaceChanged: function onWhitespaceChanged() {
        this._updateHint();
      },
      _onLangDirChanged: function onLangDirChanged(e, dir) {
        if (this.dir !== dir) {
          this.dir = dir;
          this.menu.setLanguageDirection(dir);
        }
      },
      _openIfActive: function openIfActive() {
        this.isActive() && this.open();
      },
      _minLengthMet: function minLengthMet(query) {
        query = _.isString(query) ? query : this.input.getQuery() || "";
        return query.length >= this.minLength;
      },
      _updateHint: function updateHint() {
        var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
        $selectable = this.menu.getTopSelectable();
        data = this.menu.getSelectableData($selectable);
        val = this.input.getInputValue();
        if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
          query = Input.normalizeQuery(val);
          escapedQuery = _.escapeRegExChars(query);
          frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
          match = frontMatchRegEx.exec(data.val);
          match && this.input.setHint(val + match[1]);
        } else {
          this.input.clearHint();
        }
      },
      isEnabled: function isEnabled() {
        return this.enabled;
      },
      enable: function enable() {
        this.enabled = true;
      },
      disable: function disable() {
        this.enabled = false;
      },
      isActive: function isActive() {
        return this.active;
      },
      activate: function activate() {
        if (this.isActive()) {
          return true;
        } else if (!this.isEnabled() || this.eventBus.before("active")) {
          return false;
        } else {
          this.active = true;
          this.eventBus.trigger("active");
          return true;
        }
      },
      deactivate: function deactivate() {
        if (!this.isActive()) {
          return true;
        } else if (this.eventBus.before("idle")) {
          return false;
        } else {
          this.active = false;
          this.close();
          this.eventBus.trigger("idle");
          return true;
        }
      },
      isOpen: function isOpen() {
        return this.menu.isOpen();
      },
      open: function open() {
        if (!this.isOpen() && !this.eventBus.before("open")) {
          this.menu.open();
          this._updateHint();
          this.eventBus.trigger("open");
        }
        return this.isOpen();
      },
      close: function close() {
        if (this.isOpen() && !this.eventBus.before("close")) {
          this.menu.close();
          this.input.clearHint();
          this.input.resetInputValue();
          this.eventBus.trigger("close");
        }
        return !this.isOpen();
      },
      setVal: function setVal(val) {
        this.input.setQuery(_.toStr(val));
      },
      getVal: function getVal() {
        return this.input.getQuery();
      },
      select: function select($selectable) {
        var data = this.menu.getSelectableData($selectable);
        if (data && !this.eventBus.before("select", data.obj)) {
          this.input.setQuery(data.val, true);
          this.eventBus.trigger("select", data.obj);
          this.close();
          return true;
        }
        return false;
      },
      autocomplete: function autocomplete($selectable) {
        var query, data, isValid;
        query = this.input.getQuery();
        data = this.menu.getSelectableData($selectable);
        isValid = data && query !== data.val;
        if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
          this.input.setQuery(data.val);
          this.eventBus.trigger("autocomplete", data.obj);
          return true;
        }
        return false;
      },
      moveCursor: function moveCursor(delta) {
        var query, $candidate, data, payload, cancelMove;
        query = this.input.getQuery();
        $candidate = this.menu.selectableRelativeToCursor(delta);
        data = this.menu.getSelectableData($candidate);
        payload = data ? data.obj : null;
        cancelMove = this._minLengthMet() && this.menu.update(query);
        if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
          this.menu.setCursor($candidate);
          if (data) {
            this.input.setInputValue(data.val);
          } else {
            this.input.resetInputValue();
            this._updateHint();
          }
          this.eventBus.trigger("cursorchange", payload);
          return true;
        }
        return false;
      },
      destroy: function destroy() {
        this.input.destroy();
        this.menu.destroy();
      }
    });
    return Typeahead;
    function c(ctx) {
      var methods = [].slice.call(arguments, 1);
      return function () {
        var args = [].slice.call(arguments);
        _.each(methods, function (method) {
          return ctx[method].apply(ctx, args);
        });
      };
    }
  }();
  (function () {
    "use strict";

    var old, keys, methods;
    old = $.fn.typeahead;
    keys = {
      www: "tt-www",
      attrs: "tt-attrs",
      typeahead: "tt-typeahead"
    };
    methods = {
      initialize: function initialize(o, datasets) {
        var www;
        datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
        o = o || {};
        www = WWW(o.classNames);
        return this.each(attach);
        function attach() {
          var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
          _.each(datasets, function (d) {
            d.highlight = !!o.highlight;
          });
          $input = $(this);
          $wrapper = $(www.html.wrapper);
          $hint = $elOrNull(o.hint);
          $menu = $elOrNull(o.menu);
          defaultHint = o.hint !== false && !$hint;
          defaultMenu = o.menu !== false && !$menu;
          defaultHint && ($hint = buildHintFromInput($input, www));
          defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
          $hint && $hint.val("");
          $input = prepInput($input, www);
          if (defaultHint || defaultMenu) {
            $wrapper.css(www.css.wrapper);
            $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
            $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
          }
          MenuConstructor = defaultMenu ? DefaultMenu : Menu;
          eventBus = new EventBus({
            el: $input
          });
          input = new Input({
            hint: $hint,
            input: $input
          }, www);
          menu = new MenuConstructor({
            node: $menu,
            datasets: datasets
          }, www);
          typeahead = new Typeahead({
            input: input,
            menu: menu,
            eventBus: eventBus,
            minLength: o.minLength
          }, www);
          $input.data(keys.www, www);
          $input.data(keys.typeahead, typeahead);
        }
      },
      isEnabled: function isEnabled() {
        var enabled;
        ttEach(this.first(), function (t) {
          enabled = t.isEnabled();
        });
        return enabled;
      },
      enable: function enable() {
        ttEach(this, function (t) {
          t.enable();
        });
        return this;
      },
      disable: function disable() {
        ttEach(this, function (t) {
          t.disable();
        });
        return this;
      },
      isActive: function isActive() {
        var active;
        ttEach(this.first(), function (t) {
          active = t.isActive();
        });
        return active;
      },
      activate: function activate() {
        ttEach(this, function (t) {
          t.activate();
        });
        return this;
      },
      deactivate: function deactivate() {
        ttEach(this, function (t) {
          t.deactivate();
        });
        return this;
      },
      isOpen: function isOpen() {
        var open;
        ttEach(this.first(), function (t) {
          open = t.isOpen();
        });
        return open;
      },
      open: function open() {
        ttEach(this, function (t) {
          t.open();
        });
        return this;
      },
      close: function close() {
        ttEach(this, function (t) {
          t.close();
        });
        return this;
      },
      select: function select(el) {
        var success = false,
          $el = $(el);
        ttEach(this.first(), function (t) {
          success = t.select($el);
        });
        return success;
      },
      autocomplete: function autocomplete(el) {
        var success = false,
          $el = $(el);
        ttEach(this.first(), function (t) {
          success = t.autocomplete($el);
        });
        return success;
      },
      moveCursor: function moveCursoe(delta) {
        var success = false;
        ttEach(this.first(), function (t) {
          success = t.moveCursor(delta);
        });
        return success;
      },
      val: function val(newVal) {
        var query;
        if (!arguments.length) {
          ttEach(this.first(), function (t) {
            query = t.getVal();
          });
          return query;
        } else {
          ttEach(this, function (t) {
            t.setVal(newVal);
          });
          return this;
        }
      },
      destroy: function destroy() {
        ttEach(this, function (typeahead, $input) {
          revert($input);
          typeahead.destroy();
        });
        return this;
      }
    };
    $.fn.typeahead = function (method) {
      if (methods[method]) {
        return methods[method].apply(this, [].slice.call(arguments, 1));
      } else {
        return methods.initialize.apply(this, arguments);
      }
    };
    $.fn.typeahead.noConflict = function noConflict() {
      $.fn.typeahead = old;
      return this;
    };
    function ttEach($els, fn) {
      $els.each(function () {
        var $input = $(this),
          typeahead;
        (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
      });
    }
    function buildHintFromInput($input, www) {
      return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
        autocomplete: "off",
        spellcheck: "false",
        tabindex: -1
      });
    }
    function prepInput($input, www) {
      $input.data(keys.attrs, {
        dir: $input.attr("dir"),
        autocomplete: $input.attr("autocomplete"),
        spellcheck: $input.attr("spellcheck"),
        style: $input.attr("style")
      });
      $input.addClass(www.classes.input).attr({
        autocomplete: "off",
        spellcheck: false
      });
      try {
        !$input.attr("dir") && $input.attr("dir", "auto");
      } catch (e) {}
      return $input;
    }
    function getBackgroundStyles($el) {
      return {
        backgroundAttachment: $el.css("background-attachment"),
        backgroundClip: $el.css("background-clip"),
        backgroundColor: $el.css("background-color"),
        backgroundImage: $el.css("background-image"),
        backgroundOrigin: $el.css("background-origin"),
        backgroundPosition: $el.css("background-position"),
        backgroundRepeat: $el.css("background-repeat"),
        backgroundSize: $el.css("background-size")
      };
    }
    function revert($input) {
      var www, $wrapper;
      www = $input.data(keys.www);
      $wrapper = $input.parent().filter(www.selectors.wrapper);
      _.each($input.data(keys.attrs), function (val, key) {
        _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
      });
      $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
      if ($wrapper.length) {
        $input.detach().insertAfter($wrapper);
        $wrapper.remove();
      }
    }
    function $elOrNull(obj) {
      var isValid, $el;
      isValid = _.isJQuery(obj) || _.isElement(obj);
      $el = isValid ? $(obj).first() : [];
      return $el.length ? $el : null;
    }
  })();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(447).setImmediate))

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').attr('ontouchstart', '');
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_validator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_character_counter__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_radio_group_validator__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_floating_label_plugin__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_entry_error__ = __webpack_require__(223);







__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.querySelectorAll('[data-validate]')).validator();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByClassName('character-counter-field')).characterCounter();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByClassName('character-counter-field-input')).characterCounter({
    fieldSelector: 'input'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByClassName('validate-radio-group')).radioGroupValidator({
    errorClassName: 'form-section__error'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.querySelectorAll('[data-entry-error]')).entryError({
    requiredTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.entryError.requiredTemplate', ''),
    invalidTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.entryError.invalidTemplate', '')
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByClassName('floating-label')).floatingLabel();
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CHARACTER_COUNTER_OPTIONS */
/* unused harmony export BLOCK */
/* unused harmony export COUNT_ELEMENT */
/* unused harmony export COUNT_BLOCK_ELEMENT */
/* unused harmony export COUNT_SELECTOR */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Responsible for displaying available characters in a textarea and limiting
 * the amount that can be submitted.
 * @module elements/fields/characterCounter
 */




/**
 * Defines the default options for the a character counter
 * @type {Object}
 */
var CHARACTER_COUNTER_OPTIONS = {
  fieldSelector: 'textarea',
  insertPosition: 'afterbegin'
};

/**
 * Defines the block name for the element injected into the DOM.
 * @type {string}
 */
var BLOCK = 'character-counter';

/**
 * Defines the count element injected into the DOM.
 * @type {string}
 */
var COUNT_ELEMENT = 'count';

/**
 * Defines the name of the block and count element.
 * @type {string}
 */
var COUNT_BLOCK_ELEMENT = "".concat(BLOCK, "__").concat(COUNT_ELEMENT);

/**
 * Defines the count block element selector
 * @type {string}
 */
var COUNT_SELECTOR = ".".concat(COUNT_BLOCK_ELEMENT);

/**
 * Binds the input event used to update the count.
 * @private
 * @param  {HTMLElement} el - Contains the count field
 * @param  {HTMLInputElement|HTMLTextAreaElement} field - The form field
 */
var bindInputEvent = function bindInputEvent(el, field) {
  var countEl = el.querySelector(COUNT_SELECTOR);
  field.addEventListener('input', function (_ref) {
    var length = _ref.target.value.length;
    countEl.innerText = length;
  });
};

/**
 * Creates the character counter markup used to keep track of character
 * counting.
 * @private
 * @param  {string} count - The amount of characters in the field
 * @param  {string} maxLength - The maximum length for the field
 * @param  {string} [className=''] - Additional className
 * @return {string} Fully formed HTML
 */
var createCharacterCounterComponent = function createCharacterCounterComponent(_ref2) {
  var count = _ref2.count,
    maxLength = _ref2.maxLength,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className;
  return "\n  <span class=\"".concat(BLOCK, " ").concat(className, "\" aria-hidden=\"true\">\n    <span class=\"").concat(COUNT_BLOCK_ELEMENT, "\">").concat(count, "</span>\n    / ").concat(maxLength, "\n  </span>\n");
};

/**
 * Responsible for providing feedback to the user with the amount of characters
 * entered alongside the amount allowed. This is achieved by the following:
 *
 * - Read in the maxlength attribute (if not provided, throws an error since
 *   without it we don't know what to do)
 * - create some HTML that illustrates how many characters are in a given area,
 *   along with the maximum amount of characters
 *
 * From the DOM side, this can take in optional parameters in the form of
 * data attributes:
 *
 * - data-character-counter-add-class-name: allows for a custom class name to
 *   be added to the feedback mechanism created within.
 * - data-character-insert-position: the insert position based the element
 *   passed in using the position values found on insertAdjacentHTML. If this
 *   doesn't exist, it'll use the one provided on wiring, and then fallback to
 *   afterbegin.
 *
 * This happens when the field (an input or textarea) first loads as well as
 * when the user starts entering in characters. Here's an example of markup
 * using all options:
 *
 * @example
 * <div class="things"
 *      data-character-counter-add-class-name="yo-dawg"
 *      data-character-counter-insert-position="beforebegin">
 *   <textarea maxlength="100"></textarea>
 * </div>
 *
 * which will yield:
 *
 * @example
 * <div class="things"
 *      data-character-counter-add-class-name="yo-dawg"
 *      data-character-counter-insert-position="beforebegin">
 *   <span class="character-counter yo-dawg">
 *     <span class="character-counter__count">0</span> / 200
 *   </span>
 *   <textarea maxlength="100"></textarea>
 * </div>
 *
 * @param {HTMLElement} el - Contains the form field
 * @param {Object} options - Configurable options
 */
function characterCounter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // The jQuery lookup is for PhantomJS because it's lame and doesn't know how
  // to read from el.dataset because it sucks at life. There, I said it.
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, CHARACTER_COUNTER_OPTIONS, options, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).data()),
    fieldSelector = _$$extend.fieldSelector,
    insertPosition = _$$extend.insertPosition,
    _$$extend$characterCo = _$$extend.characterCounterAddClassName,
    className = _$$extend$characterCo === void 0 ? '' : _$$extend$characterCo,
    dataAttrInsertPosition = _$$extend.characterCounterInsertPosition;
  var field = el.querySelector(fieldSelector);
  var maxLength = field.maxLength;
  if (maxLength < 0) {
    throw new Error("Character counter requires a max length on ".concat(fieldSelector));
  }
  el.insertAdjacentHTML(dataAttrInsertPosition || insertPosition, createCharacterCounterComponent({
    className: className,
    count: field.value.length,
    maxLength: maxLength
  }));
  bindInputEvent(el, field);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('characterCounter', characterCounter);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_TEMPLATES */
/* unused harmony export EVENTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_stache__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(2);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Generically handles various error states around a field
 * @module elements/fields/entry-error
 */





var DEFAULT_TEMPLATES = {
  requiredTemplate: 'valid entry required',
  invalidTemplate: 'enter a valid entry'
};
var DEFAULT_ERROR_LABEL_OPTIONS = {
  label: '',
  requiredAttr: 'data-validate-not-empty',
  entryErrorRequiredMessage: '',
  entryErrorInvalidMessage: '',
  requiredTemplate: '{{label}} entry required',
  invalidTemplate: 'enter a valid {{label}}'
};
var EVENT_NS = '.entry-label';

/**
 * Responsible for taking event names and appending a namespace
 * @param {Object} events - Key/value mapping of events
 * @returns {Object} Applicable events containing a namespace
 */
var appendNamespaceToEvents = function appendNamespaceToEvents(events) {
  return Object.keys(events).reduce(function (acc, name) {
    return Object.assign({}, acc, _defineProperty({}, name, events[name] + EVENT_NS));
  }, {});
};
var EVENTS = {
  INVALID: 'invalid',
  BLUR: 'blur',
  FOCUS: 'focus'
};
var _appendNamespaceToEve = appendNamespaceToEvents(EVENTS),
  INVALID = _appendNamespaceToEve.INVALID,
  BLUR = _appendNamespaceToEve.BLUR,
  FOCUS = _appendNamespaceToEve.FOCUS;

/**
 * Performs any sort of clean up
 * @param {jQuery} $el - Form field
 * @param {Function} deregister - Internally removes the plugin from the
 * registery
 */
var destroy = function destroy($el, deregister) {
  return function () {
    $el.off(EVENT_NS);
    deregister();
  };
};

/**
 * Responsible creating the ability to set an error message
 * @param {jQuery} $el - Form field
 * @param {string} requiredMessage - Error message when a field is required
 * @param {string} invalidMessage - Error message when a field is invalid
 * @returns {Function} Called on to set a possible error message
 */
var makeSetMessage = function makeSetMessage($el, requiredMessage, invalidMessage) {
  return function () {
    var el = $el[0];
    if (!$el.val()) {
      el.setCustomValidity(requiredMessage);
      return;
    }
    if ($el.is(':invalid')) {
      el.setCustomValidity(invalidMessage);
      return;
    }
    el.setCustomValidity('');
  };
};

/**
 * Responsible for resetting an error on a field
 * @param {HTMLElement} el - Form field
 */
var resetField = function resetField(el) {
  el.setCustomValidity('');
};

/**
 * Responsible for applying an error if applicable
 * @param {jQuery} $el - Form field
 * @param {Function} setMessage - If applicable sets an error message
 */
var applyError = function applyError($el, setMessage) {
  var el = $el[0];
  var _get = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(el, 'form.dataset'),
    validateOnlyOnSubmit = _get.validateOnlyOnSubmit;
  if (validateOnlyOnSubmit) {
    return;
  }
  setMessage();
  el.checkValidity();
};

/**
 * Responsible obtaining an error message
 * @param {string} custom - A custom error message
 * @param {string} template - Template used for the error message
 * @param {Object} data - Data used for the error message template
 */
var getMessage = function getMessage(custom, template, data) {
  return custom || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_stache__["a" /* default */])(template, data);
};

/**
 * Determines which template or message should be used from most specific to
 * most general based on a number of configured values.
 * @param {string|undefined} label - Name associated to field
 * @param {string|undefined} errorMessage - Message passed in on a field level
 * @param {string} errorType - Type of error
 * @returns {string} Template or message
 */
var getTemplate = function getTemplate(label, errorMessage, errorType) {
  var template = DEFAULT_ERROR_LABEL_OPTIONS[errorType];
  var defaultMessage = DEFAULT_TEMPLATES[errorType];

  // This means the error message was provided on a field level, so that wins
  // over any other option.
  if (errorMessage) {
    return errorMessage;
  }

  // By default, a label is required since the default template is dependent
  // on the dynamic value of the label. There is a chance that the template
  // could still be undefined since the template can be undefined. In those
  // cases, just use the default message. This should at least indicate
  // something is broken without seeing template variables.
  if (label) {
    return template || defaultMessage;
  }

  // If no label is provided, we cannot use the template, so fallback to the
  // default message as the lowest common denominator.
  return defaultMessage;
};

/**
 * Responsible for handling errors in a standardized way. In particular, it'll
 * create consistent error handling based on the type of errors.
 * @param {HTMLElement} el - Element with error in question
 * @param {Object} options - Configurable options
 * @param {Object} actions - Actions to be called on
 * @return {Object} Methods attached to an entry error
 */
function entryError(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, DEFAULT_ERROR_LABEL_OPTIONS, options, el.dataset),
    label = _Object$assign.label,
    requiredAttr = _Object$assign.requiredAttr,
    requiredTemplateOption = _Object$assign.requiredTemplate,
    invalidTemplateOption = _Object$assign.invalidTemplate,
    customRequiredMessage = _Object$assign.entryErrorRequiredMessage,
    customInvalidMessage = _Object$assign.entryErrorInvalidMessage;
  var requiredTemplate = getTemplate(label, requiredTemplateOption, 'requiredTemplate');
  var invalidTemplate = getTemplate(label, invalidTemplateOption, 'invalidTemplate');
  var requiredMessage = getMessage(customRequiredMessage, requiredTemplate, {
    label: label
  });
  var invalidMessage = getMessage(customInvalidMessage, invalidTemplate, {
    label: label
  });
  var setMessage = makeSetMessage($el, requiredMessage, invalidMessage);
  $el.attr(requiredAttr, true).on(FOCUS, function () {
    return resetField(el);
  }).on(BLUR, function () {
    return applyError($el, setMessage);
  }).on(INVALID, setMessage);
  return {
    destroy: destroy($el, deregister)
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])('entryError', entryError);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOAD */
/* unused harmony export BLUR */
/* unused harmony export FOCUS */
/* unused harmony export INVALID */
/* unused harmony export INPUT */
/* unused harmony export CONTAINER */
/* unused harmony export INVALID_SCROLL_POSITION */
/* unused harmony export CLASS_NAMES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__floating_label__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validator__ = __webpack_require__(97);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for rendering an error within a floating label.
 * @module elements/fields/floatingError
 */




var LOAD = __WEBPACK_IMPORTED_MODULE_1__floating_label__["b" /* EVENTS */].LOAD,
  BLUR = __WEBPACK_IMPORTED_MODULE_1__floating_label__["b" /* EVENTS */].BLUR,
  FOCUS = __WEBPACK_IMPORTED_MODULE_1__floating_label__["b" /* EVENTS */].FOCUS,
  INVALID = __WEBPACK_IMPORTED_MODULE_1__floating_label__["b" /* EVENTS */].INVALID,
  INPUT = __WEBPACK_IMPORTED_MODULE_1__floating_label__["b" /* EVENTS */].INPUT;

var CONTAINER = __WEBPACK_IMPORTED_MODULE_1__floating_label__["c" /* TYPES */].CONTAINER,
  FIELD = __WEBPACK_IMPORTED_MODULE_1__floating_label__["c" /* TYPES */].FIELD;

var INVALID_SCROLL_POSITION = __WEBPACK_IMPORTED_MODULE_2__validator__["a" /* EVENTS */].INVALID_SCROLL_POSITION;

var FLOATING_ERROR_OPTIONS = {
  floatingErrorContainerClassName: 'floating-label--floating-error',
  floatingErrorElement: 'p',
  floatingErrorClassName: ''
};
var KEY = Symbol('error-el');
var CLASS_NAMES = {
  FLOATING_ERROR: 'floating-error'
};

/**
 * Creates an error element to later on be appended to the DOM.
 * @private
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 * @returns {Element} An element containing the floating error
 */
var createErrorEl = function createErrorEl(errorElement, className, message) {
  var el = document.createElement(errorElement);
  el.classList.add(CLASS_NAMES.FLOATING_ERROR);
  if (className) {
    el.classList.add(className);
  }
  el.textContent = message;
  return el;
};

/**
 * Renders an error element into the DOM.
 * @private
 * @param {HTMLElement} container - The floating label element
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 * @returns {HTMLElement} - The error element
 */
var renderErrorEl = function renderErrorEl(container, errorElement, className, message) {
  var errorEl = createErrorEl(errorElement, className, message);
  container.parentNode.insertBefore(errorEl, container);
  return errorEl;
};

/**
 * Responsible for removing an error element if it exists.
 * @private
 * @param {HTMLElement} container - The floating label element
 * @param {HTMLElement} errorElement - Element containing the error
 * @param {Map} state - Contains state info around error
 * @param {string} className - className interacting with container
 */
var removeErrorEl = function removeErrorEl(container, errorElement, state, className) {
  if (errorElement) {
    container.classList.remove(className);
    errorElement.parentNode.removeChild(errorElement);
    state["delete"](KEY);
  }
};

/**
 * Sets up a listener for when an invalid formField has been found so it can
 * set the position of where to scroll to in the DOM.
 * @private
 * @param {HTMLElement} formField - The form field element
 * @param {Map} state - Contains state related data around the field
 */
var listenForInvalid = function listenForInvalid(formField, state) {
  formField.addEventListener(INVALID_SCROLL_POSITION, function (_ref) {
    var setElement = _ref.detail.setElement;
    setElement(state.get(KEY));
  });
};

/**
 * Responds to any errors that occur on a floating label by providing a message
 * above the floating label.
 * @private
 * @param {string} type - Type of event
 * @param {HTMLElement} target - Element receiving the event
 * @param {HTMLElement} container - The floating label element
 * @param {Map} state - Acts as a state container
 * @param {boolean} validateOnlyOnSubmit - Instructs to only validate on submit
 * @param {string} containerClassName - Class name provided to floating label
 * if an error occurred
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 */
var respond = function respond(type, target, container, state, validateOnlyOnSubmit, _ref2) {
  var containerClassName = _ref2.floatingErrorContainerClassName,
    errorElement = _ref2.floatingErrorElement,
    className = _ref2.floatingErrorClassName,
    _ref2$floatingErrorMe = _ref2.floatingErrorMessage,
    message = _ref2$floatingErrorMe === void 0 ? '' : _ref2$floatingErrorMe;
  var errorEl = state.get(KEY);
  var errorMessage = message || target.validationMessage;
  switch (type) {
    case LOAD:
    case BLUR:
      if (!validateOnlyOnSubmit) {
        // Assume there is no error for a clean slate
        removeErrorEl(container, errorEl, state, containerClassName);

        // This may feel redundant since there's a chance the form element
        // may already have an error. However, in the case where the blur
        // event only occurs or where the floating error is the only listener,
        // then this is necessary. Otherwise, it is redundant, but it doesn't
        // hurt anything or have any performance issues to reset the validity.
        if (container.querySelector(':invalid') === target) {
          target.setCustomValidity(errorMessage);
        }
        target.checkValidity();
      }
      break;
    case INPUT:
    case FOCUS:
      if (!target.value) {
        removeErrorEl(container, errorEl, state, containerClassName);
      }
      break;
    case INVALID:
      removeErrorEl(container, errorEl, state, containerClassName);
      // Supercedes the applied validity for one that may be more relevant
      // to the field.
      target.setCustomValidity(errorMessage);
      container.classList.add(containerClassName);
      state.set(KEY, renderErrorEl(container, errorElement, className, errorMessage));
      break;
    default:
      break;
  }
};

/**
 * Responsible for rendering an error message when an error occurs on a floating
 * label. To avoid any weirdness with CSS positioning, the error message appears
 * outside of the floating label and is referred to as a floating error.
 *
 * In order to activate this functionality, the floating label must contain the
 * following data attribute:
 *
 * - data-floating-error-message
 *
 * Other options include:
 *
 * - `data-floating-error-element`: The name of the element used for the floating
 *   error. Defaults to a `p` (for paragraph).
 * - `data-floating-error-class-name`: An additional className added to the
 *   floating error message element. Defaults to `''`.
 * - `data-floating-container-class-name`: A className applied to the floating
 *   label container when the floating error is shown. Defaults to
 *   `floating-label--floating-error`.
 *
 * @example
 * <div class="floating-label" data-floating-error-message="Hey dummy!">
 *  <label for="dude" class="floating-label__label">Something</label>
 *  <input
 *    required
 *    id="dude"
 *    type="text"
 *    class="floating-label__input"
 *    placeholder="Enter something">
 * </div>
 * @see FLOATING_ERROR_OPTIONS
 * @param {Object} options - Configurable options
 * @returns {Function} Used to setup and respond to events from floating label
 */
var floatingError = function floatingError() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _nodes$filter = nodes.filter(function (_ref3) {
        var type = _ref3.type;
        return type === CONTAINER;
      }),
      _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
      container = _nodes$filter2[0].node;
    var _nodes$filter3 = nodes.filter(function (_ref4) {
        var type = _ref4.type;
        return type === FIELD;
      }),
      _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
      formField = _nodes$filter4[0].node;
    var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, FLOATING_ERROR_OPTIONS, options, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container).data());
    var state = new Map();
    listenForInvalid(formField, state);
    return function (type, _ref5, _ref6) {
      var target = _ref5.target;
      var validateOnlyOnSubmit = _ref6.validateOnlyOnSubmit;
      return respond(type, target, container, state, validateOnlyOnSubmit, opts);
    };
  };
};
/* harmony default export */ __webpack_exports__["a"] = (floatingError);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUILTIN_CALLERS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__floating_label__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_modifiers__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconify_behaviors__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__iconify_details__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__floating_error__ = __webpack_require__(224);
/**
 * Responsible for combining all floating label related callers and exposing it
 * as a jQuery plugin.
 * @module elements/fields/floatingLabelPlugin
 */







/**
 * Defines any built in callers for a floating label.
 * @type {Array}
 */
var BUILTIN_CALLERS = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__state_modifiers__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__iconify_behaviors__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__iconify_details__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__floating_error__["a" /* default */])()];

/**
 * Performs a setup of all the necessary pieces for calling on a floating label
 * jQuery plugin.
 * @see FLOATING_LABEL_OPTIONS
 * @param {HTMLElement} el - Receives floating label treatment
 * @param {Object} options - Configurable options
 */
function floatingLabelPlugin(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$callers = options.callers,
    providedCallers = _options$callers === void 0 ? [] : _options$callers;
  var callers = [].concat(BUILTIN_CALLERS, providedCallers);
  var defaults = {
    floatingLabel: __WEBPACK_IMPORTED_MODULE_1__floating_label__["a" /* default */]
  };
  var overrides = {
    callers: callers
  };
  var opts = $.extend({}, defaults, options, overrides);
  var floatingLabelFunc = opts.floatingLabel;
  floatingLabelFunc(el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__["a" /* default */])('floatingLabel', floatingLabelPlugin);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERROR_SECTION_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for scrolling to a specific position when a form error submission
 * has occurred on a form validator.
 * @module elements/fields/formErrorScroller
 */


var ERROR_SECTION_CLASS_NAME = 'validator-error-section';

/**
 * Determines the scroll position based on the passed in configuration.
 * @private
 * @param {number} scrollPosition - Where in the page to scroll to.
 * @param {string} scrollSelector - A selector within the wrapper.
 * @returns {number|undefined} Where to scroll to when an error occurs.
 */
var resolveFormScrollPosition = function resolveFormScrollPosition(scrollPosition, scrollSelector) {
  var $scroll = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(scrollSelector);
  if ($scroll.length) {
    return $scroll.scrollTop();
  }
  return scrollPosition;
};

/**
 * Determines the insertion position of where the error message should be
 * located within the wrapper.
 * @private
 * @param {jQuery} $wrapper - The wrapper containing the form fields
 * @param {string} insertErrorBefore - The selector used for inserting before an
 * element
 * @param {string} insertErrorAfter - The selector used for inserting after an
 * element
 * @returns {Object} The position and jQuery object where to insert the error
 */
var resolveFormErrorInsertPosition = function resolveFormErrorInsertPosition($wrapper, insertErrorBefore, insertErrorAfter) {
  var errorInsertPositions = [{
    position: 'before',
    selector: insertErrorBefore
  }, {
    position: 'after',
    selector: insertErrorAfter
  }];
  var _errorInsertPositions = errorInsertPositions.map(function (_ref) {
      var position = _ref.position,
        selector = _ref.selector;
      return {
        position: position,
        $el: $wrapper.find(selector)
      };
    }).filter(function (_ref2) {
      var $el = _ref2.$el;
      return $el.length;
    }),
    _errorInsertPositions2 = _slicedToArray(_errorInsertPositions, 1),
    _errorInsertPositions3 = _errorInsertPositions2[0],
    obj = _errorInsertPositions3 === void 0 ? {} : _errorInsertPositions3;
  return obj;
};

/**
 * Renders an error section.
 * @private
 * @param {string} errorMessage - The error message
 * @returns {string} Rendered error section.
 */
var renderErrorSection = function renderErrorSection(_ref3) {
  var errorMessage = _ref3.errorMessage;
  return "\n  <div class=\"form-section ".concat(ERROR_SECTION_CLASS_NAME, "\">\n    <p class=\"form-section__error embedded-error\">").concat(errorMessage, "</p>\n  </div>\n");
};

/**
 * Handles scrolling to a specific position based on what has been provided
 * by the caller. This happens on a form level and provides the flexibility of
 * where the error should be rendered, where the page should scroll to, and the
 * message to use. If any one of these properties is missing, it will not be
 * used. Here are the available options:
 *
 * - data-validate-error-message: the error message
 * - data-validate-scroll-to-position: y-axis to scroll to
 * - data-validate-scroll-to-selector: the top part of the selector to scroll to
 * - data-validate-insert-error-before: a selector within the form where the
 *   error should be injected to before
 * - data-validate-insert-error-after: a selector within the form where the
 *   error should be injected to after
 *
 * scroll-to-position supersedes scroll-to-selector and insert-error-before will
 * supersede insert-error-after.
 *
 * Here's some example markup used for configuration purposes:
 *
 * @example
 * <form
 *   data-validate-error-message="some message"
 *   data-validate-scroll-to-position="0"
 *   data-validate-error-before=".title">
 *   <h1 class="title">I am a title</h1>
 *   <input type="text" name="name">
 *   <input type="submit" value="Submit">
 * </form>
 * @param {jQuery} $wrapper - The wrapper containing the elements
 * @param {Function} scrollTrigger - Function used for scrolling to x/y
 * coordinates.
 * @param {Object} options - Configurable options
 * @returns {boolean} Whether a scroll error has been captured.
 */
var formErrorScroller = function formErrorScroller($wrapper, scrollTrigger) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _$$extend = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend({}, options, $wrapper.data()),
    errorMessage = _$$extend.validateErrorMessage,
    scrollPosition = _$$extend.validateScrollToPosition,
    scrollSelector = _$$extend.validateScrollToSelector,
    insertErrorBefore = _$$extend.validateInsertErrorBefore,
    insertErrorAfter = _$$extend.validateInsertErrorAfter;
  // Nuke any existing sections to remove duplicate error messages.
  $wrapper.find(".".concat(ERROR_SECTION_CLASS_NAME)).remove();
  var position = resolveFormScrollPosition(scrollPosition, scrollSelector);
  var _resolveFormErrorInse = resolveFormErrorInsertPosition($wrapper, insertErrorBefore, insertErrorAfter),
    insertPosition = _resolveFormErrorInse.position,
    $error = _resolveFormErrorInse.$el;

  // If at least one criteria is not met, don't render the message since all
  // are required for this purpose, but no crazy failures occur if this isn't
  // call on, i.e. it's an enhancement, not core functionality.
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(position) && $error && errorMessage) {
    // Since this is within our control, dynamically call on jQuery method for
    // insertion.
    $error[insertPosition](renderErrorSection({
      errorMessage: errorMessage
    }));
    scrollTrigger(0, position);
    return true;
  }
  return false;
};
/* harmony default export */ __webpack_exports__["a"] = (formErrorScroller);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iconList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__floating_label__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iconify_setup__ = __webpack_require__(133);
/* unused harmony reexport TYPES */
/* unused harmony reexport EVENTS */
/* unused harmony reexport VISIBLE_CLASS_NAME */
/* unused harmony reexport ICON_CLASS_NAME */
/**
 * Responsible for covering icon related behavior within a floating label.
 * @module elements/fields/iconifyBehaviors
 */




/**
 * Defines available icons for iconify behaviors.
 * @type {Object}
 */
var iconList = [{
  name: 'invalid',
  iconId: 'exclamation-point'
}, {
  name: 'valid',
  iconId: 'check-mark'
}, {
  name: 'clear',
  iconId: 'clear'
}];

/**
 * Responsible for clearing out the value of a form field.
 * @private
 * @param {HTMLFormElement} formField - The form element in the floating label
 */
var clearValue = function clearValue(formField) {
  /* eslint-disable no-param-reassign */
  // This is here to remove the placeholder which is visible
  // between the blur and focus event.
  var placeholder = formField.placeholder;
  formField.placeholder = '';
  formField.focus();
  formField.value = '';
  formField.placeholder = placeholder;
  /* eslint-enable no-param-reassign */
};

/**
 * Responsible for exposing methods used for clearing a form field based on
 * when events are fired off. For example, `attach` would be fired off during
 * focus, where `detach` would be fired off during blur. The tricky bit here
 * is using an event that won't trigger the blur event, hence why mousedown or
 * the preferred touchend event to ensure this event happens without disrupting
 * the blur event.
 *
 * There is a cleaner version here that uses touchend that minimizes a good
 * deal of this code and it's cleaner. However, in the interest of someone
 * saying, "This is broken" because they aren't on a mobile/touch device.
 * Therefore mousedown is used to ensure clear occurs before the blur event
 * can take affect.
 * @private
 * @param {HTMLElement} clearIcon
 * @returns {Object} Contains methods used for coordinating of clearing a field
 */
var coordinateClearEvents = function coordinateClearEvents(clearIcon) {
  var evtName = 'mousedown';
  var handler;
  var shouldClearForm;
  return {
    attach: function attach() {
      clearIcon.addEventListener(evtName, handler = function handler() {
        shouldClearForm = true;
      });
    },
    detach: function detach(formField) {
      if (shouldClearForm) {
        clearValue(formField);
        clearIcon.removeEventListener(evtName, handler);
        shouldClearForm = false;
      }
    }
  };
};

/**
 * hides all icons by removing the visibility className.
 * @private
 * @param {HTMLElement} container - The icon container
 */
var hideAll = function hideAll(container) {
  Array.from(container.querySelectorAll(".".concat(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["c" /* ICON_CLASS_NAME */]))).forEach(function (el) {
    el.classList.remove(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
  });
};

/**
 * Responsible for showing the clear icon and hiding the rest of the icons.
 * @private
 * @param {HTMLElement} container - The icon container
 * @param {HTMLFormElement} target - The form field in the floating label
 * @param {HTMLElement} clearIcon - The clear icon element
 * @param {boolean} clearShown - Whether the clear icon has been shown
 * @returns {boolean|undefined} Determines whether the clear icon was shown,
 * otherwise returns undefined.
 */
var editable = function editable(container, target, clearIcon, clearShown) {
  if (clearShown && target.value) {
    return true;
  }
  hideAll(container);
  if (clearIcon && target.value) {
    clearIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    return true;
  }
  return false;
};

/**
 * Responsible for firing off a set of rules when the field has been completed.
 * This would happen when the field has initially loaded or on blur.
 * @private
 * @param {HTMLElement} container - The icon container
 * @param {HTMLElement} floatingLabel - The element containing the floating label
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} invalidIcon - The invalid icon element
 * @param {HTMLElement} validIcon - The valid icon element
 * @param {boolean} shouldValidate - Instructs to only validate on submit
 */
var completed = function completed(container, floatingLabel, formField, invalidIcon, validIcon, shouldValidate) {
  hideAll(container);
  if (shouldValidate) {
    if (invalidIcon && floatingLabel.querySelector(':invalid') === formField) {
      invalidIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    } else if (validIcon && formField.value) {
      validIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    }
  }
};

/**
 * Runs logic based on when an invalid event has been fired off.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} invalidIcon - The invalid icon element
 */
var invalidated = function invalidated(iconContainer, invalidIcon) {
  hideAll(iconContainer);
  if (invalidIcon) {
    invalidIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
  }
};

/**
 * Responds to the event received from floating label. The logic for this is as
 * follows:
 *
 * - focus: check to see if the clear icon should be shown
 * - input: show the clear icon if it already isn't shown
 * - blur: remove clear icon, show valid or invalid icon based on the state
 * formField of the form field
 * - invalid: show the invalid icon
 *
 * There are other optimizations taken for performance, but you get the idea.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} floatingLabelEl - The element containing the floating label
 * @param {HTMLFormElement} formField - The form field
 * @param {Object} icons - Contains icon elements keyed by icon
 * @returns {Function} The inner function called on by floating label
 */
var respond = function respond(iconContainer, floatingLabelEl, formField, icons) {
  var clearShown = false;
  var clearIcon = icons.clear,
    invalidIcon = icons.invalid,
    validIcon = icons.valid;
  var FOCUS = __WEBPACK_IMPORTED_MODULE_0__floating_label__["b" /* EVENTS */].FOCUS,
    BLUR = __WEBPACK_IMPORTED_MODULE_0__floating_label__["b" /* EVENTS */].BLUR,
    INVALID = __WEBPACK_IMPORTED_MODULE_0__floating_label__["b" /* EVENTS */].INVALID,
    INPUT = __WEBPACK_IMPORTED_MODULE_0__floating_label__["b" /* EVENTS */].INPUT;
  // By going one level higher in scope, we can control the state of the clear
  // icon in terms of when it was bound and when it needs to be unbound.
  var coordinate = coordinateClearEvents(clearIcon);

  // At this point, the page has loaded without any events so there's a chance
  // a field could already have values. Therefore, apply any completed
  // behaviors, i.e. invalid or valid.
  completed(iconContainer, floatingLabelEl, formField, invalidIcon, validIcon, true);
  return function (type) {
    var _ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 ? arguments[2] : undefined,
      validateOnlyOnSubmit = _ref.validateOnlyOnSubmit;
    switch (type) {
      case FOCUS:
        // Attaches clear events upon focus since it's the first time the field
        // has been interacted with. This will apply any event handlers used
        // for clearing the field.
        coordinate.attach(formField, function () {
          clearShown = false;
        });

        // Checks to see if we are in an edited state when the focus event
        // occurs. We don't about the return value because the input event
        // manages that portion of the lifecycle.
        editable(iconContainer, formField, clearIcon, clearShown);
        break;
      case INPUT:
        // At this point, the user is inputting values into the field. We call
        // on editable, so that we know how to treat the clear icon, i.e. should
        // it be shown or hidden. By returning back clearShown, we can cache
        // the state and limit the amount of DOM manipulation upon interaction.
        clearShown = editable(iconContainer, formField, clearIcon, clearShown);
        break;
      case BLUR:
        // At this point, the user is done with the field. We reset anything
        // that has state, i.e. clearShown and any event handlers. We also
        // apply the final completed state to the form, i.e. invalid or valid.
        clearShown = false;
        // Release the clear related events from memory.
        coordinate.detach(formField);
        completed(iconContainer, floatingLabelEl, formField, invalidIcon, validIcon, !validateOnlyOnSubmit);
        break;
      case INVALID:
        invalidated(iconContainer, invalidIcon);
        break;
      default:
        break;
    }
  };
};

/**
 * Responsible for rendering out icons that will be used for a floating label.
 * The rendering is happening internally for a number of reasons:
 *
 * - Minimize the payload in the HTML (that is, if this was coming from there)
 * - Keep configuring from a consumer side as simple as possible.
 * - Since the icons are dependent on JavaScript, inlining them within allows
 *   for the HTML to operate in isolation with little external factors
 *
 * It's also responsible for doing the following:
 *
 * - Showing the correct icon based on the state of the input
 * - Attach/detach any events applied to the icon
 *
 * As for usage, iconify looks for data attributes denoting the different icons
 * to render where the value is used to populate the title of the SVG for
 * i18n/accessibility purposes. Here are the support data attributes:
 *
 * - data-iconify-clear
 * - data-iconify-invalid
 * - data-iconify-valid
 *
 * Any of these options can be used at different times. Therefore, if only clear
 * should be used, then only configure data-iconify-clear and nothing else.
 * Here's an example of the expected markup:
 *
 * @example
 * <div
 *     class="floating-label"
 *     data-iconify-clear="Clear"
 *     data-iconify-invalid="Invalid"
 *     data-iconify-valid="Valid">
 *   <label for="the-dude" class="floating-label__label">The Dude</label>
 *   <input id="the-dude" class="floating-label__input">
 * </div>
 *
 * @param {Object} options - Configurable options
 * @returns {Function} Used to setup and respond to events from floating label
 */
var iconify = function iconify() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _setup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["a" /* default */])(iconList, nodes, options),
      floatingLabel = _setup.floatingLabel,
      formField = _setup.formField,
      iconContainer = _setup.iconContainer,
      iconNodes = _setup.iconNodes;
    if (iconNodes) {
      return respond(iconContainer, floatingLabel, formField, iconNodes);
    }
    return function () {};
  };
};
/* harmony default export */ __webpack_exports__["a"] = (iconify);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iconList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_modal__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iconify_setup__ = __webpack_require__(133);
/* unused harmony reexport VISIBLE_CLASS_NAME */
/**
 * Responsible for using the details behavior within a floating label.
 * @module elements/fields/iconifyDetails
 */




/**
 * Contains the list of icons associated with a more details iconify floating
 * label.
 * @type {Object}
 */
var iconList = [{
  name: 'details',
  iconId: 'details'
}];

/**
 * Defines configurable options
 * @type {Object}
 */
var DEFAULT_MORE_DETAILS = {
  modal: __WEBPACK_IMPORTED_MODULE_0__modules_modal__["a" /* default */]
};

/**
 * Responsible for showing a more details icons within a floating element. Once
 * the icon has been interacted with, it will show a modal. This is different
 * than an iconify-behaviors as this work doesn't need to hook into the
 * floating label events cycle, but rather utilizes the same setup, therefore
 * allowing us to reuse things such as setting up icons and the applicable
 * elements used in a floating label.
 *
 * To configure this work, make sure the following data attributes have been
 * provided:
 *
 * - data-iconify-more-details: contains the title for the icon used for i18n
 *   and accessibility
 * - data-open: an ID to a modal
 *
 * Since this work will leverage the modal, any modal related data attributes
 * can be applied here. Here's an example in HTML to wire this dude up:
 *
 * @example
 * <div
 *     class="floating-label"
 *     data-iconify-more-details="More Details"
 *     data-open="modal-example">
 *   <label for="the-dude" class="floating-label__label">The Dude</label>
 *   <input id="the-dude" class="floating-label__input">
 * </div>
 *
 * <div id="modal-example" class="modal u-center" data-type="default-modal">
 *   <p>modal content goes here</p>
 * </div>
 *
 * @param {Object} options - Configurable options
 * @returns {Function} Initialization of iconify more details
 */
var iconifyMoreDetails = function iconifyMoreDetails() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var opts = $.extend({}, DEFAULT_MORE_DETAILS, options);
    var modalFunc = opts.modal;
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _setup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["a" /* default */])(iconList, nodes, opts),
      floatingLabel = _setup.floatingLabel,
      iconNodes = _setup.iconNodes;
    if (!iconNodes) {
      return;
    }
    var detailsIcon = iconNodes.details;
    detailsIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    detailsIcon.addEventListener('click', function () {
      modalFunc(floatingLabel, {
        triggerOpen: true
      });
    });
  };
};
/* harmony default export */ __webpack_exports__["a"] = (iconifyMoreDetails);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMBEDDED_ERROR_CLASS_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validator__ = __webpack_require__(97);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Responsible for applying validation upon a radio group so that it can hook
 * into Constraint Validation API.
 * @module radioGroupValidator
 */




var INPUT_GROUP_OPTIONS = {
  errorClassName: '',
  inputSelector: 'input',
  errorPosition: 'afterbegin'
};

/**
 * CSS class name used for embedding an error.
 * @private
 * @type {string}
 */
var EMBEDDED_ERROR_CLASS_NAME = 'embedded-error';

/**
 * Responsible for taking any registered event listeners and releasing them
 * from memory.
 * @private
 * @param {HTMLInputElement} input - A radio input
 * @param {Array<Object>} listeners - event listeners to be removed
 */
var removeInputListeners = function removeInputListeners(input, listeners) {
  listeners.forEach(function (_ref) {
    var evt = _ref.evt,
      handler = _ref.handler;
    input.removeEventListener(evt, handler);
  });
};

/**
 * Responsible for removing the error message.
 * @private
 * @param {HTMLElement} wrap - Container element
 */
var removeError = function removeError(wrap) {
  var errorEl = wrap.querySelector(".".concat(EMBEDDED_ERROR_CLASS_NAME));
  errorEl.parentNode.removeChild(errorEl);
};

/**
 * Responsible for removing the error message.
 * @private
 * @param {HTMLElement} input - input element
 */
var togglePushButtonError = function togglePushButtonError(input) {
  var $inputName = input.getAttribute('name');
  $("input[name='" + $inputName + "']").each(function () {
    var $currentInputID = $(this).attr('id');
    var $currentInputLabel = $("label[for='" + $currentInputID + "']");
    if ($currentInputLabel.hasClass('push-button')) {
      $currentInputLabel.toggleClass('push-button-error');
    }
  });
};

/**
 * Responsible for building the element for the error.
 * @private
 * @param {string} errorClassName - CSS class name for the error
 * @param {string} errorMessage - The error message
 */
var renderError = function renderError(_ref2) {
  var errorClassName = _ref2.errorClassName,
    errorMessage = _ref2.errorMessage;
  return "<p class=\"".concat(errorClassName, " ").concat(EMBEDDED_ERROR_CLASS_NAME, "\">").concat(errorMessage, "</p>");
};

/**
 * Responsible for figuring out where the error message should be rendered in
 * the DOM.
 * @private
 * @param {Object} dataset - dataset of an HTML
 * @returns {Object} The position and selector used for inserting the error
 */
var determineInsertSelector = function determineInsertSelector(dataset) {
  var insertBeforeSelector = dataset.radioGroupInsertErrorBefore,
    insertAfterSelector = dataset.radioGroupInsertErrorAfter;
  var selectors = [{
    position: 'beforebegin',
    insertSelector: insertBeforeSelector
  }, {
    position: 'afterend',
    insertSelector: insertAfterSelector
  }];
  return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(selectors, function (_ref3) {
    var position = _ref3.position,
      insertSelector = _ref3.insertSelector;
    if (insertSelector) {
      return {
        position: position,
        insertSelector: insertSelector
      };
    }
    return false;
  }) || {};
};

/**
 * Responsible for seeing if any radio inputs are invalid and if so, to allow
 * for error messaging to be displayed. Once a change event has occurred, the
 * error goes away and will allow for any additional validation to be picked up
 * and allow the cycle to repeat itself.
 *
 * The error message and where it's located is configurable based on data
 * attributes on the element passed in. By default, if no position has been
 * provided, it'll write the error message as the first child of the wrap.
 * Here are the supported position values:
 *
 * - data-radio-group-insert-error-before
 * - data-radio-group-insert-error-after
 *
 * Where the value is a selector within the element passed in. Here's an
 * example:
 *
 * @example
 * <div data-radio-group-error-message="Yeah,well, that's just, like, your opinion, man"
 *      data-radio-group-insert-error-before=".title">
 *   <h2 class="title">I am a title or something</h2>
 *   <input type="radio" name="characters" value="dude" required>
 *   <input type="radio" name="characters" value="walter" required>
 *   <input type="radio" name="characters" value="donny" required>
 *   <button type="submit">Submit</button>
 * </div>
 *
 * @see INPUT_GROUP_OPTIONS
 * @param {HTMLElement} wrap - Element containing the inputs
 * @param {Object} options - Configurable options
 */
function radioGroupValidator(wrap) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _$$extend = $.extend({}, INPUT_GROUP_OPTIONS, options),
    inputSelector = _$$extend.inputSelector,
    errorClassName = _$$extend.errorClassName,
    errorPosition = _$$extend.errorPosition;
  var dataset = wrap.dataset;
  var errorMessage = dataset.radioGroupErrorMessage;
  var _determineInsertSelec = determineInsertSelector(dataset),
    _determineInsertSelec2 = _determineInsertSelec.position,
    position = _determineInsertSelec2 === void 0 ? errorPosition : _determineInsertSelec2,
    insertSelector = _determineInsertSelec.insertSelector;
  var insertionEl = insertSelector ? wrap.querySelector(insertSelector) : wrap;
  var INVALID_SCROLL_POSITION = __WEBPACK_IMPORTED_MODULE_2__validator__["a" /* EVENTS */].INVALID_SCROLL_POSITION;
  var errorShown = false;
  var listeners = [];
  Array.from(wrap.querySelectorAll(inputSelector)).forEach(function (input) {
    var invalidHandler;
    var changeHandler;
    var positionHandler;
    input.addEventListener('invalid', invalidHandler = function invalidHandler() {
      if (!errorShown) {
        errorShown = true;
        insertionEl.insertAdjacentHTML(position, renderError({
          errorClassName: errorClassName,
          errorMessage: errorMessage
        }));
        togglePushButtonError(input);
      }
    });
    input.addEventListener(INVALID_SCROLL_POSITION, positionHandler = function positionHandler(_ref4) {
      var setElement = _ref4.detail.setElement;
      setElement(wrap);
    });
    input.addEventListener('change', changeHandler = function changeHandler() {
      if (errorShown) {
        errorShown = false;
        removeError(wrap);
        removeInputListeners(input, listeners);
        togglePushButtonError(input);
      }
    });
    listeners = [].concat(_toConsumableArray(listeners), [{
      evt: 'invalid',
      handler: invalidHandler
    }, {
      evt: 'change',
      handler: changeHandler
    }, {
      evt: INVALID_SCROLL_POSITION,
      handler: positionHandler
    }]);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('radioGroupValidator', radioGroupValidator);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__floating_label__ = __webpack_require__(70);
/* unused harmony reexport EVENTS */
/* unused harmony reexport TYPES */
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for applying classes in the form of modifiers to a floating
 * label based on the current state, i.e. filled, invalid, selected, and so on.
 * @module elements/fields/stateModifiers
 */



/**
 * Defines default options for state modifiers
 * @type {Object}
 */
var DEFAULT_STATE_MODIFIERS = {
  filledModifier: 'filled',
  invalidModifier: 'invalid',
  selectedModifier: 'selected',
  suppressErrorModifier: 'suppress-error'
};

/**
 * Adds modifier CSS class names to any of the elements.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {...string} modifiers - Modifier names
 */
var addClassNames = function addClassNames(nodes) {
  for (var _len = arguments.length, modifiers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }
  nodes.forEach(function (_ref) {
    var name = _ref.name,
      node = _ref.node;
    modifiers.forEach(function (modifierName) {
      node.classList.add("".concat(name, "--").concat(modifierName));
    });
  });
};

/**
 * Removes modifier CSS class names to any of the elements.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {...string} modifiers - Modifier names
 */
var removeClassNames = function removeClassNames(nodes) {
  for (var _len2 = arguments.length, modifiers = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    modifiers[_key2 - 1] = arguments[_key2];
  }
  nodes.forEach(function (_ref2) {
    var name = _ref2.name,
      node = _ref2.node;
    modifiers.forEach(function (modifierName) {
      node.classList.remove("".concat(name, "--").concat(modifierName));
    });
  });
};

/**
 * Ran whenever a FIELD is in a completed state, i.e. when the page first loads
 * or when a blur event occurred.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {HTMLElement} target - The element receiving the event
 * @param {boolean} shouldApplyInvalid - Allow for applying invalid modifiers
 * @param {string} selected - The selected modifier value
 * @param {string} filled - The filled modifier value
 * @param {string} invalid - The invalid modifier value
 * @param {string} suppressError - The suppress error modifier value
 */
var completed = function completed(nodes, target, shouldApplyInvalid, _ref3) {
  var selected = _ref3.selected,
    filled = _ref3.filled,
    invalid = _ref3.invalid,
    suppressError = _ref3.suppressError;
  var _nodes$filter = nodes.filter(function (_ref4) {
      var type = _ref4.type;
      return type === __WEBPACK_IMPORTED_MODULE_0__floating_label__["c" /* TYPES */].CONTAINER;
    }),
    _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
    container = _nodes$filter2[0].node;
  removeClassNames(nodes, selected, filled, invalid, suppressError);

  // Denotes that within a floating label there is an error
  if (container.querySelector(':invalid') === target) {
    // Make sure to apply an invalid error if instructed to apply an invalid
    // modifier
    if (shouldApplyInvalid) {
      addClassNames(nodes, invalid);
    } else {
      // Otherwise, we are looking to suppress an error. Since the browser has
      // built in invalidity, we apply this class to ensure that the default
      // browser invalid behavior gets overridden.
      addClassNames(nodes, suppressError);
    }
  }
  if (target.value) {
    addClassNames(nodes, filled);
  }
};

/**
 * Responds to any event based on the type of event.
 * @private
 * @param {string} type - The type of event, i.e. focus, blur
 * @param {HTMLElement} target - The element receiving the event
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {boolean} validateOnlyOnSubmit - Instructs to only validate on submit
 * @param {Object} modifiers - Contains modifier names
 */
var respond = function respond(type, target, nodes, _ref5, modifiers) {
  var validateOnlyOnSubmit = _ref5.validateOnlyOnSubmit;
  var FOCUS = __WEBPACK_IMPORTED_MODULE_0__floating_label__["b" /* EVENTS */].FOCUS,
    BLUR = __WEBPACK_IMPORTED_MODULE_0__floating_label__["b" /* EVENTS */].BLUR,
    INVALID = __WEBPACK_IMPORTED_MODULE_0__floating_label__["b" /* EVENTS */].INVALID;
  var selected = modifiers.selected,
    filled = modifiers.filled,
    invalid = modifiers.invalid,
    suppressError = modifiers.suppressError;
  switch (type) {
    case FOCUS:
      addClassNames(nodes, selected);
      removeClassNames(nodes, filled, invalid, suppressError);
      break;
    case BLUR:
      completed(nodes, target, !validateOnlyOnSubmit, modifiers);
      break;
    case INVALID:
      removeClassNames(nodes, suppressError);
      addClassNames(nodes, invalid);
      break;
    default:
      break;
  }
};

/**
 * Responsible for initializing state modifiers. More specifically, it'll apply
 * any modifiers (i.e. CSS class names in form of BEM) when the page first
 * loads. For example, when a page initially loads and an element is invalid,
 * it'll apply any modifiers. It'll do the same when responding to events based
 * on user interaction.
 * @private
 * @see DEFAULT_STATE_MODIFIERS
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {Object} options - Options initially passed in
 * @returns {Function} - Used for firing off events
 */
var initialize = function initialize(nodes) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _$$extend = $.extend({}, DEFAULT_STATE_MODIFIERS, options),
    filled = _$$extend.filledModifier,
    invalid = _$$extend.invalidModifier,
    selected = _$$extend.selectedModifier,
    suppressError = _$$extend.suppressErrorModifier;
  var modifiers = {
    filled: filled,
    invalid: invalid,
    selected: selected,
    suppressError: suppressError
  };
  var _nodes$filter3 = nodes.filter(function (_ref6) {
      var type = _ref6.type;
      return type === __WEBPACK_IMPORTED_MODULE_0__floating_label__["c" /* TYPES */].FIELD;
    }),
    _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
    formField = _nodes$filter4[0].node;
  completed(nodes, formField, true, modifiers);
  return function (type, _ref7, data) {
    var target = _ref7.target;
    return respond(type, target, nodes, data, modifiers);
  };
};

/**
 * Provides modifiers, i.e. CSS class names in the form of BEM to a block and
 * two child block elements. These elements are coming from the nodes.
 * @see DEFAULT_STATE_MODIFIERS
 * @param options
 */
var stateModifiers = function stateModifiers() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len3 = arguments.length, nodes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      nodes[_key3] = arguments[_key3];
    }
    return initialize(nodes, options);
  };
};
/* harmony default export */ __webpack_exports__["a"] = (stateModifiers);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export VISUAL_HIDDEN_CLASS */
/* unused harmony export MODAL_CLASS */
/* unused harmony export EVENT_NAME */
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleFavorite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_modal__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Toggles the 'active' class modifier on favorite buttons when clicking
 * @module toggleFavorite
 */




var PLUGIN_NAME = 'toggleFavorite';
var ACTIVE_CLASS = 'favorite-button--active';
var VISUAL_HIDDEN_CLASS = 'u-screen-reader';
var MODAL_CLASS = 'modal';
var EVENT_NAME = 'favorite';

/**
 * Defines sensible defaults for toggle favorite.
 * @type {Object}
 */
var TOGGLE_FAVORITE_OPTIONS = {
  modal: __WEBPACK_IMPORTED_MODULE_1__modules_modal__["a" /* default */],
  container: document.body
};

/**
 * Central place to see if a specific element has been favorited.
 * @private
 * @param {jQuery} $el - Container for the favorite button
 * @returns {boolean} Whether the item has been favorited
 */
var isFavorited = function isFavorited($el) {
  return $el.hasClass(ACTIVE_CLASS);
};

/**
 * Shows the appropriate favorite related message for screen readers.
 * @private
 * @param {jQuery} $el - Container for the favorite button
 * @param {boolean} hasFavorite - Whether it has been favorited
 */
var showMessage = function showMessage($el, hasFavorite) {
  var message = $el.data('favoriteMessage');
  if (hasFavorite) {
    message = $el.data('unfavoriteMessage');
  }
  $el.find(".".concat(VISUAL_HIDDEN_CLASS)).text(message);
};

/**
 * Creates a notification specific to an item being favorited.
 * @private
 * @param {string} notificationModalId - ID for the container of the notification
 * @param {string} message - The message of the notification
 * @returns {string} Fully qualified notification
 */
var createNotification = function createNotification(_ref) {
  var notificationModalId = _ref.notificationModalId,
    message = _ref.message;
  return "\n  <div id=\"".concat(notificationModalId, "\" class=\"").concat(MODAL_CLASS, "\" data-type=\"notification\" >\n    <p class=\"u-margin-b--none u-center modal__focus-element\">").concat(message, "</p>\n  </div>\n");
};

/**
 * Responsible for showing the notification based on whether the item has been
 * favorited. Since more than one item can appear on the page, it's important
 * to allow for each notification to be unique since these requests can be made
 * asynchronously. On top of that
 * @private
 * @param {jQuery} $el - Container for the favorite button
 * @param {boolean} hasFavorite - Whether it has been favorited
 * @param {Function} modalFunc - Used to display the notification
 * @param {HTMLElement} container - Container to append to
 */
var showNotification = function showNotification($el, hasFavorite, _ref2) {
  var modalFunc = _ref2.modal,
    container = _ref2.container;
  var message = $el.data('unfavoriteNotification');
  if (hasFavorite) {
    message = $el.data('favoriteNotification');
  }
  var notificationModalId = "notification-modal-".concat(Date.now());
  var $modalContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createNotification({
    notificationModalId: notificationModalId,
    message: message
  }));
  $modalContent.appendTo(container);
  modalFunc($el, {
    triggerOpen: true,
    open: notificationModalId
  }, function () {});
};

/**
 * Responsible for initializing any visual hidden text related to the state of
 * the favorite button.
 * @private
 * @param {jQuery} $el - Container for the favorite button
 */
var initializeVisualHidden = function initializeVisualHidden($el) {
  var hasFavorite = isFavorited($el);
  var el = document.createElement('span');
  el.className = VISUAL_HIDDEN_CLASS;
  $el.prepend(el);
  showMessage($el, hasFavorite);
};

/**
 * Responsible for dispatching a favorited event.
 * @private
 * @param {HTMLElement} el - Element triggering event
 * @param {boolean} favorited - Whether the element was favorited
 */
var dispatchFavoriteEvent = function dispatchFavoriteEvent(el, favorited) {
  var evt = new CustomEvent(EVENT_NAME, {
    detail: {
      favorited: favorited
    }
  });
  el.dispatchEvent(evt);
};

/**
 * Toggle the favorited state
 * @private
 * @param {jQuery} $el - Element to toggle
 * @param {Object} opts - Configurable options
 */
var toggleActive = function toggleActive($el, opts) {
  $el.toggleClass(ACTIVE_CLASS);
  var hasFavorite = isFavorited($el);
  showMessage($el, hasFavorite);
  //showNotification($el, hasFavorite, opts);
  //dispatchFavoriteEvent($el[0], hasFavorite);
};

/**
 * Sets up click event toggle for favorite heart button.
 * @private
 * @see TOGGLE_FAVORITE_OPTIONS
 * @param {HTMLElement} el - Elements matching the selector (likely .favorite-button)
 * @param {Object} options - Configurable options
 */
function toggleFavorite(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, TOGGLE_FAVORITE_OPTIONS, options);
  initializeVisualHidden($el);
  $el.on('click', function () {
    return toggleActive($el, opts);
  });
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleFavorite);

/***/ }),
/* 232 */
/***/ (function(module, exports) {



/***/ }),
/* 233 */
/***/ (function(module, exports) {



/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dataProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_has__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_has__);
/**
 * Responsible for setting up data attributes that have required fields.
 * @module lib/dataProps
 */




/**
 * Provides a way of pulling in data attributes on an element, while providing
 * sensible defaults and required fields.
 * @param {HTMLElement|jQuery|string} el - The element containing the data attrs
 * @param {Object} [defaults={}] - Any applied default fields
 * @param {Array} [required=[]] - Represents any fields that are required
 * @return {Object} Data from the element and defaults
 */
function dataProps(el) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var data = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()({}, defaults, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).data());
  required.forEach(function (path) {
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_has___default()(data, path)) {
      throw new Error("".concat(path, " was not found as a data attr"));
    }
  });
  return data;
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('document').ready(function () {});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var exp = /\{\{\s*(.*?)\s*\}\}/g;
var stache = function stache(template) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return template.replace(exp, function (match, submatch) {
    return data[submatch] || '';
  });
};
/* harmony default export */ __webpack_exports__["a"] = (stache);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Toggle classes
 * @module abControls
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'abControls';

/**
 * Applies any sort of event handlers for the abControls.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var activeClass = 'ab-controls--active';
  $el.find('.js-ab-controls-btn').on('click', function () {
    if ($el.hasClass(activeClass)) {
      $el.removeClass(activeClass);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab-controls__wrapper').css('width', 'auto');
    } else {
      $el.addClass(activeClass);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab-controls__wrapper').css('width', '100%');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (e) {
    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass(activeClass);
    }
  });
  $el.find('.js-ab-controls-close').on('click', function (e) {
    e.stopPropagation();
    $el.removeClass(activeClass);
  });
  $el.find('.js-ab-controls-remove').on('click', function (e) {
    e.preventDefault();
    $el.removeClass('ab-controls--show');
    localStorage.setItem('abControls', 'false');
  });
  $el.find('.ab-controls-clickable').on('click', function (e) {
    var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
    var request = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: '/dbadmin/spring-controller/abtest/toggleABTestGroup',
      type: 'POST',
      data: element.data('value')
    });
    request.done(function () {
      window.location.reload(true);
    });
  });
};
/**
 * Initializes abControls.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function abControls(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: '/dbadmin/spring-controller/abtest/abtest-widget',
    type: 'GET',
    data: {
      abtestids: $el.data('ids'),
      device: 'mobile'
    },
    success: function success(data) {
      $el.append(data);
      setEventListeners($el);
      if (localStorage.getItem('abControls') === 'false') {
        $el.removeClass('ab-controls--show');
      } else if (localStorage.getItem('abControls') === 'true' || localStorage.getItem('abControls') === null) {
        $el.addClass('ab-controls--show');
        localStorage.setItem('abControls', 'true');
      }
    }
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, abControls);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export AUTO_VALUE */
/* unused harmony export BLOCK_VALUE */
/* unused harmony export CHECKED_ATTR */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Responsible for creating an accordion based on elements existing in the DOM
 * @module accordion
 */



var PLUGIN_NAME = 'accordion';
var CLICK_EVENT = 'click';
var AUTO_VALUE = 'auto';
var BLOCK_VALUE = 'block';
var CHECKED_ATTR = 'checked';
var DEFAULTS = {
  accItem: '.accordion__item',
  accContent: '.accordion__content',
  accActive: 'accordion__item--active',
  accRadio: 'js-accordion-radio',
  accLabel: '.accordion__label',
  accSpeed: 200,
  accToggle: false,
  accDataToggleAttr: 'toggle',
  accExpandFull: false,
  accDataExpandFullAttr: 'accordionExpandFull',
  accTargetItem: '',
  accQueryOpen: false,
  accDataQueryAttr: 'queryString',
  onComplete: function onComplete() {}
};

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, accordion);

/**
 * Initializes an accordion based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * accordion
 * @param {Object} options - Options used for wiring up the accordion
 * @see DEFAULTS
 */
function accordion(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = mergeOptions($el, options);
  applyDefaultsToActive($el, opts);
  applyDefaultsToRadio($el, opts);
  applyEventHandlers($el, opts);
  return {
    openPanel: function openPanel(targetItem) {
      opts.accTargetItem = targetItem;
      itemClickHandler('', $el, opts);
    },
    closeAll: function closeAll() {
      return closeActiveTab($el, opts);
    }
  };
}
;

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);
  var _opts = opts,
    accDataToggleAttr = _opts.accDataToggleAttr,
    accDataQueryAttr = _opts.accDataQueryAttr,
    accDataExpandFullAttr = _opts.accDataExpandFullAttr;
  if ($el.data(accDataToggleAttr) === true) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accToggle: true
    });
  }
  if ($el.data(accDataExpandFullAttr) === true) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accExpandFull: true
    });
  }
  if ($el.data(accDataQueryAttr) === true) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accQueryOpen: true
    });
  }
  return opts;
};

/**
 * Handles any sort of defaults when the accordion is called upon.
 * @param  {jQuery} $el - The container element
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 */
var applyDefaultsToActive = function applyDefaultsToActive($el, _ref) {
  var accActive = _ref.accActive,
    accContent = _ref.accContent,
    accLabel = _ref.accLabel;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accActive), $el).find(accContent).css({
    display: BLOCK_VALUE,
    height: AUTO_VALUE
  }).end().find(accLabel).attr('aria-expanded', "true");
};

/**
 * Handles any sort of defaults when the accordion is using radio buttons.
 * @param  {jQuery} $el - The container element
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {string} options.accItem - Selector representing the tab
 * @param  {string} options.accRadio - Selector representing a radio button
 */
var applyDefaultsToRadio = function applyDefaultsToRadio($el, _ref2) {
  var accActive = _ref2.accActive,
    accContent = _ref2.accContent,
    accLabel = _ref2.accLabel,
    accItem = _ref2.accItem,
    accRadio = _ref2.accRadio;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accRadio, ":").concat(CHECKED_ATTR), $el).closest(accItem).addClass(accActive).children(accContent).css({
    display: BLOCK_VALUE,
    height: AUTO_VALUE
  }).end().closest(accItem).children(accLabel).attr('aria-expanded', "true");
};

/**
 * Utility function to pull query parameter form URL
 * @private
 * @param {String} name - String to look for in URL
 */
var getParameterByName = function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

/**
 * Applies any sort of event handlers for the accordion.
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} options - Options used for wiring up the accordion
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var accLabel = opts.accLabel,
    accQueryOpen = opts.accQueryOpen,
    accItem = opts.accItem;
  // check if accordion has data attr set to true
  if (accQueryOpen) {
    // check for query string in URL
    var accordionOpen = getParameterByName('accordionOpen');
    if (accordionOpen) {
      // set parent for openTab
      var $parent = $el.find('#' + accordionOpen).closest(accItem);

      //  Set animation speed to 0 so default active tab closes as quick as possible.
      closeActiveTab($el, opts);
      openTab($el, $parent, opts);
    }
  }
  $el.find(accLabel).on(CLICK_EVENT, function (evt) {
    return itemClickHandler(evt, $el, opts);
  });
};

/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} opts - Options passed along from initialization
 */
var itemClickHandler = function itemClickHandler(evt, $el, opts) {
  var accActive = opts.accActive,
    accItem = opts.accItem,
    accToggle = opts.accToggle;
  var $targetItem = '';
  if (evt !== '') {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).is('[type="radio"]') || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).is('[type="checkbox"]')) {
      return;
    }
    $targetItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.currentTarget).closest(accItem);
  } else {
    $targetItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.accTargetItem);
  }
  if (!$targetItem.hasClass(accActive)) {
    if (!accToggle) {
      closeActiveTab($targetItem, opts);
    }
    openTab($el, $targetItem, opts);
  } else {
    closeExistingActiveTab($targetItem, opts);
  }
};

/**
 * Opens a tab and provides any DOM manipulation and styles used to show a tab.
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {jQuery} $targetItem - Target Accordion Clicked Item
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {string} options.accRadio - Selector representing a radio button
 * @param  {number} options.accSpeed - Speed in ms for the closing animation
 * @param  {Function} options.onComplete - Called on when animation has
 * completed
 */
var openTab = function openTab($el, $targetItem, _ref3) {
  var accActive = _ref3.accActive,
    accContent = _ref3.accContent,
    accLabel = _ref3.accLabel,
    accRadio = _ref3.accRadio,
    accSpeed = _ref3.accSpeed,
    accExpandFull = _ref3.accExpandFull,
    onComplete = _ref3.onComplete;
  var content = $targetItem.children(accContent);
  content.css({
    height: AUTO_VALUE,
    display: BLOCK_VALUE
  });
  var label = $targetItem.children(accLabel);
  label.attr('aria-expanded', 'true');
  // PDP Refine - Side Panel Accordion Logic
  if (accExpandFull) {
    // Hide Siblings when activated
    $targetItem.siblings().hide();
    // Set Label to sticky
    label.css({
      position: 'sticky',
      top: '53px',
      width: '100%',
      backgroundColor: '#fff',
      zIndex: '13001'
    });
  }
  var contentHeight = content.outerHeight(true);
  content.css({
    height: 0
  }).stop().animate({
    height: contentHeight
  }, accSpeed, function () {
    content.css({
      height: AUTO_VALUE
    });
    onComplete();
  });
  $targetItem.addClass(accActive).children(accRadio).prop(CHECKED_ATTR, true);
};

/**
 * Closes the active tab
 * @param  {jQuery} $el - Target Accordion Clicked Item
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {string} options.accItem - Selector representing the tab
 * @param  {number} options.accSpeed - Speed in ms for the closing animation
 */
var closeActiveTab = function closeActiveTab($el, _ref4) {
  var accActive = _ref4.accActive,
    accContent = _ref4.accContent,
    accLabel = _ref4.accLabel,
    accItem = _ref4.accItem,
    accSpeed = _ref4.accSpeed,
    accExpandFull = _ref4.accExpandFull;
  var $activeTab = $el.closest('.accordion').children(".".concat(accActive));
  $activeTab.find(accContent).stop().animate({
    height: 0
  }, accSpeed, function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeAttr('style');
  });
  $activeTab.removeClass(accActive).children("".concat(accLabel)).attr('aria-expanded', "false");
  if (accExpandFull) {
    // Show all list items
    $el.children().show();
  }
};

/**
 * Closes an existing tab that has directly been interacted with.
 * @param  {jQuery} $parent - The parent containing the entire tab.
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {number} options.accSpeed - Speed in ms for the closing animation
 */
var closeExistingActiveTab = function closeExistingActiveTab($parent, _ref5) {
  var accActive = _ref5.accActive,
    accContent = _ref5.accContent,
    accLabel = _ref5.accLabel,
    accSpeed = _ref5.accSpeed,
    accExpandFull = _ref5.accExpandFull;
  $parent.find(accContent).stop().animate({
    height: 0
  }, accSpeed, function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeAttr('style');
    $parent.removeClass(accActive).children(accLabel).attr('aria-expanded', "false");
    // PDP Refine - Side Panel Accordion Logic
    if (accExpandFull) {
      // Remove Labels JS styles
      $parent.find(accLabel).removeAttr('style');
      // Show all list items Siblings
      $parent.siblings().show();
    }
  });
};

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle__);

$(function () {
  var $backToTop = $('.js-back-to-top');
  var $ntfToastBtn = $('.ntf-toast--btn');
  var $fixedCornerWrap = $('#js-fixed-corner__wrap');
  var $footer = $('.site-footer');
  if ($backToTop.length === 0) {
    return;
  }
  var scrollToTop = function scrollToTop() {
    $("html, body").animate({
      scrollTop: 0
    }, 300);
  };

  // Check if back to top button exist
  if ($backToTop.length) {
    // Add click event to scroll top
    $backToTop.on("click", function () {
      scrollToTop();
    });

    // Toggle btt button visibility based on scroll position
    $(window).on("scroll resize", __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default()(function () {
      var $window = $(this);
      var docHeight = $(document).height();
      var windowHeight = window.screen.height;
      var footerWrapperHeight = docHeight - $footer.outerHeight() - windowHeight;
      var scrollPos = $(this).scrollTop();
      var scrollPosY = $window.scrollTop();
      if (scrollPos > 250) {
        $backToTop.stop().fadeIn(250);
      } else {
        $backToTop.stop().fadeOut();
      }
      if (scrollPosY >= footerWrapperHeight) {
        $ntfToastBtn.addClass('u-hide').next().addClass('fixed-corner--full-width');
      } else {
        $ntfToastBtn.removeClass('u-hide');
        $fixedCornerWrap.removeClass('fixed-corner--full-width');
      }
    }, 100));
  }
  ;
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_mask_plugin__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery_mask_plugin__);
/**
 * Handles all focus to anchor
 * @module ccExpMask to
 */






// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'ccExpMask';
var DEFAULTS = {};
function setFormating($el, opts) {
  if ($el.length) {
    $el.mask('00/00');
  }
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function ccExpMask(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setFormating($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, ccExpMask);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export regExList */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for using the creditcard behavior within a floating label.
 * @module elements/fields/iconifyCreditCard
 */



var PLUGIN_NAME = 'ccMask';

/**
 * Contains the list of regex associated with credicards
 * @type {Array}
 */
var regExList = [{
  name: 'visa',
  regex: '^4'
}, {
  name: 'amex',
  regex: '^(34|37)'
}, {
  name: 'master',
  regex: '^5[1-5]'
}, {
  name: 'jcb',
  regex: '^(352[89]|35[3-8][0-9])'
}, {
  name: 'discover',
  regex: '^(6011|65|64[4-9]|622(1(2[6-9]|[3-9])|[2-8]{2}|9([01]|2[0-5])))'
}];

/**
 * Shows the active credit card icon
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
var getCardIcon = function getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions) {
  var ccNum = $el.val();
  var _initRegExpList$filte = initRegExpList.filter(function (_ref) {
      var regex = _ref.regex;
      return regex.test(ccNum);
    }),
    _initRegExpList$filte2 = _slicedToArray(_initRegExpList$filte, 1),
    _initRegExpList$filte3 = _initRegExpList$filte2[0],
    _initRegExpList$filte4 = _initRegExpList$filte3 === void 0 ? {
      name: 'generic'
    } : _initRegExpList$filte3,
    activeCard = _initRegExpList$filte4.name;
  // const $activeCard = $(iconNodes[activeCard]);
  $el.mask(activeCard === 'amex' ? amexCCTemplate : defaultCCTemplate, maskOptions);
  // showCard($activeCard, container);
};
/**
 * Initialize credit cards' regex
 * @private
 * @returns {Array} - returns initialized regex array
 */
var initRegex = function initRegex() {
  return regExList.map(function (_ref2) {
    var name = _ref2.name,
      regex = _ref2.regex;
    return {
      name: name,
      regex: new RegExp(regex)
    };
  });
};
/**
 * Set Data Attributes for each credit card icons
 * @private
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
var applyMask = function applyMask($el) {
  var defaultCCTemplate = '0000 0000 0000 0000';
  var amexCCTemplate = '0000 000000 00000';
  var initRegExpList = initRegex();
  var maskOptions = {
    onKeyPress: function onKeyPress() {
      getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions);
    },
    translation: {
      0: {
        pattern: /[0-9*]/
      }
    }
  };
  getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions);
  $el.mask(defaultCCTemplate, maskOptions);
};
var checkEncrypted = function checkEncrypted($el) {
  var isEncrypted = typeof $el.context !== 'undefined' && $el.context.value.includes('*');
  if (!isEncrypted) {
    applyMask($el);
  }
  $el.on('input', function () {
    applyMask($el);
  });
};

/**
 * Initializes an ccMask based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * ccMask
 * @param {Object} options - Options used for wiring up the ccMask
 * @see DEFAULTS
 */
function ccMask(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  checkEncrypted($el);
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, ccMask);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(7);
/**
 * Handles all radios and checkboxes to be togglable with enter key
 * @module charCounter
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'charCounter';
var DEFAULTS = {};
var getMaxChar = function getMaxChar($el) {
  var maxChar = $el.attr('maxlength');
  return maxChar;
};
var countCurrentChar = function countCurrentChar($el) {
  var charCount = $el.val().length;
  return charCount;
};
var displayMaxChar = function displayMaxChar($el, getMaxChar) {
  var maxCharContianer = $el.attr("data-count-max");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(maxCharContianer).text(getMaxChar($el));
};
var displayCharCount = function displayCharCount($el, countCurrentChar) {
  var charCountContainer = $el.attr("data-count-total");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(charCountContainer).text(countCurrentChar($el));
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on('input', function (evt) {
    displayCharCount($el, countCurrentChar);
  });
};

/**
 * Initializes charCounter.
 * @param {HTMLElement} el - button /element that opens charCounter
 * @param {Object} options - Options used for wiring up the charCounter
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function charCounter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  displayMaxChar($el, getMaxChar);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, charCounter);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles close banners
 * @module closeBanner
 */



var PLUGIN_NAME = 'closeBanner';
var closeBannerEventHandlers = function closeBannerEventHandlers() {
  var closeBannerChild = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-banner');
  var closeBannerParent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-parent');
  closeBannerChild.on('click', function () {
    closeBannerParent.hide();
  });
};
// $el trigger
function bannerCloseBtn() {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-banner');
  closeBannerEventHandlers($el);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, bannerCloseBtn);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Toggle classes
 * @module cookiesBanner
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'cookiesBanner';
var handleToggle = function handleToggle($cookieBanner, $contentToShow, $contentToHide, activeClass) {
  var startingHeight = $cookieBanner[0].offsetHeight;
  var $backToTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-corner');
  var $attentiveNTF = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#attentive_creative');
  $cookieBanner.css('height', startingHeight);
  if (activeClass) {
    $cookieBanner.removeClass('active');
  } else {
    $cookieBanner.addClass('active');
  }
  var newHeight = $contentToShow[0].offsetHeight + 14;
  $cookieBanner.animate({
    height: newHeight
  }, 300);
  $backToTop.animate({
    bottom: newHeight
  }, 300);
  $attentiveNTF.animate({
    bottom: newHeight
  }, 300);
};
var handleClick = function handleClick($cookieBanner, $initialContent, $newContent) {
  var hasActiveClass = $cookieBanner.hasClass('active');
  if (hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true);
  } else {
    handleToggle($cookieBanner, $newContent, $initialContent, false);
  }
};
var handleScroll = function handleScroll(scrollPosY, $cookieBanner, $initialContent, $newContent) {
  var hasActiveClass = $cookieBanner.hasClass('active');
  if (scrollPosY !== 0 && hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true);
  } else if (scrollPosY === 0 && !hasActiveClass) {
    handleToggle($cookieBanner, $newContent, $initialContent, false);
  }
};

/**
 * Applies any sort of event handlers for the cookiesBanner.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var initialScrollPositon = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
  var $cookieBanner = $el.closest('.cookies-banner');
  var $initialContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookies-banner__head');
  var $newContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookies-banner__details--v2');
  if (initialScrollPositon !== 0) {
    handleToggle($cookieBanner, $initialContent, $newContent, true);
  } else {
    handleToggle($cookieBanner, $newContent, $initialContent, false);
  }
  $el.on('click', function () {
    handleClick($cookieBanner, $initialContent, $newContent);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('scroll resize', function () {
    var scrollPosY = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
    handleScroll(scrollPosY, $cookieBanner, $initialContent, $newContent);
  });
};
/**
 * Initializes cookiesBanner.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function cookiesBanner(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  setEventListeners($el);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, cookiesBanner);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SECOND */
/* unused harmony export MINUTE */
/* unused harmony export HOUR */
/* unused harmony export DAY */
/* unused harmony export DAY_CONTAINER */
/* unused harmony export HOURS_AS_DAYS_CONTAINER */
/* unused harmony export HOUR_CONTAINER */
/* unused harmony export MINUTE_CONTAINER */
/* unused harmony export SECOND_CONTAINER */
/* unused harmony export DAY_LABEL */
/* unused harmony export HOURS_AS_DAYS_LABEL */
/* unused harmony export HOUR_LABEL */
/* unused harmony export MINUTE_LABEL */
/* unused harmony export SECOND_LABEL */
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Countdown days, hours, minutes and seconds
 * @module countdown
 */

// Styleguide documenation URL: /fw_5c5624d5b6ce843062239e375741ad11ae94500a/fw_src/mobile/styleguide/site/modules.html#countdown




var SECOND = 1000;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var DAY_CONTAINER = '.js-countdown-day';
var HOURS_AS_DAYS_CONTAINER = '.js-countdown-hours-as-days';
var HOUR_CONTAINER = '.js-countdown-hour';
var MINUTE_CONTAINER = '.js-countdown-minute';
var SECOND_CONTAINER = '.js-countdown-second';
var DAY_LABEL = '.js-countdown-day-label';
var HOURS_AS_DAYS_LABEL = '.js-countdown-hours-as-days-label';
var HOUR_LABEL = '.js-countdown-hour-label';
var MINUTE_LABEL = '.js-countdown-minute-label';
var SECOND_LABEL = '.js-countdown-second-label';

// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'countdown';
var DEFAULTS = {
  targetDateTime: '2029-12-01T00:00:00-08:00',
  countdownEndText: null,
  countdownRemove: false
};
/**
 * Update countdown heading or remove when time expires
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var updateCountdownHeading = function updateCountdownHeading($el, opts) {
  // Get the countdown heading
  var $countdownHed = $el.find('.js-countdown__hed');
  // Get data-countdown-end-text value - must be set on parent
  var countdownEndText = opts.countdownEndText;
  // If countdown heading exists and there is a countdownEndText value
  if ($countdownHed.length && countdownEndText !== null) {
    $countdownHed.text(countdownEndText);
  }
};
/**
 * Boolean to see if seconds should be displayed
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var getThreshold = function getThreshold(opts) {
  return !opts.displaySeconds ? 60 : 0;
};
/**
 * Boolean to see if time has expired
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var initialTimeCheck = function initialTimeCheck(target, opts) {
  var now = new Date().getTime();
  var initialTimeLeft = target - now;
  var initialSecondsRemaining = Math.floor(initialTimeLeft / 1000);
  // Check it time remaining is more than the thershold
  return initialSecondsRemaining > getThreshold(opts);
};
/**
* Creates an object to cach countdown elements
* @param  {jQuery} $el - link
*/
var queryElements = function queryElements($el) {
  return {
    dayContainer: $el.find(DAY_CONTAINER),
    hourContainer: $el.find(HOUR_CONTAINER),
    hourAsDaysContainer: $el.find(HOURS_AS_DAYS_CONTAINER),
    minuteContainer: $el.find(MINUTE_CONTAINER),
    secondContainer: $el.find(SECOND_CONTAINER),
    dayLabel: $el.find(DAY_LABEL),
    hourLabel: $el.find(HOUR_LABEL),
    hourAsDaysLabel: $el.find(HOURS_AS_DAYS_LABEL),
    minuteLabel: $el.find(MINUTE_LABEL),
    secondLabel: $el.find(SECOND_LABEL)
  };
};
/**
 * Updates the countdown display elements
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {number} timeLeft - amount of time still left in the countdown
 */
var updateCountdownDisplay = function updateCountdownDisplay($el, $elements, opts, timeLeft) {
  var daysLeft = Math.floor(timeLeft / DAY);
  var daysLeftCheck = daysLeft === 0 ? daysLeft : daysLeft * 24;
  var hoursDaysLeft = Math.floor(timeLeft % DAY / HOUR + daysLeftCheck);
  hoursDaysLeft = hoursDaysLeft < 10 ? "00".concat(hoursDaysLeft).slice(-2) : hoursDaysLeft;
  var hoursLeft = "00".concat(Math.floor(timeLeft % DAY / HOUR)).slice(-2);
  var minutesLeft = "00".concat(Math.floor(timeLeft % HOUR / MINUTE)).slice(-2);
  var secondsLeft = "00".concat(Math.floor(timeLeft % MINUTE / SECOND)).slice(-2);
  $elements.dayContainer.text(daysLeft);
  $elements.hourContainer.text(hoursLeft);
  $elements.hourAsDaysContainer.text(hoursDaysLeft);
  $elements.minuteContainer.text(minutesLeft);
  $elements.secondContainer.text(secondsLeft);
  $elements.dayLabel.text(daysLeft === 1 ? 'day' : 'days');
  $elements.hourLabel.text(hoursLeft === '01' ? 'hour' : 'hours');
  $elements.hourAsDaysLabel.text(parseInt(hoursDaysLeft) === 1 ? 'hour' : 'hours');
  $elements.minuteLabel.text(minutesLeft === '01' ? 'minute' : 'minutes');
  $elements.secondLabel.text(secondsLeft === '01' ? 'second' : 'seconds');
};
/**
 * Runs the countdown and sets the interval
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var runCountdown = function runCountdown($el, $elements, opts) {
  var target = new Date(opts.targetDateTime).getTime();
  // initial check to see if any time remains
  var timeRemains = initialTimeCheck(target, opts);
  // if no time remains
  if (!timeRemains) {
    // Check if countdown should be removed otherwise zero it out
    if (opts.countdownRemove) {
      $el.children().not('.js-countdown__hed').remove();
    } else {
      updateCountdownDisplay($el, $elements, opts, 0);
    }
    // Display end text if provided
    updateCountdownHeading($el, opts);
    // Show countdown markup
    $el.removeClass('u-hide');
    return;
  }
  $el.removeClass('u-hide');
  var intervalId = setInterval(function () {
    var now = new Date().getTime();
    var timeLeft = target - now;
    var secondsRemaining = Math.floor(timeLeft / 1000);
    // Check if countdown has expired
    if (secondsRemaining <= getThreshold(opts)) {
      clearInterval(intervalId);
      updateCountdownDisplay($el, $elements, opts, 0);
      // Display end text if provided
      updateCountdownHeading($el, opts);
      // Remove countdown elements if option is enabled
      if (opts.countdownRemove) {
        $el.children().not('.js-countdown__hed').remove();
      }
      return;
    }
    updateCountdownDisplay($el, $elements, opts, timeLeft);
  }, SECOND);
};
/**
 * Initializes countdown
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function countdown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  // Check boolean options on initialization for countdown removal
  opts.countdownRemove = opts.countdownRemove === true || opts.countdownRemove === "";
  var $elements = queryElements($el);
  // Check if seconds markup is present
  opts.displaySeconds = $el.find('.js-countdown-second').length;
  // Check if countdown is hidden
  opts.countdownHidden = $el.hasClass('u-hide');
  runCountdown($el, $elements, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, countdown);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(7);
/**
 * Creates a Slide up/down of Content
 * @module fixedOverlay
 */




var PLUGIN_NAME = 'fixedOverlay';
var CLICK_EVENT = 'click';
var DEFAULTS = {};

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, fixedOverlay);

/**
 * Initializes an fixedOverlay based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

function fixedOverlay(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}

/**
 * Applies any sort of event handlers for the fixedOverlay.
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

var applyEventHandlers = function applyEventHandlers($el, opts) {
  opts = opts || {};

  //.js-fixed-overlay
  $el.on(CLICK_EVENT, function (evt) {
    showOverlay(evt, $el, opts);
  });

  //.js-fixed-overlay-close
  $el.next('.fixed-overlay__scroll').find('.js-fixed-overlay-close').on(CLICK_EVENT, function () {
    closeOverlay();
  });
};

/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 * @param {Object} opts - Options passed along from initialization
 */

//Activate SlideUp Event
function showOverlay(e, $el) {
  var fixedOverlayScroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-overlay__scroll');
  var $elOverlayScroll = $el.siblings('.fixed-overlay__scroll');

  //Remove the ability to scroll main content while overlay is present
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({
    'overflow-y': 'hidden'
  });
  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');
  $elOverlayScroll.addClass('fixed-overlay__scroll--active');
}

//Activate SlideDown Event
function closeOverlay() {
  var fixedOverlayScroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-overlay__scroll');

  //Add back the ability to scroll main content when overlay is closed
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({
    'overflow-y': 'auto'
  });
  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Fix an element based on scroll position
 * @module fixedScroll
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'fixedScroll';
var DEFAULTS = {
  offClass: '',
  parentElement: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window),
  scrollOffPosition: '.site-footer__container'
};
/**
 * Applies any sort of event handlers for the fixedScroll.
 * @param  {jQuery} $el - element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("scroll resize", function () {
    var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var docHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height();
    var windowHeight = $window.height();
    var currentScrollPosY = options.parentElement.scrollTop();
    var scrollOffPosition = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.scrollOffPosition).outerHeight(true);
    var offScrollPosY = docHeight - scrollOffPosition - windowHeight;
    if (currentScrollPosY >= offScrollPosY) {
      $el.addClass(options.offClass);
    } else {
      $el.removeClass(options.offClass);
    }
  });
};
/**
 * Initializes fixedScroll
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function fixedScroll(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, fixedScroll);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export BASE_CLASS */
/* unused harmony export MODIFIERS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(7);
/**
 * Fixed table header if columns overflows
 * @module fixedTableHeader
 */




var PLUGIN_NAME = 'fixedTableHeader';
var DEFAULTS = {};
var BASE_CLASS = 'table';
var MODIFIERS = {
  fixed: 'fixed-header'
};
/**
 * Get container width unaffected by table.
 * @param  {jQuery} $el - table
 */
var getContainerWidth = function getContainerWidth($el) {
  $el.css({
    display: 'none'
  });
  var containerWidth = $el.parent().width();
  $el.css({
    display: ''
  });
  return containerWidth;
};
/**
 * Check if table body exist. If not, add it to dom.
 * @param  {jQuery} $el - element
 */
var checkTBody = function checkTBody($el) {
  var $tr = $el.find('tr');
  if (!$tr.parent('tbody').length) {
    $tr.wrapAll('<tbody></tbody>');
  }
};
/**
 * Add modifier class
 * @param  {jQuery} $el - element
 * @param  {jQuery} modifier - modifier
 */
var mod = function mod($el, modifier) {
  $el.addClass("".concat(BASE_CLASS, "--").concat(modifier));
};
/**
 * Apply padding to table in place of table head
 * @param  {jQuery} $el - table
 */
var applyHeadPadding = function applyHeadPadding($el) {
  var $th = $el.find('th');
  $el.css({
    paddingLeft: "".concat($th.outerWidth(true), "px")
  });
};
/**
 * Apply th height just in case a row is in multiline
 * @param  {jQuery} $el - table
 */
var applyTHHeight = function applyTHHeight($el) {
  var $tr = $el.find('tr');
  $tr.each(function () {
    var $thisTr = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $td = $thisTr.find('td');
    var tdMaxHeight = 0;
    $td.each(function () {
      var tdHeight = $td.outerHeight();
      if (tdHeight > tdMaxHeight) {
        tdMaxHeight = tdHeight;
      }
    });
    $thisTr.find('th').css({
      height: tdMaxHeight
    });
  });
};
/**
 * Fixed head
 * @param  {jQuery} $el - table
 */
var fixedHead = function fixedHead($el) {
  var $th = $el.find('th');
  $th.wrapAll("<thead class=\"".concat(BASE_CLASS, "__head-wrap\"></thead>"));
  var $tHead = $el.find(".".concat(BASE_CLASS, "__head-wrap"));
  $th.wrap('<tr class="table__row"></tr>');
  $el.prepend($tHead);
};
/**
 * Check and apply dom manipulation for fixed header
 * @param  {jQuery} $el - table
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var applyFixedHeader = function applyFixedHeader($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tableWidth = $el.width();
  var containerWidth = getContainerWidth($el);
  if (tableWidth > containerWidth) {
    checkTBody($el);
    applyTHHeight($el);
    applyHeadPadding($el);
    fixedHead($el);
    mod($el, MODIFIERS.fixed);
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function fixedTableHeader(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyFixedHeader($el, opts);
  return {
    check: function check() {
      return applyFixedHeader($el, opts);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, fixedTableHeader);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Handles update of text or img when radios and checkboxes is clikced
 * @module giftCertUpdate
 */




var PLUGIN_NAME = 'giftCertUpdate';
var DEFAULTS = {
  gfcImgContainer: '',
  gfcContainer: ''
};
var radioGroup = function radioGroup($el) {
  var groupName = $el.find('input').attr('name');
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[type=\"radio\"][name=\"".concat(groupName, "\"]"));
};

/**
 * Replaces text on targeted element.
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var updateText = function updateText($selectedInput, opts) {
  var textContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.gfcContainer);
  var textToUpdate = $selectedInput.data('gfc-value');
  textContainer.html(textToUpdate);
};

/**
 * Replaces image on targeted element.
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var updateImg = function updateImg($selectedInput, opts) {
  var imgContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.gfcImgContainer);
  var imgToUpdate = $selectedInput.data('gfc-img');
  imgContainer.attr('src', imgToUpdate);
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, opts) {
  var $radioGroup = radioGroup($el);
  $radioGroup.on('change', function () {
    if (this.checked) {
      var $selectedInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      updateText($selectedInput, opts);
      updateImg($selectedInput, opts);
    }
  });
};

/**
 * Initializes giftCertUpdate.
 * @param {HTMLElement} el - button /element that triggers giftCertUpdate
 * @param {Object} options - Options used for wiring up the giftCertUpdate
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function giftCertUpdate(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, giftCertUpdate);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyboard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_merge_options__ = __webpack_require__(7);





var PLUGIN_NAME = 'horizontalScroll';
var DEFAULTS = {
  type: '',
  stacked: false,
  persistScroll: false,
  persistScrollKey: ''
};
var BASE_SELECTOR = '.horizontal-scroll';
var WRAPPER_SELECTOR = "".concat(BASE_SELECTOR, "__wrapper");
var SLIDES_SELECTOR = "".concat(BASE_SELECTOR, "__item");
var isRTL = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').attr('dir') === 'rtl';
var isInViewport = function isInViewport($img, $container) {
  var imgTop = $img.offset().top;
  var imgBottom = imgTop + $img.outerHeight();
  var imgLeft = $img.offset().left;
  var imgRight = imgLeft + $img.outerWidth();
  var vpTop = $container.offset().top;
  var vpBottom = vpTop + $container.height();
  var vpLeft = $container.offset().left;
  var vpRight = vpLeft + $container.outerWidth();
  return imgBottom > vpTop && imgTop < vpBottom && imgLeft < vpRight && imgRight > vpLeft;
};

/**
 * Indicates whether element is within horizontal viewport.
 * @param  {HTMLElement} slide  The DOM element of the slide.
 * @return {boolean}  Whether the element is within the horizontal viewport.
 */
function isInHorizontalViewport(slide) {
  var rect = slide.getBoundingClientRect();
  var tolerance = 1;
  var LEFTMOST_VIEWPORT_BOUNDARY = 0;
  var RIGHTMOST_VIEWPORT_BOUNDARY = window.innerWidth;
  return rect.left >= LEFTMOST_VIEWPORT_BOUNDARY && rect.right <= RIGHTMOST_VIEWPORT_BOUNDARY + tolerance;
}
var addButtonsToWrapper = function addButtonsToWrapper($el) {
  var previousButtonHTML = isRTL ? "\n    <button aria-label=\"previous page\" class=\"previous\">\n        <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-right\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M6.25 12a.75.75 0 0 1-.51-1.3L8.648 8 5.74 5.3A.75.75 0 1 1 6.76 4.2l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.749.749 0 0 1-.51.2z\"/>\n              </svg>\n          </span>\n        </span>\n      </button>\n    " : "\n    <button aria-label=\"previous page\" class=\"previous\">\n        <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-left\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M9.75 12a.749.749 0 0 1-.51-.2l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.02 1.1L7.352 8l2.908 2.7a.75.75 0 0 1-.51 1.3z\"/>\n              </svg>\n          </span>\n        </span>\n      </button>\n    ";
  var nextButtonHTML = isRTL ? "\n    <button aria-label=\"next page\" class=\"next\">\n        <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-left\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M9.75 12a.749.749 0 0 1-.51-.2l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.02 1.1L7.352 8l2.908 2.7a.75.75 0 0 1-.51 1.3z\"/>\n              </svg>\n          </span>\n        </span>\n      </button>\n    " : "\n    <button aria-label=\"next page\" class=\"next\">\n        <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-right\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M6.25 12a.75.75 0 0 1-.51-1.3L8.648 8 5.74 5.3A.75.75 0 1 1 6.76 4.2l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.749.749 0 0 1-.51.2z\"/>\n              </svg>\n          </span>\n        </span>\n      </button>\n    ";
  if (isRTL) {
    $el.after(nextButtonHTML);
    $el.before(previousButtonHTML);
  } else {
    $el.before(previousButtonHTML);
    $el.after(nextButtonHTML);
  }
};
var wrapHorizontalScrollContent = function wrapHorizontalScrollContent($el) {
  $el.wrap('<div class="horizontal-scroll__wrapper" aria-label="Carousel" role="region" />');
  addButtonsToWrapper($el);
};
/**
 * Updates the tabindex and aria-hidden attributes for each slide based on viewport visibility.
 * @return {void}
 */
var updateSlideState = function updateSlideState($el) {
  var $slides = $el.find(SLIDES_SELECTOR);
  if (!$slides.length) return;
  $slides.each(function (_, slide) {
    var tabindexValue = isInHorizontalViewport(slide) ? 0 : -1;
    var ariaHiddenValue = !isInHorizontalViewport(slide);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide).find('a:first').attr('tabindex', tabindexValue);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide).find('a:last').attr('tabindex', tabindexValue);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide).attr('aria-hidden', ariaHiddenValue);
  });
};
/**
 * Calculate combined width of all slides, whether stacked or not.
 * @param {jQuery} $slides  The slides
 * @param {Object} opts Options
 * @return {void}
 */
var calculateTotalScrollableWidth = function calculateTotalScrollableWidth($slides, opts) {
  if (opts.stacked) {
    // If stacked, calculate based on number of columns per row
    var firstSlideWidth = $slides.first().outerWidth(true);
    var visibleRows = Math.floor($slides.parent().outerHeight() / $slides.first().outerHeight(true));
    var columnsPerRow = Math.ceil($slides.length / visibleRows);
    return firstSlideWidth * columnsPerRow;
  }

  // If unstacked, sum up total slides width
  return $slides.toArray().reduce(function (totalWidth, slide) {
    return totalWidth + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide).outerWidth(true);
  }, 0);
};
/**
 * Updates enabled/disabled state of buttons based on current slider position.
 * @return {void}
 */
var updateButtonState = function updateButtonState($el, opts) {
  var $slides = $el.find("".concat(BASE_SELECTOR, "__item"));
  var $prev = $el.closest(WRAPPER_SELECTOR).find('.previous');
  var $next = $el.closest(WRAPPER_SELECTOR).find('.next');

  // Calculate container width and total slides width
  var containerWidth = $el.outerWidth();
  var totalScrollableWidth = calculateTotalScrollableWidth($slides, opts);

  // Calculate current scroll position and determine boundaries
  var currentScrollLeft = $el.scrollLeft();
  var lastSlideOffset = totalScrollableWidth - containerWidth;
  if (isRTL) {
    // In RTL, scrollLeft is negative as you scroll leftwards,
    // so the "end" is the most negative value
    var mostNegativeScrollLeft = -totalScrollableWidth + containerWidth;

    // Determine whether on first or last slide in RTL mode
    // Near zero in RTL mode means visual start
    var onFirstSlide = currentScrollLeft >= -1;
    // Near max negative value means visual end
    var onLastSlide = currentScrollLeft <= mostNegativeScrollLeft + 1;

    // Finally, update button state for RTL
    $prev.prop('disabled', onFirstSlide);
    $prev.attr('aria-hidden', onFirstSlide);
    $next.prop('disabled', onLastSlide);
    $next.attr('aria-hidden', onLastSlide);
  } else {
    // Determine whether on first or last slide in LTR mode
    var _onFirstSlide = currentScrollLeft <= 0;
    var _onLastSlide = currentScrollLeft >= lastSlideOffset;

    // Finally, update button state for LTR
    $prev.prop('disabled', _onFirstSlide);
    $prev.attr('aria-hidden', _onFirstSlide);
    $next.prop('disabled', _onLastSlide);
    $next.attr('aria-hidden', _onLastSlide);
  }
};
var showImage = function showImage($el, key) {
  var $lazyImages = $el.find('img[data-lazy]').not('.loaded');
  if (!$lazyImages.length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off("scroll.horizontalScroll-".concat(key));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).off("scroll.horizontalScroll-".concat(key));
  }
  $lazyImages.each(function eachLazyImage() {
    var $lazyImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (isInViewport($lazyImage, $el)) {
      $lazyImage.attr('src', $lazyImage.attr('data-lazy'));
      if ($lazyImage.attr('data-srcset')) {
        $lazyImage.attr('srcset', $lazyImage.attr('data-srcset'));
      }
      $lazyImage.addClass('loaded');
    }
  });
};
var onWindowScroll = function onWindowScroll($el, key) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("scroll.horizontalScroll-".concat(key), function () {
    showImage($el, key);
  });
};
/**
 * Animates the horizontal scroll to specified index.
 * @param  {number} index  The slide index to which to move.
 * @return {void}
 */
var moveSlider = function moveSlider(index, $el, $slides, opts) {
  var isWithinBounds = index >= 0 && index < $slides.length;
  if (isWithinBounds) {
    // Calculate new scroll position based on slide width
    var slideWidth = $slides.eq(index).outerWidth(true);
    var scrollDirection = isRTL ? -1 : 1;
    var scrollPosition = slideWidth * index * scrollDirection;
    updateButtonState($el, opts);
    $el.animate({
      scrollLeft: scrollPosition
    }, 'fast', function () {
      // After scroll animation is complete, set focus on the first focusable
      // element inside the visible slide
      var $visibleSlide = $slides.eq(index);
      $visibleSlide.find('a, button, input, [tabindex="0"]').first().focus();
    });
  }
};
/**
 * Gets index of currently visible slide.
 * @return {number}  Index of currently visible slide.
 */
var getCurrentSlideIndex = function getCurrentSlideIndex($slides) {
  var currentIndex = 0;
  $slides.each(function checkInView(index) {
    if (isInHorizontalViewport(this)) {
      currentIndex = index;
      // Break `each` loop after finding first visible slide
      return false;
    }
    // For ESLint
    return true;
  });
  return currentIndex;
};
/**
 * Moves slider depending on keyboard input.
 * @return {void}
 */
var handleButtonPress = function handleButtonPress(event, $el, $buttons, opts) {
  var $slides = $el.find("".concat(BASE_SELECTOR, "__item"));
  var key = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(event);
  if (key === 'ENTER' || key === 'SPACE' || event.type === 'click') {
    event.preventDefault();
    var $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target);
    var currentIndex = getCurrentSlideIndex($slides);
    var targetIndex;
    if (isRTL) {
      var hasPreviousClass = $button.hasClass('previous');
      if (hasPreviousClass) {
        targetIndex = Math.max(currentIndex - 1, 0);
      } else {
        targetIndex = Math.min(currentIndex + 1, $slides.length - 1);
      }
    } else {
      var _hasPreviousClass = $button.hasClass('previous');
      if (_hasPreviousClass) {
        targetIndex = currentIndex - 1;
      } else {
        targetIndex = currentIndex + 1;
      }
    }
    moveSlider(targetIndex, $el, $slides, opts);
  }
};
var onKeyDown = function onKeyDown($el, $a11yButtons, opts) {
  return $a11yButtons.on('keydown', function (evt) {
    return handleButtonPress(evt, $el, $a11yButtons, opts);
  });
};
var onClick = function onClick($el, $a11yButtons, opts) {
  return $a11yButtons.on('click', function (evt) {
    return handleButtonPress(evt, $el, $a11yButtons, opts);
  });
};
var onButtonFocus = function onButtonFocus($a11yButtons) {
  $a11yButtons.on('focus', function removeAriaHidden() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('aria-hidden', false);
  });
};
var onButtonBlur = function onButtonBlur($a11yButtons) {
  $a11yButtons.on('blur', function addAriaHidden() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('aria-hidden', true);
  });
};
var scrollTrackingEvent = function scrollTrackingEvent($el, opts) {
  return function () {
    var $image = $el.find('img');
    var imageIndexes = [];
    $image.each(function eachImage() {
      var $thisImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var imageIndex = $thisImage.closest('.horizontal-scroll__item').index();
      if (isInViewport($thisImage, $el)) {
        imageIndexes.push(imageIndex + 1);
      }
    });
    var carouselEvent = new CustomEvent('carouselChange');
    carouselEvent.tracking = {
      type: opts.type,
      currentSlide: imageIndexes[imageIndexes.length - 1],
      pageUrl: window.location.href,
      pageTitle: document.title,
      element: $el
    };
    window.dispatchEvent(carouselEvent);
  };
};
var onHorizontalScroll = function onHorizontalScroll($el, key, opts) {
  var trackingScroll = scrollTrackingEvent($el, opts);
  // event listener handles the displaying of images
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on("scroll.horizontalScroll-".concat(key), function () {
    showImage($el, key);
  });
  // event listener used to track marketing tracking numbers when the users scrolls.
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on("scroll.horizontalEventScroll-".concat(key), __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(trackingScroll, 500));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on('scroll.horizontalScroll', function () {
    updateSlideState($el);
    updateButtonState($el, opts);
  });
};
var persistScrollPosition = function persistScrollPosition($el, storageKey) {
  var saved = sessionStorage.getItem(storageKey);
  if (saved !== null) {
    $el.scrollLeft(parseInt(saved, 10));
  } else {
    var $active = $el.find('.active').first();
    if ($active.length) {
      var container = $el[0];
      var item = $active[0];
      container.scrollLeft = item.offsetLeft - container.offsetLeft - container.offsetWidth / 2 + item.offsetWidth / 2;
    }
  }
  $el.css('visibility', 'initial');
  $el.on('scroll.persistScroll', function () {
    sessionStorage.setItem(storageKey, $el.scrollLeft());
  });
};
var addAccessibleCarousel = function addAccessibleCarousel($el, opts) {
  wrapHorizontalScrollContent($el);
  updateSlideState($el);
  updateButtonState($el, opts);
};
var addEventListeners = function addEventListeners($el, key, opts) {
  var $a11yButtons = $el.closest(WRAPPER_SELECTOR).find('> button');
  onWindowScroll($el, key);
  onHorizontalScroll($el, key, opts);
  onKeyDown($el, $a11yButtons, opts);
  onClick($el, $a11yButtons, opts);
  onButtonFocus($a11yButtons);
  onButtonBlur($a11yButtons);
};
var init = function init($el, opts) {
  // key - creates unique name for the event namespace, so it can be later disabled
  var key = "key-".concat(Math.ceil(Math.random() * 10000000000));
  $el.find('img[data-lazy]').addClass('horizontal-scroll__lazy-image');
  showImage($el, key);
  addAccessibleCarousel($el, opts);
  addEventListeners($el, key, opts);
  if (opts.persistScroll && opts.persistScrollKey) {
    persistScrollPosition($el, opts.persistScrollKey);
  }
};
function horizontalScroll(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var _showImages = init($el, opts);
  return {
    showImages: function showImages() {
      return _showImages();
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, horizontalScroll);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Toggle classes
 * @module impressionsControls
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'impressionsControls';

/**
 * Applies any sort of event handlers for the impressionsControls.
 */
var setEventListeners = function setEventListeners($el) {
  var activeClass = 'ab-controls--active';
  $el.find('.js-impressions-controls-btn').on('click', function () {
    if ($el.hasClass(activeClass)) {
      $el.removeClass(activeClass);
    } else {
      $el.addClass(activeClass);
    }
  });
  $el.find('.js-impressions-controls-close').on('click', function (e) {
    e.preventDefault();
    $el.removeClass('ab-controls--show');
    localStorage.setItem('abControls', 'false');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (e) {
    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass(activeClass);
    }
  });
};

/**
 * Impressions polling
 * @param  {jQuery} $el - link
 */
var _doPoll = function doPoll($el) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get('/dbadmin/spring-controller/impressions/impressions-data', function (data) {
    $el.find('.impressions-widget-data').html(data);
    setEventListeners($el);
    setTimeout(function () {
      _doPoll($el);
    }, 3000);
  });
};

/**
 * Initializes impressionsControls.
 * @param {HTMLElement} el - link
 */
function impressionsControls(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: '/dbadmin/spring-controller/impressions/impressions-widget',
    type: 'GET',
    data: {
      device: 'mobile'
    },
    success: function success(data) {
      $el.append(data);
      _doPoll($el);
      if (localStorage.getItem('impressionsControls') === 'false') {
        $el.removeClass('ab-controls--show');
      } else if (localStorage.getItem('impressionsControls') === 'true' || localStorage.getItem('impressionsControls') === null) {
        $el.addClass('ab-controls--show');
        localStorage.setItem('impressionsControls', 'true');
      }
    }
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, impressionsControls);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_lazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_lazy_plugins_jquery_lazy_ajax__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_lazy_plugins_jquery_lazy_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_lazy_plugins_jquery_lazy_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(2);





function lazyAjax(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _afterLoad = options.afterLoad,
    _onError = options.onError;
  var opts = __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default()(options, ['afterLoad', 'onError']);
  var combinedOptions = Object.assign({
    onError: function onError($el) {
      if (_onError) {
        options.onError($el);
      }
      $el.trigger('lazy-ajax:error', [$el]);
    },
    afterLoad: function afterLoad($el) {
      if (_afterLoad) {
        options.afterLoad($el);
      }
      $el.trigger('lazy-ajax:after-load', [$el]);
    },
    ajaxCreateData: function ajaxCreateData($el) {
      var json = $el.data('lazy-json');
      if (!json) {
        return null;
      }
      return json;
    }
  }, opts);
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).Lazy(combinedOptions);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('lazyAjax', lazyAjax);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export LOAD_EVENT */
/* unused harmony export SCROLL_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_lib_merge_options__ = __webpack_require__(7);
/**
 * Responsible for lazy loading images in the DOM
 * @module lazyLoadImage
 */





var PLUGIN_NAME = 'lazyLoadImage';
var LOAD_EVENT = 'load.lazyLoadImage';
var SCROLL_EVENT = 'scroll.lazyloadimage';
var DEFAULTS = {};
var $WINDOW = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);

/**
 * Handles the scroll event.
 * @param {jQuery} $el - Containing the elements for the lazyLoadImage
 * @param {Object} opts - Options passed along from initialization
 */
function loadImage($el, opts) {
  if ($el.attr('data-lazy-triggered-img') === 'false') {
    var imagePosition = $el.offset().top;
    var windowBottomPosition = $WINDOW.scrollTop() + $WINDOW.innerHeight();
    ;
    var imageSrc = $el.attr('data-lazy-img');
    if (windowBottomPosition >= imagePosition) {
      $el.attr('src', imageSrc);
      $el.attr('data-lazy-triggered-img', true);
    }
  }
}

/**
 * Applies any sort of event handlers for lazyLoadImage.
 * @param {jQuery} $el - Containing the elements for the lazyLoadImage
 * @param {Object} options - Options used for wiring up the lazyLoadImage
 * @see DEFAULTS
 */
function applyEventHandlers($el, opts) {
  $WINDOW.on("".concat(LOAD_EVENT, " ").concat(SCROLL_EVENT), __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function () {
    loadImage($el, opts);
  }, 100));
}

/**
 * Initializes lazyLoadImage based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the lazyLoadImage
 * @param {Object} options - Options used for wiring up the lazyLoadImage
 * @see DEFAULTS
 */
function lazyLoadImage(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  $el.attr('data-lazy-triggered-img', false);
  applyEventHandlers($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, lazyLoadImage);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assign__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_carousel__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__slick_carousel__);



 // Import side-effect module

var defaultSettings = {
  slideshowSettings: {}
};
var offsetLoadY = 100;
function checkScroll(settings, $slideshows) {
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var totalSlideshows = $slideshows.length;
  var slideshowIteratorCount = 0;
  $slideshows.each(function () {
    var $slideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if ($slideshow.attr('lazyTriggered') === 'false') {
      var y = $slideshow.offset().top;
      var visibleY = $window.scrollTop() + $window.innerHeight();
      if (y < visibleY + offsetLoadY) {
        $slideshow.removeClass('js-lazyload-slick');
        $slideshow.slick(settings.slideshowSettings);
        $slideshow.attr('lazyTriggered', true);
      }
    } else {
      slideshowIteratorCount += 1;
    }
  });
  if (slideshowIteratorCount === totalSlideshows) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('scroll.lazyloadSlideshow resize.lazyloadSlideshow');
  }
}
function init(userSettings) {
  var $slideshows = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-slick');
  var settings = __WEBPACK_IMPORTED_MODULE_1_lodash_assign___default()({}, defaultSettings, userSettings);
  $slideshows.attr('lazyTriggered', false);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('scroll.lazyloadSlideshow resize.lazyloadSlideshow', __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
    checkScroll(settings, $slideshows);
  }, 100));
  checkScroll(settings, $slideshows);
}

// Default export
/* harmony default export */ __webpack_exports__["a"] = (init);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_slider__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_mask_plugin__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vanish_vanish__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__toggle_display__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__toggle_dropdown__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__track_video__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accordion__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fixed_overlay__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fixed_scroll__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lazyload_image__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__page_constrain__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__back_to_top__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__product_zoom__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__horizontal_scroll__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__progress_ring__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__qr_code_toggle__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__image_carousel__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__tabs__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__toggle_text__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__slidedown__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__side_panel__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__product_filter_active_button__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__product_filter_search__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__product_filter_count__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__product_filter_clear_all__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__switch_class__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__fixed_table_header__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lazyload__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lazy_ajax__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__no_focus__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__toggle_change__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__toggle_reveal__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__char_counter__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__countdown__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__gift_cert_update__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__show_on_overflow__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__cc_mask__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__cc_exp_mask__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ntf_toast__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ntf_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__ntf_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__progressive_btn__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__close_banner__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ab_controls__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__impressions_controls__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__rich_nav__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__rating_scale_rating_scale__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__cookies_banner__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__src_scripts_modules_wishlist__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__lib_props__ = __webpack_require__(60);




















































// AB Test 899 HP / PDP Increase Slick Sensitivity


/**
 *
 * AB Test 899 HP/PDP Increased Slick Sensitivity
 */
var increasedSensitivity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_51__lib_props__["a" /* get */])('slick.slickSensitivity', false);
function setupLazyLoad() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__lazyload__["a" /* default */])({
    slideshowSettings: {
      arrows: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      lazyLoad: 'ondemand'
    }
  });
}
window.resetLazyLoad = function () {
  setupLazyLoad();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-slick').removeClass('js-lazyload-slick');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-image-lp').removeClass('js-lazyload-image-lp');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
};
function setupHomeSlideshow() {
  var slideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-homepage-slideshow');
  slideshow.find(".slick-slideshow__slide").removeClass("u-hide");
  // Mock Content Start - AB Test 899 HP/PDP Increased Slick Sensitivity
  if (increasedSensitivity) document.body.classList.add('ab899-slick-sensitivity');
  // Mock Content End
  slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    // Mock Content Start - AB Test 899 HP/PDP Increased Slick Sensitivity
    touchThreshold: increasedSensitivity ? 20 : 5,
    vertical: false,
    verticalSwiping: false
    // Mock Content End
  });
}
function setupBeautyLpSlideshow() {
  var slideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-beauty-lp-slideshow');
  slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    dotsClass: 'slick-dots--beauty'
  });
}
function setupBeautyTrendsSlideshow() {
  var slideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-beauty-trends-slideshow');
  slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    dotsClass: 'slick-dots--beauty'
  });
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.navDropdowns = function (options) {
  function toggleDropdown($el) {
    $el.find("ul").slideToggle("slow");
  }

  // Iterate and reformat each matched element.
  return this.each(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).on("click", function () {
      toggleDropdown(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    });
  });
};
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__no_focus__["a" /* default */])();
  setupLazyLoad();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion').accordion({
    onComplete: function onComplete() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-table-header').fixedTableHeader('check');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-open-trigger').on('click', function (e) {
    e.preventDefault;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-accordion-open").accordion('openPanel', '#js-accordion-open-target');
  });
  // $('.product-option--size .product-option__select').sizeChange();
  // $('.product-option--color .product-option__select').colorChange();
  // $('.btn--add-to-bag').addToBag();
  // $('.product-option--oos').oosProduct();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-countdown').countdown();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-show-on-overflow').showOnOverflow();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-gfc-update').giftCertUpdate();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-image').lazyLoadImage();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progress-ring').progressRing();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-display').toggleDisplay();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-track-video").trackVideo();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal').modal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.a11y();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-char-counter').charCounter();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-banner').closeBanner();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slidedown').slidedown();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-carousel").slickSlider();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-cc').ccMask();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progressive-btn').progressiveBtn();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-cookies-banner-toggle').cookiesBanner();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-single-slide').slick({
    dots: false,
    infinite: true,
    fade: true,
    arrows: false,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 1500
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-dress-edit').slickSlider({
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  // Global Banner slider
  var banerSlideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow');
  if (banerSlideshow.children('.banner--slider-list__item').length > 1) {
    banerSlideshow.slick({
      autoplay: true,
      autoplaySpeed: 6000,
      prevArrow: '.banner__slick-prev',
      nextArrow: '.banner__slick-next'
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').on('click', function () {
      banerSlideshow.slick('slickPause');
    });
  }

  // $(".js-homepage-slideshow").slickSlider();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-nav-dropdown').navDropdowns();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-nav-dropdown--full').navDropdowns();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-overlay').fixedOverlay();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-switch-class').switchClass();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-text').toggleText();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-table-header').fixedTableHeader();
  setupHomeSlideshow();
  setupBeautyLpSlideshow();
  setupBeautyTrendsSlideshow();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-change').toggleChange();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-dropdown').toggleDropdown();

  // input mask
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-tel-us').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-tel-us').mask('(000) 000-0000');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-date').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-date').mask('00/00/0000');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-month-day').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-month-day').mask('00/00');
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-scroll').fixedScroll();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal').toggleReveal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-footer-qr-btn').qrCodeToggle();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs').tabs({
    onShow: function onShow() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-table-header').fixedTableHeader('check');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-ab-controls').abControls(); // Ab Testing Controls for previewing on testing servers
  // for all inclusive modal
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-duties-modal').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/fw/mobile/dialog/AllInclusiveModal.jsp',
      triggerOpen: open,
      type: 'toast'
    });
  });

  // Initialize lazy load on image with class name
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy({
    effect: 'fadeIn'
  });

  // for all inclusive banner modal
  // check's if banner exists for all inclusive
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fwDutyBanner').length > 0) {
    if (!__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get("all_inclusive_modal")) {
      // no cookie, open modal
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: '/fw/mobile/dialog/AllInclusiveModal.jsp',
        triggerOpen: open,
        type: 'toast',
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('all_inclusive_modal', true, {
            expires: 7
          });
        }
      });
    }
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-impressions-controls').impressionsControls();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-rich-nav').richNav();
  __WEBPACK_IMPORTED_MODULE_50__src_scripts_modules_wishlist__["a" /* default */].bindWishListEvent();

  //JS for Input - Floating Label interaction
  function updateText(event) {
    var input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
      closebtn = input.siblings('.close-btn'),
      val = input.val();
    if (val != "") {
      input.parent().addClass("field--floating-float");
    } else {
      input.parent().removeClass("field--floating-float");
    }
    if (input.is(':focus') && val != "") {
      //Show close button if input is in focus w/ text
      closebtn.show();
    } else if (input.is(':focus') && val == "") {
      //Hide close button if input is in focus w/o text
      closebtn.hide();
    }

    //Timeout Set to avoid close buttton from disappearing before intentionally clicking it
    setTimeout(function () {
      if (!input.is(':focus') && val != "") {
        //Hide close buttton if Input is no longer in focus but contains text
        closebtn.hide();
      }
    }, 200);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".field--floating input").keydown(updateText);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".field--floating input").change(updateText);
  function clearInput(event) {
    var closeBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    closeBtn.siblings('input').val('');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().removeClass("field--floating-float");
    closeBtn.hide();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".close-btn").on('click', clearInput);

  // Validation needed

  // if invalid add class of .is-error
  //hide close btn / show exclamation icon

  // if more detail needed add class .is-more-detail
  // hide close btn / show question mark link
  function filterSetup() {
    // Event for clicking on overlay on title dropdown
    var $pageHeaderOverlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-page-header-overlay");
    var $pageHeaderTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".page-header__title");
    $pageHeaderOverlay.on("click", function () {
      $pageHeaderTitle.click();
    });
  }
  filterSetup();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.vanish').vanish();

  // Image Carousels
  var IMAGE_CAROUSEL_SELECTOR = '.image-carousel';
  var PRODUCT_ZOOM_SELECTOR = "".concat(IMAGE_CAROUSEL_SELECTOR, "--product-zoom");
  var $imageCarousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(IMAGE_CAROUSEL_SELECTOR);
  $imageCarousel.filter(":not(".concat(PRODUCT_ZOOM_SELECTOR, ")")).imageCarousel();
  $imageCarousel.filter(PRODUCT_ZOOM_SELECTOR).each(function setupZoomCarousel() {
    var carousel;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('badge-on-top')) {
      carousel = new __WEBPACK_IMPORTED_MODULE_20__image_carousel__["a" /* default */](this, {
        dots: true
      });
    } else {
      carousel = new __WEBPACK_IMPORTED_MODULE_20__image_carousel__["a" /* default */](this);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product__image .image-carousel__counter').show();
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).productZoom({
      slideFunc: carousel.setSlideNumber.bind(carousel),
      beforeUnmount: carousel.transitionSlide.bind(carousel),
      targetSelector: 'img'
    });
  });

  // footer country preferences
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-view-country-preferences').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/fw/content/user/countryPreferences',
      triggerOpen: open,
      type: 'toast',
      triggerElement: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)
    });
  });

  // Launch Hero Slider
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slick-launches').each(function () {
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    $this.slick({
      dots: true,
      appendDots: $this.find('.js-pagination-dots'),
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000
    }).on('afterChange', function (event, slick, currentSlide) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(slick.$dots, function (i, el) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('li').eq(currentSlide).addClass('slick-active').find('button');
      });
    });
  });
}); // End Document Ready

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(53);


/*

Creates no focus on click events, but focuses when tabs

*/

var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
var focusClass = 'no-focus';
var focusActiveClass = 'focus-active';
/**
 * Tab Event
 * @param  {jQuery} $html - html element
 * @param  {event} evt - key event
 */
var tabEventHandler = function tabEventHandler($html, evt) {
  if (__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'TAB' || __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'SHIFT_TAB') {
    $html.removeClass(focusClass);
    $html.addClass(focusActiveClass);
  }
};
var clickEventHandler = function clickEventHandler($html) {
  $html.addClass(focusClass);
  $html.removeClass(focusActiveClass);
};
var noFocus = function noFocus() {
  $html.addClass(focusClass);
  $html.on('mousedown.noFocus', function (evt) {
    return clickEventHandler($html, evt);
  });
  $html.on('keyup.noFocus', function (evt) {
    return tabEventHandler($html, evt);
  });
};
/* harmony default export */ __webpack_exports__["a"] = (noFocus);

/***/ }),
/* 257 */
/***/ (function(module, exports) {

function restriction() {
  $(".js-ntf-restriction-modal").on("click", function () {
    $.modal({
      open: 'ntf-restriction-modal',
      triggerOpen: true,
      onClose: function onClose() {
        $.modal({
          open: 'ntf-toast--new',
          triggerOpen: true
        });
      }
    });
  });
}

// checks toast email address
function toastEmailCheck() {
  var input = $('#ntf-email-address');
  var value = input.val();
  // checks if email exists
  if (value == 'test@revolve.com') {
    $.modal({
      open: "ntf-toast--existing",
      triggerOpen: true,
      type: "toast"
    });
  } else if (value == 'new@revolve.com') {
    // checks new email
    $.modal({
      open: "ntf-toast--new",
      triggerOpen: true,
      type: "toast"
    });
  } else {
    // checks error for input field
    // back end to update error state
    input.closest('.field').addClass('is-error');
  }
}

// NTF mobile toast function
function toast() {
  var $toast = $('.ntf-toast--btn');
  var $close = $('.ntf-toast--btn-close');
  $close.on('click', function () {
    $toast.hide();
  });

  // email sign up form
  $('.ntf-toast--form').on('submit', function (event) {
    event.preventDefault();
    toastEmailCheck();
  });
  $(window).on("scroll resize", function () {
    var $window = $(this);
    var docHeight = $(document).height();
    var windowHeight = window.screen.height;
    var scrollPosY = $window.scrollTop();
    var $footerContainer = $('.site-footer__container');
    var footerHeight = $footerContainer.outerHeight(true); //- parseInt(footer.css('marginTop'))
    var footerScrollPosY = docHeight - footerHeight - windowHeight; //- (96 - 20)

    // if (scrollPosY >= footerScrollPosY) {
    //     $('.fixed-toast').hide();
    // } else {
    //     $('.fixed-toast').show();
    // }
  });
}
$(document).ready(function () {
  restriction();
  toast();
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
// Toggle Page Overflow / Constraints

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-constrain-page").on("click", function () {
    var $bodyAndHtml = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("html, body");
    var constrainClass = "page-constrain";
    if (!$bodyAndHtml.hasClass(constrainClass)) {
      $bodyAndHtml.addClass(constrainClass);
    } else {
      $bodyAndHtml.removeClass(constrainClass);
    }
  });
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(99);
/**
 * Sidebar product filter search
 * @module productFilterActiveSearch
 */






var PLUGIN_NAME = 'productFilterActiveButton';
var DEFAULTS = {
  clearAllText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.clearAllText', 'Clear')
};
var createCloseIcon = function createCloseIcon() {
  return "<span class=\"icon icon--x icon--sm u-margin-l--sm\">\n  <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\"\n      role=\"presentation\">\n      <path\n          d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28\n             4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8\n             9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\">\n      </path>\n  </svg>\n</span>";
};
var createFilterButton = function createFilterButton(text) {
  return "<li class=\"horizontal-scroll__item\n     horizontal-scroll__item--basis-none\">\n  <button class=\"btn btn--filters\">\n      ".concat(text, "\n      ").concat(createCloseIcon(), "\n  </button>\n</li>");
};

// Getting rid of Clear button for AB testing
var createContainerButtons = function createContainerButtons() {
  return "<div class=\"horizontal-scroll u-margin-b--md u-width-plus-16\">\n  <ul\n      class=\"horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding u-margin-b--md\">\n  </ul>\n</div>";
};
var addButtonsContainer = function addButtonsContainer($container, $checkboxes, _ref) {
  var clearAllText = _ref.clearAllText;
  var $buttonContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createContainerButtons(clearAllText));
  var $clearAllButton = $buttonContainer.find('button');
  $container.prepend($buttonContainer);
  $clearAllButton.on('click', function () {
    $checkboxes.each(function (index, checkbox) {
      if (checkbox.checked) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).prop('checked', false).trigger('change');
      }
    });
  });
  return {
    $buttonListContainer: $buttonContainer,
    $buttonList: $buttonContainer.find('ul')
  };
};
var addButtonToList = function addButtonToList($checkbox, $buttonList) {
  var innserSpan = $checkbox.next().children('span');
  var checkboxText;
  if (innserSpan.length) {
    checkboxText = innserSpan.eq(0).text();
  } else {
    checkboxText = $checkbox.next().text();
  }
  var $filterButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createFilterButton(checkboxText));
  $buttonList.append($filterButton);
  $filterButton.on('click', function () {
    $checkbox.prop('checked', false).trigger('change');
  });
  return $filterButton;
};
var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};
var checkButtonListVisibility = function checkButtonListVisibility($buttonListContainer, $checkboxes) {
  if (countChecked($checkboxes)) {
    $buttonListContainer.removeClass('u-hide');
    return;
  }
  $buttonListContainer.addClass('u-hide');
};
var initActiveButtons = function initActiveButtons($buttonListContainer, $buttonList, $checkboxes) {
  $checkboxes.each(function (index, checkbox) {
    var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
    var $filterButton;
    if (checkbox.checked) {
      $filterButton = addButtonToList($checkbox, $buttonList);
    }
    $checkbox.on('change', function () {
      if (checkbox.checked) {
        $filterButton = addButtonToList($checkbox, $buttonList);
      } else {
        $filterButton.remove();
      }
      checkButtonListVisibility($buttonListContainer, $checkboxes);
    });
  });
};

/**
 * Initializes productFilterActiveButton.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterActiveButton(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.filterCount);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var _addButtonsContainer = addButtonsContainer($container, $checkboxes, opts),
    $buttonListContainer = _addButtonsContainer.$buttonListContainer,
    $buttonList = _addButtonsContainer.$buttonList;
  initActiveButtons($buttonListContainer, $buttonList, $checkboxes, $count);
  checkButtonListVisibility($buttonListContainer, $checkboxes);
  $container.productFilterCount();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterActiveButton);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Product Filter Clear All
 * @module productFilterClearAll
 */



var PLUGIN_NAME = 'productFilterClearAll';
var DEFAULTS = {};
var ZeroChecked = function ZeroChecked($checkboxes) {
  return $checkboxes.filter(':checked').length === 0;
};
var clearAllVisibility = function clearAllVisibility($checkboxes, $clearButton) {
  var isZeroChecked = ZeroChecked($checkboxes);
  if (isZeroChecked) {
    $clearButton.hide();
  } else {
    $clearButton.show();
  }
};
var onChangeListener = function onChangeListener($checkboxes, $clearButton) {
  return $checkboxes.on('change', function () {
    return clearAllVisibility($checkboxes, $clearButton);
  });
};

/**
 * Initializes productFilterClearAll.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterClearAll(container) {
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var $clearButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all-button');
  $clearButton.on('click', function () {
    $checkboxes.each(function (index, checkbox) {
      if (checkbox.checked) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).prop('checked', false).trigger('change');
      }
    });
  });
  clearAllVisibility($checkboxes, $clearButton);
  onChangeListener($checkboxes, $clearButton);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterClearAll);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(99);
/**
 * Sidebar product filter search
 * @module productFilterSearch
 */






var PLUGIN_NAME = 'productFilterSearch';
var DEFAULTS = {
  zeroResultsText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.zeroResults', 'There are 0 results. Try a new search.')
};
var findMatches = function findMatches(phraseToMatch, list) {
  return list.filter(function (item) {
    var regex = new RegExp(phraseToMatch, 'ig');
    return item.value.match(regex);
  }).map(function (item) {
    return item.index;
  });
};
var createData = function createData($checkboxes) {
  return $checkboxes.toArray().map(function (checkbox, index) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).data('data-original-text', checkbox.value);
    return {
      value: checkbox.value,
      index: index
    };
  });
};
var highlightText = function highlightText(phraseToMatch, text) {
  var regex = new RegExp(phraseToMatch, 'ig');
  return text.replace(regex, function (match) {
    return "<strong>".concat(match, "</strong>");
  });
};
var createZeroResults = function createZeroResults($container, _ref) {
  var zeroResultsText = _ref.zeroResultsText;
  var $zeroResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p class='u-hide'>".concat(zeroResultsText, "</p>"));
  $container.find('#designer-search').closest('.field').after($zeroResults);
  return $zeroResults;
};
var countVisible = function countVisible($checkboxes) {
  return $checkboxes.filter(':visible').length;
};
var checkZeroResults = function checkZeroResults($checkboxes, $zeroResults) {
  if (countVisible($checkboxes) === 0) {
    $zeroResults.removeClass('u-hide');
  } else {
    $zeroResults.addClass('u-hide');
  }
};

/**
 * Initializes productFilterSearch
 * @param {HTMLElement} el - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterSearch(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var checkboxData = createData($checkboxes);
  var $searchField = $container.find('input[type="text"');
  var $zeroResults = createZeroResults($container, opts);
  $container.productFilterCount();
  // $('[aria-controls=alldesigners]').on('click', () => {
  //   $('#alldesigners').formField();
  // });
  $searchField.on('input', function () {
    var matches = findMatches($searchField.val(), checkboxData);
    $checkboxes.each(function (index, checkbox) {
      var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
      var $checkboxContainer = $checkbox.closest('.accordion__height-cap');
      var $label = $checkboxContainer.find('.checkbox__label');

      // show checkbox option
      if (matches.includes(index)) {
        $checkboxContainer.removeClass('u-hide');
        if ($searchField.val() === '') {
          $label.html($checkbox.data('data-original-text'));
          $container.removeClass('hasValue');
        } else {
          $container.addClass('hasValue');
          var highlight = highlightText($searchField.val(), $checkbox.data('data-original-text'));
          $label.html(highlight);
        }

        //  hide checkbox option
      } else {
        $checkboxContainer.addClass('u-hide');
      }
    });
    checkZeroResults($checkboxes, $zeroResults);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterSearch);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FAVORITE_ID */
/* unused harmony export FADE_OUT_BADGE_CLASS_NAME */
/* unused harmony export ZOOM_BADGE_ID */
/* unused harmony export ZOOM_BADGE_TRANSITION_EVENT */
/* unused harmony export ZOOM_BADGE_COOKIE */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_toggle_favorite__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zoom_slider_zoom__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_data_props__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keyboard__ = __webpack_require__(53);
/**
 * Responsible for rendering a product specific zoom
 * @module modules/productZoom
 */









/**
 * Defines the options which can be provided for the product zoom.
 * @type {Object}
 */
var DEFAULTS = {
  sliderZoom: __WEBPACK_IMPORTED_MODULE_5__zoom_slider_zoom__["a" /* default */],
  targetSelector: '',
  slideFunc: function slideFunc(num) {
    return num;
  },
  didUnmount: function didUnmount() {},
  zoomBadgeDuration: 2000,
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */])
};

/**
 * Defines the default props for the component.
 * @type {Object}
 */
var DEFAULT_PROPS = {
  images: [],
  noImages: 'No images found :(',
  tapToZoom: 'Tap to Zoom'
};

/**
 * Defines the id for the favorite element.
 * @type {String}
 */
var FAVORITE_ID = 'product-zoom-favorite';

/**
 * Defines the fade out className.
 * @type {String}
 */
var FADE_OUT_BADGE_CLASS_NAME = 'product-badge--fade-out';

/**
 * Defines the element ID for a zoom badge.
 * @type {String}
 */
var ZOOM_BADGE_ID = 'zoom-badge';

/**
 * Defines the event used for finishing a transition.
 * @type {String}
 */
var ZOOM_BADGE_TRANSITION_EVENT = 'transitionend';

/**
 * Contains fields for interacting with a badge cookie.
 * @type {Object}
 */
var ZOOM_BADGE_COOKIE = {
  name: 'zb',
  expires: 14
};

/**
 * Setup used for hiding the zoom badge so that it can be shown and later on
 * removed.
 * @private
 * @param  {number} zoomBadgeDuration - The duration in milliseconds when the
 *                                      badge should be removed
 */
var setupHideZoomBadge = function setupHideZoomBadge(zoomBadgeDuration) {
  setTimeout(function () {
    var $zoomBadge = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementById(ZOOM_BADGE_ID));
    $zoomBadge.on(ZOOM_BADGE_TRANSITION_EVENT, function () {
      return $zoomBadge.remove();
    }).addClass(FADE_OUT_BADGE_CLASS_NAME);
  }, zoomBadgeDuration);
};

/**
 * Contains the component used for rendering zoom info badge.
 * @private
 * @param  {string} tapToZoom - Text used in the badge
 * @return {string} Rendered template containing the badge
 */
var infoBadgeComponent = function infoBadgeComponent(_ref) {
  var tapToZoom = _ref.tapToZoom;
  return "\n  <div id=\"".concat(ZOOM_BADGE_ID, "\" class=\"product-badge product-badge--center u-absolute product-badge--inline\">\n    ").concat(tapToZoom, "\n  </div>");
};

/**
 * Renders an info badge if the necessary cookie isn't present.
 * @private
 * @param  {number} zoomBadgeDuration - Represents duration in milliseconds
 * @param  {string} tapToZoom - Text used inside zoom badge
 * @return {string} The info badge if the logic checks out
 */
var renderInfoBadge = function renderInfoBadge(_ref2) {
  var zoomBadgeDuration = _ref2.zoomBadgeDuration,
    tapToZoom = _ref2.tapToZoom;
  var name = ZOOM_BADGE_COOKIE.name,
    expires = ZOOM_BADGE_COOKIE.expires;
  var sawZoomBadge = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get(name);
  if (!sawZoomBadge) {
    __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set(name, 1, {
      expires: expires
    });
    setupHideZoomBadge(zoomBadgeDuration);
    return infoBadgeComponent({
      tapToZoom: tapToZoom
    });
  }
  return '';
};

/**
 * Renders any additional markup that goes in the menu.
 * @private
 * @return {string} A fully render template for the menu.
 */

var favoriteButtonComponent = function favoriteButtonComponent() {
  return "\n  <button id=\"".concat(FAVORITE_ID, "\" class=\"favorite-button zoom-menu__favorite\">\n    <span class=\"favorite-button__icon icon icon--heart-fill\">\n      <svg>\n        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-heart-fill\"></use>\n      </svg>\n    </span>\n  </button>");
};

/**
 * Used to bind the events for the product zoom.
 * @private
 */
var didRender = function didRender() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__elements_toggle_favorite__["a" /* default */])(document.getElementById(FAVORITE_ID));
};

/**
 * Determines whether a function should be ran based on images existing.
 * @private
 * @param  {array}   images - A list of image sources
 * @param  {Function} callback - Callback to return if logic is valid
 * @return {Function} Used for execution based on logic
 */
var shouldRun = function shouldRun(images, callback) {
  return images.length ? callback : function () {
    return '';
  };
};

/**
 * Responsible for adding the click and keydown zoom event listener
 * @param {HTMLElement} el - The element used for opening up the product zoom
 * @param {Object} [options={}] - Forwarded along options
 */
function addZoomClickListener(el, opts) {
  var targetSelector = opts.targetSelector,
    sliderZoomFunc = opts.sliderZoom;
  var _dataProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_data_props__["a" /* default */])(el, DEFAULT_PROPS),
    images = _dataProps.images,
    noImages = _dataProps.noImages;
  var handleZoom = function handleZoom(e) {
    // If keydown: only respond if event target is the container itself
    if (e.type === 'keydown') {
      // Only respond to Enter, and only if focus is on the container itself
      if (!(e.key === 'Enter' || e.keyCode === 13)) return;
      if (e.target !== el) return; // This ensures only container triggers zoom on Enter
    }
    var $imageLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).parent('a');
    if ($imageLink.data('zoomImage')) {
      return;
    }
    var startingIndex = null;
    if (images.length) {
      var $slickActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).closest('.slick-active');
      var slickIndex = $slickActive.data('slick-index');
      startingIndex = slickIndex !== undefined && slickIndex >= 0 ? slickIndex : 0;
    }
    sliderZoomFunc(images, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      menuRender: shouldRun(images, favoriteButtonComponent),
      didRender: shouldRun(images, didRender),
      startingIndex: startingIndex,
      noImages: noImages,
      zoomClickListener: function zoomClickListener() {
        return addZoomClickListener(el, opts);
      }
    }));
  };

  // Add click handler with delegation
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).on('click.product-zoom', targetSelector, handleZoom);

  // Add keydown handler without delegation
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).on('keydown.product-zoom', handleZoom);
}

/**
 * Responsible for rendering a slider zoom that's specifically used showcasing
 * a product.
 * @see DEFAULTS
 * @param {HTMLElement} el - The element used for opening up the product zoom
 * @param {Object} [options={}] - Forwarded along options
 */
function productZoom(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);
  var zoomBadgeDuration = opts.zoomBadgeDuration;
  var _dataProps2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_data_props__["a" /* default */])(el, DEFAULT_PROPS),
    images = _dataProps2.images,
    tapToZoom = _dataProps2.tapToZoom;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).append(shouldRun(images, renderInfoBadge({
    tapToZoom: tapToZoom,
    zoomBadgeDuration: zoomBadgeDuration
  })));
  addZoomClickListener(el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('productZoom', productZoom);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Progress Ring module
 * @module progressRing
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'progressRing';
var DEFAULTS = {
  filled: 0,
  filledRing: '.progress-ring__circle--fill',
  pending: 0,
  pendingRing: '.progress-ring__circle--pending',
  progressRings: '.progress-ring__circle',
  progressRingSVG: 'progress-ring__diagram',
  strokeWidth: 12,
  width: 150
};

/**
 * Calculates the radius of the circle. The radius needs to take into account
 * the added width from the stroke
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Number} The radius of the progress ring
 */
var calculateRadius = function calculateRadius(options) {
  return options.width / 2 - options.strokeWidth / 2;
};

/**
 * Calculates the circumference of the progress ring. This number allows
 * us to calculate the value for the percentage of the progress ring
 * that should be filled
 * @param  {Number} radius - The radius of the progress ring
 * @return {Number} THe circumference of the progress ring
 */
var calculateCircumference = function calculateCircumference(radius) {
  return radius * 2 * Math.PI;
};

/**
 * Calculates and adds the stroke-dashoffset attribute to the pending progress ring
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Number} circumference - The circumference of the progress ring
 */
var setPendingRing = function setPendingRing($el, options, circumference) {
  var amountFilled = circumference * (1 - (parseFloat(options.pending) + parseFloat(options.filled)));
  $el.find(options.pendingRing).attr("stroke-dashoffset", amountFilled);
};

/**
 * Calculates and adds the stroke-dashoffset attribute to the filled progress ring
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Number} circumference - The circumference of the progress ring
 */
var setFilledRing = function setFilledRing($el, options, circumference) {
  var amountFilled = circumference * (1 - options.filled);
  $el.find(options.filledRing).attr("stroke-dashoffset", amountFilled);
};

/**
 * Sets the viewBox property on the <svg> tag dynamically based on the width option
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setSVGViewBox = function setSVGViewBox($el, options) {
  // jQuery attr() does not work with the viewBox attribute so must convert from
  // jQuery to JavaScript to use the setAttribute() method
  var el = $el.get(0);
  var progressRingSVG = el.getElementsByClassName(options.progressRingSVG)[0];
  progressRingSVG.setAttribute("viewBox", "0 0 ".concat(options.width, " ").concat(options.width));
};

/**
 * Sets the calculated attributes to each of the <circle> elements in the
 * progress ring module
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setProgressRingAttributes = function setProgressRingAttributes($el, options) {
  var radius = calculateRadius(options);
  var circumference = calculateCircumference(radius);
  $el.find(options.progressRings).each(function (index, progressRing) {
    progressRing.setAttribute("cx", options.width / 2);
    progressRing.setAttribute("cy", options.width / 2);
    progressRing.setAttribute("r", radius);
    progressRing.setAttribute("stroke-dasharray", circumference);
    progressRing.setAttribute("stroke-width", options.strokeWidth);
  });
  setPendingRing($el, options, circumference);
  setFilledRing($el, options, circumference);
  setSVGViewBox($el, options);
};

/**
 * Updates the values of the progress ring and rerenders it.
 * Meant to be used if the progress ring needs to be updated after the page
 * has already been rendered.
 * @param  {jQuery} $el - progress ring element
 * @param  {Number} filled - % of the progress ring that should be filled
 * @param  {Number} pending - % of the progress ring that is pending
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var _rerender = function rerender($el, filled, pending, options) {
  var updatedOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, {
    filled: filled,
    pending: pending
  }, $el);
  setProgressRingAttributes($el, updatedOptions);
};

/**
 * Initializes progressRing
 * @param {HTMLElement} el - progress ring element
 * @param {Object} options - Options used for wiring up the progressRing
 * @see DEFAULTS
 */
function progressRing(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setProgressRingAttributes($el, opts);
  return {
    rerender: function rerender(filled, pending) {
      return _rerender($el, filled, pending, opts);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, progressRing);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(7);
/**
 * Progressive Button on click
 * @module progressiveBtn
 */





var PLUGIN_NAME = 'progressiveBtn';
var CLICK_HANDLER = 'click';
var DEFAULTS = {
  container: '.js-progressive-btn-block',
  progressCopy: 'loading..',
  barStyle: 'light',
  changeBtn: false
};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

var progressBar = function progressBar(progressCopy, barStyle) {
  return "<div class=\"progress-bar__block progress-bar--".concat(barStyle, "\">\n       <div class=\"progress-bar__hed\">\n          ").concat(progressCopy, "\n        </div>\n       <div class=\"progress-bar\">\n       </div>\n   </div>\n   ");
};
var destroyAllProgressive = function destroyAllProgressive($el, opts) {
  var isActive = $el.hasClass('active');
  var changeBtn = opts.changeBtn,
    container = opts.container;
  var $progressiveBlock = $el.closest(container);
  if (isActive && changeBtn) {
    $progressiveBlock.find('.progress-bar__block').remove();
    $progressiveBlock.find('.js-progressive-new-btn').removeClass('u-hide');
  }
  if (isActive && !changeBtn) {
    $progressiveBlock.find('.progress-bar__block').remove();
    $el.removeClass('u-hide');
  }
};
var progressiveFlow = function progressiveFlow($el, opts) {
  var container = opts.container,
    progressCopy = opts.progressCopy,
    barStyle = opts.barStyle;
  $el.addClass('active').addClass('u-hide');
  $el.closest(container).append(progressBar(progressCopy, barStyle));
};
var setEventListeners = function setEventListeners($el, opts) {
  $el.on(CLICK_HANDLER, function (evt) {
    progressiveFlow($el, opts);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function progressiveBtn(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  return {
    destroy: function destroy() {
      return destroyAllProgressive($el, opts);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, progressiveBtn);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles toggle for chinas qr code
 * @module qrCodeToggle
 */



var PLUGIN_NAME = 'qrCodeToggle';
var DEFAULTS = {};
var qrCodeToggleEventHandlers = function qrCodeToggleEventHandlers($el) {
  var qrCodeImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-footer-qr');
  $el.on('click', function () {
    qrCodeImage.toggle();
  });
};
function qrCodeToggle() {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-footer-qr-btn');
  qrCodeToggleEventHandlers($el);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, qrCodeToggle);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RATING_SCALE_OPTIONS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Responsible for the interacting with the rating scale which allows a user to
 * select a rating for a given product
 * @module modules/rating-scale/ratingScale
 */




/**
 * Defines the defaults around the rating scale.
 * @type {Object}
 */
var RATING_SCALE_OPTIONS = {
  titleSelector: 'h2',
  block: 'rating-scale-field',
  inputElement: 'input',
  labelElement: 'label',
  filledModifier: 'filled'
};

/**
 * Will apply class names to the block, input, and label based on the
 * operation, i.e. add/remove.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} op - The operation applied to the class name
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var updateField = function updateField(el, op, block, inputElement, labelElement, filledModifier) {
  el.classList[op]("".concat(block, "--").concat(filledModifier));
  var inputBlockElement = "".concat(block, "__").concat(inputElement);
  el.querySelector(".".concat(inputBlockElement)).classList[op]("".concat(inputBlockElement, "--").concat(filledModifier));
  var labelBlockElement = "".concat(block, "__").concat(labelElement);
  el.querySelector(".".concat(labelBlockElement)).classList[op]("".concat(labelBlockElement, "--").concat(filledModifier));
};

/**
 * Removes filled CSS class names.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var removeFilledClassNames = function removeFilledClassNames(el, block, inputElement, labelElement, filledModifier) {
  return updateField(el, 'remove', block, inputElement, labelElement, filledModifier);
};

/**
 * Adds filled CSS class names.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var addFilledClassNames = function addFilledClassNames(el, block, inputElement, labelElement, filledModifier) {
  return updateField(el, 'add', block, inputElement, labelElement, filledModifier);
};

/**
 * Will apply the filled modifier to any elements considered to be filled.
 * @private
 * @param {HTMLElement} wrap - Contains the star ratings
 * @param {HTMLElement} target - The block interacted with
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var applyFilledState = function applyFilledState(wrap, target, block, inputElement, labelElement, filledModifier) {
  var sections = Array.from(wrap.querySelectorAll(".".concat(block)));
  var selectedIndex = __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default()(sections, function (blockEl) {
    return blockEl === target;
  });
  sections.some(function (field, index) {
    if (index > selectedIndex) {
      return true;
    }
    addFilledClassNames(field, block, inputElement, labelElement, filledModifier);
    return false;
  });
};

/**
 * Updates the title based on the element interacted with.
 * @private
 * @param {Event} e - Event object
 * @param {HTMLElement} titleEl - The title element
 */
var updateTitle = function updateTitle(e, titleEl) {
  /* eslint-disable no-param-reassign */
  var ratingText = e.currentTarget.dataset.ratingText;
  if (ratingText) {
    titleEl.textContent = ratingText;
  }
  /* eslint-enable no-param-reassign */
};

/**
 * Removes all filled modifiers.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var resetFilled = function resetFilled(el, block, inputElement, labelElement, filledModifier) {
  Array.from(el.querySelectorAll(".".concat(block))).forEach(function (field) {
    removeFilledClassNames(field, block, inputElement, labelElement, filledModifier);
  });
};

/**
 * Responsible for the basic interactivity around the fit rating scale. It
 * expects a set of radio inputs that represents the rating from the form. It
 * assumes the following DOM structure with defaults provided:
 *
 * @example
 * <fieldset>
 *   <legend>Some Title</legend>
 *   <div class="rating-scale-field" data-rating-text="So Lame">
 *     <input type="radio" name="rating-scale" value="1" id="1-star"
 *     class="rating-scale-field__input">
 *     <label for="1-star" class="rating-scale-field__label icon">1 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Sorta Stoked">
 *     <input type="radio" name="rating-scale" value="2" id="2-star"
 *     class="rating-scale-field__input">
 *     <label for="2-star" class="rating-scale-field__label icon">2 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Totally Stoked">
 *     <input type="radio" name="rating-scale" value="3" id="3-star"
 *     class="rating-scale-field__input">
 *     <label for="3-star" class="rating-scale-field__label icon">3 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Mind Blown">
 *     <input type="radio" name="rating-scale" value="4" id="4-star"
 *     class="rating-scale-field__input">
 *     <label for="4-star" class="rating-scale-field__label icon">4 Star</label>
 *   </div>
 * </fieldset>
 *
 * Whenever a star rating has been interacted with, it'll do the following:
 *
 * - Apply filled class names to all .rating-scale-field that appear before the
 *   selected choice
 * - Will update the title of the section based on the data-rating-text
 *   attribute
 * - Will naturally select the input as the value
 *
 * @see RATING_SCALE_OPTIONS
 * @param {HTMLElement} wrap - Contains the star ratings
 * @param {Object} options - Configurable options
 */
function ratingScale(wrap) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, RATING_SCALE_OPTIONS, options),
    block = _$$extend.block,
    inputElement = _$$extend.inputElement,
    labelElement = _$$extend.labelElement,
    filledModifier = _$$extend.filledModifier,
    titleSelector = _$$extend.titleSelector;
  var titleEl = wrap.querySelector(titleSelector);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).on('click', ".".concat(block), function (e) {
    var input = e.currentTarget.querySelector(".".concat(block, "__").concat(inputElement));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find('.js-review-error__rating').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find('.form-section__title').removeClass('u-error');
    if (input !== e.target) {
      return;
    }
    resetFilled(wrap, block, inputElement, labelElement, filledModifier);
    updateTitle(e, titleEl);
    applyFilledState(wrap, e.currentTarget, block, inputElement, labelElement, filledModifier);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('ratingScale', ratingScale);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export GLOBAL_CLASS */
/* unused harmony export MAIN_NAV */
/* unused harmony export SUB_NAV_MENU */
/* unused harmony export DEPT_NAV_MENU */
/* unused harmony export CLICK_EVENT */
/* unused harmony export WOMENS_ENDPOINT_URL */
/* unused harmony export MENS_ENDPOINT_URL */
/* unused harmony export WOMENS_STORE_DATA_NAME */
/* unused harmony export MENS_STORE_DATA_NAME */
/* unused harmony export MAIN_MENU_ROOT_CATEGORY_NAME */
/* unused harmony export WOMENS_ROOT_CATEGORY_NAME */
/* unused harmony export MENS_ROOT_CATEGORY_NAME */
/* unused harmony export WOMENS_ROOT_SUBMENU */
/* unused harmony export MENS_ROOT_SUBMENU */
/* unused harmony export NEW_ROOT_CATEGORY_NAME */
/* unused harmony export MENS_PATHNAME */
/* unused harmony export MENS_DEPARTMENT_PARAM */
/* unused harmony export HP_PATHNAMES */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard__ = __webpack_require__(53);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Rich Nav - menus
 * @module richNav
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'richNav';
var GLOBAL_CLASS = '.js-global__nav';
var MAIN_NAV = '#rich-nav-container';
var SUB_NAV_MENU = '.sub-menu__wrapper';
var DEPT_NAV_MENU = '.departments__wrapper';
var CLICK_EVENT = 'click';
var WOMENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=forwardmobile&loadAll=true&richNav=true';
var MENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=forwardmobile&d=Mens&loadAll=true&richNav=true';
var WOMENS_STORE_DATA_NAME = 'womens-data';
var MENS_STORE_DATA_NAME = 'mens-data';
var MAIN_MENU_ROOT_CATEGORY_NAME = 'main menu';
var WOMENS_ROOT_CATEGORY_NAME = 'womens';
var MENS_ROOT_CATEGORY_NAME = 'mens';
var WOMENS_ROOT_SUBMENU = 'womens-menu__womens';
var MENS_ROOT_SUBMENU = 'mens-menu__mens';
var NEW_ROOT_CATEGORY_NAME = 'new';
var MENS_PATHNAME = '/mens-';
var MENS_DEPARTMENT_PARAM = 'd=Mens';
var HP_PATHNAMES = ['/', '/fw/index.jsp', '/fw/mobile/indexWomen.jsp', '/fw/mobile/indexMen.jsp'];
var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body);
var $pageWrap = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#page-wrap");
var $headerWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-site-header__wrapper");
var $sideNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-nav-side");
var $overlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-nav-side__overlay");
var $burgerIcon = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-burger-icon');
var $richNavContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-rich-nav');
var DEFAULTS = {
  swapClass: '',
  swapTarget: '',
  rnItem: '.js-rich-nav',
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */])
};
/**
  * Set focus to first anchor in open side nav
  */
function openSideNavFocus(opts) {
  var $openSideNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.is--open').last();
  if ($openSideNav.length > 0) {
    var $firstListItem = $openSideNav.children('.nav-side__list').first();
    // This could include more elements but should work for what we have (anchors or buttons and elements with tabindex not set to -1)
    $firstListItem.find('button, a, [tabindex]:not([tabindex="-1"])').eq(0).focus();
    opts.trapFocusFunc($openSideNav);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rich-nav-title').focus(); // Focus on screen reader heading - Accessibility
    opts.trapFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__wrapper'));
  }
}
/**
  * Open Rich Nav
  */
function openSideNav(opts) {
  $sideNav.show();
  $body.css({
    "overflow": "hidden"
  }).addClass('nav__sidebar--open');
  $richNavContainer.attr('aria-modal', 'true');

  // Set focus to the first element in the current sub nav
  openSideNavFocus(opts);
  var durationVal = 200;
  $sideNav.animate({
    left: "0"
  }, {
    duration: durationVal,
    queue: false
  });
  $pageWrap.animate({
    left: "270"
  }, {
    duration: durationVal,
    queue: false
  }).css({
    "position": "fixed"
  });
  $headerWrapper.animate({
    left: "270"
  }, {
    duration: durationVal,
    queue: false
  });
  $overlay.show().animate({
    left: "270",
    opacity: .8,
    display: 'block'
  }, {
    duration: durationVal,
    queue: false
  });
}
/**
  * Close Rich Nav
  */
function closeSideNav(opts) {
  $body.css({
    "overflow": "auto"
  }).removeClass('nav__sidebar--open');
  $richNavContainer.attr('aria-modal', 'false');
  var durationVal = 200;
  $sideNav.animate({
    left: "-270px"
  }, {
    duration: durationVal,
    queue: false
  });
  $pageWrap.css({
    "position": ""
  }).animate({
    left: "0px"
  }, {
    duration: durationVal,
    queue: false
  });
  $headerWrapper.animate({
    left: "0px"
  }, {
    duration: durationVal,
    queue: false
  });
  $overlay.animate({
    left: "0",
    opacity: 0
  }, durationVal, function () {
    $overlay.hide();
  });
  opts.releaseFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-menu-wrapper'), '');
}
// Method to close all submenus
function removeAllSubMenus() {
  var elements = document.querySelectorAll('.sub-menu__wrapper');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(DEPT_NAV_MENU).removeClass('u-hide');
  elements.forEach(function (element) {
    element.classList.remove('is--open');
  });
}

// Method to set active tab
function setActiveTab() {
  var department = window.rcProps ? window.rcProps.department : '';
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs-link').removeClass('tabs__link--active');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs-content').removeClass('tabs__content--active');
  if (department === 'Mens') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#mens-tab-button').addClass('tabs__link--active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#mens-menu__content').addClass('tabs__content--active');
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#womens-tab-button').addClass('tabs__link--active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#womens-menu__content').addClass('tabs__content--active');
  }
}

/**
 * Create New Element
 * @param {Object} element - Elemnt used for generating New Element
 */
function createNode(element) {
  return document.createElement(element);
}
/**
 * Create New Element
 * @param {Object} parent - Parent element that items get appended to
 * @param {Object} el - Element that is appended to the parent
 */
function appender(parent, el) {
  return parent.appendChild(el);
}
/**
* Clone Element
* @param {Object} element - Element to clone
*/
function cloneElement(element) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).clone(true);
}
/**
* Remove Is Open Class
* @param {Object} element - Element to remove class from
* @param {Object} className - class to remove
*/
function removeIsOpen(element, className) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).removeClass(className);
}
/**
* Error Handler
* @param {Object} response - response
*/
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
/**
 * Toggle Class
 * @param {Object} options - Options used for wiring up the List
 */
function toggleMenuClass($el, $currentElement, wrapperHeight) {
  var dataSwapClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($currentElement).data('swapClass');
  var dataSwapTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($currentElement).data('swapTarget');
  var $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($currentElement).attr('href');
  // If a data-swap-target attribute was used instead of href
  if (dataSwapTarget !== '') {
    $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget);
  }
  // Set Height of Sub Menu
  // console.log(wrapperHeight, lastWrapperHeight);
  // $changingElClass[0].style.minHeight = `${wrapperHeight}px`;
  $changingElClass.toggleClass(dataSwapClass);
  // if menu is hidden, make sure all next menus are hidden too
  // i.e. if you are in main menu->womens->beauty->bath & body->bath & shower, and you click on beauty back menu
  // then all menus after beauty (bath & body->bath & shower) are getting hidden too
  var $changingWrapperEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget); // menu div
  if (!$changingWrapperEl.hasClass(dataSwapClass)) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()($changingWrapperEl).nextAll().removeClass(dataSwapClass);
  }
}
/**
 * Scroll Element to Top
 * @param {Object} element - Element that is being checked
 */
function scrollToTop(element) {
  element.animate({
    scrollTop: 0
  }, 'fast');
}
/**
 * Build Wrapper Element - ie: div
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} parentListDataId - string representing parent id attribute
 * @param {string[]} dataPath - the list of category names representing the path from the root to the target subcategory
 */
function buildWrapperElement(elem, dataElement, dataId, wrapperHeight, lastWrapperHeight, dataPath) {
  var el = createNode("".concat(elem));
  var swapTargetClassName = buildForwardLinkSwapTargetClassName(dataId, dataPath, dataElement);
  var subMenuWrapperClass = 'sub-menu__wrapper';
  el.className = "".concat(subMenuWrapperClass, " js-menu-wrapper ").concat(swapTargetClassName);
  el.dataset.element = "".concat(dataElement);
  return el;
}
/**
 * Global elements to clone
 */
function cloneGLobalElements() {
  var globalNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(GLOBAL_CLASS);
  var globalNavClone = cloneElement(globalNav);
  return globalNavClone;
}
/**
 * Build List Element - ie: ul
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} dataId - Data id of menu
 * @param {string} catName - Category name of menu
 * @param {Array} path - Path to the data subcategory
 */
function buildListElement(elem, dataElement, dataId, catName, parentPath) {
  var el = createNode("".concat(elem));
  el.className = 'nav-side__list sub-menu__list';
  // Set id to mens or womens - mens logic will be needed
  el.dataset.id = dataId;
  el.dataset.category = dataElement;
  var path = parentPath === undefined || parentPath.length == 0 ? [] : parentPath.slice();
  path.push(catName);
  el.dataset.path = JSON.stringify(path);
  return el;
}
/**
 * Build List Item Link - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItemElement(elem) {
  var el = createNode("".concat(elem));
  el.className = 'nav-side__item';
  return el;
}
/**
 * Build List Item Link - ie: li > a
 * @param {Object} elem - Element used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string[]} dataPath - the list of category names representing the path from the root to the target subcategory
 */
function buildListItemButtonElement(dataElement, dataId, dataName, htmlContent, dataPath) {
  var el = createNode('button');
  el.className = 'nav-side__link return-link js-rich-nav';
  el.dataset.swapClass = 'is--open';
  el.dataset.swapTarget = '.' + buildBackLinkSwapTargetClassName(dataId, dataPath, dataElement);
  el.dataset.element = dataElement;
  el.dataset.name = dataName;
  el.innerHTML = htmlContent;
  // Add screen reader text for back links to menus
  var backToText = window.rcProps.richNav.backToText;
  var backToSpan = createNode('span');
  backToSpan.className = 'u-screen-reader';
  backToSpan.innerHTML = backToText;
  el.prepend(backToSpan);
  return el;
}

/**
 * Get subCategories specified by path.
 * @param {Object} data left nav data
 * @param {Array} path the list of category names representing the path from the root to the target subcategory
 */
function findSubCategories(data, path) {
  var result = data;
  if (data && path && path.length > 0) {
    var tmpResult = data.filter(function (cat) {
      return cat.catName.toLowerCase() === path[0];
    });
    if (tmpResult && tmpResult.length > 0) {
      result = findSubCategories(tmpResult[0].subCategoryList, path.slice(1));
    }
  }
  return result;
}
function findSubTitle(data, path, title) {
  if (typeof title === 'undefined') {
    title = '';
  }
  var result = title;
  if (data && path && path.length > 0) {
    var tmpResult = data.filter(function (cat) {
      return cat.catName.toLowerCase() === path[0];
    });
    if (tmpResult && tmpResult.length > 0) {
      result = findSubTitle(tmpResult[0].subCategoryList, path.slice(1), tmpResult[0].nameDisplay);
    }
  }
  return result;
}
function createSubmenuTitle(ul, parentDisplayName, linkHref) {
  var subCategoryLink = buildListItemElement('li');
  var subCategoryListItem;
  if (linkHref) {
    subCategoryListItem = createNode('a');
    subCategoryListItem.href = linkHref;
  } else {
    subCategoryListItem = createNode('span');
  }
  subCategoryListItem.className = 'nav-side__link nav-side__link--no-link nav-side__link--main';
  subCategoryListItem.innerHTML = parentDisplayName;
  appender(subCategoryLink, subCategoryListItem);
  appender(ul, subCategoryLink);
}
function translateBackLinkNames(ul, data) {
  var backLinks = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(ul).find(".nav-side__link.return-link.js-rich-nav");
  if (backLinks && backLinks.length > 0) {
    var listDataPath = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(ul).data('path');
    if (listDataPath && listDataPath.length > 0) {
      backLinks.each(function (index, backLink) {
        var linkDataName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(backLink).data('name');
        var sliceIndex = listDataPath.findIndex(function (listDataName) {
          return listDataName === linkDataName;
        });
        if (sliceIndex >= 0) {
          var updatedBackName = findSubTitle(data, listDataPath.slice(0, sliceIndex + 1));
          if (!!updatedBackName && updatedBackName !== '') {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(backLink).html(updatedBackName);
          } else if (linkDataName === NEW_ROOT_CATEGORY_NAME) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(backLink).html(window.rcProps.richNav.dataNames["new"]);
          }
        } else {
          if (linkDataName === WOMENS_ROOT_CATEGORY_NAME) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(backLink).html(window.rcProps.richNav.dataNames.womens);
          } else if (linkDataName === MENS_ROOT_CATEGORY_NAME) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(backLink).html(window.rcProps.richNav.dataNames.mens);
          }
        }
      });
    }
  }
}

/**
 * Build List Items and Links - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string[]} dataPath - the list of category names representing the path from the root to the target subcategory
 */
function buildListItems(data, ul, dataElement, dataId, dataCategory, dataLevel, dataPath) {
  var categories = {};
  var subCategories;
  var parentDisplayName;
  if (dataElement === 'new' || dataCategory === 'new') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'new arrivals';
    });
    subCategories = categories[0].subCategoryList;
    parentDisplayName = categories[0].nameDisplay;
  } else if (dataElement === 'sale' || dataCategory === 'sale') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'sale';
    });
    subCategories = categories[0].subCategoryList;
    parentDisplayName = categories[0].nameDisplay;
  } else {
    subCategories = findSubCategories(data, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(ul).data('path'));
    parentDisplayName = findSubTitle(data, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(ul).data('path'));
  }
  var addLeftMargin = window.rcProps && window.rcProps.richNav && window.rcProps.richNav.categoriesForFeaturedDesigners && window.rcProps.richNav.categoriesForFeaturedDesigners.indexOf(dataElement) >= 0;
  // create html markup for list items
  var links;
  // Go deeper if it's not New
  var subSubCats;
  if (dataElement !== 'new' && dataElement !== 'sale') {
    subSubCats = subCategories.filter(function (item) {
      return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement;
    });
    if (subSubCats && subSubCats.length > 0) {
      links = subSubCats[0].subCategoryList;
      parentDisplayName = subSubCats[0].nameDisplay;
    } else {
      links = subCategories;
    }
  } else {
    subSubCats = subCategories;
    if (dataElement === 'new') {
      // Get Arrival Dates subCategory List
      var arrivalSubCats = subSubCats[0].subCategoryList;
      // FIlter down to Category Names
      var arrivalLinksArray = arrivalSubCats.filter(function (item) {
        return item.catName;
      });
      // Get Category Array from "new"
      var category = subSubCats[1];
      // Push category on to arrival dates links
      arrivalLinksArray.push(category);
      // Set links to Arrivals links array
      links = arrivalLinksArray;
    } else {
      links = subSubCats;
    }
  }
  if (dataElement === 'beauty' && window.rcProps.richNav.beautyLink) {
    createSubmenuTitle(ul, parentDisplayName, window.rcProps.richNav.beautyLink);
  } else {
    createSubmenuTitle(ul, parentDisplayName);
  }

  // update back menus display names
  translateBackLinkNames(ul, data);
  links.map(function (link) {
    var categoryName = link.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
    var getParamValue = function getParamValue(s, paramName) {
      var params = new URLSearchParams(s);
      return params.get(paramName);
    };
    // create list items for anchor tags
    var li = createNode('li');
    li.className = 'nav-side__item';
    // if (addLeftMargin) {
    //   li.className += ' u-margin-l--lg';
    // }
    if (link.headingTextOnly) {
      li.className += ' nav-side__item--hed';
      li.innerHTML = link.nameDisplay;
      appender(ul, li);
      return true;
    }
    // create anchor tags
    var a = createNode('a');
    var btn = createNode('button');
    if (link.subCategoryList === undefined || link.subCategoryList.length <= 1) {
      // create a anchor
      a.className = 'nav-side__link';
      a.href = link.href;
      a.innerHTML = link.nameDisplay.toLowerCase();
      appender(li, a);
      if (link.href && link.href.indexOf(window.location.pathname) !== -1) {
        if (window.location.href.indexOf(link.href) !== -1) {
          a.className = 'nav-side__link active';
        } else {
          a.className = 'nav-side__link';
        }
      }
    } else {
      // create a button
      btn.className = 'nav-side__link nav-side__link--category js-rich-nav';
      btn.dataset.swapClass = 'is--open';
      btn.dataset.swapTarget = '.' + buildForwardLinkSwapTargetClassName(dataId, dataPath, categoryName);
      btn.dataset.element = categoryName;
      btn.dataset.level = link.level;
      btn.innerHTML = link.nameDisplay.toLowerCase();
      appender(li, btn);
    }
    appender(ul, li);
    return true;
  });
}
function buildBackLinkSwapTargetClassName(start, middles, end) {
  var result = "".concat(start, "-menu__");
  if (middles && middles.length > 0) {
    var middlesFixed = middles.map(function (middle) {
      return middle.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
    });
    var _iterator = _createForOfIteratorHelper(middlesFixed),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var middle = _step.value;
        if (middle !== end) {
          result = "".concat(result).concat(middle, "__");
        } else {
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    ;
  }
  return "".concat(result).concat(end);
}
function getDataEndpointVariables(isWomen) {
  return {
    endpointUrl: isWomen ? WOMENS_ENDPOINT_URL : MENS_ENDPOINT_URL,
    storeDataName: isWomen ? WOMENS_STORE_DATA_NAME : MENS_STORE_DATA_NAME
  };
}
function getRichNavData(isWomens, onDataLoad) {
  var dataEndpointVariables = getDataEndpointVariables(isWomens);
  var endpoint = dataEndpointVariables.endpointUrl;
  var storeData = dataEndpointVariables.storeDataName;
  if (sessionStorage.getItem(storeData)) {
    var data = JSON.parse(sessionStorage.getItem(storeData));
    onDataLoad(data);
  } else {
    fetch(endpoint, {
      credentials: 'same-origin'
    }).then(handleErrors).then(function (response) {
      return response.json();
    }).then(function (data) {
      // set data in local storage
      sessionStorage.setItem(storeData, JSON.stringify(data));
      // Build List Items from data object
      onDataLoad(data);
    })["catch"](function (error) {
      console.log(error);
    });
  }
}
function buildForwardLinkSwapTargetClassName(start, middles, end) {
  var middle = "";
  if (middles && middles.length > 0) {
    var middlesFixed = middles.map(function (element) {
      return element.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
    });
    middle = middlesFixed.join('__') + '__';
  }
  return "".concat(start, "-menu__").concat(middle).concat(end);
}

/**
 * Create New Navigation Menu
 * @param {Object} $currentElement - Elemnt used for generating New Menu
 */
function generateMarkup($currentElement, dataElement, properDataElement, dataLevel, dataCategory, properDataCategory, $parentList, parentListDataId, parentWrapperElement, wrapperHeight, lastWrapperHeight, opts) {
  // get the list of dataElements representing the path from the root to the target subcategory
  var dataPath = $parentList.data('path');
  // create div wrapper for ul list and set height
  var div = buildWrapperElement('div', dataElement, parentListDataId, wrapperHeight, lastWrapperHeight, dataPath);
  // create ul for list items with classes
  var ul = buildListElement('ul', dataElement, parentListDataId, properDataElement, dataPath);
  // Add ul to wrapping div
  appender(div, ul);
  // clone my account and customer care list
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(GLOBAL_CLASS)[0]) {
    var globalNavigation = cloneGLobalElements();
    // Add My Account and Cutomer care after ul
    appender(div, globalNavigation[0]);
  }

  // create category back Link
  if (dataCategory !== '') {
    if (dataPath && dataPath.length > 0) {
      dataPath.forEach(function (pathElement, index) {
        var categoryLink = buildListItemElement('li');
        var htmlContent = index > 0 ? dataPath[index - 1] : parentListDataId;
        var categoryButton = buildListItemButtonElement(pathElement.replace(/[^A-Z0-9]/ig, '-').toLowerCase(), parentListDataId, htmlContent, htmlContent, dataPath);
        appender(categoryLink, categoryButton);
        appender(ul, categoryLink);
      });
      var categoryLink = buildListItemElement('li');
      var htmlContent = dataPath[dataPath.length - 1];
      var categoryButton = buildListItemButtonElement(dataElement, parentListDataId, htmlContent, htmlContent, dataPath);
      appender(categoryLink, categoryButton);
      appender(ul, categoryLink);
    } else {
      var dataName = window.rcProps.richNav.dataNames.womens;
      if (parentListDataId === MENS_ROOT_CATEGORY_NAME) {
        dataName = window.rcProps.richNav.dataNames.mens;
      }
      var _categoryLink = buildListItemElement('li');
      var _categoryButton = buildListItemButtonElement(dataElement, parentListDataId, properDataCategory, dataName, dataPath);
      appender(_categoryLink, _categoryButton);
      appender(ul, _categoryLink);
    }
  }
  var forwardDataPath = dataPath === undefined || dataPath.length == 0 ? [] : dataPath.slice();
  forwardDataPath.push(properDataElement);
  getRichNavData(parentListDataId === WOMENS_ROOT_CATEGORY_NAME, function (data) {
    buildListItems(data, ul, dataElement, parentListDataId, dataCategory, dataLevel, forwardDataPath);
  });
  var closeButton = createNode('button');
  closeButton.className = 'js-rich-nav-close nav-side__item--close action-button action-button--full u-padding-a--md';
  closeButton.innerHTML = window.rcProps.richNav.closeMenuText;
  var closeBtnWrapper = createNode('div');
  closeBtnWrapper.className = 'u-padding-tb--md u-padding-rl--xl';
  appender(closeBtnWrapper, closeButton);
  appender(div, closeBtnWrapper);
  return div;
}

/**
 * Find the submenu containing the pathname.
 */
function findSubmenu(pathname, isWomens) {
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav-side__link[href*="' + pathname + '"]').length > 1 && !isWomens) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav-side__link[href*="' + pathname + '"][href*="' + MENS_DEPARTMENT_PARAM + '"]').closest('div');
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav-side__link[href*="' + pathname + '"]').closest('div');
  }
}

/**
 * Get the array containing the submenus ordered from the root to the $submenuElement.
 * Array elements are the data-swap-target classes.
 */
function recursiveSubmenuFinder($submenuElement, allSubmenus) {
  if (typeof allSubmenus === 'undefined') {
    allSubmenus = [];
  }
  var currentSubmenu = $submenuElement.attr('class').split(' ').find(function (clazz) {
    return clazz.endsWith('__' + $submenuElement.data('element'));
  });
  if (currentSubmenu) {
    allSubmenus.unshift(currentSubmenu);
    var nextDataElement = currentSubmenu.slice(0, currentSubmenu.length - ('__' + $submenuElement.data('element')).length);
    var $nextSubmenuElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('div[data-element="' + nextDataElement + '"]');
    if ($nextSubmenuElement.length) {
      return recursiveSubmenuFinder($nextSubmenuElement, allSubmenus);
    }
  }
  return allSubmenus;
}

/**
 * Open submenus.
 */
function openAllSubmenus(allSubmenus) {
  allSubmenus.forEach(function (element) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".nav-side__link--category[data-swap-target='." + element + "']").click();
  });
}

/**
 * Get the array containing category names of submenus ordered from root to the submenu containing the pathname.
 */
function recursiveCategoryNameFinder(pathname, categories, allCategoryNames) {
  if (categories && categories.length) {
    var _iterator2 = _createForOfIteratorHelper(categories),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var category = _step2.value;
        if (!(category.subCategoryList && category.subCategoryList.length) && category.href && category.href.includes(pathname) && !(category.parentId == '-c-accessories--' && category.catName == 'Beauty')) {
          return allCategoryNames;
        } else {
          var updatedCategoryNames = allCategoryNames.slice();
          updatedCategoryNames.push(category.catName.toLowerCase());
          var resultCategoryNames = recursiveCategoryNameFinder(pathname, category.subCategoryList, updatedCategoryNames);
          if (resultCategoryNames.length > 0) {
            return resultCategoryNames;
          }
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return [];
}

/**
 * Convert the array of submenu category names to the corresponding data-swap-target classnames.
 */
function getCategoryNameSubmenus(isWomens, categoryNames) {
  var categoryNameSubmenus = [];
  categoryNames.forEach(function (element, index) {
    element = element.replace(/^new arrivals$/i, 'new');
    categoryNames[index] = element.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
  });
  for (var i = 1; i <= categoryNames.length - 1; i++) {
    var categoryNameSubmenu = buildForwardLinkSwapTargetClassName(categoryNames[0], categoryNames.slice(1, i), categoryNames[i]);
    categoryNameSubmenus.push(categoryNameSubmenu);
  }
  categoryNameSubmenus.unshift(isWomens ? WOMENS_ROOT_SUBMENU : MENS_ROOT_SUBMENU);
  return categoryNameSubmenus;
}

/**
 * Sync the left nav with the current page.
 */
function goToSubmenu(pathname, querystring) {
  if (!HP_PATHNAMES.includes(pathname)) {
    // sync only the non-HP pathnames
    var isWomens = !(pathname.includes(MENS_PATHNAME) || querystring.includes(MENS_DEPARTMENT_PARAM));
    var $submenuDiv = findSubmenu(pathname, isWomens); // try to get existing submenu
    if ($submenuDiv.length) {
      var allSubmenus = recursiveSubmenuFinder($submenuDiv);
      openAllSubmenus(allSubmenus); // sync left nav by opening all submenus from root to the closest one
    } else {
      getRichNavData(isWomens, function (data) {
        var categoryNames = recursiveCategoryNameFinder(pathname, data, []);
        if (categoryNames && categoryNames.length) {
          categoryNames.unshift(isWomens ? WOMENS_ROOT_CATEGORY_NAME : MENS_ROOT_CATEGORY_NAME);
          var categoryNameSubmenus = getCategoryNameSubmenus(isWomens, categoryNames);
          openAllSubmenus(categoryNameSubmenus); // sync left nav by opening all submenus from root to the closest one
        }
      });
    }
  }
}
/**
/**
 * Handles the click event when a Menu Item has been interacted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} opts - Options passed along from initialization
 */
var itemClickHandler = function itemClickHandler(_ref, $el, wrapperHeight, opts) {
  var currentTarget = _ref.currentTarget;
  // console.log(wrapperHeight);
  var $currentElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(currentTarget);
  // Get current parent ul div wrapper data element
  var parentWrapperElement = $currentElement.closest('.js-menu-wrapper')[0].dataset.element;
  // Get current parent ul
  var $parentList = $currentElement.parents('ul');
  // Get current parent ul category data attribute
  var dataCategory = $parentList[0].dataset.category;
  var properDataCategory = dataCategory.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Get current parent ul id data attribute
  var parentListDataId = $parentList[0].dataset.id;
  // generate the proper classes and data for menus
  var dataElement = $currentElement.attr('data-element').replace(/[^A-Z0-9]/ig, '-').toLowerCase();
  var properDataElement = dataElement.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Object Level value
  var dataLevel = $currentElement.attr('data-level');
  var swapTarget = $currentElement.data('swapTarget');
  var subMenu = $el.find(swapTarget);
  var PARENT_CLASS_PARAM = SUB_NAV_MENU;
  var lastWrapperHeight = $currentElement.parents(PARENT_CLASS_PARAM).outerHeight(true);
  //release trap focus
  opts.releaseFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-menu-wrapper'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.returnFocus));
  // Hide departments nav when sub menu is open
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(DEPT_NAV_MENU).addClass('u-hide');
  // if clicking main menu
  if ($currentElement.attr('data-name') === MAIN_MENU_ROOT_CATEGORY_NAME) {
    removeIsOpen(SUB_NAV_MENU, 'is--open');
    // $(SUB_NAV_MENU).hide();
    openSideNavFocus(opts);
    // Show departments nav
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(DEPT_NAV_MENU).removeClass('u-hide');
    return;
  }
  // if clicking womens
  if ($currentElement.attr('data-name') === WOMENS_ROOT_CATEGORY_NAME && dataCategory !== WOMENS_ROOT_CATEGORY_NAME) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU).not('.womens-menu__womens').removeClass('is--open');
    openSideNavFocus(opts);
    // Show departments nav
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(DEPT_NAV_MENU).removeClass('u-hide');
    return;
  }
  // if clicking a nested mens link
  if ($currentElement.attr('data-name') === MENS_ROOT_CATEGORY_NAME && dataCategory !== MENS_ROOT_CATEGORY_NAME) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU).not('.mens-menu__mens').removeClass('is--open');
    openSideNavFocus(opts);
    // Show departments nav
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(DEPT_NAV_MENU).removeClass('u-hide');
    return;
  }
  // if clicking main menu return link from loyalty program or Customer Care
  if ($currentElement.hasClass('return-link') && (dataElement === 'loyalty' || dataElement === 'customercare')) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(DEPT_NAV_MENU).removeClass('u-hide');
  }
  // Conditional to check if menu is already built
  if (!subMenu.length) {
    // if subMenu does not exist build it - subMenuListId !== parentListDataId
    var newList = generateMarkup($currentElement, dataElement, properDataElement, dataLevel, dataCategory, properDataCategory, $parentList, parentListDataId, parentWrapperElement, wrapperHeight, lastWrapperHeight, opts);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(MAIN_NAV).append(newList);
    // setTimeout allows for the slide in effect to occur
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(newList).addClass('is--open');
    }, 200);
    scrollToTop($el);
  } else {
    // Check if Existing Menu has global elements
    if (!subMenu.find(GLOBAL_CLASS).length) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(GLOBAL_CLASS)[0]) {
        // check if any global menus exist
        // clone my account and customer care list
        var globalNavigation = cloneGLobalElements();
        appender(subMenu[0], globalNavigation[0]);
      }
      // Set Menu Height
      // console.log(wrapperHeight, lastWrapperHeight);
      // subMenu[0].style.minHeight = `${wrapperHeight}px`;
      // if (wrapperHeight < lastWrapperHeight) {
      //   subMenu[0].style.minHeight = `${lastWrapperHeight}px`;
      // }
    }
    toggleMenuClass($el, $currentElement, wrapperHeight, lastWrapperHeight, opts);
    scrollToTop($el);
  }
  setTimeout(function () {
    // Get the last sub menu with the class of is--open
    openSideNavFocus(opts);
  }, 400);
};
/**
 * Applies any sort of event handlers for the richNav.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var applyEventHandlers = function applyEventHandlers($el, wrapperHeight) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rnItem = opts.rnItem;
  var leftval;
  $el.on(CLICK_EVENT, rnItem, function (evt) {
    evt.preventDefault();
    itemClickHandler(evt, $el, wrapperHeight, opts);
  });
  // Open or Close Rich Nav
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-burger-icon, .js-nav-side__overlay").on(CLICK_EVENT, function () {
    leftval = $pageWrap.css('left');
    if (leftval == "0px") {
      openSideNav(opts);
    } else {
      closeSideNav(opts);
    }
  });
  // Close side nav with Keyboard - Accessibility
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on(CLICK_EVENT, '.js-rich-nav-close', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    closeSideNav(opts);
    $burgerIcon.trigger('focus');
  });
  // Close Rich Nav with Escape Key
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keyup', function (e) {
    if (e.key === "Escape") {
      // escape key maps to keycode `27`
      leftval = $pageWrap.css('left');
      if (leftval !== "0px") {
        closeSideNav(opts);
        $burgerIcon.trigger('focus');
      }
    }
  });
  // close all sub menus when tabs are clicked
  $el.on(CLICK_EVENT, '.tabs__link', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    removeAllSubMenus();
  });
};
/**
 * Initializes richNav.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function richNav(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var mainWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(MAIN_NAV);
  var wrapperHeight = mainWrapper.outerHeight(true);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, wrapperHeight, opts);
  setActiveTab();
  goToSubmenu(location.pathname, location.search);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, richNav);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Show element only when the other element is overflowed
 * @module modules/showOnOverflow
 */




var PLUGIN_NAME = 'showOnOverflow';
var DEFAULTS = {
  overflowEl: null,
  hideThis: null
};
var checkOverflow = function checkOverflow($el, $overflowEl, $toggleThis) {
  if ($overflowEl[0].offsetWidth < $overflowEl[0].scrollWidth) {
    $toggleThis.show();
  } else {
    $toggleThis.hide();
  }
};
function showOnOverflow(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $overflowEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.overflowEl);
  var $toggleThis = opts.hideThis ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.hideThis) : $el;
  checkOverflow($el, $overflowEl, $toggleThis);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, showOnOverflow);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles side panel
 * @module side-panel
 */







var PLUGIN_NAME = 'sidePanel';
var DEFAULTS = {
  url: '',
  onAjaxLoad: function onAjaxLoad() {},
  loadingText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.translations.sidePanel.loadingText', 'One moment please...'),
  loadingTextSR: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.translations.sidePanel.loadingTextSR', 'Content is Loading'),
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */])
};
var openSidePanelFocus = function openSidePanelFocus($el, opts) {
  if ($el.hasClass('side-panel--open')) {
    // Look for anchors, buttons, and elements with tabindex not set to -1
    var $firstElementToFocus = $el.find('button, a, [tabindex]:not([tabindex="-1"])').first();
    $firstElementToFocus[0].focus();
    opts.trapFocusFunc($el);
  }
};
var closeSidePanelFocus = function closeSidePanelFocus(opts) {
  opts.releaseFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.side-panel'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.returnFocus));
};
var closePanel = function closePanel($panel, $container, opts) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["clearAllBodyScrollLocks"])($panel[0]);
  $container.removeClass('side-panel--open');
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortRefineBtn').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortRefineBtn').attr('aria-expanded', false);
    closeSidePanelFocus(opts);
  }
};
var getLoadingMessage = function getLoadingMessage(_ref) {
  var loadingText = _ref.loadingText,
    loadingTextSR = _ref.loadingTextSR;
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n    <div class=\"nav__loading-screen u-center u-text--lg\">\n        <p class=\"u-margin-b--md\">".concat(loadingText, "</p>\n        <div class=\"progress-bar progress-bar--dark u-margin--center\">\n            <div class=\"u-screen-reader\">\n                ").concat(loadingTextSR, "\n            </div>\n        </div>\n    </div>\n"));
};

/**
 * Initializes side panel.
 * @param {HTMLElement} el - button /element that opens side panel
 * @param {Object} options - Options used for wiring up the side panel
 * @see DEFAULTS
 */
function sidePanel(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $button);
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="side-panel" id="side-panel" aria-modal="true" aria-labelledby="sortRefineBtn" />');
  var $overlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="side-panel__overlay" id="side-panel__overlay" />');
  var $panel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="side-panel__panel" />');
  var $loadingMessage = getLoadingMessage(opts);
  $panel.append($loadingMessage);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').append($container);
  $container.append($overlay);
  $container.append($panel);
  $overlay.on('click', function () {
    return closePanel($panel, $container, opts);
  });

  // AJAX
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    method: 'GET',
    url: opts.url
  }).done(function (content) {
    $panel.html(content);
    var $closeButtons = $panel.find('[side-panel-close]');
    $closeButtons.on('click', function () {
      return closePanel($panel, $container, opts);
    });
    opts.onAjaxLoad();
  });
  $button.on('click', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["disableBodyScroll"])($panel[0]);
    $container.addClass('side-panel--open');
    $button.attr('aria-expanded', true);
    setTimeout(function () {
      openSidePanelFocus($container, opts);
    }, 400);
  });
  // New arrivals page to open automatically if it's coming from side panel filter
  if (window.rcProps.isNewPage && window.location.href.indexOf('fromSidePanel=true') !== -1) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["disableBodyScroll"])($panel[0]);
    $container.addClass('side-panel--open');
    $button.attr('aria-expanded', true);
    setTimeout(function () {
      openSidePanelFocus($container, opts);
    }, 400);
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sidePanel);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SLICK_ACTIVE_CLASSNAME */
/* unused harmony export KEYS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_counter__ = __webpack_require__(135);





var SLICK_ACTIVE_CLASSNAME = 'slick-active';

/**
 * Takes any defaults coming from slick along with some additional
 * properties to override any builtin accessibility coming from slick.
 * @type {Object}
 */
var SLICK_ACCESSIBLE_OPTIONS = {
  accessibility: false,
  arrows: true,
  customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
  dots: false,
  dotsClass: 'slick-dots',
  dotsTagElement: 'ol',
  dotsWrapperSelector: '<nav />',
  focusOnSelect: true,
  slide: 'li'
};

/**
 * Strips any accessibility related attributes from the dots container since
 * they are incorrect.
 * @param {jQuery} $dots - Current dots container
 * @param {string} wrapperSelector - Used to wrap the dots
 */
var resetDotsWrapper = function resetDotsWrapper($dots, wrapperSelector) {
  return $dots.wrap(wrapperSelector).removeAttr('role');
};

/**
 * Strips any accessibility related attributes from the individual dots since
 * they are incorrect.
 * @param {jQuery} $dots - Current dots container.
 */
var resetDots = function resetDots($dots) {
  return $dots.find('li').removeAttr('aria-hidden')
  // Use detach to keep the existing elements intact
  .detach();
};

/**
 * Creates the updated dots element and acquires all the existing attributes
 * from the current dots. Since element names are immutable, we create a new
 * element with the intention to remove it later on once all the high jacking is
 * complete.
 * @param {jQuery} $dots - Current dots container
 * @param {jQuery} $li - list items representing the dots
 * @param {string} tagElement - The tagName to use for the dots container
 * @returns {jQuery} - The updated dots
 */
var createUpdatedDots = function createUpdatedDots($dots, $li, tagElement) {
  var $ol = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.createElement(tagElement)).append($li);
  var attrs = Array.from($dots[0].attributes);
  attrs.forEach(function (_ref) {
    var nodeName = _ref.nodeName,
      nodeValue = _ref.nodeValue;
    $ol.attr(nodeName, nodeValue);
  });
  return $ol;
};

/**
 * Replaces the existing dots with an updated version that makes things more
 * "accessible".
 * @param {jQuery} $dots - Current dots container
 * @param {jQuery} $updatedDots - Updated dots container
 */
var insertUpdatedDots = function insertUpdatedDots($dots, $updatedDots) {
  return $dots.after($updatedDots).remove();
};

/**
 * Applies an active slide based on a slick listener. Since slick applies it's
 * active slider via the container and since said container referenced within
 * slick exists, we need to handle this manually. Yeah, lame, I know.
 * TODO: See if we can get a patch into slick so that we can remove a good of
 * this code here.
 * @param {jQuery} $li - List elements representing dots
 */
var applyActiveSlide = function applyActiveSlide($li) {
  return function (event, slick, currentSlide, nextSlide) {
    $li.eq(currentSlide).removeClass(SLICK_ACTIVE_CLASSNAME);
    $li.eq(nextSlide).addClass(SLICK_ACTIVE_CLASSNAME);
  };
};

/**
 * Applies focus on active slide
 * @param {jQuery} $li - List elements representing dots
 */
var applyActiveSlideFocus = function applyActiveSlideFocus($li) {
  return function (event, slick, currentSlide) {
    var slide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($li.eq(currentSlide).find('button').attr('id'));
    slide.focus();
  };
};

/**
 * Responsible for resetting accessibility applied by slick when dots have been
 * requested by the caller.
 * @param {jQuery} $el - Elements receiving carousel
 * @param {jQuery} $dots - Dots container
 * @param {string} dotsTagElement - tagName used for the dots
 * @param {string} dotsWrapperSelector - Selector used for wrapper the dots
 */
var resetDotsA11y = function resetDotsA11y($el, $dots, _ref2) {
  var dotsTagElement = _ref2.dotsTagElement,
    dotsWrapperSelector = _ref2.dotsWrapperSelector;
  resetDotsWrapper($dots, dotsWrapperSelector);
  var $li = resetDots($dots);
  var $updatedDots = createUpdatedDots($dots, $li, dotsTagElement);
  insertUpdatedDots($dots, $updatedDots);
  $el.on('beforeChange', applyActiveSlide($li));
  $el.on('afterChange', applyActiveSlideFocus($li));
};

/**
 * Looks for dots if configured properly.
 * @param {string} appendDots - Where to append dots
 * @param {string} dotsClass - className to apply to dots
 * @returns {jQuery} - Dots container
 */
var findDots = function findDots(_ref3) {
  var appendDots = _ref3.appendDots,
    dotsClass = _ref3.dotsClass;
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(appendDots).find(".".concat(dotsClass))
  // There's a chance that the dots are hidden in the DOM, so make sure that
  // the dots are visible. In order to remove this, we would need to make
  // things such as modals either in script or template tags.
  .filter(':visible');
};

/**
 * Human readable mapping of key codes for keyboard support.
 * @type {Object}
 */
var KEYS = {
  LEFT: 37,
  RIGHT: 39
};

/**
 * Adds custom keyboard support to the slick image carousel.
 * When carousel is in focus, left/right arrow keys rotate the images.
 * @param {jQuery} $el - Carousel element
 */
var addKeyboardSupport = function addKeyboardSupport($el) {
  $el.on('keydown', function (_ref4) {
    var which = _ref4.which;
    var LEFT = KEYS.LEFT,
      RIGHT = KEYS.RIGHT;
    switch (which) {
      case LEFT:
        $el.slick('slickPrev');
        break;
      case RIGHT:
        $el.slick('slickNext');
        break;
      default:
        break;
    }
  });
};

/**
 * Applies custom accessibility to slick since there are people out there who
 * feel that slick does accessibility incorrectly yet recommend it? Yeah, I'm
 * confused. Anyways, the goal of this work will override any accessibility
 * defaults provided by slick so they meet the need of UX-3936.
 * @see SLICK_ACCESSIBLE_OPTIONS
 * @param {HTMLElement} el - Element getting slick carousel
 * @param {Object} options - Configurable options
 */
function slickAccessible(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, SLICK_ACCESSIBLE_OPTIONS, options);
  var slickContainer = opts.slickContainer,
    counterContainer = opts.counterContainer;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__slick_counter__["a" /* default */])($el, slickContainer, counterContainer);
  var slickInstance = $el.slick(opts);
  var $dots = findDots(opts);
  if ($dots.length) {
    resetDotsA11y($el, $dots, opts);
  }
  addKeyboardSupport($el);
  return slickInstance;
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('slickAccessible', slickAccessible);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(7);





// import slick from 'slick-carousel';
// Expose the function as a jQuery plugin for ease of use
// Expose the function as a jQuery plugin for ease of use
/**
* Merges together all the options and the various conditions in which they
* can be set.
* @param  {jQuery} $el - The container element
* @param  {Object} [options={}] - Any options provided upon initialization
* @return {Object} Immutable version of the options
*/

var initSlick = function initSlick($carouselTrack) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $carouselTrack.slick({
    lazyLoad: 'ondemand',
    arrows: options.arrows,
    infinite: options.infinite,
    slidesToShow: options.slidesToShow,
    slidesToScroll: options.slidesToScroll,
    nextArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.nextArrow),
    prevArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.prevArrow)
  });
};
var getTrack = function getTrack($el) {
  return $el.find('.slick-carousel, .slick-carousel--extend').css({
    display: 'block'
  });
};
var PLUGIN_NAME = 'slickSlider';
var DEFAULTS = {
  arrows: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 2,
  nextArrow: '.js-carousel__next',
  prevArrow: '.js-carousel__prev'
};
function slickSlider(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $carouselTrack = getTrack($el);
  initSlick($carouselTrack, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, slickSlider);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slickArrow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_carousel__ = __webpack_require__(134);


/**
 * Creates optional next/previous arrow buttons for slick carousel.
 * @param {string} element - BEM element name within image-carousel
 * @param {string} title - Title text and aria-label for svg icon
 * @param {string} svg - File name of the svg
 * @return {string} - HTML for button element
 */
function slickArrow(element, title, svg) {
  return "\n    <button type=\"button\" class=\"".concat(__WEBPACK_IMPORTED_MODULE_0__image_carousel__["b" /* BLOCK_NAME */], "__").concat(element, "\">\n      <span class=\"icon icon--sm icon--").concat(svg, "\" aria-label=\"").concat(title, "\">\n        <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n          <title>").concat(title, "</title>\n          <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-").concat(svg, "\"></use>\n        </svg>\n      </span>\n    </button>\n  ");
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Handles slidedown module. Used for view more buttons
 * @module slidedown
 */




var PLUGIN_NAME = 'slidedown';
var DEFAULTS = {
  slidedownButton: '.slidedown__btn',
  slidedownContent: '.slidedown__content'
};
/**
 * Applies any sort of event handlers for the slidedown.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var slidedownButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.slidedownButton);
  var slidedownContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.slidedownContent);
  slidedownButton.on('click', function () {
    var toggleText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('close-copy');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('close-copy', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text()).children('span').text(toggleText);
    slidedownContent.toggleClass('active');
    // if slidedown button has a class of 'active' then focus on first item revealed in column
    if (slidedownContent.hasClass('active')) {
      slidedownContent.children().first().find('a').focus();
      // if not, focus on slidedown button
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).focus();
    }
  });
};
/**
 * Initializes slidedown.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the module
 * @see DEFAULTS
 */
function slidedown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, slidedown);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Toggle classes
 * @module switchClass
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'switchClass';
var DEFAULTS = {
  switchClass: '',
  switchTarget: '',
  isActive: function isActive() {}
};
/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on('click', function (evt) {
    evt.preventDefault();
    var $changingElClass;
    // If the href attribute is defined and not equal to '#', use it to select the target element
    if ($el.attr('href') !== undefined && $el.attr('href') !== '#') {
      $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('href'));
    }
    // If a data-switch-target attribute was used instead of href
    if (options.switchTarget && options.switchTarget !== '') {
      $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.switchTarget);
      // If a data-target-element attribute was used instead of data-switch-target
    } else if (options.targetElement && options.targetElement !== '') {
      $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.targetElement);
    }
    if (!$changingElClass) {
      return;
    }
    $changingElClass.toggleClass(options.switchClass);
    if ($changingElClass.hasClass(options.switchClass)) {
      options.isActive();
    }
  });
};

/**
 * Initializes switchClass.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function switchClass(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, switchClass);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Responsible for showing/hiding content based on a tab structure
 * @module modules/tabs
 */


var JS_TABS_DEFAULT_OPTIONS = {
  tab: '.tabs__link',
  tabContent: '.tabs__content',
  tabContentActive: 'tabs__content--active',
  tabActive: 'tabs__link--active',
  tabNav: '.tabs__nav',
  tabSlider: '.tabs__presentation-slider',
  tabFixed: '.tabs__nav--fixed',
  onShow: function onShow() {}
};
var makeToggleTab = function makeToggleTab($tab, initialActiveClass, activeClass) {
  return function ($target) {
    $tab.removeClass(activeClass).attr('aria-selected', 'false').find('.u-screen-reader').remove();
    $target.addClass(activeClass).attr('aria-selected', 'true').append('<span class="u-screen-reader" aria-live="assertive"> has been selected</span>');
    if (initialActiveClass) {
      $tab.removeClass(initialActiveClass);
      $target.addClass(initialActiveClass);
    }
  };
};
var makeToggleContent = function makeToggleContent($content, tabContentActive, onShow) {
  return function ($target) {
    var contentSelector = $target.data('tab-content');
    $content.removeClass(tabContentActive);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(contentSelector).addClass(tabContentActive);
    onShow();
  };
};
var getWidthOfTabBar = function getWidthOfTabBar($el, tabNav) {
  return $el.find(tabNav).outerWidth();
};
var makeCalculation = function makeCalculation($el, tabSlider, tabNav) {
  return function ($target) {
    // Get the length of the entire tab navigation bar
    var tabNavFullLength = getWidthOfTabBar($el, tabNav);

    // Get the length of the active tab
    var tabActiveLength = $target.outerWidth();

    // Because each tab can have different with
    // we need to divide the active tab length by the
    // overall length of the navigation bar.
    var tabLengthScale = tabActiveLength / tabNavFullLength;

    // Calculate the position of the scroll (if tab is scrollable)
    var scrollLeftPosition = $el.find(tabNav).scrollLeft();

    // We get the position of the active tab from the left of
    // the tab bar. We need to also add from the scroll position.
    var tabPositionFromLeft = $target.position().left + scrollLeftPosition;

    // We need to calculate the % offset of where the slider will
    // be placed. ie. first tab will have a 0% offset.
    var positionOffset = tabPositionFromLeft / tabNavFullLength * 100;

    // Finally, we have to add inline styling, transform because its dynamic based on
    // the number of tabs we're going to be having
    $el.find(tabSlider).css('transform', 'translateX(' + positionOffset + '%) scale(' + tabLengthScale + ')');
  };
};
var tabs = function tabs(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, JS_TABS_DEFAULT_OPTIONS, $el.data(), options),
    tab = _Object$assign.tab,
    tabContent = _Object$assign.tabContent,
    tabActive = _Object$assign.tabActive,
    tabContentActive = _Object$assign.tabContentActive,
    tabNav = _Object$assign.tabNav,
    tabSlider = _Object$assign.tabSlider,
    tabFixed = _Object$assign.tabFixed,
    onShow = _Object$assign.onShow;
  var $tab = $el.find(tab).filter(function () {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.js-tabs')[0] === $el[0];
  });
  var $content = $el.find(tabContent).filter(function () {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.js-tabs')[0] === $el[0];
  });
  var activeTabClass = $el.data('active-tab') ? $el.data('active-tab').replace('.', '') : false;
  var toggleTab = makeToggleTab($tab, activeTabClass, tabActive);
  var toggleContent = makeToggleContent($content, tabContentActive, onShow);
  var $initialActiveTab = $el.find(".".concat(tabActive));
  if ($initialActiveTab.length) {
    $initialActiveTab.attr('aria-selected', 'true');
  }
  var calculateTarget;
  if ($el.find(tabFixed).length) {
    calculateTarget = makeCalculation($el, tabSlider, tabNav);
    // initiate the first active tab and calculate the width
    calculateTarget(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(tabFixed).find(".".concat(tabActive)));
  }
  $tab.on('click', function (e) {
    e.preventDefault();
    var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);

    // Ensures that fixed tabs don't have scroll feature.
    if ($el.find(tabFixed).length === 0) {
      $target[0].scrollIntoView({
        behavior: "smooth",
        block: 'nearest',
        inline: 'nearest'
      });
    }
    toggleTab($target);
    toggleContent($target);
    if ($el.find(tabFixed).length) {
      calculateTarget($target);
    }
  });
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('tabs', tabs);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module toggleChange
 */




var PLUGIN_NAME = 'toggleChange';
var DEFAULTS = {
  ctToggleClass: '',
  ctSelector: '',
  ctInverse: false
};

/**
 * Updates the text of the selector element to match the selected option
 * @param  {jQuery} $el - select element
 * @param  {Object} options - plugin options
 */
var updateSelectCopy = function updateSelectCopy($el, options) {
  var $textContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(options.ctSelector));
  if ($textContainer.length) {
    $textContainer.text($el.find('option:selected').text());
  }
};

/**
 * Return the input type of the element
 * @param  {jQuery} $el - checkbox / radio
 * @return {String} type of either checkbox or radio
 */
var inputType = function inputType($el) {
  return $el.is('select') ? 'select' : $el.attr('type');
};

/**
 * Return radio group
 * @param  {jQuery} $el - checkbox / radio
 * @return {jQuery} radio group
 */
var radioGroup = function radioGroup($el) {
  var groupName = $el.attr('name');
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[type=\"radio\"][name=\"".concat(groupName, "\"]"));
};
var toggleClassHandler = function toggleClassHandler($el, action, opts) {
  if (action == "add" && !opts.ctInverse || action == "remove" && opts.ctInverse) {
    $el.addClass(opts.ctToggleClass);
  }
  if (action == "remove" && !opts.ctInverse || action == "add" && opts.ctInverse) {
    $el.removeClass(opts.ctToggleClass);
  }
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $selector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.ctSelector);
  var type = inputType($el);
  if (type === 'radio') {
    var $radioGroup = radioGroup($el);
    var deselectEvent = "deselect-".concat($el.attr('name'));
    $el.on('change', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name=\"".concat(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('name'), "\"]")).not(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)).trigger(deselectEvent);
      toggleClassHandler($selector, "add", options);
    }).on(deselectEvent, function () {
      toggleClassHandler($selector, "remove", options);
    });
  }
  if (type === 'checkbox') {
    $el.on('change', function (evt) {
      if (evt.currentTarget.checked) {
        toggleClassHandler($selector, "add", options);
      }
      if (!evt.currentTarget.checked) {
        toggleClassHandler($selector, "remove", options);
      }
    });
  }
  if (type === 'select') {
    $el.on('change', function () {
      updateSelectCopy($el, options);
    });
  }
};
/**
 * Set dom state if element is checked
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setChecked = function setChecked($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $selector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.ctSelector);
  if ($el[0].checked && !options.ctInverse) {
    $selector.addClass(options.ctToggleClass);
  }
};
/**
 * Initializes toggleChange.
 * @param {HTMLElement} el - button /element that triggers toggleChange
 * @param {Object} options - Options used for wiring up the toggleChange
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function toggleChange(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  setChecked($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleChange);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export OVERLAY_CLASS */
/* unused harmony export OVERLAY_ACTIVE_CLASS */
/* unused harmony export PAGE_CONSTRAIN_CLASS */
/* unused harmony export CHANGE_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_difference__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styleguide_lib_merge_options__ = __webpack_require__(7);
/**
 * Responsible for creating an toggleContent based on elements existing in the DOM
 * @module toggleContent
 */






var PLUGIN_NAME = 'toggleDisplay';
var CLICK_EVENT = 'click';
var ACTIVE_CLASS = 'is-active';
var OVERLAY_CLASS = 'page-header__dropdown-overlay';
var OVERLAY_ACTIVE_CLASS = "".concat(OVERLAY_CLASS, "--active");
var PAGE_CONSTRAIN_CLASS = 'page-constrain';
var CHANGE_HANDLER = 'change';
var $bodyAndHtml = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("html, body");
var $html = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html');
var $plpHeaderDropdown = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#plpheader_dropdown');
var DEFAULTS = {
  speed: 500,
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_0__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_0__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_0__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_0__keyboard__["a" /* default */])
};

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleDisplay);

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function toggleDisplay(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $toggleThis = $el.data('toggle-select-this');
  var $toggleShow = $el.data('toggle-select-show');
  var $toggleHide = $el.data('toggle-select-hide');
  var $animationType = $el.data('toggle-select-animation');
  var $includeOverlay = $el.data('overlay');
  var $overlay;
  var $isCategoryDropdown = $el.data('category-dropdown');
  if ($includeOverlay) {
    $overlay = addOverlay($el, options, $toggleThis);
  }
  applyEventHandlers($el, $toggleThis, $overlay, $isCategoryDropdown, $toggleShow, $toggleHide, $animationType, opts);
}
function addOverlay($el, options, $toggleThis) {
  var $modal = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("<div class='page-header__dropdown-overlay'></div>");
  return $modal.insertBefore($toggleThis);
}

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var toggler = function toggler($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE) {
  if (ANIMATION_TYPE === 'pop') {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_SHOW).show();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_HIDE).hide();
  } else {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_SHOW).slideDown();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_HIDE).slideUp();
  }
};

/**
 * Applies any sort of event handlers for the toggleContent.
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function applyEventHandlers($el, $toggleThis, $overlay, $isCategoryDropdown, $toggleShow, $toggleHide, $animationType, opts) {
  opts = opts || {};
  $el.on(CLICK_EVENT, function (evt) {
    evt.stopPropagation();
    if ($toggleThis) {
      selfToggler(evt, $el, $toggleThis, $overlay, $isCategoryDropdown, $animationType, opts);
    } else {
      toggler($el, $toggleShow, $toggleHide, $animationType, opts);
    }
  });
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html, body').on(CLICK_EVENT, function (evt) {
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(evt.target).is($el) || __WEBPACK_IMPORTED_MODULE_1_jquery___default()(evt.target).closest($toggleThis).length) {
      return;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.page-header__dropdown-overlay--active').length > 0) {
      evt.stopPropagation();
      closeToggle($el, $toggleThis, $overlay, $isCategoryDropdown, $animationType, opts);
    }
  });
  $el.on(CHANGE_HANDLER, function () {
    var selectedOption = $el.find(':selected');
    var $showElements = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selectedOption.attr('data-toggle-select-show'));
    var $hideElements = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selectedOption.attr('data-toggle-select-hide'));
    var $animationType = selectedOption.attr('data-toggle-select-animation');
    if ($showElements && $hideElements) {
      toggler(selectedOption, $showElements, $hideElements, $animationType, options);
    }
  });
}

/**
 * if active, close toggles
 */
function closeToggle($el, TOGGLE_THIS, OVERLAY, $isCategoryDropdown, ANIMATION_TYPE, opts) {
  if (ANIMATION_TYPE === 'slide') {
    $el.attr('aria-expanded', 'false');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_THIS).slideUp();
  } else if (ANIMATION_TYPE === 'pop') {
    $el.attr('aria-expanded', 'false');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_THIS).hide();
  }
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_THIS).removeClass(ACTIVE_CLASS);
  $el.removeClass(ACTIVE_CLASS);
  if ($isCategoryDropdown) {
    $el.attr('aria-expanded', "false");
    $plpHeaderDropdown.attr('aria-modal', "false");
    // If client is tabbing
    if ($html.hasClass('focus-active')) {
      opts.releaseFocusFunc($el.parent('.js-page-header'), __WEBPACK_IMPORTED_MODULE_1_jquery___default()(opts.returnFocus));
    }
  }
  if (OVERLAY) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(OVERLAY).removeClass(OVERLAY_ACTIVE_CLASS);
  }
  $bodyAndHtml.removeClass(PAGE_CONSTRAIN_CLASS);
}
/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} opts - Options passed along from initialization
 */
function selfToggler(e, $el, TOGGLE_THIS, OVERLAY, $isCategoryDropdown, ANIMATION_TYPE, opts) {
  if ($el.hasClass(ACTIVE_CLASS)) {
    closeToggle($el, TOGGLE_THIS, OVERLAY, $isCategoryDropdown, ANIMATION_TYPE, opts);
  } else {
    closeOtherToggles($el);
    if (ANIMATION_TYPE === 'slide') {
      $el.attr('aria-expanded', 'true');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_THIS).slideDown();
    } else if (ANIMATION_TYPE === 'pop') {
      $el.attr('aria-expanded', 'true');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_THIS).show();
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(TOGGLE_THIS).addClass(ACTIVE_CLASS);
    $el.addClass(ACTIVE_CLASS);
    if ($isCategoryDropdown) {
      $el.attr('aria-expanded', "true");
      $plpHeaderDropdown.attr('aria-modal', "true");
      // If client is tabbing
      if ($html.hasClass('focus-active')) {
        opts.trapFocusFunc($el.parent('.js-page-header'));
      }
      // If close link is not present then create it and bind closeOtherToggles event to it
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#plp-close-link').length <= 0) {
        var plpList = document.getElementById('plp-dropdown-section');
        var closeMenuLink = createCloseMenu();
        plpList.appendChild(closeMenuLink);
        document.getElementById('plp-close-link').addEventListener('click', closeOtherToggles);
      } else {
        document.getElementById('plp-close-link').addEventListener('click', closeOtherToggles);
      }
    }
    if (OVERLAY) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(OVERLAY).addClass(OVERLAY_ACTIVE_CLASS);
    }
    $bodyAndHtml.addClass(PAGE_CONSTRAIN_CLASS);
  }
}
function closeOtherToggles(elementToRemove) {
  var elements = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-constrain-page.is-active');
  var diff = __WEBPACK_IMPORTED_MODULE_2_lodash_difference___default()(elements, elementToRemove);
  diff.map(function (el) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).click();
  });
  // if PLP header dropdown
  if (elements.parents('#plpheader_dropdown')) {
    var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
    var focusElement = $this.closest();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#plp-dropdown').focus();
  }
}
// Create a Close Menu link for dropdown
function createCloseMenu() {
  var listItem = document.createElement('li');
  listItem.classList.add('ui-list__item', 'page-header__link', 'u-padding-rl--xxl');
  var buttonTag = document.createElement('button');
  buttonTag.classList.add('action-button', 'action-button--full', 'page-header__link--close');
  buttonTag.setAttribute('id', 'plp-close-link');
  buttonTag.innerHTML = 'Close Menu<span class="u-screen-reader">dropdown</span>';
  listItem.appendChild(buttonTag);
  return listItem;
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export CLOSE_BUTTON */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(53);
/**
 * Responsible for creating an toggleContent based on elements existing in the DOM
 * @module modules/toggleContent
 */






var PLUGIN_NAME = 'toggleDropdown';
var CLICK_EVENT = 'click';
var CLOSE_BUTTON = 'js-close-dropdown';
var DEFAULTS = {
  scrollLock: true,
  parentContainer: '',
  dialogContainer: 'js-page-header__nav-list',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */])
};
var closeAllToggleDropdowns = function closeAllToggleDropdowns() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[toggle-body-lock='true']").toggleDropdown('toggle');
};

/**
 * Handles the height of the dropdown so it takes over the screen
 * @private
 */
function titleHeaderDropdownHeight() {
  var headerDropdown = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plpheader_dropdown');
  if (headerDropdown.length) {
    var docHeight = document.documentElement.clientHeight;
    var $jsPageheaderNavList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-header__nav-list');
    var titleHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-header').height();
    $jsPageheaderNavList.css({
      maxHeight: docHeight - titleHeight
    });
  }
}

/**
 * Creates a close button
 */
var createCloseButton = function createCloseButton() {
  var closeBlock = document.createElement('div');
  closeBlock.classList.add('u-padding-a--lg');
  var buttonTag = document.createElement('button');
  buttonTag.classList.add('action-button', 'action-button--full', 'page-header__link--close', CLOSE_BUTTON);
  buttonTag.innerHTML = 'Close Menu<span class="u-screen-reader">dropdown</span>';
  closeBlock.appendChild(buttonTag);
  return closeBlock;
};

/**
 * Closes Dropdown
  * @param {jQuery} $el - Containing the elements for the toggleContent
  * @param {jQuery} $toggleThis - Element to toggle
  * @param {jQuery} $parentContainer - Container that contains trigger btn and dropdown
  * @param {Object} opts - Options, defaults and data values
 */
var closeDropdown = function closeDropdown($el, $toggleThis, $parentContainer, opts) {
  $toggleThis.slideUp();
  $toggleThis.removeClass('is-active');
  $el.removeClass('is-active');
  if (opts.scrollLock) {
    $el.attr('toggle-body-lock', '');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["enableBodyScroll"])($toggleThis[0]);
    $toggleThis.off('scroll.toggledropdown');
  }
  $el.attr('aria-expanded', "false");
  $parentContainer.attr('aria-modal', "false");
  opts.releaseFocusFunc($el.closest('.js-page-header'), $el);
};

/**
 * Opens Dropdown
  * @param {jQuery} $el - Containing the elements for the toggleContent
  * @param {jQuery} $toggleThis - Element to toggle
  * @param {jQuery} $parentContainer - Container that contains trigger btn and dropdown
  * @param {Object} opts - Options, defaults and data values
 */
var openDropdown = function openDropdown($el, $toggleThis, $parentContainer, opts) {
  $toggleThis.slideDown();
  $toggleThis.addClass('is-active');
  $el.addClass('is-active');
  if (opts.scrollLock) {
    $el.attr('toggle-body-lock', 'true');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').scrollTop(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-header').offset().top);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["disableBodyScroll"])($toggleThis[0]);
  }
  $el.attr('aria-expanded', "true");
  $parentContainer.attr('aria-modal', "true");
  opts.trapFocusFunc($el.closest('.js-page-header'));
};

/**
 * Handles the click event when a label has been iteracted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 */
var itemClickHandler = function itemClickHandler($el, $toggleThis, $parentContainer, opts) {
  var dialogContainer = ".".concat(opts.dialogContainer);
  var $hasCloseButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.parentContainer).find(".".concat(CLOSE_BUTTON)).length;
  if ($el.hasClass('is-active')) {
    closeDropdown($el, $toggleThis, $parentContainer, opts);
  } else {
    openDropdown($el, $toggleThis, $parentContainer, opts);

    // If close button is not present then create it and bind closeOtherToggles event to it
    if ($hasCloseButton <= 0) {
      var $plpDialog = $parentContainer.find(dialogContainer);
      var dropdownCloseBtn = createCloseButton();
      $plpDialog.append(dropdownCloseBtn);
      $parentContainer.find(".".concat(CLOSE_BUTTON)).on('click', function () {
        return closeDropdown($el, $toggleThis, $parentContainer, opts);
      });
    } else {
      $parentContainer.find(".".concat(CLOSE_BUTTON)).on('click', function () {
        return closeDropdown($el, $toggleThis, $parentContainer, opts);
      });
    }
  }
  titleHeaderDropdownHeight();
};

/**
 * Applies any sort of event handlers for the toggleContent.
 * @private
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $toggleThis = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('data-toggle-select-this'));
  var $parentContainer = $el.closest(opts.parentContainer);
  $el.on(CLICK_EVENT, function () {
    return itemClickHandler($el, $toggleThis, $parentContainer, opts);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keyup', function (e) {
    if (e.key === "Escape" && $el.hasClass('is-active')) {
      // escape key maps to keycode `27`
      closeDropdown($el, $toggleThis, $parentContainer, opts);
      $el.trigger('focus');
    }
  });
};

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function toggleDropdown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
  return {
    toggle: function toggle() {
      return itemClickHandler($el, opts);
    }
  };
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toggleDropdown = function (options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').toggleDropdown(options);
};
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toggleDropdown.close = function () {
  closeAllToggleDropdowns();
};

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleDropdown);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles back to top button
 * @module toggleReveal
 */



var PLUGIN_NAME = 'toggleReveal';
var DEFAULTS = {};
var makeDisableFocus = function makeDisableFocus(toggleContainer, toggleButton) {
  return function () {
    toggleContainer.find('a').not(toggleButton).attr('tabindex', -1);
  };
};
var makeEnableFocus = function makeEnableFocus(toggleContainer, toggleButton) {
  return function () {
    var anchors = toggleContainer.find('a');
    anchors.not(toggleButton).attr('tabindex', 0);
    anchors.first().focus();
  };
};
var updateButtonCopy = function updateButtonCopy(toggleButton) {
  var currentText = toggleButton.find('.action-button__copy').text();
  var newToggleText = toggleButton.data('close-copy');
  toggleButton.data('close-copy', currentText).find('.action-button__copy').text(newToggleText);
};
var makeHandleReveal = function makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus) {
  return function () {
    toggleContainer.toggleClass('active');
    var redirectUrl = toggleButton.data('url');
    if (!redirectUrl || toggleContainer.hasClass('active')) {
      updateButtonCopy(toggleButton);
    }
    if (toggleContainer.hasClass('active')) {
      enableFocus();
    } else {
      if (redirectUrl) {
        toggleButton.attr('href', redirectUrl);
      }
      disableFocus();
    }
  };
};
function toggleReveal() {
  var toggleButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal');
  var toggleContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal-trigger');
  var disableFocus = makeDisableFocus(toggleContainer, toggleButton);
  var enableFocus = makeEnableFocus(toggleContainer, toggleButton);
  var handleReveal = makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus);
  disableFocus();
  toggleButton.on('click', handleReveal);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleReveal);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(7);
/**
 * Toggle Text on click
 * @module toggleText
 */




var PLUGIN_NAME = 'toggleText';
var ACTIVE_CLASS = 'toggle-text--is-active';
var DEFAULTS = {
  toggleTextTargetClass: '',
  toggleTextDefault: '',
  toggleTextAlt: '',
  toggleTextPoliteness: 'assertive'
};

/**
 * Applies any event handlers to toggle text trigger
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var makeAccessible = function makeAccessible(_ref) {
  var toggleTextTargetClass = _ref.toggleTextTargetClass,
    toggleTextPoliteness = _ref.toggleTextPoliteness;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function ariaLiveTriggers() {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!$el.data('no-aria-live')) {
      $el.attr('aria-live', toggleTextPoliteness);
    }
  });
};
/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, _ref2) {
  var toggleTextTargetClass = _ref2.toggleTextTargetClass,
    toggleTextDefault = _ref2.toggleTextDefault,
    toggleTextAlt = _ref2.toggleTextAlt;
  $el.on('click.triggerText', function (evt) {
    evt.preventDefault();
    var isActive = $el.hasClass(ACTIVE_CLASS);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function changeText() {
      var $changingEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if ($changingEl.data('toggle-text-revese')) {
        $changingEl.text(isActive ? toggleTextAlt : toggleTextDefault);
      } else {
        $changingEl.text(isActive ? toggleTextDefault : toggleTextAlt);
      }
    });
    $el.toggleClass(ACTIVE_CLASS);
  });
};
var hasHash = function hasHash($el) {
  var href = $el.attr('href');
  if (href) {
    if (href.toLowerCase().indexOf('#') !== -1 && href.length > 1) {
      return href;
    }
  }
  return false;
};
/**
 * Give <a> a unique href value, in order to avoid users hearing
 * "visited" on links they've yet to visit.
 * @param  {jQuery} $el - button /element that toggles text
 */
var makeUniqueHash = function makeUniqueHash($el) {
  if ($el.is('a') && !hasHash($el)) {
    $el.attr('href', "#toggle-text-uid-".concat(Math.ceil(Math.random() * 10000000000)));
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleText(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  makeAccessible(opts);
  makeUniqueHash($el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleText);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export VIMEO_API_URL */
/* unused harmony export YOUTUBE_API_URL */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles all Video tracking
 * @module trackVideo
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'trackVideo';
var VIMEO_API_URL = 'https://player.vimeo.com/api/player.js';
var YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';

/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 * @param  {string} string of video type to test source against
 */
var playerType = function playerType($el, type) {
  var src = $el.attr('src').toLowerCase();
  if (src.indexOf(type) !== -1) {
    return true;
  }
  return false;
};

/**
 * Clean title for GA tracking
 * @param  {string} video title
 * @return {string} clean title with no space or special characters
 */
var cleanTitle = function cleanTitle(title) {
  return title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
};

/**
 * Track with GA
 * @param  {string} Video title to send to GA
 */
var sendToGA = function sendToGA(videoTitle) {
  if (window.ga && ga.create) {
    ga('send', 'event', {
      eventCategory: 'Beauty Video',
      eventAction: 'play',
      eventLabel: videoTitle
    });
  }
};
/**
 * Set up Vimeo player event
 * @param  {object} vimeo player
 */
var setVimeoEvents = function setVimeoEvents(player) {
  var videoTitle;
  player.getVideoTitle().then(function (title) {
    videoTitle = cleanTitle(title);
  });
  player.on('play', function () {
    sendToGA(videoTitle);
  });
};
/**
 * Clean title for GA tracking
 * @param  {jQuery} $el - iframe of video to track
 * @return {string} unique id for youtube initialization
 */
var createUniqueID = function createUniqueID($el) {
  var ytid = "yt- ".concat(Math.ceil(Math.random() * 10000000000));
  $el.attr('id', ytid);
  return ytid;
};
/**
 * Init YouTube Player
 * @param  {event} youtube player event
 */
var onYouTubePlayerReady = function onYouTubePlayerReady(event) {
  var videoTitle = cleanTitle(event.target.getVideoData().title);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target.a).data('video-title', videoTitle);
};

/**
 * Set up YouTube player event
 * @param  {event} youtube play event
 */
var setYouTubeEvents = function setYouTubeEvents(event) {
  var videoTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target.a).data('video-title');
  switch (event.data) {
    case 1:
      sendToGA(videoTitle);
      break;
    default:
  }
};
/**
 * Init YouTube Player
 * @param  {jQuery} $el - iframe of video to track
* @return {object} YT Object
 */
var initYouTubeVideo = function initYouTubeVideo($el) {
  var ytid = createUniqueID($el);
  return new YT.Player(ytid, {
    events: {
      onReady: onYouTubePlayerReady,
      onStateChange: setYouTubeEvents
    }
  });
};
/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 */
var setupPlayer = function setupPlayer($el) {
  if (playerType($el, 'vimeo')) {
    var player = new Vimeo.Player($el);
    setVimeoEvents(player);
  } else if (playerType($el, 'youtube')) {
    if (window.youtubeLoaded) {
      initYouTubeVideo($el);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('youtubeLoaded', function () {
      initYouTubeVideo($el);
    });
  }
};
/**
 * Load correct api base on url
 * @param  {jQuery} $el - iframe of video to track
 */
var loadAPI = function loadAPI($el) {
  var apiURL;
  if (playerType($el, 'vimeo')) {
    apiURL = VIMEO_API_URL;
  } else if (playerType($el, 'youtube')) {
    apiURL = YOUTUBE_API_URL;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: apiURL,
    cache: true,
    dataType: 'script'
  }).done(function () {
    setupPlayer($el);
  });
};
/**
 * Initializes modal.
 * @param {HTMLElement} el - iframe of video to track
 * @see DEFAULTS
 */
function trackVideo(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  loadAPI($el);
}

/**
* Add event for YouTube API ready method
*/
window.onYouTubeIframeAPIReady = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('youtubeLoaded');
  window.youtubeLoaded = true;
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, trackVideo);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Responsible for having an item disappear when interacting with a target
 * @module modules/vanish/vanish
 */



/**
 * Defines the defaults around the disappear module.
 * @type {Object}
 */
var DISAPPEAR_DEFAULTS = {
  vanishHiddenClassName: 'vanish--hide',
  vanishTarget: '.vanish__action',
  vanishRemoveDelay: 500
};

/**
 * Will destroy and resolve the removal of the container element.
 * @private
 * @param {jQuery} $el - The container element
 * @param {number} delay - Time in milliseconds to remove the element
 * @param {Function} resolve - Function determining when removal has completed
 */
var remove = function remove($el, delay, resolve) {
  setTimeout(function () {
    $el.remove();
    resolve();
  }, delay);
};

/**
 * Responsible for removing an element/container based on interacting with an
 * a child element within said container. This is done by either looking to a
 * data attribute called data-vanish-target which contains a selector with the
 * elements that should trigger this behavior. It includes other data
 * attributes such as:
 *
 * - data-vanish-hidden-class-name: The class name applied when the target
 *   has been interacted with.
 * - data-vanish-remove-delay: The amount of time in milliseconds the element
 *   should be removed from the DOM.
 *
 * @see DISAPPEAR_DEFAULTS
 * @param {HTMLElement} el - The container element to potentially be removed
 * @param {Object} options - Any configurable options
 * @returns {Promise}
 */
function vanish(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DISAPPEAR_DEFAULTS, options, $el.data()),
    target = _$$extend.vanishTarget,
    hideClassName = _$$extend.vanishHiddenClassName,
    removeDelay = _$$extend.vanishRemoveDelay;
  return new Promise(function (resolve) {
    $el.on('click', target, function (e) {
      e.preventDefault();
      $el.addClass(hideClassName).on('transitionend', function () {
        return remove($el, removeDelay, resolve);
      });
    });
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('vanish', vanish);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imageZoom;
/**
 * Responsible for calculating the viewport for an image upon a pan or pitch
 * event occurring
 * @module modules/zoom/imageZoom
 */

/**
 * Responsible for applying zooming functionality to an element.
 * @param {Function} Hammer - A function constructor of HammerJS
 * @param {HTMLElement} el - The element receiving the zoom
 * @return {Hammer} An instance of Hammer
 */
function imageZoom(Hammer, el) {
  var hammertime = new Hammer(el, {});
  var posX = 0;
  var posY = 0;
  var scale = 1;
  var lastScale = 1;
  var lastPosX = 0;
  var lastPosY = 0;
  var maxPosX = 0;
  var maxPosY = 0;
  hammertime.get('pinch').set({
    enable: true
  });
  hammertime.on('pan pinch panend pinchend', function (ev) {
    if (scale !== 1) {
      posX = lastPosX + ev.deltaX;
      posY = lastPosY + ev.deltaY;
      maxPosX = Math.ceil((scale - 1) * (el.clientWidth / 2));
      maxPosY = Math.ceil((scale - 1) * (el.clientHeight / 2));
      if (posX > maxPosX) {
        posX = maxPosX;
      }
      if (posX < -maxPosX) {
        posX = -maxPosX;
      }
      if (posY > maxPosY) {
        posY = maxPosY;
      }
      if (posY < -maxPosY) {
        posY = -maxPosY;
      }
    }
    if (ev.type === 'pinch') {
      scale = Math.max(0.999, Math.min(lastScale * ev.scale, 4));
    }
    if (ev.type === 'pinchend') {
      lastScale = scale;
    }
    if (ev.type === 'panend') {
      lastPosX = posX < maxPosX ? posX : maxPosX;
      lastPosY = posY < maxPosY ? posY : maxPosY;
    }
    if (scale !== 1) {
      /* eslint-disable no-param-reassign */
      el.style.transform = "translate3d(".concat(posX, "px, ").concat(posY, "px, 0px) scale3d(").concat(scale, ", ").concat(scale, ", 1)");
      /* eslint-enabled no-param-reassign */
    }
  });
  return hammertime;
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLOSE_ID */
/* unused harmony export ZOOM_SLIDER_ID */
/* unused harmony export CONTENT_CLASSNAME */
/* harmony export (immutable) */ __webpack_exports__["a"] = sliderZoom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptjs__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_counter__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_props__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_zoom__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keyboard__ = __webpack_require__(53);
/**
 * Responsible for creating a slider zoom or in other words a carousel where the
 * images in the carousel can be interacted with so that they can be zoomed in
 * @module modules/zoom/sliderZoom
 */








var HAMMERJS_FALLBACK = 'https://ajax.googleapis.com/ajax/libs/hammerjs/2.0.8/hammer.min.js';

/**
 *
 * AB Test 899 HP/PDP Increased Slick Sensitivity
 */
var increasedSensitivity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_props__["a" /* get */])('slick.slickSensitivity', false);

/**
 * Makes a request for HammerJS.
 * @private
 * @return {Promise} Denotes when the request has been successfully executed
 */
var loadHammerJSFunc = function loadHammerJSFunc() {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_scriptjs___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_props__["a" /* get */])('scripts.hammerJS', HAMMERJS_FALLBACK), function () {
      resolve(window.Hammer);
    });
  });
};

/**
 * Defines the options which can be provided for the image zoom.
 * @type {Object}
 */
var DEFAULTS = {
  loadHammerJS: loadHammerJSFunc,
  startingIndex: 0,
  speed: 300,
  slideFunc: function slideFunc(num) {
    return num;
  },
  menuRender: function menuRender() {
    return '';
  },
  didRender: function didRender() {},
  didUnmount: function didUnmount() {},
  didSlideTransition: function didSlideTransition(prev, current) {
    return {
      prev: prev,
      current: current
    };
  },
  zoomClickListener: function zoomClickListener() {},
  noImages: '',
  slickContainer: '',
  counterContainer: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */])
};

/**
 * Defines the id for the close element.
 * @type {String}
 */
var CLOSE_ID = 'close-zoom-menu';

/**
 * Defines the id for the zoom slider.
 * @type {String}
 */
var ZOOM_SLIDER_ID = 'zoom-slider';

/**
 * Defines the content className
 * @type {String}
 */
var CONTENT_CLASSNAME = 'zoom-slider__content';

/**
 * Binds an event to the close element
 * @private
 * @param  {Function} callback - The event handler for the close element
 */
var bindClose = function bindClose(callback) {
  var $closeButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementById(CLOSE_ID));
  if ($closeButton.length) {
    $closeButton.on('click.closeZoom', callback);
  } else {
    console.warn("Element with ID \"".concat(CLOSE_ID, "\" not found."));
  }

  // Add this back:
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keydown.closeZoom', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal').is(':visible')) return;
      e.preventDefault();
      callback();
    }
  });
};

/**
 * Closes the dialog.
 * @private
 * @param  {Dialog} dialog - Instance of a dialog
 * @param  {Function} didUnmount - Called once the dialog has closed
 */
var closeDialog = function closeDialog(didUnmount) {
  // Unbind the click and keydown events on close
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').off('click.product-zoom');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').off('keydown.product-zoom');

  // Focus back on the parent element
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').focus();
  didUnmount();
};

/**
 * Stupid helper that concats the element id based on an id for a slide.
 * @private
 * @param  {string} id - The id of the slide being requested
 * @return {string} - A slide id
 */
var getSlideId = function getSlideId(id) {
  return "zoom-slider__item-".concat(id);
};

/**
 * Obtains a slide or image basd on the id provided in the template.
 * @private
 * @param  {number} id - The id of the slide being requested
 * @return {HTMLElement} An element representing a slide or image
 */
var getSlide = function getSlide(id) {
  return document.getElementById(getSlideId(id));
};

/**
 * Executes in the future the close callback. The callback is responsible for
 * clean up to ensure nothing is left in memory.
 * @private
 * @param  {jQuery} $zoomSlider
 * @param  {Hammer} hammer - An instance of Hammer from hammerjs
 * @param  {Function} didUnmount - Used to denote when closed
 * @return {Function} Callback function used for the event
 */
var teardownFull = function teardownFull($zoomSlider, hammer, beforeUnmount, didUnmount, zoomClickListener) {
  return function () {
    beforeUnmount();
    hammer.destroy();
    if ($zoomSlider.hasClass('slick-initialized')) $zoomSlider.slick('unslick');
    // Remove the modal HTML from the DOM
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#zoom-modal').remove();
    closeDialog(didUnmount);
    zoomClickListener();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('keydown.closeZoom');
  };
};

/**
 * Simple rendering when no images are found.
 * @private
 * @param  {String} noImages - Text indicating no images were found
 * @return {string} Template containing content around no visible images
 */
var renderNoImages = function renderNoImages(_ref) {
  var noImages = _ref.noImages;
  return "\n  <p class=\"".concat(CONTENT_CLASSNAME, "\">").concat(noImages, "</p>\n");
};

/**
 * Template containing what is to be rendered in the dialog.
 * @private
 * @param  {array} images - A list of images
 * @param  {Function} [menuRender=() => ''] - Used for additional rendering
 * @return {String} A fully rendered template as a string
 */
var renderDialog = function renderDialog(_ref2) {
  var images = _ref2.images,
    noImages = _ref2.noImages,
    _ref2$menuRender = _ref2.menuRender,
    menuRender = _ref2$menuRender === void 0 ? function () {
      return '';
    } : _ref2$menuRender;
  return "\n    <div id=\"zoom-modal\" class=\"modal modal--zoom\">\n      <h2 class=\"modal__hed u-screen-reader\">Zoom Modal</h2>\n      <div id=\"zoom-menu\" class=\"zoom-menu\">\n        <button id=\"".concat(CLOSE_ID, "\" class=\"js-modal-close zoom-menu__close\">\n          <span class=\"icon icon--lg icon--x\">\n            <svg viewBox=\"0 0 16 16\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-x\"></use></svg>\n          </span>\n        </button>\n      </div>\n      <ul id=\"").concat(ZOOM_SLIDER_ID, "\" class=\"zoom-slider u-margin-l--none\">\n        ").concat(images.length ? images.map(function (image, i) {
    return "<li><img src=\"".concat(image, "\" class=\"zoom-slider__item\" id=\"").concat(getSlideId(i), "\"></li>");
  }).join('') : renderNoImages({
    noImages: noImages
  }), "\n      </ul>\n    </div>\n  ");
};

/**
 * Focuses on the modal.
 * @private
 * @param  {jQuery} $dialog - jQuery object to focus on
 */
var focusModal = function focusModal($dialog) {
  var $slickIndex = $dialog.find('.slick-active');
  $slickIndex.attr('tabindex', 0);
  $slickIndex.focus();
};

/**
 * Merges or concats options to be passed along to slick.
 * @private
 * @param  {Object} [options={}] - Options sent along to slick
 * @return {Object} A mergingin of options for slick
 */
var mergeSliderOptions = function mergeSliderOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Mock Content Start - AB Test 899 HP/PDP Increased Slick Sensitivity
  if (increasedSensitivity) document.body.classList.add('ab899-slick-sensitivity');
  // Mock Content End
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    appendDots: '#zoom-menu',
    dotsClass: 'slider-dots__menu image-carousel__dots',
    slide: 'li',
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    // Mock Content Start - AB Test 899 HP/PDP Increased Slick Sensitivity
    touchThreshold: increasedSensitivity ? 20 : 5,
    vertical: false,
    verticalSwiping: false
    // Mock Content End
  }, options);
};

/**
 * Responsible for rendering a slider zoom. More specifically, it will create
 * a dialog/modal such that n number of images are used for creating a slider.
 * On top of that, each image will have the ability for pinch/zoom/moving
 * around an image such that the image can be examined by the end user.
 * @see DEFAULTS
 * @param {array} images - A list of images used for the slider and zooming
 * @param {Object} options - Additional hooks to interact with the slider zoom
 * @return {Promise} Denotes when the slier zoom has been fully rendered
 */
function sliderZoom(images) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options),
    startingIndex = _$$extend.startingIndex,
    speed = _$$extend.speed,
    slideFunc = _$$extend.slideFunc,
    menuRender = _$$extend.menuRender,
    didRender = _$$extend.didRender,
    beforeUnmount = _$$extend.beforeUnmount,
    didUnmount = _$$extend.didUnmount,
    loadHammerJS = _$$extend.loadHammerJS,
    didSlideTransition = _$$extend.didSlideTransition,
    noImages = _$$extend.noImages,
    zoomClickListener = _$$extend.zoomClickListener,
    slickContainer = _$$extend.slickContainer,
    counterContainer = _$$extend.counterContainer,
    trapFocusFunc = _$$extend.trapFocusFunc;
  return loadHammerJS().then(function (Hammer) {
    // Remove any existing modal before creating new one
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#zoom-modal').remove();
    var output = renderDialog({
      images: images,
      menuRender: menuRender,
      noImages: noImages
    });
    var $modalHtml = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(output);
    $modalHtml.appendTo('body');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      type: 'full',
      open: 'zoom-modal',
      triggerOpen: true
    });
    didRender();
    if (!images.length) {
      bindClose(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#zoom-modal').remove();
        closeDialog(didUnmount);
      });
      return;
    }
    slideFunc(startingIndex);
    var $zoomSlider = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementById(ZOOM_SLIDER_ID));
    var currentSliderItem = getSlide(startingIndex);
    var hammerInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__image_zoom__["a" /* default */])(Hammer, currentSliderItem);
    var currentNum = startingIndex;
    var previous;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__slick_counter__["a" /* default */])($zoomSlider, slickContainer, counterContainer);
    $zoomSlider.slick(mergeSliderOptions({
      speed: speed,
      initialSlide: startingIndex
    })).on('afterChange', function (evt, slide, currentSlide) {
      // when at the beginning or end, do not reset zooming
      if (currentNum === currentSlide) {
        return;
      }
      currentNum = currentSlide;
      var $currentSlide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide.$slides.get(currentSlide));
      // add tabindex to the current slide
      // using setTimeout because slick adds tabindex -1
      // so its race condition with focus
      setTimeout(function () {
        $currentSlide.prop('tabindex', 0);
        $currentSlide.focus();
      }, 100);
      slideFunc(currentNum);
      previous = currentSliderItem;
      hammerInstance.destroy();
      currentSliderItem = getSlide(currentNum);
      hammerInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__image_zoom__["a" /* default */])(Hammer, currentSliderItem);

      // use a setTimeout instead of the afterChange event since it'll
      // provide to long of a delay between swipe change when the image
      // has been zoomed in too much, yeah, a whole lot of edge cases
      // happening here.
      setTimeout(function () {
        /* eslint-disable no-param-reassign */
        previous.style.transform = 'none';
        /* eslint-enable no-param-reassign */
        didSlideTransition(previous, currentSliderItem);
      }, speed);
    });
    focusModal($zoomSlider);
    bindClose(teardownFull($zoomSlider, hammerInstance, beforeUnmount, didUnmount, zoomClickListener));
  });
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(287)() ? Object.assign : __webpack_require__(288);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(289)
  , value = __webpack_require__(293)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(290)() ? Object.keys : __webpack_require__(291);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(101);

var keys = Object.keys;

module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(101);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(101);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(295)() ? String.prototype.contains : __webpack_require__(296);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return str.contains("dwa") === true && str.contains("foo") === false;
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(298)()
	? __webpack_require__(78).Symbol
	: __webpack_require__(303);


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global     = __webpack_require__(78)
  , validTypes = { object: true, symbol: true };

module.exports = function () {
	var Symbol = global.Symbol;
	var symbol;
	if (typeof Symbol !== "function") return false;
	symbol = Symbol("test symbol");
	try { String(symbol); }
	catch (e) { return false; }

	// Return 'true' also for polyfills
	if (!validTypes[typeof Symbol.iterator]) return false;
	if (!validTypes[typeof Symbol.toPrimitive]) return false;
	if (!validTypes[typeof Symbol.toStringTag]) return false;

	return true;
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
	if (!value) return false;
	if (typeof value === "symbol") return true;
	if (!value.constructor) return false;
	if (value.constructor.name !== "Symbol") return false;
	return value[value.constructor.toStringTag] === "Symbol";
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d = __webpack_require__(77);

var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;

var created = create(null);
module.exports = function (desc) {
	var postfix = 0, name, ie11BugWorkaround;
	while (created[desc + (postfix || "")]) ++postfix;
	desc += postfix || "";
	created[desc] = true;
	name = "@@" + desc;
	defineProperty(
		objPrototype, name,
		d.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, d(value));
			ie11BugWorkaround = false;
		})
	);
	return name;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d            = __webpack_require__(77)
  , NativeSymbol = __webpack_require__(78).Symbol;

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		// To ensure proper interoperability with other native functions (e.g. Array.from)
		// fallback to eventual native implementation of given symbol
		hasInstance: d(
			"", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
		),
		isConcatSpreadable: d(
			"",
			(NativeSymbol && NativeSymbol.isConcatSpreadable) ||
				SymbolPolyfill("isConcatSpreadable")
		),
		iterator: d("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
		match: d("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
		replace: d("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
		search: d("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
		species: d("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
		split: d("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
		toPrimitive: d(
			"", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
		),
		toStringTag: d(
			"", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
		),
		unscopables: d(
			"", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
		)
	});
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d              = __webpack_require__(77)
  , validateSymbol = __webpack_require__(137);

var registry = Object.create(null);

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (registry[key]) return registry[key];
			return (registry[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (symbol) {
			var key;
			validateSymbol(symbol);
			for (key in registry) {
				if (registry[key] === symbol) return key;
			}
			return undefined;
		})
	});
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ES2015 Symbol polyfill for environments that do not (or partially) support it



var d                    = __webpack_require__(77)
  , validateSymbol       = __webpack_require__(137)
  , NativeSymbol         = __webpack_require__(78).Symbol
  , generateName         = __webpack_require__(300)
  , setupStandardSymbols = __webpack_require__(301)
  , setupSymbolRegistry  = __webpack_require__(302);

var create = Object.create
  , defineProperties = Object.defineProperties
  , defineProperty = Object.defineProperty;

var SymbolPolyfill, HiddenSymbol, isNativeSafe;

if (typeof NativeSymbol === "function") {
	try {
		String(NativeSymbol());
		isNativeSafe = true;
	} catch (ignore) {}
} else {
	NativeSymbol = null;
}

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
module.exports = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
	if (isNativeSafe) return NativeSymbol(description);
	symbol = create(HiddenSymbol.prototype);
	description = description === undefined ? "" : String(description);
	return defineProperties(symbol, {
		__description__: d("", description),
		__name__: d("", generateName(description))
	});
};

setupStandardSymbols(SymbolPolyfill);
setupSymbolRegistry(SymbolPolyfill);

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: d(SymbolPolyfill),
	toString: d("", function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: d(function () { return "Symbol (" + validateSymbol(this).__description__ + ")"; }),
	valueOf: d(function () { return validateSymbol(this); })
});
defineProperty(
	SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive,
	d("", function () {
		var symbol = validateSymbol(this);
		if (typeof symbol === "symbol") return symbol;
		return symbol.toString();
	})
);
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
);

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
);


/***/ }),
/* 304 */
/***/ (function(module, exports) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ is resolved with global context, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};


/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

/*!
 * jQuery & Zepto Lazy - v1.7.10
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 *
 * $("img.lazy").lazy();
 */

;(function(window, undefined) {
    "use strict";

    // noinspection JSUnresolvedVariable
    /**
     * library instance - here and not in construct to be shorter in minimization
     * @return void
     */
    var $ = window.jQuery || window.Zepto,

    /**
     * unique plugin instance id counter
     * @type {number}
     */
    lazyInstanceId = 0,

    /**
     * helper to register window load for jQuery 3
     * @type {boolean}
     */    
    windowLoaded = false;

    /**
     * make lazy available to jquery - and make it a bit more case-insensitive :)
     * @access public
     * @type {function}
     * @param {object} settings
     * @return {LazyPlugin}
     */
    $.fn.Lazy = $.fn.lazy = function(settings) {
        return new LazyPlugin(this, settings);
    };

    /**
     * helper to add plugins to lazy prototype configuration
     * @access public
     * @type {function}
     * @param {string|Array} names
     * @param {string|Array|function} [elements]
     * @param {function} loader
     * @return void
     */
    $.Lazy = $.lazy = function(names, elements, loader) {
        // make second parameter optional
        if ($.isFunction(elements)) {
            loader = elements;
            elements = [];
        }

        // exit here if parameter is not a callable function
        if (!$.isFunction(loader)) {
            return;
        }

        // make parameters an array of names to be sure
        names = $.isArray(names) ? names : [names];
        elements = $.isArray(elements) ? elements : [elements];

        var config = LazyPlugin.prototype.config,
            forced = config._f || (config._f = {});

        // add the loader plugin for every name
        for (var i = 0, l = names.length; i < l; i++) {
            if (config[names[i]] === undefined || $.isFunction(config[names[i]])) {
                config[names[i]] = loader;
            }
        }

        // add forced elements loader
        for (var c = 0, a = elements.length; c < a; c++) {
            forced[elements[c]] = names[0];
        }
    };

    /**
     * contains all logic and the whole element handling
     * is packed in a private function outside class to reduce memory usage, because it will not be created on every plugin instance
     * @access private
     * @type {function}
     * @param {LazyPlugin} instance
     * @param {object} config
     * @param {object|Array} items
     * @param {object} events
     * @param {string} namespace
     * @return void
     */
    function _executeLazy(instance, config, items, events, namespace) {
        /**
         * a helper to trigger the 'onFinishedAll' callback after all other events
         * @access private
         * @type {number}
         */
        var _awaitingAfterLoad = 0,

        /**
         * visible content width
         * @access private
         * @type {number}
         */
        _actualWidth = -1,

        /**
         * visible content height
         * @access private
         * @type {number}
         */
        _actualHeight = -1,

        /**
         * determine possibly detected high pixel density
         * @access private
         * @type {boolean}
         */
        _isRetinaDisplay = false, 

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _afterLoad = 'afterLoad',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _load = 'load',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _error = 'error',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _img = 'img',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _src = 'src',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _srcset = 'srcset',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _sizes = 'sizes',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _backgroundImage = 'background-image';

        /**
         * initialize plugin
         * bind loading to events or set delay time to load all items at once
         * @access private
         * @return void
         */
        function _initialize() {
            // detect actual device pixel ratio
            // noinspection JSUnresolvedVariable
            _isRetinaDisplay = window.devicePixelRatio > 1;

            // prepare all initial items
            items = _prepareItems(items);

            // if delay time is set load all items at once after delay time
            if (config.delay >= 0) {
                setTimeout(function() {
                    _lazyLoadItems(true);
                }, config.delay);
            }

            // if no delay is set or combine usage is active bind events
            if (config.delay < 0 || config.combined) {
                // create unique event function
                events.e = _throttle(config.throttle, function(event) {
                    // reset detected window size on resize event
                    if (event.type === 'resize') {
                        _actualWidth = _actualHeight = -1;
                    }

                    // execute 'lazy magic'
                    _lazyLoadItems(event.all);
                });

                // create function to add new items to instance
                events.a = function(additionalItems) {
                    additionalItems = _prepareItems(additionalItems);
                    items.push.apply(items, additionalItems);
                };

                // create function to get all instance items left
                events.g = function() {
                    // filter loaded items before return in case internal filter was not running until now
                    return (items = $(items).filter(function() {
                        return !$(this).data(config.loadedName);
                    }));
                };

                // create function to force loading elements
                events.f = function(forcedItems) {
                    for (var i = 0; i < forcedItems.length; i++) {
                        // only handle item if available in current instance
                        // use a compare function, because Zepto can't handle object parameter for filter
                        // var item = items.filter(forcedItems[i]);
                        /* jshint loopfunc: true */
                        var item = items.filter(function() {
                            return this === forcedItems[i];
                        });

                        if (item.length) {
                            _lazyLoadItems(false, item);   
                        }
                    }
                };

                // load initial items
                _lazyLoadItems();

                // bind lazy load functions to scroll and resize event
                // noinspection JSUnresolvedVariable
                $(config.appendScroll).on('scroll.' + namespace + ' resize.' + namespace, events.e);
            }
        }

        /**
         * prepare items before handle them
         * @access private
         * @param {Array|object|jQuery} items
         * @return {Array|object|jQuery}
         */
        function _prepareItems(items) {
            // fetch used configurations before loops
            var defaultImage = config.defaultImage,
                placeholder = config.placeholder,
                imageBase = config.imageBase,
                srcsetAttribute = config.srcsetAttribute,
                loaderAttribute = config.loaderAttribute,
                forcedTags = config._f || {};

            // filter items and only add those who not handled yet and got needed attributes available
            items = $(items).filter(function() {
                var element = $(this),
                    tag = _getElementTagName(this);

                return !element.data(config.handledName) && 
                       (element.attr(config.attribute) || element.attr(srcsetAttribute) || element.attr(loaderAttribute) || forcedTags[tag] !== undefined);
            })

            // append plugin instance to all elements
            .data('plugin_' + config.name, instance);

            for (var i = 0, l = items.length; i < l; i++) {
                var element = $(items[i]),
                    tag = _getElementTagName(items[i]),
                    elementImageBase = element.attr(config.imageBaseAttribute) || imageBase;

                // generate and update source set if an image base is set
                if (tag === _img && elementImageBase && element.attr(srcsetAttribute)) {
                    element.attr(srcsetAttribute, _getCorrectedSrcSet(element.attr(srcsetAttribute), elementImageBase));
                }

                // add loader to forced element types
                if (forcedTags[tag] !== undefined && !element.attr(loaderAttribute)) {
                    element.attr(loaderAttribute, forcedTags[tag]);
                }

                // set default image on every element without source
                if (tag === _img && defaultImage && !element.attr(_src)) {
                    element.attr(_src, defaultImage);
                }

                // set placeholder on every element without background image
                else if (tag !== _img && placeholder && (!element.css(_backgroundImage) || element.css(_backgroundImage) === 'none')) {
                    element.css(_backgroundImage, "url('" + placeholder + "')");
                }
            }

            return items;
        }

        /**
         * the 'lazy magic' - check all items
         * @access private
         * @param {boolean} [allItems]
         * @param {object} [forced]
         * @return void
         */
        function _lazyLoadItems(allItems, forced) {
            // skip if no items where left
            if (!items.length) {
                // destroy instance if option is enabled
                if (config.autoDestroy) {
                    // noinspection JSUnresolvedFunction
                    instance.destroy();
                }

                return;
            }

            var elements = forced || items,
                loadTriggered = false,
                imageBase = config.imageBase || '',
                srcsetAttribute = config.srcsetAttribute,
                handledName = config.handledName;

            // loop all available items
            for (var i = 0; i < elements.length; i++) {
                // item is at least in loadable area
                if (allItems || forced || _isInLoadableArea(elements[i])) {
                    var element = $(elements[i]),
                        tag = _getElementTagName(elements[i]),
                        attribute = element.attr(config.attribute),
                        elementImageBase = element.attr(config.imageBaseAttribute) || imageBase,
                        customLoader = element.attr(config.loaderAttribute);

                        // is not already handled 
                    if (!element.data(handledName) &&
                        // and is visible or visibility doesn't matter
                        (!config.visibleOnly || element.is(':visible')) && (
                        // and image source or source set attribute is available
                        (attribute || element.attr(srcsetAttribute)) && (
                            // and is image tag where attribute is not equal source or source set
                            (tag === _img && (elementImageBase + attribute !== element.attr(_src) || element.attr(srcsetAttribute) !== element.attr(_srcset))) ||
                            // or is non image tag where attribute is not equal background
                            (tag !== _img && elementImageBase + attribute !== element.css(_backgroundImage))
                        ) ||
                        // or custom loader is available
                        customLoader))
                    {
                        // mark element always as handled as this point to prevent double handling
                        loadTriggered = true;
                        element.data(handledName, true);

                        // load item
                        _handleItem(element, tag, elementImageBase, customLoader);
                    }
                }
            }

            // when something was loaded remove them from remaining items
            if (loadTriggered) {
                items = $(items).filter(function() {
                    return !$(this).data(handledName);
                });
            }
        }

        /**
         * load the given element the lazy way
         * @access private
         * @param {object} element
         * @param {string} tag
         * @param {string} imageBase
         * @param {function} [customLoader]
         * @return void
         */
        function _handleItem(element, tag, imageBase, customLoader) {
            // increment count of items waiting for after load
            ++_awaitingAfterLoad;

            // extended error callback for correct 'onFinishedAll' handling
            var errorCallback = function() {
                _triggerCallback('onError', element);
                _reduceAwaiting();

                // prevent further callback calls
                errorCallback = $.noop;
            };

            // trigger function before loading image
            _triggerCallback('beforeLoad', element);

            // fetch all double used data here for better code minimization
            var srcAttribute = config.attribute,
                srcsetAttribute = config.srcsetAttribute,
                sizesAttribute = config.sizesAttribute,
                retinaAttribute = config.retinaAttribute,
                removeAttribute = config.removeAttribute,
                loadedName = config.loadedName,
                elementRetina = element.attr(retinaAttribute);

            // handle custom loader
            if (customLoader) {
                // on load callback
                var loadCallback = function() {
                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(config.loaderAttribute);
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // remove item from waiting queue and possibly trigger finished event
                    // it's needed to be asynchronous to run after filter was in _lazyLoadItems
                    setTimeout(_reduceAwaiting, 1);

                    // prevent further callback calls
                    loadCallback = $.noop;
                };

                // bind error event to trigger callback and reduce waiting amount
                element.off(_error).one(_error, errorCallback)

                // bind after load callback to element
                .one(_load, loadCallback);

                // trigger custom loader and handle response
                if (!_triggerCallback(customLoader, element, function(response) {
                    if(response) {
                        element.off(_load);
                        loadCallback();
                    }
                    else {
                        element.off(_error);
                        errorCallback();
                    }
                })) {
                    element.trigger(_error);
                }
            }

            // handle images
            else {
                // create image object
                var imageObj = $(new Image());

                // bind error event to trigger callback and reduce waiting amount
                imageObj.one(_error, errorCallback)

                // bind after load callback to image
                .one(_load, function() {
                    // remove element from view
                    element.hide();

                    // set image back to element
                    // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                    if (tag === _img) {
                        element.attr(_sizes, imageObj.attr(_sizes))
                               .attr(_srcset, imageObj.attr(_srcset))
                               .attr(_src, imageObj.attr(_src));
                    }
                    else {
                        element.css(_backgroundImage, "url('" + imageObj.attr(_src) + "')");
                    }

                    // bring it back with some effect!
                    element[config.effect](config.effectTime);

                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(srcAttribute + ' ' + srcsetAttribute + ' ' + retinaAttribute + ' ' + config.imageBaseAttribute);

                        // only remove 'sizes' attribute, if it was a custom one
                        if (sizesAttribute !== _sizes) {
                            element.removeAttr(sizesAttribute);
                        }
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // cleanup image object
                    imageObj.remove();

                    // remove item from waiting queue and possibly trigger finished event
                    _reduceAwaiting();
                });

                // set sources
                // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                var imageSrc = (_isRetinaDisplay && elementRetina ? elementRetina : element.attr(srcAttribute)) || '';
                imageObj.attr(_sizes, element.attr(sizesAttribute))
                        .attr(_srcset, element.attr(srcsetAttribute))
                        .attr(_src, imageSrc ? imageBase + imageSrc : null);

                // call after load even on cached image
                imageObj.complete && imageObj.trigger(_load); // jshint ignore : line
            }
        }

        /**
         * check if the given element is inside the current viewport or threshold
         * @access private
         * @param {object} element
         * @return {boolean}
         */
        function _isInLoadableArea(element) {
            var elementBound = element.getBoundingClientRect(),
                direction    = config.scrollDirection,
                threshold    = config.threshold,
                vertical     = // check if element is in loadable area from top
                               ((_getActualHeight() + threshold) > elementBound.top) &&
                               // check if element is even in loadable are from bottom
                               (-threshold < elementBound.bottom),
                horizontal   = // check if element is in loadable area from left
                               ((_getActualWidth() + threshold) > elementBound.left) &&
                               // check if element is even in loadable area from right
                               (-threshold < elementBound.right);

            if (direction === 'vertical') {
                return vertical;
            }
            else if (direction === 'horizontal') {
                return horizontal;
            }

            return vertical && horizontal;
        }

        /**
         * receive the current viewed width of the browser
         * @access private
         * @return {number}
         */
        function _getActualWidth() {
            return _actualWidth >= 0 ? _actualWidth : (_actualWidth = $(window).width());
        }

        /**
         * receive the current viewed height of the browser
         * @access private
         * @return {number}
         */
        function _getActualHeight() {
            return _actualHeight >= 0 ? _actualHeight : (_actualHeight = $(window).height());
        }

        /**
         * get lowercase tag name of an element
         * @access private
         * @param {object} element
         * @returns {string}
         */
        function _getElementTagName(element) {
            return element.tagName.toLowerCase();
        }

        /**
         * prepend image base to all srcset entries
         * @access private
         * @param {string} srcset
         * @param {string} imageBase
         * @returns {string}
         */
        function _getCorrectedSrcSet(srcset, imageBase) {
            if (imageBase) {
                // trim, remove unnecessary spaces and split entries
                var entries = srcset.split(',');
                srcset = '';

                for (var i = 0, l = entries.length; i < l; i++) {
                    srcset += imageBase + entries[i].trim() + (i !== l - 1 ? ',' : '');
                }
            }

            return srcset;
        }

        /**
         * helper function to throttle down event triggering
         * @access private
         * @param {number} delay
         * @param {function} callback
         * @return {function}
         */
        function _throttle(delay, callback) {
            var timeout,
                lastExecute = 0;

            return function(event, ignoreThrottle) {
                var elapsed = +new Date() - lastExecute;

                function run() {
                    lastExecute = +new Date();
                    // noinspection JSUnresolvedFunction
                    callback.call(instance, event);
                }

                timeout && clearTimeout(timeout); // jshint ignore : line

                if (elapsed > delay || !config.enableThrottle || ignoreThrottle) {
                    run();
                }
                else {
                    timeout = setTimeout(run, delay - elapsed);
                }
            };
        }

        /**
         * reduce count of awaiting elements to 'afterLoad' event and fire 'onFinishedAll' if reached zero
         * @access private
         * @return void
         */
        function _reduceAwaiting() {
            --_awaitingAfterLoad;

            // if no items were left trigger finished event
            if (!items.length && !_awaitingAfterLoad) {
                _triggerCallback('onFinishedAll');
            }
        }

        /**
         * single implementation to handle callbacks, pass element and set 'this' to current instance
         * @access private
         * @param {string|function} callback
         * @param {object} [element]
         * @param {*} [args]
         * @return {boolean}
         */
        function _triggerCallback(callback, element, args) {
            if ((callback = config[callback])) {
                // jQuery's internal '$(arguments).slice(1)' are causing problems at least on old iPads
                // below is shorthand of 'Array.prototype.slice.call(arguments, 1)'
                callback.apply(instance, [].slice.call(arguments, 1));
                return true;
            }

            return false;
        }

        // if event driven or window is already loaded don't wait for page loading
        if (config.bind === 'event' || windowLoaded) {
            _initialize();
        }

        // otherwise load initial items and start lazy after page load
        else {
            // noinspection JSUnresolvedVariable
            $(window).on(_load + '.' + namespace, _initialize);
        }  
    }

    /**
     * lazy plugin class constructor
     * @constructor
     * @access private
     * @param {object} elements
     * @param {object} settings
     * @return {object|LazyPlugin}
     */
    function LazyPlugin(elements, settings) {
        /**
         * this lazy plugin instance
         * @access private
         * @type {object|LazyPlugin|LazyPlugin.prototype}
         */
        var _instance = this,

        /**
         * this lazy plugin instance configuration
         * @access private
         * @type {object}
         */
        _config = $.extend({}, _instance.config, settings),

        /**
         * instance generated event executed on container scroll or resize
         * packed in an object to be referenceable and short named because properties will not be minified
         * @access private
         * @type {object}
         */
        _events = {},

        /**
         * unique namespace for instance related events
         * @access private
         * @type {string}
         */
        _namespace = _config.name + '-' + (++lazyInstanceId);

        // noinspection JSUndefinedPropertyAssignment
        /**
         * wrapper to get or set an entry from plugin instance configuration
         * much smaller on minify as direct access
         * @access public
         * @type {function}
         * @param {string} entryName
         * @param {*} [value]
         * @return {LazyPlugin|*}
         */
        _instance.config = function(entryName, value) {
            if (value === undefined) {
                return _config[entryName];
            }

            _config[entryName] = value;
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * add additional items to current instance
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.addItems = function(items) {
            _events.a && _events.a($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * get all left items of this instance
         * @access public
         * @returns {object}
         */
        _instance.getItems = function() {
            return _events.g ? _events.g() : {};
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all items in loadable area right now
         * by default without throttle
         * @access public
         * @type {function}
         * @param {boolean} [useThrottle]
         * @return {LazyPlugin}
         */
        _instance.update = function(useThrottle) {
            _events.e && _events.e({}, !useThrottle); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force element(s) to load directly, ignoring the viewport
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.force = function(items) {
            _events.f && _events.f($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all available items right now
         * this call ignores throttling
         * @access public
         * @type {function}
         * @return {LazyPlugin}
         */
        _instance.loadAll = function() {
            _events.e && _events.e({all: true}, true); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * destroy this plugin instance
         * @access public
         * @type {function}
         * @return undefined
         */
        _instance.destroy = function() {
            // unbind instance generated events
            // noinspection JSUnresolvedFunction, JSUnresolvedVariable
            $(_config.appendScroll).off('.' + _namespace, _events.e);
            // noinspection JSUnresolvedVariable
            $(window).off('.' + _namespace);

            // clear events
            _events = {};

            return undefined;
        };

        // start using lazy and return all elements to be chainable or instance for further use
        // noinspection JSUnresolvedVariable
        _executeLazy(_instance, _config, elements, _events, _namespace);
        return _config.chainable ? elements : _instance;
    }

    /**
     * settings and configuration data
     * @access public
     * @type {object|*}
     */
    LazyPlugin.prototype.config = {
        // general
        name               : 'lazy',
        chainable          : true,
        autoDestroy        : true,
        bind               : 'load',
        threshold          : 500,
        visibleOnly        : false,
        appendScroll       : window,
        scrollDirection    : 'both',
        imageBase          : null,
        defaultImage       : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        placeholder        : null,
        delay              : -1,
        combined           : false,

        // attributes
        attribute          : 'data-src',
        srcsetAttribute    : 'data-srcset',
        sizesAttribute     : 'data-sizes',
        retinaAttribute    : 'data-retina',
        loaderAttribute    : 'data-loader',
        imageBaseAttribute : 'data-imagebase',
        removeAttribute    : true,
        handledName        : 'handled',
        loadedName         : 'loaded',

        // effect
        effect             : 'show',
        effectTime         : 0,

        // throttle
        enableThrottle     : true,
        throttle           : 250,

        // callbacks
        beforeLoad         : undefined,
        afterLoad          : undefined,
        onError            : undefined,
        onFinishedAll      : undefined
    };

    // register window load event globally to prevent not loading elements
    // since jQuery 3.X ready state is fully async and may be executed after 'load' 
    $(window).on('load', function() {
        windowLoaded = true;
    });
})(window);

/***/ }),
/* 308 */
/***/ (function(module, exports) {

/*!
 * jQuery & Zepto Lazy - AJAX Plugin - v1.4
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 */
;(function($) {
    // load data by ajax request and pass them to elements inner html, like:
    // <div data-loader="ajax" data-src="url.html" data-method="post" data-type="html"></div>
    $.lazy('ajax', function(element, response) {
        ajaxRequest(this, element, response, element.attr('data-method'));
    });

    // load data by ajax get request and pass them to elements inner html, like:
    // <div data-loader="get" data-src="url.html" data-type="html"></div>
    $.lazy('get', function(element, response) {
        ajaxRequest(this, element, response, 'GET');
    });

    // load data by ajax post request and pass them to elements inner html, like:
    // <div data-loader="post" data-src="url.html" data-type="html"></div>
    $.lazy('post', function(element, response) {
        ajaxRequest(this, element, response, 'POST');
    });

    // load data by ajax put request and pass them to elements inner html, like:
    // <div data-loader="put" data-src="url.html" data-type="html"></div>
    $.lazy('put', function(element, response) {
        ajaxRequest(this, element, response, 'PUT');
    });

    /**
     * execute ajax request and handle response
     * @param {object} instance
     * @param {jQuery|object} element
     * @param {function} response
     * @param {string} [method]
     */
    function ajaxRequest(instance, element, response, method) {
        method = method ? method.toUpperCase() : 'GET';

        var data;
        if ((method === 'POST' || method === 'PUT') && instance.config('ajaxCreateData')) {
            data = instance.config('ajaxCreateData').apply(instance, [element]);
        }

        $.ajax({
            url: element.attr('data-src'),
            type: method === 'POST' || method === 'PUT' ? method : 'GET',
            data: data,
            dataType: element.attr('data-type') || 'html',

            /**
             * success callback
             * @access private
             * @param {*} content
             * @return {void}
             */
            success: function(content) {
                // set responded data to element's inner html
                element.html(content);

                // use response function for Zepto
                response(true);

                // remove attributes
                if (instance.config('removeAttribute')) {
                    element.removeAttr('data-src data-method data-type');
                }
            },

            /**
             * error callback
             * @access private
             * @return {void}
             */
            error: function() {
                // pass error state to lazy
                // use response function for Zepto
                response(false);
            }
        });
    }
})(window.jQuery || window.Zepto);

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(373),
    hashDelete = __webpack_require__(374),
    hashGet = __webpack_require__(375),
    hashHas = __webpack_require__(376),
    hashSet = __webpack_require__(377);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(61),
    keys = __webpack_require__(69);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(61),
    keysIn = __webpack_require__(73);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(106),
    arrayIncludes = __webpack_require__(108),
    arrayIncludesWith = __webpack_require__(144),
    arrayMap = __webpack_require__(109),
    baseUnary = __webpack_require__(83),
    cacheHas = __webpack_require__(116);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(355);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 321 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(148),
    baseIsNaN = __webpack_require__(328),
    strictIndexOf = __webpack_require__(411);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(80),
    equalArrays = __webpack_require__(164),
    equalByTag = __webpack_require__(365),
    equalObjects = __webpack_require__(366),
    getTag = __webpack_require__(88),
    isArray = __webpack_require__(22),
    isBuffer = __webpack_require__(95),
    isTypedArray = __webpack_require__(128);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(88),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(80),
    baseIsEqual = __webpack_require__(151);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(126),
    isMasked = __webpack_require__(385),
    isObject = __webpack_require__(52),
    toSource = __webpack_require__(181);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(88),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isLength = __webpack_require__(127),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(90),
    nativeKeys = __webpack_require__(399);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(52),
    isPrototype = __webpack_require__(90),
    nativeKeysIn = __webpack_require__(400);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(327),
    getMatchData = __webpack_require__(369),
    matchesStrictComparable = __webpack_require__(173);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(151),
    get = __webpack_require__(125),
    hasIn = __webpack_require__(428),
    isKey = __webpack_require__(121),
    isStrictComparable = __webpack_require__(172),
    matchesStrictComparable = __webpack_require__(173),
    toKey = __webpack_require__(71);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(80),
    assignMergeValue = __webpack_require__(146),
    baseFor = __webpack_require__(320),
    baseMergeDeep = __webpack_require__(337),
    isObject = __webpack_require__(52),
    keysIn = __webpack_require__(73),
    safeGet = __webpack_require__(177);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(146),
    cloneBuffer = __webpack_require__(155),
    cloneTypedArray = __webpack_require__(156),
    copyArray = __webpack_require__(85),
    initCloneObject = __webpack_require__(171),
    isArguments = __webpack_require__(94),
    isArray = __webpack_require__(22),
    isArrayLikeObject = __webpack_require__(185),
    isBuffer = __webpack_require__(95),
    isFunction = __webpack_require__(126),
    isObject = __webpack_require__(52),
    isPlainObject = __webpack_require__(186),
    isTypedArray = __webpack_require__(128),
    safeGet = __webpack_require__(177),
    toPlainObject = __webpack_require__(440);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(113);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(423),
    defineProperty = __webpack_require__(163),
    identity = __webpack_require__(93);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    arrayMap = __webpack_require__(109),
    isArray = __webpack_require__(22),
    isSymbol = __webpack_require__(96);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(414);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(106),
    arrayIncludes = __webpack_require__(108),
    arrayIncludesWith = __webpack_require__(144),
    cacheHas = __webpack_require__(116),
    createSet = __webpack_require__(361),
    setToArray = __webpack_require__(123);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(84),
    last = __webpack_require__(432),
    parent = __webpack_require__(401),
    toKey = __webpack_require__(71);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);

  // Prevent prototype pollution:
  // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
  // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
  var index = -1,
      length = path.length;

  if (!length) {
    return true;
  }

  while (++index < length) {
    var key = toKey(path[index]);

    // Always block "__proto__" anywhere in the path if it's not expected
    if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
      return false;
    }

    // Block constructor/prototype as non-terminal traversal keys to prevent
    // escaping the object graph into built-in constructors and prototypes.
    if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
      return false;
    }
  }

  var obj = parent(object, path);
  return obj == null || delete obj[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(154);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(117);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(61),
    getSymbols = __webpack_require__(120);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(61),
    getSymbolsIn = __webpack_require__(168);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(86),
    root = __webpack_require__(21);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(347),
    hasUnicode = __webpack_require__(170),
    stringToArray = __webpack_require__(412),
    toString = __webpack_require__(74);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(107),
    createCtor = __webpack_require__(86),
    createHybrid = __webpack_require__(161),
    createRecurry = __webpack_require__(162),
    getHolder = __webpack_require__(118),
    replaceHolders = __webpack_require__(92),
    root = __webpack_require__(21);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(152),
    isArrayLike = __webpack_require__(68),
    keys = __webpack_require__(69);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(107),
    createCtor = __webpack_require__(86),
    root = __webpack_require__(21);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(140),
    noop = __webpack_require__(187),
    setToArray = __webpack_require__(123);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(153),
    createBind = __webpack_require__(356),
    createCurry = __webpack_require__(358),
    createHybrid = __webpack_require__(161),
    createPartial = __webpack_require__(360),
    getData = __webpack_require__(167),
    mergeData = __webpack_require__(398),
    setData = __webpack_require__(178),
    setWrapToString = __webpack_require__(179),
    toInteger = __webpack_require__(189);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(186);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(340);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    Uint8Array = __webpack_require__(141),
    eq = __webpack_require__(72),
    equalArrays = __webpack_require__(164),
    mapToArray = __webpack_require__(396),
    setToArray = __webpack_require__(123);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(165);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(426),
    overRest = __webpack_require__(176),
    setToString = __webpack_require__(124);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(402);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(172),
    keys = __webpack_require__(69);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(91);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(91);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(91);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(91);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(117),
    cloneDataView = __webpack_require__(348),
    cloneRegExp = __webpack_require__(349),
    cloneSymbol = __webpack_require__(350),
    cloneTypedArray = __webpack_require__(156);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    isArguments = __webpack_require__(94),
    isArray = __webpack_require__(22);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(72),
    isArrayLike = __webpack_require__(68),
    isIndex = __webpack_require__(89),
    isObject = __webpack_require__(52);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(103),
    getData = __webpack_require__(167),
    getFuncName = __webpack_require__(368),
    lodash = __webpack_require__(444);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(353);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(310),
    ListCache = __webpack_require__(79),
    Map = __webpack_require__(104);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(87);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(87);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(87);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(87);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(433);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(157),
    composeArgsRight = __webpack_require__(158),
    replaceHolders = __webpack_require__(92);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(175);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(113),
    baseSlice = __webpack_require__(154);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(85),
    isIndex = __webpack_require__(89);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 405 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(79);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 407 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    Map = __webpack_require__(104),
    MapCache = __webpack_require__(105);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(315),
    hasUnicode = __webpack_require__(170),
    unicodeToArray = __webpack_require__(415);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(397);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(143),
    arrayIncludes = __webpack_require__(108);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(103),
    LodashWrapper = __webpack_require__(139),
    copyArray = __webpack_require__(85);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(111),
    copyObject = __webpack_require__(61),
    createAssigner = __webpack_require__(159),
    isArrayLike = __webpack_require__(68),
    isPrototype = __webpack_require__(90),
    keys = __webpack_require__(69);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(421),
    createCompounder = __webpack_require__(160);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(74),
    upperFirst = __webpack_require__(442);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(147);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(364),
    toString = __webpack_require__(74);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(359),
    findIndex = __webpack_require__(184);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(149);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(321),
    hasPath = __webpack_require__(169);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(322),
    hasPath = __webpack_require__(169);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(326),
    baseUnary = __webpack_require__(83),
    nodeUtil = __webpack_require__(122);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(330),
    baseUnary = __webpack_require__(83),
    nodeUtil = __webpack_require__(122);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(160);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(105);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(336),
    createAssigner = __webpack_require__(159);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(109),
    baseClone = __webpack_require__(147),
    baseUnset = __webpack_require__(346),
    castPath = __webpack_require__(84),
    copyObject = __webpack_require__(61),
    customOmitClone = __webpack_require__(363),
    flatRest = __webpack_require__(367),
    getAllKeysIn = __webpack_require__(166);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(115),
    createWrap = __webpack_require__(362),
    getHolder = __webpack_require__(118),
    replaceHolders = __webpack_require__(92);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(190);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(61),
    keysIn = __webpack_require__(73);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(345);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(357);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(316),
    hasUnicodeWord = __webpack_require__(372),
    toString = __webpack_require__(74),
    unicodeWords = __webpack_require__(416);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(103),
    LodashWrapper = __webpack_require__(139),
    baseLodash = __webpack_require__(114),
    isArray = __webpack_require__(22),
    isObjectLike = __webpack_require__(24),
    wrapperClone = __webpack_require__(418);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(445)))

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(446);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(451);

module.exports = function (value) {
	if (typeof value !== "function") return false;

	if (!hasOwnProperty.call(value, "length")) return false;

	try {
		if (typeof value.length !== "number") return false;
		if (typeof value.call !== "function") return false;
		if (typeof value.apply !== "function") return false;
	} catch (error) {
		return false;
	}

	return !isPrototype(value);
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(192);

// prettier-ignore
var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };

module.exports = function (value) {
	if (!isValue(value)) return false;
	return hasOwnProperty.call(possibleTypes, typeof value);
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(448);

var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;

module.exports = function (value) {
	if (!isFunction(value)) return false;
	if (classRe.test(functionToString.call(value))) return false;
	return true;
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(449);

module.exports = function (value) {
	if (!isObject(value)) return false;
	try {
		if (!value.constructor) return false;
		return value.constructor.prototype === value;
	} catch (error) {
		return false;
	}
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__(131);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__(131);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(193);

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__(452);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__(454);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;

var _assertString = __webpack_require__(131);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(193);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLSThresholds */
/* unused harmony export FCPThresholds */
/* unused harmony export FIDThresholds */
/* unused harmony export INPThresholds */
/* unused harmony export LCPThresholds */
/* unused harmony export TTFBThresholds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return S; });
/* unused harmony export getFCP */
/* unused harmony export getFID */
/* unused harmony export getINP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return W; });
/* unused harmony export getTTFB */
/* unused harmony export onCLS */
/* unused harmony export onFCP */
/* unused harmony export onFID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Q; });
/* unused harmony export onLCP */
/* unused harmony export onTTFB */
var e,n,t,i,r,a=-1,o=function(e){addEventListener("pageshow",(function(n){n.persisted&&(a=n.timeStamp,e(n))}),!0)},c=function(){return window.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0]},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),i="navigate";a>=0?i="back-forward-cache":t&&(document.prerendering||u()>0?i="prerender":document.wasDiscarded?i="restore":t.type&&(i=t.type.replace(/_/g,"-")));return{name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v3-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:i}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var i=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries())}))}));return i.observe(Object.assign({type:e,buffered:!0},t||{})),i}}catch(e){}},d=function(e,n,t,i){var r,a;return function(o){n.value>=0&&(o||i)&&((a=n.value-(r||0))||void 0===r)&&(r=n.value,n.delta=a,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n))}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},p=function(e){var n=function(n){"pagehide"!==n.type&&"hidden"!==document.visibilityState||e(n)};addEventListener("visibilitychange",n,!0),addEventListener("pagehide",n,!0)},v=function(e){var n=!1;return function(t){n||(e(t),n=!0)}},m=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T())},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0)},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0)},E=function(){return m<0&&(m=h(),y(),o((function(){setTimeout((function(){m=h(),y()}),0)}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},L=[1800,3e3],w=function(e,n){n=n||{},C((function(){var t,i=E(),r=f("FCP"),a=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(a.disconnect(),e.startTime<i.firstHiddenTime&&(r.value=Math.max(e.startTime-u(),0),r.entries.push(e),t(!0)))}))}));a&&(t=d(e,r,L,n.reportAllChanges),o((function(i){r=f("FCP"),t=d(e,r,L,n.reportAllChanges),l((function(){r.value=performance.now()-i.timeStamp,t(!0)}))})))}))},b=[.1,.25],S=function(e,n){n=n||{},w(v((function(){var t,i=f("CLS",0),r=0,a=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=a[0],t=a[a.length-1];r&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(r+=e.value,a.push(e)):(r=e.value,a=[e])}})),r>i.value&&(i.value=r,i.entries=a,t())},u=s("layout-shift",c);u&&(t=d(e,i,b,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0)})),o((function(){r=0,i=f("CLS",0),t=d(e,i,b,n.reportAllChanges),l((function(){return t()}))})),setTimeout(t,0))})))},A={passive:!0,capture:!0},I=new Date,P=function(i,r){e||(e=r,n=i,t=new Date,k(removeEventListener),F())},F=function(){if(n>=0&&n<t-I){var r={entryType:"first-input",name:e.type,target:e.target,cancelable:e.cancelable,startTime:e.timeStamp,processingStart:e.timeStamp+n};i.forEach((function(e){e(r)})),i=[]}},M=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){P(e,n),r()},i=function(){r()},r=function(){removeEventListener("pointerup",t,A),removeEventListener("pointercancel",i,A)};addEventListener("pointerup",t,A),addEventListener("pointercancel",i,A)}(n,e):P(n,e)}},k=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,M,A)}))},D=[100,300],x=function(t,r){r=r||{},C((function(){var a,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),a(!0))},m=function(e){e.forEach(l)},h=s("first-input",m);a=d(t,u,D,r.reportAllChanges),h&&p(v((function(){m(h.takeRecords()),h.disconnect()}))),h&&o((function(){var o;u=f("FID"),a=d(t,u,D,r.reportAllChanges),i=[],n=-1,e=null,k(addEventListener),o=l,i.push(o),F()}))}))},B=0,R=1/0,H=0,N=function(e){e.forEach((function(e){e.interactionId&&(R=Math.min(R,e.interactionId),H=Math.max(H,e.interactionId),B=H?(H-R)/7+1:0)}))},O=function(){return r?B:performance.interactionCount||0},q=function(){"interactionCount"in performance||r||(r=s("event",N,{type:"event",buffered:!0,durationThreshold:0}))},j=[200,500],_=0,z=function(){return O()-_},G=[],J={},K=function(e){var n=G[G.length-1],t=J[e.interactionId];if(t||G.length<10||e.duration>n.latency){if(t)t.entries.push(e),t.latency=Math.max(t.latency,e.duration);else{var i={id:e.interactionId,latency:e.duration,entries:[e]};J[i.id]=i,G.push(i)}G.sort((function(e,n){return n.latency-e.latency})),G.splice(10).forEach((function(e){delete J[e.id]}))}},Q=function(e,n){n=n||{},C((function(){var t;q();var i,r=f("INP"),a=function(e){e.forEach((function(e){(e.interactionId&&K(e),"first-input"===e.entryType)&&(!G.some((function(n){return n.entries.some((function(n){return e.duration===n.duration&&e.startTime===n.startTime}))}))&&K(e))}));var n,t=(n=Math.min(G.length-1,Math.floor(z()/50)),G[n]);t&&t.latency!==r.value&&(r.value=t.latency,r.entries=t.entries,i())},c=s("event",a,{durationThreshold:null!==(t=n.durationThreshold)&&void 0!==t?t:40});i=d(e,r,j,n.reportAllChanges),c&&("PerformanceEventTiming"in window&&"interactionId"in PerformanceEventTiming.prototype&&c.observe({type:"first-input",buffered:!0}),p((function(){a(c.takeRecords()),r.value<0&&z()>0&&(r.value=0,r.entries=[]),i(!0)})),o((function(){G=[],_=O(),r=f("INP"),i=d(e,r,j,n.reportAllChanges)})))}))},U=[2500,4e3],V={},W=function(e,n){n=n||{},C((function(){var t,i=E(),r=f("LCP"),a=function(e){var n=e[e.length-1];n&&n.startTime<i.firstHiddenTime&&(r.value=Math.max(n.startTime-u(),0),r.entries=[n],t())},c=s("largest-contentful-paint",a);if(c){t=d(e,r,U,n.reportAllChanges);var m=v((function(){V[r.id]||(a(c.takeRecords()),c.disconnect(),V[r.id]=!0,t(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return setTimeout(m,0)}),!0)})),p(m),o((function(i){r=f("LCP"),t=d(e,r,U,n.reportAllChanges),l((function(){r.value=performance.now()-i.timeStamp,V[r.id]=!0,t(!0)}))}))}}))},X=[800,1800],Y=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0)},Z=function(e,n){n=n||{};var t=f("TTFB"),i=d(e,t,X,n.reportAllChanges);Y((function(){var r=c();if(r){var a=r.responseStart;if(a<=0||a>performance.now())return;t.value=Math.max(a-u(),0),t.entries=[r],i(!0),o((function(){t=f("TTFB",0),(i=d(e,t,X,n.reportAllChanges))(!0)}))}}))};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/chrome.js